import React, { useState, useRef, useLayoutEffect, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { collection, doc, setDoc, onSnapshot, getDocs, query, where, serverTimestamp, deleteDoc, getDoc, addDoc, updateDoc } from 'firebase/firestore';
import { db, auth, secondaryAuth } from './firebase';
import { signInWithEmailAndPassword, onAuthStateChanged, signOut, createUserWithEmailAndPassword, sendPasswordResetEmail, updatePassword } from 'firebase/auth';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

import { 
  LayoutDashboard, Users, Map as MapIcon, Wallet, CheckSquare, Store, Clock, Palette, 
  Smartphone, Menu, Bell, Search as SearchIcon, X, MessageCircle, QrCode, UserPlus, FileText, UploadCloud, 
  ExternalLink, Edit2, Edit3, Trash2, AlertTriangle, FileSpreadsheet, CheckCircle, ArrowRight, ChevronRight,
  Download, Link, LogOut, RotateCw, Move, LayoutGrid, Plus, Minus, RefreshCw, Trash, Info, Hand, Spline, Maximize, 
  FlipHorizontal, Hexagon, Type, Layers, ArrowUp, ArrowDown, PaintBucket, Flower2, Trees, Cuboid, Magnet, 
  DollarSign, PieChart, TrendingDown, Upload, Building, Landmark, History, Phone, Mail, Calendar, Eye, EyeOff, MessageSquare, 
  FileSignature, AlertCircle, Star, Image as ImageIcon, CalendarDays, FileDown, 
  ListTodo, CheckCircle2, Circle, PlayCircle, AlignLeft, MapPin, ShieldCheck, Printer, Scan, Camera, Navigation as NavigationIcon, Navigation, MoreVertical,
  Square, RectangleHorizontal, Settings2, GripVertical, Wand2, Moon, Heart, Send, Lock, Unlock, WifiOff, Globe, Key, Power, Quote, Check, Factory,
  Sparkles, BookOpenText, ListTree, Shirt, Hotel, CloudSun, Languages, Ticket, Gift, Hash, SquareUser, Activity, Gem, UserCheck, BarChart3, Binary, MonitorPlay,
  Inbox, ChevronDown
} from 'lucide-react';

// 🔴 AQUÍ CONECTAMOS TU NUEVO MÓDULO EXCLUSIVO:
import GestorPulserasView from './views/GestorPulserasView';
import MonitorRecepcionView from './views/MonitorRecepcionView';
import CatalogoMuestrasView from './views/CatalogoMuestrasView';
import GestorPreciosView from './views/GestorPreciosView';

// 🔴 CONEXIÓN A STRIPE (Reemplaza con tu clave Publicable de Stripe)
const stripePromise = loadStripe('pk_test_51UMEr4PWwjjZi7vXKyrFJvN8p0C5ogOczmQCubvEkcJvlDKHAtOvGWEUc0DALOLGVRn7X9jgtprdA5RF2WyIBA1m00SHD58u7y');

// Función Helper para Exportar a CSV
const exportToCSV = (filename, rows) => {
  const csvContent = "data:text/csv;charset=utf-8," + rows.map(e => Object.values(e).join(",")).join("\n");
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const MOCK_BUDGET = { total: 150000, spent: 45000 };

// 🔴 AHORA EL ID ES DINÁMICO PARA PODER CAMBIAR DE BODA EN BODA
export let ID_DEL_EVENTO = "evento_de_prueba";
export const setGlobalEventId = (id) => { ID_DEL_EVENTO = id; };

// ==========================================
// --- LOGOTIPO OFICIAL BAULIA (DIAMANTE PRO) ---
// ==========================================
const BauliaLogo = ({ className = "h-10", forceWhite = false }) => (
  <svg viewBox="0 0 915 201" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={{ overflow: 'visible' }}>
    <style>
      {`
        .baulia-text { 
          fill: #FFFFFF; 
          transition: fill 0.5s ease; 
        }
        .baulia-diamond-animator {
          transform-origin: 100px 100px;
          transform: rotate(45deg) scale(0.8); 
          transition: transform 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        }
        .baulia-diamond-shape { 
          fill: transparent; 
          stroke: #D4AF37; 
          stroke-width: 1.72px;
          transition: fill 0.5s ease, stroke-width 0.3s ease;
        }
        .baulia-b { 
          fill: #D4AF37; 
          transition: all 0.6s ease; 
          transform-origin: 100px 100px; 
        }
        svg:hover .baulia-diamond-animator { transform: rotate(135deg) scale(0.85); }
        svg:hover .baulia-diamond-shape { stroke-width: 3px; }
        svg:hover .baulia-b { transform: scale(1.05); fill: #FDF1A9; }
      `}
    </style>
    
    <g className="baulia-text">
      <path d="M265.12,78.58h-.35c0-2.04-.75-3.8-2.24-5.25-1.5-1.46-3.27-2.18-5.31-2.18h-1.42l-.12-1.18h9.44v8.62ZM265.12,143.97v8.62h-9.44l.12-1.18h1.42c2.05,0,3.82-.73,5.31-2.18,1.49-1.46,2.24-3.21,2.24-5.25h.35ZM272.44,69.96v82.62h-7.67v-82.62h7.67ZM279.17,69.96c5.51,0,10.17.83,13.99,2.48,3.82,1.65,6.71,3.95,8.68,6.91,1.97,2.95,2.95,6.39,2.95,10.33,0,3.3-.63,6.2-1.89,8.68-1.26,2.48-2.87,4.49-4.84,6.02-1.97,1.53-4.05,2.62-6.26,3.25,4.17.63,7.77,2.01,10.8,4.13,3.03,2.12,5.35,4.78,6.96,7.97,1.61,3.19,2.42,6.75,2.42,10.68,0,4.41-1.06,8.28-3.19,11.63-2.12,3.35-5.25,5.94-9.38,7.79-4.13,1.85-9.11,2.77-14.93,2.77h-13.1c.08-1.42.12-2.83.12-4.25h12.51c4.09,0,7.55-.73,10.39-2.18,2.83-1.46,5-3.6,6.49-6.43,1.49-2.83,2.24-6.22,2.24-10.15,0-4.41-.85-7.99-2.54-10.74-1.69-2.75-3.88-4.84-6.55-6.26-2.68-1.42-5.57-2.38-8.68-2.89-3.11-.51-6.08-.77-8.91-.77v-1.06c1.81,0,3.82-.2,6.02-.59,2.2-.39,4.33-1.18,6.37-2.36,2.04-1.18,3.74-2.93,5.08-5.25,1.34-2.32,2.01-5.37,2.01-9.15,0-3.54-.65-6.57-1.95-9.09-1.3-2.52-3.23-4.43-5.78-5.72-2.56-1.3-5.72-1.95-9.5-1.95h-10.86c0-.08-.1-.41-.29-1-.2-.59-.49-1.51-.89-2.77h12.51Z" />
      <path d="M381.98,143.97c-.55,1.58-.63,2.91-.24,4.01.39,1.1,1.04,1.95,1.95,2.54.9.59,1.83.89,2.77.89h1.06v1.18h-23.73v-1.18h1.06c1.81,0,3.68-.57,5.61-1.71,1.93-1.14,3.52-3.05,4.78-5.72h6.73ZM407.36,68.31l1.06,8.26-29.63,75.66h-7.08l30.22-71.77c.86-1.97,1.59-3.66,2.18-5.08.59-1.42,1.1-2.79,1.53-4.13.43-1.34.65-2.32.65-2.95h1.06ZM424,120.36v3.54h-36.95v-3.54h36.95ZM407.36,68.31l34.94,83.57h-10.03l-27.27-72.36,2.36-11.21ZM429.31,143.97h9.68c1.18,2.68,2.75,4.58,4.72,5.72,1.97,1.14,3.85,1.71,5.67,1.71h.94v1.18h-26.56v-1.18h1.06c1.49,0,2.83-.65,4.01-1.95,1.18-1.3,1.34-3.13.47-5.49Z" />
      <path d="M506.51,69.96v7.08h-.35c0-1.73-.61-3.15-1.83-4.25-1.22-1.1-2.7-1.65-4.43-1.65h-1.89v-1.18h8.5ZM513.83,69.96v51.94c0,5.67,1.04,10.66,3.13,14.99,2.08,4.33,5.02,7.69,8.79,10.09,3.78,2.4,8.14,3.6,13.1,3.6,5.27,0,9.87-1.14,13.81-3.42,3.93-2.28,7-5.45,9.21-9.5,2.2-4.05,3.31-8.79,3.31-14.22v-53.47h5.55v53.47c0,6.14-1.32,11.51-3.95,16.11-2.64,4.6-6.36,8.2-11.15,10.8-4.8,2.6-10.39,3.9-16.76,3.9s-12.26-1.28-17.17-3.84c-4.92-2.56-8.73-6.14-11.45-10.74-2.71-4.6-4.07-9.97-4.07-16.11v-53.59h7.67ZM521.97,69.96v1.18h-1.89c-1.73,0-3.21.55-4.43,1.65-1.22,1.1-1.83,2.52-1.83,4.25h-.24v-7.08h8.38ZM538.73,61.58c1.65-1.81,3.31-3.6,4.96-5.37,1.65-1.77,3.32-3.5,5.02-5.19s3.36-3.32,5.02-4.9c.87.94,1.73,1.93,2.6,2.95.87,1.02,1.61,2.12,2.24,3.31-2.12,1.18-4.25,2.36-6.37,3.54-2.12,1.18-4.23,2.3-6.31,3.36-2.09,1.06-4.19,2.11-6.31,3.13l-.83-.83ZM565.53,69.96v7.08h-.35c0-1.73-.61-3.15-1.83-4.25-1.22-1.1-2.7-1.65-4.43-1.65h-1.89v-1.18h8.5ZM578.86,69.96v1.18h-1.89c-1.73,0-3.21.55-4.43,1.65-1.22,1.1-1.83,2.52-1.83,4.25h-.24v-7.08h8.38Z" />
      <path d="M646.97,78.58h-.35c-.08-2.04-.85-3.8-2.3-5.25-1.46-1.46-3.21-2.18-5.25-2.18h-1.53v-1.18h9.44v8.62ZM646.97,143.97v8.62h-9.44v-1.18h1.53c2.05,0,3.8-.73,5.25-2.18s2.22-3.21,2.3-5.25h.35ZM654.29,69.96v82.62h-7.67v-82.62h7.67ZM653.94,78.58v-8.62h9.44v1.18h-1.53c-2.05,0-3.8.73-5.25,2.18s-2.22,3.21-2.3,5.25h-.35ZM686.16,148.93v3.66h-32.22v-3.66h32.22ZM693.36,133.46l-6.85,19.12h-19.59l4.25-3.66c4.17,0,7.57-.65,10.21-1.95,2.64-1.3,4.78-3.13,6.43-5.49,1.65-2.36,3.11-5.04,4.37-8.03h1.18Z" />
      <path d="M758.75,78.58h-.35c-.08-2.04-.85-3.8-2.3-5.25-1.46-1.46-3.21-2.18-5.25-2.18h-1.53v-1.18h9.44v8.62ZM758.75,143.97v8.62h-9.44v-1.18h1.53c2.05,0,3.8-.73,5.25-2.18s2.22-3.21,2.3-5.25h.35ZM766.07,69.96v82.62h-7.67v-82.62h7.67ZM765.72,78.58v-8.62h9.44v1.18h-1.53c-2.05,0-3.8.73-5.25,2.18-1.46,1.46-2.22,3.21-2.3,5.25h-.35ZM765.72,143.97h.35c.08,2.05.84,3.8,2.3,5.25,1.46,1.46,3.21,2.18,5.25,2.18h1.53v1.18h-9.44v-8.62Z" />
      <path d="M846.33,143.97c-.55,1.58-.63,2.91-.24,4.01.39,1.1,1.04,1.95,1.95,2.54.9.59,1.83.89,2.77.89h1.06v1.18h-23.73v-1.18h1.06c1.81,0,3.68-.57,5.61-1.71,1.93-1.14,3.52-3.05,4.78-5.72h6.73ZM871.71,68.31l1.06,8.26-29.63,75.66h-7.08l30.22-71.77c.87-1.97,1.59-3.66,2.18-5.08.59-1.42,1.1-2.79,1.53-4.13.43-1.34.65-2.32.65-2.95h1.06ZM888.35,120.36v3.54h-36.95v-3.54h36.95ZM871.71,68.31l34.94,83.57h-10.03l-27.27-72.36,2.36-11.21ZM893.67,143.97h9.68c1.18,2.68,2.75,4.58,4.72,5.72,1.97,1.14,3.85,1.71,5.67,1.71h.94v1.18h-26.56v-1.18h1.06c1.49,0,2.83-.65,4.01-1.95s1.34-3.13.47-5.49Z" />
    </g>

    <g className="baulia-diamond-animator">
      <rect className="baulia-diamond-shape" x=".86" y=".86" width="198.64" height="198.64" transform="translate(0 200.36) rotate(-90)" strokeMiterlimit="10" />
    </g>

    <path className="baulia-b" d="M116.87,94.54l6.01-.41c6.47,0,11.27,1.21,14.42,3.62,3.14,2.42,4.72,5.83,4.72,10.25s-2.01,9.59-6.01,15.51c-4.01,5.92-9.2,11.3-15.58,16.13h7.79c3.19,0,5.42-.14,6.7-.41,1.27-.27,2-.41,2.19-.41,1.27,0,1.91.68,1.91,2.05s-.91,2.1-2.73,2.19c-7.02,0-13.76-.09-20.23-.27-10.2,6.47-20.23,9.7-30.07,9.7-4.65,0-8.34-.87-11.07-2.6s-4.1-3.48-4.1-5.26.75-3.16,2.25-4.17c1.5-1,3.62-1.5,6.36-1.5,10.66,0,22.59.23,35.81.68,5.47-4.46,9.84-9.64,13.12-15.51,3.28-5.88,4.92-11.18,4.92-15.92,0-7.56-4.06-11.34-12.16-11.34-3.19,0-6.49.5-9.91,1.5-3.42,1-5.47,1.71-6.15,2.12s-1.12.61-1.3.61c-.55,0-.82-.39-.82-1.16s1.18-1.71,3.55-2.8c10.39-5.01,20.54-11.68,30.48-20.02,9.93-8.34,14.9-14.28,14.9-17.83,0-1.64-1.28-2.46-3.83-2.46-10.39.09-24.65,7.88-42.78,23.37-3.65,9.38-9.64,20.91-17.97,34.58-8.34,13.67-17.06,25.9-26.17,36.69-9.11,10.8-15.9,16.19-20.36,16.19-2.73,0-4.1-1.41-4.1-4.24,0-6.47,6.13-17.99,18.38-34.58,12.25-16.58,26.12-31.84,41.61-45.78,2.73-6.65,4.1-11.5,4.1-14.56s-.73-5.47-2.19-7.24c-1.46-1.78-3.6-3.08-6.42-3.9-4.46-1.18-9.18-1.78-14.14-1.78s-8.77.12-11.41.34c-2.64.23-5.86.68-9.64,1.37-3.78.68-6.86,1.87-9.22,3.55-2.37,1.69-3.55,3.83-3.55,6.42s1.27,4.6,3.83,6.01c2.55,1.41,5.67,2.39,9.36,2.94s7.36,1.14,11,1.78c3.64.64,6.74,1.89,9.29,3.76,2.55,1.87,3.83,4.49,3.83,7.86,0,.91-.2,1.37-.61,1.37s-.73-.14-.96-.41c-.23-.27-.62-.82-1.16-1.64-.82-1.18-2.03-2.1-3.62-2.73-1.59-.64-4.06-1.25-7.38-1.84-3.33-.59-6.47-1.23-9.43-1.91-2.96-.68-5.94-1.57-8.95-2.66-3.01-1.09-5.42-2.64-7.24-4.65-1.82-2-2.73-4.35-2.73-7.04s1.14-5.08,3.42-7.17c2.28-2.1,5.28-3.74,9.02-4.92,7.65-2.28,15.63-3.42,23.92-3.42,21.5,0,32.25,5.65,32.25,16.95,0,1-.23,2.51-.68,4.51,18.4-14.85,33.35-22.28,44.83-22.28,5.1,0,7.65,1.55,7.65,4.65,0,4.46-4.67,10.8-14.01,19-9.34,8.2-18.98,14.58-28.9,19.13ZM44.17,163.69c2.64,0,9.73-8.45,21.25-25.35,11.52-16.9,20.75-32.64,27.68-47.22-13.67,13.03-25.76,26.58-36.29,40.66-10.52,14.08-15.78,23.66-15.78,28.77,0,2.09,1.05,3.14,3.14,3.14ZM111,142.64l-24.74-.55c-7.02,0-10.52,1.05-10.52,3.14,0,1.18,1.18,2.3,3.55,3.35,2.37,1.05,5.1,1.57,8.2,1.57,8.11,0,15.94-2.5,23.51-7.52Z" />
  </svg>
);

// --- COMPONENTES DE ESTRUCTURA ---

const mockGuests = [
  { 
    id: '1a2b', name: 'Familia Pérez Gómez', passes: 4, childrenPasses: 2, status: 'confirmado', entered: 1, phone: '5512345678', tableId: 't1', sent: true, side: 'novia', 
    subGuests: [
      { id: 's1', name: 'Sr. Roberto Pérez', isChild: false, entered: true }, 
      { id: 's2', name: 'Sra. María Gómez', isChild: false, entered: false }, 
      { id: 's3', name: 'Roberto Jr.', isChild: true, entered: false }, 
      { id: 's4', name: 'Ana Pérez', isChild: true, entered: false }
    ] 
  },
  { 
    id: '3c4d', name: 'Carlos Rodríguez', passes: 1, childrenPasses: 0, status: 'ingreso', entered: 1, phone: '5587654321', tableId: 't2', sent: true, side: 'novio', 
    subGuests: [
      { id: 's5', name: 'Carlos Rodríguez', isChild: false, entered: true }
    ] 
  },
  { 
    id: '5e6f', name: 'Ana y Roberto', passes: 2, childrenPasses: 0, status: 'pendiente', entered: 0, phone: '5599887766', tableId: null, sent: false, side: 'general', 
    subGuests: [] // Aún no han registrado los nombres
  }
];

const mockGastos = [
  { id: 1, concepto: 'Salón y Banquete', categoria: 'Lugar', estimado: 80000, pagado: 40000, proveedorId: null, fechaLimite: '2026-10-15', historial: [{id: 1, fecha: '2025-10-01', monto: 40000, metodo: 'Transferencia', cuenta: '0987654321'}] },
  { id: 2, concepto: 'DJ e Iluminación', categoria: 'Música', estimado: 15000, pagado: 5000, proveedorId: 3, fechaLimite: '2024-05-01', historial: [{id: 2, fecha: '2023-10-15', monto: 5000, metodo: 'Efectivo', cuenta: ''}] },
];

const mockProveedores = [
  { id: 1, nombre: 'Florería El Encanto', categoria: 'Decoración', servicio: 'Arreglos Florales', costo: 20000, status: 'Cotizado', contratado: false, gastoId: null, contrato: null, telefono: '5511223344', email: 'flores@encanto.com', notas: 'Las flores son súper frescas.', banco: 'BBVA', clabe: '012345678901234567', titular: 'Ana Flores', rating: 0, galeria: 2 },
  { id: 2, nombre: 'Banquetes Gourmet', categoria: 'Comida/Bebida', servicio: 'Catering 100 pax', costo: 85000, status: 'Descartado', contratado: false, gastoId: null, contrato: null, telefono: '5599887766', email: 'ventas@gourmet.com', notas: 'Muy caros y no incluyen mantelería.', banco: '', clabe: '', titular: '', rating: 2, galeria: 0 },
  { id: 3, nombre: 'DJ Party Mix', categoria: 'Música', servicio: 'Audio e Iluminación', costo: 15000, status: 'Contratado', contratado: true, gastoId: 2, contrato: 'contrato_dj.pdf', telefono: '5522334455', email: 'dj@partymix.com', notas: 'Llegarán 3 horas antes a montar.', banco: 'Santander', clabe: '014987654321098765', titular: 'Carlos Mix', rating: 5, galeria: 1 },
];

const mockTareas = [
  { id: 1, titulo: 'Definir lista de invitados inicial', categoria: 'Logística', fechaLimite: '2025-01-15', estado: 'listo' },
  { id: 2, titulo: 'Prueba de menú y coctelería', categoria: 'Comida/Bebida', fechaLimite: '2026-05-15', estado: 'proceso' },
  { id: 3, titulo: 'Enviar invitaciones digitales', categoria: 'Comunicación', fechaLimite: '2026-08-01', estado: 'pendiente' },
  { id: 4, titulo: 'Trámite de permisos del salón', categoria: 'Trámites', fechaLimite: '2024-02-10', estado: 'pendiente' }, // Tarea vencida de prueba
];

const mockTiming = [
  { id: 1, hora: '14:00', actividad: 'Recepción y Coctel de Bienvenida', responsable: 'Hostess / Catering', lugar: 'Terraza Sur', notas: 'Ofrecer margaritas y canapés fríos.' },
  { id: 2, hora: '15:30', actividad: 'Entrada Estelar', responsable: 'DJ Party Mix', lugar: 'Salón Principal', notas: 'Canción: Viva la Vida (Coldplay). Luces al 100%.' },
  { id: 3, hora: '16:00', actividad: 'Inicio del Banquete (1er Tiempo)', responsable: 'Capitán de Meseros', lugar: 'Salón Principal', notas: 'Servir Crema de Cilantro rápidamente.' },
  { id: 4, hora: '18:00', actividad: 'Apertura de Pista / Baile', responsable: 'Novios / DJ', lugar: 'Pista de Baile', notas: 'Chisperos encendidos al centro de la pista.' },
];

// --- BASE DE DATOS GLOBAL Y UTILIDADES ---
const mockGlobalProviders = [
  { 
    id: 'prov_1', nombre: 'Florería El Encanto', facebook: '[https://facebook.com/elencantoflores](https://facebook.com/elencantoflores)',
    categoria: 'Decoración', servicio: 'Arreglos Florales y Centros de Mesa', costoPromedio: 20000, 
    lat: 19.4326, lng: -99.1332, ratingPromedio: 4.8, telefono: '5511223344'
  },
  { 
    id: 'prov_2', nombre: 'Banquetes Gourmet MTY', facebook: '[https://facebook.com/banquetesgourmetmty](https://facebook.com/banquetesgourmetmty)',
    categoria: 'Comida/Bebida', servicio: 'Catering Premium 3 Tiempos', costoPromedio: 85000, 
    lat: 25.6866, lng: -100.3161, ratingPromedio: 5.0, telefono: '8112345678'
  },
  { 
    id: 'prov_3', nombre: 'DJ Party Mix', facebook: '[https://facebook.com/djpartymixoficial](https://facebook.com/djpartymixoficial)',
    categoria: 'Música', servicio: 'Audio, Iluminación y Chisperos', costoPromedio: 15000, 
    lat: 19.0414, lng: -98.2063, ratingPromedio: 3.5, telefono: '2221234567'
  }
];

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; 
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// ==========================================
// --- COMPONENTE: MENÚ LATERAL (SIDEBAR) ---
// ==========================================
const Sidebar = ({ isOpen, setIsOpen, activeTab, setActiveTab, userRole, userPlan, agencyConfig, isDarkMode, hasSocialWall, hasBlackLabel }) => {
  const planLevels = { 'oro': 1, 'diamante': 2 };
  const level = planLevels[userPlan] || 2; 

  const menuGroups = [
    { 
      title: 'Planeación y Finanzas', 
      items: [ 
        { id: 'dashboard', icon: LayoutDashboard, label: 'Centro de Mando', minLevel: 1, allowedPlans: ['basico', 'esencial', 'plata', 'oro', 'diamante'] }, 
        { id: 'tareas', icon: CheckSquare, label: 'Checklist', minLevel: 1, allowedPlans: ['basico', 'esencial', 'plata', 'oro', 'diamante'] }, 
        { id: 'presupuesto', icon: Wallet, label: 'Control Financiero', minLevel: 1, allowedPlans: ['basico', 'esencial', 'plata', 'oro', 'diamante'] }, 
        { id: 'proveedores', icon: Store, label: 'Directorio de Proveedores', minLevel: 1, allowedPlans: ['basico', 'esencial', 'plata', 'oro', 'diamante'] } 
      ] 
    },
    { 
      title: 'Logística de Invitados', 
      items: [ 
        { id: 'invitados', icon: Users, label: 'Lista de Invitados', minLevel: 1, allowedPlans: ['basico', 'esencial', 'plata', 'oro', 'diamante'] }, 
        { id: 'invitacion', icon: Smartphone, label: 'Invitación Digital', minLevel: 1, allowedPlans: ['basico', 'esencial', 'plata', 'oro', 'diamante'] }, 
        { id: 'mesas', icon: LayoutGrid, label: 'Gestión de Mesas', minLevel: 2, allowedPlans: ['oro', 'diamante'] },
        { id: 'mapa', icon: MapIcon, label: 'Croquis del Salón', minLevel: 2, allowedPlans: ['diamante'] }
      ] 
    },
    { 
      title: 'Operación del Evento', 
      items: [ 
        { id: 'timing', icon: Clock, label: 'El Minuto a Minuto', minLevel: 1, allowedPlans: ['plata', 'oro', 'diamante'] }, 
        { id: 'escaner', icon: Scan, label: 'Control Puerta (QR)', minLevel: 2, allowedPlans: ['oro', 'diamante', 'security_kit'], extraCondition: hasBlackLabel }, 
        { id: 'monitor', icon: Activity, label: 'Monitor en Vivo', minLevel: 2, allowedPlans: ['diamante', 'security_kit'], extraCondition: hasBlackLabel } 
      ] 
    },
    { 
      title: 'Add-Ons', 
      items: [ 
        { id: 'pulseras', icon: Ticket, label: 'Taller Black Label', minLevel: 2, allowedPlans: ['diamante', 'security_kit'], extraCondition: hasBlackLabel }, 
        { id: 'galeria', icon: Camera, label: 'Muro Social (Vivo)', minLevel: 1, allowedPlans: ['diamante', 'social_wall'], extraCondition: hasSocialWall } 
      ] 
    }
  ];

  const themeColors = { indigo: 'bg-indigo-600 text-white shadow-[0_0_15px_rgba(79,70,229,0.4)]', rose: 'bg-rose-600 text-white shadow-[0_0_15px_rgba(225,29,72,0.4)]', emerald: 'bg-emerald-600 text-white shadow-[0_0_15px_rgba(5,150,105,0.4)]', slate: 'bg-slate-800 dark:bg-white/20 text-white', amber: 'bg-gradient-to-r from-amber-500 to-yellow-600 text-white shadow-[0_0_20px_rgba(245,158,11,0.3)] border border-amber-400/50', sky: 'bg-sky-500 text-white' };
  const activeTheme = agencyConfig?.themeColor ? themeColors[agencyConfig.themeColor] : themeColors.amber;
  const agencyName = agencyConfig?.name || 'BAULIA';

  return (
    <aside className="hidden xl:flex inset-y-0 left-0 z-30 w-72 bg-[#000000] text-slate-300 transition-transform duration-500 flex-col border-r border-white/5 print:hidden">
      <div className="flex items-center justify-center px-6 h-[88px] shrink-0 border-b border-white/5">
        {/* LOGO PLATINO ESCRITORIO EN LÍNEA */}
        <svg viewBox="0 0 950.3 241.1" className="h-6 w-auto" xmlns="http://www.w3.org/2000/svg">
          <g fill="#F8FAFC">
            <path d="M300.8,89.1h-.4c0-2-.7-3.8-2.2-5.3s-3.3-2.2-5.3-2.2h-1.4v-1.2c-.1,0,9.3,0,9.3,0v8.6h0ZM300.8,154.4v8.6h-9.4v-1.2h1.5c2,0,3.8-.7,5.3-2.2s2.2-3.2,2.2-5.3h.4ZM308.1,80.4v82.6h-7.7v-82.6h7.7ZM314.8,80.4c5.5,0,10.2.8,14,2.5s6.7,4,8.7,6.9c2,3,3,6.4,3,10.3s-.6,6.2-1.9,8.7-2.9,4.5-4.8,6c-2,1.5-4.1,2.6-6.3,3.2,4.2.6,7.8,2,10.8,4.1s5.4,4.8,7,8c1.6,3.2,2.4,6.7,2.4,10.7s-1.1,8.3-3.2,11.6-5.3,5.9-9.4,7.8c-4.1,1.9-9.1,2.8-14.9,2.8h-13.1c0-1.4.1-2.8.1-4.2h12.5c4.1,0,7.6-.7,10.4-2.2s5-3.6,6.5-6.4c1.5-2.8,2.2-6.2,2.2-10.2s-.8-8-2.5-10.7c-1.7-2.8-3.9-4.8-6.6-6.3-2.7-1.4-5.6-2.4-8.7-2.9s-6.1-.8-8.9-.8v-1.1c1.8,0,3.8-.2,6-.6s4.3-1.2,6.4-2.4c2-1.2,3.7-2.9,5.1-5.3,1.3-2.3,2-5.4,2-9.1s-.6-6.6-1.9-9.1-3.2-4.4-5.8-5.7c-2.6-1.3-5.7-1.9-9.5-1.9h-10.9s0-.4-.3-1c-.2-.6-.5-1.5-.9-2.8h12.5,0Z"/>
            <path d="M417.6,154.4c-.6,1.6-.6,2.9-.2,4s1,1.9,1.9,2.5,1.8.9,2.8.9h1.1v1.2h-23.7v-1.2h1.1c1.8,0,3.7-.6,5.6-1.7,1.9-1.1,3.5-3,4.8-5.7h6.7,0ZM443,78.8l1.1,8.3-29.6,75.7h-7.1l30.2-71.8c.9-2,1.6-3.7,2.2-5.1s1.1-2.8,1.5-4.1c.4-1.3.6-2.3.6-3h1.1,0ZM459.6,130.8v3.5h-36.9v-3.5h36.9ZM443,78.8l34.9,83.6h-10l-27.3-72.4s2.4-11.2,2.4-11.2ZM464.9,154.4h9.7c1.2,2.7,2.8,4.6,4.7,5.7,2,1.1,3.9,1.7,5.7,1.7h.9v1.2h-26.6v-1.2h1.1c1.5,0,2.8-.6,4-1.9,1.2-1.3,1.3-3.1.5-5.5h0Z"/>
            <path d="M542.1,80.4v7.1h-.4c0-1.7-.6-3.1-1.8-4.2s-2.7-1.7-4.4-1.7h-1.9v-1.2h8.5ZM549.5,80.4v51.9c0,5.7,1,10.7,3.1,15s5,7.7,8.8,10.1c3.8,2.4,8.1,3.6,13.1,3.6s9.9-1.1,13.8-3.4c3.9-2.3,7-5.4,9.2-9.5s3.3-8.8,3.3-14.2v-53.5h5.5v53.5c0,6.1-1.3,11.5-4,16.1-2.6,4.6-6.4,8.2-11.2,10.8s-10.4,3.9-16.8,3.9-12.3-1.3-17.2-3.8c-4.9-2.6-8.7-6.1-11.4-10.7-2.7-4.6-4.1-10-4.1-16.1v-53.6h7.9ZM557.6,80.4v1.2h-1.9c-1.7,0-3.2.6-4.4,1.7s-1.8,2.5-1.8,4.2h-.2v-7.1h8.4,0ZM574.4,72.1c1.7-1.8,3.3-3.6,5-5.4s3.3-3.5,5-5.2,3.4-3.3,5-4.9c.9.9,1.7,1.9,2.6,3,.9,1,1.6,2.1,2.2,3.3-2.1,1.2-4.2,2.4-6.4,3.5-2.1,1.2-4.2,2.3-6.3,3.4s-4.2,2.1-6.3,3.1c0,0-.8-.8-.8-.8ZM601.2,80.4v7.1h-.4c0-1.7-.6-3.1-1.8-4.2s-2.7-1.7-4.4-1.7h-1.9v-1.2h8.5ZM614.5,80.4v1.2h-1.9c-1.7,0-3.2.6-4.4,1.7s-1.8,2.5-1.8,4.2h-.2v-7.1h8.4,0Z"/>
            <path d="M682.6,89.1h-.4c0-2-.8-3.8-2.3-5.3s-3.2-2.2-5.3-2.2h-1.5v-1.2h9.4v8.6h0ZM682.6,154.4v8.6h-9.4v-1.2h1.5c2,0,3.8-.7,5.3-2.2s2.2-3.2,2.3-5.3h.4,0ZM689.9,80.4v82.6h-7.7v-82.6h7.7ZM689.6,89.1v-8.6h9.4v1.2h-1.5c-2,0-3.8.7-5.3,2.2s-2.2,3.2-2.3,5.3h-.4,0ZM721.8,159.4v3.7h-32.2v-3.7h32.2ZM729,143.9l-6.8,19.1h-19.6l4.2-3.7c4.2,0,7.6-.6,10.2-1.9,2.6-1.3,4.8-3.1,6.4-5.5,1.7-2.4,3.1-5,4.4-8h1.2,0Z"/>
            <path d="M794.4,89.1h-.4c0-2-.8-3.8-2.3-5.3s-3.2-2.2-5.3-2.2h-1.5v-1.2h9.4v8.6h0ZM794.4,154.4v8.6h-9.4v-1.2h1.5c2,0,3.8-.7,5.3-2.2s2.2-3.2,2.3-5.3h.4,0ZM801.7,80.4v82.6h-7.7v-82.6h7.7ZM801.3,89.1v-8.6h9.4v1.2h-1.5c-2,0-3.8.7-5.3,2.2s-2.2,3.2-2.3,5.3h-.4,0ZM801.3,154.4h.4c0,2,.8,3.8,2.3,5.3s3.2,2.2,5.3,2.2h1.5v1.2h-9.4v-8.6h0Z"/>
            <path d="M882,154.4c-.6,1.6-.6,2.9-.2,4,.4,1.1,1,1.9,1.9,2.5s1.8.9,2.8.9h1.1v1.2h-23.7v-1.2h1.1c1.8,0,3.7-.6,5.6-1.7,1.9-1.1,3.5-3,4.8-5.7h6.7,0ZM907.3,78.8l1.1,8.3-29.6,75.7h-7.1l30.2-71.8c.9-2,1.6-3.7,2.2-5.1.6-1.4,1.1-2.8,1.5-4.1.4-1.3.6-2.3.6-3h1.1ZM924,130.8v3.5h-36.9v-3.5h36.9ZM907.3,78.8l34.9,83.6h-10l-27.3-72.4,2.4-11.2h0ZM929.3,154.4h9.7c1.2,2.7,2.8,4.6,4.7,5.7,2,1.1,3.9,1.7,5.7,1.7h.9v1.2h-26.6v-1.2h1.1c1.5,0,2.8-.6,4-1.9s1.3-3.1.5-5.5h0Z"/>
            <path d="M84.6,147.2c-8.9,11.8-13.3,19.9-13.3,24.2s.9,2.6,2.6,2.6h0c2.2,0,8.2-7.1,17.9-21.3,9.7-14.2,17.5-27.5,23.3-39.8-11.5,11-21.7,22.4-30.5,34.2Z"/>
            <path d="M109.4,155.8c-5.9,0-8.9.9-8.9,2.6s1,1.9,3,2.8c2,.9,4.3,1.3,6.9,1.3,6.8,0,13.4-2.1,19.7-6.3l-20.8-.5Z"/>
            <path d="M121.1,8L8.5,120.6l112.5,112.5,112.5-112.5L121.1,8ZM159.4,99.7c-7.9,6.9-16,12.3-24.3,16.1h0s5-.4,5-.4c5.5,0,9.5,1,12.2,3.1s4,4.9,4,8.6-1.7,8.1-5,13.1-7.8,9.5-13.1,13.6h6.5c2.7,0,4.5-.1,5.6-.3,1.1-.2,1.7-.3,1.8-.3,1.1,0,1.6.6,1.6,1.7s-.8,1.8-2.3,1.8c-5.9,0-11.6,0-17-.2-8.6,5.5-17,8.2-25.3,8.2s-7-.7-9.3-2.2c-2.3-1.5-3.5-2.9-3.5-4.4s.6-2.6,1.9-3.5c1.3-.8,3.1-1.3,5.4-1.3,9,0,19,.2,30.1.6,4.6-3.8,8.3-8.1,11-13.1,2.8-5,4.1-9.4,4.1-13.4,0-6.4-3.4-9.5-10.3-9.5s-5.5.4-8.4,1.3c-2.9.8-4.6,1.4-5.2,1.8-.6.3-.9.5-1.1.5-.5,0-.7-.3-.7-1s1-1.4,3-2.4c8.8-4.2,17.3-9.8,25.6-16.9s12.5-12,12.5-15-1.1-2.1-3.2-2.1c-8.8,0-20.8,6.6-36,19.7-3.1,7.9-8.1,17.6-15.1,29.1-7,11.5-14.4,21.8-22,30.9-7.7,9.1-13.4,13.6-17.1,13.6s-3.5-1.2-3.5-3.6c0-5.5,5.2-15.1,15.5-29.1,10.3-14,22-26.8,35-38.5,2.3-5.6,3.5-9.7,3.5-12.2s-.6-4.6-1.8-6.1c-1.2-1.5-3-2.6-5.4-3.3-3.8-1-7.7-1.5-11.9-1.5s-7.4,0-9.6.3c-2.2.2-4.9.6-8.1,1.2-3.2.6-5.8,1.6-7.8,3-2,1.4-3,3.2-3,5.4s1.1,3.9,3.2,5c2.2,1.2,4.8,2,7.9,2.5,3.1.5,6.2,1,9.3,1.5s5.7,1.6,7.8,3.2c2.2,1.6,3.2,3.8,3.2,6.6s-.2,1.2-.5,1.2-.6-.1-.8-.3c-.2-.2-.5-.7-1-1.4-.7-1-1.7-1.8-3.1-2.3s-3.4-1.1-6.2-1.6c-2.8-.5-5.5-1-7.9-1.6-2.5-.6-5-1.3-7.5-2.2-2.5-.9-4.6-2.2-6.1-3.9-1.5-1.7-2.3-3.7-2.3-5.9s1-4.3,2.9-6c1.9-1.8,4.5-3.1,7.6-4.1,6.5-1.9,13.2-2.9,20.1-2.9,18.1,0,27.1,4.8,27.1,14.3s0,2.6,0,3.4c15.2-12.2,27.6-18.3,37.2-18.3s6.5,1.3,6.5,3.9c0,3.8-3.9,9.1-11.8,16Z"/>
            <path d="M121.1,0L.5,120.6l120.5,120.5,120.5-120.5L121.1,0ZM3.5,120.5L121.1,2.9l117.6,117.6-117.6,117.6L3.5,120.5Z"/>
          </g>
        </svg>
      </div>
      
      <nav className="flex-1 overflow-y-auto py-6 px-4 space-y-7 custom-scrollbar">
        {menuGroups.map((group, gIdx) => {
          const visibleItems = group.items.filter(item => {
            if (item.extraCondition === true) return true;
            if (item.allowedPlans && userPlan) return item.allowedPlans.includes(userPlan.toLowerCase());
            return level >= item.minLevel; 
          });
          if (visibleItems.length === 0) return null;
          return (
            <div key={`desk_g_${gIdx}`} className="space-y-1">
              <p className="text-[9px] text-slate-500 uppercase tracking-[0.2em] font-bold ml-4 mb-3">{group.title}</p>
              {visibleItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeTab === item.id;
                return (
                  <button key={item.id} onClick={() => setActiveTab(item.id)} className={`w-full flex items-center space-x-3 px-4 py-3.5 rounded-xl transition-all ${isActive ? 'bg-white/10 text-white font-bold' : 'text-slate-400 hover:bg-white/5 hover:text-white'}`}>
                    <Icon size={18} strokeWidth={isActive ? 2.5 : 2} />
                    <span className="text-xs tracking-wide">{item.label}</span>
                  </button>
                );
              })}
            </div>
          );
        })}
      </nav>
    </aside>
  );
};

// ==========================================
// --- COMPONENTE: DASHBOARD VIEW (VISTA MAESTRA) ---
// ==========================================
const DashboardView = ({ authData, guests, tables, gastos, presupuestoTotal, tareas, setActiveTab, addNotification }) => {
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);
  const [passModal, setPassModal] = useState({ open: false, newPass: '', loading: false, msg: '', type: '' });

  // 🔴 DETECTOR DE DATOS FANTASMA (ONBOARDING)
  const isDemoMode = (guests || []).some(g => String(g.id).includes('_demo_')) || 
                     (tables || []).some(t => String(t.id).includes('_demo_')) || 
                     (gastos || []).some(g => String(g.id).includes('_demo_')) ||
                     (tareas || []).some(t => String(t.id).includes('_demo_'));

  const handleClearDemoData = async () => {
    if(addNotification) addNotification('Limpiando Bóveda...', 'Eliminando datos de ejemplo.', 'info');
    const promesas = [];
    (guests || []).filter(g => String(g.id).includes('_demo_')).forEach(g => promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", g.id))));
    (tables || []).filter(t => String(t.id).includes('_demo_')).forEach(t => promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", t.id))));
    (gastos || []).filter(g => String(g.id).includes('_demo_')).forEach(g => promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "gastos", g.id))));
    (tareas || []).filter(t => String(t.id).includes('_demo_')).forEach(t => promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "tareas", t.id))));
    await Promise.all(promesas);
    if(addNotification) addNotification('¡Bóveda Limpia!', 'El panel está listo para tu evento real.', 'success');
  };

  const totalPasses = guests.reduce((sum, guest) => sum + guest.passes, 0);
  const confirmedPasses = guests.filter(g => g.status === 'confirmado' || g.status === 'ingreso').reduce((sum, guest) => sum + guest.passes, 0);
  const confirmationPercentage = totalPasses > 0 ? Math.round((confirmedPasses / totalPasses) * 100) : 0;

  const totalMesas = tables ? tables.length : 0;
  const capacidadTotalSillas = tables ? tables.reduce((sum, t) => sum + (t.capacity || 10), 0) : 0;
  const pasesAcomodados = guests.filter(g => g.tableId).reduce((sum, g) => sum + g.passes, 0);
  const ocupacionPorcentaje = capacidadTotalSillas > 0 ? Math.round((pasesAcomodados / capacidadTotalSillas) * 100) : 0;

  const totalEstimado = gastos ? gastos.reduce((sum, g) => sum + g.estimado, 0) : 0;
  const totalPagado = gastos ? gastos.reduce((sum, g) => sum + g.pagado, 0) : 0;
  const budgetPercentage = presupuestoTotal > 0 ? Math.round((totalEstimado / presupuestoTotal) * 100) : 0;

  const tareasCompletadas = tareas ? tareas.filter(t => t.estado === 'listo').length : 0;
  const tareasTotal = tareas ? tareas.length : 0;
  const tareasPorcentaje = tareasTotal > 0 ? Math.round((tareasCompletadas / tareasTotal) * 100) : 0;

  const tareasPendientes = tareas ? tareas.filter(t => t.estado !== 'listo').sort((a, b) => new Date(a.fechaLimite || '2099-01-01') - new Date(b.fechaLimite || '2099-01-01')).slice(0, 4) : [];
  const pagosPendientes = gastos ? gastos.filter(g => (g.estimado - g.pagado) > 0).sort((a, b) => new Date(a.fechaLimite || '2099-01-01') - new Date(b.fechaLimite || '2099-01-01')).slice(0, 3) : [];

  const formatMoney = (amount) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount || 0);
  const isOverdue = (dateStr) => { if(!dateStr) return false; return new Date(dateStr) < new Date(); };

  const currentEvent = authData?.availableEvents?.find(e => e.eventId === authData?.eventId);
  const plan = currentEvent?.plan || 'oro';
  const eventName = currentEvent?.nombres || 'Proyecto Baulia';

  let gradientStyle = 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)';
  let accentColor = '#64748b'; 
  if (plan === 'diamante') { gradientStyle = 'linear-gradient(180deg, #eef2ff 0%, #ffffff 100%)'; accentColor = '#4f46e5'; } 
  else if (plan === 'oro') { gradientStyle = 'linear-gradient(180deg, #fffbeb 0%, #ffffff 100%)'; accentColor = '#d97706'; } 
  else if (plan === 'plata') { gradientStyle = 'linear-gradient(180deg, #f1f5f9 0%, #ffffff 100%)'; accentColor = '#475569'; }

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if(passModal.newPass.length < 6) { setPassModal(prev => ({...prev, msg: 'La contraseña debe tener al menos 6 caracteres.', type: 'error'})); return; }
    setPassModal(prev => ({...prev, loading: true, msg: ''}));
    try {
      if (!auth.currentUser) throw new Error("No hay usuario autenticado.");
      await updatePassword(auth.currentUser, passModal.newPass);
      setPassModal({ open: false, newPass: '', loading: false, msg: '¡Contraseña actualizada exitosamente!', type: 'success' });
      if(addNotification) addNotification('Seguridad Actualizada', 'Tu contraseña ha sido cambiada.', 'success');
      setTimeout(() => setPassModal({ open: false, newPass: '', loading: false, msg: '', type: '' }), 3000);
    } catch (error) {
      if(error.code === 'auth/requires-recent-login') setPassModal(prev => ({...prev, loading: false, msg: 'Cierra sesión y vuelve a entrar para cambiarla.', type: 'error'}));
      else setPassModal(prev => ({...prev, loading: false, msg: 'Error al cambiar la contraseña.', type: 'error'}));
    }
  };

  const triggerDashboardPdf = async () => {
    setIsPreparingPrint(true);
    if(addNotification) addNotification('Preparando Documento', 'Generando formato ejecutivo...', 'info');
    setTimeout(async () => {
      try {
        const { jsPDF } = await import('jspdf');
        const html2canvas = (await import('html2canvas')).default;
        const element = document.getElementById('hidden-executive-report');
        const canvas = await html2canvas(element, { scale: 2, useCORS: true, logging: false });
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF('p', 'mm', 'letter');
        pdf.addImage(imgData, 'JPEG', 0, 0, 215.9, 279.4);
        pdf.save(`Reporte-Ejecutivo-${eventName.replace(/\s+/g, '-')}.pdf`);
        if(addNotification) addNotification('¡Descarga Lista!', 'El reporte se guardó en tu dispositivo.', 'success');
      } catch (error) { if(addNotification) addNotification('Error', 'Fallo al generar el PDF.', 'error'); }
      setIsPreparingPrint(false);
    }, 800);
  };

  return (
    <div className="space-y-6 relative">
      
      {/* 🔴 BANNER DE ONBOARDING (DATOS FANTASMA) - Oculto si es solo Social Wall */}
      {isDemoMode && plan !== 'social_wall' && (
        <div className="bg-indigo-600 dark:bg-amber-500 rounded-2xl p-5 shadow-lg flex flex-col sm:flex-row items-center justify-between gap-4 animate-in slide-in-from-top-4">
          <div className="flex items-center text-white dark:text-slate-900">
            <Sparkles size={24} className="mr-3 shrink-0 animate-pulse"/>
            <div>
              <h3 className="font-black text-lg">Modo de Demostración</h3>
              <p className="text-sm font-medium opacity-90">Hemos cargado datos de ejemplo para que veas cómo funciona la Bóveda. Explora a tu gusto.</p>
            </div>
          </div>
          <button onClick={handleClearDemoData} className="w-full sm:w-auto px-6 py-3 bg-white text-indigo-700 dark:text-slate-900 rounded-xl font-black text-xs uppercase tracking-widest shadow-md hover:scale-105 transition-transform shrink-0">
             Iniciar mi Evento Real
          </button>
        </div>
      )}

      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-[#1C1917] p-5 sm:p-6 rounded-3xl border border-[#D4AF37]/25 shadow-xl">
        <div className="flex items-center gap-3.5">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
            <Activity size={20} />
          </div>
          <div>
            <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block mb-0.5">Monitoreo en tiempo real de tu evento.</span>
            <h2 className="text-2xl sm:text-3xl font-editorial text-white tracking-wide leading-none">Centro de Mando</h2>
          </div>
        </div>
        
        <div className="flex flex-wrap items-center gap-2.5 w-full md:w-auto justify-start md:justify-end">
          <button onClick={() => setPassModal({ ...passModal, open: true })} className="flex-1 md:flex-none flex items-center justify-center px-4 h-9 bg-transparent border border-white/10 text-slate-300 rounded-lg text-[10px] font-bold hover:bg-white/5 hover:text-white transition-colors uppercase tracking-widest shrink-0">
            <Key size={14} className="mr-1.5 text-[#D4AF37]" /> <span className="hidden sm:inline">Cambiar</span> Contraseña
          </button>
          {/* El botón de PDF se oculta si es Social Wall porque no hay mesas ni invitados que imprimir */}
          {plan !== 'social_wall' && (
            <button onClick={triggerDashboardPdf} disabled={isPreparingPrint} className="flex-1 md:flex-none flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-[#1C1917] rounded-lg text-[10px] font-black hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)] uppercase tracking-widest shrink-0 disabled:opacity-50">
              {isPreparingPrint ? <RefreshCw size={14} className="mr-1.5 animate-spin"/> : <Download size={14} className="mr-1.5"/>} 
              {isPreparingPrint ? 'Generando...' : <><span className="hidden sm:inline">Descargar</span> Reporte</>}
            </button>
          )}
        </div>
      </div>

      {/* 🟢 MAGIA AQUÍ: SI ES SOCIAL WALL, MOSTRAMOS LA CONSOLA VIP. SI NO, LAS GRÁFICAS NORMALES */}
      {plan === 'social_wall' ? (
        <div className="bg-slate-900 dark:bg-[#0a0a0a] rounded-3xl p-8 sm:p-12 text-center text-white border border-slate-800 dark:border-white/10 shadow-2xl relative overflow-hidden transition-colors mt-6">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[200%] h-full bg-indigo-500/10  hidden md:block  hidden md:block blur-[100px] rounded-full pointer-events-none"></div>
          
          <Sparkles size={64} className="mx-auto mb-6 text-amber-500 animate-pulse"/>
          <h2 className="text-3xl sm:text-5xl font-black mb-4 tracking-tight">Tu Muro Social está listo</h2>
          <p className="text-slate-400 text-sm sm:text-base max-w-lg mx-auto mb-8">
            Bienvenido a tu experiencia interactiva. Todo tu ecosistema está optimizado para proyectar las fotos de tu evento en tiempo real. Cero estrés, 100% Alta Costura.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
            {setActiveTab && (
              <button onClick={() => setActiveTab('galeria')} className="px-8 py-4 bg-amber-500 hover:bg-amber-400 text-slate-900 font-black rounded-xl uppercase tracking-widest text-xs transition-colors shadow-[0_0_20px_rgba(245,158,11,0.3)] flex items-center justify-center">
                 Abrir Consola del Proyector
              </button>
            )}
          </div>
        </div>
      ) : (
        <>
          {/* VISTA NORMAL (ORO/DIAMANTE) - GRÁFICAS DE MESAS, DINERO, ETC. */}
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-6 mt-6">
            <div className="bg-[#1C1917] p-4 sm:p-6 rounded-3xl border border-[#D4AF37]/30 shadow-xl relative overflow-hidden group">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-[#D4AF37] text-[9px] sm:text-[10px] font-black uppercase tracking-widest">Asignados</p>
                  <h3 className="text-2xl sm:text-4xl font-black text-white mt-1">{totalPasses}</h3>
                </div>
                <div className="p-2 sm:p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/20 text-[#D4AF37] rounded-xl group-hover:scale-110 transition-transform"><Users className="w-4 h-4 sm:w-6 sm:h-6" /></div>
              </div>
              <div className="mt-3 sm:mt-4 flex items-center text-sm">
                <span className="text-[#1C1917] font-black bg-[#D4AF37] px-2 py-0.5 rounded text-[8px] sm:text-[10px] uppercase tracking-widest">{confirmationPercentage}% Confirmado</span>
              </div>
            </div>

            <div className="bg-[#1C1917] p-4 sm:p-6 rounded-3xl border border-[#D4AF37]/30 shadow-xl relative overflow-hidden group">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-[#D4AF37] text-[9px] sm:text-[10px] font-black uppercase tracking-widest">Mesas</p>
                  <h3 className="text-2xl sm:text-4xl font-black text-white mt-1">{totalMesas}</h3>
                </div>
                <div className="p-2 sm:p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/20 text-[#D4AF37] rounded-xl group-hover:scale-110 transition-transform"><Layers className="w-4 h-4 sm:w-6 sm:h-6" /></div>
              </div>
              <div className="mt-3 sm:mt-5 w-full bg-black/40 rounded-full h-1.5 overflow-hidden">
                <div className="bg-[#D4AF37] h-full rounded-full transition-all duration-500" style={{ width: `${ocupacionPorcentaje}%` }}></div>
              </div>
              <p className="text-[8px] sm:text-[10px] text-slate-400 mt-2 sm:mt-3 font-bold uppercase tracking-widest">
                <span className="text-white">{capacidadTotalSillas} Sillas</span> • {ocupacionPorcentaje}%
              </p>
            </div>

            <div className="bg-[#1C1917] p-4 sm:p-6 rounded-3xl border border-[#D4AF37]/30 shadow-xl relative overflow-hidden group">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-[#D4AF37] text-[9px] sm:text-[10px] font-black uppercase tracking-widest">Estimado</p>
                  <h3 className="text-2xl sm:text-4xl font-black text-white mt-1">${(totalEstimado / 1000).toFixed(0)}k</h3>
                </div>
                <div className="p-2 sm:p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/20 text-[#D4AF37] rounded-xl group-hover:scale-110 transition-transform"><Wallet className="w-4 h-4 sm:w-6 sm:h-6" /></div>
              </div>
              <div className="mt-3 sm:mt-5 w-full bg-black/40 rounded-full h-1.5 overflow-hidden">
                <div className={`h-full rounded-full transition-colors ${budgetPercentage > 100 ? 'bg-rose-500' : 'bg-[#D4AF37]'}`} style={{ width: `${Math.min(budgetPercentage, 100)}%` }}></div>
              </div>
              <p className="text-[8px] sm:text-[10px] text-slate-400 mt-2 sm:mt-3 font-bold uppercase tracking-widest flex flex-col sm:flex-row sm:justify-between">
                <span>Pagado: ${(totalPagado/1000).toFixed(1)}k</span>
              </p>
            </div>

            <div className="bg-[#1C1917] p-4 sm:p-6 rounded-3xl border border-[#D4AF37]/30 shadow-xl relative overflow-hidden group">
              <div className="flex justify-between items-start">
                <div>
                  <p className="text-[#D4AF37] text-[9px] sm:text-[10px] font-black uppercase tracking-widest">Avance</p>
                  <h3 className="text-2xl sm:text-4xl font-black text-white mt-1">{tareasPorcentaje}%</h3>
                </div>
                <div className="p-2 sm:p-3 bg-[#D4AF37]/10 border border-[#D4AF37]/20 text-[#D4AF37] rounded-xl group-hover:scale-110 transition-transform"><CheckSquare className="w-4 h-4 sm:w-6 sm:h-6" /></div>
              </div>
              <div className="mt-3 sm:mt-5 w-full bg-black/40 rounded-full h-1.5 overflow-hidden">
                <div className="bg-[#D4AF37] h-full rounded-full" style={{ width: `${tareasPorcentaje}%` }}></div>
              </div>
              <p className="text-[8px] sm:text-[10px] text-slate-400 mt-2 sm:mt-3 font-bold uppercase tracking-widest">
                <span className="text-white">{tareasCompletadas}</span> de {tareasTotal}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
            <div className="bg-[#1C1917] rounded-3xl border border-[#D4AF37]/30 shadow-xl flex flex-col overflow-hidden">
              <div className="p-5 border-b border-[#D4AF37]/15 bg-[#141210] flex justify-between items-center">
                <h3 className="font-bold text-white flex items-center text-sm"><ListTodo size={16} className="mr-2 text-[#D4AF37]"/> Prioridades Logísticas</h3>
                {setActiveTab && <button onClick={() => setActiveTab('tareas')} className="text-[10px] font-black text-[#D4AF37] hover:text-white uppercase tracking-widest print:hidden">Ver Tablero</button>}
              </div>
              <div className="p-5 flex-1">
                {tareasPendientes.length === 0 ? (
                  <div className="h-full flex flex-col items-center justify-center text-slate-500 py-6">
                    <CheckCircle size={40} className="mb-3 text-[#D4AF37]/30"/>
                    <p className="text-xs font-bold uppercase tracking-widest">Sin tareas urgentes.</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {tareasPendientes.map(tarea => {
                      const vencida = isOverdue(tarea.fechaLimite);
                      return (
                        <div key={tarea.id} className="flex items-start gap-3 p-3 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                          <div className={`mt-1 w-2 h-2 rounded-full shadow-[0_0_8px_currentColor] shrink-0 ${vencida ? 'bg-rose-500 text-rose-500 animate-pulse' : 'bg-[#D4AF37] text-[#D4AF37]'}`}></div>
                          <div className="flex-1 min-w-0">
                            <p className={`text-sm font-bold truncate ${vencida ? 'text-rose-400' : 'text-slate-200'}`}>{tarea.titulo}</p>
                            <div className="flex items-center gap-2 mt-1.5">
                              <span className="text-[8px] font-black uppercase tracking-widest text-[#D4AF37] bg-[#D4AF37]/10 px-2 py-0.5 rounded border border-[#D4AF37]/20">{tarea.categoria}</span>
                              {tarea.fechaLimite && <span className={`text-[9px] font-bold tracking-widest ${vencida ? 'text-rose-500' : 'text-slate-400'}`}><Calendar size={10} className="inline mr-0.5"/> {tarea.fechaLimite}</span>}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>

            <div className="bg-[#1C1917] rounded-3xl border border-[#D4AF37]/30 shadow-xl flex flex-col overflow-hidden">
              <div className="p-5 border-b border-[#D4AF37]/15 bg-[#141210] flex justify-between items-center">
                <h3 className="font-bold text-white flex items-center text-sm"><AlertTriangle size={16} className="mr-2 text-[#D4AF37]"/> Alertas Financieras</h3>
                {setActiveTab && <button onClick={() => setActiveTab('presupuesto')} className="text-[10px] font-black text-[#D4AF37] hover:text-white uppercase tracking-widest print:hidden">Abrir Bóveda</button>}
              </div>
              <div className="p-5 flex-1">
                {pagosPendientes.length === 0 ? (
                  <div className="h-full flex flex-col items-center justify-center text-slate-500 py-6">
                    <CheckCircle size={40} className="mb-3 text-[#D4AF37]/30"/>
                    <p className="text-xs font-bold uppercase tracking-widest">Finanzas Sanas.</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {pagosPendientes.map(pago => {
                      const deuda = pago.estimado - pago.pagado;
                      const vencido = isOverdue(pago.fechaLimite);
                      return (
                        <div key={pago.id} className="flex justify-between items-center bg-white/5 p-3 rounded-xl border border-white/10 hover:bg-white/10 transition-colors">
                          <div className="min-w-0 flex-1 mr-3">
                            <p className="text-sm font-bold text-slate-200 truncate">{pago.concepto}</p>
                            <p className={`text-[9px] font-bold mt-1 uppercase tracking-widest flex items-center ${vencido ? 'text-rose-500' : 'text-slate-400'}`}>
                              <Clock size={10} className="mr-1"/> {pago.fechaLimite ? `Límite: ${pago.fechaLimite}` : 'Sin plazo'}
                            </p>
                          </div>
                          <div className="text-right flex-shrink-0">
                            <p className="text-[9px] text-[#D4AF37] font-black uppercase tracking-widest mb-0.5">Pendiente</p>
                            <p className={`text-base font-black ${vencido ? 'text-rose-500' : 'text-white'}`}>{formatMoney(deuda)}</p>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {/* ÁREA INVISIBLE PARA EL RENDER DEL REPORTE EJECUTIVO (Oculto en Social Wall) */}
      {plan !== 'social_wall' && (
        <div style={{ position: 'absolute', top: '-10000px', left: '-10000px', zIndex: -9999 }}>
          <div id="hidden-executive-report" className="bg-white relative shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '20mm', boxSizing: 'border-box', overflow: 'hidden', background: gradientStyle }}>
             
             <div className="absolute top-0 left-0 w-full h-3" style={{ backgroundColor: accentColor }}></div>

             <div className="flex justify-between items-center mb-12 mt-4">
                <div>
                  <h1 className="text-5xl font-editorial font-bold text-slate-900 leading-none">Reporte Ejecutivo</h1>
                  <p className="text-base font-black tracking-[0.2em] uppercase mt-3" style={{ color: accentColor }}>{eventName}</p>
                </div>
                <div className="text-right flex flex-col items-end">
                  <BauliaLogo className="h-10" forceWhite={false} />
                  <p className="text-[8px] text-slate-400 mt-2 uppercase tracking-[0.3em] font-bold">Tecnología Inteligente</p>
                </div>
             </div>

             <div className="grid grid-cols-2 gap-10 mb-10">
               <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                  <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1">Logística de Asistentes</p>
                  <p className="text-5xl font-editorial text-slate-900 mb-2">{totalPasses}</p>
                  <p className="text-xs font-bold" style={{ color: accentColor }}>{confirmationPercentage}% Confirmación oficial</p>
                  <div className="w-full bg-slate-200 h-0.5 mt-3"><div className="h-0.5" style={{ width: `${confirmationPercentage}%`, backgroundColor: accentColor }}></div></div>
               </div>
               <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                  <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1">Acomodo y Mesas</p>
                  <p className="text-5xl font-editorial text-slate-900 mb-2">{totalMesas} <span className="text-lg text-slate-400 font-sans font-light">mesas</span></p>
                  <p className="text-xs font-bold" style={{ color: accentColor }}>{capacidadTotalSillas} Sillas totales • {ocupacionPorcentaje}% Ocupación</p>
                  <div className="w-full bg-slate-200 h-0.5 mt-3"><div className="h-0.5" style={{ width: `${ocupacionPorcentaje}%`, backgroundColor: accentColor }}></div></div>
               </div>
             </div>

             <div className="grid grid-cols-2 gap-10 mb-12">
               <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                  <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1">Estado de la Bóveda</p>
                  <p className="text-5xl font-editorial text-slate-900 mb-2">${(totalEstimado / 1000).toFixed(1)}k</p>
                  <p className="text-xs font-bold flex justify-between" style={{ color: accentColor }}>
                    <span>Abonado: ${(totalPagado/1000).toFixed(1)}k</span>
                  </p>
                  <div className="w-full bg-slate-200 h-0.5 mt-3"><div className="h-0.5" style={{ width: `${Math.min(budgetPercentage, 100)}%`, backgroundColor: accentColor }}></div></div>
               </div>
               <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                  <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1">Avance de Planeación</p>
                  <p className="text-5xl font-editorial text-slate-900 mb-2">{tareasPorcentaje}%</p>
                  <p className="text-xs font-bold" style={{ color: accentColor }}>{tareasCompletadas} de {tareasTotal} objetivos listos</p>
                  <div className="w-full bg-slate-200 h-0.5 mt-3"><div className="h-0.5" style={{ width: `${tareasPorcentaje}%`, backgroundColor: accentColor }}></div></div>
               </div>
             </div>

             <div className="grid grid-cols-2 gap-10">
               <div>
                  <h3 className="text-[10px] font-bold uppercase tracking-widest text-slate-800 mb-4 border-b border-slate-200 pb-2">Logística Inmediata</h3>
                  {tareasPendientes.length === 0 ? <p className="text-xs text-slate-400 italic">El cronograma está limpio.</p> : (
                    <ul className="space-y-3">
                      {tareasPendientes.map(t => (
                        <li key={t.id} className="text-xs text-slate-600 flex justify-between items-center border-b border-slate-100 pb-1.5 last:border-0">
                          <span className="font-medium pr-2 truncate">{t.titulo}</span>
                          <span className="text-slate-400 shrink-0 font-mono text-[10px]">{t.fechaLimite || '-'}</span>
                        </li>
                      ))}
                    </ul>
                  )}
               </div>
               <div>
                  <h3 className="text-[10px] font-bold uppercase tracking-widest text-slate-800 mb-4 border-b border-slate-200 pb-2">Deudas Próximas</h3>
                  {pagosPendientes.length === 0 ? <p className="text-xs text-slate-400 italic">Finanzas sanas.</p> : (
                    <ul className="space-y-3">
                      {pagosPendientes.map(p => (
                        <li key={p.id} className="text-xs text-slate-600 flex justify-between items-center border-b border-slate-100 pb-1.5 last:border-0">
                          <span className="font-medium pr-2 truncate">{p.concepto}</span>
                          <span className="font-black text-slate-900 shrink-0">{formatMoney(p.estimado - p.pagado)}</span>
                        </li>
                      ))}
                    </ul>
                  )}
               </div>
             </div>

             <div className="absolute bottom-[15mm] left-[20mm] right-[20mm] flex justify-between items-center text-[7px] uppercase tracking-widest text-slate-400 border-t border-slate-200 pt-3">
                <span>Fecha de Emisión: {new Date().toLocaleDateString('es-MX')}</span>
                <span>Confidencial • {eventName}</span>
             </div>
          </div>
        </div>
      )}

      {/* MODAL DE CAMBIO DE CONTRASEÑA */}
      {passModal.open && (
        <div className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 flex justify-between items-center bg-[#141210]">
              <h3 className="font-editorial font-black text-xl text-[#D4AF37] flex items-center tracking-wide"><Key size={20} className="mr-2.5"/> Seguridad</h3>
              <button onClick={() => setPassModal({ open: false, newPass: '', loading: false, msg: '', type: '' })} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            </div>
            <form onSubmit={handleChangePassword} className="p-6 space-y-5">
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Nueva Contraseña</label>
                <input 
                  type="password" 
                  required 
                  value={passModal.newPass} 
                  onChange={e => setPassModal({...passModal, newPass: e.target.value})} 
                  className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors"
                  placeholder="Mínimo 6 caracteres..."
                />
              </div>
              
              {passModal.msg && (
                <div className={`p-4 rounded-xl text-xs font-bold border ${passModal.type === 'error' ? 'bg-rose-500/10 text-rose-400 border-rose-500/20' : 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/30'}`}>
                  {passModal.msg}
                </div>
              )}

              <button type="submit" disabled={passModal.loading} className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-2 shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors disabled:opacity-50">
                {passModal.loading ? 'Actualizando...' : 'Guardar Contraseña'}
              </button>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

// ==========================================
// --- COMPONENTE: RECEPCIÓN Y ESCÁNER (CÁMARA CUADRADA 100%) ---
// ==========================================
const EscanerView = ({ guests, setGuests, tables, isSharedMode, exitSharedMode, simulateSharedMode, addNotification }) => {
  const [forceMobile, setForceMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  
  const [isListOpen, setIsListOpen] = useState(false);
  const [listSearchTerm, setListSearchTerm] = useState('');
  const [listTab, setListTab] = useState('todos'); 
  
  const [showShareModal, setShowShareModal] = useState(false);
  const [staffPhone, setStaffPhone] = useState('');
  const [camError, setCamError] = useState(null);
  // 🔴 ESTADO DEL SEMÁFORO DE CONEXIÓN
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const [showProtocol, setShowProtocol] = useState(isSharedMode);

  const [cardData, setCardData] = useState({ 
    status: 'idle', 
    title: 'Esperando código...', 
    subtitle: 'Apunta la cámara a la pulsera del invitado.' 
  });

  const scannerRef = useRef(null);
  const lastScannedCode = useRef(null);
  
  const guestsRef = useRef(guests || []);
  useEffect(() => { guestsRef.current = guests || []; }, [guests]);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const showDesktopPlaceholder = isDesktop && !forceMobile && !isSharedMode;

  useEffect(() => {
    if (showDesktopPlaceholder) return;

    let html5QrCode;
    const initScanner = () => {
      if (!window.Html5Qrcode) {
        setTimeout(initScanner, 500); 
        return;
      }
      try {
        html5QrCode = new window.Html5Qrcode("qr-reader-puerta");
        scannerRef.current = html5QrCode;
        
        html5QrCode.start(
          { facingMode: "environment" }, 
          { 
             fps: 15, 
             aspectRatio: 1.0, // 🔴 FUERZA LA PROPORCIÓN CUADRADA
             qrbox: function(width, height) {
                // 🔴 HACE QUE EL ÁREA DE ESCANEO SEA EL 95% DE LA PANTALLA, IMPOSIBLE FALLAR
                return { width: width * 0.95, height: height * 0.95 };
             }
          },
          (decodedText) => {
             let code = decodedText;
             try {
                const parsedUrl = new URL(decodedText);
                code = parsedUrl.searchParams.get('u') || parsedUrl.searchParams.get('usr') || parsedUrl.searchParams.get('uid') || parsedUrl.searchParams.get('invitado') || code;
             } catch(e) {}
             
             if (lastScannedCode.current === code) return;
             lastScannedCode.current = code;
             setTimeout(() => { lastScannedCode.current = null; }, 3000);

             if (code && code !== 'null') processEntry(code);
          },
          (errorMessage) => {}
        ).catch(err => {
           setCamError("Permite el uso de la cámara en tu navegador para continuar.");
        });
      } catch(e) { console.error(e); }
    };

    initScanner();

    return () => {
      if (scannerRef.current && scannerRef.current.isScanning) {
        scannerRef.current.stop().catch(e=>e);
      }
    };
  }, [showDesktopPlaceholder]);

  const processEntry = async (code) => {
    try {
      // 🔴 1. PREGUNTAMOS A LA BASE DE DATOS EL PLAN Y LA HORA EXACTA
      const eventSnap = await getDoc(doc(db, "eventos", ID_DEL_EVENTO));
      if (eventSnap.exists()) {
        const evData = eventSnap.data();

        // 🔴 2. VALIDACIÓN DE TIEMPO (Solo para Kit de Seguridad)
        if (evData.plan === 'security_kit' && evData.horaEvento && evData.fecha) {
          // Blindaje: Detectamos si la fecha es de Firebase o es un texto (String)
          const eventDate = evData.fecha.toDate ? evData.fecha.toDate() : new Date(evData.fecha + 'T00:00:00');
          
          // Ajustamos la hora de inicio
          const [hrs, mins] = evData.horaEvento.split(':');
          eventDate.setHours(hrs, mins);

          const now = new Date();
          const diffHours = (now - eventDate) / (1000 * 60 * 60);

          // Si pasaron más de 24 horas desde el inicio del evento, bloqueamos
          if (diffHours > 24) {
            setCardData({ status: 'error', title: 'Licencia Expirada', subtitle: 'El acceso de 24 horas ha terminado.' });
            return; // Cortamos la función aquí, no escanea nada
          }
        }
      }

      // 🔴 3. CONTINÚA EL ESCANEO NORMAL
      const codeLower = code.trim().toLowerCase();
      let foundParentId = null;
      let targetSubId = null;

      if (codeLower.startsWith('usr_')) {
         const parts = codeLower.split('_');
         if (parts.length >= 3) foundParentId = parts[1];
         targetSubId = codeLower;
      } else {
         foundParentId = codeLower;
      }

      if (!foundParentId) {
        setCardData({ status: 'error', title: 'Código Inválido', subtitle: 'Este pase no pertenece al evento.' });
        return;
      }

      const docRef = doc(db, "eventos", ID_DEL_EVENTO, "invitados", foundParentId);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
         setCardData({ status: 'error', title: 'No Encontrado', subtitle: 'La familia no está en la base de datos.' });
         return;
      }
      
      const freshParent = { id: docSnap.id, ...docSnap.data() };

      if (freshParent.status === 'cancelado') {
         setCardData({ status: 'error', title: 'Acceso Denegado', subtitle: `La invitación de ${freshParent.name} fue cancelada.` });
         return;
      }

      let targetSub = targetSubId ? (freshParent.subGuests || []).find(sg => sg.id === targetSubId) : null;
      if (!targetSub) {
         targetSub = (freshParent.subGuests || []).find(sg => !sg.entered);
         if (!targetSub) { 
           setCardData({ status: 'warning', title: 'Pases Agotados', subtitle: `Toda la familia ${freshParent.name} ya ingresó.` });
           return; 
         }
      }

      const tableName = tables.find(t => String(t.id) === String(freshParent.tableId))?.name || 'Sin Mesa Asignada';

      if (targetSub.entered) { 
        setCardData({ status: 'warning', title: targetSub.name, subtitle: `Mesa: ${tableName}` });
        return; 
      }

      const newSubs = (freshParent.subGuests || []).map(sg => sg.id === targetSub.id ? { ...sg, entered: true } : sg);
      const enteredCount = newSubs.filter(sg => sg.entered).length;
      
      let newStatus = freshParent.status;
      if (enteredCount > 0 && newStatus !== 'ingreso') newStatus = 'ingreso';

      setCardData({ status: 'success', title: targetSub.name, subtitle: `Mesa: ${tableName}` });
      await setDoc(docRef, { ...freshParent, subGuests: newSubs, entered: enteredCount, status: newStatus });
      
    } catch(e) {
      setCardData({ status: 'error', title: 'Error de Red', subtitle: 'Revisa tu conexión a internet.' });
    }
  };

  const handleManualEntryFromList = async (parentGuest, subGuest) => {
    if (subGuest.entered) return;
    try {
      const docRef = doc(db, "eventos", ID_DEL_EVENTO, "invitados", parentGuest.id);
      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) return;
      const freshParent = { id: docSnap.id, ...docSnap.data() };
      
      const newSubs = (freshParent.subGuests || []).map(sg => sg.id === subGuest.id ? { ...sg, entered: true } : sg);
      const newEntered = newSubs.filter(sg => sg.entered).length;
      let newStatus = freshParent.status;
      if (newEntered > 0 && newStatus !== 'ingreso') newStatus = 'ingreso';
      await setDoc(docRef, { ...freshParent, subGuests: newSubs, entered: newEntered, status: newStatus });
    } catch(e){}
  };

  // 🔴 CORRECCIÓN: URL DEL PANEL BAULIA
  const getCleanBaseUrl = () => window.location.hostname.includes('localhost') ? window.location.origin : 'https://panel.baulia.com';

  const copyStaffLink = () => {
    const url = `${getCleanBaseUrl()}/?modo=puerta&e=${ID_DEL_EVENTO}`;
    navigator.clipboard.writeText(url).then(() => {
      if (addNotification) addNotification('¡Copiado!', 'Enlace de Recepción copiado.', 'success');
    }).catch(() => {
      const textArea = document.createElement("textarea");
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      try { 
         document.execCommand('copy'); 
         if (addNotification) addNotification('¡Copiado!', 'Enlace de Recepción copiado.', 'success');
      } catch (err) {}
      document.body.removeChild(textArea);
    });
  };

  const shareStaffLinkWhatsApp = () => {
    const url = `${getCleanBaseUrl()}/?modo=puerta&e=${ID_DEL_EVENTO}`;
    const msg = `📱 *Recepción EventMaster*\n\nAccede al escáner de puerta aquí:\n${url}`;
    window.open(`https://wa.me/${staffPhone.replace(/\D/g,'')}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const flattenedGuests = [];
  (guests || []).forEach(g => {
    if (g.status === 'cancelado') return;
    if (g.subGuests && g.subGuests.length > 0) {
        g.subGuests.forEach(sg => flattenedGuests.push({ parent: g, sub: sg, searchStr: `${sg.name || ''} ${g.name || ''}`.toLowerCase(), entered: sg.entered }));
    }
  });
  
  const filteredList = flattenedGuests.filter(item => {
    const matchesSearch = (item.searchStr || '').includes((listSearchTerm || '').toLowerCase());
    if (listTab === 'adentro') return matchesSearch && item.entered;
    if (listTab === 'faltan') return matchesSearch && !item.entered;
    return matchesSearch;
  });

  if (showDesktopPlaceholder) {
     return (
        <div className="h-full flex flex-col items-center justify-center p-6 animate-in fade-in">
           <div className="bg-[#1C1917] p-8 sm:p-10 rounded-[2.5rem] shadow-[0_25px_70px_rgba(0,0,0,0.9)] max-w-lg w-full text-center border border-[#D4AF37]/30 relative overflow-hidden text-white">
              <div className="absolute top-0 left-0 w-full h-3 bg-[#D4AF37]"></div>
              <div className="w-24 h-24 bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
                 <Smartphone size={48} />
              </div>
              <h2 className="text-3xl font-editorial font-black text-white mb-3 tracking-tight">Escáner Móvil</h2>
              <p className="text-slate-400 mb-8 text-sm leading-relaxed">
                 Esta herramienta está diseñada para usarse en la puerta del evento usando la cámara de un celular o tablet.
              </p>
              
              <div className="bg-[#141210] p-6 rounded-2xl border border-white/10 text-left mb-6 shadow-inner">
                 <label className="block text-xs font-black text-slate-400 uppercase tracking-widest mb-4 flex items-center"><ShieldCheck size={16} className="mr-2 text-[#D4AF37]"/> Enviar acceso al Staff</label>
                 <div className="flex gap-3 mb-4">
                    <input type="tel" placeholder="WhatsApp (10 dígitos)..." value={staffPhone} onChange={e=>setStaffPhone(e.target.value)} className="w-full p-3 border border-white/10 rounded-xl font-bold outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors" />
                    <button onClick={shareStaffLinkWhatsApp} className="px-5 bg-[#D4AF37] text-[#1C1917] rounded-xl hover:bg-[#c5a028] shadow-[0_5px_15px_rgba(212,175,55,0.25)] transition-colors active:scale-95"><Send size={18}/></button>
                 </div>
                 <button onClick={copyStaffLink} className="w-full py-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold hover:bg-white/10 transition-colors flex items-center justify-center shadow-sm active:scale-95 uppercase tracking-widest text-[10px]">
                    <Link size={16} className="mr-2"/> Copiar enlace manual
                 </button>
              </div>
              
              <button onClick={() => setForceMobile(true)} className="text-[10px] font-bold text-slate-500 hover:text-[#D4AF37] underline transition-colors">Forzar vista de escáner aquí en la computadora</button>
           </div>
        </div>
     );
  }

  return (
    <div className={`h-full flex flex-col space-y-4 pb-6 ${isSharedMode ? 'max-w-lg mx-auto' : 'max-w-4xl'}`}>
      
      {/* 🔴 SEMÁFORO DE CONEXIÓN INTELIGENTE */}
      <div className={`p-3 rounded-2xl shadow-lg flex items-center justify-between transition-colors duration-500 animate-in slide-in-from-top-4 mb-3 border ${isOffline ? 'bg-amber-500 border-amber-600' : 'bg-[#1C1917] border-[#D4AF37]/30'}`}>
        <div className="flex items-center">
          {isOffline ? (
            <WifiOff size={18} className="mr-2.5 text-[#141210] animate-pulse" />
          ) : (
            <div className="relative mr-2.5 flex items-center justify-center w-5 h-5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-30 animate-ping"></span>
              <div className="relative w-2.5 h-2.5 bg-emerald-500 rounded-full shadow-[0_0_8px_#10b981]"></div>
            </div>
          )}
          <span className={`font-bold text-xs uppercase tracking-widest ${isOffline ? 'text-[#141210]' : 'text-[#D4AF37]'}`}>
            {isOffline ? 'Modo Supervivencia' : 'En Línea'}
          </span>
        </div>
        <span className={`text-[9px] font-medium ${isOffline ? 'text-[#141210]/80' : 'text-slate-400'}`}>
          {isOffline ? 'Guardando localmente' : 'Sincronizado'}
        </span>
      </div>

      <div className="flex justify-between items-center gap-4 px-2 mb-2">
        <div>
          <h2 className="text-3xl font-editorial font-black text-white tracking-wide">{isSharedMode ? 'Recepción VIP' : 'Control de Accesos'}</h2>
          <p className="text-[#D4AF37] text-[10px] font-bold uppercase tracking-widest mt-1">Escaneo continuo automático.</p>
        </div>
        {!isSharedMode && (
          <button onClick={() => setShowShareModal(true)} className="p-3 bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 rounded-full hover:bg-[#D4AF37]/20 transition-colors shadow-sm" title="Compartir a Staff">
            <Link size={20} /> 
          </button>
        )}
      </div>

      <div className="flex flex-col gap-4 flex-1">
        
        {/* 🔴 INYECCIÓN CSS PARA FORZAR EL VIDEO CUADRADO AL 100% */}
        <style>{`
          #qr-reader-puerta { width: 100% !important; height: 100% !important; border: none !important; position: absolute !important; inset: 0 !important; }
          #qr-reader-puerta video { object-fit: cover !important; width: 100% !important; height: 100% !important; border-radius: 1.5rem !important; }
          #qr-reader-puerta canvas { display: none !important; }
        `}</style>

        {/* 🔴 ESCÁNER CUADRADO PERFECTO */}
        <div className="w-full max-w-[350px] mx-auto bg-[#141210] rounded-3xl overflow-hidden relative shadow-[0_15px_40px_rgba(0,0,0,0.6)] border border-[#D4AF37]/30 flex-shrink-0 aspect-square">
          {camError ? (
            <button onClick={() => window.location.reload()} className="absolute inset-0 flex flex-col items-center justify-center text-white bg-[#1C1917] p-6 text-center z-50">
              <Camera size={48} className="text-rose-500 mb-4"/>
              <span className="font-bold text-lg mb-2">Permiso de cámara requerido</span>
              <span className="text-sm text-slate-400">{camError}</span>
            </button>
          ) : (
            <>
               <div id="qr-reader-puerta"></div>
               {/* Marcos y Laser */}
               <div className="absolute inset-0 border-[30px] border-[#1C1917]/70 pointer-events-none z-10"></div>
               <div className="absolute inset-0 border-2 border-emerald-400 m-[30px] pointer-events-none z-10 opacity-70 rounded-xl">
                 <div className="w-full h-0.5 bg-emerald-400 shadow-[0_0_15px_#34d399] absolute top-1/2 -translate-y-1/2 opacity-60 animate-pulse"></div>
               </div>
            </>
          )}
        </div>

        {/* 🔴 FICHA INTELIGENTE */}
        <div className={`w-full p-6 rounded-3xl shadow-xl border-2 transition-all flex flex-col justify-center min-h-[140px] flex-shrink-0 relative overflow-hidden
            ${cardData.status === 'idle' ? 'bg-[#1C1917] border-[#D4AF37]/30' : ''}
            ${cardData.status === 'success' ? 'bg-emerald-50 border-emerald-400 shadow-[0_0_20px_rgba(16,185,129,0.3)] scale-[1.02]' : ''}
            ${cardData.status === 'warning' ? 'bg-amber-50 border-amber-400 shadow-[0_0_20px_rgba(245,158,11,0.3)] scale-[1.02]' : ''}
            ${cardData.status === 'error' ? 'bg-rose-50 border-rose-400 shadow-[0_0_20px_rgba(244,63,94,0.3)]' : ''}
        `}>
           <div className="relative z-10 text-center">
              <p className={`text-[10px] font-black uppercase tracking-widest mb-2
                ${cardData.status === 'idle' ? 'text-[#D4AF37]' : ''}
                ${cardData.status === 'success' ? 'text-emerald-600' : ''}
                ${cardData.status === 'warning' ? 'text-amber-600' : ''}
                ${cardData.status === 'error' ? 'text-rose-600' : ''}
              `}>
                 {cardData.status === 'idle' ? 'ESTADO: LISTO' : cardData.status === 'success' ? 'ACCESO APROBADO' : cardData.status === 'warning' ? '¡YA INGRESÓ!' : 'ERROR'}
              </p>
              <h3 className={`text-2xl sm:text-3xl font-black leading-tight mb-2 ${cardData.status === 'idle' ? 'text-white font-editorial' : 'text-slate-900'}`}>
                {cardData.title}
              </h3>
              <p className={`text-sm sm:text-lg font-bold ${cardData.status === 'idle' ? 'text-slate-400' : cardData.status === 'success' ? 'text-emerald-700' : cardData.status === 'warning' ? 'text-amber-700' : 'text-slate-500'}`}>
                {cardData.subtitle}
              </p>
           </div>
           
           {/* Iconos de fondo */}
           {cardData.status === 'success' && <CheckCircle size={100} className="absolute -right-4 -bottom-4 text-emerald-500/10 pointer-events-none"/>}
           {cardData.status === 'warning' && <AlertTriangle size={100} className="absolute -right-4 -bottom-4 text-amber-500/10 pointer-events-none"/>}
           {cardData.status === 'error' && <X size={100} className="absolute -right-4 -bottom-4 text-rose-500/10 pointer-events-none"/>}
        </div>

        <button onClick={() => setIsListOpen(true)} className="w-full py-5 bg-[#D4AF37] text-[#141210] rounded-2xl font-black shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors flex items-center justify-center text-sm uppercase tracking-widest flex-shrink-0 mt-2">
          <Users size={20} className="mr-3 text-[#141210]" /> Abrir Directorio Manual
        </button>
      </div>

      {/* MODAL DIRECTORIO MANUAL */}
      {isListOpen && (
         <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex flex-col justify-end sm:justify-center sm:p-6 animate-in fade-in duration-200">
             <div className="bg-[#1C1917] w-full sm:max-w-2xl mx-auto sm:rounded-3xl rounded-t-3xl shadow-[0_25px_70px_rgba(0,0,0,0.9)] flex flex-col h-[90vh] sm:h-[80vh] overflow-hidden border border-[#D4AF37]/30">
                <div className="p-5 border-b border-[#D4AF37]/20 bg-[#141210] flex items-center justify-between shrink-0">
                   <div>
                     <h3 className="text-xl font-editorial font-black text-[#D4AF37] flex items-center tracking-wide"><Users size={20} className="mr-2.5" /> Ingreso Manual</h3>
                     <p className="text-[10px] text-slate-400 uppercase tracking-widest mt-1">Busca por nombre si no traen pulsera.</p>
                   </div>
                   <button onClick={() => setIsListOpen(false)} className="p-2 bg-white/5 rounded-full hover:bg-white/10 text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
                </div>
                
                <div className="bg-[#1C1917] border-b border-white/10 shadow-sm z-10 shrink-0">
                   <div className="flex p-3 gap-2 bg-[#141210]">
                      <button onClick={()=>setListTab('todos')} className={`flex-1 py-2.5 rounded-lg text-xs font-bold uppercase tracking-widest transition-all border ${listTab==='todos' ? 'bg-[#D4AF37] text-[#141210] border-[#D4AF37] shadow-sm' : 'bg-transparent text-slate-400 border-white/10 hover:border-white/30'}`}>Todos</button>
                      <button onClick={()=>setListTab('adentro')} className={`flex-1 py-2.5 rounded-lg text-xs font-bold uppercase tracking-widest transition-all border ${listTab==='adentro' ? 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' : 'bg-transparent text-slate-400 border-white/10 hover:border-white/30'}`}>Adentro</button>
                      <button onClick={()=>setListTab('faltan')} className={`flex-1 py-2.5 rounded-lg text-xs font-bold uppercase tracking-widest transition-all border ${listTab==='faltan' ? 'bg-rose-500/20 text-rose-400 border-rose-500/30' : 'bg-transparent text-slate-400 border-white/10 hover:border-white/30'}`}>Faltan</button>
                   </div>
                   <div className="relative p-4">
                     <SearchIcon className="absolute left-7 top-1/2 -translate-y-1/2 text-slate-500" size={18}/>
                     <input type="text" autoFocus placeholder="Buscar por nombre o familia..." value={listSearchTerm} onChange={(e) => setListSearchTerm(e.target.value)} className="w-full pl-12 pr-4 py-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none transition-colors font-bold text-white placeholder-slate-500" />
                   </div>
                </div>
                
                <div className="overflow-y-auto flex-1 p-4 bg-[#1C1917] custom-scrollbar space-y-3">
                   {filteredList.map(item => {
                      const { parent, sub } = item;
                      const mesaName = tables.find(t => String(t.id) === String(parent.tableId))?.name || 'Sin Mesa Asignada';
                      
                      return (
                        <div key={sub.id} className={`flex flex-col sm:flex-row justify-between items-start sm:items-center p-4 border rounded-2xl transition-all shadow-sm ${sub.entered ? 'border-emerald-500/30 bg-emerald-500/10' : 'bg-[#141210] border-white/10 hover:border-[#D4AF37]/40'}`}>
                           <div className="mb-3 sm:mb-0 w-full sm:w-auto">
                              <p className={`font-bold text-lg leading-tight ${sub.entered ? 'text-emerald-400' : 'text-white'}`}>{sub.name}</p>
                              <div className="flex flex-wrap items-center gap-2 mt-2">
                                 <span className="text-[9px] font-black uppercase text-slate-400 bg-white/5 px-2 py-1 rounded border border-white/10">{parent.name}</span>
                                 <span className="text-[9px] font-black uppercase text-[#D4AF37] bg-[#D4AF37]/10 border border-[#D4AF37]/20 px-2 py-1 rounded">Mesa: {mesaName}</span>
                              </div>
                           </div>
                           
                           <div className="w-full sm:w-auto text-right">
                             {sub.entered ? (
                                <div className="px-5 py-3 rounded-xl text-sm font-black bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 flex items-center justify-center sm:justify-start"><CheckCircle size={18} className="mr-2"/> Ya Ingresó</div>
                             ) : (
                                <button onClick={() => handleManualEntryFromList(parent, sub)} className="w-full sm:w-auto px-6 py-3.5 rounded-xl text-[10px] uppercase tracking-widest font-black bg-[#D4AF37] border border-[#D4AF37] text-[#1C1917] hover:bg-[#c5a028] shadow-[0_5px_15px_rgba(212,175,55,0.25)] transition-all active:scale-95 flex items-center justify-center">
                                  Dar Acceso <ArrowRight size={14} className="ml-2" />
                                </button>
                             )}
                           </div>
                        </div>
                      )
                   })}
                   {filteredList.length === 0 && <div className="text-center p-12 text-slate-500 font-bold text-sm border-2 border-dashed border-white/10 rounded-2xl bg-[#141210]">No se encontraron invitados.</div>}
                </div>
             </div>
         </div>
      )}

      {showShareModal && (
        <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden p-6 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 text-white">
            <button onClick={() => setShowShareModal(false)} className="absolute top-4 right-4 text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            <div className="w-16 h-16 bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 rounded-full flex items-center justify-center mx-auto mb-4"><ShieldCheck size={32}/></div>
            <h3 className="font-editorial font-black text-2xl text-white mb-2">Acceso de Staff</h3>
            <p className="text-[10px] text-slate-400 mb-6 uppercase tracking-widest">Envía este link al personal en puerta.</p>
            <div className="flex gap-2 mb-4">
              <input type="tel" placeholder="Número WhatsApp..." value={staffPhone} onChange={e=>setStaffPhone(e.target.value)} className="w-full p-3 bg-[#141210] border border-white/10 rounded-xl text-white font-bold outline-none focus:border-[#D4AF37]" />
              <button onClick={shareStaffLinkWhatsApp} className="px-5 bg-[#D4AF37] text-[#1C1917] rounded-xl hover:bg-[#c5a028] shadow-[0_5px_15px_rgba(212,175,55,0.2)]"><Send size={18}/></button>
            </div>
            <button onClick={() => { setShowShareModal(false); setForceMobile(true); }} className="w-full py-3 bg-white/5 border border-white/10 text-slate-300 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-white/10 transition-colors mb-2">Simular en esta pantalla</button>
          </div>
        </div>
      )}
      {/* 🔴 MODAL DE PROTOCOLO OFFLINE PARA EL STAFF */}
      {showProtocol && (
        <div className="fixed inset-0 z-[9999] bg-black/95 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in zoom-in duration-300">
          <div className="bg-[#1C1917] rounded-[2rem] w-full max-w-sm overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 flex flex-col relative text-white">
            <div className="bg-[#D4AF37] p-8 text-center text-[#1C1917] relative overflow-hidden">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20"></div>
              <ShieldCheck size={48} className="mx-auto mb-3 opacity-90 relative z-10"/>
              <h3 className="text-xl font-black uppercase tracking-widest relative z-10">Protocolo de Puerta</h3>
            </div>
            <div className="p-6 sm:p-8 space-y-5 text-slate-300 text-sm font-medium leading-relaxed">
              <p>Para garantizar que el escáner funcione a la perfección, <b className="text-white">incluso si se cae el internet</b>, sigue estas reglas de oro:</p>
              
              <div className="bg-[#141210] border border-white/10 p-4 rounded-xl space-y-4 shadow-inner">
                <div className="flex items-start">
                  <span className="bg-[#D4AF37]/20 text-[#D4AF37] border border-[#D4AF37]/30 w-6 h-6 rounded-full flex items-center justify-center font-black text-xs shrink-0 mr-3 mt-0.5">1</span> 
                  <p><b>No cierres esta pestaña.</b> Puedes bloquear la pantalla de tu celular y guardarlo, pero no cierres el navegador.</p>
                </div>
                <div className="flex items-start">
                  <span className="bg-[#D4AF37]/20 text-[#D4AF37] border border-[#D4AF37]/30 w-6 h-6 rounded-full flex items-center justify-center font-black text-xs shrink-0 mr-3 mt-0.5">2</span> 
                  <p><b>Evita abrir otras Apps.</b> Usar la cámara normal de tu celular consume memoria y podría reiniciar este escáner.</p>
                </div>
              </div>
            </div>
            <div className="p-6 pt-0 mt-2">
              <button onClick={() => setShowProtocol(false)} className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black uppercase tracking-widest text-[10px] hover:scale-[1.02] transition-transform shadow-[0_10px_25px_rgba(212,175,55,0.25)]">
                Entendido, Iniciar Escáner
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: INVITADOS (DARK PREMIUM - MULTIMODAL + MOTOR DE AFINIDAD) ---
// ==========================================
const InvitadosView = ({ tables, guests, setGuests, addNotification, tipoEvento, userPlan, eventName, urlInvitacion }) => {
  const isBodaType = tipoEvento === 'boda';
  const isPremium = userPlan === 'oro' || userPlan === 'diamante';
  const [isWeddingMode, setIsWeddingMode] = useState(isBodaType);
  const [expandedMobileRow, setExpandedMobileRow] = useState(null);
  const toggleMobileRow = (id) => setExpandedMobileRow(prev => prev === id ? null : id);

  const [qrEnabled, setQrEnabled] = useState(true);
  const [passCountEnabled, setPassCountEnabled] = useState(true);
  
  // 🟢 BANCO GLOBAL DE ETIQUETAS (AFINIDAD)
  const [globalTags, setGlobalTags] = useState([]);
  const [newTagInput, setNewTagInput] = useState('');
  const [isTagManagerOpen, setIsTagManagerOpen] = useState(false);

  // 🟢 ESTADOS PARA LA PORTADA, LOGO Y SUBIDAS CLOUDINARY
  const [qrCover, setQrCover] = useState(null);
  const [eventLogo, setEventLogo] = useState(null); 
  const [hasManualLogo, setHasManualLogo] = useState(false);
  const [isUploadingCover, setIsUploadingCover] = useState(false);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false);
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    setIsWeddingMode(tipoEvento === 'boda');
  }, [tipoEvento]);

  // 🟢 EFECTO INTELIGENTE: ESCUCHA LA BÓVEDA EN TIEMPO REAL
  useEffect(() => {
    if (typeof ID_DEL_EVENTO === 'undefined') return;
    const unsub = onSnapshot(doc(db, "eventos", ID_DEL_EVENTO), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setQrEnabled(data.isQrEnabled !== false); 
        setPassCountEnabled(data.isPassCountEnabled !== false);
        if (data.tipoEvento) setIsWeddingMode(data.tipoEvento === 'boda');
        if (data.etiquetasGlobales) setGlobalTags(data.etiquetasGlobales);
        else setGlobalTags([]);
        
        if (data.qrCoverUrl) setQrCover(data.qrCoverUrl);
        else setQrCover(null);
        
        if (data.monogramaUrl) {
           setHasManualLogo(true);
           setEventLogo(data.monogramaUrl);
        } else {
           setHasManualLogo(false);
           setEventLogo(null);
        }
      }
    });
    return () => unsub();
  }, []);

  // 🟢 FUNCIONES DEL BANCO DE ETIQUETAS
  const handleCreateGlobalTag = async (e) => {
    if (e) e.preventDefault();
    const cleanTag = newTagInput.trim();
    if (!cleanTag) return;
    const exists = globalTags.some(t => t.toLowerCase() === cleanTag.toLowerCase());
    if (exists) {
      if (addNotification) addNotification('Etiqueta duplicada', 'Esa etiqueta ya existe en tu banco.', 'warning');
      setNewTagInput('');
      return;
    }
    const updated = [...globalTags, cleanTag];
    setGlobalTags(updated);
    setNewTagInput('');
    try {
      await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { etiquetasGlobales: updated });
    } catch (err) { console.error(err); }
  };

  const handleDeleteGlobalTag = async (tagToRemove) => {
    const updated = globalTags.filter(t => t !== tagToRemove);
    setGlobalTags(updated);
    try {
      await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { etiquetasGlobales: updated });
      if (addNotification) addNotification('Etiqueta Eliminada', `Se quitó "${tagToRemove}" del banco.`, 'info');
    } catch (err) { console.error(err); }
  };

  const [searchTerm, setSearchTerm] = useState('');
  const [filtroLado, setFiltroLado] = useState('Todos');

  const [addModal, setAddModal] = useState({ open: false, side: 'general' });
  const [newGuest, setNewGuest] = useState({ name: '', adultPasses: 1, childrenPasses: 0, phone: '', status: 'por_invitar', tags: [] });
  const [editModal, setEditModal] = useState({ open: false, guest: null });
  const [deleteModal, setDeleteModal] = useState(null);
  const [qrModal, setQrModal] = useState(null); 

  useEffect(() => { setLogoError(false); }, [qrModal, eventLogo]);

  const [exportViewOpen, setExportViewOpen] = useState(false);
  const [exportCols, setExportCols] = useState({ nombre: true, pases: true, estatus: true, telefono: true, mesa: true });
  const [splitBySide, setSplitBySide] = useState(false); 
  const [isFabOpen, setIsFabOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [isPreparingListPrint, setIsPreparingListPrint] = useState(false);
  const [isPreparingQRPrint, setIsPreparingQRPrint] = useState(false);

  const safeGuests = guests || [];
  const [skippedRequests, setSkippedRequests] = useState(new Set());
  const [whatsappPromptModal, setWhatsappPromptModal] = useState(null);
  
  const currentRequest = safeGuests.find(g => g.extraRequested > 0 && !skippedRequests.has(g.id)) || null;

  const handleAprobarPases = async () => {
    if (!currentRequest) return;
    try {
      const guestRef = doc(db, "eventos", ID_DEL_EVENTO, "invitados", currentRequest.id);
      const nuevosPases = currentRequest.passes + currentRequest.extraRequested;
      const subGuestsArray = currentRequest.subGuests || [];
      const nuevosOriginales = currentRequest.originalPasses ? currentRequest.originalPasses + currentRequest.extraRequested : nuevosPases;
      
      const faltantes = nuevosPases - subGuestsArray.length;
      const nuevosSubGuests = [...subGuestsArray];
      for (let i=0; i<faltantes; i++) {
          nuevosSubGuests.push({
              id: `usr_extra_${Date.now()}_${i}`,
              name: '',
              isChild: false,
              entered: false,
              tags: currentRequest.tags || []
          });
      }

      await updateDoc(guestRef, { 
         passes: nuevosPases, 
         originalPasses: nuevosOriginales,
         extraRequested: 0,
         subGuests: nuevosSubGuests,
         status: 'pendiente'
      });
      
      setWhatsappPromptModal({
        id: currentRequest.id,
        name: currentRequest.name,
        phone: currentRequest.phone,
        nuevosPases: nuevosPases
      });
    } catch(e) { console.error(e); }
  };

  const handleRechazarPases = async () => {
    if (!currentRequest) return;
    try {
      const guestRef = doc(db, "eventos", ID_DEL_EVENTO, "invitados", currentRequest.id);
      await updateDoc(guestRef, { extraRequested: 0 });
    } catch(e) { console.error(e); }
  };

  const handleAtenderDespues = () => {
    if (!currentRequest) return;
    setSkippedRequests(prev => new Set(prev).add(currentRequest.id));
    if(addNotification) addNotification('Pospuesto', 'Podrás revisar esta solicitud más tarde desde la campanita de notificaciones.', 'info');
  };

  const handleSendExtraPassWhatsApp = () => {
    if (!whatsappPromptModal) return;
    const rawPhone = whatsappPromptModal.phone || '';
    const phone = String(rawPhone).replace(/\D/g,'');
    
    if (phone && phone.length >= 10) {
        let linkPersonalizado = '';
        if (urlInvitacion) {
          const separator = urlInvitacion.includes('?') ? '&' : '?';
          linkPersonalizado = `${urlInvitacion}${separator}u=${whatsappPromptModal.id}`;
        } else {
          const baseDomain = window.location.hostname.includes('localhost') ? window.location.origin : 'https://baulia.com';
          linkPersonalizado = `${baseDomain}/${ID_DEL_EVENTO}?u=${whatsappPromptModal.id}`;
        }

        const msg = `¡Hola *${whatsappPromptModal.name}*! Hemos aprobado tus pases extra. Ahora tienes *${whatsappPromptModal.nuevosPases} lugares* reservados.\n\nHemos habilitado tu invitación nuevamente para que registres los nombres de tus nuevos acompañantes. Por favor entra aquí y completa tu registro:\n${linkPersonalizado}`;
        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank');
    }
    setWhatsappPromptModal(null);
  };

  const handleOpenAdd = (side) => {
    setNewGuest({ name: '', adultPasses: 1, childrenPasses: 0, phone: '', status: 'por_invitar', tags: [] });
    setAddModal({ open: true, side });
  };

  const handleOpenEdit = (guest) => {
    const pNum = guest.passes || 1;
    const adultos = pNum - (guest.childrenPasses || 0);
    const existingSubs = guest.subGuests && guest.subGuests.length > 0 
      ? guest.subGuests.map(sg => ({ ...sg, tags: sg.tags || [] }))
      : Array(pNum).fill(null).map((_, i) => ({
          id: `usr_${guest.id}_${i}`,
          name: i === 0 ? guest.name : '',
          isChild: i >= adultos,
          entered: false,
          tags: guest.tags || []
        }));

    setEditModal({ 
      open: true, 
      guest: { 
        ...guest, 
        tags: guest.tags || [],
        subGuests: existingSubs
      } 
    });
  };

  const toggleNewGuestTag = (tag) => {
    setNewGuest(prev => {
      const current = prev.tags || [];
      const exists = current.includes(tag);
      return { ...prev, tags: exists ? current.filter(t => t !== tag) : [...current, tag] };
    });
  };

  const toggleEditGuestFamilyTag = (tag) => {
    setEditModal(prev => {
      const g = prev.guest;
      const current = g.tags || [];
      const exists = current.includes(tag);
      const updatedFamilyTags = exists ? current.filter(t => t !== tag) : [...current, tag];
      
      // Sincroniza la etiqueta familiar en los integrantes que no la tenían o que la tenían
      const updatedSubs = (g.subGuests || []).map(sg => {
        const sgTags = sg.tags || [];
        if (exists) {
          return { ...sg, tags: sgTags.filter(t => t !== tag) };
        } else {
          return { ...sg, tags: sgTags.includes(tag) ? sgTags : [...sgTags, tag] };
        }
      });

      return { ...prev, guest: { ...g, tags: updatedFamilyTags, subGuests: updatedSubs } };
    });
  };

  const toggleSubGuestTag = (subIdx, tag) => {
    setEditModal(prev => {
      const g = prev.guest;
      const subs = [...(g.subGuests || [])];
      const target = { ...subs[subIdx] };
      const currentTags = target.tags || [];
      target.tags = currentTags.includes(tag) ? currentTags.filter(t => t !== tag) : [...currentTags, tag];
      subs[subIdx] = target;
      return { ...prev, guest: { ...g, subGuests: subs } };
    });
  };

  const handleSubGuestEditChange = (subIdx, field, val) => {
    setEditModal(prev => {
      const g = prev.guest;
      const subs = [...(g.subGuests || [])];
      subs[subIdx] = { ...subs[subIdx], [field]: val };
      const childrenCount = subs.filter(s => s.isChild).length;
      return { ...prev, guest: { ...g, subGuests: subs, childrenPasses: childrenCount } };
    });
  };

  // 🟢 FUNCIONES PARA SUBIR IMÁGENES A LA NUBE Y GUARDARLAS PERMANENTEMENTE
  const handleCoverUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploadingCover(true);
    if (addNotification) addNotification('Subiendo Fondo...', 'Guardando portada en el servidor.', 'info');
    
    const formData = new FormData(); 
    formData.append('file', file); 
    formData.append('upload_preset', "ml_default");
    
    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/duy0mcqsh/image/upload`, { method: 'POST', body: formData });
      const data = await res.json();
      if (data.secure_url) {
         await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { qrCoverUrl: data.secure_url });
         if (addNotification) addNotification('¡Listo!', 'El fondo del pase se ha guardado para todos.', 'success');
      }
    } catch(err) {
      console.error(err);
      if (addNotification) addNotification('Error', 'Fallo al subir la imagen.', 'error');
    }
    setIsUploadingCover(false);
    e.target.value = null;
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploadingLogo(true);
    if (addNotification) addNotification('Subiendo Logo...', 'Guardando monograma manual.', 'info');
    
    const formData = new FormData(); 
    formData.append('file', file); 
    formData.append('upload_preset', "ml_default");
    
    try {
      const res = await fetch(`https://api.cloudinary.com/v1_1/duy0mcqsh/image/upload`, { method: 'POST', body: formData });
      const data = await res.json();
      if (data.secure_url) {
         await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { monogramaUrl: data.secure_url });
         if (addNotification) addNotification('¡Listo!', 'Logo actualizado correctamente.', 'success');
      }
    } catch(err) {
      if (addNotification) addNotification('Error', 'Fallo al subir el logo.', 'error');
    }
    setIsUploadingLogo(false);
    e.target.value = null;
  };

  const handleRemoveCover = async () => {
    try {
      await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { qrCoverUrl: null });
    } catch(e) { console.error(e); }
  };

  const handleRemoveManualLogo = async () => {
    try {
      await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { monogramaUrl: null });
      if (addNotification) addNotification('Modo Automático', 'Buscando monograma de la invitación...', 'info');
    } catch(e) { console.error(e); }
  };

  const totalPases = safeGuests.reduce((sum, g) => sum + (g.passes || 0), 0);
  const totalNinos = safeGuests.reduce((sum, g) => sum + (g.childrenPasses || 0), 0);
  const totalConfirmados = safeGuests.filter(g => g.status === 'confirmado' || g.status === 'ingreso').reduce((sum, g) => sum + (g.passes || 0), 0);
  const totalPendientes = safeGuests.filter(g => g.status === 'pendiente' || g.status === 'por_invitar').reduce((sum, g) => sum + (g.passes || 0), 0);
  const totalIngresos = safeGuests.reduce((sum, g) => sum + (g.entered || 0), 0); 
  
  const totalCancelados = safeGuests.reduce((sum, g) => {
    const pasesOriginales = g.originalPasses || g.passes || 0;
    const pasesConfirmados = g.subGuests?.length || 0;
    if (g.status === 'cancelado') return sum + pasesOriginales;
    if (g.status === 'confirmado' || g.status === 'ingreso') return sum + Math.max(0, pasesOriginales - pasesConfirmados);
    return sum;
  }, 0);

  const pasesNovia = safeGuests.filter(g => g.side === 'novia').reduce((sum, g) => sum + (g.passes || 0), 0);
  const pasesNovio = safeGuests.filter(g => g.side === 'novio').reduce((sum, g) => sum + (g.passes || 0), 0);
  const totalMesas = tables ? tables.length : 0;

  // 🟢 MAGIA: Agrupar visualmente a las familias separadas por el Modo Separador
  const familiasUnificadasMap = new Map();
  safeGuests.forEach(g => {
      const rootId = g.parentId || g.id;
      const tableObj = tables?.find(t => String(t.id) === String(g.tableId));
      const tName = tableObj ? tableObj.name : g.tableId;

      const subGuestsWithTable = (g.subGuests || []).map(sg => ({
          ...sg,
          tags: sg.tags || g.tags || [],
          specificTableId: g.tableId,
          specificTableName: tName
      }));

      if (!familiasUnificadasMap.has(rootId)) {
          const rootGuest = safeGuests.find(rg => rg.id === rootId) || g;
          familiasUnificadasMap.set(rootId, { 
              ...rootGuest, 
              tableIds: g.tableId ? [g.tableId] : [], 
              displayPasses: g.passes,
              todasMesasNombre: tName ? [tName] : [],
              mergedSubGuests: subGuestsWithTable
          });
      } else {
          const parent = familiasUnificadasMap.get(rootId);
          if (g.tableId && !parent.tableIds.includes(g.tableId)) {
              parent.tableIds.push(g.tableId);
              if (tName && !parent.todasMesasNombre.includes(tName)) {
                  parent.todasMesasNombre.push(tName);
              }
          }
          parent.displayPasses += g.passes;
          parent.mergedSubGuests = [...(parent.mergedSubGuests || []), ...subGuestsWithTable];
      }
  });

  const unifiedGuests = Array.from(familiasUnificadasMap.values()).map(parent => {
      if (parent.mergedSubGuests && parent.mergedSubGuests.length > 0) {
          parent.mergedSubGuests.sort((a, b) => {
              if (a.name === parent.name && b.name !== parent.name) return -1;
              if (b.name === parent.name && a.name !== parent.name) return 1;
              if (a.name && !b.name) return -1;
              if (!a.name && b.name) return 1;
              return 0;
          });
      }
      return parent;
  });

  const invitadosFiltrados = unifiedGuests.filter(g => {
    const term = searchTerm.toLowerCase();
    const matchesSide = filtroLado === 'Todos' ? true : g.side === filtroLado.toLowerCase();
    if (!term) return matchesSide;

    const name = (g.name || '').toLowerCase();
    const status = (g.status || '').toLowerCase();
    const side = g.side ? g.side.toLowerCase() : ''; 
    const subGuestsNames = g.mergedSubGuests ? g.mergedSubGuests.map(sg => (sg.name || '').toLowerCase()).join(' ') : '';
    const mesasNames = g.todasMesasNombre ? g.todasMesasNombre.join(' ').toLowerCase() : '';
    const guestTagsStr = (g.tags || []).join(' ').toLowerCase();
    const subTagsStr = g.mergedSubGuests ? g.mergedSubGuests.map(sg => (sg.tags || []).join(' ')).join(' ').toLowerCase() : '';

    return (name.includes(term) || status.includes(term) || subGuestsNames.includes(term) || mesasNames.includes(term) || side.includes(term) || guestTagsStr.includes(term) || subTagsStr.includes(term)) && matchesSide;
  });

  const getFlattenedGuests = (guestList) => {
    const flattened = [];
    guestList.forEach(guest => {
      if (!isPremium) {
        flattened.push({ _rowId: guest.id, parentGuest: guest, displayName: guest.name, passes: guest.displayPasses || guest.passes, isMain: true, isChild: false, pin: null, entered: false, specificTableName: null, rowTags: guest.tags || [] });
        return; 
      }
      if (!guest.mergedSubGuests || guest.mergedSubGuests.length === 0 || !qrEnabled) {
        flattened.push({ _rowId: guest.id, parentGuest: guest, displayName: guest.name, passes: guest.displayPasses || guest.passes, isMain: true, isChild: false, pin: null, entered: false, specificTableName: null, rowTags: guest.tags || [] });
      } else {
        guest.mergedSubGuests.forEach((sg, idx) => {
          flattened.push({ 
            _rowId: sg.id, 
            parentGuest: guest, 
            displayName: sg.name || (sg.isChild ? 'Niño (Por registrar)' : 'Acompañante (Por registrar)'), 
            passes: guest.displayPasses || guest.passes, 
            isMain: idx === 0, 
            isChild: sg.isChild, 
            pin: sg.id, 
            entered: sg.entered,
            isEmptyName: !sg.name,
            specificTableName: sg.specificTableName,
            rowTags: (sg.tags && sg.tags.length > 0) ? sg.tags : (guest.tags || [])
          });
        });
        const faltantes = (guest.displayPasses || guest.passes || 0) - guest.mergedSubGuests.length;
        if (faltantes > 0 && (guest.status === 'pendiente' || guest.status === 'por_invitar')) {
          flattened.push({ _rowId: `${guest.id}_faltantes`, parentGuest: guest, displayName: `Lugares sin confirmar (${faltantes})`, passes: faltantes, isMain: false, isChild: false, pin: null, isMissing: true, entered: false, specificTableName: null, rowTags: [] });
        }
      }
    });
    return flattened;
  };

  const flattenedList = getFlattenedGuests(invitadosFiltrados);

  const handleSendWhatsApp = async (parentGuest) => {
    const phone = parentGuest.phone ? parentGuest.phone.replace(/\D/g,'') : '';
    if (!phone) {
       if (addNotification) addNotification('Falta Teléfono', `Agrega un número de WhatsApp a ${parentGuest.name} para enviarle la invitación.`, 'warning');
       return;
    }
    let linkPersonalizado = '';
    if (urlInvitacion) {
      const separator = urlInvitacion.includes('?') ? '&' : '?';
      linkPersonalizado = `${urlInvitacion}${separator}u=${parentGuest.id}`;
    } else {
      const baseDomain = window.location.hostname.includes('localhost') ? window.location.origin : 'https://baulia.com';
      linkPersonalizado = `${baseDomain}/${ID_DEL_EVENTO}?u=${parentGuest.id}`;
    }
    let msg = `¡Hola *${parentGuest.name}*! Tenemos el honor de invitarte a nuestro evento.\n\nPor favor entra al siguiente enlace para ver los detalles, la ubicación y *Confirmar tu Asistencia*:\n\n ${linkPersonalizado}\n\n¡Te esperamos!`;
    if (passCountEnabled && isPremium) {
      msg = `¡Hola *${parentGuest.name}*! Tenemos el honor de invitarte a nuestro evento.\n\nTu pase es VIP e intransferible. Por favor entra al siguiente enlace para ver los detalles, la ubicación y *Confirmar tu Asistencia* (tienes ${parentGuest.displayPasses || parentGuest.passes} lugares reservados):\n\n ${linkPersonalizado}\n\n¡Te esperamos!`;
    }
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank');
    const nuevoStatus = parentGuest.status === 'por_invitar' ? 'pendiente' : parentGuest.status;
    const updatedGuest = { ...parentGuest, sent: true, status: nuevoStatus };
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", parentGuest.id), updatedGuest);
    if (addNotification) addNotification('Enviado', `Se abrió WhatsApp para ${parentGuest.name}.`, 'success');
  };

  const handleSaveGuest = async (e) => {
    e.preventDefault();
    const nuevoId = Date.now().toString();
    const adultos = passCountEnabled ? (Number(newGuest.adultPasses) || 1) : 1;
    const ninos = passCountEnabled ? (Number(newGuest.childrenPasses) || 0) : 0; 
    const pNum = adultos + ninos;
    const selectedTags = newGuest.tags || [];
    
    const initSubGuests = qrEnabled ? Array(pNum).fill(null).map((_, i) => ({
      id: `usr_${nuevoId}_${i}`,
      name: i === 0 ? newGuest.name : '', 
      isChild: i >= adultos, 
      entered: false,
      tags: [...selectedTags]
    })) : [];

    const datosInvitado = {
      name: newGuest.name, passes: pNum, childrenPasses: ninos, phone: newGuest.phone, 
      status: newGuest.status, side: addModal.side, entered: 0, tableId: null, 
      sent: false, subGuests: initSubGuests, extraRequested: 0, originalPasses: pNum,
      tags: selectedTags
    };
    
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", nuevoId), datosInvitado);
    setAddModal({ open: false, side: 'general' });
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    const updatedGuest = { ...editModal.guest, extraRequested: 0 };
    if (!passCountEnabled) updatedGuest.passes = 1; 
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", updatedGuest.id), updatedGuest);
    setEditModal({ open: false, guest: null });
    if (addNotification) addNotification('Guardado', 'Datos y etiquetas actualizados.', 'success');
  };

  const executeDeleteGuest = async () => {
    if(deleteModal) {
      await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", deleteModal.id));
      setDeleteModal(null);
    }
  };

  const toggleCol = (col) => setExportCols(prev => ({ ...prev, [col]: !prev[col] }));

  const triggerListPdfDownload = async () => {
    setIsPreparingListPrint(true);
    setTimeout(async () => {
      try {
        const { jsPDF } = await import('jspdf');
        const html2canvas = (await import('html2canvas')).default;
        const pages = document.querySelectorAll('.list-pdf-page');
        const pdf = new jsPDF('p', 'mm', 'letter');
        for (let i = 0; i < pages.length; i++) {
           const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, backgroundColor: '#ffffff', logging: false });
           const imgData = canvas.toDataURL('image/jpeg', 0.95);
           if (i > 0) pdf.addPage();
           pdf.addImage(imgData, 'JPEG', 0, 0, 215.9, 279.4);
        }
        pdf.save(`Reporte-Asistencia-${eventName?.replace(/\s+/g, '-') || 'Invitados'}.pdf`);
        if(addNotification) addNotification('¡PDF Guardado!', 'Revisa tu carpeta de descargas.', 'success');
      } catch (error) {}
      setIsPreparingListPrint(false);
      setExportViewOpen(false);
    }, 800);
  };

  const exportToExcel = () => {
    if (addNotification) addNotification('Generando Excel', 'Preparando documento corporativo...', 'info');
    const allList = getFlattenedGuests(invitadosFiltrados);

    let html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
    <head><meta charset="utf-8"><style>
      table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; }
      th { background-color: #0f172a; color: #ffffff; padding: 12px; border: 1px solid #cbd5e1; text-align: left; font-weight: bold; text-transform: uppercase; font-size: 11px; }
      td { padding: 10px; border: 1px solid #cbd5e1; font-size: 13px; }
      .header { background-color: #f8fafc; font-size: 22px; font-weight: bold; padding: 20px; text-align: left; border: none; }
      .summary { background-color: #f1f5f9; font-weight: bold; font-size: 14px; text-align: center; border: 1px solid #cbd5e1; padding: 15px; }
    </style></head><body>`;

    html += `<table>
      <tr><td colspan="5" class="header">Reporte Oficial de Asistencia - EventMaster</td></tr>
      <tr><td colspan="5" style="text-align: right; color: #64748b; border: none;">Fecha de emisión: ${new Date().toLocaleDateString('es-MX')}</td></tr>
      <tr><td colspan="5" style="border: none;"></td></tr>
      <tr>
        <td colspan="2" class="summary">${passCountEnabled ? 'Pases Totales:' : 'Invitados Totales:'} <span style="font-size:18px; color:#0f172a;">${passCountEnabled ? totalPases : safeGuests.length}</span></td>
        <td colspan="1" class="summary">Confirmados: <span style="font-size:18px; color:#16a34a;">${passCountEnabled ? totalConfirmados : safeGuests.filter(g => g.status === 'confirmado').length}</span></td>
        ${qrEnabled ? `<td colspan="2" class="summary">Ya Ingresaron: <span style="font-size:18px; color:#0284c7;">${totalIngresos}</span></td>` : ''}
      </tr>
      <tr><td colspan="5" style="border: none;"></td></tr>
      <tr>`;
      
    if(exportCols.nombre) html += `<th>Nombre del Asistente</th>`;
    if(exportCols.pases && passCountEnabled) html += `<th>Pases</th>`;
    if(exportCols.estatus) html += `<th>Estatus</th>`;
    if(exportCols.telefono) html += `<th>Teléfono Titular</th>`;
    if(exportCols.mesa) html += `<th>Mesa Asignada</th>`;
    html += `</tr>`;

    allList.forEach(row => {
      let mesaName = row.specificTableName || 'Sin Mesa';
      if (row.isMissing) mesaName = '-';
          
      let displayName = row.displayName;
      if (row.isMain && row.parentGuest.todasMesasNombre?.length > 1) {
          displayName += ' (Fam. Dividida)';
      }

      html += `<tr>`;
      if(exportCols.nombre) html += `<td>${row.isMain ? '<b>'+displayName+'</b>' : displayName} ${row.isChild ? '(Niño)' : ''}</td>`;
      if(exportCols.pases && passCountEnabled) html += `<td style="text-align:center;">${row.isMain ? row.passes : ''}</td>`;
      if(exportCols.estatus) html += `<td>${row.parentGuest.status.replace('_', ' ').toUpperCase()}</td>`;
      if(exportCols.telefono) html += `<td>${row.isMain ? (row.parentGuest.phone || 'N/A') : ''}</td>`;
      if(exportCols.mesa) html += `<td>${mesaName}</td>`;
      html += `</tr>`;
    });
    html += `</table></body></html>`;

    const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Lista_Invitados_${eventName?.replace(/\s+/g, '_') || 'EventMaster'}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 🟢 ELEMENTO JSX ESTABLE (Evita que el input pierda el foco al teclear)
  const quickTagCreatorJSX = (
    <div className="flex gap-1.5 mt-2">
      <input 
        type="text" 
        value={newTagInput} 
        onChange={e => setNewTagInput(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleCreateGlobalTag(); } }}
        placeholder="Nueva etiqueta (ej. Primos, VIP)..." 
        className="flex-1 px-3 py-1.5 bg-[#141210] border border-white/10 rounded-lg text-xs outline-none focus:border-[#D4AF37] text-white transition-colors"
      />
      <button 
        type="button" 
        onClick={handleCreateGlobalTag}
        className="px-3 py-1.5 bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/30 rounded-lg text-[10px] font-black uppercase tracking-widest hover:bg-[#D4AF37]/25 transition-colors shrink-0"
      >
        + Crear
      </button>
    </div>
  );

  return (
    <div className="h-full flex flex-col md:space-y-6 relative text-zinc-100 bg-black min-h-[100vh] md:p-4 md:rounded-3xl transition-colors duration-500 pb-32">
      
      {/* VISTA PREVIA PROFESIONAL (PDF/EXCEL) */}
      {/* ... (El contenido de exportViewOpen se mantiene igual) ... */}

      {/* CABECERA OLED RESPONSIVA */}
      <div className="flex flex-row justify-between items-center bg-[#121212] p-4 md:p-6 md:rounded-3xl border-b md:border border-zinc-800/50 shadow-sm relative z-30">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-2xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 hidden md:flex items-center justify-center text-[#D4AF37] shrink-0">
            <Users size={20} />
          </div>
          <div>
            <span className="hidden md:block text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] mb-0.5">Control de asistencia</span>
            <h2 className="text-xl md:text-3xl font-editorial text-[#F4F4F5] tracking-wide leading-none">Gestión de Invitados</h2>
          </div>
        </div>
        
        {/* MENÚ MÓVIL (3 PUNTOS) */}
        <div className="md:hidden relative">
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-zinc-400 hover:text-white transition-colors">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>
          </button>
          {isMobileMenuOpen && (
            <div className="absolute right-0 top-full mt-2 w-48 bg-[#18181b] border border-zinc-800 rounded-xl shadow-2xl py-2 z-50">
              {isPremium && <button onClick={() => { setIsTagManagerOpen(true); setIsMobileMenuOpen(false); }} className="w-full text-left px-4 py-3 text-sm text-zinc-300 hover:bg-white/5 flex items-center gap-2"><Layers size={16}/> Etiquetas</button>}
              <button onClick={() => { setExportViewOpen(true); setIsMobileMenuOpen(false); }} className="w-full text-left px-4 py-3 text-sm text-zinc-300 hover:bg-white/5 flex items-center gap-2"><FileSpreadsheet size={16}/> Exportar</button>
              <div className="border-t border-zinc-800 my-1"></div>
              <div className="px-4 py-3 flex items-center justify-between">
                <span className="text-sm text-zinc-300">Modo Boda</span>
                <button onClick={async () => {
                  const newVal = !isWeddingMode;
                  setIsWeddingMode(newVal);
                  try { await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { tipoEvento: newVal ? 'boda' : 'general' }); } catch(e) {}
                }} className={`relative w-8 h-4 rounded-full transition-colors ${isWeddingMode ? 'bg-[#D4AF37]' : 'bg-zinc-700'}`}>
                  <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${isWeddingMode ? 'translate-x-4' : 'translate-x-0'}`}></div>
                </button>
              </div>
            </div>
          )}
        </div>

        {/* ACCIONES ESCRITORIO */}
        <div className="hidden md:flex flex-wrap items-center gap-2.5 justify-end">
          {isPremium && (
            <button onClick={() => setIsTagManagerOpen(true)} className="flex items-center justify-center px-4 h-9 bg-transparent border border-zinc-700 text-zinc-300 hover:text-white rounded-lg text-[10px] font-bold hover:bg-white/5 transition-colors uppercase tracking-widest shrink-0">
              <Layers size={14} className="mr-1.5"/> Etiquetas ({globalTags.length})
            </button>
          )}
          <button onClick={() => setExportViewOpen(true)} className="flex items-center justify-center px-4 h-9 bg-transparent border border-zinc-700 text-zinc-300 hover:text-white rounded-lg text-[10px] font-bold hover:bg-white/5 transition-colors uppercase tracking-widest shrink-0">
            <FileSpreadsheet size={14} className="mr-1.5"/> Exportar
          </button>
          
          <div className="flex items-center bg-transparent px-3 h-9 rounded-lg border border-zinc-700 transition-colors shrink-0">
            <span className="text-[9px] font-bold text-zinc-400 uppercase tracking-wider mr-2">Boda</span>
            <button onClick={async () => {
              const newVal = !isWeddingMode;
              setIsWeddingMode(newVal);
              try { await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { tipoEvento: newVal ? 'boda' : 'general' }); } catch(e) {}
            }} className={`relative w-8 h-4 rounded-full transition-colors ${isWeddingMode ? 'bg-[#D4AF37]' : 'bg-white/10'}`}>
              <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${isWeddingMode ? 'translate-x-4' : 'translate-x-0'}`}></div>
            </button>
          </div>

          {isWeddingMode ? (
            <div className="flex gap-2 shrink-0">
              <button onClick={() => handleOpenAdd('novia')} className="flex items-center justify-center px-4 h-9 bg-[#F43F5E]/10 border border-[#F43F5E]/30 text-[#F43F5E] rounded-lg text-[10px] font-bold hover:bg-[#F43F5E]/20 transition-colors uppercase tracking-widest">
                <UserPlus size={14} className="mr-1.5"/> Novia
              </button>
              <button onClick={() => handleOpenAdd('novio')} className="flex items-center justify-center px-4 h-9 bg-sky-500/10 border border-sky-500/30 text-sky-400 rounded-lg text-[10px] font-bold hover:bg-sky-500/20 transition-colors uppercase tracking-widest">
                <UserPlus size={14} className="mr-1.5"/> Novio
              </button>
            </div>
          ) : (
            <button onClick={() => handleOpenAdd('general')} className="flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-black rounded-lg text-[10px] font-black hover:bg-[#c5a028] transition-colors uppercase tracking-widest shrink-0">
              <UserPlus size={14} className="mr-1.5"/> Nuevo Invitado
            </button>
          )}
        </div>
      </div>

      {/* ESTADÍSTICAS (Grid en Desktop, Scroll Horizontal tipo Historias en Móvil) */}
      <div className={`flex overflow-x-auto md:grid md:${isPremium ? 'grid-cols-6' : 'grid-cols-4'} gap-3 px-4 md:px-0 pt-2 md:pt-0 custom-scrollbar snap-x shrink-0 w-full`}>
        <div className="min-w-[130px] md:min-w-0 bg-[#121212] p-3 rounded-2xl border border-white/5 flex flex-col justify-center snap-center">
          <div className="text-zinc-500 font-bold text-[9px] uppercase tracking-[0.2em] mb-1 flex items-center"><Users className="w-3 h-3 mr-1.5 text-zinc-400"/> {passCountEnabled ? 'Totales' : 'Invitados'}</div>
          <h3 className="text-xl font-editorial font-black text-[#F4F4F5]">{passCountEnabled ? totalPases : safeGuests.length}</h3>
        </div>
        
        {isPremium && passCountEnabled && (
        <div className="min-w-[130px] md:min-w-0 bg-[#121212] p-3 rounded-2xl border border-white/5 flex flex-col justify-center snap-center">
          <div className="text-sky-500 font-bold text-[9px] uppercase tracking-[0.2em] mb-1 flex items-center"><Users className="w-3 h-3 mr-1.5 text-sky-400"/> Niños</div>
          <h3 className="text-xl font-editorial font-black text-sky-400">{totalNinos}</h3>
        </div>
        )}
        
        <div className="min-w-[130px] md:min-w-0 bg-[#121212] p-3 rounded-2xl border border-[#D4AF37]/20 flex flex-col justify-center snap-center shadow-[0_0_15px_rgba(212,175,55,0.05)]">
          <div className="text-[#D4AF37] font-bold text-[9px] uppercase tracking-[0.2em] mb-1 flex items-center"><CheckCircle className="w-3 h-3 mr-1.5"/> Confirmados</div>
          <h3 className="text-xl font-editorial font-black text-[#D4AF37]">{passCountEnabled ? totalConfirmados : safeGuests.filter(g => g.status === 'confirmado' || g.status === 'ingreso').length}</h3>
        </div>
        
        <div className="min-w-[130px] md:min-w-0 bg-[#121212] p-3 rounded-2xl border border-white/5 flex flex-col justify-center snap-center">
          <div className="text-zinc-500 font-bold text-[9px] uppercase tracking-[0.2em] mb-1 flex items-center"><Clock className="w-3 h-3 mr-1.5 text-zinc-400"/> Pendientes</div>
          <h3 className="text-xl font-editorial font-black text-zinc-300">{passCountEnabled ? totalPendientes : safeGuests.filter(g => g.status === 'pendiente' || g.status === 'por_invitar').length}</h3>
        </div>
        
        <div className="min-w-[130px] md:min-w-0 bg-[#121212] p-3 rounded-2xl border border-[#F43F5E]/20 flex flex-col justify-center snap-center">
          <div className="text-[#F43F5E] font-bold text-[9px] uppercase tracking-[0.2em] mb-1 flex items-center"><X className="w-3 h-3 mr-1.5"/> Cancelados</div>
          <h3 className="text-xl font-editorial font-black text-[#F43F5E]">{passCountEnabled ? totalCancelados : safeGuests.filter(g => g.status === 'cancelado').length}</h3>
        </div>
        
        {isPremium && qrEnabled && (
        <div className="min-w-[130px] md:min-w-0 bg-[#121212] p-3 rounded-2xl border border-[#10B981]/20 flex flex-col justify-center snap-center">
          <div className="text-[#10B981] font-bold text-[9px] uppercase tracking-[0.2em] mb-1 flex items-center"><Scan className="w-3 h-3 mr-1.5"/> Ingresaron</div>
          <h3 className="text-xl font-editorial font-black text-[#10B981]">{totalIngresos}</h3>
        </div>
        )}
      </div>

      {isWeddingMode && passCountEnabled && (
        <div className="bg-[#121212] py-2 px-6 mx-4 md:mx-0 rounded-2xl border border-white/5 flex items-center justify-around">
          <div className="text-center flex items-center gap-3"><p className="text-[8px] font-bold text-zinc-500 uppercase tracking-widest">Novia</p><p className="text-sm font-editorial font-black text-[#F43F5E]">{pasesNovia}</p></div>
          <div className="h-4 w-px bg-white/10"></div>
          <div className="text-center flex items-center gap-3"><p className="text-[8px] font-bold text-zinc-500 uppercase tracking-widest">Novio</p><p className="text-sm font-editorial font-black text-sky-400">{pasesNovio}</p></div>
        </div>
      )}

      <div className="flex-1 flex flex-col transition-colors duration-500 z-10 relative mt-2 md:mt-0">
        {/* BUSCADOR STICKY PREMIUM */}
        <div className="px-4 md:px-0 py-2 bg-black/80 md:bg-transparent backdrop-blur-xl sticky top-0 z-40 shrink-0 mb-2 border-b border-white/5 md:border-none">
          <div className="relative flex-1">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" size={16} />
            <input type="text" placeholder="Buscar en la lista..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-3 border border-white/5 rounded-2xl text-sm outline-none focus:border-[#D4AF37]/50 bg-[#121212] text-[#F4F4F5] placeholder-zinc-600 transition-colors shadow-inner" />
          </div>
        </div>

        {/* CONTENEDOR DE LISTA */}
        <div className="md:overflow-y-auto md:custom-scrollbar md:bg-[#121212] md:rounded-3xl md:border md:border-white/5 flex-1 relative">
          
          <div className="hidden md:block">
            <table className="w-full text-left text-xs whitespace-nowrap">
              <thead className="bg-[#141210] border-b border-[#D4AF37]/20 text-[#D4AF37] sticky top-0 z-10 transition-colors">
                <tr>
                  <th className="px-5 py-3 font-bold uppercase tracking-wider text-[10px]">Nombre</th>
                  {isPremium && passCountEnabled && <th className="px-3 py-3 font-bold uppercase tracking-wider text-[10px] text-center">Tipo / Etiquetas</th>}
                  {passCountEnabled && <th className="px-3 py-3 font-bold uppercase tracking-wider text-[10px] text-center">Pases</th>}
                  {isPremium && <th className="px-4 py-3 font-bold uppercase tracking-wider text-[10px] text-center">Mesa</th>}
                  {isPremium && qrEnabled && <th className="px-3 py-3 font-bold uppercase tracking-wider text-[10px] text-center">QR Pase</th>}
                  <th className="px-4 py-3 font-bold uppercase tracking-wider text-[10px] text-center">Estatus</th>
                  <th className="px-5 py-3 font-bold uppercase tracking-wider text-[10px] text-right">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10">
                {flattenedList.map((row) => (
                  <tr key={`desktop_${row._rowId}`} className={`transition-colors hover:bg-white/5 ${row.parentGuest.status === 'cancelado' ? 'bg-rose-500/10 opacity-70' : row.isMain ? 'bg-[#1C1917] border-t-2 border-[#D4AF37]/20' : 'bg-[#141210]/60'}`}>
                    <td className="px-5 py-3">
                      <div className="flex flex-col">
                        <div className="flex items-center gap-1.5">
                          <span className={`${row.isMain ? 'font-bold text-white' : 'font-normal text-slate-400'} ${row.isMissing || row.isEmptyName ? 'text-[#D4AF37] italic' : ''} ${row.parentGuest.status === 'cancelado' ? 'line-through text-slate-600' : ''}`}>
                            {row.displayName}
                          </span>
                          {row.isMain && row.parentGuest.todasMesasNombre?.length > 1 && (
                            <span className="px-1.5 py-0.5 rounded text-[8px] font-black uppercase tracking-widest border bg-amber-500/10 text-amber-400 border-amber-500/20" title={`Distribuidos en: ${row.parentGuest.todasMesasNombre.join(', ')}`}>
                              Dividida
                            </span>
                          )}
                          {isWeddingMode && !row.isMissing && row.parentGuest.side && row.parentGuest.side !== 'general' && (
                            <span className={`px-2 py-0.5 rounded text-[8px] font-black uppercase tracking-widest border ${row.parentGuest.side === 'novia' ? 'bg-rose-500/10 text-rose-400 border-rose-500/20' : 'bg-sky-500/10 text-sky-400 border-sky-500/20'}`}>
                              {row.parentGuest.side}
                            </span>
                          )}
                        </div>
                      </div>
                    </td>
                    
                    {isPremium && passCountEnabled && (
                      <td className="px-3 py-3 text-center">
                        {row.isMissing ? (
                          <span className="text-slate-600">-</span>
                        ) : (
                          <div className="flex items-center justify-center gap-1 flex-wrap max-w-[220px] mx-auto">
                            {row.isChild && (
                              <span className="text-sky-400 bg-sky-500/10 border border-sky-500/20 px-2 py-0.5 rounded text-[8px] uppercase font-black tracking-widest">Niño</span>
                            )}
                            {row.rowTags && row.rowTags.map(t => (
                              <span key={t} className="text-[#D4AF37] bg-[#D4AF37]/10 border border-[#D4AF37]/20 px-2 py-0.5 rounded text-[8px] uppercase font-bold tracking-wider">
                                {t}
                              </span>
                            ))}
                            {!row.isChild && (!row.rowTags || row.rowTags.length === 0) && (
                              <span className="text-slate-600">-</span>
                            )}
                          </div>
                        )}
                      </td>
                    )}
                    
                    {passCountEnabled && (
                       <td className="px-3 py-3 text-center">
                          {row.isMain || row.isMissing ? <span className="font-black text-[#D4AF37] text-sm">{row.parentGuest.displayPasses || row.passes}</span> : <span className="text-slate-600">-</span>}
                       </td>
                    )}

                    {isPremium && (
                      <td className="px-4 py-3 text-center">
                        {row.specificTableName ? (
                           <span className="px-3 py-1 bg-white/5 text-slate-300 rounded-lg text-[10px] font-bold border border-white/10 shadow-sm whitespace-nowrap">
                             {row.specificTableName}
                           </span>
                        ) : (
                           <span className="text-[10px] text-slate-600 italic">
                             {row.isMissing ? '-' : 'No asignado'}
                           </span>
                        )}
                      </td>
                    )}

                    {isPremium && qrEnabled && (
                       <td className="px-3 py-3 text-center">
                         {row.pin && row.parentGuest.status !== 'cancelado' ? (
                           <button onClick={() => setQrModal(row)} className="text-[#D4AF37] hover:text-white bg-[#D4AF37]/10 hover:bg-[#D4AF37]/20 p-2 rounded-lg transition-colors border border-[#D4AF37]/20" title="Ver Pase Individual">
                             <QrCode size={16} />
                           </button>
                         ) : <span className="text-slate-600">-</span>}
                       </td>
                    )}
                    
                    <td className="px-4 py-3 text-center">
                      {row.isMissing ? (
                        <span className="text-slate-600">-</span>
                      ) : row.entered && !row.isMain && qrEnabled ? (
                        <span className="px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-widest border bg-emerald-500/20 text-emerald-400 border-emerald-500/30">
                           EN EL EVENTO
                        </span>
                      ) : (
                        <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-widest border ${row.parentGuest.status === 'nuevo' ? 'bg-[#D4AF37] text-[#141210] border-[#D4AF37] animate-pulse shadow-md' : row.parentGuest.status === 'en_proceso' ? 'bg-amber-500/10 text-amber-400 border-amber-500/30' : row.parentGuest.status === 'ingreso' ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30' : row.parentGuest.status === 'confirmado' ? 'bg-[#D4AF37]/15 text-[#D4AF37] border-[#D4AF37]/40 shadow-[0_0_10px_rgba(212,175,55,0.1)]' : row.parentGuest.status === 'cancelado' ? 'bg-rose-500/10 text-rose-400 border-rose-500/20' : row.parentGuest.status === 'por_invitar' ? 'bg-white/5 text-slate-400 border-white/10' : 'bg-transparent text-slate-500 border-white/5'}`}>
                          {row.parentGuest.status === 'ingreso' ? `EN EVENTO` : row.parentGuest.status === 'nuevo' ? 'NUEVO' : (row.parentGuest.status ? row.parentGuest.status.replace('_', ' ') : 'PENDIENTE')}
                        </span>
                      )}
                    </td>
                    
                    <td className="px-5 py-3 text-right">
                      {row.isMain || !qrEnabled ? (
                        <div className="flex justify-end space-x-1.5">
                          <button onClick={() => handleSendWhatsApp(row.parentGuest)} className={`p-2 rounded-lg transition-colors border ${row.parentGuest.sent ? 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/30' : 'bg-transparent text-slate-400 border-white/10 hover:bg-white/5 hover:text-white'}`} title="Enviar por WhatsApp"><MessageCircle size={14}/></button>
                          <button onClick={() => handleOpenEdit(row.parentGuest)} className="p-2 text-slate-400 bg-transparent border border-white/10 hover:text-white hover:bg-white/5 rounded-lg transition-colors" title="Editar Familia y Etiquetas"><Edit2 size={14} /></button>
                          <button onClick={() => setDeleteModal(row.parentGuest)} className="p-2 text-slate-400 bg-transparent border border-white/10 hover:text-rose-500 hover:bg-rose-500/10 hover:border-rose-500/20 rounded-lg transition-colors"><Trash2 size={14} /></button>
                        </div>
                      ) : (
                        <button onClick={() => handleOpenEdit(row.parentGuest)} className="text-[9px] text-[#D4AF37] hover:underline uppercase tracking-widest font-bold">
                          Etiquetar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="block md:hidden pb-24 px-4 space-y-3 pt-2">
            {flattenedList.length === 0 ? (
              <div className="text-center p-8 text-zinc-500 mt-4 text-sm border border-dashed border-white/10 rounded-2xl">No se encontraron invitados.</div>
            ) : (
              flattenedList.map((row) => {
                const isExpanded = expandedMobileRow === row._rowId;
                const isCancelado = row.parentGuest.status === 'cancelado';
                let tableNameDisplay = row.specificTableName || 'Sin mesa';
                if (row.isMissing) tableNameDisplay = '-';

                return (
                  <div key={`mobile_${row._rowId}`} className={`transition-all duration-300 rounded-2xl overflow-hidden border ${row.isMain ? 'bg-[#121212] border-white/5 shadow-lg' : 'bg-[#0a0a0a] border-l-[3px] border-l-zinc-800 border-y-transparent border-r-transparent ml-4 rounded-l-none'} ${isCancelado ? 'opacity-50' : ''}`}>
                    <div onClick={() => toggleMobileRow(row._rowId)} className="p-4 flex justify-between items-center cursor-pointer select-none">
                      <div className="flex-1 min-w-0 pr-3">
                        <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                          <span className={`font-editorial font-bold truncate text-lg leading-tight tracking-wide ${row.isMain ? 'text-[#F4F4F5]' : 'text-zinc-400'}`}>
                            {row.displayName}
                          </span>
                          {row.isChild && (
                            <span className="px-2 py-0.5 rounded-full text-[8px] font-black uppercase tracking-widest bg-sky-500/10 text-sky-400 border border-sky-500/20">Niño</span>
                          )}
                          {row.rowTags && row.rowTags.map(t => (
                            <span key={t} className="px-2 py-0.5 rounded-full text-[8px] font-bold uppercase tracking-wider bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20">
                              {t}
                            </span>
                          ))}
                        </div>
                        <div className="flex items-center gap-2 text-[11px] font-medium tracking-wide">
                          <span className="text-zinc-500 truncate max-w-[140px] flex items-center"><MapPin size={10} className="mr-1 opacity-50"/> {tableNameDisplay}</span>
                          {row.isMain && <span className="text-zinc-600">• {row.passes} lugares</span>}
                        </div>
                      </div>
                      <div className="flex flex-col items-end gap-1.5 shrink-0">
                        {row.isMissing ? null : row.entered && !row.isMain && qrEnabled ? (
                           <span className="text-[9px] font-black uppercase tracking-widest text-[#10B981] bg-[#10B981]/10 px-2 py-1 rounded-md">
                             Adentro
                           </span>
                        ) : (
                           <span className={`text-[10px] uppercase font-bold tracking-widest px-2 py-1 rounded-md ${row.parentGuest.status === 'nuevo' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' : row.parentGuest.status === 'en_proceso' ? 'bg-amber-500/10 text-amber-500' : row.parentGuest.status === 'ingreso' ? 'bg-[#10B981]/10 text-[#10B981]' : row.parentGuest.status === 'confirmado' ? 'bg-[#D4AF37]/10 text-[#D4AF37]' : row.parentGuest.status === 'cancelado' ? 'bg-[#F43F5E]/10 text-[#F43F5E]' : 'bg-white/5 text-zinc-400'}`}>
                             {row.parentGuest.status === 'ingreso' ? `En evento` : row.parentGuest.status === 'nuevo' ? 'Nuevo' : row.parentGuest.status === 'por_invitar' ? 'Por invitar' : row.parentGuest.status.replace('_', ' ')}
                           </span>
                        )}
                      </div>
                    </div>
                    
                    {isExpanded && (
                      <div className="px-4 pb-4 pt-0 bg-transparent animate-in slide-in-from-top-2 fade-in duration-200">
                        <div className="flex gap-2 pt-3 border-t border-white/5 mt-1">
                          <button onClick={(e) => { e.stopPropagation(); handleSendWhatsApp(row.parentGuest); }} className={`flex-[1.5] py-2.5 rounded-xl text-[10px] uppercase tracking-widest font-black flex items-center justify-center transition-all ${row.parentGuest.sent ? 'bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30' : 'bg-white/5 text-zinc-300 hover:bg-white/10'}`}>
                            <MessageCircle size={14} className="mr-1.5"/> Enviar
                          </button>
                          <button onClick={(e) => { e.stopPropagation(); handleOpenEdit(row.parentGuest); }} className="flex-1 py-2.5 bg-white/5 text-zinc-300 hover:bg-white/10 rounded-xl text-[10px] uppercase tracking-widest font-black flex items-center justify-center transition-all">
                            <Edit2 size={14} className="mr-1.5"/> Editar
                          </button>
                          {row.isMain && (
                            <button onClick={(e) => { e.stopPropagation(); setDeleteModal(row.parentGuest); }} className="px-4 py-2.5 bg-rose-500/10 text-rose-500 rounded-xl flex items-center justify-center transition-all hover:bg-rose-500/20">
                              <Trash2 size={14}/>
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {/* 🟢 MODAL GESTOR DEL BANCO DE ETIQUETAS */}
      {isTagManagerOpen && (
        <div className="fixed inset-0 z-[250] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 flex justify-between items-center bg-[#141210]">
              <div>
                <h3 className="font-editorial font-black text-xl text-[#D4AF37]">Banco de Etiquetas</h3>
                <p className="text-[10px] uppercase tracking-widest text-slate-400 mt-1">Crea grupos para el acomodo inteligente.</p>
              </div>
              <button onClick={() => setIsTagManagerOpen(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            </div>
            <div className="p-6 space-y-5">
              <form onSubmit={handleCreateGlobalTag} className="flex gap-2">
                <input 
                  type="text" 
                  value={newTagInput} 
                  onChange={e => setNewTagInput(e.target.value)} 
                  placeholder="Ej. Amigos Novio, Primos, Universidad..." 
                  className="flex-1 p-3.5 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors"
                />
                <button type="submit" className="px-5 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest hover:bg-[#c5a028] transition-colors shrink-0 shadow-[0_5px_15px_rgba(212,175,55,0.2)]">
                  Agregar
                </button>
              </form>

              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">Etiquetas Activas ({globalTags.length})</label>
                {globalTags.length === 0 ? (
                  <div className="text-center p-6 border border-dashed border-white/10 rounded-2xl text-xs text-slate-500 bg-[#141210]">
                    Aún no has creado etiquetas. Escribe arriba para comenzar.
                  </div>
                ) : (
                  <div className="flex flex-wrap gap-2 max-h-60 overflow-y-auto custom-scrollbar p-1">
                    {globalTags.map(tag => (
                      <div key={tag} className="flex items-center gap-2 px-3 py-2 rounded-xl bg-[#141210] border border-[#D4AF37]/40 text-xs font-bold text-[#D4AF37] shadow-sm">
                        <span>#{tag}</span>
                        <button onClick={() => handleDeleteGlobalTag(tag)} className="text-[#D4AF37]/60 hover:text-rose-400 transition-colors"><X size={14}/></button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <button onClick={() => setIsTagManagerOpen(false)} className="w-full py-3.5 bg-white/5 border border-white/10 hover:bg-white/10 text-white rounded-xl font-black text-xs uppercase tracking-widest transition-colors">Listo</button>
            </div>
          </div>
        </div>
      )}

      {/* 🟢 MODAL NUEVO INVITADO CON CHIPS DE ETIQUETAS */}
      {addModal.open && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 transition-colors flex flex-col max-h-[90vh] text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 flex justify-between items-center bg-[#141210] transition-colors shrink-0"><h3 className="font-editorial font-black text-2xl text-[#D4AF37] tracking-wide">Nuevo Invitado</h3><button type="button" onClick={() => setAddModal({ open: false, side: 'general' })} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button></div>
            <form onSubmit={handleSaveGuest} className="p-6 overflow-y-auto custom-scrollbar space-y-5">
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Nombre del Titular o Familia</label><input type="text" required value={newGuest.name} onChange={e=>setNewGuest({...newGuest, name: e.target.value})} className="w-full p-3.5 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" /></div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Teléfono (WhatsApp)</label><input type="text" value={newGuest.phone} onChange={e=>setNewGuest({...newGuest, phone: e.target.value})} className="w-full p-3.5 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" placeholder="10 dígitos" /></div>
              {passCountEnabled && (
                <div className={`grid ${isPremium ? 'grid-cols-2' : 'grid-cols-1'} gap-4`}>
                  <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Pases {isPremium ? 'Adultos' : 'Totales'}</label><input type="number" min="1" required value={newGuest.adultPasses} onChange={e=>setNewGuest({...newGuest, adultPasses: e.target.value})} className="w-full p-3.5 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-[#D4AF37] font-black text-center transition-colors" /></div>
                  {isPremium && (
                    <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Pases Niños</label><input type="number" min="0" required value={newGuest.childrenPasses} onChange={e=>setNewGuest({...newGuest, childrenPasses: e.target.value})} className="w-full p-3.5 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-sky-400 font-black text-center transition-colors" /></div>
                  )}
                </div>
              )}

              {/* 🟢 SELECTOR DE ETIQUETAS (TOCAR PARA SELECCIONAR) */}
              {isPremium && (
                <div className="pt-2 border-t border-white/5">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Etiquetas de Afinidad (Toca para asignar)</label>
                  {globalTags.length > 0 ? (
                    <div className="flex flex-wrap gap-1.5 mb-2">
                      {globalTags.map(tag => {
                        const isSelected = (newGuest.tags || []).includes(tag);
                        return (
                          <button
                            type="button"
                            key={tag}
                            onClick={() => toggleNewGuestTag(tag)}
                            className={`px-3 py-1.5 rounded-xl text-xs font-bold transition-all border ${isSelected ? 'bg-[#D4AF37] text-[#1C1917] border-[#D4AF37] shadow-sm scale-[1.02]' : 'bg-[#141210] text-slate-400 border-white/10 hover:border-[#D4AF37]/50'}`}
                          >
                            #{tag}
                          </button>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="text-[11px] text-slate-400 italic mb-2">Crea tu primera etiqueta abajo (ej. Primos, Amigos, Trabajo):</p>
                  )}
                  {quickTagCreatorJSX}
                </div>
              )}

              <button type="submit" className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-6 shadow-[0_10px_25px_rgba(212,175,55,0.2)] hover:bg-[#c5a028] transition-colors">Guardar Invitado</button>
            </form>
          </div>
        </div>
      )}

      {/* 🟢 MODAL EDITAR FAMILIA + MICRO-ETIQUETADO POR INTEGRANTE */}
      {editModal.open && (
        <div className="fixed inset-0 z-[200] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-lg overflow-hidden shadow-2xl border border-transparent dark:border-white/10 animate-in zoom-in-95 duration-200 transition-colors flex flex-col max-h-[92vh]">
            <div className="px-6 py-5 border-b border-slate-100 dark:border-white/5 flex justify-between items-center bg-slate-50 dark:bg-white/5 transition-colors shrink-0"><h3 className="font-bold text-lg text-slate-900 dark:text-white tracking-wide">Editar Familia y Etiquetas</h3><button onClick={() => setEditModal({ open: false, guest: null })} className="text-slate-400 hover:text-slate-800 dark:hover:text-white"><X size={20}/></button></div>
            <form onSubmit={handleSaveEdit} className="p-6 space-y-5 overflow-y-auto custom-scrollbar flex-1">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Nombre Titular</label><input type="text" required value={editModal.guest.name} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, name: e.target.value }})} className="w-full p-3 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl text-sm outline-none focus:border-indigo-500 dark:focus:border-amber-500 text-slate-800 dark:text-white font-bold transition-colors" /></div>
                <div><label className="block text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Teléfono (WhatsApp)</label><input type="text" value={editModal.guest.phone || ''} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, phone: e.target.value }})} className="w-full p-3 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl text-sm outline-none focus:border-indigo-500 dark:focus:border-amber-500 text-slate-800 dark:text-white font-bold transition-colors" /></div>
       {/* 🟢 MODAL EDITAR FAMILIA + MICRO-ETIQUETADO POR INTEGRANTE */}
      {editModal.open && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-lg overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 transition-colors flex flex-col max-h-[92vh] text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 flex justify-between items-center bg-[#141210] transition-colors shrink-0"><h3 className="font-editorial font-black text-xl text-[#D4AF37] tracking-wide">Editar Familia y Etiquetas</h3><button type="button" onClick={() => setEditModal({ open: false, guest: null })} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button></div>
            <form onSubmit={handleSaveEdit} className="p-6 space-y-5 overflow-y-auto custom-scrollbar flex-1">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Nombre Titular</label><input type="text" required value={editModal.guest.name} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, name: e.target.value }})} className="w-full p-3 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" /></div>
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Teléfono (WhatsApp)</label><input type="text" value={editModal.guest.phone || ''} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, phone: e.target.value }})} className="w-full p-3 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" /></div>
              </div>

              <div className={`grid ${isPremium ? 'grid-cols-2' : 'grid-cols-1'} gap-4`}>
                {isPremium && (
                  <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Asignar Mesa</label>
                    <select value={editModal.guest.tableId || ''} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, tableId: e.target.value || null }})} className="w-full p-3 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors appearance-none">
                      <option value="">Sin Mesa</option>
                      {tables?.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                  </div>
                )}
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Estatus</label>
                  <select value={editModal.guest.status} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, status: e.target.value }})} className="w-full p-3 bg-[#141210] border border-white/10 rounded-xl text-sm outline-none focus:border-[#D4AF37] text-white font-bold transition-colors appearance-none">
                    <option value="por_invitar">Por Invitar</option><option value="pendiente">Pendiente</option><option value="confirmado">Confirmado</option><option value="cancelado">Canceló</option>
                  </select>
                </div>
              </div>

              {/* 🟢 ETIQUETAS DE TODA LA FAMILIA */}
              {isPremium && (
                <div className="pt-3 border-t border-white/5">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Etiqueta Familiar General (Aplica a todos)</label>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {globalTags.map(tag => {
                      const isSelected = (editModal.guest.tags || []).includes(tag);
                      return (
                        <button
                          type="button"
                          key={tag}
                          onClick={() => toggleEditGuestFamilyTag(tag)}
                          className={`px-3 py-1.5 rounded-xl text-xs font-bold transition-all border ${isSelected ? 'bg-[#D4AF37] text-[#1C1917] border-[#D4AF37] shadow-sm' : 'bg-[#141210] text-slate-400 border-white/10 hover:border-[#D4AF37]/50'}`}
                        >
                          #{tag}
                        </button>
                      );
                    })}
                  </div>
                  {quickTagCreatorJSX}
                </div>
              )}

              {/* 🟢 MICRO-ETIQUETADO POR INTEGRANTE INDIVIDUAL (IDEAL PARA SEPARAR PRIMOS EN FAMILIAS GRANDES) */}
              {isPremium && editModal.guest.subGuests && editModal.guest.subGuests.length > 1 && (
                <div className="pt-3 border-t border-white/5">
                  <div className="mb-3">
                    <label className="block text-[10px] font-bold text-[#D4AF37] uppercase tracking-widest">Integrantes Individuales ({editModal.guest.subGuests.length})</label>
                    <p className="text-[10px] text-slate-400 mt-0.5">Si etiquetas solo a algunos integrantes (ej. #Primos), el Modo Afinidad los separará automáticamente para sentarlos con su grupo.</p>
                  </div>
                  <div className="space-y-2.5 max-h-60 overflow-y-auto custom-scrollbar pr-1">
                    {editModal.guest.subGuests.map((sg, idx) => (
                      <div key={sg.id || idx} className="p-3 rounded-2xl bg-[#141210] border border-white/10 space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="text-[10px] font-black text-slate-500 w-5">#{idx + 1}</span>
                          <input 
                            type="text" 
                            value={sg.name || ''} 
                            placeholder={`Integrante ${idx + 1}`}
                            onChange={e => handleSubGuestEditChange(idx, 'name', e.target.value)}
                            className="flex-1 px-2.5 py-1.5 bg-[#1C1917] border border-white/10 rounded-lg text-xs font-bold text-white outline-none focus:border-[#D4AF37]"
                          />
                          <button
                            type="button"
                            onClick={() => handleSubGuestEditChange(idx, 'isChild', !sg.isChild)}
                            className={`px-2 py-1 rounded-lg text-[9px] font-black uppercase tracking-wider border transition-colors ${sg.isChild ? 'bg-sky-500/20 text-sky-400 border-sky-500/30' : 'bg-[#1C1917] text-slate-500 border-white/10'}`}
                          >
                            Niño
                          </button>
                        </div>
                        {globalTags.length > 0 && (
                          <div className="flex flex-wrap gap-1 pl-5">
                            {globalTags.map(tag => {
                              const hasTag = (sg.tags || []).includes(tag);
                              return (
                                <button
                                  type="button"
                                  key={tag}
                                  onClick={() => toggleSubGuestTag(idx, tag)}
                                  className={`px-2 py-0.5 rounded-md text-[9px] font-bold transition-all border ${hasTag ? 'bg-[#D4AF37] text-[#1C1917] border-[#D4AF37]' : 'bg-[#1C1917] text-slate-400 border-white/10 hover:border-[#D4AF37]/50'}`}
                                >
                                  #{tag}
                                </button>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <button type="submit" className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-4 shadow-[0_10px_25px_rgba(212,175,55,0.2)] hover:bg-[#c5a028] transition-colors">Guardar Cambios</button>
            </form>
          </div>
        </div>
      )}       </div>

              <div className={`grid ${isPremium ? 'grid-cols-2' : 'grid-cols-1'} gap-4`}>
                {isPremium && (
                  <div><label className="block text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Asignar Mesa</label>
                    <select value={editModal.guest.tableId || ''} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, tableId: e.target.value || null }})} className="w-full p-3 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl text-sm outline-none focus:border-indigo-500 dark:focus:border-amber-500 text-slate-800 dark:text-white font-bold transition-colors">
                      <option value="">Sin Mesa</option>
                      {tables?.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                    </select>
                  </div>
                )}
                <div><label className="block text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Estatus</label>
                  <select value={editModal.guest.status} onChange={e=>setEditModal({ ...editModal, guest: { ...editModal.guest, status: e.target.value }})} className="w-full p-3 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl text-sm outline-none focus:border-indigo-500 dark:focus:border-amber-500 text-slate-800 dark:text-white font-bold transition-colors">
                    <option value="por_invitar">Por Invitar</option><option value="pendiente">Pendiente</option><option value="confirmado">Confirmado</option><option value="cancelado">Canceló</option>
                  </select>
                </div>
              </div>

              {/* 🟢 ETIQUETAS DE TODA LA FAMILIA */}
              {isPremium && (
                <div className="pt-3 border-t border-slate-100 dark:border-white/5">
                  <label className="block text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Etiqueta Familiar General (Aplica a todos)</label>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {globalTags.map(tag => {
                      const isSelected = (editModal.guest.tags || []).includes(tag);
                      return (
                        <button
                          type="button"
                          key={tag}
                          onClick={() => toggleEditGuestFamilyTag(tag)}
                          className={`px-3 py-1.5 rounded-xl text-xs font-bold transition-all border ${isSelected ? 'bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 border-indigo-600 dark:border-amber-500 shadow-sm' : 'bg-slate-50 dark:bg-[#111] text-slate-600 dark:text-slate-400 border-slate-200 dark:border-white/10 hover:border-indigo-300'}`}
                        >
                          #{tag}
                        </button>
                      );
                    })}
                  </div>
                  {quickTagCreatorJSX}
                </div>
              )}

              {/* 🟢 MICRO-ETIQUETADO POR INTEGRANTE INDIVIDUAL (IDEAL PARA SEPARAR PRIMOS EN FAMILIAS GRANDES) */}
              {isPremium && editModal.guest.subGuests && editModal.guest.subGuests.length > 1 && (
                <div className="pt-3 border-t border-slate-100 dark:border-white/5">
                  <div className="mb-3">
                    <label className="block text-[10px] font-bold text-indigo-600 dark:text-amber-500 uppercase tracking-widest">Integrantes Individuales ({editModal.guest.subGuests.length})</label>
                    <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-0.5">Si etiquetas solo a algunos integrantes (ej. #Primos), el Modo Afinidad los separará automáticamente para sentarlos con su grupo.</p>
                  </div>
                  <div className="space-y-2.5 max-h-60 overflow-y-auto custom-scrollbar pr-1">
                    {editModal.guest.subGuests.map((sg, idx) => (
                      <div key={sg.id || idx} className="p-3 rounded-2xl bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 space-y-2">
                        <div className="flex items-center gap-2">
                          <span className="text-[10px] font-black text-slate-400 w-5">#{idx + 1}</span>
                          <input 
                            type="text" 
                            value={sg.name || ''} 
                            placeholder={`Integrante ${idx + 1}`}
                            onChange={e => handleSubGuestEditChange(idx, 'name', e.target.value)}
                            className="flex-1 px-2.5 py-1.5 bg-white dark:bg-[#050505] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold text-slate-800 dark:text-white outline-none"
                          />
                          <button
                            type="button"
                            onClick={() => handleSubGuestEditChange(idx, 'isChild', !sg.isChild)}
                            className={`px-2 py-1 rounded-lg text-[9px] font-black uppercase tracking-wider border transition-colors ${sg.isChild ? 'bg-sky-500 text-white border-sky-500' : 'bg-white dark:bg-[#050505] text-slate-400 border-slate-200 dark:border-white/10'}`}
                          >
                            Niño
                          </button>
                        </div>
                        {globalTags.length > 0 && (
                          <div className="flex flex-wrap gap-1 pl-5">
                            {globalTags.map(tag => {
                              const hasTag = (sg.tags || []).includes(tag);
                              return (
                                <button
                                  type="button"
                                  key={tag}
                                  onClick={() => toggleSubGuestTag(idx, tag)}
                                  className={`px-2 py-0.5 rounded-md text-[9px] font-bold transition-all border ${hasTag ? 'bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 border-indigo-600 dark:border-amber-500' : 'bg-white dark:bg-[#050505] text-slate-400 border-slate-200 dark:border-white/10'}`}
                                >
                                  #{tag}
                                </button>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <button type="submit" className="w-full py-4 bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 rounded-xl font-black text-xs uppercase tracking-widest mt-4 shadow-md dark:shadow-[0_0_15px_rgba(245,158,11,0.3)] hover:bg-indigo-700 dark:hover:bg-amber-400 transition-colors">Guardar Cambios</button>
            </form>
          </div>
        </div>
      )}

      {deleteModal && (
        <div className="fixed inset-0 z-[300] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-rose-500/20 animate-in zoom-in-95 duration-200 transition-colors text-center p-8">
            <div className="w-20 h-20 bg-rose-500/10 text-rose-500 border border-rose-500/20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
              <Trash2 size={32} />
            </div>
            <h3 className="font-editorial font-black text-2xl text-white mb-2">¿Eliminar Invitado?</h3>
            <p className="text-sm text-slate-400 mb-8 font-light leading-relaxed">
              Estás a punto de eliminar a <strong className="text-white">{deleteModal.name}</strong>. Sus pases y códigos QR quedarán invalidados. Esta acción no se puede deshacer.
            </p>
            <div className="flex gap-3">
              <button onClick={() => setDeleteModal(null)} className="flex-1 py-3.5 bg-white/5 text-slate-300 border border-white/10 rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-white/10 transition-colors">Cancelar</button>
              <button onClick={executeDeleteGuest} className="flex-1 py-3.5 bg-rose-500 text-white rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-rose-600 transition-colors shadow-[0_5px_15px_rgba(244,63,94,0.3)]">Sí, Eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* 🟢 LA MAGIA DE LA PORTADA DEL PASE (REDISEÑO PREMIUM MANUAL) */}
      {qrModal && (
        <div className="fixed inset-0 z-[400] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-300 flex flex-col relative max-h-[95vh]">
            
            <div className="px-6 py-4 border-b border-[#D4AF37]/20 flex justify-between items-center z-10 shrink-0 bg-[#141210]">
              <h3 className="font-editorial font-bold text-lg text-[#D4AF37] tracking-wide">Diseño del Pase</h3>
              
              <div className="flex gap-2 print:hidden items-center">
                 <div className="flex items-center gap-1">
                     <label className="cursor-pointer text-[#D4AF37] bg-[#D4AF37]/10 px-3 py-1.5 rounded-full hover:bg-[#D4AF37]/20 transition-colors text-[10px] font-bold uppercase tracking-widest flex items-center shadow-sm border border-[#D4AF37]/20" title="Subir Logo Manual">
                        {isUploadingLogo ? <RefreshCw size={14} className="animate-spin"/> : <><ImageIcon size={14} className="mr-1"/> Logo</>}
                        <input type="file" accept="image/*" className="hidden" onChange={handleLogoUpload}/>
                     </label>
                     {hasManualLogo && (
                       <button onClick={handleRemoveManualLogo} className="text-rose-400 bg-rose-500/10 p-1.5 rounded-full hover:bg-rose-500/20 transition-colors shadow-sm" title="Quitar logo manual"><Trash size={14}/></button>
                     )}
                 </div>

                 <label className="cursor-pointer text-[#D4AF37] bg-[#D4AF37]/10 px-3 py-1.5 rounded-full hover:bg-[#D4AF37]/20 transition-colors text-[10px] font-bold uppercase tracking-widest flex items-center shadow-sm border border-[#D4AF37]/20" title="Subir foto de fondo">
                    {isUploadingCover ? <RefreshCw size={14} className="animate-spin"/> : <><ImageIcon size={14} className="mr-1"/> Fondo</>}
                    <input type="file" accept="image/*" className="hidden" onChange={handleCoverUpload}/>
                 </label>
                 
                 {qrCover && <button onClick={handleRemoveCover} className="text-rose-400 bg-rose-500/10 p-1.5 rounded-full hover:bg-rose-500/20 transition-colors shadow-sm" title="Quitar portada"><Trash size={14}/></button>}
                 
                 <div className="w-px h-4 bg-white/20 mx-1"></div>
                 
                 <button onClick={() => setQrModal(null)} className="text-slate-400 hover:text-[#D4AF37] bg-white/5 p-1.5 rounded-full shadow-sm border border-white/10 transition-colors"><X size={16}/></button>
              </div>
            </div>
            
            <div className="overflow-y-auto custom-scrollbar bg-[#141210] p-4 sm:p-6 flex-1 flex justify-center items-center">
               <div id={`qr-container-${qrModal.pin}`} className="bg-white relative rounded-2xl overflow-hidden shadow-xl w-full max-w-[300px] mx-auto flex flex-col" style={{ aspectRatio: '9/16' }}>
                  
                  <div className="absolute inset-0 w-full h-[60%] bg-slate-50 flex items-center justify-center overflow-hidden">
                     {qrCover ? (
                        <img src={qrCover} alt="Portada" className="w-full h-full object-cover" crossOrigin="anonymous"/>
                     ) : (
                        <div className="text-slate-300 flex flex-col items-center">
                           <ImageIcon size={48} className="opacity-20 mb-2"/>
                           <span className="text-[10px] uppercase font-bold tracking-widest opacity-40 text-center">Fondo<br/>Transparente</span>
                        </div>
                     )}
                  </div>

                  <div className="absolute inset-0 w-full h-full pointer-events-none" style={{ background: 'linear-gradient(to bottom, transparent 20%, rgba(255,255,255,0.9) 45%, #ffffff 55%, #ffffff 100%)' }}></div>

                  <div className="relative z-10 flex flex-col h-full justify-end px-5 pb-6 items-center text-center">
                     
                     <div className="mb-2 h-12 flex items-center justify-center">
                        {!logoError && eventLogo && (
                          <img 
                             src={eventLogo} 
                             alt="Logo Evento" 
                             className="max-h-full max-w-[120px] object-contain drop-shadow-md" 
                             onError={() => setLogoError(true)}
                          />
                        )}
                     </div>

                     <h2 className="text-2xl font-editorial font-black text-slate-900 leading-normal mb-1 whitespace-normal break-words w-full px-2" style={{ paddingBottom: '2px' }}>
                        {qrModal.displayName}
                     </h2>

                     {isPremium && qrModal.parentGuest.tableId && (
                       <p className="text-[10px] font-bold text-slate-800 uppercase tracking-widest mb-3">
                         {tables?.find(t => String(t.id) === String(qrModal.parentGuest.tableId))?.name || qrModal.parentGuest.tableId}
                       </p>
                     )}
                     {(!isPremium || !qrModal.parentGuest.tableId) && <div className="h-3 mb-3"></div>}

                     <div className="bg-white p-2 rounded-xl shadow-[0_5px_15px_rgba(0,0,0,0.08)] border border-slate-200 mb-3">
                        <img 
                           src={`https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${qrModal.pin}&margin=1`} 
                           alt="QR" 
                           className="w-36 h-36 object-contain mix-blend-multiply"
                           crossOrigin="anonymous"
                        />
                     </div>

                     <p className="font-mono text-[9px] text-slate-700 tracking-widest bg-slate-100 py-1.5 px-3 rounded-lg border border-slate-200 mb-2">
                        PIN: <strong className="text-slate-900 font-bold break-all">{qrModal.pin}</strong>
                     </p>

                     <p className="text-[8px] uppercase tracking-[0.15em] text-slate-500 font-bold">Pase Personal • Intransferible</p>
                  </div>
               </div>
            </div>

            <div className="p-4 border-t border-[#D4AF37]/20 shrink-0 bg-[#1C1917]">
              <button 
                disabled={isPreparingQRPrint}
                onClick={async () => {
                  setIsPreparingQRPrint(true);
                  if(addNotification) addNotification('Preparando Pase', 'Renderizando en alta calidad...', 'info');
                  try {
                    const html2canvas = (await import('html2canvas')).default;
                    const container = document.getElementById(`qr-container-${qrModal.pin}`);
                    const canvas = await html2canvas(container, { scale: 3, useCORS: true, backgroundColor: '#ffffff', logging: false });
                    const imgData = canvas.toDataURL('image/jpeg', 1.0);
                    const link = document.createElement('a');
                    link.download = `Pase-${qrModal.displayName.replace(/\s+/g, '-')}.jpg`;
                    link.href = imgData;
                    link.click();
                    if(addNotification) addNotification('¡Listo!', 'El pase se descargó a tu equipo.', 'success');
                  } catch(e) {
                    console.error(e);
                    if(addNotification) addNotification('Error', 'Fallo al descargar.', 'error');
                  }
                  setIsPreparingQRPrint(false);
                }} 
                className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.2)] flex items-center justify-center disabled:opacity-50"
              >
                {isPreparingQRPrint ? <RefreshCw size={16} className="mr-2 animate-spin"/> : <Download size={16} className="mr-2"/>} Descargar Imagen
              </button>
            </div>

          </div>
        </div>
      )}

      {/* 🔴 MODALES DE GESTIÓN DE PASES EXTRA EN COLA (AUTO-POPUP) */}
      {currentRequest && !whatsappPromptModal && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl p-6 text-center border border-transparent dark:border-white/10">
            <div className="w-16 h-16 bg-amber-100 dark:bg-amber-500/20 text-amber-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
              <Users size={32} />
            </div>
            <h3 className="text-xl font-black text-slate-800 dark:text-white mb-2 font-editorial">Solicitud de Pases Extra</h3>
            <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
              La familia <b>{currentRequest.name}</b> está solicitando <b>+{currentRequest.extraRequested}</b> pases adicionales.<br/><br/>Si apruebas, su invitación se actualizará a modo pendiente y podrás avisarle por WhatsApp al instante.
            </p>
            <div className="flex space-x-3 mb-4">
              <button onClick={handleRechazarPases} className="flex-1 py-3.5 bg-slate-100 dark:bg-[#111] text-slate-600 dark:text-slate-300 border border-transparent dark:border-white/10 rounded-xl font-bold hover:bg-slate-200 dark:hover:bg-white/5 transition-colors text-[10px] uppercase tracking-widest">
                Rechazar
              </button>
              <button onClick={handleAprobarPases} className="flex-1 py-3.5 bg-amber-500 text-slate-900 rounded-xl font-black shadow-lg hover:bg-amber-400 transition-transform active:scale-95 text-[10px] uppercase tracking-widest">
                Aprobar Pases
              </button>
            </div>
            <button onClick={handleAtenderDespues} className="text-[10px] font-bold text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 uppercase tracking-widest transition-colors py-2">
              Atender después
            </button>
          </div>
        </div>
      )}

      {whatsappPromptModal && (() => {
        const rawPhone = whatsappPromptModal.phone || '';
        const phone = String(rawPhone).replace(/\D/g,'');
        const hasPhone = phone && phone.length >= 10;
        
        return (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl p-6 text-center border border-transparent dark:border-white/10">
            <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-500/20 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
              <MessageCircle size={32} />
            </div>
            <h3 className="text-xl font-black text-slate-800 dark:text-white mb-2 font-editorial">¡Pases Aprobados!</h3>
            
            {hasPhone ? (
              <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
                Se ha habilitado la invitación para <b>{whatsappPromptModal.name}</b>.<br/><br/>¿Deseas enviarle un mensaje por WhatsApp ahora mismo para avisarle que registre a sus acompañantes?
              </p>
            ) : (
              <div className="mb-6 p-3 bg-rose-50 dark:bg-rose-500/10 border border-rose-200 dark:border-rose-500/20 rounded-xl text-left">
                <p className="text-sm text-slate-600 dark:text-slate-300 mb-3 text-center">Se ha habilitado la invitación para <b>{whatsappPromptModal.name}</b>.</p>
                <div className="flex items-center justify-center">
                  <AlertTriangle size={14} className="mr-1.5 text-rose-500 shrink-0"/> 
                  <span className="text-[10px] font-bold text-rose-600 dark:text-rose-400 uppercase tracking-widest leading-tight">No tiene WhatsApp registrado en la lista</span>
                </div>
              </div>
            )}

            <div className="flex space-x-3">
              <button onClick={() => setWhatsappPromptModal(null)} className="flex-1 py-3.5 bg-slate-100 dark:bg-[#111] text-slate-600 dark:text-slate-300 border border-transparent dark:border-white/10 rounded-xl font-bold hover:bg-slate-200 dark:hover:bg-white/5 transition-colors text-[10px] uppercase tracking-widest">
                Cerrar
              </button>
              {hasPhone && (
                <button onClick={handleSendExtraPassWhatsApp} className="flex-1 py-3.5 bg-emerald-500 text-white rounded-xl font-black shadow-lg hover:bg-emerald-600 transition-transform active:scale-95 text-[10px] uppercase tracking-widest flex items-center justify-center">
                  Notificar por WhatsApp
                </button>
              )}
            </div>
          </div>
        </div>
        );
      })()}

      {/* FAB: BOTÓN FLOTANTE MÓVIL (PREMIUM BLANCO APERLADO) */}
      <div className="md:hidden fixed bottom-[72px] right-4 z-50 flex flex-col items-end gap-3">
        {isFabOpen && isWeddingMode && (
          <div className="flex flex-col gap-3 animate-in slide-in-from-bottom-5 fade-in duration-200 mb-1">
            <button onClick={() => { handleOpenAdd('novia'); setIsFabOpen(false); }} className="flex items-center gap-3 bg-[#121212] border border-white/10 text-[#F4F4F5] px-5 py-3.5 rounded-full shadow-2xl font-bold text-[10px] uppercase tracking-widest self-end hover:bg-white/5">
              Invitado Novia <UserPlus size={16} className="text-[#F43F5E]"/>
            </button>
            <button onClick={() => { handleOpenAdd('novio'); setIsFabOpen(false); }} className="flex items-center gap-3 bg-[#121212] border border-white/10 text-[#F4F4F5] px-5 py-3.5 rounded-full shadow-2xl font-bold text-[10px] uppercase tracking-widest self-end hover:bg-white/5">
              Invitado Novio <UserPlus size={16} className="text-sky-400"/>
            </button>
          </div>
        )}
        
        <button 
          onClick={() => {
            if (isWeddingMode) setIsFabOpen(!isFabOpen);
            else handleOpenAdd('general');
          }} 
          className="w-14 h-14 bg-[#F4F4F5] text-black border border-white/20 rounded-full flex items-center justify-center shadow-[0_4px_25px_rgba(255,255,255,0.15)] transition-transform active:scale-95"
        >
          {isFabOpen && isWeddingMode ? <X size={24} /> : <UserPlus size={24} />}
        </button>
      </div>

    </div>
  );
};

// ==========================================
// --- COMPONENTE: VISTA PREVIA INVITACIÓN EN EL PANEL ---
// ==========================================
const InvitacionView = ({ guests, urlInvitacion }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  // 🟢 UNIFICAR FAMILIAS DIVIDIDAS EN MESAS (Mantiene 1 sola invitación y su ID original corto)
  const unifiedGuests = React.useMemo(() => {
    const map = new Map();
    (guests || []).forEach(g => {
      const rootId = g.parentId || g.id;
      if (!map.has(rootId)) {
        const rootObj = (guests || []).find(rg => rg.id === rootId) || g;
        map.set(rootId, { ...rootObj, id: rootId, passes: g.passes || 0 });
      } else {
        const existing = map.get(rootId);
        existing.passes += (g.passes || 0);
      }
    });
    return Array.from(map.values());
  }, [guests]);

  const [selectedGuestId, setSelectedGuestId] = useState(unifiedGuests[0]?.id || null);
  const [isMobileSimulatorOpen, setIsMobileSimulatorOpen] = useState(false);

  const filteredGuests = unifiedGuests.filter(g => (g.name || '').toLowerCase().includes(searchTerm.toLowerCase()));
  const guest = unifiedGuests.find(g => g.id === selectedGuestId) || unifiedGuests[0];

  // 🔴 CONSTRUCCIÓN DE LA URL SEGURA PARA EL IFRAME
  let iframeUrl = '';
  if (urlInvitacion) {
    const separator = urlInvitacion.includes('?') ? '&' : '?';
    iframeUrl = `${urlInvitacion}${separator}u=${selectedGuestId || ''}&preview=1`;
  }

  // 🔴 REUTILIZAMOS EL SIMULADOR PARA ESCRITORIO Y MÓVIL
  const SimulatorContent = () => (
    <>
      {!urlInvitacion ? (
        <div className="w-full h-full flex flex-col items-center justify-center p-8 text-center bg-[#1C1917] rounded-3xl border border-[#D4AF37]/30 shadow-xl transition-colors text-white">
           <Link size={56} className="text-[#D4AF37] mb-6 opacity-80"/>
           <h3 className="text-2xl font-editorial font-black text-white mb-2">Falta el Enlace</h3>
           <p className="text-slate-400 text-sm leading-relaxed max-w-[250px]">No se ha guardado el enlace de la invitación web para este evento.</p>
           <div className="mt-8 border border-white/10 p-4 rounded-xl bg-[#141210] text-xs text-slate-400 text-left flex items-start transition-colors shadow-inner">
              <Info size={16} className="mr-2.5 shrink-0 mt-0.5 text-[#D4AF37]"/>
              <p>Ve a "Centro de Operaciones" y edita la licencia del cliente para agregar la URL.</p>
           </div>
        </div>
      ) : (
        <div className="w-full flex-1 bg-[#141210] rounded-3xl border border-[#D4AF37]/30 shadow-[0_25px_70px_rgba(0,0,0,0.9)] relative overflow-hidden transition-colors ring-4 ring-[#1C1917]">
           
           {/* 🔴 Badge de seguridad superior */}
           <div className="absolute top-0 inset-x-0 flex justify-center z-30 pointer-events-none">
              <span className="bg-rose-500/90 backdrop-blur text-white text-[9px] font-black uppercase tracking-widest py-1.5 px-5 rounded-b-xl shadow-[0_5px_15px_rgba(244,63,94,0.3)] flex items-center border-x border-b border-rose-600/50">
                 <Lock size={10} className="mr-1.5"/> Simulación Segura
              </span>
           </div>

           {guest ? (
              <iframe 
                 key={iframeUrl}
                 src={iframeUrl} 
                 className="absolute inset-0 w-full h-full border-none rounded-3xl z-10" 
                 title="Invitacion Simulada"
              ></iframe>
           ) : (
             <div className="w-full h-full flex flex-col items-center justify-center text-slate-500 transition-colors z-10 relative">
               <Users size={36} className="mb-4 text-[#D4AF37] opacity-40"/>
               <span className="text-[10px] font-bold uppercase tracking-widest text-[#D4AF37]/70">Selecciona un invitado</span>
             </div>
           )}
        </div>
      )}
    </>
  );

  return (
    <div className="h-full flex flex-col lg:flex-row gap-6 pb-6 relative overflow-hidden transition-colors items-stretch">
      
      {/* PANEL IZQUIERDO: LISTA DE INVITADOS */}
      <div className="flex-1 flex flex-col h-full min-h-0 bg-[#1C1917] rounded-3xl border border-[#D4AF37]/25 shadow-xl overflow-hidden transition-colors">
        <div className="p-5 border-b border-[#D4AF37]/20 bg-[#141210] transition-colors shrink-0">
          <h2 className="text-xl font-editorial font-black text-[#D4AF37] flex items-center tracking-wide"><Smartphone size={20} className="mr-2"/> Simulador en Vivo</h2>
          <p className="text-[10px] text-slate-400 uppercase tracking-widest mt-1">Selecciona un pase para probarlo en el diseño real.</p>
          <div className="mt-5 relative">
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" size={16} />
            <input type="text" placeholder="Buscar familia para simular..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} className="w-full pl-11 pr-4 py-3 bg-[#1C1917] border border-white/10 text-white rounded-xl text-xs outline-none focus:border-[#D4AF37] transition-colors font-bold placeholder-slate-500" />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-3 custom-scrollbar bg-transparent">
          {filteredGuests.length > 0 ? (
            <ul className="space-y-2 pb-12 lg:pb-0">
              {filteredGuests.map(g => (
                <li key={g.id}>
                  {/* 🔴 EN MÓVIL ABRIMOS EL MODAL, EN ESCRITORIO SOLO CAMBIAMOS EL ID */}
                  <button onClick={() => { setSelectedGuestId(g.id); setIsMobileSimulatorOpen(true); }} className={`w-full text-left p-4 rounded-2xl transition-all flex items-center justify-between shadow-sm border ${selectedGuestId === g.id ? 'bg-[#D4AF37]/15 border-[#D4AF37] shadow-[0_5px_15px_rgba(212,175,55,0.15)] scale-[1.01]' : 'bg-[#141210] border-white/10 hover:border-[#D4AF37]/50 hover:bg-[#D4AF37]/5'}`}>
                    <div className="min-w-0 pr-3">
                      <p className={`font-bold text-sm truncate ${selectedGuestId === g.id ? 'text-white' : 'text-slate-300'}`}>{g.name}</p>
                      <p className="text-[10px] text-slate-500 font-bold mt-1 truncate"><span className="text-[#D4AF37]">{g.originalPasses || g.passes}</span> Pases | <span className={`uppercase tracking-widest ${g.status === 'cancelado' ? 'text-rose-500' : g.status === 'confirmado' ? 'text-emerald-400' : 'text-slate-400'}`}>{g.status.replace('_', ' ')}</span></p>
                    </div>
                    <div className={`shrink-0 flex items-center justify-center w-10 h-10 rounded-full border transition-colors ${selectedGuestId === g.id ? 'bg-[#D4AF37] border-[#D4AF37] text-[#141210]' : 'bg-white/5 border-white/10 text-slate-400'}`}>
                      <Smartphone size={16}/>
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          ) : <div className="p-10 text-center text-slate-500 text-sm border border-dashed border-white/10 bg-white/5 rounded-2xl m-2 font-medium">No se encontraron invitados.</div>}
        </div>
      </div>

      {/* PANEL DERECHO: SIMULADOR ESCRITORIO */}
      <div className="hidden lg:flex w-[400px] flex-shrink-0 flex-col h-full">
        <SimulatorContent />
      </div>

      {/* 🔴 MODAL MÓVIL: SIMULADOR A PANTALLA COMPLETA */}
      {isMobileSimulatorOpen && (
        <div className="fixed inset-0 z-[9999] bg-black/90 backdrop-blur-md flex flex-col pt-10 sm:p-4 animate-in slide-in-from-bottom-full duration-300 lg:hidden">
          <div className="flex justify-between items-center bg-[#1C1917] rounded-t-3xl p-5 shrink-0 border-b border-[#D4AF37]/30 shadow-[0_10px_20px_rgba(0,0,0,0.5)] relative z-20">
            <div className="min-w-0 pr-4">
              <h3 className="font-bold text-sm text-white truncate">Viendo: {guest.name}</h3>
              <p className="text-[10px] text-[#D4AF37] font-bold uppercase tracking-widest mt-0.5">Modo Seguro Activado</p>
            </div>
            <button onClick={() => setIsMobileSimulatorOpen(false)} className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-slate-400 hover:text-[#D4AF37] shrink-0 shadow-sm border border-white/10 transition-colors"><X size={20}/></button>
          </div>
          <div className="flex-1 w-full bg-[#1C1917] relative overflow-hidden flex flex-col pb-4 px-3 pt-3">
             <SimulatorContent />
          </div>
        </div>
      )}

    </div>
  );
};

// ==========================================
// --- COMPONENTE: GESTIÓN DE MESAS (MOTOR DUAL: TETRIS + AFINIDAD) ---
// ==========================================
const MesasView = ({ tables, setTables, guests, setGuests, addNotification }) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [creationMode, setCreationMode] = useState('iguales'); 
  const [cantidadIguales, setCantidadIguales] = useState(1);
  const [mezclaVariedad, setMezclaVariedad] = useState([]);
  const [guestSeleccionado, setGuestSeleccionado] = useState(null);
  const [smartAssign, setSmartAssign] = useState(null);
  const [tableToEdit, setTableToEdit] = useState(null);
  const [guestSplitPrompt, setGuestSplitPrompt] = useState(null);
  const [modoSeparador, setModoSeparador] = useState(false);
  const [separarCantidad, setSepararCantidad] = useState(1);

  // 🟢 ESTADOS DE ETIQUETAS Y MOTOR DE AFINIDAD
  const [globalTags, setGlobalTags] = useState([]);
  const [tableTags, setTableTags] = useState([]);
  const [newTagInput, setNewTagInput] = useState('');
  const [autoAssignModal, setAutoAssignModal] = useState(false);
  const [assignMode, setAssignMode] = useState('afinidad'); // 'clasico' | 'afinidad'
  const [selectedAffinityTags, setSelectedAffinityTags] = useState([]);
  const lastAssignParams = useRef({ mode: 'clasico', tags: [] });

  const [configActual, setCurrentConfig] = useState({
    tipo: 'redonda', 
    capacidadRedonda: 10,
    capacidadPersonalizada: 10,
    ladosCuadrada: { top: 3, right: 3, bottom: 3, left: 3 }, 
    ladosTablon: { top: 5, bottom: 5, left: 1, right: 1 },
    ladosOvalada: { top: 4, bottom: 4, left: 2, right: 2 }, 
    modeloSerpentina: 'mod4',
    ladosSerpentina: { ext: 5, int: 2, izq: 1, der: 1 }, 
    uTablones: { izq: 2, centro: 1, der: 2 },
    uSillas: { extIzq: 10, intIzq: 5, extCentro: 5, intCentro: 0, extDer: 10, intDer: 5, cabeceras: 2 },
    libreMedidas: { largo: 2.0, ancho: 1.0 },
    ladosLibre: { top: 4, bottom: 4, left: 2, right: 2 }
  });

  // 🟢 ESCUCHA EL BANCO DE ETIQUETAS DE LA BÓVEDA
  useEffect(() => {
    if (typeof ID_DEL_EVENTO === 'undefined') return;
    const unsub = onSnapshot(doc(db, "eventos", ID_DEL_EVENTO), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        const tags = data.etiquetasGlobales || [];
        setGlobalTags(tags);
      }
    });
    return () => unsub();
  }, []);

  const handleCreateGlobalTag = async (e) => {
    if (e) e.preventDefault();
    const clean = newTagInput.trim();
    if (!clean) return;
    if (globalTags.some(t => t.toLowerCase() === clean.toLowerCase())) {
      setNewTagInput('');
      return;
    }
    const updated = [...globalTags, clean];
    setGlobalTags(updated);
    setTableTags(prev => [...prev, clean]);
    setNewTagInput('');
    try {
      await updateDoc(doc(db, "eventos", ID_DEL_EVENTO), { etiquetasGlobales: updated });
    } catch (err) { console.error(err); }
  };

  const toggleTableTag = (tag) => {
    setTableTags(prev => prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]);
  };

  // 🟢 REFERENCIAS FRESCAS PARA EVITAR STALE CLOSURES
  const guestsRef = useRef(guests || []);
  const tablesRef = useRef(tables || []);
  useEffect(() => {
      guestsRef.current = guests || [];
      tablesRef.current = tables || [];
  }, [guests, tables]);

  const safeTables = tables || [];
  const safeGuests = guests || [];
  const invitadosSinMesa = safeGuests.filter(g => !g.tableId && g.status !== 'cancelado');

  // Extraemos todas las etiquetas disponibles (del banco + las que tengan los invitados o mesas)
  const allAvailableTags = Array.from(new Set([
    ...globalTags,
    ...safeGuests.flatMap(g => [...(g.tags || []), ...(g.subGuests || []).flatMap(sg => sg.tags || [])]),
    ...safeTables.flatMap(t => t.tags || [])
  ]));

  const modelosSerpentina = {
    'mod1': { nombre: '1.58m x 0.75m', max: { ext: 3, int: 1, izq: 1, der: 1 } },
    'mod2': { nombre: '2.00m x 0.75m', max: { ext: 4, int: 1, izq: 1, der: 1 } },
    'mod3': { nombre: '2.10m x 0.75m', max: { ext: 4, int: 1, izq: 1, der: 1 } },
    'mod4': { nombre: '2.44m x 0.90m', max: { ext: 5, int: 2, izq: 1, der: 1 } }
  };

  const calcularCapacidad = (config) => {
    switch (config.tipo) {
      case 'redonda': return config.capacidadRedonda;
      case 'cuadrada': return config.ladosCuadrada.top + config.ladosCuadrada.right + config.ladosCuadrada.bottom + config.ladosCuadrada.left;
      case 'tablon': return config.ladosTablon.top + config.ladosTablon.bottom + config.ladosTablon.left + config.ladosTablon.right;
      case 'ovalada': return config.ladosOvalada.top + config.ladosOvalada.bottom + config.ladosOvalada.left + config.ladosOvalada.right;
      case 'serpentina': return config.ladosSerpentina.ext + config.ladosSerpentina.int + config.ladosSerpentina.izq + config.ladosSerpentina.der;
      case 'forma_u': return config.uSillas.extIzq + config.uSillas.intIzq + config.uSillas.extCentro + config.uSillas.intCentro + config.uSillas.extDer + config.uSillas.intDer + config.uSillas.cabeceras;
      case 'libre': return config.ladosLibre.top + config.ladosLibre.bottom + config.ladosLibre.left + config.ladosLibre.right;
      default: return 0;
    }
  };

  const handleConfigChange = (tipo, campo, valor, maxLimit) => {
    let num = parseInt(valor) || 0;
    if (num < 0) num = 0;
    if (maxLimit !== null && maxLimit !== undefined && num > maxLimit) num = maxLimit;

    if (tipo === 'general') setCurrentConfig({ ...configActual, [campo]: num });
    else if (tipo === 'medidas_libre') {
      let val = parseFloat(valor) || 0;
      if (val < 0.5) val = 0.5; 
      const newMedidas = { ...configActual.libreMedidas, [campo]: val };
      const maxLargo = Math.floor(newMedidas.largo / 0.5);
      const maxAncho = Math.floor(newMedidas.ancho / 0.5);
      const newLados = {
        top: Math.min(configActual.ladosLibre.top, maxLargo),
        bottom: Math.min(configActual.ladosLibre.bottom, maxLargo),
        left: Math.min(configActual.ladosLibre.left, maxAncho),
        right: Math.min(configActual.ladosLibre.right, maxAncho)
      };
      setCurrentConfig({ ...configActual, libreMedidas: newMedidas, ladosLibre: newLados });
    } 
    else if (tipo === 'serpentina_modelo') {
      const modLimits = modelosSerpentina[valor].max;
      setCurrentConfig({
        ...configActual, 
        modeloSerpentina: valor,
        ladosSerpentina: {
          ext: Math.min(configActual.ladosSerpentina.ext, modLimits.ext),
          int: Math.min(configActual.ladosSerpentina.int, modLimits.int),
          izq: Math.min(configActual.ladosSerpentina.izq, modLimits.izq),
          der: Math.min(configActual.ladosSerpentina.der, modLimits.der)
        }
      });
    }
    else setCurrentConfig({ ...configActual, [tipo]: { ...configActual[tipo], [campo]: num } });
  };

  const agregarAVariedad = (e) => {
    e.preventDefault();
    const capacidad = calcularCapacidad(configActual);
    if (capacidad === 0) {
      if(addNotification) addNotification('Error', 'La mesa debe tener al menos 1 silla.', 'warning');
      return;
    }
    setMezclaVariedad([...mezclaVariedad, { id: Date.now(), cantidad: cantidadIguales, tags: [...tableTags], config: { ...configActual, capacidadCalculada: capacidad } }]);
    setCantidadIguales(1);
    if(addNotification) addNotification('Agregada a la mezcla', `Paquete de ${cantidadIguales} mesa(s) añadido.`, 'success');
  };

  const eliminarDeVariedad = (id) => setMezclaVariedad(mezclaVariedad.filter(m => m.id !== id));

   const generarMesas = async () => {
      if (creationMode === 'edit' && tableToEdit) {
         const capacidad = calcularCapacidad(configActual);
         const assignedGuests = safeGuests.filter(g => g.tableId === tableToEdit.id);
         const usedChairs = assignedGuests.reduce((sum, g) => sum + g.passes, 0);
         if (capacidad < usedChairs) {
              if(addNotification) addNotification('Acción Denegada', `La mesa ya tiene ${usedChairs} personas asignadas. Libera invitados primero.`, 'warning');
              return;
         }
         await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", tableToEdit.id), { 
            ...tableToEdit, 
            capacity: capacidad, 
            tipo: configActual.tipo, 
            configDetalle: configActual,
            tags: tableTags 
         });
         setIsAddModalOpen(false);
         setTableToEdit(null);
         setTableTags([]);
         setCreationMode('iguales');
         if(addNotification) addNotification('Mesa Actualizada', 'Los cambios y etiquetas se guardaron con éxito.', 'success');
         return;
      }

      let nuevasMesas = [];
      let startIdx = safeTables.length + 1;

      if (creationMode === 'iguales') {
         const capacidad = calcularCapacidad(configActual);
         if (capacidad === 0) return;
         for (let i = 0; i < cantidadIguales; i++) {
            nuevasMesas.push({ id: `mesa_${Date.now()}_${i}`, name: `Mesa ${startIdx + i}`, capacity: capacidad, tipo: configActual.tipo, configDetalle: configActual, tags: tableTags });
         }
      } else if (creationMode === 'variedad') {
         if (mezclaVariedad.length === 0) return;
         mezclaVariedad.forEach(paquete => {
            for (let i = 0; i < paquete.cantidad; i++) {
               nuevasMesas.push({ id: `mesa_${Date.now()}_${Math.random()}`, name: `Mesa ${startIdx}`, capacity: paquete.config.capacidadCalculada, tipo: paquete.config.tipo, configDetalle: paquete.config, tags: paquete.tags || [] });
               startIdx++;
            }
         });
      }

      const promesas = nuevasMesas.map(mesa => setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", mesa.id), mesa));
      await Promise.all(promesas);

      setIsAddModalOpen(false);
      setMezclaVariedad([]);
      setTableTags([]);
      setCantidadIguales(1);
      if(addNotification) addNotification('Mesas Creadas', `Se agregaron ${nuevasMesas.length} mesas a la nube.`, 'success');
   };

   const isProcessingAutoAssign = useRef(false);

   // 🟢 PASO 1: ABRIR EL MODAL DEL MOTOR DUAL (O EJECUTAR DIRECTO SI NO HAY ETIQUETAS)
   const handleOpenAutoAssign = () => {
      const currentGuests = guestsRef.current || safeGuests;
      const unassigned = currentGuests.filter(g => !g.tableId && g.status !== 'cancelado');
      if (unassigned.length === 0) {
         if(addNotification) addNotification('Listo', 'Todos los invitados ya tienen mesa asignada.', 'info');
         return;
      }

      if (allAvailableTags.length > 0) {
         setSelectedAffinityTags(allAvailableTags);
         setAssignMode('afinidad');
         setAutoAssignModal(true);
      } else {
         iniciarProcesoAutoAcomodo('clasico', []);
      }
   };

   // 🟢 PASO 2: VERIFICAR SILLAS Y DISPARAR EL MOTOR ELEGIDO
   const iniciarProcesoAutoAcomodo = (mode = lastAssignParams.current.mode, activeTags = lastAssignParams.current.tags) => {
      if (isProcessingAutoAssign.current) return;
      isProcessingAutoAssign.current = true;
      setAutoAssignModal(false);
      lastAssignParams.current = { mode, tags: activeTags };

      const currentGuests = guestsRef.current || safeGuests;
      const currentTables = tablesRef.current || safeTables;

      if (!currentGuests || currentGuests.length === 0) {
         isProcessingAutoAssign.current = false;
         return;
      }
      const unassigned = currentGuests.filter(g => !g.tableId && g.status !== 'cancelado');
      if (unassigned.length === 0) {
         if(addNotification) addNotification('Listo', 'Todos los invitados ya tienen mesa asignada.', 'info');
         isProcessingAutoAssign.current = false;
         return;
      }
      const unassignedPasses = unassigned.reduce((sum, g) => sum + g.passes, 0);
      let availableChairs = 0;
      currentTables.forEach(t => {
         const assigned = currentGuests.filter(g => g.tableId === t.id);
         const used = assigned.reduce((sum, g) => sum + g.passes, 0);
         availableChairs += (t.capacity - used);
      });

      if (unassignedPasses > availableChairs) {
         setSmartAssign({ faltantes: unassignedPasses - availableChairs, invitadosPendientes: unassignedPasses });
         isProcessingAutoAssign.current = false;
         return;
      }

      if (mode === 'afinidad' && activeTags.length > 0) {
         ejecutarAsignacionAfinidad(currentTables, currentGuests, activeTags);
      } else {
         ejecutarAsignacionLogic(currentTables, currentGuests);
      }
   };

   // 🟢 MOTOR 2: ALGORITMO DE AFINIDAD + DESGARRE SILENCIOSO + IMÁN DE MESAS + TETRIS
   const ejecutarAsignacionAfinidad = async (mesasDisponibles, invitadosActuales, activeTags) => {
      let currentGuests = [...invitadosActuales];
      let preSplitWrites = [];

      // FASE A: DESGARRE SILENCIOSO (Si una familia sin mesa tiene solo algunos integrantes con una etiqueta activa, los separamos automáticamente)
      const unassignedInitial = currentGuests.filter(g => !g.tableId && g.status !== 'cancelado');

      for (let guest of unassignedInitial) {
         if (guest.passes > 1 && guest.subGuests && guest.subGuests.length > 1) {
            const subGroups = new Map();
            guest.subGuests.forEach(sg => {
               const sgTags = (sg.tags && sg.tags.length > 0) ? sg.tags : (guest.tags || []);
               const matchingTag = activeTags.find(at => sgTags.includes(at)) || '__REMAINDER__';
               if (!subGroups.has(matchingTag)) subGroups.set(matchingTag, []);
               subGroups.get(matchingTag).push(sg);
            });

            if (subGroups.size > 1) {
               const entries = Array.from(subGroups.entries());
               const [firstKey, firstSubs] = entries[0];
               const rootId = guest.parentId || guest.id;

               const updatedOriginal = {
                  ...guest,
                  passes: firstSubs.length,
                  childrenPasses: firstSubs.filter(s => s.isChild).length,
                  subGuests: firstSubs,
                  tags: firstKey === '__REMAINDER__' ? (guest.tags || []).filter(t => !activeTags.includes(t)) : [firstKey]
               };
               currentGuests = currentGuests.map(g => g.id === guest.id ? updatedOriginal : g);
               preSplitWrites.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), updatedOriginal));

               for (let idx = 1; idx < entries.length; idx++) {
                  const [tagKey, subs] = entries[idx];
                  const newId = `sep_aff_${Date.now()}_${Math.floor(Math.random()*10000)}_${idx}`;
                  const newFragment = {
                     ...guest,
                     id: newId,
                     parentId: rootId,
                     name: guest.name.replace(' (Separado)', ''),
                     passes: subs.length,
                     childrenPasses: subs.filter(s => s.isChild).length,
                     tableId: null,
                     subGuests: subs,
                     tags: tagKey === '__REMAINDER__' ? [] : [tagKey]
                  };
                  currentGuests.push(newFragment);
                  preSplitWrites.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", newId), newFragment));
               }
            }
         }
      }

      if (preSplitWrites.length > 0) {
         await Promise.all(preSplitWrites);
      }

      // Función auxiliar para obtener las etiquetas efectivas de un bloque
      const getEffectiveTags = (g) => {
         const set = new Set(g.tags || []);
         (g.subGuests || []).forEach(sg => (sg.tags || []).forEach(t => set.add(t)));
         return Array.from(set);
      };

      let promesas = [];
      let changesMade = false;

      // Función interna para sentar a un grupo en una mesa (o consolidar si ya hay un hermano ahí)
      const seatGuestInTable = (guest, targetTable) => {
         const familyRootId = guest.parentId || guest.id;
         const siblingFragment = currentGuests.find(g => g.id !== guest.id && (g.parentId === familyRootId || g.id === familyRootId) && g.tableId === targetTable.id);

         if (siblingFragment) {
            const mergedPasses = siblingFragment.passes + guest.passes;
            const mergedSubGuests = [...(siblingFragment.subGuests || []), ...(guest.subGuests || [])];
            const updatedSibling = { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests };
            promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), updatedSibling));
            promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id)));
            currentGuests = currentGuests.filter(g => g.id !== guest.id).map(g => g.id === siblingFragment.id ? updatedSibling : g);
         } else {
            const updatedGuest = { ...guest, tableId: targetTable.id };
            promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), updatedGuest));
            currentGuests = currentGuests.map(g => g.id === guest.id ? updatedGuest : g);
         }
         changesMade = true;
      };

      // FASE B: AGRUPACIÓN POR CADA ETIQUETA SELECCIONADA (Priorizando Mesas con Imán de Etiqueta)
      for (let tag of activeTags) {
         let tagGuests = currentGuests
            .filter(g => !g.tableId && g.status !== 'cancelado' && getEffectiveTags(g).includes(tag))
            .sort((a, b) => b.passes - a.passes);

         for (let guest of tagGuests) {
            // Verificamos que siga sin mesa
            const freshGuest = currentGuests.find(g => g.id === guest.id);
            if (!freshGuest || freshGuest.tableId) continue;

            let tablesWithSpace = mesasDisponibles.map(table => {
               const assigned = currentGuests.filter(g => g.tableId === table.id);
               const used = assigned.reduce((sum, g) => sum + g.passes, 0);
               const hasTableTag = (table.tags || []).includes(tag);
               const hasSameTagCompanions = assigned.some(ag => getEffectiveTags(ag).includes(tag));
               const isEmpty = used === 0;
               return { table, available: table.capacity - used, hasTableTag, hasSameTagCompanions, isEmpty };
            }).filter(t => t.available > 0);

            if (tablesWithSpace.length === 0) continue;

            // Prioridad 1: Mesas etiquetadas explícitamente con este Tag
            // Prioridad 2: Mesas neutrales donde ya sentamos a otros con este mismo Tag
            // Prioridad 3: Mesas neutrales totalmente vacías
            // Prioridad 4: Cualquier mesa neutral con espacio
            const getPriority = (tObj) => {
               if (tObj.hasTableTag) return 1;
               const hasOtherTableTags = (tObj.table.tags || []).length > 0;
               if (!hasOtherTableTags && tObj.hasSameTagCompanions) return 2;
               if (!hasOtherTableTags && tObj.isEmpty) return 3;
               if (!hasOtherTableTags) return 4;
               return 5;
            };

            const fullFitTables = tablesWithSpace.filter(t => t.available >= freshGuest.passes);
            if (fullFitTables.length > 0) {
               fullFitTables.sort((a, b) => {
                  const pA = getPriority(a);
                  const pB = getPriority(b);
                  if (pA !== pB) return pA - pB;
                  return a.available - b.available;
               });
               seatGuestInTable(freshGuest, fullFitTables[0].table);
            } else {
               // Si no cabe entero en ninguna mesa, pausamos y preguntamos al cliente cómo dividirlo
               tablesWithSpace.sort((a, b) => {
                  const pA = getPriority(a);
                  const pB = getPriority(b);
                  if (pA !== pB) return pA - pB;
                  return b.available - a.available;
               });
               const bestPartial = tablesWithSpace[0];
               const maxPlaceable = Math.min(freshGuest.passes - 1, bestPartial.available);
               const familyRootId = freshGuest.parentId || freshGuest.id;
               const siblingFragment = currentGuests.find(g => g.id !== freshGuest.id && (g.parentId === familyRootId || g.id === familyRootId) && g.tableId === bestPartial.table.id);

               if (promesas.length > 0) await Promise.all(promesas);

               setSepararCantidad(maxPlaceable);
               setGuestSplitPrompt({
                  guest: freshGuest,
                  targetTableId: bestPartial.table.id,
                  table: bestPartial.table,
                  usedChairs: bestPartial.table.capacity - bestPartial.available,
                  availableChairs: bestPartial.available,
                  minPlaceable: 1,
                  maxPlaceable,
                  isForced: true,
                  siblingFragment,
                  isAutoAssign: true
               });
               isProcessingAutoAssign.current = false;
               return;
            }
         }
      }

      if (promesas.length > 0) {
         await Promise.all(promesas);
      }

      // FASE C: RELLENO TETRIS PARA EL RESTO DE INVITADOS SIN ETIQUETA ACTIVA
      await ejecutarAsignacionLogic(mesasDisponibles, currentGuests, changesMade);
   };

   // 🟢 MOTOR 1: ALGORITMO CLÁSICO (EL TETRIS PERFECTO)
   const ejecutarAsignacionLogic = async (mesasDisponibles, invitadosActuales, priorChanges = false) => {
      let currentGuests = [...invitadosActuales];
      let changesMade = priorChanges;
      let promesas = [];

      const unassignedGuests = currentGuests
         .filter(g => !g.tableId && g.status !== 'cancelado')
         .sort((a, b) => b.passes - a.passes);

      for (let guest of unassignedGuests) {
         let tablesWithSpace = mesasDisponibles.map(table => {
            const assignedGuests = currentGuests.filter(g => g.tableId === table.id);
            const usedChairs = assignedGuests.reduce((sum, g) => sum + g.passes, 0);
            return { table, available: table.capacity - usedChairs };
         }).filter(t => t.available > 0);

         if (tablesWithSpace.length === 0) continue; 

         const fullFitTables = tablesWithSpace.filter(t => t.available >= guest.passes);
         
         if (fullFitTables.length > 0) {
            fullFitTables.sort((a, b) => a.available - b.available);
            const bestTable = fullFitTables[0].table;
            
            const familyRootId = guest.parentId || guest.id;
            const siblingFragment = currentGuests.find(g => g.id !== guest.id && (g.parentId === familyRootId || g.id === familyRootId) && g.tableId === bestTable.id);

            if (siblingFragment) {
                const mergedPasses = siblingFragment.passes + guest.passes;
                const mergedSubGuests = [...(siblingFragment.subGuests || []), ...(guest.subGuests || [])];
                const updatedSibling = { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests };
                promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), updatedSibling));
                promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id)));
                currentGuests = currentGuests.filter(g => g.id !== guest.id).map(g => g.id === siblingFragment.id ? updatedSibling : g);
            } else {
                const updatedGuest = { ...guest, tableId: bestTable.id };
                promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), updatedGuest));
                currentGuests = currentGuests.map(g => g.id === guest.id ? updatedGuest : g);
            }
            
            changesMade = true;
         } else {
            tablesWithSpace.sort((a, b) => b.available - a.available);
            const bestPartialTable = tablesWithSpace[0].table;
            const availableChairs = tablesWithSpace[0].available;
            const maxPlaceable = Math.min(guest.passes - 1, availableChairs);

            const familyRootId = guest.parentId || guest.id;
            const siblingFragment = currentGuests.find(g => g.id !== guest.id && (g.parentId === familyRootId || g.id === familyRootId) && g.tableId === bestPartialTable.id);

            if (promesas.length > 0) await Promise.all(promesas);
            
            setSepararCantidad(maxPlaceable); 
            setGuestSplitPrompt({
               guest, 
               targetTableId: bestPartialTable.id, 
               table: bestPartialTable, 
               usedChairs: bestPartialTable.capacity - availableChairs,
               availableChairs,
               minPlaceable: 1,
               maxPlaceable,
               isForced: true,
               siblingFragment,
               isAutoAssign: true
            });
            isProcessingAutoAssign.current = false;
            return;
         }
      }

      if (promesas.length > 0) {
         await Promise.all(promesas);
         if(addNotification) addNotification('Auto-Acomodo Inteligente', 'Acomodo automático completado con éxito.', 'success');
      } else if (changesMade) {
         if(addNotification) addNotification('Auto-Acomodo Inteligente', 'Grupos acomodados por afinidad.', 'success');
      } else {
         if(addNotification) addNotification('Sin Cambios', 'No se pudieron asignar más invitados.', 'info');
      }
      isProcessingAutoAssign.current = false;
   };

   const generarYAsignarMagico = async (opcion) => {
      let mesasNuevas = [];
      let startIdx = safeTables.length + 1;
      let sillasGeneradas = 0;

      const baseConfig = {  
         'redondas': { cap: 10, tipo: 'redonda', config: { tipo: 'redonda', capacidadRedonda: 10 } },
         'cuadradas': { cap: 12, tipo: 'cuadrada', config: { tipo: 'cuadrada', ladosCuadrada: { top: 3, right: 3, bottom: 3, left: 3 } } },
         'tablones': { cap: 12, tipo: 'tablon', config: { tipo: 'tablon', ladosTablon: { top: 5, bottom: 5, left: 1, right: 1 } } },
         'ovaladas': { cap: 14, tipo: 'ovalada', config: { tipo: 'ovalada', ladosOvalada: { top: 4, bottom: 4, left: 3, right: 3 } } },
         'serpentinas': { cap: 9, tipo: 'serpentina', config: { tipo: 'serpentina', modeloSerpentina: 'mod4', ladosSerpentina: { ext: 5, int: 2, izq: 1, der: 1 } } }
      };

      while (sillasGeneradas < smartAssign.faltantes) {
         let cfg;
         if (opcion === 'mixto') {
            cfg = (startIdx % 2 === 0) ? baseConfig['redondas'] : baseConfig['tablones'];
         } else {
            cfg = baseConfig[opcion];
         }
         mesasNuevas.push({ id: `mesa_smart_${Date.now()}_${startIdx}`, name: `Mesa ${startIdx}`, capacity: cfg.cap, tipo: cfg.tipo, configDetalle: cfg.config, tags: [] });
         sillasGeneradas += cfg.cap;
         startIdx++;
      }

      await Promise.all(mesasNuevas.map(m => setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", m.id), m)));
      setSmartAssign(null);
      if(addNotification) addNotification('¡Magia Aplicada!', `Se generaron mesas mágicas en la nube.`, 'success');
      setTimeout(() => { iniciarProcesoAutoAcomodo(); }, 800);
   };

   const consolidateToNull = async (guestsList) => {
       const currentGuests = guestsRef.current || safeGuests;
       const affectedRootIds = new Set(guestsList.map(g => g.parentId || g.id));
       const movingIds = new Set(guestsList.map(g => g.id));
       const promesas = [];

       affectedRootIds.forEach(rootId => {
           const familyDocs = currentGuests.filter(g => (g.parentId || g.id) === rootId);
           const toConsolidate = familyDocs.filter(g => !g.tableId || movingIds.has(g.id));

           if (toConsolidate.length > 0) {
               const baseDoc = familyDocs.find(g => g.id === rootId) || toConsolidate[0];
               const totalPasses = toConsolidate.reduce((sum, g) => sum + (g.passes || 0), 0);
               const mergedSubs = toConsolidate.flatMap(g => g.subGuests || []);
               const mergedTags = Array.from(new Set([
                   ...(baseDoc.tags || []),
                   ...mergedSubs.flatMap(sg => sg.tags || [])
               ]));

               const survivingId = (!baseDoc.tableId || movingIds.has(baseDoc.id)) ? rootId : toConsolidate[0].id;
               const unifiedDoc = {
                   ...baseDoc,
                   id: survivingId,
                   parentId: survivingId === rootId ? null : rootId,
                   tableId: null,
                   passes: totalPasses,
                   childrenPasses: mergedSubs.filter(s => s.isChild).length,
                   subGuests: mergedSubs,
                   tags: mergedTags
               };

               promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", survivingId), unifiedDoc));
               toConsolidate.forEach(g => {
                   if (g.id !== survivingId) {
                       promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", g.id)));
                   }
               });
           }
       });

       await Promise.all(promesas);
   };

   const emptyTable = async (tableId) => {
      const currentGuests = guestsRef.current || safeGuests;
      const guestsToUpdate = currentGuests.filter(g => g.tableId === tableId);
      await consolidateToNull(guestsToUpdate);
      if(addNotification) addNotification('Mesa Vaciada', 'Invitados consolidados y liberados.', 'info');
   };

   const deleteTable = async (tableId) => {
      await emptyTable(tableId);
      await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", tableId));
      if(addNotification) addNotification('Mesa Eliminada', 'La mesa ha sido borrada.', 'warning');
   };

   const emptyAllTables = async () => {
      const currentGuests = guestsRef.current || safeGuests;
      const guestsToUpdate = currentGuests.filter(g => g.tableId !== null);
      await consolidateToNull(guestsToUpdate);
      if(addNotification) addNotification('Todas las mesas vaciadas', 'Invitados consolidados.', 'info');
   };

   const deleteAllTables = async () => {
      await emptyAllTables();
      const promesas = safeTables.map(t => deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", t.id)));
      await Promise.all(promesas);
      if(addNotification) addNotification('Mesas Eliminadas', 'Se borraron todas las mesas de la base de datos.', 'warning');
   };

   const handleDragStart = (e, guestId) => { e.dataTransfer.setData('guestId', guestId); setGuestSeleccionado(null); };
   const handleDrop = (e, targetTableId) => { e.preventDefault(); moverInvitado(e.dataTransfer.getData('guestId'), targetTableId); };
   const handleDragOver = (e) => e.preventDefault();

   const moverInvitado = async (guestId, targetTableId) => {
      const currentGuests = guestsRef.current || safeGuests;
      const currentTables = tablesRef.current || safeTables;

      const guest = currentGuests.find(g => g.id === guestId);
      if (!guest || guest.tableId === targetTableId) return;

      const isToTable = targetTableId !== null;
      let table = null;
      let usedChairs = 0;
        
      if (isToTable) {
           table = currentTables.find(t => t.id === targetTableId);
           usedChairs = currentGuests.filter(g => g.tableId === targetTableId).reduce((sum, g) => sum + g.passes, 0);
      }

      const availableChairs = isToTable ? table.capacity - usedChairs : Infinity;
      const isForcedSplit = isToTable && guest.passes > availableChairs;

      if (isToTable && availableChairs <= 0) {
          if(addNotification) addNotification('Mesa Llena', `No hay sillas disponibles en ${table.name}.`, 'warning');
          return;
      }

      const familyRootId = guest.parentId || guest.id;
      const siblingFragment = currentGuests.find(g => 
          g.id !== guest.id && 
          (g.parentId === familyRootId || g.id === familyRootId) && 
          (isToTable ? g.tableId === targetTableId : !g.tableId)
      );

      if (guest.passes > 1 && (isForcedSplit || modoSeparador)) {
          const maxPlaceable = Math.min(guest.passes - 1, availableChairs);
          setSepararCantidad(maxPlaceable);
          setGuestSplitPrompt({
              guest, targetTableId, table, usedChairs, availableChairs,
              minPlaceable: 1, maxPlaceable, isForced: isForcedSplit, siblingFragment,
              isAutoAssign: false
          });
          return;
      }

      if (siblingFragment) {
          const mergedPasses = siblingFragment.passes + guest.passes;
          const mergedSubGuests = [...(siblingFragment.subGuests || []), ...(guest.subGuests || [])];
          await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), { 
              ...siblingFragment, 
              passes: mergedPasses, 
              subGuests: mergedSubGuests 
          });
          await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id));
          if(addNotification) addNotification('Familias Unidas', `Familia reunida con éxito.`, 'success');
          return;
      }

      await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guestId), { ...guest, tableId: targetTableId });
   };

   const handleSplitChoice = async (mode) => {
         if (!guestSplitPrompt) return;
         const promptData = { ...guestSplitPrompt };
         setGuestSplitPrompt(null);

         const { guest, targetTableId, siblingFragment, isAutoAssign } = promptData;
          
         if (mode === 'all') {
               if (siblingFragment) {
                   const mergedPasses = siblingFragment.passes + guest.passes;
                   const mergedSubGuests = [...(siblingFragment.subGuests || []), ...(guest.subGuests || [])];
                   await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests });
                   await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id));
               } else {
                   await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), { ...guest, tableId: targetTableId });
               }
               
               if (isAutoAssign) setTimeout(() => iniciarProcesoAutoAcomodo(), 800);
         } else if (mode === 'split') {
               const qtyToMove = separarCantidad;
               const qtyRemaining = guest.passes - qtyToMove;
               
               const subGuestsOriginal = guest.subGuests || [];
               const subGuestsToMove = subGuestsOriginal.slice(0, qtyToMove);
               const subGuestsToKeep = subGuestsOriginal.slice(qtyToMove);

               if (siblingFragment) {
                   const mergedPasses = siblingFragment.passes + qtyToMove;
                   const mergedSubGuests = [...(siblingFragment.subGuests || []), ...subGuestsToMove];
                   await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests });
                   await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), { ...guest, passes: qtyRemaining, subGuests: subGuestsToKeep });
               } else {
                   const newGuestId = `sep_${Date.now()}`;
                   const newGuest = { 
                       ...guest, 
                       id: newGuestId, 
                       parentId: guest.parentId || guest.id,
                       name: guest.name.replace(' (Separado)', ''), 
                       passes: qtyToMove, 
                       childrenPasses: 0, 
                       tableId: targetTableId,
                       subGuests: subGuestsToMove
                   };
                   await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), { ...guest, passes: qtyRemaining, subGuests: subGuestsToKeep });
                   await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", newGuestId), newGuest);
               }
               
               if (isAutoAssign) setTimeout(() => iniciarProcesoAutoAcomodo(), 800);
         }
   };

  const handleGuestClick = (guest) => {
    if (guestSeleccionado?.id === guest.id) setGuestSeleccionado(null);
    else setGuestSeleccionado(guest);
  };

  const handleTableClick = (tableId) => { if (guestSeleccionado) moverInvitado(guestSeleccionado.id, tableId); };

  const getTipoIcon = (tipo) => {
    switch(tipo) {
      case 'redonda': return <Circle size={16} className="text-rose-500"/>;
      case 'cuadrada': return <Square size={16} className="text-sky-500"/>;
      case 'tablon': return <RectangleHorizontal size={16} className="text-amber-500"/>;
      case 'ovalada': return <div className="w-5 h-3 rounded-[50%] border-2 border-indigo-500"></div>;
      case 'serpentina': return <Spline size={16} className="text-teal-500"/>;
      case 'forma_u': return <Magnet size={16} className="text-purple-500 rotate-180"/>;
      case 'libre': return <Settings2 size={16} className="text-slate-500 dark:text-slate-400"/>;
      default: return <Settings2 size={16} className="text-slate-500 dark:text-slate-400"/>;
    }
  };

  const renderConfigForm = () => {
    switch (configActual.tipo) {
      case 'redonda':
        return (
          <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 mb-4 animate-in fade-in transition-colors">
            <label className="block text-xs font-bold mb-3 text-slate-400">Sillas por Mesa Redonda (Máx. 10)</label>
            <input type="number" min="1" max="10" value={configActual.capacidadRedonda} onChange={(e) => handleConfigChange('general', 'capacidadRedonda', e.target.value, 10)} className="w-full p-3 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white shadow-sm font-bold transition-colors" />
          </div>
        );
      case 'cuadrada':
        return (
          <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 mb-4 animate-in fade-in transition-colors">
            <label className="block text-xs font-bold mb-4 text-slate-400 border-b border-white/10 pb-3">Distribución de Sillas (Máx. 3 por lado)</label>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Arriba</label><input type="number" min="0" max="3" value={configActual.ladosCuadrada.top} onChange={(e) => handleConfigChange('ladosCuadrada', 'top', e.target.value, 3)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Abajo</label><input type="number" min="0" max="3" value={configActual.ladosCuadrada.bottom} onChange={(e) => handleConfigChange('ladosCuadrada', 'bottom', e.target.value, 3)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Izquierdo</label><input type="number" min="0" max="3" value={configActual.ladosCuadrada.left} onChange={(e) => handleConfigChange('ladosCuadrada', 'left', e.target.value, 3)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Derecho</label><input type="number" min="0" max="3" value={configActual.ladosCuadrada.right} onChange={(e) => handleConfigChange('ladosCuadrada', 'right', e.target.value, 3)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
            </div>
          </div>
        );
      case 'tablon':
        return (
          <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 mb-4 animate-in fade-in transition-colors">
            <label className="block text-xs font-bold mb-4 text-slate-400 border-b border-white/10 pb-3">Distribución de Sillas (Tablón)</label>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Largo 1</label><input type="number" min="0" max="5" value={configActual.ladosTablon.top} onChange={(e) => handleConfigChange('ladosTablon', 'top', e.target.value, 5)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Largo 2</label><input type="number" min="0" max="5" value={configActual.ladosTablon.bottom} onChange={(e) => handleConfigChange('ladosTablon', 'bottom', e.target.value, 5)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Cabecera 1</label><input type="number" min="0" max="1" value={configActual.ladosTablon.left} onChange={(e) => handleConfigChange('ladosTablon', 'left', e.target.value, 1)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Cabecera 2</label><input type="number" min="0" max="1" value={configActual.ladosTablon.right} onChange={(e) => handleConfigChange('ladosTablon', 'right', e.target.value, 1)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
            </div>
          </div>
        );
      case 'ovalada':
        return (
          <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 mb-4 animate-in fade-in transition-colors">
            <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/20 p-3 rounded-xl mb-4 text-[10px] text-[#D4AF37] flex items-start transition-colors">
              <Info size={14} className="mr-2 flex-shrink-0 mt-0.5"/>
              <span>Mesa de 3.05m x 1.22m (Capacidad máxima: 14).</span>
            </div>
            <label className="block text-xs font-bold mb-4 text-slate-400 border-b border-white/10 pb-3">Distribución (Ovalada)</label>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Recto 1</label><input type="number" min="0" max="4" value={configActual.ladosOvalada.top} onChange={(e) => handleConfigChange('ladosOvalada', 'top', e.target.value, 4)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Recto 2</label><input type="number" min="0" max="4" value={configActual.ladosOvalada.bottom} onChange={(e) => handleConfigChange('ladosOvalada', 'bottom', e.target.value, 4)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Curva Izq.</label><input type="number" min="0" max="3" value={configActual.ladosOvalada.left} onChange={(e) => handleConfigChange('ladosOvalada', 'left', e.target.value, 3)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Curva Der.</label><input type="number" min="0" max="3" value={configActual.ladosOvalada.right} onChange={(e) => handleConfigChange('ladosOvalada', 'right', e.target.value, 3)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
            </div>
          </div>
        );
      case 'serpentina':
        const maxS = modelosSerpentina[configActual.modeloSerpentina].max;
        return (
          <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 mb-4 animate-in fade-in transition-colors">
            <label className="block text-xs font-bold mb-2 text-slate-400">Modelo de Serpentina (1/4 Círculo)</label>
            <select value={configActual.modeloSerpentina} onChange={(e) => handleConfigChange('serpentina_modelo', null, e.target.value)} className="w-full p-3 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] shadow-sm font-bold text-sm mb-5 text-[#D4AF37] transition-colors appearance-none">
              {Object.entries(modelosSerpentina).map(([key, val]) => (
                <option key={key} value={key}>{val.nombre} (Máx. {val.max.ext + val.max.int + val.max.izq + val.max.der} sillas)</option>
              ))}
            </select>

            <label className="block text-xs font-bold mb-4 text-slate-400 border-b border-white/10 pb-3">Distribución de Sillas</label>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Arco Exterior (Máx. {maxS.ext})</label><input type="number" min="0" max={maxS.ext} value={configActual.ladosSerpentina.ext} onChange={(e) => handleConfigChange('ladosSerpentina', 'ext', e.target.value, maxS.ext)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Arco Interior (Máx. {maxS.int})</label><input type="number" min="0" max={maxS.int} value={configActual.ladosSerpentina.int} onChange={(e) => handleConfigChange('ladosSerpentina', 'int', e.target.value, maxS.int)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Ancho Izq. (Máx. {maxS.izq})</label><input type="number" min="0" max={maxS.izq} value={configActual.ladosSerpentina.izq} onChange={(e) => handleConfigChange('ladosSerpentina', 'izq', e.target.value, maxS.izq)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Ancho Der. (Máx. {maxS.der})</label><input type="number" min="0" max={maxS.der} value={configActual.ladosSerpentina.der} onChange={(e) => handleConfigChange('ladosSerpentina', 'der', e.target.value, maxS.der)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
            </div>
          </div>
        );
      case 'libre':
        const largoVal = configActual.libreMedidas?.largo || 2.0;
        const anchoVal = configActual.libreMedidas?.ancho || 1.0;
        const maxLargo = Math.floor(largoVal / 0.5);
        const maxAncho = Math.floor(anchoVal / 0.5);
        
        const lTop = configActual.ladosLibre?.top || 0;
        const lBot = configActual.ladosLibre?.bottom || 0;
        const lLeft = configActual.ladosLibre?.left || 0;
        const lRight = configActual.ladosLibre?.right || 0;

        return (
          <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 mb-4 animate-in fade-in transition-colors">
            <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/20 p-3 rounded-xl mb-5 text-[10px] text-[#D4AF37] flex items-start transition-colors">
              <Info size={14} className="mr-2 flex-shrink-0 mt-0.5"/>
              <span><b>Regla estricta:</b> Cada silla requiere mínimo <b>0.5 metros lineales</b>. Ajusta las dimensiones de la mesa y el sistema calculará el límite físico.</span>
            </div>

            <label className="block text-xs font-bold mb-4 text-slate-400 border-b border-white/10 pb-3">1. Dimensiones de la Mesa Fija (Metros)</label>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <label className="text-[10px] font-bold text-slate-500 uppercase">Largo (m)</label>
                <input type="number" step="0.5" min="0.5" value={largoVal} onChange={(e) => handleConfigChange('medidas_libre', 'largo', e.target.value)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] shadow-sm font-bold text-[#D4AF37] transition-colors mt-1" />
                <p className="text-[9px] text-slate-500 mt-1.5">Máx. {maxLargo} sillas por lado largo.</p>
              </div>
              <div>
                <label className="text-[10px] font-bold text-slate-500 uppercase">Ancho / Cabecera (m)</label>
                <input type="number" step="0.5" min="0.5" value={anchoVal} onChange={(e) => handleConfigChange('medidas_libre', 'ancho', e.target.value)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] shadow-sm font-bold text-[#D4AF37] transition-colors mt-1" />
                <p className="text-[9px] text-slate-500 mt-1.5">Máx. {maxAncho} sillas por cabecera.</p>
              </div>
            </div>

            <label className="block text-xs font-bold mb-4 text-slate-400 border-b border-white/10 pb-3">2. Distribución Exacta</label>
            <div className="grid grid-cols-2 gap-4">
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Largo Arriba</label><input type="number" min="0" max={maxLargo} value={lTop} onChange={(e) => handleConfigChange('ladosLibre', 'top', e.target.value, maxLargo)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Lado Largo Abajo</label><input type="number" min="0" max={maxLargo} value={lBot} onChange={(e) => handleConfigChange('ladosLibre', 'bottom', e.target.value, maxLargo)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Cabecera Izquierda</label><input type="number" min="0" max={maxAncho} value={lLeft} onChange={(e) => handleConfigChange('ladosLibre', 'left', e.target.value, maxAncho)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
              <div><label className="text-[10px] font-bold text-slate-500 uppercase">Cabecera Derecha</label><input type="number" min="0" max={maxAncho} value={lRight} onChange={(e) => handleConfigChange('ladosLibre', 'right', e.target.value, maxAncho)} className="w-full p-2.5 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#1C1917] text-white transition-colors mt-1" /></div>
            </div>
            
            <div className="mt-5 pt-4 border-t border-white/10 flex justify-between items-center bg-[#1C1917] p-4 rounded-xl transition-colors">
              <span className="text-xs font-bold text-slate-400">Capacidad Resultante:</span>
              <span className="font-black text-lg text-[#D4AF37]">{lTop + lBot + lLeft + lRight} pases</span>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="h-full flex flex-col space-y-6 pb-6 relative text-white bg-[#141210] min-h-[100vh] p-4 rounded-3xl transition-colors duration-500">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-[#1C1917] p-5 sm:p-6 rounded-3xl border border-[#D4AF37]/25 shadow-xl">
        <div className="flex items-center gap-3.5">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
            <LayoutGrid size={20} />
          </div>
          <div>
            <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block mb-0.5">Control de distribución espacial.</span>
            <h2 className="text-2xl sm:text-3xl font-editorial text-white tracking-wide leading-none">Gestión de Mesas</h2>
          </div>
        </div>
        
        <div className="flex flex-wrap sm:flex-nowrap items-center gap-2.5 w-full xl:w-auto justify-start xl:justify-end">
           <div className="flex-1 sm:flex-none flex items-center bg-[#141210] px-3 py-2 rounded-xl border border-white/10 shadow-sm justify-between sm:justify-start whitespace-nowrap shrink-0 hover:border-[#D4AF37]/40 transition-colors">
              <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mr-2">Modo Separador</span>
              <button onClick={() => setModoSeparador(!modoSeparador)} className={`relative w-8 h-4 rounded-full transition-colors shrink-0 ${modoSeparador ? 'bg-[#D4AF37]' : 'bg-white/10'}`}>
                <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${modoSeparador ? 'translate-x-4' : 'translate-x-0'}`}></div>
              </button>
           </div>
           <button onClick={handleOpenAutoAssign} className="flex-1 sm:flex-none flex items-center justify-center px-4 h-9 bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 rounded-lg text-[10px] font-bold hover:bg-[#D4AF37]/20 transition-colors uppercase tracking-widest shrink-0">
              <Wand2 size={14} className="mr-1.5 shrink-0" /> Auto-Acomodar
           </button>
           <button onClick={emptyAllTables} className="flex-1 sm:flex-none flex items-center justify-center px-4 h-9 bg-transparent border border-white/10 text-slate-300 rounded-lg text-[10px] font-bold hover:bg-white/5 hover:text-white transition-colors uppercase tracking-widest shrink-0">
              Vaciar
           </button>
           <button onClick={deleteAllTables} className="flex-1 sm:flex-none flex items-center justify-center px-4 h-9 bg-rose-500/10 text-rose-400 border border-rose-500/20 rounded-lg text-[10px] font-bold hover:bg-rose-500/20 transition-colors uppercase tracking-widest shrink-0">
              Borrar Mesas
           </button>
           <button onClick={() => { setTableToEdit(null); setTableTags([]); setCreationMode('iguales'); setIsAddModalOpen(true); }} className="w-full sm:w-auto flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-[#1C1917] rounded-lg text-[10px] font-black hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)] uppercase tracking-widest shrink-0">
              <Plus size={14} className="mr-1.5 shrink-0" /> Nuevas Mesas
           </button>
        </div>
      </div>

      {/* 🔴 CONTENEDOR PRINCIPAL: PANELES DE MESAS E INVITADOS */}
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 flex-1 overflow-hidden z-10 relative">
        
        {/* PANEL: INVITADOS SIN MESA */}
        <div 
          className={`w-full lg:w-72 bg-[#1C1917] rounded-3xl border flex flex-col transition-all duration-300 shadow-xl overflow-hidden shrink-0 ${guestSeleccionado ? 'border-[#D4AF37] ring-2 ring-[#D4AF37]/20 shadow-[0_0_20px_rgba(212,175,55,0.15)]' : 'border-[#D4AF37]/25'} max-h-[30vh] lg:max-h-none`}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, null)}
          onClick={() => { if(guestSeleccionado) moverInvitado(guestSeleccionado.id, null); }}
        >
          <div className="p-4 lg:p-5 border-b border-[#D4AF37]/15 bg-[#141210] transition-colors shrink-0">
            <h3 className="font-bold text-white flex items-center text-xs uppercase tracking-widest"><Users size={16} className="mr-2 text-[#D4AF37]"/> No Asignados <span className="ml-auto bg-white/5 text-[#D4AF37] border border-[#D4AF37]/30 px-2 py-0.5 rounded-md font-black">{invitadosSinMesa.length}</span></h3>
            <p className="text-[9px] text-slate-400 mt-2 font-medium leading-tight">Toca un invitado para seleccionarlo, luego toca la mesa.</p>
          </div>
          
          <div className="flex-1 overflow-y-auto overflow-x-hidden p-3 lg:p-4 flex flex-row lg:flex-col gap-2.5 custom-scrollbar bg-transparent flex-wrap lg:flex-nowrap content-start">
            {invitadosSinMesa.map(g => {
              const gTags = Array.from(new Set([...(g.tags || []), ...(g.subGuests || []).flatMap(sg => sg.tags || [])]));
              return (
                <div 
                  key={g.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, g.id)}
                  onClick={(e) => { e.stopPropagation(); handleGuestClick(g); }}
                  className={`px-3 py-2 lg:p-3.5 rounded-xl border flex flex-col cursor-pointer transition-all shadow-sm w-auto lg:w-full flex-grow-0 ${guestSeleccionado?.id === g.id ? 'bg-[#D4AF37]/15 border-[#D4AF37] text-white transform scale-[1.02] shadow-[0_0_15px_rgba(212,175,55,0.2)]' : 'bg-[#141210] border-white/10 hover:border-[#D4AF37]/40 text-slate-200 hover:bg-white/5'}`}
                >
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center truncate max-w-[140px] lg:max-w-none">
                      <GripVertical size={14} className={`mr-2 hidden lg:block ${guestSeleccionado?.id === g.id ? 'text-[#D4AF37]/70' : 'text-slate-500 cursor-grab'}`} />
                      <span className="font-bold text-xs lg:text-sm truncate">{g.name}</span>
                    </div>
                    <span className={`text-[9px] lg:text-[10px] font-black px-2 py-0.5 rounded-md ml-2 shrink-0 ${guestSeleccionado?.id === g.id ? 'bg-[#D4AF37] text-[#141210]' : 'bg-white/5 text-slate-300 border border-white/10'}`}>
                      {g.passes}p
                    </span>
                  </div>
                  {gTags.length > 0 && (
                    <div className="flex flex-wrap gap-1 mt-1.5 lg:pl-5">
                      {gTags.map(t => (
                        <span key={t} className={`text-[8px] font-bold uppercase px-1.5 py-0.5 rounded ${guestSeleccionado?.id === g.id ? 'bg-[#D4AF37]/20 text-[#D4AF37] border border-[#D4AF37]/30' : 'bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20'}`}>
                          #{t}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            {invitadosSinMesa.length === 0 && (
              <div className="text-center p-4 lg:p-8 text-slate-500 text-xs border border-dashed border-white/10 bg-white/5 rounded-xl font-medium w-full mt-2">Todos están asignados.</div>
            )}
          </div>
        </div>

        {/* PANEL DERECHO: GRID DE MESAS */}
        <div className="flex-1 overflow-y-auto custom-scrollbar lg:pr-2 pb-6">
          {safeTables.length === 0 ? (
            <div className="text-center py-16 lg:py-20 bg-[#1C1917] rounded-3xl border border-[#D4AF37]/25 shadow-xl h-full flex flex-col items-center justify-center transition-colors px-4">
              <LayoutGrid size={40} className="mx-auto mb-4 text-slate-600"/>
              <h3 className="text-xl lg:text-2xl font-editorial font-bold text-white mb-2">Aún no hay mesas</h3>
              <p className="text-slate-400 text-xs lg:text-sm mb-6 max-w-md">Puedes agregarlas manualmente o usar el asistente mágico.</p>
              <button onClick={() => setIsAddModalOpen(true)} className="px-6 py-3 bg-[#D4AF37]/15 text-[#D4AF37] font-black uppercase tracking-widest text-[10px] rounded-xl border border-[#D4AF37]/30 hover:bg-[#D4AF37]/25 transition-colors">Crear Mesas</button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-5">
              {safeTables.map(table => {
                const assignedGuests = safeGuests.filter(g => g.tableId === table.id);
                const usedChairs = assignedGuests.reduce((sum, g) => sum + g.passes, 0);
                const isFull = usedChairs >= table.capacity;

                return (
                  <div 
                    key={table.id} 
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, table.id)}
                    onClick={() => handleTableClick(table.id)}
                    className={`bg-[#1C1917] p-4 lg:p-5 rounded-3xl border shadow-xl flex flex-col relative group transition-all duration-300 ${guestSeleccionado && !isFull ? 'border-[#D4AF37] bg-[#D4AF37]/5 cursor-pointer shadow-[0_0_20px_rgba(212,175,55,0.15)] ring-2 ring-[#D4AF37]/20' : 'border-[#D4AF37]/25 hover:border-[#D4AF37]/50'}`}
                  >
                    <div className="absolute top-3 lg:top-4 right-3 lg:right-4 flex opacity-100 lg:opacity-0 group-hover:opacity-100 transition-opacity space-x-1.5 z-50">
                       <button onClick={(e) => { e.stopPropagation(); setTableToEdit(table); setTableTags(table.tags || []); setCurrentConfig(table.configDetalle || configActual); setCreationMode('edit'); setIsAddModalOpen(true); }} className="p-1.5 text-slate-400 hover:text-white bg-[#141210] border border-white/10 rounded-lg transition-colors" title="Editar Mesa y Etiquetas"><Edit2 size={14}/></button>
                       <button onClick={(e) => { e.stopPropagation(); emptyTable(table.id); }} className="p-1.5 text-slate-400 hover:text-white bg-[#141210] border border-white/10 rounded-lg transition-colors" title="Vaciar Mesa"><Users size={14}/></button>
                       <button onClick={(e) => { e.stopPropagation(); deleteTable(table.id); }} className="p-1.5 text-slate-400 hover:text-rose-400 bg-[#141210] border border-white/10 rounded-lg transition-colors" title="Borrar Mesa"><Trash2 size={14}/></button>
                    </div>
                    
                    <div className="flex items-center mb-3">
                      <div className="w-10 h-10 lg:w-12 lg:h-12 bg-white/5 rounded-full flex items-center justify-center mr-3 border border-white/10 shrink-0">
                        {getTipoIcon(table.tipo, table.configDetalle?.formaPersonalizada)}
                      </div>
                      <div className="flex-1 min-w-0 pr-24 lg:pr-20">
                        <h4 className="font-editorial font-bold text-white text-base lg:text-lg leading-tight truncate">{table.name}</h4>
                        <p className="text-[8px] lg:text-[9px] uppercase font-black text-slate-400 tracking-widest mt-0.5">
                           {table.tipo === 'libre' ? 'Diseño Libre' : table.tipo}
                        </p>
                      </div>
                    </div>

                    {/* 🟢 ETIQUETAS IMÁN DE LA MESA */}
                    {table.tags && table.tags.length > 0 && (
                      <div className="flex flex-wrap gap-1 mb-3">
                        {table.tags.map(tag => (
                          <span key={tag} className="px-2 py-0.5 rounded-md text-[8px] font-black uppercase tracking-wider bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 flex items-center">
                            <Magnet size={9} className="mr-1"/> {tag}
                          </span>
                        ))}
                      </div>
                    )}

                    <div className="mb-4 bg-[#141210] rounded-xl p-2.5 lg:p-3 border border-white/5 flex items-center justify-between transition-colors">
                      <div className="flex items-center text-xs font-bold text-slate-300">
                        <Users size={14} className="mr-2 text-[#D4AF37]"/> {usedChairs} / {table.capacity}
                      </div>
                      {isFull ? <span className="text-[8px] lg:text-[9px] bg-rose-500/10 text-rose-400 px-2 py-1 rounded-md font-black uppercase tracking-widest border border-rose-500/20">Llena</span> : <span className={`text-[8px] lg:text-[9px] font-bold uppercase tracking-widest ${guestSeleccionado ? 'text-[#D4AF37] animate-pulse' : 'text-slate-500'}`}>{guestSeleccionado ? 'Toca para soltar' : 'Sillas libres'}</span>}
                    </div>

                    <div className="mt-auto border-t border-white/10 pt-3 min-h-[60px] flex flex-wrap gap-1.5 content-start transition-colors">
                      {assignedGuests.map(g => (
                        <div 
                          key={g.id} 
                          draggable
                          onDragStart={(e) => handleDragStart(e, g.id)}
                          onClick={(e) => { e.stopPropagation(); handleGuestClick(g); }}
                          className={`text-[9px] lg:text-[10px] px-2.5 py-1.5 rounded-lg font-bold truncate flex items-center cursor-pointer lg:cursor-grab shadow-sm border transition-colors max-w-full ${guestSeleccionado?.id === g.id ? 'bg-[#D4AF37] text-[#141210] border-[#D4AF37]' : 'bg-white/5 text-slate-300 border-white/10 hover:border-[#D4AF37]/40'}`}
                        >
                          <span className="truncate">{g.name}</span> <span className="ml-1.5 opacity-50 font-black shrink-0">({g.passes})</span>
                        </div>
                      ))}
                      {assignedGuests.length === 0 && <span className="text-[10px] lg:text-xs text-slate-500 font-medium italic w-full text-center mt-2">Mesa vacía</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* 🟢 MODAL DEL MOTOR DUAL: CLÁSICO VS AFINIDAD */}
      {autoAssignModal && (
        <div className="fixed inset-0 z-[300] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-[2.5rem] w-full max-w-lg overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 flex flex-col max-h-[90vh] text-white">
            <div className="px-8 py-6 border-b border-[#D4AF37]/20 flex justify-between items-center bg-[#141210] shrink-0">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-[#D4AF37]/15 text-[#D4AF37] flex items-center justify-center border border-[#D4AF37]/30 shadow-inner">
                  <Wand2 size={20}/>
                </div>
                <div>
                  <h3 className="font-editorial font-black text-xl text-[#D4AF37]">Motor de Auto-Acomodo</h3>
                  <p className="text-[10px] uppercase tracking-widest text-slate-400 mt-1">Las mesas ya asignadas manualmente no se moverán.</p>
                </div>
              </div>
              <button onClick={() => setAutoAssignModal(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={22}/></button>
            </div>

            <div className="p-8 overflow-y-auto custom-scrollbar space-y-6">
              {/* SELECTOR DE MODO */}
              <div className="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={() => setAssignMode('afinidad')}
                  className={`p-4 rounded-2xl border text-left transition-all ${assignMode === 'afinidad' ? 'border-[#D4AF37] bg-[#D4AF37]/10 shadow-[0_0_15px_rgba(212,175,55,0.15)]' : 'border-white/10 bg-[#141210] opacity-70 hover:opacity-100 hover:border-white/30'}`}
                >
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="font-black text-xs uppercase tracking-widest text-[#D4AF37]">Modo Afinidad</span>
                    <Magnet size={16} className="text-[#D4AF37]"/>
                  </div>
                  <p className="text-[10px] text-slate-400 leading-relaxed">Agrupa por las etiquetas que elijas, separa primos automáticamente y rellena huecos al final.</p>
                </button>

                <button
                  type="button"
                  onClick={() => setAssignMode('clasico')}
                  className={`p-4 rounded-2xl border text-left transition-all ${assignMode === 'clasico' ? 'border-emerald-500 bg-emerald-500/10 shadow-[0_0_15px_rgba(16,185,129,0.15)]' : 'border-white/10 bg-[#141210] opacity-70 hover:opacity-100 hover:border-white/30'}`}
                >
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="font-black text-xs uppercase tracking-widest text-emerald-400">Modo Clásico</span>
                    <LayoutGrid size={16} className="text-emerald-400"/>
                  </div>
                  <p className="text-[10px] text-slate-400 leading-relaxed">Tetris matemático puro. Prioriza familias completas optimizando cada silla e ignora etiquetas.</p>
                </button>
              </div>

              {/* CHIPS DE ETIQUETAS A CONSIDERAR EN MODO AFINIDAD */}
              {assignMode === 'afinidad' && (
                <div className="bg-[#141210] p-5 rounded-2xl border border-white/5 space-y-4 animate-in fade-in">
                  <div className="space-y-1">
                    <div className="flex items-center justify-between gap-4">
                      <h4 className="text-xs font-black uppercase tracking-widest text-white">Etiquetas a agrupar hoy</h4>
                      <button
                        type="button"
                        onClick={() => {
                          if (selectedAffinityTags.length === allAvailableTags.length) setSelectedAffinityTags([]);
                          else setSelectedAffinityTags([...allAvailableTags]);
                        }}
                        className="text-[9px] font-black uppercase tracking-widest text-[#D4AF37] hover:underline shrink-0"
                      >
                        {selectedAffinityTags.length === allAvailableTags.length ? 'Desmarcar todas' : 'Seleccionar todas'}
                      </button>
                    </div>
                    <p className="text-[10px] text-slate-400">Toca las etiquetas que quieres que el algoritmo junte en las mesas.</p>
                  </div>

                  {/* CHIP INAMOVIBLE DE NÚCLEO FAMILIAR */}
                  <div className="flex flex-wrap gap-2">
                    <div className="px-3 py-2 rounded-xl text-[10px] uppercase tracking-widest font-black bg-emerald-500/15 text-emerald-400 border border-emerald-500/30 flex items-center gap-1.5 cursor-default">
                      <CheckCircle size={13}/> Grupo Original
                    </div>
                    {allAvailableTags.map(tag => {
                      const active = selectedAffinityTags.includes(tag);
                      return (
                        <button
                          type="button"
                          key={tag}
                          onClick={() => {
                            setSelectedAffinityTags(prev => prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]);
                          }}
                          className={`px-3.5 py-2 rounded-xl text-[10px] uppercase tracking-widest font-black transition-all border ${active ? 'bg-[#D4AF37] text-[#1C1917] border-[#D4AF37] shadow-[0_5px_10px_rgba(212,175,55,0.2)] scale-[1.02]' : 'bg-[#1C1917] text-slate-400 border-white/10'}`}
                        >
                          #{tag}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div className="p-6 border-t border-white/10 bg-[#141210] flex gap-3 shrink-0">
              <button onClick={() => setAutoAssignModal(false)} className="px-6 py-4 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 text-slate-300 font-bold text-xs uppercase tracking-widest transition-colors">
                Cancelar
              </button>
              <button 
                onClick={() => iniciarProcesoAutoAcomodo(assignMode, selectedAffinityTags)} 
                className="flex-1 py-4 rounded-xl bg-[#D4AF37] text-[#1C1917] font-black text-xs uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-all flex items-center justify-center gap-2"
              >
                <Wand2 size={16}/> Comenzar Auto-Acomodo
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL INTELIGENTE: SEPARAR FAMILIA O MOVER GRUPO */}
      {guestSplitPrompt && (
        <div className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden p-8 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 border border-[#D4AF37]/30 text-white">
            <div className="w-20 h-20 bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/30 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner"><Users size={32} /></div>
            <h3 className="font-editorial font-black text-2xl text-white mb-2">Acomodar Grupo</h3>
            
            {guestSplitPrompt.isForced ? (
                <p className="text-rose-400 mb-6 text-sm leading-relaxed">
                   Esta mesa es para <b className="text-white">{guestSplitPrompt.table.capacity} personas</b> y solo quedan <b className="text-white">{guestSplitPrompt.availableChairs} sillas libres</b>. El grupo de <b className="text-white">{guestSplitPrompt.guest.name}</b> ({guestSplitPrompt.guest.passes} pases) supera la capacidad.<br/><br/>¿Cuántos deseas acomodar en esta mesa?
                </p>
            ) : (
                <p className="text-slate-400 mb-6 text-sm leading-relaxed">
                   <b className="text-white">{guestSplitPrompt.guest.name}</b> tiene {guestSplitPrompt.guest.passes} pases y hay {guestSplitPrompt.availableChairs} sillas libres aquí.<br/><br/>¿Cuántos deseas acomodar en esta mesa?
                </p>
            )}

            <div className="flex items-center justify-center gap-4 mb-6 bg-[#141210] p-4 rounded-2xl border border-white/10">
                <button 
                   onClick={() => setSepararCantidad(Math.max(guestSplitPrompt.minPlaceable, separarCantidad - 1))}
                   disabled={separarCantidad <= guestSplitPrompt.minPlaceable}
                   className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center font-black text-white disabled:opacity-30 transition-colors hover:bg-white/10"
                >-</button>
                <div className="text-4xl font-black text-[#D4AF37] w-14 text-center">{separarCantidad}</div>
                <button 
                   onClick={() => setSepararCantidad(Math.min(guestSplitPrompt.maxPlaceable, separarCantidad + 1))}
                   disabled={separarCantidad >= guestSplitPrompt.maxPlaceable}
                   className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center font-black text-white disabled:opacity-30 transition-colors hover:bg-white/10"
                >+</button>
            </div>

            <div className="flex flex-col space-y-3">
              <button onClick={() => handleSplitChoice('split')} className="w-full p-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black uppercase tracking-widest text-[10px] shadow-[0_5px_15px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors">Mover {separarCantidad} pase(s)</button>
              
              {!guestSplitPrompt.isForced && (
                 <button onClick={() => handleSplitChoice('all')} className="w-full p-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition-colors">Mover familia ({guestSplitPrompt.guest.passes})</button>
              )}
              
              <button onClick={() => handleSplitChoice('cancel')} className="w-full p-3 text-slate-500 font-bold hover:text-slate-300 transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL: ASISTENTE INTELIGENTE AUTO-ACOMODAR (CUANDO FALTAN MESAS) */}
      {smartAssign && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-200 transition-colors">
          <div className="bg-[#1C1917] rounded-[2.5rem] w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 text-white">
            <div className="bg-[#141210] p-8 text-center relative overflow-hidden border-b border-[#D4AF37]/20">
              <div className="w-20 h-20 bg-[#D4AF37]/15 rounded-full flex items-center justify-center mx-auto mb-4 border border-[#D4AF37]/30 relative z-10 shadow-inner">
                <Wand2 size={36} className="text-[#D4AF37]"/>
              </div>
              <h3 className="text-2xl font-editorial font-black text-white mb-2 relative z-10">Asistente Inteligente</h3>
              <p className="text-slate-400 text-sm font-medium relative z-10">Faltan mesas para acomodar a todos.</p>
            </div>
            
            <div className="p-8">
              <div className="bg-rose-500/10 border border-rose-500/20 rounded-2xl p-5 mb-6 text-center transition-colors">
                <p className="text-sm font-bold text-rose-400">Tienes {smartAssign.faltantes} invitados sin asiento disponible.</p>
                <p className="text-xs text-rose-300/70 mt-2 font-medium">¿Qué tipo de mesas deseas generar en automático?</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <button onClick={() => generarYAsignarMagico('redondas')} className="w-full p-4 bg-[#141210] border border-white/10 rounded-2xl flex flex-col items-center text-center hover:border-[#D4AF37]/50 transition-all group shadow-sm">
                  <Circle size={28} className="text-white group-hover:text-[#D4AF37] mb-3 transition-colors"/>
                  <p className="font-bold text-white text-sm">Redondas</p>
                  <p className="text-[10px] text-slate-500 mb-3 font-medium">10 Sillas c/u</p>
                  <span className="bg-white/5 text-slate-300 border border-white/10 text-[10px] font-black px-2.5 py-1 rounded-md group-hover:bg-[#D4AF37]/15 group-hover:text-[#D4AF37] group-hover:border-[#D4AF37]/30 transition-colors">+{Math.ceil(smartAssign.faltantes/10)} mesas</span>
                </button>

                <button onClick={() => generarYAsignarMagico('tablones')} className="w-full p-4 bg-[#141210] border border-white/10 rounded-2xl flex flex-col items-center text-center hover:border-[#D4AF37]/50 transition-all group shadow-sm">
                  <RectangleHorizontal size={28} className="text-white group-hover:text-[#D4AF37] mb-3 transition-colors"/>
                  <p className="font-bold text-white text-sm">Tablones</p>
                  <p className="text-[10px] text-slate-500 mb-3 font-medium">12 Sillas c/u</p>
                  <span className="bg-white/5 text-slate-300 border border-white/10 text-[10px] font-black px-2.5 py-1 rounded-md group-hover:bg-[#D4AF37]/15 group-hover:text-[#D4AF37] group-hover:border-[#D4AF37]/30 transition-colors">+{Math.ceil(smartAssign.faltantes/12)} mesas</span>
                </button>

                <button onClick={() => generarYAsignarMagico('cuadradas')} className="w-full p-4 bg-[#141210] border border-white/10 rounded-2xl flex flex-col items-center text-center hover:border-[#D4AF37]/50 transition-all group shadow-sm">
                  <Square size={28} className="text-white group-hover:text-[#D4AF37] mb-3 transition-colors"/>
                  <p className="font-bold text-white text-sm">Cuadradas</p>
                  <p className="text-[10px] text-slate-500 mb-3 font-medium">12 Sillas c/u</p>
                  <span className="bg-white/5 text-slate-300 border border-white/10 text-[10px] font-black px-2.5 py-1 rounded-md group-hover:bg-[#D4AF37]/15 group-hover:text-[#D4AF37] group-hover:border-[#D4AF37]/30 transition-colors">+{Math.ceil(smartAssign.faltantes/12)} mesas</span>
                </button>

                <button onClick={() => generarYAsignarMagico('ovaladas')} className="w-full p-4 bg-[#141210] border border-white/10 rounded-2xl flex flex-col items-center text-center hover:border-[#D4AF37]/50 transition-all group shadow-sm">
                  <div className="w-10 h-5 rounded-[50%] border-4 border-white group-hover:border-[#D4AF37] transition-colors mb-3"></div>
                  <p className="font-bold text-white text-sm">Ovaladas</p>
                  <p className="text-[10px] text-slate-500 mb-3 font-medium">14 Sillas c/u</p>
                  <span className="bg-white/5 text-slate-300 border border-white/10 text-[10px] font-black px-2.5 py-1 rounded-md group-hover:bg-[#D4AF37]/15 group-hover:text-[#D4AF37] group-hover:border-[#D4AF37]/30 transition-colors">+{Math.ceil(smartAssign.faltantes/14)} mesas</span>
                </button>

                <button onClick={() => generarYAsignarMagico('serpentinas')} className="w-full p-4 bg-[#141210] border border-white/10 rounded-2xl flex flex-col items-center text-center hover:border-[#D4AF37]/50 transition-all group shadow-sm">
                  <Spline size={28} className="text-white group-hover:text-[#D4AF37] mb-3 transition-colors"/>
                  <p className="font-bold text-white text-sm">Serpentinas</p>
                  <p className="text-[10px] text-slate-500 mb-3 font-medium">9 Sillas c/u</p>
                  <span className="bg-white/5 text-slate-300 border border-white/10 text-[10px] font-black px-2.5 py-1 rounded-md group-hover:bg-[#D4AF37]/15 group-hover:text-[#D4AF37] group-hover:border-[#D4AF37]/30 transition-colors">+{Math.ceil(smartAssign.faltantes/9)} mesas</span>
                </button>

                <button onClick={() => { setSmartAssign(null); setCurrentConfig({...configActual, tipo: 'libre'}); setCreationMode('iguales'); setIsAddModalOpen(true); }} className="w-full p-4 bg-[#141210] border border-white/10 rounded-2xl flex flex-col items-center text-center hover:border-[#D4AF37]/50 transition-all group shadow-sm">
                  <Settings2 size={28} className="text-white group-hover:text-[#D4AF37] mb-3 transition-colors"/>
                  <p className="font-bold text-white text-sm">Diseño Libre</p>
                  <p className="text-[10px] text-slate-500 mb-3 font-medium">A tu medida</p>
                  <span className="bg-white/5 text-slate-300 border border-white/10 text-[10px] font-black px-2.5 py-1 rounded-md group-hover:bg-[#D4AF37]/15 group-hover:text-[#D4AF37] group-hover:border-[#D4AF37]/30 transition-colors">Configurar</span>
                </button>
              </div>

              <button onClick={() => setSmartAssign(null)} className="w-full py-4 mt-6 text-xs font-black uppercase tracking-widest text-slate-500 hover:text-white transition-colors">Cancelar y hacer manual</button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CONFIGURAR / EDITAR MESAS CON IMÁN DE ETIQUETAS */}
      {isAddModalOpen && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in zoom-in-95 duration-200 transition-colors">
          <div className="bg-[#1C1917] rounded-[2.5rem] w-full max-w-lg overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 flex flex-col max-h-[90vh] transition-colors text-white">
            
            <div className="px-8 py-6 border-b border-[#D4AF37]/20 flex justify-between items-center bg-[#141210] shrink-0 transition-colors">
              <h3 className="font-editorial font-black text-2xl text-[#D4AF37] flex items-center tracking-wide"><LayoutGrid size={22} className="mr-2.5"/> {creationMode === 'edit' ? `Editar ${tableToEdit?.name}` : 'Configurar Mesas'}</h3>
              <button onClick={() => setIsAddModalOpen(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={24}/></button>
            </div>

            <div className="p-8 overflow-y-auto flex-1 custom-scrollbar">
              {creationMode !== 'edit' && (
                <div className="flex p-1.5 bg-slate-100 dark:bg-[#111] rounded-xl mb-6 border border-slate-200 dark:border-white/5 transition-colors">
                  <button onClick={() => {setCreationMode('iguales'); setTableToEdit(null);}} className={`flex-1 py-2.5 text-xs font-black uppercase tracking-widest rounded-lg transition-all ${creationMode === 'iguales' && !tableToEdit ? 'bg-white dark:bg-[#222] text-indigo-600 dark:text-white shadow-sm border border-slate-200 dark:border-white/10' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'}`}>Todas Iguales</button>
                  <button onClick={() => {setCreationMode('variedad'); setTableToEdit(null);}} className={`flex-1 py-2.5 text-xs font-black uppercase tracking-widest rounded-lg transition-all ${creationMode === 'variedad' ? 'bg-white dark:bg-[#222] text-indigo-600 dark:text-white shadow-sm border border-slate-200 dark:border-white/10' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'}`}>Crear Mezcla</button>
                </div>
              )}

              <label className="block text-[10px] font-black uppercase tracking-widest mb-3 text-slate-500 dark:text-slate-400">Forma de la mesa</label>
              <div className="grid grid-cols-3 sm:grid-cols-6 gap-3 mb-6">
                {[
                  { id: 'redonda', lbl: 'Redonda', icon: <Circle size={24} className="mb-1.5"/>, action: () => setCurrentConfig({...configActual, tipo: 'redonda', capacidadRedonda: 10}) },
                  { id: 'cuadrada', lbl: 'Cuadrada', icon: <Square size={24} className="mb-1.5"/>, action: () => setCurrentConfig({...configActual, tipo: 'cuadrada', ladosCuadrada: {top:3, right:3, bottom:3, left:3}}) },
                  { id: 'tablon', lbl: 'Tablón', icon: <RectangleHorizontal size={24} className="mb-1.5"/>, action: () => setCurrentConfig({...configActual, tipo: 'tablon', ladosTablon: {top:5, bottom:5, left:1, right:1}}) },
                  { id: 'ovalada', lbl: 'Ovalada', icon: <div className={`w-8 h-4 rounded-[50%] border-2 mb-1.5 ${configActual.tipo === 'ovalada' ? 'border-indigo-600 dark:border-amber-400' : 'border-slate-400 dark:border-slate-500'}`}></div>, action: () => setCurrentConfig({...configActual, tipo: 'ovalada', ladosOvalada: {top:4, bottom:4, left:3, right:3}}) },
                  { id: 'serpentina', lbl: 'Curva', icon: <Spline size={24} className="mb-1.5"/>, action: () => setCurrentConfig({...configActual, tipo: 'serpentina', modeloSerpentina: 'mod4', ladosSerpentina: {ext:5, int:2, izq:1, der:1}}) },
                  { id: 'libre', lbl: 'Libre', icon: <Settings2 size={24} className="mb-1.5"/>, action: () => setCurrentConfig({...configActual, tipo: 'libre'}) },
                ].map(b => (
                  <button key={b.id} onClick={(e) => { e.preventDefault(); b.action(); }} className={`flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all ${configActual.tipo === b.id ? 'border-indigo-500 bg-indigo-50 text-indigo-700 dark:border-amber-500 dark:bg-amber-500/10 dark:text-amber-400 shadow-md' : 'border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-[#111] text-slate-500 dark:text-slate-400 hover:border-indigo-300 dark:hover:border-amber-500/50'}`}>
                    {b.icon}
                    <span className="text-[9px] font-bold uppercase tracking-wider">{b.lbl}</span>
                  </button>
                ))}
              </div>

              {renderConfigForm()}

              {/* 🟢 IMÁN DE ETIQUETAS PARA LA MESA (SOPORTA MÚLTIPLES ETIQUETAS) */}
              <div className="mt-6 border-t border-slate-100 dark:border-white/10 pt-5">
                <label className="block text-[10px] font-black uppercase tracking-widest mb-1.5 text-indigo-600 dark:text-amber-400 flex items-center">
                  <Magnet size={13} className="mr-1.5"/> Imán de Afinidad para esta mesa (Opcional)
                </label>
                <p className="text-[11px] text-slate-500 dark:text-slate-400 mb-3">Toca una o varias etiquetas (ej. #Primos y #Amigos) para que esta mesa atraiga a esos grupos en automático.</p>
                
                {allAvailableTags.length > 0 && (
                  <div className="flex flex-wrap gap-1.5 mb-3">
                    {allAvailableTags.map(tag => {
                      const active = tableTags.includes(tag);
                      return (
                        <button
                          type="button"
                          key={tag}
                          onClick={() => toggleTableTag(tag)}
                          className={`px-3 py-1.5 rounded-xl text-xs font-bold transition-all border ${active ? 'bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 border-indigo-600 dark:border-amber-500 shadow-sm' : 'bg-slate-50 dark:bg-[#111] text-slate-500 border-slate-200 dark:border-white/10'}`}
                        >
                          #{tag}
                        </button>
                      );
                    })}
                  </div>
                )}

                <div className="flex gap-2">
                  <input 
                    type="text" 
                    value={newTagInput} 
                    onChange={e => setNewTagInput(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleCreateGlobalTag(); } }}
                    placeholder="Crear nueva etiqueta..." 
                    className="flex-1 px-3 py-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl text-xs outline-none focus:border-indigo-500 dark:focus:border-amber-500 text-slate-800 dark:text-white"
                  />
                  <button type="button" onClick={handleCreateGlobalTag} className="px-4 py-2 bg-slate-100 dark:bg-white/10 text-slate-700 dark:text-white rounded-xl text-[10px] font-black uppercase tracking-widest">
                    + Añadir
                  </button>
                </div>
              </div>

              {creationMode !== 'edit' && (
                <div className="mt-6 border-t border-slate-100 dark:border-white/10 pt-6 transition-colors">
                  <label className="block text-[10px] font-black uppercase tracking-widest mb-3 text-slate-500 dark:text-slate-400">Cantidad a generar</label>
                  <div className="flex items-center gap-4">
                    <input type="number" min="1" value={cantidadIguales} onChange={(e) => { let v = parseInt(e.target.value); if(v>0) setCantidadIguales(v); }} className="w-24 p-4 border border-slate-200 dark:border-white/10 rounded-xl outline-none focus:border-indigo-500 dark:focus:border-amber-500 font-black text-center text-xl bg-slate-50 dark:bg-[#111] text-slate-900 dark:text-white shadow-inner transition-colors" />
                    
                    {creationMode === 'variedad' && (
                      <button onClick={agregarAVariedad} className="flex-1 py-4 bg-indigo-100 dark:bg-indigo-500/20 text-indigo-700 dark:text-indigo-400 font-bold uppercase tracking-widest text-xs rounded-xl border border-indigo-200 dark:border-indigo-500/30 hover:bg-indigo-200 dark:hover:bg-indigo-500/30 transition-colors flex items-center justify-center shadow-sm">
                        <Plus size={16} className="mr-2"/> Añadir a mezcla
                      </button>
                    )}
                  </div>
                </div>
              )}

              {creationMode === 'variedad' && mezclaVariedad.length > 0 && (
                <div className="mt-6 bg-slate-800 dark:bg-[#111] border dark:border-white/10 rounded-2xl p-5 text-white animate-in slide-in-from-bottom-4 shadow-inner transition-colors">
                  <h4 className="text-xs font-black uppercase tracking-widest mb-4 border-b border-slate-700 dark:border-white/10 pb-3">Paquete a generar:</h4>
                  <ul className="space-y-2.5 mb-5 max-h-40 overflow-y-auto custom-scrollbar">
                    {mezclaVariedad.map(item => (
                      <li key={item.id} className="flex items-center justify-between text-xs bg-slate-700/50 dark:bg-black/50 border border-slate-600 dark:border-white/5 p-3 rounded-xl transition-colors">
                        <div className="flex items-center font-medium flex-wrap gap-1">
                          <span className="font-black text-indigo-300 dark:text-amber-400 mr-1.5 text-sm">{item.cantidad}x</span> 
                          <span className="uppercase tracking-wider">{item.config.tipo === 'libre' ? 'Diseño Libre' : item.config.tipo}</span> 
                          <span className="text-slate-400 dark:text-slate-500 ml-1 font-bold">({item.config.capacidadCalculada} sillas)</span>
                          {item.tags && item.tags.map(t => (
                            <span key={t} className="text-[9px] bg-indigo-500/20 text-indigo-300 px-1.5 py-0.5 rounded ml-1">#{t}</span>
                          ))}
                        </div>
                        <button onClick={() => eliminarDeVariedad(item.id)} className="text-slate-400 hover:text-rose-400 transition-colors p-1"><Trash2 size={16}/></button>
                      </li>
                    ))}
                  </ul>
                  <div className="text-right text-[10px] font-black uppercase tracking-widest text-indigo-300 dark:text-amber-500 pt-2 border-t border-slate-700 dark:border-white/10">Total a crear: {mezclaVariedad.reduce((acc, curr) => acc + curr.cantidad, 0)} mesas</div>
                </div>
              )}
            </div>

            <div className="p-6 border-t border-white/10 bg-[#141210] shrink-0 transition-colors">
              {creationMode === 'iguales' || creationMode === 'edit' ? (
                <button onClick={generarMesas} className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black uppercase tracking-widest text-xs shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors active:scale-95">
                  {creationMode === 'edit' ? 'Guardar Cambios' : `Generar ${cantidadIguales} Mesa${cantidadIguales > 1 ? 's' : ''}`}
                </button>
              ) : (
                <button onClick={generarMesas} disabled={mezclaVariedad.length === 0} className={`w-full py-4 rounded-xl font-black uppercase tracking-widest text-xs shadow-md transition-all active:scale-95 ${mezclaVariedad.length > 0 ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028]' : 'bg-white/5 text-slate-500 border border-white/10 cursor-not-allowed'}`}>
                  Generar Mezcla Completa
                </button>
              )}
            </div>

          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: SECCION DE CROQUIS Y AJUSTE DE SILLAS ---
// ==========================================
const MapaView = ({ tables = [], setTables, guests = [], setGuests, globalSearch = '', elements = [], setElements }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [dragging, setDragging] = useState(null); 
  const [selectionBox, setSelectionBox] = useState(null); 
  const [snapGuides, setSnapGuides] = useState({ x: null, y: null });
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [scale, setScale] = useState(30);
  
  const [activeTool, setActiveTool] = useState('select'); 
  const [measureLine, setMeasureLine] = useState(null); 
  const [mousePos, setMousePos] = useState({x: 0, y: 0});
  
  const [history, setHistory] = useState([]);
  const [roomGrouped, setRoomGrouped] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  
  const [guestSplitPrompt, setGuestSplitPrompt] = useState(null); 
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [modoSeparador, setModoSeparador] = useState(false);
  const [separarCantidad, setSepararCantidad] = useState(1);

  // 🔴 ESTADOS PARA EL MOTOR PDF DEL MAPA
  const [showExportModal, setShowExportModal] = useState(false);
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);
  const [isCapturingPdf, setIsCapturingPdf] = useState(false);
  const [printScale, setPrintScale] = useState(1);
  const [printPan, setPrintPan] = useState({ x: 0, y: 0 });
  const [isPrintDragging, setIsPrintDragging] = useState(false);
  const [printDragStart, setPrintDragStart] = useState({ x: 0, y: 0 });
  const [isBlueprintPanActive, setIsBlueprintPanActive] = useState(false);

  const placedTables = tables.filter(t => t.x !== undefined && t.x !== null);
  const availableTables = tables.filter(t => t.x === undefined || t.x === null);
  const allItems = [...elements, ...placedTables];
  
  const roomAreas = elements.filter(e => e.isRoomArea);
  const addAreas = roomAreas.filter(e => e.mode === 'add');
  const subAreas = roomAreas.filter(e => e.mode === 'subtract');
  const overlayAreas = roomAreas.filter(e => e.mode === 'overlay'); 
  const physicalStructures = elements.filter(e => !e.isRoomArea);
  const isMultiSelection = selectedIds.length > 1;

  const saveHistory = (currElements, currTables) => {
    setHistory(prev => [...prev.slice(-19), { elements: JSON.parse(JSON.stringify(currElements)), tables: JSON.parse(JSON.stringify(currTables)) }]);
  };

  const handleUndo = () => {
    if (history.length === 0) return;
    const prevState = history[history.length - 1];
    setElements(prevState.elements);
    if (setTables) setTables(prevState.tables);
    setHistory(prev => prev.slice(0, -1));
    setSelectedIds([]);
  };

  const containerRef = useRef(null);
  const [vp, setVp] = useState({ w: 0, h: 0 });

  // 🟢 Aseguramos que el observador se recargue cuando entramos/salimos del Portal
  useLayoutEffect(() => {
    const observeTarget = containerRef.current;
    if (!observeTarget) return;
    const resizeObserver = new ResizeObserver(entries => {
      const { width, height } = entries[0].contentRect;
      if (width > 0 && height > 0) setVp({ w: width, h: height });
    });
    resizeObserver.observe(observeTarget);
    return () => resizeObserver.disconnect();
  }, [isEditMode]);
  
  const centerAndFitMap = () => {
    if (vp.w === 0 || vp.h === 0) return;
    const allItemsForBounds = [...elements, ...placedTables];
    if (allItemsForBounds.length === 0) { setPan({ x: 0, y: 0 }); setScale(30); return; }

    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    allItemsForBounds.forEach(el => {
      const w = el.width || 2; const h = el.height || 2;
      if (el.x < minX) minX = el.x; if (el.y < minY) minY = el.y;
      if (el.x + w > maxX) maxX = el.x + w; if (el.y + h > maxY) maxY = el.y + h;
    });

    if (minX === Infinity) return;
    const paddingX = 180; const paddingY = 180; 
    const scaleX = (vp.w - paddingX) / ((maxX - minX) || 1);
    const scaleY = (vp.h - paddingY) / ((maxY - minY) || 1);
    const newScale = Math.max(5, Math.min(120, Math.min(scaleX, scaleY)));
    setScale(newScale); 
    setPan({ x: -(minX + (maxX - minX) / 2) * newScale, y: -(minY + (maxY - minY) / 2) * newScale });
  };

  const [initialFitDone, setInitialFitDone] = useState(false);
  useEffect(() => {
    if (vp.w > 0 && vp.h > 0 && !initialFitDone) {
      setTimeout(() => centerAndFitMap(), 50); setInitialFitDone(true);
    }
  }, [vp, initialFitDone]);

  useEffect(() => {
    if (showExportModal) {
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      const allItemsForBounds = [...elements, ...placedTables];
      allItemsForBounds.forEach(el => {
        const w = el.width || 2; const h = el.height || 2;
        if (el.x < minX) minX = el.x; if (el.y < minY) minY = el.y;
        if (el.x + w > maxX) maxX = el.x + w; if (el.y + h > maxY) maxY = el.y + h;
      });
      if (minX === Infinity) { minX = -10; minY = -10; maxX = 10; maxY = 10; }

      const designW = (maxX - minX) * scale;
      const designH = (maxY - minY) * scale;
      const cx = (minX * scale) + designW / 2; 
      const cy = (minY * scale) + designH / 2;
      
      const targetW = 900; 
      const targetH = 600; 
      const initialZoom = Math.min(targetW / (designW || 1), targetH / (designH || 1)) * 0.85; 
      
      setPrintScale(initialZoom);
      setPrintPan({ x: (targetW / 2) - (cx * initialZoom), y: (targetH / 2) - (cy * initialZoom) });
    }
  }, [showExportModal, elements, placedTables, scale]);

  const offsetX = (vp.w / 2) + pan.x;
  const offsetY = (vp.h / 2) + pan.y;

  const handleDragStart = (e, item, actionType) => {
    e.dataTransfer.setData('actionType', actionType);
    e.dataTransfer.setData('payload', JSON.stringify(item));
  };

  const handleDropOnCanvas = (e) => {
    e.preventDefault();
    const guestId = e.dataTransfer.getData('guestId');
    
    if (guestId && setGuests) {
      const rect = containerRef.current.getBoundingClientRect();
      const dropX = ((e.clientX - rect.left) - offsetX) / scale;
      const dropY = ((e.clientY - rect.top) - offsetY) / scale;
      
      const margin = 0.8;
      const targetTable = tables.find(t => {
        const tw = t.width || 2; const th = t.height || 2;
        return dropX >= (t.x - margin) && dropX <= (t.x + tw + margin) && dropY >= (t.y - margin) && dropY <= (t.y + th + margin);
      });

      const guest = guests.find(g => g.id === guestId);
      if (!guest) return;

      const isToTable = targetTable !== undefined;
      const targetTableId = isToTable ? targetTable.id : null;

      if (guest.tableId === targetTableId) return;

      let usedChairs = 0;
      if (isToTable) {
          usedChairs = guests.filter(g => g.tableId === targetTableId).reduce((sum, g) => sum + g.passes, 0);
      }

      const availableChairs = isToTable ? targetTable.capacity - usedChairs : Infinity;
      const isForcedSplit = isToTable && guest.passes > availableChairs;

      if (isToTable && availableChairs <= 0) return;

      const familyRootId = guest.parentId || guest.id;
      const siblingFragment = guests.find(g => 
          g.id !== guest.id && 
          (g.parentId === familyRootId || g.id === familyRootId) && 
          (isToTable ? g.tableId === targetTableId : !g.tableId)
      );

      if (guest.passes > 1 && (isForcedSplit || modoSeparador)) {
           const maxPlaceable = Math.min(guest.passes - 1, availableChairs);
           setSepararCantidad(maxPlaceable);
           setGuestSplitPrompt({ 
              guest, targetTableId, table: targetTable, usedChairs, availableChairs, 
              minPlaceable: 1, maxPlaceable, isForced: isForcedSplit, siblingFragment 
           });
           return;
      }

      if (siblingFragment) {
          const mergedPasses = siblingFragment.passes + guest.passes;
          const mergedSubGuests = [...(siblingFragment.subGuests || []), ...(guest.subGuests || [])];
          setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests });
          deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id));
          return;
      }

      setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guestId), { ...guest, tableId: targetTableId });
      return;
    }

    if (!isEditMode) return;
    const actionType = e.dataTransfer.getData('actionType');
    if (!actionType) return;
    saveHistory(elements, tables);

    const payload = JSON.parse(e.dataTransfer.getData('payload'));
    const rect = e.currentTarget.getBoundingClientRect();
    let w = payload.width || 2; let h = payload.height || 2;
    
    if (actionType === 'new_table' || actionType === 'existing_table') {
      const pType = payload.type || payload.tipo;
      if (['round_table', 'square_table', 'redonda', 'cuadrada'].includes(pType)) { w = 1.5; h = 1.5; }
      else if (['rect_table', 'tablon'].includes(pType)) { w = 2.44; h = 0.7; }
      else if (['ovalada'].includes(pType)) { w = 3.05; h = 1.22; }
      else if (['serpentina'].includes(pType)) { 
         let arcL = 2.44;
         if(payload.configDetalle?.modeloSerpentina === 'mod1') arcL = 1.58;
         if(payload.configDetalle?.modeloSerpentina === 'mod2') arcL = 2.0;
         if(payload.configDetalle?.modeloSerpentina === 'mod3') arcL = 2.1;
         w = arcL / (Math.PI / 2); h = w; 
      }
      else if (['personalizada', 'libre'].includes(pType)) { w = payload.configDetalle?.libreMedidas?.largo || 2; h = payload.configDetalle?.libreMedidas?.ancho || 1; }
    }

    const finalX = ((e.clientX - rect.left) - offsetX) / scale - (w / 2);
    const finalY = ((e.clientY - rect.top) - offsetY) / scale - (h / 2);

    if (actionType === 'existing_table') {
      const updatedTable = tables.find(t => t.id === payload.id);
      if(updatedTable) {
          const newT = { ...updatedTable, x: finalX, y: finalY, width: w, height: h };
          setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", payload.id), newT);
      }
      setSelectedIds([payload.id]);
    } else if (actionType === 'new_table') {
      const newTableId = `mesa_${Date.now()}`;
      const newTable = { id: newTableId, name: `Mesa ${tables.length + 1}`, type: payload.type, capacity: payload.capacity, width: w, height: h, x: finalX, y: finalY, rotation: 0 };
      setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", newTableId), newTable);
      setSelectedIds([newTableId]);
    } else if (actionType === 'structure' || actionType === 'room_area') {
      const newElId = `mapa_${Date.now()}`;
      const newEl = { ...payload, id: newElId, x: finalX, y: finalY, rotation: 0, customLabel: '', mode: payload.mode || 'add' };
      setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", newElId), newEl);
      setSelectedIds([newElId]);
    }
    setActiveTool('select'); 
  };

  const handlePointerDownObject = (e, id, isTable) => {
    if (!isEditMode) return;
    if (activeTool !== 'select' && activeTool !== 'rotate') return;
    e.stopPropagation(); 
    
    const el = (isTable ? tables : elements).find(item => item.id === id);
    if (!el) return;
    saveHistory(elements, tables);

    let currentSelection = [...selectedIds];

    if (e.shiftKey || e.metaKey || e.ctrlKey) {
        if (currentSelection.includes(id)) {
            currentSelection = currentSelection.filter(selId => selId !== id);
        } else {
            if (el.groupId) {
                const groupIds = allItems.filter(x => x.groupId === el.groupId).map(x => x.id);
                currentSelection = [...new Set([...currentSelection, ...groupIds])];
            } else {
                currentSelection.push(id);
            }
        }
        setSelectedIds(currentSelection);
    } else {
        if (!currentSelection.includes(id)) {
            if (el.groupId) {
                currentSelection = allItems.filter(x => x.groupId === el.groupId).map(x => x.id);
            } else if (el.isRoomArea && roomGrouped) {
                currentSelection = elements.filter(x => x.isRoomArea).map(x => x.id);
            } else {
                currentSelection = [id];
            }
            setSelectedIds(currentSelection);
        }
    }
    
    if (currentSelection.length === 0) return;
    
    const targets = allItems.filter(x => currentSelection.includes(x.id));

    if (activeTool === 'rotate') {
       let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
       targets.forEach(t => {
           const w = t.width || 2; const h = t.height || 2;
           if (t.x < minX) minX = t.x; if (t.y < minY) minY = t.y;
           if (t.x + w > maxX) maxX = t.x + w; if (t.y + h > maxY) maxY = t.y + h;
       });
       const cx = minX + (maxX - minX) / 2;
       const cy = minY + (maxY - minY) / 2;
       
       let groupOriginals = {};
       targets.forEach(t => { groupOriginals[t.id] = { x: t.x, y: t.y, rotation: t.rotation || 0, w: t.width||2, h: t.height||2, isTable: t.capacity !== undefined }; });

       const rect = containerRef.current.getBoundingClientRect();
       const startAngle = Math.atan2(((e.clientY - rect.top) - offsetY)/scale - cy, ((e.clientX - rect.left) - offsetX)/scale - cx) * (180 / Math.PI);

       setDragging({ type: 'rotate', id, isTable, cx, cy, origSelection: currentSelection, groupOriginals, startAngle });
       return;
    }

    let groupOriginals = {};
    targets.forEach(t => { groupOriginals[t.id] = {x: t.x, y: t.y, isTable: t.capacity !== undefined}; });
    setDragging({ type: 'move', id, isTable, startX: e.clientX, startY: e.clientY, origX: el.x, origY: el.y, groupOriginals, w: el.width || 2, h: el.height || 2 });
  };

  const handlePointerMove = (e) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if(!rect) return;
    
    const worldX = ((e.clientX - rect.left) - offsetX) / scale;
    const worldY = ((e.clientY - rect.top) - offsetY) / scale;
    setMousePos({x: worldX, y: worldY});

    if (selectionBox) {
        setSelectionBox(prev => ({...prev, currentX: worldX, currentY: worldY}));
        return;
    }

    if (activeTool === 'measure' && measureLine && !measureLine.done) {
       setMeasureLine(prev => ({...prev, x2: worldX, y2: worldY}));
       return;
    }

    if (!dragging) return;
    
    if (dragging.isPanning) {
      setPan({ x: dragging.startPanX + (e.clientX - dragging.startX), y: dragging.startPanY + (e.clientY - dragging.startY) });
      return;
    }

    if (dragging.type === 'rotate') {
      const currentAngle = Math.atan2(worldY - dragging.cy, worldX - dragging.cx) * (180 / Math.PI);
      let deltaAngle = currentAngle - dragging.startAngle;
      deltaAngle = Math.round(deltaAngle / 15) * 15; 

      const rad = deltaAngle * (Math.PI / 180);
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);

      const updateItem = (orig) => {
         const objCx = orig.x + orig.w/2;
         const objCy = orig.y + orig.h/2;
         const newCx = (objCx - dragging.cx) * cos - (objCy - dragging.cy) * sin + dragging.cx;
         const newCy = (objCx - dragging.cx) * sin + (objCy - dragging.cy) * cos + dragging.cy;
         return { x: newCx - orig.w/2, y: newCy - orig.h/2, rotation: orig.rotation + deltaAngle };
      };

      setElements(elements.map(el => dragging.origSelection.includes(el.id) ? { ...el, ...updateItem(dragging.groupOriginals[el.id]) } : el));
      if (setTables) setTables(tables.map(t => dragging.origSelection.includes(t.id) ? { ...t, ...updateItem(dragging.groupOriginals[t.id]) } : t));
      return;
    }

    if (dragging.type === 'move') {
      const dxMeters = (e.clientX - dragging.startX) / scale;
      const dyMeters = (e.clientY - dragging.startY) / scale;
      let finalX = dragging.origX + dxMeters;
      let finalY = dragging.origY + dyMeters;

      let snapGuideX = null; let snapGuideY = null;
      let bestSnapDistX = 0.15; let bestSnapDistY = 0.15;
      const myW = dragging.w; const myH = dragging.h;

      if (Object.keys(dragging.groupOriginals).length === 1) {
          const targetList = [...elements.filter(e => e.isRoomArea), ...placedTables];
          targetList.forEach(other => {
            if (dragging.groupOriginals[other.id]) return; 
            
            const isOtherTable = other.capacity !== undefined;
            if (dragging.isTable && isOtherTable) {
               const t1 = (tables.find(t=>t.id === dragging.id)?.tipo) || (tables.find(t=>t.id === dragging.id)?.type) || '';
               const t2 = other.tipo || other.type || '';
               const noSnap = ['round_table', 'redonda', 'ovalada'];
               if (noSnap.includes(t1) || noSnap.includes(t2)) return;
            }

            const oW = other.width || 2; const oH = other.height || 2;
            const snapsX = [ { dist: Math.abs(finalX - (other.x + oW)), pos: other.x + oW }, { dist: Math.abs((finalX + myW) - other.x), pos: other.x - myW }, { dist: Math.abs(finalX - other.x), pos: other.x }, { dist: Math.abs((finalX + myW) - (other.x + oW)), pos: other.x + oW - myW } ];
            const snapsY = [ { dist: Math.abs(finalY - (other.y + oH)), pos: other.y + oH }, { dist: Math.abs((finalY + myH) - other.y), pos: other.y - myH }, { dist: Math.abs(finalY - other.y), pos: other.y }, { dist: Math.abs((finalY + myH) - (other.y + oH)), pos: other.y + oH - myH } ];

            snapsX.forEach(s => { if (s.dist < bestSnapDistX) { bestSnapDistX = s.dist; finalX = s.pos; snapGuideX = s.pos; } });
            snapsY.forEach(s => { if (s.dist < bestSnapDistY) { bestSnapDistY = s.dist; finalY = s.pos; snapGuideY = s.pos; } });
          });
      }
      setSnapGuides({ x: snapGuideX, y: snapGuideY });

      const finalDx = finalX - dragging.origX;
      const finalDy = finalY - dragging.origY;
      
      setElements(elements.map(el => dragging.groupOriginals[el.id] ? { ...el, x: dragging.groupOriginals[el.id].x + finalDx, y: dragging.groupOriginals[el.id].y + finalDy } : el));
      if (setTables) setTables(tables.map(t => dragging.groupOriginals[t.id] ? { ...t, x: dragging.groupOriginals[t.id].x + finalDx, y: dragging.groupOriginals[t.id].y + finalDy } : t));
    }
  };

  const handlePointerUp = async () => {
    if (selectionBox) {
        const minX = Math.min(selectionBox.startX, selectionBox.currentX);
        const maxX = Math.max(selectionBox.startX, selectionBox.currentX);
        const minY = Math.min(selectionBox.startY, selectionBox.currentY);
        const maxY = Math.max(selectionBox.startY, selectionBox.currentY);
        
        const newSelected = allItems.filter(el => {
           if(el.x === undefined) return false;
           const elW = el.width || 2; const elH = el.height || 2;
           const elMaxX = el.x + elW; const elMaxY = el.y + elH;
           return !(el.x > maxX || elMaxX < minX || el.y > maxY || elMaxY < minY);
        }).map(el => el.id);
        
        if(newSelected.length > 0) setSelectedIds(newSelected);
        setSelectionBox(null);
    }

    if (dragging && dragging.type === 'move') {
        const promesas = Object.keys(dragging.groupOriginals).map(id => {
            const isTab = dragging.groupOriginals[id].isTable;
            const item = isTab ? tables.find(t => String(t.id) === String(id)) : elements.find(e => String(e.id) === String(id));
            const collectionName = isTab ? "mesas" : "mapa";
            return item ? setDoc(doc(db, "eventos", ID_DEL_EVENTO, collectionName, String(id)), item) : Promise.resolve();
        });
        await Promise.all(promesas);
    }
    
    if (dragging && dragging.type === 'rotate') {
        const promesas = dragging.origSelection.map(id => {
            const isTab = dragging.groupOriginals[id].isTable;
            const item = isTab ? tables.find(t => String(t.id) === String(id)) : elements.find(e => String(e.id) === String(id));
            const collectionName = isTab ? "mesas" : "mapa";
            return item ? setDoc(doc(db, "eventos", ID_DEL_EVENTO, collectionName, String(id)), item) : Promise.resolve();
        });
        await Promise.all(promesas);
    }

    setDragging(null);
    setSnapGuides({x:null, y:null});
  };

  const updateElementData = async (id, newData) => {
    saveHistory(elements, tables);
    const el = elements.find(e => String(e.id) === String(id));
    if(el) await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", String(id)), { ...el, ...newData });
  };

  const handleTableConfig = async (id, table, category, field, value, max) => {
    let num = category === 'libreMedidas' ? parseFloat(value) : parseInt(value);
    if (isNaN(num) || num < 0) num = 0;
    if (max !== undefined && max !== null && num > max) num = max;
    
    let newConfig = { ...table.configDetalle };
    
    if (category === 'ladosTablon' && !newConfig.ladosTablon) newConfig.ladosTablon = { top: 5, bottom: 5, left: 1, right: 1 };
    if (category === 'ladosCuadrada' && !newConfig.ladosCuadrada) newConfig.ladosCuadrada = { top: 3, right: 3, bottom: 3, left: 3 };
    if (category === 'ladosOvalada' && !newConfig.ladosOvalada) newConfig.ladosOvalada = { top: 4, bottom: 4, left: 2, right: 2 };
    if (category === 'ladosSerpentina' && !newConfig.ladosSerpentina) newConfig.ladosSerpentina = { ext: 5, int: 2, izq: 1, der: 1 };
    if (category === 'ladosLibre' && !newConfig.ladosLibre) newConfig.ladosLibre = { top: 4, bottom: 4, left: 2, right: 2 };
    if (category === 'libreMedidas' && !newConfig.libreMedidas) newConfig.libreMedidas = { largo: 2.0, ancho: 1.0 };

    if (field) {
      newConfig[category] = { ...newConfig[category], [field]: num };
    } else {
      newConfig[category] = num;
    }
    
    let newCap = table.capacity;
    if (category === 'capacidadRedonda') newCap = num;
    else if (category === 'ladosTablon') newCap = newConfig.ladosTablon.top + newConfig.ladosTablon.bottom + newConfig.ladosTablon.left + newConfig.ladosTablon.right;
    else if (category === 'ladosCuadrada') newCap = newConfig.ladosCuadrada.top + newConfig.ladosCuadrada.bottom + newConfig.ladosCuadrada.left + newConfig.ladosCuadrada.right;
    else if (category === 'ladosOvalada') newCap = newConfig.ladosOvalada.top + newConfig.ladosOvalada.bottom + newConfig.ladosOvalada.left + newConfig.ladosOvalada.right;
    else if (category === 'ladosSerpentina') newCap = newConfig.ladosSerpentina.ext + newConfig.ladosSerpentina.int + newConfig.ladosSerpentina.izq + newConfig.ladosSerpentina.der;
    else if (category === 'ladosLibre') newCap = newConfig.ladosLibre.top + newConfig.ladosLibre.bottom + newConfig.ladosLibre.left + newConfig.ladosLibre.right;
    
    let newW = table.width;
    let newH = table.height;
    if (category === 'libreMedidas') {
      if (field === 'largo') newW = num;
      if (field === 'ancho') newH = num;
    }

    const updatedTable = { ...table, configDetalle: newConfig, capacity: newCap, width: newW, height: newH };
    
    if (setTables) {
      setTables(tables.map(t => String(t.id) === String(id) ? updatedTable : t));
    }

    saveHistory(elements, tables);
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", String(id)), updatedTable);
  };

  const removeFromMapSelected = async () => {
    saveHistory(elements, tables);
    const promesas = [];
    selectedIds.forEach(id => {
      const isTable = tables.some(t => String(t.id) === String(id));
      if (isTable) {
        const t = tables.find(x => String(x.id) === String(id));
        promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", String(id)), { ...t, x: null, y: null, rotation: 0, groupId: null }));
      } else {
        promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", String(id))));
      }
    });
    await Promise.all(promesas);
    setSelectedIds([]);
  };

  const permanentlyDeleteSelected = () => {
    setConfirmDialog({
      title: '¿Eliminar Elementos?',
      message: '¿Estás seguro de eliminar permanentemente estos elementos? Si son mesas, los invitados sentados se soltarán en el plano. Esta acción no se puede deshacer.',
      isDestructive: true,
      onConfirm: async () => {
        saveHistory(elements, tables);
        const promesas = [];
        selectedIds.forEach(id => {
          const isTable = tables.some(t => String(t.id) === String(id));
          if (isTable) {
            promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", String(id))));
            const tableGuests = guests.filter(g => String(g.tableId) === String(id));
            tableGuests.forEach(g => {
               promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", String(g.id)), { ...g, tableId: null }));
            });
          } else {
            promesas.push(deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", String(id))));
          }
        });
        await Promise.all(promesas);
        setSelectedIds([]);
        setConfirmDialog(null);
      }
    });
  };

  const toggleGroupSelection = async () => {
     const firstItem = allItems.find(x => String(x.id) === String(selectedIds[0]));
     const allHaveSameGroup = firstItem && firstItem.groupId && selectedIds.every(id => {
         const item = allItems.find(x => String(x.id) === String(id));
         return item && item.groupId === firstItem.groupId;
     });

     const promesas = [];
     if (allHaveSameGroup) {
        const grpId = firstItem.groupId;
        elements.forEach(e => { if(e.groupId === grpId) promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", String(e.id)), {...e, groupId: null})) });
        tables.forEach(t => { if(t.groupId === grpId) promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", String(t.id)), {...t, groupId: null})) });
     } else {
        const newGroupId = 'grp_' + Date.now();
        selectedIds.forEach(id => {
           const e = elements.find(x => String(x.id) === String(id));
           if (e) promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", String(id)), {...e, groupId: newGroupId}));
           const t = tables.find(x => String(x.id) === String(id));
           if (t) promesas.push(setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", String(id)), {...t, groupId: newGroupId}));
        });
     }
     await Promise.all(promesas);
  };

  const handleSplitChoice = (mode) => {
      if (!guestSplitPrompt) return;
      const promptData = { ...guestSplitPrompt };
      setGuestSplitPrompt(null);
      const { guest, targetTableId, table, usedChairs, siblingFragment } = promptData;

      if (mode === 'all') {
          if (siblingFragment) {
              const mergedPasses = siblingFragment.passes + guest.passes;
              const mergedSubGuests = [...(siblingFragment.subGuests || []), ...(guest.subGuests || [])];
              setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests });
              deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id));
          } else {
              setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), { ...guest, tableId: targetTableId });
          }
      } else if (mode === 'split') {
          const qtyToMove = separarCantidad;
          const qtyRemaining = guest.passes - qtyToMove;

          const subGuestsOriginal = guest.subGuests || [];
          const subGuestsToMove = subGuestsOriginal.slice(0, qtyToMove);
          const subGuestsToKeep = subGuestsOriginal.slice(qtyToMove);

          if (siblingFragment) {
              const mergedPasses = siblingFragment.passes + qtyToMove;
              const mergedSubGuests = [...(siblingFragment.subGuests || []), ...subGuestsToMove];
              setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", siblingFragment.id), { ...siblingFragment, passes: mergedPasses, subGuests: mergedSubGuests });
              setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), { ...guest, passes: qtyRemaining, subGuests: subGuestsToKeep });
          } else {
              const newGuestId = `sep_${Date.now()}`;
              const newGuest = { 
                  ...guest, 
                  id: newGuestId, 
                  parentId: guest.parentId || guest.id,
                  name: guest.name.replace(' (Separado)', ''), 
                  passes: qtyToMove, 
                  childrenPasses: 0, 
                  tableId: targetTableId,
                  subGuests: subGuestsToMove
              };
              setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", guest.id), { ...guest, passes: qtyRemaining, subGuests: subGuestsToKeep });
              setDoc(doc(db, "eventos", ID_DEL_EVENTO, "invitados", newGuestId), newGuest);
          }
      }
  };

  const getTextureStyle = (texture) => {
    switch(texture) {
      case 'grass': return { backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' viewBox=\'0 0 20 20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M2 2c0 1-1 2-2 2v-1c.5 0 1-.5 1-1h1zm16 0c0 1 1 2 2 2v-1c-.5 0-1-.5-1-1h-1zM9 9c0 1-1 2-2 2v-1c.5 0 1-.5 1-1h1zm8 8c0 1-1 2-2 2v-1c.5 0 1-.5 1-1h1z\' fill=\'%2310b981\' fill-opacity=\'0.15\' fill-rule=\'evenodd\'/%3E")', backgroundColor: '#064e3b', color: '#34d399', borderColor: '#059669' };
      case 'water': return { backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'20\' height=\'20\' viewBox=\'0 0 20 20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 10 Q 5 15 10 10 T 20 10\' stroke=\'%2338bdf8\' stroke-width=\'1.5\' fill=\'none\' opacity=\'0.3\'/%3E%3C/svg%3E")', backgroundSize: '100% 20px', backgroundColor: '#082f49', color: '#7dd3fc', borderColor: '#0284c7' };
      case 'wood': return { backgroundImage: 'repeating-linear-gradient(to right, #451a03, #451a03 2px, #78350f 2px, #78350f 20px)', backgroundColor: '#451a03', color: '#fbbf24', borderColor: '#92400e' };
      case 'marble': return { backgroundImage: 'linear-gradient(45deg, #1C1917 25%, #27272a 25%, #27272a 50%, #1C1917 50%, #1C1917 75%, #27272a 75%, #27272a 100%)', backgroundSize: '20px 20px', color: '#e2e8f0', borderColor: '#3f3f46' };
      case 'dance': return { backgroundImage: 'linear-gradient(45deg, #141210 25%, #1C1917 25%, #1C1917 50%, #141210 50%, #141210 75%, #1C1917 75%, #1C1917 100%)', backgroundSize: '40px 40px', backgroundColor: '#141210', color: '#c084fc', borderColor: '#9333ea' };
      default: return { backgroundColor: '#141210', color: '#94a3b8', borderColor: '#334155' };
    }
  };

  const renderContextualMenu = () => {
    if (selectedIds.length === 0) return null;

    if (isMultiSelection) {
       const firstItem = allItems.find(x => String(x.id) === String(selectedIds[0]));
       const allHaveSameGroup = firstItem && firstItem.groupId && selectedIds.every(id => {
           const item = allItems.find(x => String(x.id) === String(id));
           return item && item.groupId === firstItem.groupId;
       });

       return (
         <div className="p-5 bg-[#1C1917] border-b border-[#D4AF37]/20 shrink-0 shadow-[0_10px_20px_rgba(0,0,0,0.5)] relative z-10 text-white">
            <div className="flex items-center justify-between mb-4">
              <span className="text-[11px] font-black uppercase tracking-widest text-[#D4AF37] flex items-center"><Layers size={14} className="mr-1.5"/> {selectedIds.length} Seleccionados</span>
              <button onClick={() => setSelectedIds([])} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={16}/></button>
            </div>
            <div className="flex gap-2">
              <button onClick={toggleGroupSelection} className="flex-1 py-2 bg-[#D4AF37]/10 hover:bg-[#D4AF37]/20 text-[#D4AF37] rounded-lg text-xs font-bold transition-colors flex items-center justify-center border border-[#D4AF37]/30">
                <Link size={14} className="mr-1.5"/> {allHaveSameGroup ? 'Desagrupar' : 'Agrupar'}
              </button>
              <button onClick={removeFromMapSelected} className="flex-1 py-2 bg-white/5 hover:bg-white/10 text-slate-300 rounded-lg text-xs font-bold transition-colors flex items-center justify-center border border-white/10" title="Quitar del plano">
                <Move size={14} className="mr-1.5"/> Quitar
              </button>
              <button onClick={permanentlyDeleteSelected} className="flex-1 py-2 bg-rose-500/10 hover:bg-rose-500/20 text-rose-400 rounded-lg text-xs font-bold transition-colors flex items-center justify-center border border-rose-500/20" title="Eliminar de la BD">
                <Trash2 size={14} className="mr-1.5"/> Eliminar
              </button>
            </div>
         </div>
       );
    }

    let el = allItems.find(i => i.id === selectedIds[0]);
    if (!el) return null;
    
    const isSub = el.mode === 'subtract';
    const isTable = el.capacity !== undefined;
    const tType = el.tipo || el.type;

    let normType = 'libre';
    if (['round_table', 'redonda'].includes(tType)) normType = 'redonda';
    if (['square_table', 'cuadrada'].includes(tType)) normType = 'cuadrada';
    if (['rect_table', 'tablon'].includes(tType)) normType = 'tablon';
    if (tType === 'ovalada') normType = 'ovalada';
    if (tType === 'serpentina') normType = 'serpentina';
    if (['personalizada', 'libre'].includes(tType)) normType = 'libre';

    const config = el.configDetalle || {};

    return (
      <div className="p-5 bg-[#1C1917] border-b border-[#D4AF37]/20 shrink-0 shadow-[0_10px_20px_rgba(0,0,0,0.5)] relative z-10 text-white">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center">
            <span className="text-[11px] font-black uppercase tracking-widest text-[#D4AF37] flex items-center truncate max-w-[150px]"><Settings2 size={16} className="mr-2 text-[#D4AF37]"/> {el.name || el.customLabel || 'Propiedades'}</span>
          </div>
          <button onClick={() => setSelectedIds([])} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={16}/></button>
        </div>

        {el.isRoomArea && (
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-[#141210] p-3 rounded-xl flex items-center justify-between border border-white/10 shadow-inner">
              <span className="text-[9px] text-slate-400 font-bold uppercase tracking-widest">Ancho (m)</span>
              <input type="number" step="0.5" value={el.width} onChange={e => updateElementData(el.id, {width: Math.max(0.5, parseFloat(e.target.value) || 0.5)})} className="w-14 text-right bg-transparent text-sm font-black text-[#D4AF37] outline-none" />
            </div>
            <div className="bg-[#141210] p-3 rounded-xl flex items-center justify-between border border-white/10 shadow-inner">
              <span className="text-[9px] text-slate-400 font-bold uppercase tracking-widest">Largo (m)</span>
              <input type="number" step="0.5" value={el.height} onChange={e => updateElementData(el.id, {height: Math.max(0.5, parseFloat(e.target.value) || 0.5)})} className="w-14 text-right bg-transparent text-sm font-black text-[#D4AF37] outline-none" />
            </div>
            {el.mode !== 'overlay' && (
              <button onClick={() => updateElementData(el.id, {mode: isSub ? 'add' : 'subtract'})} className={`col-span-2 py-3 rounded-xl text-[10px] font-bold uppercase tracking-widest transition-colors shadow-sm border ${isSub ? 'bg-rose-500/10 text-rose-400 hover:bg-rose-500/20 border-rose-500/20' : 'bg-white/5 text-slate-300 hover:bg-white/10 border-white/10'}`}>
                 {isSub ? 'Convertir a Piso Fijo' : 'Convertir a Hueco / Patio'}
              </button>
            )}
          </div>
        )}

        {isTable && (
          <div className="mb-4 space-y-3">
            
            <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/20 p-3 rounded-xl mb-4 flex items-center shadow-inner">
               <Users size={16} className="text-[#D4AF37] mr-2 shrink-0"/>
               <span className="text-[10px] font-black text-[#D4AF37] uppercase tracking-widest leading-tight">Configurar sillas</span>
            </div>

            {normType === 'redonda' && (
              <div className="bg-[#141210] p-3 rounded-xl flex items-center justify-between border border-white/10 shadow-inner">
                <span className="text-[9px] text-slate-400 font-bold uppercase tracking-widest">Sillas Totales</span>
                <input type="number" min="1" max="14" value={config.capacidadRedonda || el.capacity} onChange={e => handleTableConfig(el.id, el, 'capacidadRedonda', null, e.target.value, 14)} className="w-12 text-right bg-transparent text-sm font-black text-[#D4AF37] outline-none" />
              </div>
            )}
            
            {normType === 'tablon' && (
              <div className="bg-[#141210] p-3 rounded-xl border border-white/10 shadow-inner grid grid-cols-2 gap-3">
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Largo 1</span><input type="number" min="0" value={config.ladosTablon?.top ?? 5} onChange={e=>handleTableConfig(el.id, el, 'ladosTablon', 'top', e.target.value, 5)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Largo 2</span><input type="number" min="0" value={config.ladosTablon?.bottom ?? 5} onChange={e=>handleTableConfig(el.id, el, 'ladosTablon', 'bottom', e.target.value, 5)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Cabecera 1</span><input type="number" min="0" value={config.ladosTablon?.left ?? 1} onChange={e=>handleTableConfig(el.id, el, 'ladosTablon', 'left', e.target.value, 1)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Cabecera 2</span><input type="number" min="0" value={config.ladosTablon?.right ?? 1} onChange={e=>handleTableConfig(el.id, el, 'ladosTablon', 'right', e.target.value, 1)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
              </div>
            )}

            {normType === 'cuadrada' && (
              <div className="bg-[#141210] p-3 rounded-xl border border-white/10 shadow-inner grid grid-cols-2 gap-3">
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Lado Arriba</span><input type="number" min="0" value={config.ladosCuadrada?.top ?? 3} onChange={e=>handleTableConfig(el.id, el, 'ladosCuadrada', 'top', e.target.value, 3)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Lado Abajo</span><input type="number" min="0" value={config.ladosCuadrada?.bottom ?? 3} onChange={e=>handleTableConfig(el.id, el, 'ladosCuadrada', 'bottom', e.target.value, 3)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Lado Izq.</span><input type="number" min="0" value={config.ladosCuadrada?.left ?? 3} onChange={e=>handleTableConfig(el.id, el, 'ladosCuadrada', 'left', e.target.value, 3)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Lado Der.</span><input type="number" min="0" value={config.ladosCuadrada?.right ?? 3} onChange={e=>handleTableConfig(el.id, el, 'ladosCuadrada', 'right', e.target.value, 3)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
              </div>
            )}

            {normType === 'ovalada' && (
              <div className="bg-[#141210] p-3 rounded-xl border border-white/10 shadow-inner grid grid-cols-2 gap-3">
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Recto Arriba</span><input type="number" min="0" value={config.ladosOvalada?.top ?? 4} onChange={e=>handleTableConfig(el.id, el, 'ladosOvalada', 'top', e.target.value, 4)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Recto Abajo</span><input type="number" min="0" value={config.ladosOvalada?.bottom ?? 4} onChange={e=>handleTableConfig(el.id, el, 'ladosOvalada', 'bottom', e.target.value, 4)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Curva Izq.</span><input type="number" min="0" value={config.ladosOvalada?.left ?? 2} onChange={e=>handleTableConfig(el.id, el, 'ladosOvalada', 'left', e.target.value, 3)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Curva Der.</span><input type="number" min="0" value={config.ladosOvalada?.right ?? 2} onChange={e=>handleTableConfig(el.id, el, 'ladosOvalada', 'right', e.target.value, 3)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
              </div>
            )}

            {normType === 'serpentina' && (() => {
              const mod = config.modeloSerpentina || 'mod4';
              const sMax = mod === 'mod1' ? {e:3,i:1,s:1} : mod === 'mod2' ? {e:4,i:1,s:1} : mod === 'mod3' ? {e:4,i:1,s:1} : {e:5,i:2,s:1};
              return (
                <div className="bg-[#141210] p-3 rounded-xl border border-white/10 shadow-inner grid grid-cols-2 gap-3">
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Arco Exterior</span><input type="number" min="0" value={config.ladosSerpentina?.ext ?? sMax.e} onChange={e=>handleTableConfig(el.id, el, 'ladosSerpentina', 'ext', e.target.value, sMax.e)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Arco Interior</span><input type="number" min="0" value={config.ladosSerpentina?.int ?? sMax.i} onChange={e=>handleTableConfig(el.id, el, 'ladosSerpentina', 'int', e.target.value, sMax.i)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Ancho Izq.</span><input type="number" min="0" value={config.ladosSerpentina?.izq ?? sMax.s} onChange={e=>handleTableConfig(el.id, el, 'ladosSerpentina', 'izq', e.target.value, sMax.s)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Ancho Der.</span><input type="number" min="0" value={config.ladosSerpentina?.der ?? sMax.s} onChange={e=>handleTableConfig(el.id, el, 'ladosSerpentina', 'der', e.target.value, sMax.s)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                </div>
              );
            })()}

            {normType === 'libre' && (
              <div className="bg-[#141210] p-4 rounded-xl border border-white/10 shadow-inner">
                <div className="text-[9px] font-black text-[#D4AF37] uppercase tracking-wider mb-3">Medidas (Metros)</div>
                <div className="grid grid-cols-2 gap-3 mb-4">
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Largo</span><input type="number" step="0.5" min="0.5" value={config.libreMedidas?.largo ?? 2} onChange={e=>handleTableConfig(el.id, el, 'libreMedidas', 'largo', e.target.value)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Ancho</span><input type="number" step="0.5" min="0.5" value={config.libreMedidas?.ancho ?? 1} onChange={e=>handleTableConfig(el.id, el, 'libreMedidas', 'ancho', e.target.value)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                </div>
                <div className="text-[9px] font-black text-[#D4AF37] uppercase tracking-wider mb-3">Distribución (Sillas)</div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Arriba</span><input type="number" min="0" value={config.ladosLibre?.top ?? 4} onChange={e=>handleTableConfig(el.id, el, 'ladosLibre', 'top', e.target.value)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Abajo</span><input type="number" min="0" value={config.ladosLibre?.bottom ?? 4} onChange={e=>handleTableConfig(el.id, el, 'ladosLibre', 'bottom', e.target.value)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Izquierda</span><input type="number" min="0" value={config.ladosLibre?.left ?? 2} onChange={e=>handleTableConfig(el.id, el, 'ladosLibre', 'left', e.target.value)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                  <div className="flex flex-col"><span className="text-[8px] text-slate-400 font-bold mb-1.5 uppercase">Derecha</span><input type="number" min="0" value={config.ladosLibre?.right ?? 2} onChange={e=>handleTableConfig(el.id, el, 'ladosLibre', 'right', e.target.value)} className="w-full text-xs p-2 border border-white/10 rounded-lg bg-[#1C1917] outline-none text-center font-bold text-white focus:border-[#D4AF37]" /></div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="flex items-center gap-2 pt-4 mt-3 border-t border-white/10">
          {isTable ? (
            <>
              <button onClick={removeFromMapSelected} className="flex-1 py-3 bg-white/5 border border-white/10 text-slate-300 hover:text-white hover:bg-white/10 rounded-xl text-[9px] font-bold uppercase tracking-widest flex items-center justify-center transition-colors" title="Quita la mesa del plano pero la guarda en tu lista">
                <Move size={14} className="mr-1.5"/> Quitar
              </button>
              <button onClick={permanentlyDeleteSelected} className="flex-1 py-3 bg-rose-500/10 border border-rose-500/20 text-rose-400 hover:text-rose-300 hover:bg-rose-500/20 rounded-xl text-[9px] font-bold uppercase tracking-widest flex items-center justify-center transition-colors" title="Elimina la mesa permanentemente">
                <Trash2 size={14} className="mr-1.5"/> Eliminar
              </button>
            </>
          ) : (
            <button onClick={permanentlyDeleteSelected} className="flex-1 py-3 bg-rose-500/10 border border-rose-500/20 text-rose-400 hover:text-rose-300 hover:bg-rose-500/20 rounded-xl text-[10px] font-bold uppercase tracking-widest flex items-center justify-center transition-colors">
              <Trash2 size={14} className="mr-1.5"/> Borrar Área
            </button>
          )}
        </div>
      </div>
    );
  };

  // 🟢 COMPONENTE REUTILIZABLE: LIENZO DEL MAPA
  const canvasContent = (
    <div ref={containerRef} className="flex-1 relative overflow-hidden bg-[#050505] z-10" onDrop={handleDropOnCanvas} onDragOver={(e) => e.preventDefault()}>
             
      {isEditMode && activeTool === 'measure' && (
          <div className="absolute z-[9999] pointer-events-none transform -translate-x-1/2 -translate-y-[150%]" style={{ left: mousePos.x * scale + offsetX, top: mousePos.y * scale + offsetY }}>
            <div className="bg-slate-900/80 backdrop-blur text-white text-[10px] font-mono px-2 py-1 rounded-lg shadow-lg flex flex-col items-center leading-tight">
              <span>X: {mousePos.x.toFixed(1)}</span>
              <span>Y: {mousePos.y.toFixed(1)}</span>
            </div>
          </div>
      )}

      {selectionBox && (
          <div className="absolute border border-indigo-500 bg-indigo-500/20 pointer-events-none z-[9999]"
               style={{
                  left: Math.min(selectionBox.startX, selectionBox.currentX) * scale + offsetX,
                  top: Math.min(selectionBox.startY, selectionBox.currentY) * scale + offsetY,
                  width: Math.abs(selectionBox.currentX - selectionBox.startX) * scale,
                  height: Math.abs(selectionBox.currentY - selectionBox.startY) * scale
               }} />
      )}

      <div 
        className={`absolute inset-0 z-0 touch-none ${activeTool === 'measure' ? 'cursor-crosshair' : (activeTool === 'pan' ? 'cursor-grab active:cursor-grabbing' : (activeTool === 'rotate' ? 'cursor-alias' : 'cursor-default'))}`}
        onPointerDown={(e) => {
          if (e.button === 2) { setMeasureLine(null); return; } 
          
          const rect = containerRef.current.getBoundingClientRect();
          const worldX = ((e.clientX - rect.left) - offsetX) / scale;
          const worldY = ((e.clientY - rect.top) - offsetY) / scale;

          if (activeTool === 'measure') {
            if (!measureLine) {
               setMeasureLine({ x1: worldX, y1: worldY, x2: worldX, y2: worldY, done: false });
            } else if (!measureLine.done) {
               setMeasureLine({ ...measureLine, done: true }); 
            } else {
               setMeasureLine(null);
            }
          } else if (activeTool === 'pan') {
            setSelectedIds([]);
            setDragging({ isPanning: true, startX: e.clientX, startY: e.clientY, startPanX: pan.x, startPanY: pan.y });
          } else if (activeTool === 'select') {
            setSelectionBox({ startX: worldX, startY: worldY, currentX: worldX, currentY: worldY });
            setSelectedIds([]);
          }
        }}
        onContextMenu={(e) => { e.preventDefault(); setMeasureLine(null); }}
      />

      <div className="absolute inset-0 pointer-events-none">
        <svg className="absolute inset-0 w-full h-full pointer-events-none drop-shadow-xl z-10">
           <defs>
             <mask id="roomMask">
               <rect x="-5000" y="-5000" width="10000" height="10000" fill="black" />
               {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'white' }))}
               {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
             </mask>
             <mask id="outerWallMask">
               <rect x="-5000" y="-5000" width="10000" height="10000" fill="white" />
               {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
               {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
             </mask>
             <mask id="subWallMask">
               <rect x="-5000" y="-5000" width="10000" height="10000" fill="black" />
               {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'white' }))}
               {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
             </mask>
           </defs>

           <g transform={`translate(${offsetX}, ${offsetY})`}>
             <rect x="-5000" y="-5000" width="10000" height="10000" fill="#1C1917" mask="url(#roomMask)" />
             <g mask="url(#outerWallMask)">
               {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { stroke: '#D4AF37', strokeWidth: scale * 0.08, strokeLinejoin: 'round', fill: 'none' }))}
             </g>
             <g mask="url(#subWallMask)">
               {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { stroke: '#D4AF37', strokeWidth: scale * 0.08, strokeLinejoin: 'round', fill: 'none' }))}
             </g>
           </g>

           {measureLine && (() => {
             const dx = measureLine.x2 - measureLine.x1; const dy = measureLine.y2 - measureLine.y1;
             const length = Math.sqrt(dx*dx + dy*dy);
             const p1x = measureLine.x1 * scale; const p1y = measureLine.y1 * scale;
             const p2x = measureLine.x2 * scale; const p2y = measureLine.y2 * scale;

             return (
               <g transform={`translate(${offsetX}, ${offsetY})`} className="pointer-events-none z-[9999]">
                  <line x1={p1x} y1={p1y} x2={p2x} y2={p2y} stroke="#0ea5e9" strokeWidth="3" strokeDasharray="6 4" />
                  <circle cx={p1x} cy={p1y} r="6" fill="#0ea5e9" stroke="white" strokeWidth="2" />
                  <circle cx={p2x} cy={p2y} r="6" fill="#0ea5e9" stroke="white" strokeWidth="2" />
                  <g transform={`translate(${p1x + dx/2}, ${p1y + dy/2 - 12})`}>
                     <rect x="-35" y="-15" width="70" height="24" rx="6" fill="#0ea5e9" opacity="0.95" />
                     <text x="0" y="2" fill="white" fontSize="12" fontWeight="bold" textAnchor="middle">{length.toFixed(2)} m</text>
                  </g>
               </g>
             );
           })()}
        </svg>

        {overlayAreas.map((el) => {
          const isSelected = selectedIds.includes(el.id);
          const canInteract = activeTool === 'select' || activeTool === 'rotate';
          const isPool = el.shapeType === 'pool';

          return (
            <div
              key={el.id}
              onPointerDown={(e) => handlePointerDownObject(e, el.id, false)}
              className={`absolute flex items-center justify-center select-none shadow-md transition-shadow duration-300 z-0
                ${canInteract ? 'pointer-events-auto cursor-pointer' : 'pointer-events-none'}
                ${isSelected && canInteract ? 'ring-4 ring-rose-500 ring-offset-2 shadow-2xl' : (canInteract ? 'hover:ring-2 hover:ring-indigo-300' : '')}
              `}
              style={{
                width: el.width * scale, height: el.height * scale,
                left: el.x * scale + offsetX, top: el.y * scale + offsetY,
                transform: `rotate(${el.rotation || 0}deg)`,
                ...getTextureStyle(el.texture),
                boxShadow: isPool ? `inset 0 0 0 ${0.3 * scale}px #94a3b8` : 'none',
                borderRadius: isPool ? '8px' : '0px'
              }}
            >
              <span className="font-extrabold text-center pointer-events-none drop-shadow-md bg-white/40 px-2 py-0.5 rounded backdrop-blur-sm" style={{ fontSize: `${Math.max(0.5, Math.min(el.width, el.height) * 0.25)}rem` }}>
                {el.customLabel || el.name}
              </span>
            </div>
          );
        })}

        {roomAreas.filter(e => e.mode !== 'overlay').map((el) => {
          const isSelected = selectedIds.includes(el.id);
          const isSub = el.mode === 'subtract';
          const canInteract = activeTool === 'select' || activeTool === 'rotate';
          
          return (
            <div
              key={el.id}
              className={`absolute z-20 ${canInteract ? 'pointer-events-auto' : 'pointer-events-none'}`}
              style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale + offsetX, top: el.y * scale + offsetY, transform: `rotate(${el.rotation || 0}deg)` }}
            >
              <div 
                onPointerDown={(e) => handlePointerDownObject(e, el.id, false)}
                className={`w-full h-full cursor-pointer transition-colors duration-300 ${isSelected ? (isSub ? 'bg-rose-500/20 border-2 border-dashed border-rose-600' : 'bg-indigo-500/10 border-2 border-dashed border-indigo-600') : (isSub && canInteract ? 'hover:bg-rose-500/10' : (canInteract ? 'hover:bg-slate-500/5' : ''))}`}
                style={{ clipPath: getShapeClipPath(el) }}
              >
                {el.customLabel && (
                  <span className="absolute inset-0 flex items-center justify-center font-extrabold text-slate-500 opacity-80 uppercase tracking-widest pointer-events-none" style={{ fontSize: `${Math.max(0.6, Math.min(el.width, el.height) * 0.2)}rem` }}>
                    {el.customLabel}
                  </span>
                )}
              </div>
            </div>
          );
        })}

        {physicalStructures.map((el) => {
          const isSelected = selectedIds.includes(el.id);
          const canInteract = activeTool === 'select' || activeTool === 'rotate';
          
          return (
            <div
              key={el.id}
              onPointerDown={(e) => handlePointerDownObject(e, el.id, false)}
              className={`absolute flex items-center justify-center select-none shadow-md transition-shadow duration-300 ${canInteract ? 'pointer-events-auto cursor-pointer' : 'pointer-events-none'}
                ${el.shape} ${el.color} ${el.texture === 'none' ? '' : 'border-[3px]'}
                ${isSelected && canInteract ? 'ring-4 ring-rose-500 ring-offset-2 z-40 shadow-2xl' : (canInteract ? 'hover:ring-2 hover:ring-indigo-300 z-20' : 'z-20')}
              `}
              style={{
                width: el.width * scale, height: el.height * scale,
                left: el.x * scale + offsetX, top: el.y * scale + offsetY,
                transform: `rotate(${el.rotation || 0}deg)`,
                ...getTextureStyle(el.texture)
              }}
            >
              <span className="font-extrabold text-center pointer-events-none drop-shadow-md bg-white/40 px-2 py-0.5 rounded backdrop-blur-sm" style={{ fontSize: `${Math.max(0.5, Math.min(el.width, el.height) * 0.25)}rem` }}>
                {el.customLabel || el.name}
              </span>
            </div>
          );
        })}

        {placedTables.map((el) => {
          const isSelected = selectedIds.includes(el.id);
          const occupancy = guests.filter(g => g.tableId === el.id).reduce((s, g) => s + g.passes, 0);
          const isSearched = globalSearch && guests.some(g => g.tableId === el.id && g.name.toLowerCase().includes(globalSearch.toLowerCase()));
          const canInteract = activeTool === 'select' || activeTool === 'rotate';

          return (
            <div
              key={el.id}
              onPointerDown={(e) => handlePointerDownObject(e, el.id, true)}
              className={`absolute flex items-center justify-center select-none transition-shadow duration-300 ${canInteract ? 'pointer-events-auto cursor-pointer' : 'pointer-events-none'}
                ${isSelected && canInteract ? 'ring-4 ring-rose-500 ring-offset-[6px] rounded-full' : (canInteract ? 'hover:ring-2 hover:ring-indigo-400 hover:ring-offset-4 rounded-full' : '')}
              `}
              style={{
                width: el.width * scale, height: el.height * scale,
                left: el.x * scale + offsetX, top: el.y * scale + offsetY,
                transform: `rotate(${el.rotation || 0}deg)`,
                zIndex: isSearched ? 9999 : (isSelected ? 50 : 40)
              }}
            >
              <TableWithChairs tableData={el} occupancy={occupancy} scale={scale} tableGuests={guests.filter(g => g.tableId === el.id)} searchQuery={globalSearch} />
            </div>
          );
        })}

        <div className="absolute bottom-6 right-6 z-[600] flex flex-col gap-3 pointer-events-none">
          <div className="bg-white/95 backdrop-blur-md p-1.5 rounded-2xl shadow-2xl border border-slate-200 flex flex-col pointer-events-auto">
            <button onClick={() => setScale(s => Math.min(200, s + Math.max(2, s * 0.1)))} className="p-2.5 text-slate-600 hover:bg-slate-100 hover:text-indigo-600 rounded-xl transition-colors" title="Acercar">
              <Plus size={24}/>
            </button>
            <div className="h-px bg-slate-200 mx-2 my-1"></div>
            <button onClick={() => setScale(s => Math.max(5, s - Math.max(2, s * 0.1)))} className="p-2.5 text-slate-600 hover:bg-slate-100 hover:text-indigo-600 rounded-xl transition-colors" title="Alejar">
              <Minus size={24}/>
            </button>
          </div>
          <button onClick={centerAndFitMap} className="bg-white/95 backdrop-blur-md p-3.5 rounded-2xl shadow-2xl border border-slate-200 text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors pointer-events-auto flex items-center justify-center group" title="Ajustar y Centrar Plano">
            <Maximize size={24} className="group-hover:scale-110 transition-transform" />
          </button>
        </div>

      </div>
    </div>
  );

  // 🟢 VISTA DE LECTURA (NORMAL)
  if (!isEditMode) {
    return (
      <div className="h-full flex flex-col space-y-4 pb-6 relative" onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} onMouseLeave={handlePointerUp}>
        <div className="absolute top-6 right-6 z-[600] pointer-events-auto animate-in zoom-in duration-300">
          <button onClick={() => setIsEditMode(true)} className="px-6 py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl text-xs uppercase tracking-widest font-black shadow-[0_10px_25px_rgba(212,175,55,0.25)] flex items-center hover:bg-[#c5a028] transition-all hover:scale-105 border border-[#D4AF37]">
            <Edit2 size={16} className="mr-2"/> Editar Plano
          </button>
        </div>
        <div className="flex-1 bg-[#141210] rounded-3xl border border-[#D4AF37]/25 shadow-xl flex flex-col overflow-hidden relative transition-colors">
          {canvasContent}
        </div>
      </div>
    );
  }

  // 🟢 VISTA DE EDICIÓN EN PANTALLA COMPLETA (PORTAL)
  return createPortal(
    <div 
      className="fixed inset-0 z-[99999] bg-black/85 backdrop-blur-md flex flex-col p-2 md:p-6 animate-in zoom-in-95 duration-200 text-white" 
      onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} onMouseLeave={handlePointerUp}
    >
      <div className="flex-1 bg-[#1C1917] rounded-3xl shadow-[0_25px_70px_rgba(0,0,0,0.9)] flex flex-col overflow-hidden relative border border-[#D4AF37]/30 transition-colors">

        {/* 1. BARRA SUPERIOR (TOP BAR) - Acciones Globales */}
        <div className="bg-[#141210] border-b border-[#D4AF37]/20 px-4 py-4 flex flex-wrap justify-between items-center z-30 shrink-0 gap-3">
           <div className="flex items-center gap-2">
              <button onClick={handleUndo} disabled={history.length === 0} className={`px-4 py-2 rounded-xl text-[10px] uppercase tracking-widest font-black flex items-center transition-colors border ${history.length > 0 ? 'bg-white/5 text-white hover:bg-white/10 border-white/10' : 'bg-transparent text-slate-600 border-white/5 cursor-not-allowed'}`}><RotateCw size={14} className="mr-1.5" style={{ transform: 'scaleX(-1)' }}/> Deshacer</button>
              
              <button onClick={() => { 
                 setConfirmDialog({
                   title: 'Limpiar Plano',
                   message: '¿Estás seguro de limpiar todo el plano? Se vaciarán las mesas pero los invitados no se eliminarán. Esta acción no se puede deshacer.',
                   isDestructive: true,
                   onConfirm: async () => {
                     saveHistory(elements, tables);
                     const promesasMapa = elements.map(e => deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "mapa", String(e.id))));
                     const promesasMesas = placedTables.map(t => setDoc(doc(db, "eventos", ID_DEL_EVENTO, "mesas", String(t.id)), { ...t, x: null, y: null, rotation: 0, groupId: null }));
                     await Promise.all([...promesasMapa, ...promesasMesas]);
                     setSelectedIds([]); 
                     setPan({x:0, y:0});
                     setConfirmDialog(null);
                   }
                 });
               }} className="px-4 py-2 bg-rose-500/10 border border-rose-500/20 text-rose-500 hover:bg-rose-500/20 rounded-xl text-[10px] uppercase tracking-widest font-black flex items-center transition-colors"><Trash2 size={14} className="mr-1.5"/> Limpiar</button>
              
              <div className="hidden md:block w-px h-5 bg-white/10 mx-1"></div>
              <button onClick={() => { setRoomGrouped(!roomGrouped); setSelectedIds([]); }} className={`px-4 py-2 rounded-xl text-[10px] uppercase tracking-widest font-black flex items-center transition-colors border ${roomGrouped ? 'bg-[#D4AF37]/10 border-[#D4AF37]/30 text-[#D4AF37]' : 'bg-white/5 border-white/10 text-slate-300 hover:bg-white/10'}`}>
                {roomGrouped ? <Lock size={14} className="mr-1.5"/> : <Unlock size={14} className="mr-1.5"/>} 
                {roomGrouped ? 'Desbloquear Áreas' : 'Bloquear Áreas'}
              </button>
           </div>

           <div className="flex items-center gap-3">
              <div className="flex items-center bg-[#1C1917] px-4 py-2 rounded-xl border border-white/10">
                 <span className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mr-3">Modo Separador</span>
                 <button onClick={() => setModoSeparador(!modoSeparador)} className={`relative w-8 h-4 rounded-full transition-colors ${modoSeparador ? 'bg-[#D4AF37]' : 'bg-slate-600'}`}>
                   <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${modoSeparador ? 'translate-x-4' : 'translate-x-0'}`}></div>
                 </button>
              </div>
              <div className="hidden md:block w-px h-5 bg-white/10 mx-1"></div>
              <button onClick={() => setShowExportModal(true)} className="px-4 py-2 bg-white/5 border border-white/10 text-white rounded-xl text-[10px] uppercase tracking-widest font-black hover:bg-white/10 transition-colors flex items-center"><FileDown size={14} className="mr-1.5"/> PDF</button>
              
              <button onClick={() => { setIsEditMode(false); setSelectedIds([]); centerAndFitMap(); }} className="px-6 py-2.5 bg-[#D4AF37] text-[#1C1917] rounded-xl text-[10px] uppercase tracking-widest font-black hover:bg-[#c5a028] transition-colors shadow-[0_5px_15px_rgba(212,175,55,0.25)] flex items-center"><CheckCircle size={16} className="mr-1.5"/> Guardar y Cerrar</button>
           </div>
        </div>

        <div className="flex-1 flex flex-col md:flex-row overflow-hidden relative">

           {/* 2. BARRA LATERAL IZQUIERDA (TOOLS) */}
           <div className="w-full md:w-20 bg-[#141210] md:border-r border-b md:border-b-0 border-[#D4AF37]/20 flex md:flex-col items-center justify-center md:justify-start py-2 md:py-6 gap-3 z-20 shrink-0 shadow-[4px_0_15px_-3px_rgba(0,0,0,0.5)] overflow-x-auto">
              <button onClick={() => {setActiveTool('select'); setMeasureLine(null);}} className={`p-4 rounded-xl transition-all ${activeTool === 'select' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_5px_15px_rgba(212,175,55,0.3)] md:scale-110' : 'text-slate-500 hover:bg-white/5 hover:text-white'}`} title="Seleccionar Libre">
                <NavigationIcon size={20} className="-rotate-90" />
              </button>
              <button onClick={() => {setActiveTool('pan'); setSelectedIds([]); setMeasureLine(null);}} className={`p-4 rounded-xl transition-all ${activeTool === 'pan' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_5px_15px_rgba(212,175,55,0.3)] md:scale-110' : 'text-slate-500 hover:bg-white/5 hover:text-white'}`} title="Mover Lienzo">
                <Hand size={20} />
              </button>
              <button onClick={() => { if(selectedIds.length>1) toggleGroupSelection(); else setActiveTool('select'); }} className={`p-4 rounded-xl transition-all ${selectedIds.length > 1 ? 'text-[#D4AF37] bg-[#D4AF37]/10 hover:bg-[#D4AF37]/20 ring-2 ring-[#D4AF37]/30 animate-pulse' : 'text-slate-600 cursor-not-allowed'}`} title="Agrupar Selección">
                <Link size={20} />
              </button>
              <div className="hidden md:block w-8 h-px bg-white/10 my-2"></div>
              <div className="md:hidden h-8 w-px bg-white/10 mx-2"></div>
              <button onClick={() => {setActiveTool('measure'); setSelectedIds([]);}} className={`p-4 rounded-xl transition-all ${activeTool === 'measure' ? 'bg-sky-500 text-white shadow-[0_5px_15px_rgba(14,165,233,0.3)] md:scale-110' : 'text-slate-500 hover:bg-white/5 hover:text-white'}`} title="Cinta Métrica">
                <Spline size={20} />
              </button>
              <div className="hidden md:block w-8 h-px bg-white/10 my-2"></div>
              <div className="md:hidden h-8 w-px bg-white/10 mx-2"></div>
              <button onClick={() => setActiveTool('rotate')} className={`p-4 rounded-xl transition-all ${activeTool === 'rotate' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_5px_15px_rgba(212,175,55,0.3)] md:scale-110' : 'text-slate-500 hover:bg-white/5 hover:text-white'}`} title="Girar Selección">
                <RotateCw size={20} />
              </button>
           </div>

           {/* 3. LIENZO CENTRAL */}
           {canvasContent}

           {/* 4. PANEL LATERAL DERECHO (INSPECTOR Y LIBRERÍA) */}
           <div className="w-full md:w-[320px] border-l border-[#D4AF37]/20 bg-[#141210] flex flex-col z-20 shrink-0 shadow-[-4px_0_15px_-3px_rgba(0,0,0,0.5)]">
              
              {/* Inspector Contextual */}
              <div className="shrink-0 empty:hidden">
                 {renderContextualMenu()}
              </div>
              
              {/* Catálogo / Librería */}
              <div className="p-4 overflow-y-auto flex-1 custom-scrollbar">
                
                <h3 className="font-bold text-white mb-3 text-[10px] uppercase tracking-wider flex items-center">
                  <Spline size={14} className="mr-2 text-slate-500"/> 1. Áreas y Exteriores
                </h3>
                <div className="grid grid-cols-3 gap-2 mb-6">
                  {ROOM_AREAS_CATALOG.map((tmpl, idx) => {
                    if (tmpl.shapeType === 'polygon') return null; 
                    return (
                      <div key={idx} draggable onDragStart={(e) => handleDragStart(e, tmpl, 'room_area')} className="bg-[#1C1917] p-2 rounded-xl border border-white/10 text-center cursor-grab active:cursor-grabbing hover:bg-white/5 hover:border-white/30 transition-colors shadow-sm">
                         <div className="h-6 flex items-center justify-center mb-1 text-slate-400">
                            <div 
                              className="border border-slate-500 bg-[#141210]" 
                              style={{ 
                                width: '20px', height: '20px',
                                borderRadius: tmpl.shapeType === 'ellipse' && tmpl.name === 'Área Circular' ? '50%' : tmpl.shapeType === 'ellipse' ? '50%' : '3px',
                                clipPath: tmpl.shapeType === 'triangle' ? 'polygon(0 0, 0 100%, 100% 100%)' : 'none',
                                ...(tmpl.mode === 'overlay' ? getTextureStyle(tmpl.texture) : {})
                              }}
                            ></div>
                         </div>
                         <p className="text-[9px] font-bold text-slate-400 leading-tight">{tmpl.name}</p>
                      </div>
                    );
                  })}
                </div>

                <h3 className="font-bold text-[#D4AF37] mb-3 text-[10px] uppercase tracking-wider flex items-center pt-4 border-t border-white/10">
                  <Users size={14} className="mr-2 text-[#D4AF37]/50"/> 2. Mesas Reales ({availableTables.length})
                </h3>
                <div className="space-y-2 mb-6">
                  {availableTables.map((table) => {
                    const occupancy = guests.filter(g => g.tableId === table.id).reduce((s, g) => s + g.passes, 0);
                    const tType = table.tipo || table.type;
                    let tW = 1.5, tH = 1.5;
                    if (tType === 'rect_table' || tType === 'tablon') { tW = 2.44; tH = 0.7; }
                    else if (tType === 'ovalada') { tW = 3.05; tH = 1.22; }
                    else if (tType === 'serpentina') { tW = 1.8; tH = 1.8; }
                    else if (tType === 'personalizada' || tType === 'libre') { tW = table.configDetalle?.libreMedidas?.largo || 2; tH = table.configDetalle?.libreMedidas?.ancho || 1; }

                    return (
                      <div key={table.id} draggable onDragStart={(e) => handleDragStart(e, {id: table.id, width: tW, height: tH}, 'existing_table')} className="bg-[#1C1917] p-2 rounded-xl border border-white/10 shadow-sm cursor-grab active:cursor-grabbing hover:border-[#D4AF37]/50 transition-all flex items-center">
                        <div className="w-8 h-8 bg-[#141210] rounded-lg flex items-center justify-center mr-3 text-[#D4AF37] flex-shrink-0">
                          {table.tipo === 'round_table' || table.tipo === 'redonda' ? <div className="w-3.5 h-3.5 rounded-full border-2 border-current"></div> : <div className="w-3.5 h-3.5 rounded-sm border-2 border-current"></div>}
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-bold text-white truncate">{table.name}</p>
                          <p className="text-[9px] text-slate-500 uppercase font-bold tracking-widest mt-0.5">{occupancy}/{table.capacity} Sillas</p>
                        </div>
                      </div>
                    );
                  })}
                  {availableTables.length === 0 && <p className="text-[10px] text-slate-500 italic text-center py-4 bg-[#1C1917] rounded-xl border border-dashed border-white/10">Todas ubicadas en el plano.</p>}
                </div>

                <h3 className="font-bold text-emerald-400 mb-3 text-[10px] uppercase tracking-wider flex items-center pt-4 border-t border-white/10">
                  <Plus size={14} className="mr-2 text-emerald-500/50"/> 3. Mesas Extra
                </h3>
                <div className="grid grid-cols-4 gap-2 mb-6">
                  {TABLE_TEMPLATES.map((tmpl, idx) => {
                    let iconEl;
                    if (tmpl.type === 'round_table') iconEl = <div className="mx-auto mb-1 border-2 border-emerald-400 rounded-full w-5 h-5"></div>;
                    else if (tmpl.type === 'square_table') iconEl = <div className="mx-auto mb-1 border-2 border-emerald-400 rounded-sm w-5 h-5"></div>;
                    else if (tmpl.type === 'rect_table') iconEl = <div className="mx-auto mb-1 border-2 border-emerald-400 rounded-sm w-6 h-3 mt-1"></div>;
                    else if (tmpl.type === 'ovalada') iconEl = <div className="mx-auto mb-1 border-2 border-emerald-400 rounded-[10px] w-6 h-3 mt-1"></div>;
                    else if (tmpl.type === 'serpentina') iconEl = (
                      <svg className="mx-auto mb-1" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M 2 18 A 16 16 0 0 1 18 2 L 18 7 A 11 11 0 0 0 7 18 Z" fill="none" stroke="#34d399" strokeWidth="2" />
                      </svg>
                    );

                    return (
                      <div key={idx} draggable onDragStart={(e) => handleDragStart(e, tmpl, 'new_table')} className="bg-[#1C1917] p-2 rounded-xl border border-white/10 text-center cursor-grab active:cursor-grabbing hover:border-emerald-500/50 transition-colors shadow-sm">
                         {iconEl}
                         <p className="text-[9px] font-bold text-slate-400 leading-tight mt-1">{tmpl.name}</p>
                      </div>
                    );
                  })}
                </div>

                <h3 className="font-bold text-slate-400 mb-3 text-[10px] uppercase tracking-wider flex items-center pt-4 border-t border-white/10">
                  <Move size={14} className="mr-2 text-slate-600"/> 4. Físico
                </h3>
                <div className="space-y-2">
                  {STRUCTURAL_CATALOG.map((item, idx) => (
                    <div key={idx} draggable onDragStart={(e) => handleDragStart(e, item, 'structure')} className="bg-[#1C1917] p-2 rounded-xl border border-white/10 shadow-sm cursor-grab active:cursor-grabbing hover:border-white/30 transition-all flex items-center">
                      <div className="w-10 h-10 rounded-lg flex items-center justify-center mr-3 border border-white/10 flex-shrink-0 shadow-inner" style={getTextureStyle(item.texture)}></div>
                      <div>
                        <p className="text-sm font-bold text-white leading-tight">{item.name}</p>
                        <p className="text-[9px] text-slate-500 uppercase tracking-widest font-bold mt-0.5">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
           </div>

        </div>
      </div>

      {/* 🟢 MODALES DENTRO DEL MODO EDICIÓN (POR ENCIMA DEL PORTAL) */}
      
      {/* Modal de Confirmación */}
      {confirmDialog && (
        <div className="fixed inset-0 z-[100000] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in pointer-events-auto">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden p-8 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 border border-[#D4AF37]/30 text-white">
            <div className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner border ${confirmDialog.isDestructive ? 'bg-rose-500/10 text-rose-500 border-rose-500/20' : 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/20'}`}>
              {confirmDialog.isDestructive ? <Trash2 size={36} /> : <AlertTriangle size={36} />}
            </div>
            <h3 className="font-editorial font-black text-2xl text-white mb-3">{confirmDialog.title}</h3>
            <p className="text-slate-400 mb-8 text-sm leading-relaxed">
              {confirmDialog.message}
            </p>
            <div className="flex gap-3">
              <button onClick={() => setConfirmDialog(null)} className="flex-1 p-4 bg-white/5 text-slate-300 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition-colors border border-white/10">
                Cancelar
              </button>
              <button onClick={confirmDialog.onConfirm} className={`flex-1 p-4 text-[#1C1917] rounded-xl font-black uppercase tracking-widest text-[10px] shadow-[0_10px_25px_rgba(0,0,0,0.5)] transition-transform active:scale-95 ${confirmDialog.isDestructive ? 'bg-rose-500 text-white hover:bg-rose-600' : 'bg-[#D4AF37] hover:bg-[#c5a028]'}`}>
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Inteligente de Separación de Invitados */}
      {guestSplitPrompt && (
        <div className="fixed inset-0 z-[100000] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in pointer-events-auto">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden p-8 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 border border-[#D4AF37]/30 text-white">
            <div className="w-20 h-20 bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/30 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner"><Users size={32} /></div>
            <h3 className="font-editorial font-black text-2xl text-white mb-2">Acomodar Grupo</h3>
            
            {guestSplitPrompt.isForced ? (
                <p className="text-rose-400 mb-6 text-sm leading-relaxed">
                   Esta mesa es para <b className="text-white">{guestSplitPrompt.table.capacity} personas</b> y solo quedan <b className="text-white">{guestSplitPrompt.availableChairs} sillas libres</b>. La familia <b className="text-white">{guestSplitPrompt.guest.name}</b> ({guestSplitPrompt.guest.passes} pases) supera la capacidad.<br/><br/>¿Cuántos deseas acomodar en esta mesa?
                </p>
            ) : (
                <p className="text-slate-400 mb-6 text-sm leading-relaxed">
                   <b className="text-white">{guestSplitPrompt.guest.name}</b> tiene {guestSplitPrompt.guest.passes} pases y hay {guestSplitPrompt.availableChairs} sillas libres en esta mesa.<br/><br/>¿Cuántos deseas acomodar aquí?
                </p>
            )}

            <div className="flex items-center justify-center gap-4 mb-6 bg-[#141210] p-4 rounded-2xl border border-white/10">
                <button 
                   onClick={() => setSepararCantidad(Math.max(guestSplitPrompt.minPlaceable, separarCantidad - 1))}
                   disabled={separarCantidad <= guestSplitPrompt.minPlaceable}
                   className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center font-black text-white disabled:opacity-30 transition-colors hover:bg-white/10"
                >-</button>
                <div className="text-4xl font-black text-[#D4AF37] w-14 text-center">{separarCantidad}</div>
                <button 
                   onClick={() => setSepararCantidad(Math.min(guestSplitPrompt.maxPlaceable, separarCantidad + 1))}
                   disabled={separarCantidad >= guestSplitPrompt.maxPlaceable}
                   className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center font-black text-white disabled:opacity-30 transition-colors hover:bg-white/10"
                >+</button>
            </div>

            <div className="flex flex-col space-y-3">
              <button onClick={() => handleSplitChoice('split')} className="w-full p-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black uppercase tracking-widest text-[10px] shadow-[0_5px_15px_rgba(212,175,55,0.25)] transition-colors hover:bg-[#c5a028] active:scale-95">Mover {separarCantidad} pase(s)</button>
              
              {!guestSplitPrompt.isForced && (
                 <button onClick={() => handleSplitChoice('all')} className="w-full p-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition-colors">Mover familia ({guestSplitPrompt.guest.passes})</button>
              )}
              
              <button onClick={() => setGuestSplitPrompt(null)} className="w-full p-3 text-slate-500 font-bold hover:text-slate-300 mt-2 transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Exportación a PDF */}
      {showExportModal && (
        <div className="fixed inset-0 z-[100000] bg-slate-900/95 flex flex-col overflow-hidden backdrop-blur-sm">
          <div className="bg-slate-900 text-white p-4 flex flex-col sm:flex-row justify-between items-center shadow-lg border-b border-slate-700 z-10 shrink-0 gap-4">
            <div className="flex items-center space-x-4 w-full sm:w-auto">
              <button onClick={() => setShowExportModal(false)} className="p-2 hover:bg-slate-800 rounded-full transition-colors"><X size={24}/></button>
              <div>
                <h3 className="font-bold text-sm">Vista Previa de Exportación</h3>
                <p className="text-[10px] text-slate-400">Ajusta el zoom, bloquea y descarga.</p>
              </div>
            </div>
            <button onClick={triggerPdfDownload} disabled={isPreparingPrint} className="px-6 py-3 bg-indigo-600 hover:bg-indigo-500 rounded-xl text-sm font-bold flex items-center shadow-lg transition-all w-full sm:w-auto justify-center disabled:bg-slate-600">
              {isPreparingPrint ? <RefreshCw size={18} className="mr-2 animate-spin"/> : <Download size={18} className="mr-2"/>} 
              {isPreparingPrint ? 'Armando PDF...' : 'Guardar PDF'}
            </button>
          </div>
          
          <div className="flex-1 overflow-y-auto custom-scrollbar flex flex-col items-center py-8 relative gap-8">
             <div className="bg-white shadow-[0_0_40px_rgba(0,0,0,0.5)] relative shrink-0 map-pdf-page flex flex-col" style={{ width: '279.4mm', height: '215.9mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden' }}>
               
               <header className="border-b-4 border-slate-900 pb-2 mb-4 flex justify-between items-end shrink-0">
                 <div>
                   <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Plano y Acomodo</h1>
                   <p className="text-slate-500 text-sm font-medium">Proyecto: Proyecto Actual</p>
                 </div>
                 <div className="text-right">
                   <p className="text-xs font-bold text-slate-400">Escala Ajustada (Carta Horizontal)</p>
                 </div>
               </header>

               <div 
                 onPointerDown={handlePrintPointerDown} onPointerMove={handlePrintPointerMove} onPointerUp={handlePrintPointerUp} onPointerLeave={handlePrintPointerUp} onWheel={handlePrintWheel}
                 className={`w-full flex-1 bg-[#eef2f6] border-2 border-slate-300 rounded-xl relative overflow-hidden flex shadow-inner ${isBlueprintPanActive ? 'cursor-grab active:cursor-grabbing touch-none ring-4 ring-indigo-300' : ''}`}
               >
                 {!isCapturingPdf && (
                   <div className="absolute top-3 left-3 z-50 flex flex-col sm:flex-row items-start sm:items-center gap-2">
                     <button onClick={() => setIsBlueprintPanActive(!isBlueprintPanActive)} className={`px-3 py-2 transition-colors rounded-xl font-bold text-[10px] flex items-center shadow-lg border border-slate-700 ${isBlueprintPanActive ? 'bg-indigo-500 text-white' : 'bg-slate-900/90 text-white hover:bg-slate-800'}`}>
                       <Hand size={14} className="mr-1.5"/> {isBlueprintPanActive ? 'Arrastre Activo (Bloquear para PDF)' : 'Activar Arrastre'}
                     </button>
                     <div className="bg-slate-900/90 backdrop-blur text-white rounded-xl shadow-lg flex items-center pointer-events-auto border border-slate-700">
                       <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPrintScale(s => Math.max(0.1, s - 0.15)); }} className="p-3 hover:bg-white/20 transition-colors rounded-l-xl active:bg-white/30 touch-manipulation"><Minus size={16} /></button>
                       <div className="w-px h-5 bg-white/20"></div>
                       <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPrintScale(s => Math.min(5, s + 0.15)); }} className="p-3 hover:bg-white/20 transition-colors rounded-r-xl active:bg-white/30 touch-manipulation"><Plus size={16} /></button>
                     </div>
                   </div>
                 )}

                 <div style={{ transform: `translate(${printPan.x}px, ${printPan.y}px) scale(${printScale})`, transformOrigin: '0 0', width: '100%', height: '100%' }}>
                   <svg className="absolute inset-0 w-full h-full pointer-events-none z-10" style={{ overflow: 'visible' }}>
                      <defs>
                        <mask id="printRoomMask">
                          <rect x="-5000" y="-5000" width="10000" height="10000" fill="black" />
                          {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'white' }))}
                          {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
                        </mask>
                        <mask id="printOuterWallMask">
                          <rect x="-5000" y="-5000" width="10000" height="10000" fill="white" />
                          {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
                          {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
                        </mask>
                        <mask id="printSubWallMask">
                          <rect x="-5000" y="-5000" width="10000" height="10000" fill="black" />
                          {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'white' }))}
                          {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { fill: 'black' }))}
                        </mask>
                      </defs>
                      <g>
                        <rect x="-5000" y="-5000" width="10000" height="10000" fill="#ffffff" mask="url(#printRoomMask)" />
                        <g mask="url(#printOuterWallMask)">
                          {addAreas.map(el => renderSVGShape(el, scale, 0, 0, { stroke: '#1e293b', strokeWidth: scale * 0.10, strokeLinejoin: 'round', fill: 'none' }))}
                        </g>
                        <g mask="url(#printSubWallMask)">
                          {subAreas.map(el => renderSVGShape(el, scale, 0, 0, { stroke: '#1e293b', strokeWidth: scale * 0.10, strokeLinejoin: 'round', fill: 'none' }))}
                        </g>
                      </g>
                   </svg>

                   {overlayAreas.map((el) => (
                     <div key={el.id} className="absolute flex items-center justify-center select-none pointer-events-none z-0" style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale, top: el.y * scale, transform: `rotate(${el.rotation || 0}deg)`, ...getTextureStyle(el.texture), boxShadow: el.shapeType === 'pool' ? `inset 0 0 0 ${0.3 * scale}px #94a3b8` : 'none', borderRadius: el.shapeType === 'pool' ? '8px' : '0px' }}>
                       <span className="font-extrabold text-center drop-shadow-md bg-white/40 px-2 py-0.5 rounded backdrop-blur-sm" style={{ fontSize: `${Math.max(0.5, Math.min(el.width, el.height) * 0.25)}rem` }}>{el.customLabel || el.name}</span>
                     </div>
                   ))}

                   {roomAreas.filter(e => e.mode !== 'overlay').map((el) => (
                     <div key={el.id} className="absolute z-20 pointer-events-none" style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale, top: el.y * scale, transform: `rotate(${el.rotation || 0}deg)` }}>
                       <div className="w-full h-full" style={{ clipPath: getShapeClipPath(el) }}>
                         {el.customLabel && <span className="absolute inset-0 flex items-center justify-center font-extrabold text-slate-500 opacity-80 uppercase tracking-widest pointer-events-none" style={{ fontSize: `${Math.max(0.6, Math.min(el.width, el.height) * 0.2)}rem` }}>{el.customLabel}</span>}
                       </div>
                     </div>
                   ))}

                   {physicalStructures.map((el) => (
                     <div key={el.id} className={`absolute flex items-center justify-center select-none shadow-md pointer-events-none z-20 ${el.shape} ${el.color} ${el.texture === 'none' ? '' : 'border-[3px]'}`} style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale, top: el.y * scale, transform: `rotate(${el.rotation || 0}deg)`, ...getTextureStyle(el.texture) }}>
                       <span className="font-extrabold text-center drop-shadow-md bg-white/40 px-2 py-0.5 rounded backdrop-blur-sm" style={{ fontSize: `${Math.max(0.5, Math.min(el.width, el.height) * 0.25)}rem` }}>{el.customLabel || el.name}</span>
                     </div>
                   ))}

                   {placedTables.map((el) => {
                     const occupancy = guests.filter(g => g.tableId === el.id).reduce((s, g) => s + g.passes, 0);
                     return (
                       <div key={el.id} className="absolute flex items-center justify-center select-none pointer-events-none z-40" style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale, top: el.y * scale, transform: `rotate(${el.rotation || 0}deg)` }}>
                         <TableWithChairs tableData={el} occupancy={occupancy} scale={scale} tableGuests={guests.filter(g => g.tableId === el.id)} searchQuery={""} />
                       </div>
                     );
                   })}
                 </div>
               </div>
             </div>
          </div>
        </div>
      )}

      {/* Modal Inteligente de Separación de Invitados */}
      {guestSplitPrompt && (
        <div className="fixed inset-0 z-[100000] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in pointer-events-auto">
          <div className="bg-white rounded-3xl w-full max-w-sm overflow-hidden p-6 text-center shadow-2xl animate-in zoom-in-95 border border-slate-200">
            <div className="w-16 h-16 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4"><Users size={32} /></div>
            <h3 className="font-bold text-xl text-slate-800 mb-2">Acomodar Grupo</h3>
            
            {guestSplitPrompt.isForced ? (
                <p className="text-rose-500 mb-4 text-[13px] font-medium leading-relaxed">
                   Esta mesa es para <b>{guestSplitPrompt.table.capacity} personas</b> y solo quedan <b>{guestSplitPrompt.availableChairs} sillas disponibles</b>. La familia <b>{guestSplitPrompt.guest.name}</b> ({guestSplitPrompt.guest.passes} pases) supera la capacidad.<br/><br/>¿Cuántos deseas acomodar en esta mesa?
                </p>
            ) : (
                <p className="text-slate-500 mb-4 text-[13px] leading-relaxed">
                   <b>{guestSplitPrompt.guest.name}</b> tiene {guestSplitPrompt.guest.passes} pases y hay {guestSplitPrompt.availableChairs} sillas libres en esta mesa.<br/><br/>¿Cuántos deseas acomodar aquí?
                </p>
            )}

            <div className="flex items-center justify-center gap-4 mb-6 bg-slate-50 p-4 rounded-2xl border border-slate-100">
                <button 
                   onClick={() => setSepararCantidad(Math.max(guestSplitPrompt.minPlaceable, separarCantidad - 1))}
                   disabled={separarCantidad <= guestSplitPrompt.minPlaceable}
                   className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center font-black text-slate-800 shadow-sm disabled:opacity-30"
                >-</button>
                <div className="text-3xl font-black text-indigo-600 w-12 text-center">{separarCantidad}</div>
                <button 
                   onClick={() => setSepararCantidad(Math.min(guestSplitPrompt.maxPlaceable, separarCantidad + 1))}
                   disabled={separarCantidad >= guestSplitPrompt.maxPlaceable}
                   className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center font-black text-slate-800 shadow-sm disabled:opacity-30"
                >+</button>
            </div>

            <div className="flex flex-col space-y-2">
              <button onClick={() => handleSplitChoice('split')} className="w-full p-3 bg-indigo-600 text-white rounded-xl font-bold uppercase tracking-widest text-[10px] shadow-md transition-transform active:scale-95">Mover {separarCantidad} pase(s)</button>
              
              {!guestSplitPrompt.isForced && (
                 <button onClick={() => handleSplitChoice('all')} className="w-full p-3 bg-slate-100 text-slate-700 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-slate-200 transition-colors">Mover familia completa ({guestSplitPrompt.guest.passes})</button>
              )}
              
              <button onClick={() => setGuestSplitPrompt(null)} className="w-full p-3 text-slate-400 font-bold hover:text-slate-600 mt-2 transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
            </div>
          </div>
        </div>
      )}

    </div>,
    document.getElementById('root') || document.body // <--- Usamos el contenedor seguro de React
  );
};

// ==========================================
// COMPONENTES AUXILIARES PARA MAPAVIEW (DEBEN ESTAR FUERA DE MAPAVIEW PERO EN EL MISMO ARCHIVO)
// ==========================================

const TABLE_TEMPLATES = [
  { type: 'round_table', name: 'Mesa Redonda', width: 1.5, height: 1.5, capacity: 10, desc: 'Ø 1.5m' },
  { type: 'square_table', name: 'Mesa Cuadrada', width: 1.5, height: 1.5, capacity: 12, desc: '1.5x1.5m' },
  { type: 'rect_table', name: 'Tablón', width: 2.44, height: 0.7, capacity: 10, desc: '2.4x0.7m' },
  { type: 'ovalada', name: 'Mesa Ovalada', width: 3.05, height: 1.22, capacity: 12, desc: '3.0x1.2m' },
  { type: 'serpentina', name: 'Serpentina', width: 1.8, height: 1.8, capacity: 9, desc: 'Curva' }
];

const STRUCTURAL_CATALOG = [
  { type: 'dance_floor', name: 'Pista Baile', width: 5, height: 5, shape: 'rounded-none', color: 'border-fuchsia-400 text-fuchsia-900', texture: 'dance', desc: '5x5m' },
  { type: 'stage', name: 'Escenario', width: 6, height: 3, shape: 'rounded-sm', color: 'border-amber-900 text-amber-50', texture: 'wood', desc: '6x3m' },
  { type: 'bar', name: 'Barra', width: 3, height: 0.8, shape: 'rounded-sm', color: 'border-zinc-800 text-white', texture: 'marble', desc: '3x0.8m' },
  { type: 'garden', name: 'Jardín', width: 6, height: 4, shape: 'rounded-xl', color: 'border-green-600 text-green-900', texture: 'grass', desc: 'Área Verde' },
  { type: 'pool', name: 'Alberca', width: 6, height: 4, shape: 'rounded-lg', color: 'border-cyan-500 text-cyan-900', texture: 'water', desc: 'Piscina' }
];

const ROOM_AREAS_CATALOG = [
  { type: 'room_area', shapeType: 'rect', name: 'Área Cuadrada', width: 8, height: 8, isRoomArea: true, mode: 'add' },
  { type: 'room_area', shapeType: 'ellipse', name: 'Área Circular', width: 8, height: 8, isRoomArea: true, mode: 'add' },
  { type: 'room_area', shapeType: 'triangle', name: 'Área Triangular', width: 8, height: 8, isRoomArea: true, triangleCorner: 0, mode: 'add' }, 
  { type: 'room_area', shapeType: 'polygon', name: 'Polígono Libre', width: 8, height: 8, isRoomArea: true, sides: 5, mode: 'add' },
  { type: 'room_area', shapeType: 'rect', name: 'Jardín', width: 10, height: 10, isRoomArea: true, mode: 'overlay', texture: 'grass' },
  { type: 'room_area', shapeType: 'rect', name: 'Terraza', width: 10, height: 6, isRoomArea: true, mode: 'overlay', texture: 'wood' },
  { type: 'room_area', shapeType: 'pool', name: 'Alberca', width: 8, height: 4, isRoomArea: true, mode: 'overlay', texture: 'water' }
];

const getShapeClipPath = (el) => {
  if (el.shapeType === 'ellipse') return 'ellipse(50% 50% at 50% 50%)';
  if (el.shapeType === 'triangle') {
    const c = el.triangleCorner || 0;
    if (c === 0) return 'polygon(0% 0%, 0% 100%, 100% 100%)'; 
    if (c === 1) return 'polygon(0% 100%, 100% 100%, 100% 0%)'; 
    if (c === 2) return 'polygon(0% 0%, 100% 0%, 100% 100%)'; 
    if (c === 3) return 'polygon(0% 0%, 100% 0%, 0% 100%)'; 
  }
  if (el.shapeType === 'polygon') {
    const sides = el.sides || 5;
    let pts = [];
    for(let i=0; i<sides; i++){
      const angle = (i * 2 * Math.PI / sides) - Math.PI / 2;
      pts.push(`${(50 + 50 * Math.cos(angle)).toFixed(1)}% ${(50 + 50 * Math.sin(angle)).toFixed(1)}%`);
    }
    return `polygon(${pts.join(', ')})`;
  }
  return 'none';
};

const renderSVGShape = (el, scale, minX, minY, props) => {
  if (el.shapeType === 'custom_polygon' && el.absPoints) {
      const pts = el.absPoints.map(p => `${(p.x - minX) * scale},${(p.y - minY) * scale}`).join(' ');
      return <polygon key={el.id} points={pts} {...props} />;
  }

  const w = el.width * scale;
  const h = el.height * scale;
  const x = (el.x - minX) * scale;
  const y = (el.y - minY) * scale;
  const tRegular = `rotate(${el.rotation || 0} ${x + w/2} ${y + h/2})`;

  if (el.shapeType === 'ellipse') {
    return <ellipse key={el.id} cx={x + w/2} cy={y + h/2} rx={w/2} ry={h/2} transform={tRegular} {...props} />;
  }
  if (el.shapeType === 'triangle') {
    let points = '';
    const corner = el.triangleCorner || 0; 
    if (corner === 0) points = `${x},${y} ${x},${y + h} ${x + w},${y + h}`; 
    else if (corner === 1) points = `${x},${y + h} ${x + w},${y + h} ${x + w},${y}`; 
    else if (corner === 2) points = `${x},${y} ${x + w},${y} ${x + w},${y + h}`; 
    else if (corner === 3) points = `${x},${y} ${x + w},${y} ${x},${y + h}`; 
    return <polygon key={el.id} points={points} transform={tRegular} {...props} />;
  }
  if (el.sides && el.sides > 2) {
    const sides = el.sides;
    const cx = x + w/2; const cy = y + h/2;
    const rX = w / 2; const rY = h / 2;
    let points = [];
    for (let i = 0; i < sides; i++) {
      const angle = (i * 2 * Math.PI / sides) - Math.PI / 2;
      points.push(`${cx + rX * Math.cos(angle)},${cy + rY * Math.sin(angle)}`);
    }
    return <polygon key={el.id} points={points.join(' ')} transform={tRegular} {...props} />;
  }
  
  return <rect key={el.id} x={x} y={y} width={w} height={h} transform={tRegular} {...props} />;
};

const TableWithChairs = ({ tableData, occupancy, scale, tableGuests = [], searchQuery = '' }) => {
  const cap = tableData.capacity;
  const chairSize = 0.45 * scale; 
  const tipo = tableData.tipo || tableData.type;
  const config = tableData.configDetalle;

  let wMeters = tableData.width || 1.5;
  let hMeters = tableData.height || 1.5;
  let widthT_meters = 0.8; 

  if (tipo === 'rect_table' || tipo === 'tablon') { wMeters = 2.44; hMeters = 0.7; } 
  else if (tipo === 'ovalada') { wMeters = 3.05; hMeters = 1.22; } 
  else if (tipo === 'serpentina') { 
    let arcLength = 2.44;
    if (config?.modeloSerpentina === 'mod1') { arcLength = 1.58; widthT_meters = 0.75; }
    if (config?.modeloSerpentina === 'mod2') { arcLength = 2.00; widthT_meters = 0.75; }
    if (config?.modeloSerpentina === 'mod3') { arcLength = 2.10; widthT_meters = 0.75; }
    if (config?.modeloSerpentina === 'mod4') { arcLength = 2.44; widthT_meters = 0.90; }
    wMeters = arcLength / (Math.PI / 2); hMeters = wMeters; 
  } else if (tipo === 'libre') { 
    wMeters = config?.libreMedidas?.largo || 2.0; hMeters = config?.libreMedidas?.ancho || 1.0; 
  }

  const tableW = wMeters * scale;
  const tableH = hMeters * scale;
  const padding = 0.08 * scale;
  const chairs = [];

  const seatAssignments = [];
  if (tableGuests && tableGuests.length > 0) {
    tableGuests.forEach(g => {
      for (let p = 0; p < (g.passes || 1); p++) {
        seatAssignments.push({ guest: g, label: g.name + ((g.passes || 1) > 1 ? ` (Pase ${p + 1})` : '') });
      }
    });
  }

  for (let i = 0; i < cap; i++) {
    const isOccupied = i < occupancy;
    let cx = 0, cy = 0, angleDeg = 0;

    if (tipo === 'round_table' || tipo === 'redonda') {
      angleDeg = i * (360 / cap);
      const aRad = angleDeg * (Math.PI / 180);
      const rX = (tableW / 2) + (chairSize / 2) + padding;
      const rY = (tableH / 2) + (chairSize / 2) + padding;
      cx = (tableW / 2) + rX * Math.cos(aRad) - (chairSize / 2);
      cy = (tableH / 2) + rY * Math.sin(aRad) - (chairSize / 2);
    } else if (tipo === 'ovalada') {
      const topCap = config?.ladosOvalada?.top ?? 4;
      const botCap = config?.ladosOvalada?.bottom ?? 4;
      const leftCap = config?.ladosOvalada?.left ?? Math.floor((cap - topCap - botCap) / 2);
      const radius = tableH / 2; const straightW = tableW - tableH; 
      
      if (i < topCap) {
        if (topCap === 1) cx = tableW / 2 - chairSize/2;
        else cx = radius + ((straightW / (topCap - 1)) * i) - chairSize/2;
        cy = -(chairSize + padding); angleDeg = 270;
      } else if (i < topCap + botCap) {
        const idx = i - topCap;
        if (botCap === 1) cx = tableW / 2 - chairSize/2;
        else cx = radius + ((straightW / (botCap - 1)) * idx) - chairSize/2;
        cy = tableH + padding; angleDeg = 90;
      } else if (i < topCap + botCap + leftCap) {
        const idx = i - (topCap + botCap);
        const aRad = (90 + (180 / (leftCap + 1)) * (idx + 1)) * (Math.PI/180);
        const R = radius + chairSize/2 + padding;
        cx = radius + R * Math.cos(aRad) - chairSize/2; cy = radius - R * Math.sin(aRad) - chairSize/2;
        angleDeg = 360 - (90 + (180 / (leftCap + 1)) * (idx + 1)); 
      } else {
        const rightCap = cap - (topCap + botCap + leftCap);
        const idx = i - (topCap + botCap + leftCap);
        const aRad = (-90 + (180 / (rightCap + 1)) * (idx + 1)) * (Math.PI/180);
        const R = radius + chairSize/2 + padding;
        cx = (tableW - radius) + R * Math.cos(aRad) - chairSize/2; cy = radius - R * Math.sin(aRad) - chairSize/2;
        angleDeg = 360 - (-90 + (180 / (rightCap + 1)) * (idx + 1)); 
      }
    } else if (tipo === 'serpentina') {
      const extCap = config?.ladosSerpentina?.ext ?? Math.ceil(cap/2);
      const intCap = config?.ladosSerpentina?.int ?? Math.floor(cap/2) - 2;
      const izqCap = config?.ladosSerpentina?.izq ?? 1;
      const widthT = widthT_meters * scale;
      
      if (i < extCap) {
         const aRad = ((90 / (extCap + 1)) * (i + 1)) * (Math.PI/180);
         const R = tableW + chairSize/2 + padding;
         cx = R * Math.cos(aRad) - chairSize/2; cy = tableW - R * Math.sin(aRad) - chairSize/2;
         angleDeg = 360 - ((90 / (extCap + 1)) * (i + 1)); 
      } else if (i < extCap + intCap) {
         const idx = i - extCap;
         let aDeg = 45; 
         if (intCap > 1) aDeg = 15 + (idx * ((90 - 30) / (intCap - 1)));
         const aRad = aDeg * (Math.PI/180);
         const R = tableW - widthT - chairSize/2 - padding;
         cx = R * Math.cos(aRad) - chairSize/2; cy = tableW - R * Math.sin(aRad) - chairSize/2;
         angleDeg = 180 - aDeg; 
      } else if (i < extCap + intCap + izqCap) {
         cx = -(chairSize + padding); cy = (widthT / 2) - chairSize/2; angleDeg = 180; 
      } else {
         cx = tableW - (widthT / 2) - chairSize/2; cy = tableW + padding; angleDeg = 90; 
      }
    } else if (tipo === 'square_table' || tipo === 'cuadrada') {
      const topCap = config?.ladosCuadrada?.top ?? Math.ceil(cap / 4);
      const botCap = config?.ladosCuadrada?.bottom ?? Math.ceil(cap / 4);
      const leftCap = config?.ladosCuadrada?.left ?? Math.ceil(cap / 4);
      
      if (i < topCap) {
        cx = ((tableW / (topCap || 1)) * (i + 0.5)) - chairSize/2; cy = -(chairSize + padding); angleDeg = 270;
      } else if (i < topCap + botCap) {
        cx = ((tableW / (botCap || 1)) * ((i - topCap) + 0.5)) - chairSize/2; cy = tableH + padding; angleDeg = 90;
      } else if (i < topCap + botCap + leftCap) {
        cx = -(chairSize + padding); cy = ((tableH / (leftCap || 1)) * ((i - (topCap + botCap)) + 0.5)) - chairSize/2; angleDeg = 180;
      } else {
        const rightCap = cap - topCap - botCap - leftCap;
        cx = tableW + padding; cy = ((tableH / (rightCap || 1)) * ((i - (topCap + botCap + leftCap)) + 0.5)) - chairSize/2; angleDeg = 0;
      }
    } else {
      // Tablón o Libre
      const topCap = config?.ladosLibre?.top ?? config?.ladosTablon?.top ?? Math.floor((cap - 2) / 2);
      const botCap = config?.ladosLibre?.bottom ?? config?.ladosTablon?.bottom ?? Math.ceil((cap - 2) / 2);
      const leftCap = config?.ladosLibre?.left ?? config?.ladosTablon?.left ?? 1;
      
      if (i < topCap) {
        cx = ((tableW / (topCap || 1)) * (i + 0.5)) - chairSize/2; cy = -(chairSize + padding); angleDeg = 270;
      } else if (i < topCap + botCap) {
        cx = ((tableW / (botCap || 1)) * ((i - topCap) + 0.5)) - chairSize/2; cy = tableH + padding; angleDeg = 90;
      } else if (i < topCap + botCap + leftCap) {
        cx = -(chairSize + padding); cy = ((tableH / (leftCap || 1)) * ((i - (topCap + botCap)) + 0.5)) - chairSize/2; angleDeg = 180;
      } else {
        const rightCap = cap - topCap - botCap - leftCap;
        cx = tableW + padding; cy = ((tableH / (rightCap || 1)) * ((i - (topCap + botCap + leftCap)) + 0.5)) - chairSize/2; angleDeg = 0;
      }
    }

    const guestObj = seatAssignments[i];
    const guestName = guestObj ? guestObj.label : null;
    const chairGuestId = guestObj ? guestObj.guest.id : null;
    const totalRotation = angleDeg + (tableData.rotation || 0); 
    const isMatched = searchQuery && guestName && guestName.toLowerCase().includes(searchQuery.toLowerCase());
    const isTableMatched = searchQuery && tableData.name && tableData.name.toLowerCase().includes(searchQuery.toLowerCase());
    const activeSearchClasses = (isMatched || (isTableMatched && isOccupied)) ? 'ring-4 ring-rose-500 ring-offset-2 bg-white border-white scale-110 z-50' : (isOccupied ? 'bg-[#D4AF37] border-[#D4AF37]' : 'bg-[#141210] border-[#D4AF37]/40');

    chairs.push(
      <div key={i} 
           draggable={!!chairGuestId}
           onDragStart={(e) => {
             if (chairGuestId) {
               e.dataTransfer.setData('guestId', chairGuestId);
               e.stopPropagation();
             }
           }}
           className={`group absolute flex items-center justify-center rounded-full border-[1.5px] shadow-sm transition-all duration-300 hover:z-50 ${chairGuestId ? 'cursor-grab pointer-events-auto' : 'pointer-events-none'} ${activeSearchClasses} z-0`} 
           style={{ left: cx, top: cy, width: chairSize, height: chairSize, transform: `rotate(${angleDeg}deg)` }}>
         <div className={`absolute w-[45%] h-[115%] right-[-12%] rounded-full shadow-sm transition-colors duration-300 ${isMatched || (isTableMatched && isOccupied) ? 'bg-rose-500' : (isOccupied ? 'bg-[#c5a028]' : 'bg-white/10')}`}></div>
         {isOccupied && guestName && (
           <div className="absolute hidden group-hover:flex items-center justify-center bg-[#141210]/95 backdrop-blur-md text-[#D4AF37] text-[10px] font-bold px-3 py-2 rounded-xl shadow-[0_10px_25px_rgba(212,175,55,0.2)] whitespace-nowrap z-[100] -top-10 pointer-events-none border border-[#D4AF37]/30 animate-in fade-in zoom-in-95 duration-200" style={{ transform: `rotate(-${totalRotation}deg)` }}>
             {guestName}
           </div>
         )}
      </div>
    );
  }

  const matchedNames = [];
  if (searchQuery) {
    seatAssignments.forEach(obj => {
      if (obj.label && obj.label.toLowerCase().includes(searchQuery.toLowerCase()) && !matchedNames.includes(obj.label)) matchedNames.push(obj.label);
    });
  }

  let innerContent = null;
  let shapeClass = 'rounded-sm shadow-xl';
  let borderClass = 'border-2';
  let baseColor = 'bg-[#141210] border-[#D4AF37] text-white'; 

  if (tipo === 'round_table' || tipo === 'redonda' || tipo === 'ovalada') { shapeClass = 'rounded-[999px] shadow-xl'; } 
  else if (tipo === 'serpentina') {
    shapeClass = 'rounded-none'; borderClass = 'border-0'; baseColor = 'bg-transparent text-white'; 
    const widthT = widthT_meters * scale;
    const innerR = tableW - widthT;
    innerContent = (
      <svg className="absolute inset-0 overflow-visible drop-shadow-md" style={{ zIndex: -1, width: tableW, height: tableW }}>
         <path d={`M 0 0 A ${tableW} ${tableW} 0 0 1 ${tableW} ${tableW} L ${tableW - widthT} ${tableW} A ${innerR} ${innerR} 0 0 0 0 ${widthT} Z`} fill="#141210" stroke="#D4AF37" strokeWidth="2" />
      </svg>
    );
  }

  return (
    <div style={{ width: tableW, height: tableH }} className="relative pointer-events-none">
      {chairs}
      <div className={`absolute inset-0 flex flex-col items-center justify-center z-10 ${shapeClass} ${borderClass} ${baseColor}`}>
        {innerContent}
        <div className="z-20 flex items-center justify-center pointer-events-none" style={{ transform: `rotate(-${tableData.rotation || 0}deg)` }}>
          <span className="font-black text-[#D4AF37]/70 select-none drop-shadow-sm uppercase tracking-widest" style={{ fontSize: `${Math.max(0.6, tableW * 0.018)}rem` }}>
            {tableData.name ? tableData.name.replace(/Mesa\s+/i, '').trim() : ''}
          </span>
        </div>
        {matchedNames.length > 0 && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-[300]" style={{ transform: `rotate(-${tableData.rotation || 0}deg)` }}>
            <div className="absolute -top-12 flex flex-col items-center animate-in slide-in-from-bottom-2 duration-300">
              <div className="bg-[#1C1917]/95 backdrop-blur-md text-white text-[10px] font-bold px-4 py-2.5 rounded-xl shadow-[0_10px_25px_rgba(212,175,55,0.3)] border border-[#D4AF37]/50 text-center whitespace-nowrap flex flex-col gap-0.5">
                {matchedNames.map((n, idx) => <span key={idx}>{n}</span>)}
              </div>
              <div className="w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-[#D4AF37]/50 mt-[-1px]"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ==========================================
// VISTA NUEVA: VISUALIZADOR DE DECORACIÓN (VECTORES PROFESIONALES SVG)
// ==========================================

// --- FUNCIONES MATEMÁTICAS PARA CURVAS SUAVES ---
const catmullRom = (t, p0, p1, p2, p3) => {
  const t2 = t * t; const t3 = t2 * t;
  return 0.5 * ((2 * p1) + (-p0 + p2) * t + (2 * p0 - 5 * p1 + 4 * p2 - p3) * t2 + (-p0 + 3 * p1 - 3 * p2 + p3) * t3);
};

const getSplinePoint = (t, points) => {
  const p = points.length - 1;
  const scaledT = t * p;
  const i = Math.floor(scaledT);
  const localT = scaledT - i;
  
  const p0 = points[Math.max(0, i - 1)];
  const p1 = points[i];
  const p2 = points[Math.min(p, i + 1)];
  const p3 = points[Math.min(p, i + 2)];
  
  return {
    x: catmullRom(localT, p0.x, p1.x, p2.x, p3.x),
    y: catmullRom(localT, p0.y, p1.y, p2.y, p3.y)
  };
};

const DECO_CATALOG = [
  { type: 'mampara_arco', name: 'Mampara Arco', defaultW: 1.2, defaultH: 2.2, defaultColor: '#fecdd3' },
  { type: 'mampara_cuad', name: 'Mampara Recta', defaultW: 1.5, defaultH: 2.2, defaultColor: '#bfdbfe' },
  { type: 'globo_guirnalda', name: 'Guirnalda Libre', defaultW: 2.5, defaultH: 2.5, defaultColor: '#fde047', colors: ['#fde047', '#ffffff'] },
  { type: 'globo_individual', name: 'Globo/Tercia', defaultW: 0.5, defaultH: 0.5, defaultColor: '#fcd34d', clusterType: 'single', sizeInches: 11 },
  { type: 'letras_neon', name: 'Letras Neón', defaultW: 1.2, defaultH: 0.4, text: 'Better Together', defaultColor: '#fef08a' },
  { type: 'mesa_principal', name: 'Mesa Novios', defaultW: 2.0, defaultH: 0.75, defaultColor: '#ffffff' },
  { type: 'silla_tiffany', name: 'Silla Tiffany', defaultW: 0.4, defaultH: 0.9, defaultColor: '#e5e7eb' },
  { type: 'sillon_lounge', name: 'Sillón Lounge', defaultW: 1.5, defaultH: 0.8, defaultColor: '#fbcfe8' },
  { type: 'silla_trono', name: 'Trono Rey/Reina', defaultW: 0.8, defaultH: 1.6, defaultColor: '#fef08a' },
  { type: 'arbol_pino', name: 'Pino Elegante', defaultW: 1.0, defaultH: 2.5, defaultColor: '#16a34a' },
  { type: 'arbusto_redondo', name: 'Arbusto Topiario', defaultW: 0.8, defaultH: 1.2, defaultColor: '#22c55e' },
  { type: 'arbol_cerezo', name: 'Árbol Follaje', defaultW: 1.5, defaultH: 2.5, defaultColor: '#fecdd3' },
  { type: 'flor_rosa', name: 'Rosas (Arreglo)', defaultW: 0.8, defaultH: 0.6, defaultColor: '#ef4444' },
  { type: 'flor_girasol', name: 'Girasoles', defaultW: 0.8, defaultH: 0.8, defaultColor: '#eab308' },
  { type: 'flor_tulipan', name: 'Tulipanes', defaultW: 0.6, defaultH: 0.7, defaultColor: '#d946ef' }
];

const PRESET_COLORS = ['#ffffff', 'rgba(255, 255, 255, 0.4)', '#fecdd3', '#fbcfe8', '#bfdbfe', '#a7f3d0', '#6ee7b7', '#16a34a', '#fde047', '#eab308', '#fcd34d', '#fed7aa', '#e5e7eb', '#9ca3af', '#1f2937', '#d946ef', '#ef4444'];

// ==========================================
// --- COMPONENTE: BOCETADOR DE DECORACIÓN (DARK PREMIUM) ---
// ==========================================
const DecoracionView = ({ elements = [], setElements, addNotification }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [dragging, setDragging] = useState(null);

  const [isEditMode, setIsEditMode] = useState(true);
  const [activeTool, setActiveTool] = useState('select'); 
  
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [selectedBalloonId, setSelectedBalloonId] = useState(null);
  
  const [pan, setPan] = useState({ x: 0, y: 150 }); 
  const [scale, setScale] = useState(90); 
  const [snapEnabled, setSnapEnabled] = useState(true);
  const [snapGuides, setSnapGuides] = useState({ x: null, y: null });

  const [bgImage, setBgImage] = useState(() => localStorage.getItem('deco_bgImage') || null);
  const [bgImgSize, setBgImgSize] = useState(() => JSON.parse(localStorage.getItem('deco_bgSize')) || { w: 10, h: 10 });
  const [bgPos, setBgPos] = useState(() => JSON.parse(localStorage.getItem('deco_bgPos')) || { x: 0, y: 0 });
  
  const [calibrationLine, setCalibrationLine] = useState(null);
  const [calibrationModal, setCalibrationModal] = useState(null);
  const [realDistanceInput, setRealDistanceInput] = useState('');
  
  const [showExportModal, setShowExportModal] = useState(false);
  const [showClearConfirm, setShowClearConfirm] = useState(false); 
  const [isBlueprintPanActive, setIsBlueprintPanActive] = useState(false); 

  const [isPreparingPrint, setIsPreparingPrint] = useState(false);
  const [isCapturingPdf, setIsCapturingPdf] = useState(false);

  const fileInputRefBg = useRef(null);

  const [printScale, setPrintScale] = useState(1);
  const [printPan, setPrintPan] = useState({ x: 0, y: 0 });
  const [isPrintDragging, setIsPrintDragging] = useState(false);
  const [printDragStart, setPrintDragStart] = useState({ x: 0, y: 0 });

  const containerRef = useRef(null);
  const [vp, setVp] = useState({ w: 0, h: 0 });

  const stateRef = useRef({ scale, pan, vp, offsetX: 0, offsetY: 0 });
  const offsetX = (vp.w / 2) + pan.x;
  const offsetY = (vp.h / 2) + pan.y;
  stateRef.current = { scale, pan, vp, offsetX, offsetY };

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(entries => {
      const { width, height } = entries[0].contentRect;
      if (width > 0 && height > 0) setVp({ w: width, h: height });
    });
    resizeObserver.observe(container);

    const handleWheel = (e) => {
      e.preventDefault();
      const st = stateRef.current;
      const zoomSensitivity = 0.003;
      const delta = -e.deltaY * zoomSensitivity;
      const newScale = Math.min(Math.max(20, st.scale * (1 + delta)), 400);
      
      const rect = container.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      const worldX = (mouseX - st.offsetX) / st.scale;
      const worldY = (mouseY - st.offsetY) / st.scale;

      const newOffsetX = mouseX - worldX * newScale;
      const newOffsetY = mouseY - worldY * newScale;

      setPan({ x: newOffsetX - (st.vp.w / 2), y: newOffsetY - (st.vp.h / 2) });
      setScale(newScale);
    };

    container.addEventListener('wheel', handleWheel, { passive: false });
    return () => { resizeObserver.disconnect(); container.removeEventListener('wheel', handleWheel); };
  }, []);

  useEffect(() => {
    if (showExportModal) {
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      if (bgImage) {
          minX = Math.min(minX, bgPos.x); minY = Math.min(minY, bgPos.y);
          maxX = Math.max(maxX, bgPos.x + bgImgSize.w); maxY = Math.max(maxY, bgPos.y + bgImgSize.h);
      }
      elements.forEach(el => {
          minX = Math.min(minX, el.x); minY = Math.min(minY, el.y);
          maxX = Math.max(maxX, el.x + el.width); maxY = Math.max(maxY, el.y + el.height);
      });
      if (minX === Infinity) { minX = 0; minY = 0; maxX = 10; maxY = 10; }

      const designW = (maxX - minX) * scale;
      const designH = (maxY - minY) * scale;
      const cx = (minX * scale) + designW / 2; 
      const cy = (minY * scale) + designH / 2;
      
      const targetW = 750; 
      const targetH = 380; 
      const initialZoom = Math.min(targetW / (designW || 1), targetH / (designH || 1)) * 0.85; 
      
      setPrintScale(initialZoom);
      setPrintPan({ x: (targetW / 2) - (cx * initialZoom), y: (targetH / 2) - (cy * initialZoom) });
    }
  }, [showExportModal, elements, bgImage, bgPos, bgImgSize, scale]);

  const handleBgUpload = (e) => {
    const file = e.target.files[0];
    if(!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
       const img = new Image();
       img.onload = () => {
          const aspect = img.height / img.width;
          const newSize = { w: 15, h: 15 * aspect };
          const newPos = { x: 0, y: 0 };
          
          setBgImgSize(newSize); setBgPos(newPos); setBgImage(event.target.result); setPan({x:0, y:0}); 
          localStorage.setItem('deco_bgImage', event.target.result);
          localStorage.setItem('deco_bgSize', JSON.stringify(newSize));
          localStorage.setItem('deco_bgPos', JSON.stringify(newPos));
          if(addNotification) addNotification('Plano Cargado', 'Usa la herramienta "Calibrar" y luego "Mover Fondo".', 'info');
       };
       img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  const removeBackground = () => {
    setBgImage(null); setCalibrationLine(null);
    localStorage.removeItem('deco_bgImage'); localStorage.removeItem('deco_bgSize'); localStorage.removeItem('deco_bgPos');
    setActiveTool('select');
  };

  const applyCalibration = () => {
    const realMeters = parseFloat(realDistanceInput);
    if (!realMeters || isNaN(realMeters)) {
      if(addNotification) addNotification('Atención', 'Ingresa un número válido en metros.', 'warning');
      return;
    }
    const factor = realMeters / calibrationModal.lengthWorld;
    const newSize = { w: bgImgSize.w * factor, h: bgImgSize.h * factor };
    
    setBgImgSize(newSize); localStorage.setItem('deco_bgSize', JSON.stringify(newSize));
    setCalibrationModal(null); setCalibrationLine(null); setActiveTool('select');
    if(addNotification) addNotification('Plano Calibrado', 'El fondo coincide con medidas reales.', 'success');
  };

  const executeClearAll = async () => {
    elements.forEach(e => deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", e.id)));
    setElements([]); 
    setSelectedId(null); 
    setEditingGroupId(null); 
    removeBackground();
    setShowClearConfirm(false);
    if(addNotification) addNotification('Lienzo Limpio', 'Se ha borrado todo el diseño.', 'success');
  };

  const handleDragStart = (e, item) => {
    e.dataTransfer.setData('text/plain', JSON.stringify(item));
    e.dataTransfer.setData('text', JSON.stringify(item));
    e.dataTransfer.setData('payload', JSON.stringify(item)); 
  };

  const createNewElement = async (payload, finalX, finalY) => {
    let extraProps = {};
    if (payload.type === 'globo_guirnalda') {
      const clusterCount = 15;
      extraProps.balloonCount = clusterCount * 3;
      extraProps.controlPoints = [ {x: 0, y: 0.5}, {x: 0.166, y: 0.5}, {x: 0.333, y: 0.5}, {x: 0.5, y: 0.5}, {x: 0.666, y: 0.5}, {x: 0.833, y: 0.5}, {x: 1, y: 0.5} ];
      const balloons = [];
      for (let c = 0; c < clusterCount; c++) {
        const clusterId = `init_${c}`;
        const t = c / (clusterCount - 1 || 1);
        const clusterAngleOffset = Math.random() * Math.PI * 2;
        for (let j = 0; j < 3; j++) {
          const angle = clusterAngleOffset + (j * (Math.PI * 2 / 3));
          const radiusOffset = 0.06 + (Math.random() * 0.04);
          balloons.push({ id: c * 3 + j, clusterId, t, isMain: j === 0, offsetX: Math.cos(angle) * radiusOffset, offsetY: Math.sin(angle) * radiusOffset, sizeInches: j === 0 ? 11 : 9, colorOverride: null });
        }
      }
      extraProps.balloons = balloons;
    } else if (payload.type === 'globo_individual') {
      extraProps.clusterType = payload.clusterType;
      extraProps.sizeInches = payload.sizeInches;
      let initBalloons = [{id: 0, clusterId: 1, colorOverride: null}];
      if(payload.clusterType === 'tercia') initBalloons = [{id:0, clusterId: 1, colorOverride: null}, {id:1, clusterId: 1, colorOverride: null}, {id:2, clusterId: 1, colorOverride: null}];
      if(payload.clusterType === 'cuarteto') initBalloons = [{id:0, clusterId: 1, colorOverride: null}, {id:1, clusterId: 1, colorOverride: null}, {id:2, clusterId: 1, colorOverride: null}, {id:3, clusterId: 1, colorOverride: null}, {id:4, clusterId: 1, colorOverride: null}];
      extraProps.balloons = initBalloons;
    }

    const newEl = {
      id: `deco_${Date.now()}_${Math.floor(Math.random()*1000)}`,
      type: payload.type, name: payload.name, width: payload.defaultW, height: payload.defaultH, x: finalX, y: finalY,
      color: payload.defaultColor, colors: payload.colors || [payload.defaultColor], rotation: 0, zIndex: elements.length + 1, text: payload.text || '', ...extraProps
    };

    setElements(prev => [...prev, newEl]);
    setSelectedId(newEl.id);
    try { await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", newEl.id), newEl); } catch(err) {}
  };

  const handleDropOnCanvas = (e) => {
    e.preventDefault(); e.stopPropagation();
    try {
      const payloadData = e.dataTransfer.getData('text/plain') || e.dataTransfer.getData('text') || e.dataTransfer.getData('payload');
      if (!payloadData) return;
      const payload = JSON.parse(payloadData);
      const rect = containerRef.current.getBoundingClientRect();
      const mouseX = e.clientX - rect.left; const mouseY = e.clientY - rect.top;
      const finalX = (mouseX - offsetX) / scale - (payload.defaultW / 2);
      const finalY = (mouseY - offsetY) / scale - (payload.defaultH / 2);
      createNewElement(payload, finalX, finalY);
    } catch (error) {}
  };

  const handlePointerDown = (e, id, type = 'element', index = null) => {
    e.stopPropagation(); 
    
    setSelectedId(id);
    if(type === 'element' && editingGroupId !== id) { setEditingGroupId(null); setSelectedBalloonId(null); } 
    else if (type === 'element' && editingGroupId === id) { setSelectedBalloonId(null); return; }
    
    const el = elements.find(item => item.id === id);
    if(el) {
      let groupOffsets = [];
      if (type === 'balloon') {
        const b = el.balloons.find(x => x.id === index);
        if (b && b.clusterId) groupOffsets = el.balloons.filter(x => x.clusterId === b.clusterId).map(x => ({id: x.id, ox: x.offsetX || 0, oy: x.offsetY || 0}));
        else if (b) groupOffsets = [{id: b.id, ox: b.offsetX || 0, oy: b.offsetY || 0}];
      }

      setDragging({ 
        id, type, balloonId: type === 'balloon' ? index : null, index,
        startX: e.clientX, startY: e.clientY, origX: el.x, origY: el.y, 
        origCurveX: type === 'curve_control' ? el.controlPoints[index].x : 0, 
        origCurveY: type === 'curve_control' ? el.controlPoints[index].y : 0, w: el.width, h: el.height, groupOffsets
      });
    }
  };

  const handlePointerMove = (e) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if(!rect) return;
    const worldX = ((e.clientX - rect.left) - offsetX) / scale;
    const worldY = ((e.clientY - rect.top) - offsetY) / scale;

    if (activeTool === 'calibrate' && calibrationLine && calibrationLine.isDragging) {
       setCalibrationLine({ ...calibrationLine, x2: worldX, y2: worldY }); return;
    }

    if (!dragging) return;
    
    if (dragging.isPanning) {
      setPan({ x: dragging.startPanX + (e.clientX - dragging.startX), y: dragging.startPanY + (e.clientY - dragging.startY) }); return;
    }

    if (dragging.type === 'move_bg') {
      const newX = dragging.startBgX + (e.clientX - dragging.startX) / scale;
      const newY = dragging.startBgY + (e.clientY - dragging.startY) / scale;
      setBgPos({ x: newX, y: newY });
      return;
    }

    const dxMeters = (e.clientX - dragging.startX) / scale;
    const dyMeters = (e.clientY - dragging.startY) / scale;

    if (dragging.type === 'balloon') {
       const el = elements.find(x => x.id === dragging.id);
       const updatedBalloons = el.balloons.map(b => {
           const inGroup = dragging.groupOffsets.find(go => go.id === b.id);
           if (inGroup) return { ...b, offsetX: inGroup.ox + dxMeters, offsetY: inGroup.oy + dyMeters };
           return b;
       });
       setElements(elements.map(x => x.id === dragging.id ? { ...x, balloons: updatedBalloons } : x)); return;
    }

    if (dragging.type === 'curve_control') {
       const newPoints = [...elements.find(e => e.id === dragging.id).controlPoints];
       newPoints[dragging.index] = { x: dragging.origCurveX + (dxMeters / dragging.w), y: dragging.origCurveY + (dyMeters / dragging.h) };
       setElements(elements.map(el => el.id === dragging.id ? { ...el, controlPoints: newPoints } : el)); return;
    }

    let finalX = dragging.origX + dxMeters;
    let finalY = dragging.origY + dyMeters;
    let guideX = null; let guideY = null;

    if (snapEnabled && !editingGroupId) {
      const snapThreshold = 0.3;
      const myCenter = finalX + (dragging.w / 2); const myMiddle = finalY + (dragging.h / 2);
      const others = elements.filter(el => el.id !== dragging.id);

      for (let other of others) {
        const otherCenter = other.x + (other.width / 2); const otherMiddle = other.y + (other.height / 2);
        if (Math.abs(myCenter - otherCenter) < snapThreshold) { finalX = otherCenter - (dragging.w / 2); guideX = otherCenter; }
        const myBottom = finalY + dragging.h; const otherBottom = other.y + other.height;
        if (Math.abs(myBottom - otherBottom) < snapThreshold) { finalY = otherBottom - dragging.h; guideY = otherBottom; } 
        else if (Math.abs(myMiddle - otherMiddle) < snapThreshold) { finalY = Math.abs(myMiddle - otherMiddle) < snapThreshold ? otherMiddle : guideY; }
      }
    }

    setSnapGuides({ x: guideX, y: guideY });
    setElements(elements.map(el => el.id === dragging.id ? { ...el, x: finalX, y: finalY } : el));
  };

  const handlePointerUp = async () => {
    if (activeTool === 'calibrate' && calibrationLine && calibrationLine.isDragging) {
       setCalibrationLine({ ...calibrationLine, isDragging: false });
       const dx = calibrationLine.x2 - calibrationLine.x1;
       const dy = calibrationLine.y2 - calibrationLine.y1;
       const lengthWorld = Math.sqrt(dx*dx + dy*dy);
       setCalibrationModal({ lengthWorld }); return;
    }

    if (dragging && dragging.type === 'move_bg') {
       localStorage.setItem('deco_bgPos', JSON.stringify(bgPos));
    } else if (dragging && dragging.type !== 'isPanning') {
       const el = elements.find(e => e.id === dragging.id);
       if (el) await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", el.id), el);
    }
    
    setDragging(null);
    setSnapGuides({x: null, y: null});
  };

  const updateElementData = async (id, newData) => {
    const el = elements.find(e => e.id === id);
    if(el) {
        const updatedEl = { ...el, ...newData };
        setElements(elements.map(e => e.id === id ? updatedEl : e)); 
        await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", id), updatedEl);
    }
  };

  const deleteSelected = async () => {
    if(selectedId) {
       const idToDelete = selectedId;
       setSelectedId(null); setEditingGroupId(null);
       setElements(elements.filter(e => e.id !== idToDelete)); 
       await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", idToDelete));
    }
  };

  const rotateSelected = async () => {
    const el = elements.find(e => e.id === selectedId);
    if(el) {
        const newRot = (el.rotation || 0) + 15;
        setElements(elements.map(e => e.id === selectedId ? { ...e, rotation: newRot } : e)); 
        await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", selectedId), { ...el, rotation: newRot });
    }
  };

  const changeZIndex = async (id, direction) => {
    const el = elements.find(e => e.id === id);
    if(el) {
        const newZ = el.zIndex + direction;
        setElements(elements.map(e => e.id === id ? { ...e, zIndex: newZ } : e)); 
        await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "decoracion", id), { ...el, zIndex: newZ });
    }
  };

  const toggleGarlandColor = (colorId, color) => {
    const el = elements.find(e => e.id === colorId);
    let newColors = [...(el.colors || [el.color])];
    if (newColors.includes(color)) {
      newColors = newColors.filter(c => c !== color);
      if (newColors.length === 0) newColors = [color]; 
    } else {
      newColors.push(color);
    }
    updateElementData(colorId, { colors: newColors, color: newColors[0] });
  };

  const handleGarlandCountChange = (id, newCount) => {
    const el = elements.find(e => e.id === id);
    const validCount = Math.max(3, Math.min(300, newCount)); 
    let newBalloons = [...(el.balloons || [])];
    
    if (validCount > newBalloons.length) {
       let nextId = newBalloons.length > 0 ? Math.max(...newBalloons.map(b=>b.id)) + 1 : 0;
       const clusters = Math.ceil(validCount / 3);
       for (let i = newBalloons.length; i < validCount; i++) {
         const c = Math.floor(i / 3);
         const j = i % 3;
         const t = c / (clusters - 1 || 1);
         const clusterId = `gen_${c}`;
         const angle = (c * 0.7) + (j * (Math.PI * 2 / 3)); 
         const radiusOffset = 0.08 + (Math.random() * 0.03);
         newBalloons.push({
           id: nextId++, clusterId, t, isMain: j === 0,
           offsetX: Math.cos(angle) * radiusOffset,
           offsetY: Math.sin(angle) * radiusOffset,
           sizeInches: j === 0 ? 11 : 9, colorOverride: null
         });
       }
    } else if (validCount < newBalloons.length) {
       newBalloons = newBalloons.slice(0, validCount);
    }
    updateElementData(id, { balloonCount: validCount, balloons: newBalloons });
  };

  const addClusterToGarland = (type) => {
    if (!selectedId) return;
    const el = elements.find(e => e.id === selectedId);
    const refB = el.balloons.find(x => x.id === selectedBalloonId) || el.balloons[Math.floor(el.balloons.length/2)];
    const t = refB ? refB.t : 0.5;
    const baseOx = refB && refB.offsetX != null ? refB.offsetX : 0;
    const baseOy = refB && refB.offsetY != null ? refB.offsetY : 0;
    
    let newBalloons = [];
    let nextId = el.balloons.length > 0 ? Math.max(...el.balloons.map(x=>x.id)) + 1 : 0;
    const rOffset = 0.12; 
    const clusterId = Date.now().toString() + Math.random().toString();

    if (type === 'single') {
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx + rOffset, offsetY: baseOy + rOffset, sizeInches: 11, colorOverride: null, clusterId: null });
    } else if (type === 'tercia') {
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx, offsetY: baseOy - rOffset, sizeInches: 11, colorOverride: null, clusterId });
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx - rOffset*0.86, offsetY: baseOy + rOffset*0.5, sizeInches: 11, colorOverride: null, clusterId });
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx + rOffset*0.86, offsetY: baseOy + rOffset*0.5, sizeInches: 11, colorOverride: null, clusterId });
    } else if (type === 'cuarteto') {
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx - rOffset*0.7, offsetY: baseOy - rOffset*0.7, sizeInches: 11, colorOverride: null, clusterId });
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx + rOffset*0.7, offsetY: baseOy - rOffset*0.7, sizeInches: 11, colorOverride: null, clusterId });
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx - rOffset*0.7, offsetY: baseOy + rOffset*0.7, sizeInches: 11, colorOverride: null, clusterId });
      newBalloons.push({ id: nextId++, t, isMain: true, offsetX: baseOx + rOffset*0.7, offsetY: baseOy + rOffset*0.7, sizeInches: 11, colorOverride: null, clusterId });
    }

    updateElementData(el.id, { balloons: [...el.balloons, ...newBalloons], balloonCount: el.balloons.length + newBalloons.length });
    setSelectedBalloonId(newBalloons[0].id);
  };

  const getTransparentStyle = (color) => ({
    backgroundColor: color.includes('rgba') ? undefined : color,
    backgroundImage: color.includes('rgba') ? 'linear-gradient(45deg, #e2e8f0 25%, transparent 25%, transparent 75%, #e2e8f0 75%, #e2e8f0), linear-gradient(45deg, #e2e8f0 25%, transparent 25%, transparent 75%, #e2e8f0 75%, #e2e8f0)' : 'none',
    backgroundPosition: '0 0, 4px 4px', backgroundSize: '8px 8px'
  });

  const renderShape = (el) => {
    const w = el.width * scale; const h = el.height * scale;
    switch(el.type) {
      case 'mampara_arco': return <div style={{ backgroundColor: el.color, width: '100%', height: '100%', borderRadius: `${w/2}px ${w/2}px 0 0`, boxShadow: 'inset 0px -5px 20px rgba(0,0,0,0.1), 0 10px 15px -3px rgba(0,0,0,0.2)' }}><div className="absolute bottom-0 w-full h-2 bg-black/10"></div></div>;
      case 'mampara_cuad': return <div style={{ backgroundColor: el.color, width: '100%', height: '100%', borderRadius: '4px 4px 0 0', boxShadow: 'inset 0px -5px 20px rgba(0,0,0,0.1), 0 10px 15px -3px rgba(0,0,0,0.2)' }}><div className="absolute bottom-0 w-full h-2 bg-black/10"></div></div>;
      case 'silla_tiffany': return (<svg width="100%" height="100%" viewBox="0 0 40 100" style={{ filter: 'drop-shadow(2px 5px 4px rgba(0,0,0,0.15))' }}><rect x="6" y="50" width="3" height="50" fill={el.color} /><rect x="31" y="50" width="3" height="50" fill={el.color} /><rect x="2" y="46" width="36" height="6" rx="2" fill={el.color} opacity="0.9"/><rect x="6" y="0" width="3" height="46" fill={el.color} /><rect x="31" y="0" width="3" height="46" fill={el.color} /><rect x="6" y="5" width="28" height="3" fill={el.color} /><rect x="6" y="15" width="28" height="2" fill={el.color} /><rect x="13" y="17" width="2" height="29" fill={el.color} opacity="0.8"/><rect x="19" y="17" width="2" height="29" fill={el.color} opacity="0.8"/><rect x="25" y="17" width="2" height="29" fill={el.color} opacity="0.8"/></svg>);
      case 'sillon_lounge': return (<svg width="100%" height="100%" viewBox="0 0 150 80" style={{ filter: 'drop-shadow(0 8px 10px rgba(0,0,0,0.2))' }}><rect x="20" y="65" width="8" height="15" fill="#451a03" rx="2"/><rect x="122" y="65" width="8" height="15" fill="#451a03" rx="2"/><rect x="10" y="45" width="130" height="20" rx="5" fill={el.color} /><path d="M 20 45 L 20 15 Q 20 0 75 0 Q 130 0 130 15 L 130 45 Z" fill={el.color} opacity="0.95"/><rect x="0" y="30" width="25" height="35" rx="8" fill={el.color} opacity="0.9"/><rect x="125" y="30" width="25" height="35" rx="8" fill={el.color} opacity="0.9"/><circle cx="50" cy="20" r="2" fill="rgba(0,0,0,0.2)"/><circle cx="75" cy="20" r="2" fill="rgba(0,0,0,0.2)"/><circle cx="100" cy="20" r="2" fill="rgba(0,0,0,0.2)"/><circle cx="62.5" cy="30" r="2" fill="rgba(0,0,0,0.2)"/><circle cx="87.5" cy="30" r="2" fill="rgba(0,0,0,0.2)"/></svg>);
      case 'silla_trono': return (<svg width="100%" height="100%" viewBox="0 0 80 160" style={{ filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.25))' }}><rect x="15" y="95" width="8" height="65" fill="#b45309" rx="2"/><rect x="57" y="95" width="8" height="65" fill="#b45309" rx="2"/><path d="M 10 95 L 10 40 Q 40 -10 70 40 L 70 95 Z" fill={el.color} /><path d="M 8 95 L 8 40 Q 40 -15 72 40 L 72 95" fill="none" stroke="#eab308" strokeWidth="4"/><rect x="5" y="80" width="70" height="15" rx="4" fill={el.color} opacity="0.9"/><rect x="0" y="60" width="15" height="25" rx="5" fill="#eab308"/><rect x="65" y="60" width="15" height="25" rx="5" fill="#eab308"/><circle cx="40" cy="20" r="4" fill="#eab308"/></svg>);
      case 'arbol_pino': return (<svg width="100%" height="100%" viewBox="0 0 100 200" style={{ filter: 'drop-shadow(0 15px 15px rgba(0,0,0,0.2))' }}><rect x="42" y="160" width="16" height="40" fill="#78350f" rx="3"/><polygon points="10,170 50,80 90,170" fill={el.color} opacity="0.85"/><polygon points="15,120 50,40 85,120" fill={el.color} opacity="0.9"/><polygon points="25,70 50,0 75,70" fill={el.color} /></svg>);
      case 'arbusto_redondo': return (<svg width="100%" height="100%" viewBox="0 0 100 120" style={{ filter: 'drop-shadow(0 10px 10px rgba(0,0,0,0.15))' }}><polygon points="30,120 20,80 80,80 70,120" fill="#78350f" /><rect x="15" y="70" width="70" height="10" fill="#451a03" rx="2"/><circle cx="50" cy="45" r="45" fill={el.color} /><circle cx="40" cy="35" r="15" fill="#ffffff" opacity="0.15"/><circle cx="65" cy="55" r="10" fill="#000000" opacity="0.1"/></svg>);
      case 'arbol_cerezo': return (<svg width="100%" height="100%" viewBox="0 0 100 200" style={{ overflow: 'visible', filter: 'drop-shadow(0 15px 15px rgba(0,0,0,0.2))' }}><path d="M 45 200 Q 50 100 30 50 M 55 200 Q 50 100 70 60" stroke="#78350f" strokeWidth="8" fill="none" strokeLinecap="round"/><path d="M 45 120 Q 70 90 80 70 M 52 150 Q 30 110 20 90" stroke="#78350f" strokeWidth="5" fill="none" strokeLinecap="round"/><circle cx="30" cy="50" r="30" fill={el.color} opacity="0.9" /><circle cx="70" cy="60" r="35" fill={el.color} opacity="0.85" /><circle cx="50" cy="30" r="40" fill={el.color} opacity="0.95" /><circle cx="20" cy="80" r="25" fill={el.color} opacity="0.8" /><circle cx="80" cy="90" r="25" fill={el.color} opacity="0.8" /><circle cx="50" cy="70" r="30" fill="#ffffff" opacity="0.3" /></svg>);
      case 'flor_rosa': return (<svg width="100%" height="100%" viewBox="0 0 100 80" style={{ filter: 'drop-shadow(0 8px 10px rgba(0,0,0,0.2))' }}><path d="M 10 70 Q 30 20 50 30 Q 70 20 90 70" fill="none" stroke="#16a34a" strokeWidth="6" strokeLinecap="round"/><path d="M 50 80 L 50 20" fill="none" stroke="#15803d" strokeWidth="6" strokeLinecap="round"/><g transform="translate(20, 25)"><circle cx="0" cy="0" r="18" fill={el.color} /><path d="M -5 -5 Q 10 -15 10 5 Q -10 15 -5 -5" fill="rgba(0,0,0,0.15)"/><path d="M 0 0 Q 5 -5 5 2 Q -5 5 0 0" fill="rgba(0,0,0,0.25)"/></g><g transform="translate(80, 25)"><circle cx="0" cy="0" r="18" fill={el.color} /><path d="M -5 -5 Q 10 -15 10 5 Q -10 15 -5 -5" fill="rgba(0,0,0,0.15)"/><path d="M 0 0 Q 5 -5 5 2 Q -5 5 0 0" fill="rgba(0,0,0,0.25)"/></g><g transform="translate(50, 15)"><circle cx="0" cy="0" r="22" fill={el.color} opacity="0.95"/><path d="M -6 -6 Q 12 -18 12 6 Q -12 18 -6 -6" fill="rgba(0,0,0,0.15)"/><path d="M 0 0 Q 6 -6 6 2 Q -6 6 0 0" fill="rgba(0,0,0,0.25)"/></g></svg>);
      case 'flor_girasol': return (<svg width="100%" height="100%" viewBox="0 0 100 120" style={{ filter: 'drop-shadow(0 5px 8px rgba(0,0,0,0.2))' }}><rect x="46" y="50" width="8" height="70" fill="#16a34a" rx="4"/><ellipse cx="30" cy="80" rx="20" ry="8" transform="rotate(-30 30 80)" fill="#15803d"/><ellipse cx="70" cy="90" rx="20" ry="8" transform="rotate(30 70 90)" fill="#15803d"/><g transform="translate(50, 40)">{Array.from({length: 12}).map((_, i) => (<ellipse key={`out${i}`} cx="0" cy="-25" rx="8" ry="20" transform={`rotate(${i*30} 0 0)`} fill={el.color} />))}{Array.from({length: 12}).map((_, i) => (<ellipse key={`in${i}`} cx="0" cy="-18" rx="6" ry="15" transform={`rotate(${(i*30)+15} 0 0)`} fill={el.color} opacity="0.8" />))}<circle cx="0" cy="0" r="16" fill="#451a03" /><circle cx="0" cy="0" r="12" fill="#290f02" /><circle cx="-5" cy="-5" r="1.5" fill="#78350f" /><circle cx="5" cy="5" r="1.5" fill="#78350f" /><circle cx="5" cy="-5" r="1.5" fill="#78350f" /><circle cx="-5" cy="5" r="1.5" fill="#78350f" /></g></svg>);
      case 'flor_tulipan': return (<svg width="100%" height="100%" viewBox="0 0 100 120" style={{ filter: 'drop-shadow(0 6px 8px rgba(0,0,0,0.15))' }}><path d="M 50 120 Q 40 80 25 40" fill="none" stroke="#16a34a" strokeWidth="5" strokeLinecap="round"/><path d="M 50 120 Q 55 80 50 30" fill="none" stroke="#15803d" strokeWidth="5" strokeLinecap="round"/><path d="M 50 120 Q 60 80 75 45" fill="none" stroke="#16a34a" strokeWidth="5" strokeLinecap="round"/><path d="M 50 110 Q 20 80 35 50 Q 40 80 50 110" fill="#22c55e"/><path d="M 50 100 Q 80 70 65 40 Q 60 70 50 100" fill="#15803d"/><g transform="translate(25, 40) rotate(-15)"><path d="M -10 0 C -10 -20 10 -20 10 0 L 5 -10 L 0 5 L -5 -10 Z" fill={el.color}/><path d="M -10 0 C -10 15 10 15 10 0 C 10 -15 -10 -15 -10 0" fill={el.color} opacity="0.8"/></g><g transform="translate(75, 45) rotate(15)"><path d="M -10 0 C -10 -20 10 -20 10 0 L 5 -10 L 0 5 L -5 -10 Z" fill={el.color}/><path d="M -10 0 C -10 15 10 15 10 0 C 10 -15 -10 -15 -10 0" fill={el.color} opacity="0.8"/></g><g transform="translate(50, 30)"><path d="M -12 0 C -12 -25 12 -25 12 0 L 6 -12 L 0 6 L -6 -12 Z" fill={el.color}/><path d="M -12 0 C -12 18 12 18 12 0 C 12 -18 -12 -18 -12 0" fill={el.color} opacity="0.9"/></g></svg>);
      case 'globo_individual': {
        const sizeInInches = el.sizeInches || 11;
        const rPx = ((sizeInInches * 0.0254) / 2) * scale;
        const getBalColor = (b) => b && b.colorOverride ? b.colorOverride : el.color;

        const renderBalloon = (b, x, y, angle = 0, scaleR = 1) => {
           if (!b) return null;
           const cColor = getBalColor(b);
           const isTrans = cColor.includes('rgba');
           const isSel = selectedBalloonId === b.id && editingGroupId === el.id;
           const sProps = isTrans ? { stroke: "rgba(255,255,255,0.8)", strokeWidth: 1 } : {};
           if (isSel) { sProps.stroke = "#ec4899"; sProps.strokeWidth = 3; }
           const finalX = x + ((b.offsetX || 0) * scale);
           const finalY = y + ((b.offsetY || 0) * scale);

           return (
             <g key={b.id} transform={`translate(${finalX}, ${finalY}) rotate(${angle})`}
                onPointerDown={(e) => {
                  if(editingGroupId === el.id) {
                    e.stopPropagation(); setSelectedBalloonId(b.id);
                    let groupOffsets = b.clusterId ? el.balloons.filter(x => x.clusterId === b.clusterId).map(x => ({id: x.id, ox: x.offsetX || 0, oy: x.offsetY || 0})) : [{id: b.id, ox: b.offsetX || 0, oy: b.offsetY || 0}];
                    setDragging({ id: el.id, type: 'balloon', balloonId: b.id, startX: e.clientX, startY: e.clientY, groupOffsets });
                  }
                }}
                style={{ cursor: editingGroupId === el.id ? 'pointer' : 'default' }}
             >
                <circle cx="0" cy="0" r={rPx * scaleR} fill={cColor} {...sProps} />
                <polygon points={`${-rPx*scaleR*0.15},${rPx*scaleR*0.95} ${rPx*scaleR*0.15},${rPx*scaleR*0.95} 0,${rPx*scaleR*1.15}`} fill={cColor} />
             </g>
           );
        };

        const bArr = el.balloons || [{id:0}];
        let balloonsNodes = [];
        const cx = w / 2; const cy = h / 2;

        if (el.clusterType === 'tercia') {
            balloonsNodes.push(renderBalloon(bArr[0], cx, cy - rPx * 0.5, 0));
            balloonsNodes.push(renderBalloon(bArr[1], cx - rPx * 0.8, cy + rPx * 0.5, -45));
            balloonsNodes.push(renderBalloon(bArr[2], cx + rPx * 0.8, cy + rPx * 0.5, 45));
        } else if (el.clusterType === 'cuarteto') {
            balloonsNodes.push(renderBalloon(bArr[0], cx - rPx * 0.6, cy - rPx * 0.6, -45));
            balloonsNodes.push(renderBalloon(bArr[1], cx + rPx * 0.6, cy - rPx * 0.6, 45));
            balloonsNodes.push(renderBalloon(bArr[2], cx - rPx * 0.6, cy + rPx * 0.6, -135));
            balloonsNodes.push(renderBalloon(bArr[3], cx + rPx * 0.6, cy + rPx * 0.6, 135));
            balloonsNodes.push(renderBalloon(bArr[4], cx, cy, 0, 0.35)); 
        } else {
            balloonsNodes.push(renderBalloon(bArr[0], cx, cy));
        }

        return <div className="w-full h-full" style={{ overflow: 'visible' }}><svg width="100%" height="100%" style={{ overflow: 'visible', filter: 'drop-shadow(2px 4px 4px rgba(0,0,0,0.15))' }}><g style={{ pointerEvents: editingGroupId === el.id ? 'auto' : 'none' }}>{balloonsNodes}</g></svg></div>;
      }
      case 'globo_guirnalda':
        const renderBalloons = [];
        const cols = el.colors && el.colors.length > 0 ? el.colors : [el.color];
        let pathVisualizer = null;
        if (selectedId === el.id && !editingGroupId) {
           const pathD = el.controlPoints.map((pt, i) => `${i===0?'M':'L'} ${pt.x * w} ${pt.y * h}`).join(' ');
           pathVisualizer = <path d={pathD} stroke="rgba(99,102,241,0.6)" strokeWidth="2" strokeDasharray="4 4" fill="none" />;
        }

        el.balloons.forEach((b) => {
          const pt = getSplinePoint(b.t, el.controlPoints);
          const bx = pt.x * w; const by = pt.y * h;
          const radiusPx = ((b.sizeInches || (b.isMain ? 11 : 9)) * 0.0254 / 2) * scale;
          const color = b.colorOverride || cols[b.id % cols.length];
          const isTransparent = color.includes('rgba');
          const isSelected = selectedBalloonId === b.id && editingGroupId === el.id;
          
          renderBalloons.push(
            <circle key={b.id} cx={bx + ((b.offsetX || 0) * scale)} cy={by + ((b.offsetY || 0) * scale)} r={radiusPx} fill={color} 
              stroke={isTransparent ? "rgba(255,255,255,0.8)" : (isSelected ? "#ec4899" : "none")}
              strokeWidth={isSelected ? 3 : (isTransparent ? 1 : 0)} opacity={isTransparent ? 1 : (b.isMain ? 0.95 : 0.9)} 
              onPointerDown={(e) => {
                if(editingGroupId === el.id) {
                  e.stopPropagation(); setSelectedBalloonId(b.id);
                  let groupOffsets = b.clusterId ? el.balloons.filter(x => x.clusterId === b.clusterId).map(x => ({id: x.id, ox: x.offsetX || 0, oy: x.offsetY || 0})) : [{id: b.id, ox: b.offsetX || 0, oy: b.offsetY || 0}];
                  setDragging({ id: el.id, type: 'balloon', balloonId: b.id, startX: e.clientX, startY: e.clientY, groupOffsets });
                }
              }}
              style={{ cursor: editingGroupId === el.id ? 'move' : 'default' }}
            />
          );
        });

        return (
          <div className="w-full h-full relative" style={{ pointerEvents: 'none' }}>
            <svg width="100%" height="100%" style={{ overflow: 'visible', filter: 'drop-shadow(3px 5px 8px rgba(0,0,0,0.2))' }}>
              {pathVisualizer}
              <g style={{ pointerEvents: editingGroupId === el.id ? 'auto' : 'none' }}>{renderBalloons}</g>
            </svg>
            {selectedId === el.id && !editingGroupId && el.controlPoints.map((pt, idx) => (
              <div key={idx} onPointerDown={(e) => handlePointerDown(e, el.id, 'curve_control', idx)}
                className="absolute w-4 h-4 bg-indigo-500 border-2 border-white rounded-full shadow-lg cursor-move pointer-events-auto hover:scale-125 transition-transform z-50 flex items-center justify-center"
                style={{ left: pt.x * w - 8, top: pt.y * h - 8 }}
              ><div className="w-1 h-1 bg-white rounded-full"></div></div>
            ))}
          </div>
        );
      default: return <div style={{ backgroundColor: el.color, width: '100%', height: '100%' }} />;
    }
  };

  const renderSidebarIcon = (item) => {
    switch(item.type) {
      case 'mampara_arco': return <div className="w-6 h-10 bg-pink-200 border-2 border-pink-300 rounded-t-full shadow-inner"></div>;
      case 'mampara_cuad': return <div className="w-8 h-10 bg-blue-200 border-2 border-blue-300 rounded-t-sm shadow-inner"></div>;
      case 'globo_guirnalda': return (<div className="flex -space-x-2"><div className="w-4 h-4 rounded-full bg-yellow-300 border border-yellow-400"></div><div className="w-5 h-5 rounded-full bg-yellow-300 border border-yellow-400 -mt-1"></div><div className="w-4 h-4 rounded-full bg-yellow-300 border border-yellow-400"></div></div>);
      case 'globo_individual': return (<div className="flex -space-x-1"><div className="w-3 h-4 bg-yellow-300 rounded-full border border-yellow-400 rounded-b-md relative"></div><div className="w-4 h-5 bg-yellow-300 rounded-full border border-yellow-400 rounded-b-md relative z-10 -mt-1"></div><div className="w-3 h-4 bg-yellow-300 rounded-full border border-yellow-400 rounded-b-md relative"></div></div>);
      case 'letras_neon': return <Type size={28} className="text-yellow-400 drop-shadow-md" />;
      case 'mesa_principal': return <div className="w-10 h-4 bg-white border-2 border-slate-300 rounded-sm shadow-sm relative"><div className="absolute top-0 w-full h-1 bg-slate-200"></div></div>;
      case 'silla_tiffany': return (<div className="w-4 h-8 flex flex-col items-center"><div className="w-3 h-4 border-x-2 border-t-2 border-slate-400 rounded-t-sm"></div><div className="w-4 h-1 bg-slate-300"></div><div className="w-3 h-3 flex justify-between"><div className="w-0.5 h-full bg-slate-400"></div><div className="w-0.5 h-full bg-slate-400"></div></div></div>);
      case 'sillon_lounge': return (<div className="w-8 h-6 flex items-end relative"><div className="w-full h-3 bg-pink-300 rounded-sm relative z-10"></div><div className="absolute top-0 left-1 w-6 h-4 bg-pink-300 rounded-t-sm"></div></div>);
      case 'silla_trono': return (<div className="w-5 h-9 flex flex-col items-center"><div className="w-4 h-5 bg-yellow-200 border-2 border-yellow-400 rounded-t-full"></div><div className="w-5 h-1.5 bg-yellow-400 rounded-sm"></div><div className="w-4 h-3 flex justify-between"><div className="w-1 h-full bg-amber-700"></div><div className="w-1 h-full bg-amber-700"></div></div></div>);
      case 'arbol_pino': return (<div className="w-6 h-10 flex flex-col items-center"><div className="w-0 h-0 border-l-[12px] border-r-[12px] border-b-[16px] border-l-transparent border-r-transparent border-b-green-600 mb-[-8px] z-20"></div><div className="w-0 h-0 border-l-[14px] border-r-[14px] border-b-[18px] border-l-transparent border-r-transparent border-b-green-600 mb-[-8px] z-10"></div><div className="w-0 h-0 border-l-[16px] border-r-[16px] border-b-[20px] border-l-transparent border-r-transparent border-b-green-600"></div><div className="w-2 h-4 bg-amber-900"></div></div>);
      case 'arbusto_redondo': return (<div className="w-6 h-8 flex flex-col items-center justify-end relative"><div className="w-6 h-6 bg-green-500 rounded-full absolute top-0 z-10"></div><div className="w-4 h-3 bg-amber-900 clip-path-polygon-[0_0,100%_0,80%_100%,20%_100%]"></div></div>);
      case 'arbol_cerezo': return <Trees size={28} className="text-pink-300" />;
      case 'flor_rosa': return <Flower2 size={24} className="text-rose-500" />;
      case 'flor_girasol': return (<div className="relative w-6 h-6 flex items-center justify-center"><div className="absolute w-6 h-6 rounded-full border-4 border-dashed border-yellow-400 animate-spin-slow"></div><div className="w-3 h-3 bg-amber-900 rounded-full z-10"></div></div>);
      case 'flor_tulipan': return (<div className="flex items-end h-8 space-x-0.5"><div className="w-2 h-3 bg-fuchsia-500 rounded-b-md"></div><div className="w-2.5 h-4 bg-fuchsia-500 rounded-b-md mb-1"></div><div className="w-2 h-3 bg-fuchsia-500 rounded-b-md"></div></div>);
      default: return <div className="w-6 h-6 bg-slate-200"></div>;
    }
  };

  const getMaterialList = () => {
    const inventory = {}; 
    elements.forEach(e => {
      if (e.type === 'globo_guirnalda' || e.type === 'globo_individual') {
        const baseColors = e.colors && e.colors.length > 0 ? e.colors : [e.color];
        (e.balloons || []).forEach(b => {
          const bSize = b.sizeInches || (b.isMain ? 11 : 9);
          const bColor = b.colorOverride || baseColors[b.id % baseColors.length] || '#ffffff';
          const key = `globo_${bSize}_${bColor}`;
          if (!inventory[key]) inventory[key] = { name: `Globos Látex (${bSize}")`, count: 0, colors: [bColor] };
          inventory[key].count++;
        });
      } else {
        let itemName = e.name;
        if (e.type.includes('mampara') || e.type.includes('mesa') || e.type.includes('sillon') || e.type.includes('letras')) itemName += ` (${Number(e.width).toFixed(1)}m x ${Number(e.height).toFixed(1)}m)`;
        const key = `${e.type}_${e.width}_${e.height}_${e.color}`;
        if (!inventory[key]) inventory[key] = { name: itemName, count: 0, colors: [e.color] };
        inventory[key].count++;
      }
    });
    return Object.values(inventory).sort((a, b) => b.count - a.count);
  };

  const selectedElement = elements.find(e => e.id === selectedId);
  const sortedElements = [...elements].sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0));

  const handlePrintWheel = (e) => {
    e.preventDefault(); e.stopPropagation();
    const zoomSensitivity = 0.002;
    const delta = -e.deltaY * zoomSensitivity;
    setPrintScale(s => Math.max(0.1, Math.min(s * (1 + delta), 5)));
  };

  const handlePrintPointerDown = (e) => {
    if (!isBlueprintPanActive) return; 
    e.preventDefault(); 
    e.stopPropagation();
    setIsPrintDragging(true);
    setPrintDragStart({ x: e.clientX - printPan.x, y: e.clientY - printPan.y });
  };

  const handlePrintPointerMove = (e) => {
    if (!isPrintDragging) return;
    setPrintPan({ x: e.clientX - printDragStart.x, y: e.clientY - printDragStart.y });
  };

  const handlePrintPointerUp = () => setIsPrintDragging(false);

  const triggerPdfDownload = async () => {
    setIsPreparingPrint(true);
    setIsCapturingPdf(true);

    setTimeout(async () => {
      try {
        const { jsPDF } = await import('jspdf');
        const html2canvas = (await import('html2canvas')).default;

        const pages = document.querySelectorAll('.export-pdf-page');
        const pdf = new jsPDF('p', 'mm', 'letter');

        for (let i = 0; i < pages.length; i++) {
           const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
           const imgData = canvas.toDataURL('image/jpeg', 0.95);
           if (i > 0) pdf.addPage();
           pdf.addImage(imgData, 'JPEG', 0, 0, 215.9, 279.4);
        }
        
        pdf.save('Blueprint-Decoracion.pdf');
        if(addNotification) addNotification('¡PDF Guardado!', 'Revisa tu carpeta de descargas.', 'success');
      } catch (error) {
        console.error(error);
        if(addNotification) addNotification('Error', 'Hubo un fallo al generar el archivo PDF.', 'error');
      }
      setIsCapturingPdf(false);
      setIsPreparingPrint(false);
      setShowExportModal(false);
    }, 500); 
  };

  if (showExportModal) {
    const materials = getMaterialList();
    const PAGE_1_LIMIT = 8;
    const PAGE_N_LIMIT = 22;
    const page1Materials = materials.slice(0, PAGE_1_LIMIT);
    const extraMaterials = materials.slice(PAGE_1_LIMIT);
    const extraPages = [];
    for (let i = 0; i < extraMaterials.length; i += PAGE_N_LIMIT) {
       extraPages.push(extraMaterials.slice(i, i + PAGE_N_LIMIT));
    }
    
    return (
      <div className="fixed inset-0 z-[120] bg-slate-900/95 flex flex-col overflow-hidden backdrop-blur-sm">
        
        <div className="bg-slate-900 text-white p-4 flex flex-col sm:flex-row justify-between items-center shadow-lg border-b border-slate-700 z-10 shrink-0 gap-4">
          <div className="flex items-center space-x-4 w-full sm:w-auto">
            <button onClick={() => setShowExportModal(false)} className="p-2 hover:bg-slate-800 rounded-full transition-colors"><X size={24}/></button>
            <div>
              <h3 className="font-bold text-sm">Vista Previa de Exportación</h3>
              <p className="text-[10px] text-slate-400">Ajusta el zoom, bloquea y descarga.</p>
            </div>
          </div>
          <button onClick={triggerPdfDownload} disabled={isPreparingPrint} className="px-6 py-3 bg-indigo-600 hover:bg-indigo-500 rounded-xl text-sm font-bold flex items-center shadow-lg transition-all w-full sm:w-auto justify-center disabled:bg-slate-600">
            {isPreparingPrint ? <RefreshCw size={18} className="mr-2 animate-spin"/> : <Download size={18} className="mr-2"/>} 
            {isPreparingPrint ? 'Armando PDF...' : 'Descargar PDF'}
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto custom-scrollbar flex flex-col items-center py-8 relative gap-8">
           
           <div className="bg-white shadow-[0_0_40px_rgba(0,0,0,0.5)] relative shrink-0 export-pdf-page" style={{ width: '215.9mm', height: '279.4mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden' }}>
             <header className="border-b-4 border-slate-900 pb-3 mb-5 flex justify-between items-end">
                <div>
                  <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Render Decorativo</h1>
                  <p className="text-slate-500 text-sm font-medium">Proyecto: Boda Ana & Luis</p>
                </div>
                <div className="text-right">
                  <p className="text-xs font-bold text-slate-400">Escala Ajustada (Carta)</p>
                </div>
             </header>

             <div 
               onPointerDown={handlePrintPointerDown} onPointerMove={handlePrintPointerMove} onPointerUp={handlePrintPointerUp} onPointerLeave={handlePrintPointerUp} onWheel={handlePrintWheel}
               className={`w-full h-[120mm] bg-[#eef2f6] border-2 border-slate-300 rounded-xl mb-6 relative overflow-hidden flex shadow-inner ${isBlueprintPanActive ? 'cursor-grab active:cursor-grabbing touch-none ring-4 ring-indigo-300' : ''}`}
             >
                {!isCapturingPdf && (
                  <div className="absolute top-3 left-3 z-50 flex flex-col sm:flex-row items-start sm:items-center gap-2">
                    <button onClick={() => setIsBlueprintPanActive(!isBlueprintPanActive)} className={`px-3 py-2 transition-colors rounded-xl font-bold text-[10px] flex items-center shadow-lg border border-slate-700 ${isBlueprintPanActive ? 'bg-indigo-500 text-white' : 'bg-slate-900/90 text-white hover:bg-slate-800'}`}>
                      <Hand size={14} className="mr-1.5"/> {isBlueprintPanActive ? 'Arrastre Activo (Bloquear para PDF)' : 'Activar Arrastre'}
                    </button>
                    <div className="bg-slate-900/90 backdrop-blur text-white rounded-xl shadow-lg flex items-center pointer-events-auto border border-slate-700">
                      <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPrintScale(s => Math.max(0.1, s - 0.15)); }} className="p-3 hover:bg-white/20 transition-colors rounded-l-xl active:bg-white/30 touch-manipulation"><Minus size={16} /></button>
                      <div className="w-px h-5 bg-white/20"></div>
                      <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPrintScale(s => Math.min(5, s + 0.15)); }} className="p-3 hover:bg-white/20 transition-colors rounded-r-xl active:bg-white/30 touch-manipulation"><Plus size={16} /></button>
                    </div>
                  </div>
                )}

                <div style={{ transform: `translate(${printPan.x}px, ${printPan.y}px) scale(${printScale})`, transformOrigin: '0 0', width: '100%', height: '100%' }}>
                  <div className="absolute inset-0 z-0 pointer-events-none" style={{ width: '5000px', height: '5000px', left: '-2500px', top: '-2500px', backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.1) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.1) 1px, transparent 1px)`, backgroundSize: `${scale}px ${scale}px` }}></div>
                  {bgImage && (
                    <div className="absolute z-0 opacity-80" style={{ left: bgPos.x * scale, top: bgPos.y * scale }}>
                      <img src={bgImage} style={{ width: bgImgSize.w * scale, height: bgImgSize.h * scale }} className="max-w-none rounded shadow-md pointer-events-none" />
                    </div>
                  )}
                  {sortedElements.map((el) => (
                    <div key={el.id} className="absolute flex items-center justify-center select-none origin-bottom pointer-events-none" style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale, top: el.y * scale, transform: `rotateZ(${el.rotation || 0}deg)`, zIndex: el.zIndex }}>
                      {renderShape(el)}
                    </div>
                  ))}
                </div>
             </div>

             <h2 className="text-lg font-bold text-slate-800 border-b border-slate-200 pb-2 mb-3 flex items-center"><CheckSquare size={18} className="mr-2 text-indigo-500"/> Lista de Requerimientos (BOM)</h2>
             <table className="w-full text-left text-xs border-collapse">
               <thead>
                 <tr className="bg-slate-100 text-slate-700">
                   <th className="py-2 px-3 font-bold border border-slate-200 w-12 text-center">Cant.</th>
                   <th className="py-2 px-3 font-bold border border-slate-200">Elemento</th>
                   <th className="py-2 px-3 font-bold border border-slate-200 w-40">Color Base</th>
                 </tr>
               </thead>
               <tbody>
                 {page1Materials.map((m, i) => (
                   <tr key={i} className="border-b border-slate-200">
                     <td className="py-2 px-3 text-center font-black text-indigo-600 border-x border-slate-200">{m.count}</td>
                     <td className="py-2 px-3 font-medium border-r border-slate-200 text-slate-800">{m.name}</td>
                     <td className="py-2 px-3 border-r border-slate-200">
                        <div className="flex flex-wrap gap-2">
                          {m.colors.map((c, idx) => (
                            <div key={idx} className="flex items-center bg-slate-50 px-1.5 py-0.5 rounded border border-slate-200">
                              <div className="w-3 h-3 rounded-full border border-slate-300 mr-1.5 shadow-sm" style={getTransparentStyle(c)}></div>
                              <span className="text-[9px] uppercase text-slate-600 font-mono font-bold">{c}</span>
                            </div>
                          ))}
                        </div>
                     </td>
                   </tr>
                 ))}
                 {materials.length === 0 && <tr><td colSpan="3" className="py-4 text-center text-slate-400">El lienzo está vacío.</td></tr>}
               </tbody>
             </table>
             <div className="absolute bottom-6 right-6 text-[10px] font-bold text-slate-400">Página 1 de {1 + extraPages.length}</div>
           </div>

           {/* 📄 PÁGINAS ADICIONALES */}
           {extraPages.map((pageMats, pIdx) => (
             <div key={`extrapage_${pIdx}`} className="bg-white shadow-2xl relative shrink-0 export-pdf-page" style={{ width: '215.9mm', height: '279.4mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden' }}>
               <header className="border-b-4 border-slate-900 pb-3 mb-6 flex justify-between items-end">
                  <div>
                    <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Render Decorativo (Cont.)</h1>
                    <p className="text-slate-500 text-sm font-medium">Proyecto: Boda Ana & Luis</p>
                  </div>
               </header>

               <table className="w-full text-left text-xs border-collapse">
                 <thead>
                   <tr className="bg-slate-100 text-slate-700">
                     <th className="py-2 px-3 font-bold border border-slate-200 w-12 text-center">Cant.</th>
                     <th className="py-2 px-3 font-bold border border-slate-200">Elemento</th>
                     <th className="py-2 px-3 font-bold border border-slate-200 w-40">Color Base</th>
                   </tr>
                 </thead>
                 <tbody>
                   {pageMats.map((m, i) => (
                     <tr key={i} className="border-b border-slate-200">
                       <td className="py-2 px-3 text-center font-black text-indigo-600 border-x border-slate-200">{m.count}</td>
                       <td className="py-2 px-3 font-medium border-r border-slate-200 text-slate-800">{m.name}</td>
                       <td className="py-2 px-3 border-r border-slate-200">
                          <div className="flex flex-wrap gap-2">
                            {m.colors.map((c, idx) => (
                              <div key={idx} className="flex items-center bg-slate-50 px-1.5 py-0.5 rounded border border-slate-200">
                                <div className="w-3 h-3 rounded-full border border-slate-300 mr-1.5 shadow-sm" style={getTransparentStyle(c)}></div>
                                <span className="text-[9px] uppercase text-slate-600 font-mono font-bold">{c}</span>
                              </div>
                            ))}
                          </div>
                       </td>
                     </tr>
                   ))}
                 </tbody>
               </table>
               <div className="absolute bottom-6 right-6 text-[10px] font-bold text-slate-400">Página {pIdx + 2} de {1 + extraPages.length}</div>
             </div>
           ))}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col space-y-4 pb-6 relative transition-colors duration-500 z-10" onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} onMouseLeave={handlePointerUp}>
      
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-3">
        <div>
          <h2 className="text-3xl font-editorial text-slate-900 dark:text-white tracking-wide">Bocetador de Decoración</h2>
          <p className="text-slate-500 dark:text-slate-400 text-sm mt-1 font-light">Arrastra elementos del catálogo al lienzo interactivo.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => setShowExportModal(true)} className="px-4 py-2 bg-white dark:bg-[#0a0a0a] border border-slate-200 dark:border-white/10 text-slate-700 dark:text-white rounded-xl text-xs uppercase tracking-widest font-bold shadow-sm hover:bg-slate-50 dark:hover:bg-white/5 transition-colors flex items-center">
            <FileDown size={14} className="mr-2 text-indigo-600 dark:text-amber-500"/> Blueprint PDF
          </button>
          <button 
            onClick={() => setSnapEnabled(!snapEnabled)} 
            className={`flex items-center px-4 py-2 rounded-xl text-xs uppercase tracking-widest font-bold transition-colors border shadow-sm ${snapEnabled ? 'bg-indigo-50 dark:bg-amber-500/10 border-indigo-200 dark:border-amber-500/20 text-indigo-700 dark:text-amber-400' : 'bg-white dark:bg-[#0a0a0a] border-slate-200 dark:border-white/10 text-slate-500 dark:text-slate-400'}`}
            title="Auto-alinear objetos magnéticamente"
          >
            <Magnet size={14} className="mr-2"/> Imán {snapEnabled ? 'ON' : 'OFF'}
          </button>

          <button onClick={() => setShowClearConfirm(true)} className="px-4 py-2 bg-white dark:bg-[#0a0a0a] border border-rose-200 dark:border-rose-500/20 text-rose-600 dark:text-rose-400 rounded-xl text-xs font-bold hover:bg-rose-50 dark:hover:bg-rose-500/10 transition-colors shadow-sm">
            <Trash2 size={16} />
          </button>
        </div>
      </div>
      
      <div className="flex-1 bg-white dark:bg-[#0a0a0a] rounded-[2rem] border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-2xl flex flex-col md:flex-row overflow-hidden relative transition-colors duration-500">
        
        {/* BANNERS DE INSTRUCCIONES CLARAS */}
        {activeTool === 'move_bg' && (
           <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-emerald-600 text-white px-6 py-3 rounded-2xl shadow-2xl z-[200] flex items-center animate-in slide-in-from-top-4 border-2 border-emerald-400">
              <Move size={20} className="mr-3 animate-pulse" />
              <div>
                <p className="font-bold text-sm">Modo Mover Fondo</p>
                <p className="text-xs text-emerald-100">Arrastra la foto para ajustarla a la cuadrícula.</p>
              </div>
              <button onClick={() => setActiveTool('select')} className="ml-6 p-2 bg-emerald-700 rounded-lg hover:bg-emerald-800 transition-colors flex items-center font-bold text-sm shadow-sm"><CheckCircle size={16} className="mr-1.5"/> Listo</button>
           </div>
        )}

        {activeTool === 'calibrate' && (
           <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-sky-600 text-white px-6 py-3 rounded-2xl shadow-2xl z-[200] flex items-center animate-in slide-in-from-top-4 border-2 border-sky-400">
              <Spline size={20} className="mr-3 animate-pulse" />
              <div>
                <p className="font-bold text-sm">Calibración Láser</p>
                <p className="text-xs text-sky-100">Haz <b>clic sostenido</b> en un extremo y <b>arrastra</b> hasta el otro.</p>
              </div>
              <button onClick={() => { setActiveTool('select'); setCalibrationLine(null); }} className="ml-6 p-2 bg-sky-700 rounded-lg hover:bg-sky-800 transition-colors flex items-center font-bold text-sm shadow-sm"><X size={16} className="mr-1.5"/> Cancelar</button>
           </div>
        )}

        {/* BARRA DE HERRAMIENTAS FLOTANTE (ESTILO CRISTAL) */}
        {isEditMode && (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 md:top-1/2 md:bottom-auto md:left-4 md:-translate-x-0 md:-translate-y-1/2 bg-white/90 dark:bg-black/60 backdrop-blur-xl border border-slate-200 dark:border-white/10 shadow-2xl rounded-2xl flex flex-row md:flex-col items-center p-2 gap-2 z-[15] transition-colors duration-500">
             <button onClick={() => setActiveTool('select')} className={`p-3 rounded-xl transition-all ${activeTool === 'select' ? 'bg-indigo-500 dark:bg-amber-500 text-white dark:text-slate-900 shadow-lg scale-110' : 'text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-white/10 hover:text-indigo-600 dark:hover:text-amber-400'}`} title="Seleccionar">
               <NavigationIcon size={20} className="-rotate-90" />
             </button>
             <button onClick={() => setActiveTool('pan')} className={`p-3 rounded-xl transition-all ${activeTool === 'pan' ? 'bg-indigo-500 dark:bg-amber-500 text-white dark:text-slate-900 shadow-lg scale-110' : 'text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-white/10 hover:text-indigo-600 dark:hover:text-amber-400'}`} title="Mover Plano">
               <Hand size={20} />
             </button>
             {bgImage && (
               <button onClick={() => setActiveTool('move_bg')} className={`p-3 rounded-xl transition-all ${activeTool === 'move_bg' ? 'bg-emerald-500 text-white shadow-lg scale-110' : 'text-slate-400 dark:text-slate-500 hover:bg-slate-100 dark:hover:bg-white/10 hover:text-emerald-500 dark:hover:text-emerald-400'}`} title="Mover Foto">
                 <ImageIcon size={20} />
               </button>
             )}
          </div>
        )}

        <div ref={containerRef} className="flex-1 relative overflow-hidden bg-slate-100 dark:bg-[#111] transition-colors duration-500">
          <div 
            className={`absolute inset-0 z-0 ${activeTool === 'calibrate' ? 'cursor-crosshair' : 'touch-none'}`}
            onPointerDown={(e) => {
              if (activeTool === 'calibrate') {
                const rect = containerRef.current.getBoundingClientRect();
                const worldX = ((e.clientX - rect.left) - offsetX) / scale;
                const worldY = ((e.clientY - rect.top) - offsetY) / scale;
                setCalibrationLine({ x1: worldX, y1: worldY, x2: worldX, y2: worldY, isDragging: true });
                return;
              }

              if (activeTool === 'move_bg' && bgImage) {
                setDragging({ type: 'move_bg', startX: e.clientX, startY: e.clientY, startBgX: bgPos.x, startBgY: bgPos.y });
                return;
              }

              setSelectedId(null); setEditingGroupId(null); setSelectedBalloonId(null);
              if (activeTool === 'pan' || activeTool === 'select') {
                setDragging({ isPanning: true, startX: e.clientX, startY: e.clientY, startPanX: pan.x, startPanY: pan.y });
              }
            }}
            onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); e.dataTransfer.dropEffect = 'copy'; }}
            onDrop={handleDropOnCanvas}
          />

          <div className="w-full h-full pointer-events-none">
            <div className="w-full h-full touch-none">
              
              {/* 🔴 GRID DE FONDO DE ARQUITECTURA (CLARO Y OSCURO) */}
              <div className="absolute inset-0 z-0 pointer-events-none">
                {bgImage && (
                  <div className="absolute z-0 pointer-events-none opacity-60" style={{ left: (bgPos.x * scale) + offsetX, top: (bgPos.y * scale) + offsetY }}>
                    <img src={bgImage} style={{ width: bgImgSize.w * scale, height: bgImgSize.h * scale }} className="max-w-none shadow-2xl border-4 border-slate-300 dark:border-white/10 rounded" />
                  </div>
                )}
                <div className="absolute inset-0 transition-opacity duration-500 z-10 pointer-events-none bg-transparent" 
                     style={{ 
                       backgroundImage: `linear-gradient(to right, rgba(120,120,120,0.15) 1px, transparent 1px), linear-gradient(to bottom, rgba(120,120,120,0.15) 1px, transparent 1px)`, 
                       backgroundSize: `${scale}px ${scale}px`, 
                       backgroundPosition: `${offsetX}px ${offsetY}px` 
                     }} />
              </div>

              {calibrationLine && (() => {
                 const p1x = calibrationLine.x1 * scale + offsetX; const p1y = calibrationLine.y1 * scale + offsetY;
                 const p2x = calibrationLine.x2 * scale + offsetX; const p2y = calibrationLine.y2 * scale + offsetY;
                 return (
                   <svg className="absolute inset-0 w-full h-full pointer-events-none z-[150] overflow-visible">
                      <line x1={p1x} y1={p1y} x2={p2x} y2={p2y} stroke="#0ea5e9" strokeWidth="4" strokeDasharray="8 4" />
                      <circle cx={p1x} cy={p1y} r="8" fill="#0ea5e9" stroke="white" strokeWidth="3" />
                      <circle cx={p2x} cy={p2y} r="8" fill="#0ea5e9" stroke="white" strokeWidth="3" />
                   </svg>
                 );
              })()}

              <div className="absolute inset-0 pointer-events-none z-20">
                {sortedElements.map((el) => {
                  const isSelected = selectedId === el.id;
                  const isDimmed = editingGroupId && editingGroupId !== el.id;
                  return (
                    <div key={el.id} onPointerDown={(e) => handlePointerDown(e, el.id)} onDoubleClick={(e) => { if (el.type === 'globo_guirnalda' || el.type === 'globo_individual') { e.stopPropagation(); setEditingGroupId(el.id); setSelectedBalloonId(null); } }}
                      className={`absolute flex items-center justify-center cursor-pointer select-none origin-bottom ${isSelected && !editingGroupId ? 'ring-2 ring-offset-4 ring-pink-500 dark:ring-amber-500 dark:ring-offset-black z-[100]' : ''} ${!editingGroupId ? 'hover:ring-2 hover:ring-offset-2 hover:ring-slate-400 dark:hover:ring-white/50 pointer-events-auto' : ''}`}
                      style={{ width: el.width * scale, height: el.height * scale, left: el.x * scale + offsetX, top: el.y * scale + offsetY, transform: `rotateZ(${el.rotation || 0}deg)`, zIndex: isSelected ? 9999 : el.zIndex, opacity: isDimmed ? 0.3 : 1 }}
                    >
                      {renderShape(el)}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        
        <div className="w-full md:w-80 border-l border-slate-200 dark:border-white/5 bg-slate-50 dark:bg-black/20 backdrop-blur-xl flex flex-col z-20 relative h-full shrink-0 transition-colors duration-500">
          
          {/* PANEL DE EDICIÓN ULTRA COMPACTO */}
          {selectedElement && (
            <div className="shrink-0 bg-white dark:bg-[#0a0a0a] border-b-2 border-indigo-200 dark:border-amber-500/20 p-4 shadow-md z-30 relative max-h-[40vh] overflow-y-auto custom-scrollbar animate-in slide-in-from-right-4 transition-colors">
              <div className="flex items-center justify-between mb-3 border-b border-slate-100 dark:border-white/5 pb-2">
                <h3 className="font-bold text-slate-800 dark:text-white text-xs flex items-center uppercase tracking-widest"><Palette size={14} className="mr-1.5 text-indigo-500 dark:text-amber-500"/> Editar {selectedElement.name}</h3>
                <div className="flex items-center space-x-1.5">
                  {editingGroupId && <button onClick={() => { setEditingGroupId(null); setSelectedBalloonId(null); }} className="text-pink-600 dark:text-amber-900 bg-pink-50 dark:bg-amber-500 hover:bg-pink-100 dark:hover:bg-amber-400 text-[9px] font-black uppercase px-2.5 py-1.5 rounded-md transition-colors">Cerrar Edición</button>}
                  <button onClick={() => {setSelectedId(null); setEditingGroupId(null);}} className="p-1.5 text-slate-400 dark:text-slate-500 hover:text-rose-500 dark:hover:text-rose-400 bg-slate-100 dark:bg-white/5 rounded-md transition-colors"><X size={14}/></button>
                </div>
              </div>

              {editingGroupId && (selectedElement.type === 'globo_guirnalda' || selectedElement.type === 'globo_individual') ? (
                <div className="space-y-3">
                  {selectedBalloonId !== null ? (() => {
                     const b = selectedElement.balloons.find(x => x.id === selectedBalloonId);
                     if (!b) return null;
                     return (
                       <>
                         <div>
                           <label className="block text-[9px] font-black text-pink-700 dark:text-amber-500 uppercase tracking-widest mb-2">Color de Globo</label>
                           <div className="flex flex-wrap gap-1.5">
                             {PRESET_COLORS.map(color => (
                               <button key={color} onClick={() => { const newBalloons = selectedElement.balloons.map(x => x.id === selectedBalloonId ? {...x, colorOverride: color} : x); updateElementData(selectedElement.id, { balloons: newBalloons }); }} className={`w-6 h-6 rounded-full shadow-sm border-2 ${b.colorOverride === color ? 'border-pink-500 dark:border-amber-500 scale-110' : 'border-slate-200 dark:border-white/10 hover:scale-110 transition-transform'}`} style={getTransparentStyle(color)} />
                             ))}
                           </div>
                           <button onClick={() => { const newBalloons = selectedElement.balloons.map(x => x.id === selectedBalloonId ? {...x, colorOverride: null} : x); updateElementData(selectedElement.id, { balloons: newBalloons }); }} className="text-[10px] bg-white dark:bg-white/5 border border-pink-200 dark:border-white/10 px-3 py-1.5 rounded-lg text-pink-600 dark:text-slate-300 font-bold uppercase tracking-widest mt-3 w-full text-center hover:bg-pink-50 dark:hover:bg-white/10 transition-colors shadow-sm">Restaurar Color Base</button>
                         </div>
                         <div>
                           <label className="block text-[9px] font-black text-pink-700 dark:text-amber-500 uppercase tracking-widest mb-1.5 mt-2">Medida (Pulgadas)</label>
                           <select value={b.sizeInches || selectedElement.sizeInches || (b.isMain ? 11 : 5)} onChange={e => { const val = parseFloat(e.target.value); const newBalloons = selectedElement.balloons.map(x => x.id === selectedBalloonId ? {...x, sizeInches: val} : x); updateElementData(selectedElement.id, { balloons: newBalloons }); }} className="w-full px-3 py-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none text-slate-700 dark:text-white focus:border-pink-400 dark:focus:border-amber-500 transition-colors">
                             <option value={5}>5"</option><option value={9}>9"</option><option value={11}>11"</option><option value={18}>18"</option><option value={24}>24"</option><option value={36}>36"</option>
                           </select>
                         </div>
                       </>
                     );
                  })() : (
                     <div className="bg-pink-50 dark:bg-amber-500/10 text-pink-700 dark:text-amber-400 p-3 rounded-xl text-[10px] font-bold border border-pink-200 dark:border-amber-500/20 flex items-start shadow-sm"><Info size={16} className="mr-2 flex-shrink-0 mt-0.5" />Toca un globo en el lienzo para aislarlo, cambiar su medida o color.</div>
                  )}

                  {selectedElement.type === 'globo_guirnalda' && (
                    <div className="mt-3 pt-3 border-t border-slate-100 dark:border-white/5">
                      <label className="block text-[9px] font-black text-indigo-700 dark:text-amber-500 uppercase tracking-widest mb-2 text-center">Agregar Cluster</label>
                      <div className="grid grid-cols-3 gap-2">
                        <button onClick={() => addClusterToGarland('single')} className="py-2 bg-white dark:bg-white/5 text-indigo-700 dark:text-white border border-indigo-200 dark:border-white/10 rounded-lg text-[10px] font-bold hover:bg-indigo-50 dark:hover:bg-white/10 transition-colors shadow-sm flex flex-col items-center"><div className="w-3 h-3 bg-indigo-400 dark:bg-amber-500 rounded-full mb-1"></div>1</button>
                        <button onClick={() => addClusterToGarland('tercia')} className="py-2 bg-white dark:bg-white/5 text-indigo-700 dark:text-white border border-indigo-200 dark:border-white/10 rounded-lg text-[10px] font-bold hover:bg-indigo-50 dark:hover:bg-white/10 transition-colors shadow-sm flex flex-col items-center"><div className="flex -space-x-1 mb-1"><div className="w-2.5 h-2.5 bg-indigo-400 dark:bg-amber-500 rounded-full"></div><div className="w-2.5 h-2.5 bg-indigo-400 dark:bg-amber-500 rounded-full z-10"></div><div className="w-2.5 h-2.5 bg-indigo-400 dark:bg-amber-500 rounded-full"></div></div>3</button>
                        <button onClick={() => addClusterToGarland('cuarteto')} className="py-2 bg-white dark:bg-white/5 text-indigo-700 dark:text-white border border-indigo-200 dark:border-white/10 rounded-lg text-[10px] font-bold hover:bg-indigo-50 dark:hover:bg-white/10 transition-colors shadow-sm flex flex-col items-center"><div className="grid grid-cols-2 gap-[1px] mb-1"><div className="w-1.5 h-1.5 bg-indigo-400 dark:bg-amber-500 rounded-full"></div><div className="w-1.5 h-1.5 bg-indigo-400 dark:bg-amber-500 rounded-full"></div><div className="w-1.5 h-1.5 bg-indigo-400 dark:bg-amber-500 rounded-full"></div><div className="w-1.5 h-1.5 bg-indigo-400 dark:bg-amber-500 rounded-full"></div></div>4</button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="space-y-3">
                  {selectedElement.type === 'globo_individual' && (
                    <>
                      <div>
                        <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-1.5">Agrupación</label>
                        <select value={selectedElement.clusterType || 'single'} onChange={(e) => { const newType = e.target.value; let newBalloons = []; if (newType === 'single') newBalloons = [{id:0, clusterId: 1, colorOverride: null}]; if (newType === 'tercia') newBalloons = [{id:0, clusterId: 1, colorOverride: null}, {id:1, clusterId: 1, colorOverride: null}, {id:2, clusterId: 1, colorOverride: null}]; if (newType === 'cuarteto') newBalloons = [{id:0, clusterId: 1, colorOverride: null}, {id:1, clusterId: 1, colorOverride: null}, {id:2, clusterId: 1, colorOverride: null}, {id:3, clusterId: 1, colorOverride: null}, {id:4, clusterId: 1, colorOverride: null}]; updateElementData(selectedId, { clusterType: newType, balloons: newBalloons }); }} className="w-full px-3 py-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none focus:border-indigo-400 dark:focus:border-amber-500 text-slate-800 dark:text-white transition-colors">
                          <option value="single">Suelto</option><option value="tercia">Tercia (3)</option><option value="cuarteto">Cuarteto (4)</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-1.5 mt-2">Diámetro (Pulgadas)</label>
                        <select value={selectedElement.sizeInches || 11} onChange={(e) => updateElementData(selectedId, { sizeInches: parseFloat(e.target.value) })} className="w-full px-3 py-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none focus:border-indigo-400 dark:focus:border-amber-500 text-slate-800 dark:text-white transition-colors">
                          <option value={5}>5"</option><option value={9}>9"</option><option value={11}>11"</option><option value={18}>18"</option><option value={24}>24"</option><option value={36}>36"</option>
                        </select>
                      </div>
                    </>
                  )}

                  {selectedElement.type === 'globo_guirnalda' ? (
                    <div>
                      <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Paleta de Colores</label>
                      <div className="flex flex-wrap gap-2 mb-4">
                        {PRESET_COLORS.map(color => {
                          const isSelected = selectedElement.colors?.includes(color);
                          return (
                            <button key={color} onClick={() => toggleGarlandColor(selectedId, color)} className={`w-6 h-6 rounded-full shadow-sm border-2 transition-transform ${isSelected ? 'border-indigo-600 dark:border-amber-500 scale-110' : 'border-slate-200 dark:border-white/10 hover:scale-110'}`} style={getTransparentStyle(color)} />
                          );
                        })}
                      </div>
                      <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-1.5">Densidad (Cantidad de Globos)</label>
                      <input type="number" min="3" max="300" value={selectedElement.balloonCount || 45} onChange={(e) => handleGarlandCountChange(selectedId, parseInt(e.target.value) || 45)} className="w-full px-3 py-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-black text-indigo-600 dark:text-amber-500 outline-none focus:border-indigo-400 dark:focus:border-amber-400 shadow-inner transition-colors" />
                    </div>
                  ) : (
                    <div>
                      <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-2">Color del Mobiliario</label>
                      <div className="flex flex-wrap gap-2">
                        {PRESET_COLORS.map(color => (<button key={color} onClick={() => updateElementData(selectedId, { color })} className={`w-6 h-6 rounded-full shadow-sm border-2 transition-transform hover:scale-110 ${selectedElement.color === color ? 'border-indigo-500 dark:border-amber-500 scale-110' : 'border-slate-200 dark:border-white/10'}`} style={getTransparentStyle(color)} />))}
                        <label className="w-6 h-6 rounded-full shadow-sm border-2 border-dashed border-indigo-400 dark:border-amber-500 flex items-center justify-center cursor-pointer hover:bg-indigo-50 dark:hover:bg-amber-500/10 transition-colors bg-white dark:bg-[#111]"><PaintBucket size={12} className="text-indigo-600 dark:text-amber-500" /><input type="color" value={selectedElement.color} onChange={(e) => updateElementData(selectedId, { color: e.target.value })} className="opacity-0 absolute w-0 h-0" /></label>
                      </div>
                    </div>
                  )}

                  {selectedElement.type === 'letras_neon' && (
                    <div className="mt-3">
                      <label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-1.5">Texto Neón</label>
                      <input type="text" value={selectedElement.text} onChange={(e) => updateElementData(selectedId, { text: e.target.value })} className="w-full px-3 py-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none focus:border-indigo-400 dark:focus:border-amber-500 text-slate-800 dark:text-white shadow-inner transition-colors" />
                    </div>
                  )}

                  {selectedElement.type !== 'globo_individual' && (
                    <div className="flex items-center gap-3 pt-3 mt-2 border-t border-slate-100 dark:border-white/5 transition-colors">
                      <div className="flex-1"><label className="block text-[9px] font-black text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-1 text-center">Ancho (m)</label><input type="number" step="0.1" min="0.1" value={selectedElement.width} onChange={(e) => updateElementData(selectedId, { width: parseFloat(e.target.value) || 0.1 })} className="w-full px-2 py-1.5 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none text-center focus:border-indigo-400 dark:focus:border-amber-500 text-slate-800 dark:text-white shadow-inner transition-colors" /></div>
                      <div className="flex-1"><label className="block text-[9px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-1 text-center">Alto (m)</label><input type="number" step="0.1" min="0.1" value={selectedElement.height} onChange={(e) => updateElementData(selectedId, { height: parseFloat(e.target.value) || 0.1 })} className="w-full px-2 py-1.5 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-lg text-xs font-bold outline-none text-center focus:border-indigo-400 dark:focus:border-amber-500 text-slate-800 dark:text-white shadow-inner transition-colors" /></div>
                    </div>
                  )}
                </div>
              )}
              
              {/* BOTONES DE CAPA Y BORRAR */}
              {!editingGroupId && (
                 <div className="flex items-center gap-2 pt-4 mt-4 border-t border-slate-100 dark:border-white/5 transition-colors">
                   <button onClick={() => changeZIndex(selectedId, 1)} className="flex-1 py-2 bg-slate-50 dark:bg-white/5 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-white/10 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-white hover:border-indigo-300 dark:hover:border-white/20 hover:text-indigo-600 dark:hover:text-white flex items-center justify-center transition-colors shadow-sm"><ArrowUp size={12} className="mr-1"/> Frente</button>
                   <button onClick={() => changeZIndex(selectedId, -1)} className="flex-1 py-2 bg-slate-50 dark:bg-white/5 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-white/10 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-white hover:border-indigo-300 dark:hover:border-white/20 hover:text-indigo-600 dark:hover:text-white flex items-center justify-center transition-colors shadow-sm"><ArrowDown size={12} className="mr-1"/> Fondo</button>
                   <button onClick={deleteSelected} className="flex-1 py-2 bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400 border border-rose-200 dark:border-rose-500/20 rounded-lg text-[9px] font-black uppercase tracking-widest hover:bg-rose-100 dark:hover:bg-rose-500/20 hover:border-rose-300 dark:hover:border-rose-500/40 flex items-center justify-center transition-colors shadow-sm"><Trash2 size={12} className="mr-1"/> Borrar</button>
                 </div>
              )}
            </div>
          )}

          <div className="overflow-y-auto flex-1 hide-scrollbar p-5 space-y-6">
            <div className="bg-white dark:bg-[#0a0a0a] rounded-2xl shadow-sm dark:shadow-2xl border border-slate-200 dark:border-white/10 p-5 transition-colors">
              <h3 className="font-bold text-slate-800 dark:text-white mb-3 text-[10px] uppercase tracking-widest flex items-center border-b border-slate-100 dark:border-white/5 pb-2 transition-colors"><MapPin size={14} className="mr-1.5 text-rose-500 dark:text-rose-400"/> Escenario Real</h3>
              {!bgImage ? (
                <><input type="file" accept="image/*" ref={fileInputRefBg} onChange={handleBgUpload} className="hidden" /><button onClick={() => fileInputRefBg.current.click()} className="w-full py-4 bg-slate-50 dark:bg-[#111] text-slate-600 dark:text-slate-400 rounded-xl font-black uppercase tracking-widest text-[10px] hover:bg-slate-100 dark:hover:bg-white/5 hover:text-indigo-600 dark:hover:text-white transition-colors flex items-center justify-center border-2 border-dashed border-slate-300 dark:border-white/20"><ImageIcon size={16} className="mr-2"/> Subir Foto / Plano</button></>
              ) : (
                <div className="space-y-2.5">
                  <button onClick={() => setActiveTool('calibrate')} className={`w-full py-3 rounded-xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center transition-all shadow-sm ${activeTool === 'calibrate' ? 'bg-sky-500 text-white ring-2 ring-sky-200' : 'bg-sky-50 dark:bg-sky-500/10 text-sky-600 dark:text-sky-400 hover:bg-sky-100 dark:hover:bg-sky-500/20 border border-sky-200 dark:border-sky-500/20'}`}><Spline size={14} className="mr-2"/> Calibrar Medidas</button>
                  <button onClick={() => setActiveTool('move_bg')} className={`w-full py-3 rounded-xl font-black text-[10px] uppercase tracking-widest flex items-center justify-center transition-all shadow-sm ${activeTool === 'move_bg' ? 'bg-emerald-500 text-white ring-2 ring-emerald-200' : 'bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-500/20 border border-emerald-200 dark:border-emerald-500/20'}`}><Move size={14} className="mr-2"/> Mover Fondo</button>
                  <button onClick={removeBackground} className="w-full py-2.5 bg-white dark:bg-transparent border border-rose-200 dark:border-rose-500/20 text-rose-500 dark:text-rose-400 rounded-xl font-black uppercase tracking-widest text-[9px] hover:bg-rose-50 dark:hover:bg-rose-500/10 transition-colors mt-2">Quitar Imagen</button>
                </div>
              )}
            </div>

            <div>
              <h3 className="font-bold text-slate-800 dark:text-white mb-4 text-[10px] uppercase tracking-widest flex items-center"><Layers size={14} className="mr-2 text-indigo-500 dark:text-amber-500"/> Catálogo PRO</h3>
              <div className="grid grid-cols-2 gap-3 pb-6">
                {DECO_CATALOG.map((item, idx) => (
                  <div key={idx} draggable onDragStart={(e) => handleDragStart(e, item)} onClick={() => { const cx = (-pan.x / scale) + ((vp.w / 2) / scale) - (item.defaultW / 2); const cy = (-pan.y / scale) + ((vp.h / 2) / scale) - (item.defaultH / 2); createNewElement(item, cx, cy); }} className="bg-white dark:bg-[#0a0a0a] p-3 rounded-2xl border border-slate-200 dark:border-white/10 text-center cursor-grab active:cursor-grabbing hover:border-pink-400 dark:hover:border-amber-500 hover:shadow-md transition-all group" title="Haz clic para agregar al centro, o arrastra al lienzo">
                     <div className="h-10 flex items-center justify-center mb-2 pointer-events-none group-hover:scale-110 transition-transform">{renderSidebarIcon(item)}</div>
                     <p className="text-[9px] font-bold text-slate-600 dark:text-slate-400 leading-tight pointer-events-none uppercase tracking-wider">{item.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {calibrationModal && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in zoom-in-95 transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] w-full max-w-md overflow-hidden shadow-2xl p-8 text-center border-4 border-sky-200 dark:border-sky-500/30 transition-colors">
             <div className="w-20 h-20 bg-sky-50 dark:bg-sky-500/10 text-sky-500 dark:text-sky-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner dark:border dark:border-sky-500/20"><Maximize size={36} /></div>
             <h3 className="font-editorial font-black text-2xl text-slate-800 dark:text-white mb-2 transition-colors">Escalar Fondo</h3>
             <p className="text-slate-500 dark:text-slate-400 text-sm mb-8 leading-relaxed">¿Cuántos <b>metros reales</b> mide la línea azul que acabas de trazar en la foto?</p>
             <div className="flex items-center justify-center bg-slate-50 dark:bg-[#111] border-2 border-slate-200 dark:border-white/10 rounded-2xl mb-8 focus-within:border-sky-400 dark:focus-within:border-sky-500 transition-all shadow-inner">
                <input type="number" step="0.1" autoFocus placeholder="Ej. 2.5" value={realDistanceInput} onChange={(e) => setRealDistanceInput(e.target.value)} className="w-full p-4 bg-transparent outline-none font-black text-3xl text-center text-slate-800 dark:text-white" />
                <span className="pr-6 font-black text-slate-400 dark:text-slate-500 text-xs uppercase tracking-widest">metros</span>
             </div>
             <div className="flex space-x-3">
                <button onClick={() => { setCalibrationModal(null); setCalibrationLine(null); setActiveTool('select'); }} className="flex-1 p-4 bg-slate-100 dark:bg-white/5 text-slate-600 dark:text-slate-300 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-slate-200 dark:hover:bg-white/10 transition-colors">Cancelar</button>
                <button onClick={applyCalibration} className="flex-1 p-4 bg-sky-500 text-white dark:text-slate-900 rounded-xl font-black uppercase tracking-widest text-[10px] shadow-lg hover:bg-sky-600 dark:hover:bg-sky-400 hover:shadow-sky-500/30 transition-all active:scale-95">Aplicar Escala</button>
             </div>
          </div>
        </div>
      )}

      {showClearConfirm && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/60 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in zoom-in-95 transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-sm overflow-hidden p-8 text-center shadow-2xl border border-rose-100 dark:border-white/10 transition-colors">
             <div className="w-16 h-16 bg-rose-100 dark:bg-rose-500/10 text-rose-500 rounded-full flex items-center justify-center mx-auto mb-6 dark:border dark:border-rose-500/20"><Trash2 size={32} /></div>
             <h3 className="font-editorial font-black text-2xl text-slate-800 dark:text-white mb-2 transition-colors">¿Borrar Diseño?</h3>
             <p className="text-slate-500 dark:text-slate-400 mb-8 text-sm leading-relaxed">Se eliminarán todos los muebles y fondos de este plano. Esta acción no se puede deshacer.</p>
             <div className="flex space-x-3">
               <button onClick={() => setShowClearConfirm(false)} className="flex-1 p-4 bg-slate-100 dark:bg-white/5 text-slate-700 dark:text-white rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-slate-200 dark:hover:bg-white/10 transition-colors">Cancelar</button>
               <button onClick={executeClearAll} className="flex-1 p-4 bg-rose-500 text-white rounded-xl font-black uppercase tracking-widest text-[10px] hover:bg-rose-600 transition-colors shadow-md dark:shadow-[0_0_15px_rgba(244,63,94,0.3)]">Sí, Borrar Todo</button>
             </div>
          </div>
        </div>
      )}

    </div>
  );
};

// ==========================================
// --- COMPONENTE: CHECKLIST (DARK PREMIUM) ---
// ==========================================
const ChecklistView = ({ tareas, addNotification }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [filtroCategoria, setFiltroCategoria] = useState('Todas');
  
  const [formData, setFormData] = useState({
    titulo: '', categoria: 'Logística', fechaLimite: '', estado: 'pendiente'
  });

  const categorias = ['Logística', 'Comida/Bebida', 'Comunicación', 'Música', 'Decoración', 'Finanzas', 'Otros'];

  const safeTareas = tareas || [];

  const handleSaveTarea = async (e) => {
    e.preventDefault();
    const nuevoId = Date.now().toString();
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "tareas", nuevoId), { id: nuevoId, ...formData });
    setIsFormOpen(false);
    setFormData({ titulo: '', categoria: 'Logística', fechaLimite: '', estado: 'pendiente' });
    if(addNotification) addNotification('Tarea Agregada', 'Se ha añadido al tablero correctamente.', 'success', 'tareas');
  };

  const moverTarea = async (id, nuevoEstado) => {
    const tarea = safeTareas.find(t => t.id === id);
    if(tarea) {
      await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "tareas", id.toString()), { ...tarea, estado: nuevoEstado });
    }
  };

  const eliminarTarea = async (id) => {
    await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "tareas", id.toString()));
    if(addNotification) addNotification('Tarea Eliminada', 'Se ha quitado del checklist.', 'warning');
  };

  const isOverdue = (dateStr) => {
    if (!dateStr) return false;
    return new Date(dateStr) < new Date();
  };

  const tareasFiltradas = filtroCategoria === 'Todas' 
    ? safeTareas 
    : safeTareas.filter(t => t.categoria === filtroCategoria);

  const pendientes = tareasFiltradas.filter(t => t.estado === 'pendiente');
  const enProceso = tareasFiltradas.filter(t => t.estado === 'proceso');
  const completadas = tareasFiltradas.filter(t => t.estado === 'listo');

  const renderTarea = (tarea) => {
    const overdue = isOverdue(tarea.fechaLimite) && tarea.estado !== 'listo';
    
    return (
      <div key={tarea.id} className={`bg-[#141210] p-4 rounded-2xl border shadow-sm mb-3 transition-all hover:shadow-md hover:scale-[1.01] group hover:border-[#D4AF37]/50 ${overdue ? 'border-rose-500/40 shadow-[0_0_15px_rgba(244,63,94,0.1)]' : 'border-white/10'}`}>
        <div className="flex justify-between items-start mb-2">
          <span className="px-2 py-1 bg-white/5 text-slate-400 border border-white/5 rounded-md text-[8px] font-black uppercase tracking-widest">{tarea.categoria}</span>
          <button onClick={() => eliminarTarea(tarea.id)} className="text-slate-600 hover:text-rose-500 opacity-100 md:opacity-0 group-hover:opacity-100 transition-opacity p-1"><X size={14}/></button>
        </div>
        
        <h4 className={`font-bold text-sm mb-3 leading-snug ${tarea.estado === 'listo' ? 'text-slate-500 line-through' : 'text-white'}`}>
          {tarea.titulo}
        </h4>
        
        <div className="flex items-center justify-between mt-auto pt-3 border-t border-white/5 gap-2">
          <div className="flex items-center shrink-0">
            {tarea.fechaLimite ? (
              <span className={`text-[8px] font-black uppercase tracking-widest flex items-center px-1.5 py-1 rounded-md border ${overdue ? 'text-rose-400 bg-rose-500/10 border-rose-500/20' : 'text-slate-400 bg-white/5 border-white/10'}`}>
                {overdue ? <AlertCircle size={10} className="mr-1.5"/> : <Calendar size={10} className="mr-1.5"/>}
                <span>{tarea.fechaLimite}</span>
              </span>
            ) : <span className="text-[8px] font-bold text-slate-500 uppercase tracking-widest flex items-center"><Calendar size={10} className="mr-1"/> <span>Sin fecha</span></span>}
          </div>
          
          <div className="flex flex-wrap gap-1.5 justify-end">
            {tarea.estado === 'pendiente' && (
              <button onClick={() => moverTarea(tarea.id, 'proceso')} className="px-2 py-1.5 bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/20 text-[8px] font-black uppercase tracking-widest rounded-lg hover:bg-[#D4AF37]/20 transition-colors flex items-center">
                <Clock size={10} className="mr-1.5 w-3 h-3"/> Iniciar
              </button>
            )}
            {tarea.estado === 'proceso' && (
              <>
                <button onClick={() => moverTarea(tarea.id, 'pendiente')} className="px-2 py-1.5 text-slate-400 text-[8px] font-black uppercase tracking-widest hover:text-white transition-colors">Pausar</button>
                <button onClick={() => moverTarea(tarea.id, 'listo')} className="px-2 py-1.5 bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 text-[8px] font-black uppercase tracking-widest rounded-lg hover:bg-emerald-500/20 transition-colors flex items-center">
                  <CheckCircle2 size={10} className="mr-1.5 w-3 h-3"/> Listo
                </button>
              </>
            )}
            {tarea.estado === 'listo' && (
              <button onClick={() => moverTarea(tarea.id, 'pendiente')} className="px-2 py-1.5 text-slate-500 text-[8px] font-black uppercase tracking-widest hover:text-[#D4AF37] transition-colors">Reabrir</button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="h-full flex flex-col space-y-6 pb-6 relative text-white bg-[#141210] min-h-[100vh] p-4 rounded-3xl transition-colors duration-500 z-10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-[#1C1917] p-5 sm:p-6 rounded-3xl border border-[#D4AF37]/25 shadow-xl">
        <div className="flex items-center gap-3.5">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
            <ListTodo size={20} />
          </div>
          <div>
            <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block mb-0.5">Organiza tu progreso logístico.</span>
            <h2 className="text-2xl sm:text-3xl font-editorial text-white tracking-wide leading-none">Tablero de Actividades</h2>
          </div>
        </div>
        
        <div className="flex flex-wrap items-center gap-2.5 w-full md:w-auto justify-start md:justify-end">
          <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)} className="px-3.5 py-2 h-9 bg-[#141210] border border-white/10 rounded-lg text-[10px] font-bold text-white outline-none focus:border-[#D4AF37] shadow-sm transition-colors flex-1 sm:flex-none cursor-pointer uppercase tracking-widest appearance-none">
            <option value="Todas">Todas las Categorías</option>
            {categorias.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <button onClick={() => setIsFormOpen(true)} className="flex-1 md:flex-none flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-[#1C1917] rounded-lg text-[10px] font-black hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)] uppercase tracking-widest shrink-0">
            <Plus size={14} className="mr-1.5 shrink-0" /> Nueva Tarea
          </button>
        </div>
      </div>

      {/* 🔴 CONTENEDOR CON SWIPE HORIZONTAL PARA MÓVILES */}
      <div className="flex-1 flex md:flex-row gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory custom-scrollbar pb-4 md:pb-0">
        
        {/* COLUMNA 1: POR HACER */}
        <div className="w-[80vw] md:w-auto md:flex-1 shrink-0 snap-center flex flex-col bg-[#1C1917] rounded-3xl border border-white/5 p-4 transition-colors shadow-xl">
          <div className="flex items-center justify-between mb-5 px-2 pt-2">
            <h3 className="font-black text-slate-300 flex items-center text-xs uppercase tracking-widest"><Circle size={14} className="mr-2 text-slate-500"/> Por Hacer</h3>
            <span className="bg-[#141210] text-slate-400 text-[10px] font-black px-2.5 py-1 rounded-md border border-white/5 shadow-sm">{pendientes.length}</span>
          </div>
          <div className="flex-1 overflow-y-auto px-1 pb-4 custom-scrollbar">
            {pendientes.map(renderTarea)}
            {pendientes.length === 0 && <div className="text-center py-12 text-slate-500 text-xs border border-dashed border-white/10 bg-white/5 rounded-2xl font-medium">No hay tareas pendientes.</div>}
          </div>
        </div>

        {/* COLUMNA 2: EN PROCESO */}
        <div className="w-[80vw] md:w-auto md:flex-1 shrink-0 snap-center flex flex-col bg-[#1C1917] rounded-3xl border border-[#D4AF37]/20 p-4 transition-colors shadow-[0_0_20px_rgba(212,175,55,0.05)]">
          <div className="flex items-center justify-between mb-5 px-2 pt-2">
            <h3 className="font-black text-[#D4AF37] flex items-center text-xs uppercase tracking-widest"><Clock size={14} className="mr-2 text-[#D4AF37]"/> En Proceso</h3>
            <span className="bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 text-[10px] font-black px-2.5 py-1 rounded-md shadow-sm">{enProceso.length}</span>
          </div>
          <div className="flex-1 overflow-y-auto px-1 pb-4 custom-scrollbar">
            {enProceso.map(renderTarea)}
            {enProceso.length === 0 && <div className="text-center py-12 text-[#D4AF37]/50 text-xs border border-dashed border-[#D4AF37]/20 bg-[#D4AF37]/5 rounded-2xl font-medium">Inicia una tarea.</div>}
          </div>
        </div>

        {/* COLUMNA 3: COMPLETADO */}
        <div className="w-[80vw] md:w-auto md:flex-1 shrink-0 snap-center flex flex-col bg-[#1C1917] rounded-3xl border border-emerald-500/10 p-4 transition-colors shadow-xl">
          <div className="flex items-center justify-between mb-5 px-2 pt-2">
            <h3 className="font-black text-emerald-400 flex items-center text-xs uppercase tracking-widest"><CheckCircle2 size={14} className="mr-2 text-emerald-500"/> Completado</h3>
            <span className="bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 text-[10px] font-black px-2.5 py-1 rounded-md shadow-sm">{completadas.length}</span>
          </div>
          <div className="flex-1 overflow-y-auto px-1 pb-4 custom-scrollbar">
            {completadas.map(renderTarea)}
            {completadas.length === 0 && <div className="text-center py-12 text-emerald-500/50 text-xs border border-dashed border-emerald-500/20 bg-emerald-500/5 rounded-2xl font-medium">Aún no hay tareas terminadas.</div>}
          </div>
        </div>
      </div>

      {/* MODAL FORMULARIO */}
      {isFormOpen && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in zoom-in-95 duration-200 transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors">
              <h3 className="font-editorial font-black text-xl text-[#D4AF37] flex items-center tracking-wide"><ListTodo size={20} className="mr-2.5"/> Agregar Tarea</h3>
              <button onClick={() => setIsFormOpen(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            </div>
            <form onSubmit={handleSaveTarea} className="p-6 space-y-5">
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">¿Qué necesitas hacer?</label>
                <input type="text" required value={formData.titulo} onChange={e=>setFormData({...formData, titulo: e.target.value})} placeholder="Ej. Contratar al fotógrafo" className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors" autoFocus/>
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Categoría</label>
                <select value={formData.categoria} onChange={e=>setFormData({...formData, categoria: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors cursor-pointer appearance-none">
                  {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Fecha Límite (Opcional)</label>
                <input type="date" value={formData.fechaLimite} onChange={e=>setFormData({...formData, fechaLimite: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white [color-scheme:dark] transition-colors font-bold" />
              </div>
              
              <button type="submit" className="w-full p-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-6 shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors active:scale-95">
                Crear Tarea
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: CRONOGRAMA (DARK PREMIUM) ---
// ==========================================
const TimingView = ({ timing, setTiming, addNotification }) => {
  const [exportViewOpen, setExportViewOpen] = useState(false);
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);
  
  const [modalOpen, setModalOpen] = useState(false);
  const [editModal, setEditModal] = useState({ open: false, evento: null });
  const [deleteModal, setDeleteModal] = useState(null);
  const [formData, setFormData] = useState({ hora: '', actividad: '', responsable: '', lugar: '', notas: '' });

  const timingOrdenado = [...timing].sort((a, b) => a.hora.localeCompare(b.hora));

  const handleSave = async (e) => {
      e.preventDefault();
    const nuevoId = Date.now().toString();
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "timing", nuevoId), { id: nuevoId, ...formData });
      setModalOpen(false);
      if(addNotification) addNotification('Actividad Guardada', 'El cronograma se ha actualizado en la nube.', 'success');
  };

  const handleUpdate = async (e) => {
      e.preventDefault();
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "timing", editModal.evento.id.toString()), editModal.evento);
      setEditModal({ open: false, evento: null });
      if(addNotification) addNotification('Cambios Guardados', 'Actividad modificada en la nube.', 'success');
  };

  const executeDelete = async () => {
    await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "timing", deleteModal.id.toString()));
      setDeleteModal(null);
      if(addNotification) addNotification('Eliminada', 'Actividad removida del cronograma.', 'warning');
  };

  const triggerPdfDownload = async () => {
    setIsPreparingPrint(true);
    setTimeout(async () => {
      try {
        const { jsPDF } = await import('jspdf');
        const html2canvas = (await import('html2canvas')).default;
        const pages = document.querySelectorAll('.timing-pdf-page');
        const pdf = new jsPDF('p', 'mm', 'letter');

        for (let i = 0; i < pages.length; i++) {
           const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
           const imgData = canvas.toDataURL('image/jpeg', 0.95);
           if (i > 0) pdf.addPage();
           pdf.addImage(imgData, 'JPEG', 0, 0, 215.9, 279.4);
        }
        pdf.save('Cronograma-Rundown.pdf');
        if(addNotification) addNotification('¡PDF Guardado!', 'Revisa tu carpeta de descargas.', 'success');
      } catch (error) {
        if(addNotification) addNotification('Error', 'Fallo al generar el PDF.', 'error');
      }
      setIsPreparingPrint(false);
      setExportViewOpen(false);
    }, 500);
  };

  if (exportViewOpen) {
    const PAGE_1_LIMIT = 12;
    const PAGE_N_LIMIT = 18;
    const firstPageItems = timingOrdenado.slice(0, PAGE_1_LIMIT);
    const extraItems = timingOrdenado.slice(PAGE_1_LIMIT);
    const extraPages = [];
    for(let i=0; i<extraItems.length; i+=PAGE_N_LIMIT) extraPages.push(extraItems.slice(i, i+PAGE_N_LIMIT));

    const renderTableRows = (rows) => (
      <table className="w-full text-left text-sm border-collapse">
        <thead>
          <tr className="bg-slate-800 text-white">
            <th className="px-4 py-3 font-bold w-24 border border-slate-800">Hora</th>
            <th className="px-4 py-3 font-bold border border-slate-800">Actividad / Momento</th>
            <th className="px-4 py-3 font-bold border border-slate-800">Responsable</th>
            <th className="px-4 py-3 font-bold border border-slate-800">Lugar / Notas Extra</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((evento, idx) => (
            <tr key={`print_${evento.id}`} className={idx % 2 === 0 ? 'bg-slate-50' : 'bg-white'}>
              <td className="px-4 py-4 font-black text-lg text-indigo-600 border border-slate-300 align-top">{evento.hora}</td>
              <td className="px-4 py-4 border border-slate-300 align-top"><p className="font-bold text-slate-800 text-base">{evento.actividad}</p></td>
              <td className="px-4 py-4 border border-slate-300 font-bold text-slate-600 uppercase text-xs align-top">{evento.responsable}</td>
              <td className="px-4 py-4 border border-slate-300 align-top">
                {evento.lugar && <p className="font-bold text-xs text-slate-800 mb-1 flex items-center"><MapPin size={10} className="mr-1"/> {evento.lugar}</p>}
                {evento.notas && <p className="text-xs text-slate-500 italic">{evento.notas}</p>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );

    return (
      <div className="fixed inset-0 z-[120] bg-slate-900/95 flex flex-col overflow-hidden backdrop-blur-md">
        <div className="bg-[#0a0a0a] text-white p-4 flex justify-between items-center border-b border-white/10 shadow-lg print:hidden z-10 shrink-0 gap-4">
          <div className="flex items-center space-x-4">
            <button onClick={() => setExportViewOpen(false)} className="p-2 hover:bg-white/10 rounded-full transition-colors"><X size={24}/></button>
            <div><h3 className="font-bold text-sm">Estudio de Impresión: Staff Rundown</h3><p className="text-[10px] text-slate-400 uppercase tracking-widest">Guion operativo Carta.</p></div>
          </div>
          <button onClick={triggerPdfDownload} disabled={isPreparingPrint} className="px-5 py-2.5 bg-amber-500 hover:bg-amber-400 text-slate-900 rounded-xl text-sm font-black flex items-center shadow-[0_0_15px_rgba(245,158,11,0.3)] transition-all disabled:opacity-50">
            {isPreparingPrint ? <RefreshCw size={16} className="mr-2 animate-spin"/> : <Download size={16} className="mr-2"/>} 
            {isPreparingPrint ? 'Preparando...' : 'Descargar PDF'}
          </button>
        </div>

        <div className="flex-1 overflow-y-auto bg-[#111] custom-scrollbar flex flex-col items-center py-8 gap-8">
          <div className="timing-pdf-page bg-white mx-auto shadow-2xl shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden', position: 'relative' }}>
            <header className="flex justify-between items-start border-b-4 border-slate-900 pb-6 mb-8">
              <div>
                <h1 className="text-4xl font-black text-slate-900 uppercase tracking-tight">GUION OPERATIVO</h1>
                <p className="text-lg text-slate-600 font-bold mt-1">EVENT MASTER</p>
              </div>
              <div className="text-right">
                <p className="text-sm font-bold text-slate-500 uppercase tracking-widest">Documento Confidencial</p>
                <p className="text-xs text-slate-400 mt-1">Solo Staff y Proveedores</p>
              </div>
            </header>
            <main>{renderTableRows(firstPageItems)}</main>
            <div className="absolute bottom-6 right-6 text-[10px] font-bold text-slate-400">Página 1 de {1 + extraPages.length}</div>
          </div>

          {extraPages.map((pageRows, pIdx) => (
            <div key={`extrapage_${pIdx}`} className="timing-pdf-page bg-white mx-auto shadow-2xl shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden', position: 'relative' }}>
              <header className="border-b-2 border-slate-800 pb-3 mb-6">
                <h1 className="text-xl font-black text-slate-900 uppercase tracking-tight">GUION OPERATIVO (Cont.)</h1>
              </header>
              <main>{renderTableRows(pageRows)}</main>
              <div className="absolute bottom-6 right-6 text-[10px] font-bold text-slate-400">Página {pIdx + 2} de {1 + extraPages.length}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col space-y-6 pb-6 relative text-white bg-[#141210] min-h-[100vh] p-4 rounded-3xl transition-colors duration-500 z-10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-[#1C1917] p-5 sm:p-6 rounded-3xl border border-[#D4AF37]/25 shadow-xl">
        <div className="flex items-center gap-3.5">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
            <Clock size={20} />
          </div>
          <div>
            <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block mb-0.5">Sincroniza staff y proveedores.</span>
            <h2 className="text-2xl sm:text-3xl font-editorial text-white tracking-wide leading-none">El Minuto a Minuto</h2>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2.5 w-full md:w-auto justify-start md:justify-end">
          <button onClick={() => setExportViewOpen(true)} className="flex-1 md:flex-none flex items-center justify-center px-4 h-9 bg-transparent border border-white/10 text-slate-300 rounded-lg text-[10px] uppercase tracking-widest font-bold hover:bg-white/5 hover:text-white shadow-sm transition-colors shrink-0">
            <FileDown size={14} className="mr-1.5 text-[#D4AF37]"/> Reporte PDF
          </button>
          <button onClick={() => { setFormData({ hora: '', actividad: '', responsable: '', lugar: '', notas: '' }); setModalOpen(true); }} className="flex-1 md:flex-none flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-[#1C1917] rounded-lg font-black text-[10px] uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-all shrink-0">
            <Plus size={14} className="mr-1.5" /> Momento
          </button>
        </div>
      </div>

      <div className="flex-1 bg-[#1C1917] rounded-3xl border border-[#D4AF37]/25 shadow-xl p-6 overflow-y-auto custom-scrollbar transition-colors">
        {timingOrdenado.length === 0 ? (
          <div className="text-center py-24 text-slate-500 flex flex-col items-center justify-center h-full">
            <Clock size={56} className="mx-auto mb-4 text-[#D4AF37] opacity-50"/>
            <h3 className="text-2xl font-editorial font-black text-white mb-2">Cronograma Vacío</h3>
            <p className="text-sm font-medium">Empieza a planear el orden de tu evento.</p>
          </div>
        ) : (
          <div className="relative border-l-[3px] border-[#D4AF37]/20 ml-4 md:ml-10 space-y-8 py-4 transition-colors">
            {timingOrdenado.map((evento) => (
              <div key={evento.id} className="relative pl-8 md:pl-12 group">
                <div className="absolute w-5 h-5 bg-[#141210] border-4 border-[#D4AF37] rounded-full -left-[11px] top-1.5 shadow-[0_0_10px_rgba(212,175,55,0.3)] group-hover:scale-125 transition-transform z-10"></div>
                <div className="bg-[#141210] border border-white/10 p-5 rounded-2xl hover:border-[#D4AF37]/50 transition-all flex flex-col md:flex-row gap-4 shadow-sm">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-2xl font-black text-[#D4AF37] tracking-tight">{evento.hora}</span>
                      <span className="px-2.5 py-1 bg-white/5 text-slate-300 rounded-md text-[9px] font-black uppercase tracking-widest border border-white/10">{evento.responsable}</span>
                    </div>
                    <h4 className="text-xl font-editorial font-bold text-white mb-2 leading-tight">{evento.actividad}</h4>
                    {evento.lugar && <p className="text-xs font-bold text-slate-400 flex items-center mb-1.5"><MapPin size={12} className="mr-1.5 text-rose-500"/> {evento.lugar}</p>}
                    {evento.notas && <p className="text-xs text-slate-400 flex items-start mt-3 bg-[#1C1917] p-3 rounded-xl border border-white/5"><AlignLeft size={12} className="mr-2 mt-0.5 opacity-50 shrink-0 text-[#D4AF37]"/> <span className="italic leading-relaxed">{evento.notas}</span></p>}
                  </div>
                  <div className="flex md:flex-col justify-end md:justify-start gap-2 pt-4 md:pt-0 border-t md:border-t-0 border-white/10 mt-2 md:mt-0 transition-colors">
                    <button onClick={() => setEditModal({ open: true, evento: { ...evento } })} className="p-2.5 bg-white/5 text-slate-400 hover:text-white hover:bg-white/10 rounded-xl transition-colors"><Edit2 size={16} /></button>
                    <button onClick={() => setDeleteModal(evento)} className="p-2.5 bg-rose-500/10 text-rose-500 hover:text-rose-400 hover:bg-rose-500/20 rounded-xl transition-colors"><Trash2 size={16} /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODALES CON ESTILO DARK/PREMIUM */}
      {modalOpen && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors"><h3 className="font-editorial font-black text-2xl text-[#D4AF37] flex items-center"><Clock size={20} className="mr-2.5"/> Agregar Momento</h3><button onClick={() => setModalOpen(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button></div>
            <form onSubmit={handleSave} className="p-6 space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Hora</label><input type="time" required value={formData.hora} onChange={e=>setFormData({...formData, hora: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white font-bold [color-scheme:dark] transition-colors" /></div>
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Responsable</label><input type="text" value={formData.responsable} onChange={e=>setFormData({...formData, responsable: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" placeholder="Ej. DJ, Hostess" /></div>
              </div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Actividad / Momento</label><input type="text" required value={formData.actividad} onChange={e=>setFormData({...formData, actividad: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" placeholder="Ej. Entrada de Novios" /></div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Lugar (Opcional)</label><input type="text" value={formData.lugar} onChange={e=>setFormData({...formData, lugar: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white text-sm transition-colors" placeholder="Ej. Pista de Baile" /></div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Notas Extra (Opcional)</label><textarea value={formData.notas} onChange={e=>setFormData({...formData, notas: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white text-sm resize-none h-20 transition-colors" placeholder="Canción específica, detalles..." /></div>
              <button type="submit" className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-6 shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors active:scale-95">Guardar Momento</button>
            </form>
          </div>
        </div>
      )}

      {editModal.open && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors"><h3 className="font-editorial font-black text-2xl text-[#D4AF37]">Editar Momento</h3><button onClick={() => setEditModal({open: false, evento: null})} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button></div>
            <form onSubmit={handleUpdate} className="p-6 space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Hora</label><input type="time" required value={editModal.evento.hora} onChange={e=>setEditModal({...editModal, evento: {...editModal.evento, hora: e.target.value}})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white font-bold [color-scheme:dark] transition-colors" /></div>
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Responsable</label><input type="text" value={editModal.evento.responsable} onChange={e=>setEditModal({...editModal, evento: {...editModal.evento, responsable: e.target.value}})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" /></div>
              </div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Actividad / Momento</label><input type="text" required value={editModal.evento.actividad} onChange={e=>setEditModal({...editModal, evento: {...editModal.evento, actividad: e.target.value}})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white font-bold transition-colors" /></div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Lugar (Opcional)</label><input type="text" value={editModal.evento.lugar || ''} onChange={e=>setEditModal({...editModal, evento: {...editModal.evento, lugar: e.target.value}})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white text-sm transition-colors" /></div>
              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Notas Extra</label><textarea value={editModal.evento.notas || ''} onChange={e=>setEditModal({...editModal, evento: {...editModal.evento, notas: e.target.value}})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] text-white text-sm resize-none h-20 transition-colors" /></div>
              <button type="submit" className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-6 shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors active:scale-95">Guardar Cambios</button>
            </form>
          </div>
        </div>
      )}

      {deleteModal && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm p-8 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-rose-500/20 animate-in zoom-in-95 duration-200 transition-colors text-white">
             <div className="w-20 h-20 bg-rose-500/10 text-rose-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner border border-rose-500/20"><Trash2 size={36} /></div>
             <h3 className="font-editorial font-black text-2xl text-white mb-2 transition-colors">¿Eliminar actividad?</h3>
             <p className="text-slate-400 text-sm mb-8 leading-relaxed">Borrarás "<b className="text-white">{deleteModal.actividad}</b>" a las {deleteModal.hora}. Esta acción es definitiva.</p>
             <div className="flex space-x-3">
               <button onClick={()=>setDeleteModal(null)} className="flex-1 py-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold hover:bg-white/10 hover:text-white transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
               <button onClick={executeDelete} className="flex-1 py-4 bg-rose-500 text-white rounded-xl font-black hover:bg-rose-600 transition-colors shadow-[0_5px_15px_rgba(244,63,94,0.3)] uppercase tracking-widest text-[10px]">Sí, Eliminar</button>
             </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: PRESUPUESTO (DARK PREMIUM) ---
// ==========================================
const PresupuestoView = ({ eventId, authData, gastos, setGastos, proveedores, setProveedores, presupuestoTotal, setPresupuestoTotal, addNotification }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({ concepto: '', categoria: 'Lugar', estimado: '', fechaLimite: '' });
  const [paymentProcess, setPaymentProcess] = useState(null);
  const [deleteProcess, setDeleteProcess] = useState(null);
  const [historyModal, setHistoryModal] = useState(null);
  const [editGastoModal, setEditGastoModal] = useState(null);
  const [viewMode, setViewMode] = useState('table'); 
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);
  const [isEditingBudget, setIsEditingBudget] = useState(false);
  const [tempBudget, setTempBudget] = useState(presupuestoTotal);

  // 🟢 LA LLAVE MAESTRA: Recibimos el ID directamente desde tu panel principal
  const EVENT_ID = eventId || authData?.eventId || authData?.id || '';

  useEffect(() => {
    if (!isEditingBudget) setTempBudget(presupuestoTotal);
  }, [presupuestoTotal, isEditingBudget]);

  const categorias = ['Lugar', 'Música', 'Decoración', 'Recuerdos', 'Comida/Bebida', 'Ropa/Maquillaje', 'Papelería', 'Otros'];
  const coloresCategoria = { 'Lugar':'bg-indigo-500', 'Música':'bg-pink-500', 'Decoración':'bg-emerald-500', 'Comida/Bebida':'bg-amber-500', 'Otros':'bg-slate-500' };

  const safeGastos = gastos || [];
  const totalEstimado = safeGastos.reduce((sum, g) => sum + g.estimado, 0);
  const totalPagado = safeGastos.reduce((sum, g) => sum + g.pagado, 0);
  const totalDeuda = totalEstimado - totalPagado;
  const budgetPercentage = presupuestoTotal > 0 ? Math.round((totalEstimado / presupuestoTotal) * 100) : 0;

  const gastosPorCategoria = safeGastos.reduce((acc, g) => { acc[g.categoria] = (acc[g.categoria] || 0) + g.estimado; return acc; }, {});
  
  // ESTILOS DINÁMICOS SEGÚN EL PLAN
  const currentEvent = authData?.availableEvents?.find(e => e.eventId === authData?.eventId);
  const plan = currentEvent?.plan || 'oro';
  const eventName = currentEvent?.nombres || 'Proyecto Baulia';

  let gradientStyle = 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)';
  let accentColor = '#64748b'; 
  if (plan === 'diamante') {
      gradientStyle = 'linear-gradient(180deg, #eef2ff 0%, #ffffff 100%)';
      accentColor = '#4f46e5';
  } else if (plan === 'oro') {
      gradientStyle = 'linear-gradient(180deg, #fffbeb 0%, #ffffff 100%)';
      accentColor = '#d97706';
  } else if (plan === 'plata') {
      gradientStyle = 'linear-gradient(180deg, #f1f5f9 0%, #ffffff 100%)';
      accentColor = '#475569';
  }

  // 🟢 FUNCIONES REPARADAS CON MANEJO DE ERRORES Y EVENT_ID
  const handleSaveGasto = async (e) => {
    if (e) e.preventDefault();
    if (!EVENT_ID) {
      if (addNotification) addNotification('Error', 'No se encontró el ID del evento.', 'error');
      return;
    }
    try {
      const nuevoId = Date.now().toString();
      const nuevoGasto = { id: nuevoId, ...formData, estimado: Number(formData.estimado), pagado: 0, proveedorId: null, historial: [] };
      await setDoc(doc(db, "eventos", EVENT_ID, "gastos", nuevoId), nuevoGasto);
      setIsFormOpen(false);
      setFormData({ concepto: '', categoria: 'Lugar', estimado: '', fechaLimite: '' });
      if (addNotification) addNotification('Éxito', 'Gasto agregado correctamente.', 'success');
    } catch (error) {
      console.error(error);
      if (addNotification) addNotification('Error', 'Hubo un fallo al conectar con la base de datos.', 'error');
    }
  };

  const handleUpdateGasto = async (e) => {
    if (e) e.preventDefault();
    try {
      const gastoActualizado = { ...editGastoModal, estimado: Number(editGastoModal.estimado) };
      await setDoc(doc(db, "eventos", EVENT_ID, "gastos", editGastoModal.id.toString()), gastoActualizado);
      setEditGastoModal(null);
      if (addNotification) addNotification('Actualizado', 'Los cambios se han guardado.', 'success');
    } catch (error) {
      console.error(error);
      if (addNotification) addNotification('Error', 'No se pudieron guardar los cambios.', 'error');
    }
  };

  const handleAddPayment = async (e) => {
    if (e) e.preventDefault();
    try {
      const { item, monto, fecha, metodo, cuenta, comprobante } = paymentProcess;
      const montoNum = Number(monto);
      const nombreArchivo = comprobante ? comprobante.name : null;
      
      const gastoActualizado = { 
        ...item, 
        pagado: item.pagado + montoNum, 
        historial: [...(item.historial || []), { id: Date.now(), fecha, monto: montoNum, metodo, cuenta, comprobante: nombreArchivo }] 
      };
      
      await setDoc(doc(db, "eventos", EVENT_ID, "gastos", item.id.toString()), gastoActualizado);
      setPaymentProcess(null);
      if (addNotification) addNotification('Pago Registrado', `Se abonaron $${montoNum} a ${item.concepto}.`, 'success');
    } catch (error) {
      console.error(error);
      if (addNotification) addNotification('Error', 'Fallo al registrar el pago.', 'error');
    }
  };

  const initiateDelete = (gasto) => {
    if (gasto.pagado === 0) executeDelete(gasto, 0, false);
    else setDeleteProcess({ step: 1, item: gasto, refundAmount: '', keepRemaining: false });
  };

  const executeDelete = async (gasto, refundAmount, keepRemaining) => {
    try {
      const refund = Number(refundAmount); 
      const lostMoney = gasto.pagado - refund;
      
      if (lostMoney > 0 && keepRemaining) {
        const gastoActualizado = { ...gasto, concepto: `${gasto.concepto} (Cancelado)`, estimado: lostMoney, pagado: lostMoney, proveedorId: null };
        await setDoc(doc(db, "eventos", EVENT_ID, "gastos", gasto.id.toString()), gastoActualizado);
      } else { 
        await deleteDoc(doc(db, "eventos", EVENT_ID, "gastos", gasto.id.toString())); 
      }
      
      if (gasto.proveedorId && proveedores) { 
        const prov = proveedores.find(p => p.id === gasto.proveedorId);
        if (prov) {
           await setDoc(doc(db, "eventos", EVENT_ID, "proveedores", prov.id.toString()), { ...prov, status: 'Descartado', contratado: false, gastoId: null });
        }
      }
      
      setDeleteProcess(null);
      if (addNotification) addNotification('Cancelado', 'Servicio cancelado con éxito.', 'warning');
    } catch (error) {
      console.error(error);
      if (addNotification) addNotification('Error', 'No se pudo eliminar el gasto.', 'error');
    }
  };

  const exportData = () => {
    if (addNotification) addNotification('Generando Excel', 'Preparando documento financiero corporativo...', 'info');

    let html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
    <head><meta charset="utf-8"><style>
      table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; }
      th { background-color: #0f172a; color: #ffffff; padding: 12px; border: 1px solid #cbd5e1; text-align: center; font-weight: bold; }
      td { padding: 10px; border: 1px solid #cbd5e1; }
      .currency { text-align: right; }
      .center { text-align: center; }
      .header { background-color: #f8fafc; font-size: 22px; font-weight: bold; padding: 20px; text-align: left; }
      .summary-box { background-color: #f1f5f9; font-weight: bold; font-size: 14px; text-align: center; }
      .deuda-activa { color: #d97706; font-weight: bold; }
      .deuda-saldada { color: #16a34a; font-weight: bold; }
    </style></head><body>`;

    html += `<table>
      <tr><td colspan="6" class="header">Bóveda Financiera Baulia - ${eventName}</td></tr>
      <tr><td colspan="6" style="text-align: right; color: #64748b;">Fecha de emisión: ${new Date().toLocaleDateString('es-MX')}</td></tr>
      <tr><td colspan="6"></td></tr>
      <tr>
        <td colspan="2" class="summary-box">Presupuesto Global:<br><span style="font-size: 18px; color: #0f172a;">${formatMoney(presupuestoTotal)}</span></td>
        <td colspan="2" class="summary-box">Capital Pagado:<br><span style="font-size: 18px; color: #16a34a;">${formatMoney(totalPagado)}</span></td>
        <td colspan="2" class="summary-box">Deuda Restante:<br><span style="font-size: 18px; color: #d97706;">${formatMoney(totalDeuda)}</span></td>
      </tr>
      <tr><td colspan="6"></td></tr>
      <tr>
        <th>Concepto / Proveedor</th><th>Categoría</th><th>Límite de Pago</th><th>Costo Estimado</th><th>Abonado</th><th>Por Pagar</th>
      </tr>`;

    safeGastos.forEach(g => {
      const deuda = g.estimado - g.pagado;
      html += `<tr>
        <td style="font-weight: bold;">${g.concepto}</td>
        <td class="center">${g.categoria}</td>
        <td class="center">${g.fechaLimite || 'Sin Fecha'}</td>
        <td class="currency">${formatMoney(g.estimado)}</td>
        <td class="currency" style="color: #16a34a;">${formatMoney(g.pagado)}</td>
        <td class="currency ${deuda > 0 ? 'deuda-activa' : 'deuda-saldada'}">${deuda > 0 ? formatMoney(deuda) : 'Saldado'}</td>
      </tr>`;
    });

    html += `</table></body></html>`;

    const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Presupuesto_Baulia_${eventName.replace(/\s+/g, '_')}.xls`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const guardarPresupuestoNube = async () => {
    const nuevoValor = Number(tempBudget);
    if (isNaN(nuevoValor) || nuevoValor <= 0) return;
    setPresupuestoTotal(nuevoValor);
    setIsEditingBudget(false);
    localStorage.setItem('eventmaster_presupuesto', nuevoValor);
    try {
      await setDoc(doc(db, "eventos", EVENT_ID), { presupuestoTotal: nuevoValor }, { merge: true });
      if(addNotification) addNotification('Presupuesto Guardado', 'Se ha guardado tu presupuesto total en la nube.', 'success');
    } catch (error) {
      console.error(error);
    }
  };

  const formatMoney = (amount) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount || 0);
  const isOverdue = (dateStr, deuda) => { if(!dateStr || deuda <= 0) return false; return new Date(dateStr) < new Date(); };
  const gastosConFecha = safeGastos.filter(g => g.fechaLimite && (g.estimado - g.pagado) > 0).sort((a,b) => new Date(a.fechaLimite) - new Date(b.fechaLimite));

  const triggerPdfDownload = async () => {
    setIsPreparingPrint(true);
    if(addNotification) addNotification('Preparando Documento', 'Generando formato financiero VIP...', 'info');

    setTimeout(async () => {
      try {
        const { jsPDF } = await import('jspdf');
        const html2canvas = (await import('html2canvas')).default;
        
        const pages = document.querySelectorAll('.hidden-finance-pdf-page');
        const pdf = new jsPDF('p', 'mm', 'letter');

        for (let i = 0; i < pages.length; i++) {
           const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, logging: false });
           const imgData = canvas.toDataURL('image/jpeg', 1.0);
           if (i > 0) pdf.addPage();
           pdf.addImage(imgData, 'JPEG', 0, 0, 215.9, 279.4);
        }
        
        pdf.save(`Reporte-Financiero-${eventName.replace(/\s+/g, '-')}.pdf`);
        if(addNotification) addNotification('¡Descarga Lista!', 'El reporte se guardó en tu dispositivo.', 'success');
      } catch (error) {
        console.error(error);
        if(addNotification) addNotification('Error', 'Fallo al generar el PDF.', 'error');
      }
      setIsPreparingPrint(false);
    }, 800);
  };

  const PAGE_1_LIMIT = 8;
  const PAGE_N_LIMIT = 15;
  const firstPageItems = safeGastos.slice(0, PAGE_1_LIMIT);
  const extraItems = safeGastos.slice(PAGE_1_LIMIT);
  const extraPages = [];
  for(let i=0; i<extraItems.length; i+=PAGE_N_LIMIT) extraPages.push(extraItems.slice(i, i+PAGE_N_LIMIT));

  const renderTableRows = (rows) => (
    <table className="w-full text-left text-sm border-collapse">
      <thead>
        <tr className="border-b-2" style={{ borderColor: accentColor }}>
          <th className="px-2 py-3 font-black text-slate-800 uppercase tracking-widest text-[10px]">Concepto / Servicio</th>
          <th className="px-2 py-3 font-black text-slate-800 uppercase tracking-widest text-[10px] text-right">Costo Total</th>
          <th className="px-2 py-3 font-black text-slate-800 uppercase tracking-widest text-[10px] text-right">Abonado</th>
          <th className="px-2 py-3 font-black text-slate-800 uppercase tracking-widest text-[10px] text-right">Deuda</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((gasto) => {
          const deuda = gasto.estimado - gasto.pagado;
          return (
            <tr key={`print_${gasto.id}`} className="border-b border-slate-200/60">
              <td className="px-2 py-4">
                 <p className="font-bold text-slate-900 text-sm leading-none">{gasto.concepto}</p>
                 <p className="text-[10px] text-slate-500 uppercase tracking-widest mt-1">{gasto.categoria} {gasto.fechaLimite ? `• Límite: ${gasto.fechaLimite}` : ''}</p>
              </td>
              <td className="px-2 py-4 text-right font-medium text-slate-600">{formatMoney(gasto.estimado)}</td>
              <td className="px-2 py-4 text-right font-bold text-emerald-600">{formatMoney(gasto.pagado)}</td>
              <td className="px-2 py-4 text-right font-bold" style={{ color: deuda > 0 ? accentColor : '#10b981' }}>{deuda > 0 ? formatMoney(deuda) : 'Saldado'}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <div className="h-full flex flex-col space-y-6 pb-6 relative text-slate-900 dark:text-slate-200 transition-colors duration-500 z-10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-[#1C1917] p-5 sm:p-6 rounded-3xl border border-[#D4AF37]/25 shadow-xl">
        <div className="flex items-center gap-3.5">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
            <Wallet size={20} />
          </div>
          <div>
            <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block mb-0.5">Gestión de capital y abonos.</span>
            <h2 className="text-2xl sm:text-3xl font-editorial text-white tracking-wide leading-none">Control Financiero</h2>
          </div>
        </div>
        
        <div className="flex flex-wrap items-center gap-2.5 w-full md:w-auto justify-start md:justify-end">
          <div className="bg-[#141210] rounded-xl border border-white/10 p-1 hidden sm:flex shadow-sm transition-colors">
            <button onClick={()=>setViewMode('table')} className={`px-4 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-widest flex items-center transition-colors ${viewMode === 'table' ? 'bg-[#1C1917] text-[#D4AF37] shadow-sm border border-[#D4AF37]/30' : 'text-slate-500 hover:text-white'}`}><LayoutGrid size={14} className="mr-2"/> Tabla</button>
            <button onClick={()=>setViewMode('calendar')} className={`px-4 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-widest flex items-center transition-colors ${viewMode === 'calendar' ? 'bg-[#1C1917] text-[#D4AF37] shadow-sm border border-[#D4AF37]/30' : 'text-slate-500 hover:text-white'}`}><CalendarDays size={14} className="mr-2"/> Fechas</button>
          </div>
          <button onClick={triggerPdfDownload} disabled={isPreparingPrint} className="flex-1 md:flex-none flex items-center justify-center px-4 h-9 bg-transparent border border-white/10 text-slate-300 rounded-lg text-[10px] uppercase tracking-widest font-bold hover:bg-white/5 hover:text-white transition-colors disabled:opacity-50 shrink-0">
            {isPreparingPrint ? <RefreshCw size={14} className="mr-1.5 animate-spin"/> : <FileDown size={14} className="mr-1.5 text-[#D4AF37]"/>} 
            PDF
          </button>
          <button onClick={exportData} className="hidden sm:flex items-center justify-center px-4 h-9 bg-transparent border border-white/10 text-slate-300 rounded-lg text-[10px] uppercase tracking-widest font-bold hover:bg-white/5 hover:text-white transition-colors shrink-0">
            <Download size={14} className="mr-1.5 text-[#D4AF37]"/> Excel
          </button>
          <button onClick={() => { setFormData({ concepto: '', categoria: 'Lugar', estimado: '', fechaLimite: '' }); setIsFormOpen(true); }} className="flex-1 md:flex-none flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-[#1C1917] rounded-lg font-black text-[10px] uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors shrink-0">
            <Plus size={14} className="mr-1.5" /> Gasto
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 mt-4">
        <div className="bg-[#141210] p-4 sm:p-6 rounded-2xl border border-[#D4AF37]/30 shadow-[0_4px_15px_rgba(0,0,0,0.5)] flex flex-col relative overflow-hidden group transition-all hover:border-[#D4AF37]/60">
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
          <div className="text-slate-400 font-bold text-[9px] sm:text-[10px] uppercase tracking-[0.2em] mb-3 flex justify-between items-center z-10 relative">
            <span className="flex items-center"><Wallet size={12} className="mr-1.5 text-[#D4AF37]"/> Presupuesto</span>
            {!isEditingBudget && (
              <button onClick={() => setIsEditingBudget(true)} className="text-slate-400 hover:text-[#D4AF37] transition-colors p-1.5 bg-white/5 rounded-lg border border-white/10" title="Editar Presupuesto"><Edit2 size={10}/></button>
            )}
          </div>
          {isEditingBudget ? (
             <div className="flex mt-auto bg-[#1C1917] rounded-xl overflow-hidden border border-[#D4AF37]/50 focus-within:border-[#D4AF37] transition-colors z-10 relative">
               <span className="pl-3 py-2 text-[#D4AF37] font-bold text-xs">$</span>
               <input type="number" autoFocus value={tempBudget} onChange={(e)=>setTempBudget(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') guardarPresupuestoNube(); }} className="w-full py-2 px-1 bg-transparent font-bold outline-none text-white text-xs transition-colors" />
               <button onClick={guardarPresupuestoNube} className="bg-[#D4AF37] text-[#1C1917] px-4 font-black text-[9px] uppercase tracking-widest">OK</button>
             </div>
          ) : (
             <h3 className="text-2xl sm:text-3xl lg:text-4xl font-editorial text-white mt-auto z-10 relative tracking-wide truncate">{formatMoney(presupuestoTotal)}</h3>
          )}
        </div>

        <div className="bg-[#141210] p-4 sm:p-6 rounded-2xl border border-white/10 shadow-[0_4px_15px_rgba(0,0,0,0.5)] flex flex-col relative overflow-hidden group transition-all hover:border-white/30">
          <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
          <div className="text-slate-400 font-bold text-[9px] sm:text-[10px] uppercase tracking-[0.2em] mb-3 flex items-center z-10 relative"><PieChart size={12} className="mr-1.5 text-white"/> Estimado</div>
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-editorial text-white mt-auto z-10 relative tracking-wide truncate">{formatMoney(totalEstimado)}</h3>
        </div>

        <div className="bg-[#141210] p-4 sm:p-6 rounded-2xl border border-white/10 shadow-[0_4px_15px_rgba(0,0,0,0.5)] flex flex-col relative overflow-hidden group transition-all hover:border-emerald-500/40">
          <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
          <div className="text-emerald-400 font-bold text-[9px] sm:text-[10px] uppercase tracking-[0.2em] mb-3 flex items-center z-10 relative"><DollarSign size={12} className="mr-1.5"/> Pagado</div>
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-editorial text-emerald-400 mt-auto z-10 relative tracking-wide truncate">{formatMoney(totalPagado)}</h3>
        </div>

        <div className="bg-[#141210] p-4 sm:p-6 rounded-2xl border border-white/10 shadow-[0_4px_15px_rgba(0,0,0,0.5)] flex flex-col relative overflow-hidden group transition-all hover:border-amber-500/40">
          <div className="absolute inset-0 bg-gradient-to-br from-amber-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
          <div className="text-amber-500 font-bold text-[9px] sm:text-[10px] uppercase tracking-[0.2em] mb-3 flex items-center z-10 relative"><TrendingDown size={12} className="mr-1.5"/> Deuda Restante</div>
          <h3 className="text-2xl sm:text-3xl lg:text-4xl font-editorial text-amber-500 mt-auto z-10 relative tracking-wide truncate">{formatMoney(totalDeuda)}</h3>
        </div>
      </div>

      <div className="bg-[#1C1917] p-5 sm:p-8 rounded-2xl border border-[#D4AF37]/20 shadow-xl print:hidden transition-colors mt-6">
        <h3 className="text-[10px] font-black text-[#D4AF37] uppercase tracking-widest mb-4 flex items-center"><PieChart size={14} className="mr-2"/> Distribución del Capital (Estimado)</h3>
        <div className="w-full h-3 rounded-full overflow-hidden flex bg-white/5 border border-white/10 transition-colors">
          {Object.entries(gastosPorCategoria).map(([cat, amount], idx) => {
            const pct = (amount / totalEstimado) * 100;
            return <div key={idx} className={`${coloresCategoria[cat] || 'bg-slate-400'} h-full transition-all`} style={{width: `${pct}%`}} title={`${cat}: ${formatMoney(amount)}`}></div>
          })}
        </div>
        <div className="flex flex-wrap gap-5 mt-4">
          {Object.entries(gastosPorCategoria).map(([cat, amount], idx) => (
            <div key={idx} className="flex items-center text-[10px] font-bold text-slate-300 uppercase tracking-wider"><span className={`w-2.5 h-2.5 rounded-full mr-2 shadow-sm ${coloresCategoria[cat] || 'bg-slate-400'}`}></span>{cat} <span className="opacity-50 ml-1">({(amount/totalEstimado*100).toFixed(0)}%)</span></div>
          ))}
        </div>
      </div>

      {viewMode === 'table' ? (
        <div className="flex-1 bg-[#1C1917] rounded-3xl border border-white/10 shadow-xl overflow-hidden flex flex-col print:hidden transition-colors">
          
          <div className="hidden md:block overflow-y-auto custom-scrollbar">
            <table className="w-full text-left text-sm whitespace-nowrap">
              <thead className="bg-[#141210] border-b border-white/10 text-[#D4AF37] uppercase tracking-widest text-[10px] transition-colors">
                <tr>
                  <th className="px-6 py-5 font-black">Servicio Contratado</th>
                  <th className="px-6 py-5 font-black">Límite</th>
                  <th className="px-6 py-5 font-black text-right">Costo Total</th>
                  <th className="px-6 py-5 font-black text-right">Abonado</th>
                  <th className="px-6 py-5 font-black text-right">Falta Pagar</th>
                  <th className="px-6 py-5 font-black text-center">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {safeGastos.map((gasto) => {
                  const deuda = gasto.estimado - gasto.pagado;
                  const overdue = isOverdue(gasto.fechaLimite, deuda);
                  return (
                    <tr key={gasto.id} className="hover:bg-white/5 transition-colors">
                      <td className="px-6 py-5">
                        <p className="font-bold text-white text-base transition-colors">{gasto.concepto}</p>
                        {gasto.proveedorId && <p className="text-[9px] text-[#D4AF37] font-bold uppercase tracking-widest flex items-center mt-1.5 transition-colors"><Building size={10} className="mr-1"/> Proveedor Vinculado</p>}
                      </td>
                      <td className="px-6 py-5">
                        {gasto.fechaLimite ? (
                           <span className={`px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-widest flex items-center w-max border transition-colors ${overdue ? 'bg-rose-500/10 text-rose-400 border-rose-500/20' : (deuda===0 ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-white/5 text-slate-400 border-white/10')}`}>
                             {overdue ? <AlertCircle size={12} className="mr-1.5"/> : <Calendar size={12} className="mr-1.5"/>}
                             {gasto.fechaLimite}
                           </span>
                        ) : <span className="text-[10px] font-bold uppercase text-slate-500 tracking-widest transition-colors">Sin Plazo</span>}
                      </td>
                      <td className="px-6 py-5 text-right font-medium text-slate-300 transition-colors">{formatMoney(gasto.estimado)}</td>
                      <td className="px-6 py-5 text-right">
                        <span className="font-bold text-emerald-400 block text-base transition-colors">{formatMoney(gasto.pagado)}</span>
                        {gasto.historial?.length > 0 && <button onClick={()=>setHistoryModal(gasto)} className="text-[9px] text-[#D4AF37] hover:underline font-bold uppercase tracking-widest flex items-center justify-end w-full mt-1 transition-colors"><History size={10} className="mr-1"/> Pagos ({gasto.historial.length})</button>}
                      </td>
                      <td className="px-6 py-5 text-right font-black text-amber-500 text-base transition-colors">{deuda > 0 ? formatMoney(deuda) : <span className="text-emerald-400 text-[10px] uppercase tracking-widest border border-emerald-500/20 bg-emerald-500/10 px-2 py-1 rounded-md transition-colors">Liquidado</span>}</td>
                      <td className="px-6 py-5 text-center">
                        <div className="flex justify-center items-center space-x-2">
                          {deuda > 0 && <button onClick={() => setPaymentProcess({ item: gasto, monto: '', fecha: new Date().toISOString().split('T')[0], metodo: 'Transferencia', cuenta: '', comprobante: null })} className="px-4 py-1.5 bg-emerald-500/10 text-emerald-400 font-bold uppercase tracking-widest text-[10px] rounded-lg hover:bg-emerald-500/20 border border-emerald-500/20 transition-colors">Abonar</button>}
                          <button onClick={() => setEditGastoModal(gasto)} className="p-2 text-slate-400 hover:text-white bg-white/5 border border-white/10 rounded-lg transition-colors"><Edit2 size={14} /></button>
                          <button onClick={() => initiateDelete(gasto)} className="p-2 text-slate-400 hover:text-rose-400 bg-white/5 border border-white/10 rounded-lg transition-colors"><Trash2 size={14} /></button>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <div className="md:hidden flex-1 overflow-y-auto p-2 sm:p-4 space-y-3 custom-scrollbar bg-transparent mt-4 pb-24">
            {safeGastos.map((gasto) => {
              const deuda = gasto.estimado - gasto.pagado;
              const overdue = isOverdue(gasto.fechaLimite, deuda);
              return (
                <div key={gasto.id} className={`bg-[#141210] p-4 rounded-2xl border shadow-sm transition-colors ${overdue ? 'border-rose-500/50' : 'border-white/10'}`}>
                   
                   <div className="flex justify-between items-start mb-3">
                      <div className="pr-2">
                         <p className="font-bold text-white text-base leading-tight">{gasto.concepto}</p>
                         <p className="text-[10px] text-slate-500 uppercase tracking-widest mt-1">{gasto.categoria}</p>
                      </div>
                      <span className={`px-2 py-1 rounded text-[9px] font-bold uppercase tracking-widest border shrink-0 ${overdue ? 'bg-rose-500/10 text-rose-500 border-rose-500/20' : (deuda===0 ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-white/5 text-slate-400 border-white/10')}`}>
                        {gasto.fechaLimite || 'Sin plazo'}
                      </span>
                   </div>

                   {gasto.proveedorId && <p className="text-[9px] text-[#D4AF37] font-bold uppercase tracking-widest flex items-center mb-4 bg-[#D4AF37]/10 w-max px-2 py-1 rounded"><Building size={10} className="mr-1"/> Prov. Vinculado</p>}

                   <div className="flex justify-between items-end mb-4 bg-[#1C1917] p-3 rounded-xl border border-white/5">
                      <div>
                        <p className="text-[9px] text-slate-500 uppercase tracking-widest mb-0.5">Costo Total</p>
                        <p className="font-medium text-slate-300 text-sm">{formatMoney(gasto.estimado)}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-[9px] text-slate-500 uppercase tracking-widest mb-0.5">Resta por pagar</p>
                        <p className={`font-black text-lg ${deuda > 0 ? 'text-amber-500' : 'text-emerald-400'}`}>{deuda > 0 ? formatMoney(deuda) : 'Liquidado'}</p>
                      </div>
                   </div>

                   <div className="pt-3 border-t border-white/10 flex justify-between gap-2">
                      <div className="flex gap-2">
                        <button onClick={() => setEditGastoModal(gasto)} className="p-2.5 bg-white/5 text-slate-400 hover:text-white rounded-xl transition-colors"><Edit2 size={16}/></button>
                        <button onClick={() => initiateDelete(gasto)} className="p-2.5 bg-white/5 text-slate-400 hover:text-rose-400 rounded-xl transition-colors"><Trash2 size={16}/></button>
                      </div>
                      <div className="flex gap-2 flex-1 justify-end">
                        {gasto.historial?.length > 0 && <button onClick={()=>setHistoryModal(gasto)} className="px-3 py-2 bg-white/5 text-[#D4AF37] rounded-xl text-[10px] font-bold uppercase tracking-widest transition-colors flex items-center"><History size={14} className="mr-1 sm:mr-0"/></button>}
                        {deuda > 0 && <button onClick={() => setPaymentProcess({ item: gasto, monto: '', fecha: new Date().toISOString().split('T')[0], metodo: 'Transferencia', cuenta: '', comprobante: null })} className="px-5 py-2 bg-emerald-500/20 text-emerald-400 rounded-xl text-[10px] font-black uppercase tracking-widest border border-emerald-500/30 hover:bg-emerald-500/30 transition-colors flex items-center justify-center">Abonar</button>}
                      </div>
                   </div>
                </div>
              )
            })}
            {safeGastos.length === 0 && <div className="text-center py-10 text-slate-500 text-sm border border-dashed border-white/10 rounded-2xl">No hay gastos registrados.</div>}
          </div>

        </div>
      ) : (
        <div className="flex-1 bg-[#1C1917] rounded-3xl border border-white/10 shadow-xl overflow-hidden p-8 print:hidden transition-colors">
          <h3 className="font-editorial font-bold text-white text-2xl mb-8 flex items-center transition-colors"><CalendarDays size={24} className="mr-3 text-amber-500"/> Próximos Pagos Pendientes</h3>
          {gastosConFecha.length === 0 ? (
            <div className="text-center py-16 text-slate-500"><Calendar size={48} className="mx-auto mb-4 opacity-20"/> No hay pagos pendientes con fecha límite asignada.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {gastosConFecha.map(g => {
                const deuda = g.estimado - g.pagado;
                const overdue = isOverdue(g.fechaLimite, deuda);
                return (
                  <div key={g.id} className={`p-6 rounded-2xl border-l-4 shadow-md flex flex-col bg-[#141210] border-y border-r border-white/5 transition-colors ${overdue ? 'border-l-rose-500' : 'border-l-amber-500'}`}>
                    <div className="flex justify-between items-start mb-4">
                      <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-widest border transition-colors ${overdue ? 'bg-rose-500/10 text-rose-400 border-rose-500/20' : 'bg-amber-500/10 text-amber-500 border-amber-500/20'}`}>{g.fechaLimite}</span>
                      {overdue && <AlertCircle size={16} className="text-rose-500 animate-pulse"/>}
                    </div>
                    <h4 className="font-bold text-white text-lg truncate mb-1 transition-colors">{g.concepto}</h4>
                    <p className="text-[10px] font-bold text-slate-500 uppercase tracking-widest mb-4 transition-colors">{g.categoria}</p>
                    <div className="mt-auto pt-4 border-t border-white/5 flex justify-between items-center transition-colors">
                      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest transition-colors">Deuda:</span>
                      <span className={`font-black text-xl transition-colors ${overdue ? 'text-rose-500' : 'text-amber-500'}`}>{formatMoney(deuda)}</span>
                    </div>
                    <button onClick={() => setPaymentProcess({ item: g, monto: '', fecha: new Date().toISOString().split('T')[0], metodo: 'Transferencia', cuenta: '', comprobante: null })} className="w-full mt-5 py-3 bg-[#1C1917] border border-white/10 rounded-xl text-xs font-bold text-[#D4AF37] uppercase tracking-widest hover:bg-white/5 transition-all">Registrar Abono</button>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      )}

      {/* ÁREA INVISIBLE PARA EL RENDER DEL REPORTE EJECUTIVO (ESTILO SUTIL) */}
      <div style={{ position: 'absolute', top: '-10000px', left: '-10000px', zIndex: -9999 }}>
        <div className="hidden-finance-pdf-page bg-white relative shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '20mm', boxSizing: 'border-box', overflow: 'hidden', background: gradientStyle }}>
           
           <div className="absolute top-0 left-0 w-full h-3" style={{ backgroundColor: accentColor }}></div>

           <div className="flex justify-between items-center mb-12 mt-4">
              <div>
                <h1 className="text-5xl font-editorial font-bold text-slate-900 leading-none">Bóveda Financiera</h1>
                <p className="text-base font-black tracking-[0.2em] uppercase mt-3" style={{ color: accentColor }}>{eventName}</p>
              </div>
              <div className="text-right flex flex-col items-end">
                <BauliaLogo className="h-10" forceWhite={false} />
                <p className="text-[8px] text-slate-400 mt-2 uppercase tracking-[0.3em] font-bold">Tecnología Inteligente</p>
              </div>
           </div>

           <div className="grid grid-cols-3 gap-6 mb-10">
             <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1">Presupuesto Global</p>
                <p className="text-3xl font-editorial text-slate-900">{formatMoney(presupuestoTotal)}</p>
             </div>
             <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1">Capital Pagado</p>
                <p className="text-3xl font-editorial text-emerald-600">{formatMoney(totalPagado)}</p>
             </div>
             <div className="p-6 border border-slate-200/60 rounded-2xl bg-white/60">
                <p className="text-[9px] uppercase tracking-widest text-slate-500 font-bold mb-1" style={{ color: accentColor }}>Deuda Restante</p>
                <p className="text-3xl font-editorial font-bold" style={{ color: accentColor }}>{formatMoney(totalDeuda)}</p>
             </div>
           </div>

           <main>{renderTableRows(firstPageItems)}</main>
           
           <div className="absolute bottom-[15mm] left-[20mm] right-[20mm] flex justify-between items-center text-[7px] uppercase tracking-widest text-slate-400 border-t border-slate-200 pt-3">
              <span>Fecha de Emisión: {new Date().toLocaleDateString('es-MX')}</span>
              <span>Página 1 de {1 + extraPages.length}</span>
           </div>
        </div>

        {/* PÁGINAS EXTRA DEL PDF OCULTO */}
        {extraPages.map((pageRows, pIdx) => (
          <div key={`hidden_finance_page_${pIdx}`} className="hidden-finance-pdf-page bg-white relative shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '20mm', boxSizing: 'border-box', overflow: 'hidden', background: gradientStyle }}>
             <div className="absolute top-0 left-0 w-full h-3" style={{ backgroundColor: accentColor }}></div>
             <div className="flex justify-between items-center mb-8 mt-4">
                <h1 className="text-3xl font-editorial font-bold text-slate-900 leading-none">Desglose (Cont.)</h1>
                <p className="text-sm font-black tracking-[0.2em] uppercase" style={{ color: accentColor }}>{eventName}</p>
             </div>
             <main>{renderTableRows(pageRows)}</main>
             <div className="absolute bottom-[15mm] left-[20mm] right-[20mm] flex justify-between items-center text-[7px] uppercase tracking-widest text-slate-400 border-t border-slate-200 pt-3">
                <span>Fecha de Emisión: {new Date().toLocaleDateString('es-MX')}</span>
                <span>Página {pIdx + 2} de {1 + extraPages.length}</span>
             </div>
          </div>
        ))}
      </div>

      {isFormOpen && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-[#D4AF37]/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between transition-colors">
              <h3 className="font-editorial font-black text-xl text-[#D4AF37]">Nuevo Gasto</h3>
              <button onClick={() => setIsFormOpen(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            </div>
            <div className="p-6 space-y-5">
              <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Concepto</label><input type="text" value={formData.concepto} onChange={e=>setFormData({...formData, concepto: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors" placeholder="Ej. Fotografía"/></div>
              <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Categoría</label><select value={formData.categoria} onChange={e=>setFormData({...formData, categoria: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors appearance-none">{categorias.map(c => <option key={c} value={c}>{c}</option>)}</select></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Estimado ($)</label><input type="number" value={formData.estimado} onChange={e=>setFormData({...formData, estimado: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors" /></div>
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Fecha Límite</label><input type="date" value={formData.fechaLimite} onChange={e=>setFormData({...formData, fechaLimite: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white [color-scheme:dark] transition-colors font-bold" /></div>
              </div>
              <button type="button" onClick={handleSaveGasto} disabled={!formData.concepto || !formData.estimado} className="w-full p-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-6 hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)] disabled:opacity-50">Guardar Gasto</button>
            </div>
          </div>
        </div>
      )}

      {editGastoModal && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-[#D4AF37]/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between transition-colors"><h3 className="font-editorial font-black text-xl text-[#D4AF37]">Editar Gasto</h3><button onClick={() => setEditGastoModal(null)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button></div>
            <div className="p-6 space-y-5">
              <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Concepto</label><input type="text" value={editGastoModal.concepto} onChange={e=>setEditGastoModal({...editGastoModal, concepto: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors" /></div>
              <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Categoría</label><select value={editGastoModal.categoria} onChange={e=>setEditGastoModal({...editGastoModal, categoria: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors appearance-none">{categorias.map(c => <option key={c} value={c}>{c}</option>)}</select></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Costo Estimado ($)</label><input type="number" value={editGastoModal.estimado} onChange={e=>setEditGastoModal({...editGastoModal, estimado: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white font-bold transition-colors" /></div>
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Fecha Límite</label><input type="date" value={editGastoModal.fechaLimite || ''} onChange={e=>setEditGastoModal({...editGastoModal, fechaLimite: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none text-white [color-scheme:dark] transition-colors font-bold" /></div>
              </div>
              <button type="button" onClick={handleUpdateGasto} className="w-full p-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest mt-6 hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)]">Guardar Cambios</button>
            </div>
          </div>
        </div>
      )}

      {historyModal && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-[#D4AF37]/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors">
              <h3 className="font-bold text-sm text-[#D4AF37] flex items-center uppercase tracking-widest"><History size={16} className="mr-2"/> Historial de Pagos</h3>
              <button onClick={() => setHistoryModal(null)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            </div>
            <div className="p-6 max-h-96 overflow-y-auto space-y-4 custom-scrollbar bg-[#1C1917] transition-colors">
              <p className="text-white font-bold mb-4 transition-colors">{historyModal.concepto}</p>
              {historyModal.historial.map((abono, i) => (
                <div key={abono.id} className="p-4 border border-white/10 rounded-2xl relative flex justify-between items-center bg-[#141210] shadow-sm hover:border-[#D4AF37]/50 transition-colors">
                  <div className="absolute -left-2 -top-2 w-6 h-6 bg-[#1C1917] border border-[#D4AF37]/50 rounded-full flex items-center justify-center text-[10px] font-black text-[#D4AF37]">{i+1}</div>
                  <div>
                    <p className="font-black text-emerald-400 text-xl transition-colors">{formatMoney(abono.monto)}</p>
                    <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500 flex items-center mt-1"><Calendar size={10} className="mr-1"/> {abono.fecha}</p>
                  </div>
                  <div className="text-right flex flex-col items-end">
                    <p className="text-[9px] font-black text-[#D4AF37] uppercase bg-[#D4AF37]/10 border border-[#D4AF37]/20 px-2 py-1 rounded-md inline-block transition-colors">{abono.metodo}</p>
                    {abono.cuenta && <p className="text-[10px] text-slate-500 mt-2 font-mono">Ref: {abono.cuenta}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {paymentProcess && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-emerald-500/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-white/10 bg-emerald-500/10 flex justify-between items-center transition-colors">
              <h3 className="font-bold text-sm text-emerald-400 flex items-center uppercase tracking-widest"><DollarSign size={16} className="mr-2"/> Registrar Pago</h3>
              <button onClick={() => setPaymentProcess(null)} className="text-slate-400 hover:text-white transition-colors"><X size={20}/></button>
            </div>
            <div className="p-6 space-y-5">
              <div className="bg-[#141210] p-4 rounded-xl border border-white/5 text-xs text-slate-400 mb-2 transition-colors">Destino: <b className="text-sm text-white ml-1 transition-colors">{paymentProcess.item.concepto}</b></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Monto ($)</label><input type="number" required max={paymentProcess.item.estimado - paymentProcess.item.pagado} value={paymentProcess.monto} onChange={e=>setPaymentProcess({...paymentProcess, monto: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl font-black text-xl text-emerald-400 focus:border-emerald-500 outline-none bg-[#141210] transition-colors" placeholder="0.00" /></div>
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Fecha</label><input type="date" required value={paymentProcess.fecha} onChange={e=>setPaymentProcess({...paymentProcess, fecha: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl focus:border-emerald-500 outline-none bg-[#141210] text-white text-sm [color-scheme:dark] transition-colors font-bold" /></div>
              </div>
              <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Forma de Pago</label><select value={paymentProcess.metodo} onChange={e=>setPaymentProcess({...paymentProcess, metodo: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl focus:border-emerald-500 outline-none bg-[#141210] text-white text-sm transition-colors cursor-pointer appearance-none font-bold"><option value="Transferencia">Transferencia</option><option value="Efectivo">Efectivo</option><option value="Tarjeta">Tarjeta</option><option value="Depósito">Depósito</option></select></div>
              {(paymentProcess.metodo === 'Transferencia' || paymentProcess.metodo === 'Depósito') && (<div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Cuenta / Referencia</label><input type="text" placeholder="Ej. 01234567890" value={paymentProcess.cuenta} onChange={e=>setPaymentProcess({...paymentProcess, cuenta: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl focus:border-emerald-500 outline-none bg-[#141210] text-white text-sm font-mono transition-colors font-bold" /></div>)}
              
              <div className="flex space-x-3 pt-6 border-t border-white/10 transition-colors">
                <button type="button" onClick={() => setPaymentProcess(null)} className="flex-1 p-4 bg-white/5 font-bold rounded-xl text-slate-400 hover:text-white transition-colors uppercase tracking-widest text-[10px] border border-white/5">Cancelar</button>
                <button type="button" onClick={handleAddPayment} disabled={!paymentProcess.monto} className="flex-1 p-4 bg-emerald-500 text-[#1C1917] font-black rounded-xl shadow-[0_5px_15px_rgba(16,185,129,0.3)] hover:bg-emerald-600 transition-colors uppercase tracking-widest text-[10px] disabled:opacity-50">Guardar Pago</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteProcess && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-rose-500/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-white/10 bg-rose-500/10 flex justify-between items-center transition-colors">
              <h3 className="font-bold text-sm text-rose-400 flex items-center uppercase tracking-widest"><AlertTriangle size={16} className="mr-2"/> Cancelar Servicio</h3>
              <button onClick={() => setDeleteProcess(null)} className="text-slate-400 hover:text-white transition-colors"><X size={20}/></button>
            </div>
            <div className="p-6 space-y-4">
              <p className="text-sm text-slate-300 transition-colors">Este gasto ya tiene <b className="text-rose-400">{formatMoney(deleteProcess.item.pagado)}</b> abonados. ¿Cuánto dinero te regresó el proveedor?</p>
              <div>
                <label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400 transition-colors">Monto Reembolsado ($)</label>
                <input type="number" max={deleteProcess.item.pagado} value={deleteProcess.refundAmount} onChange={e=>setDeleteProcess({...deleteProcess, refundAmount: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl text-rose-400 font-bold focus:border-rose-500 outline-none bg-[#141210] transition-colors" placeholder="0.00"/>
              </div>
              <div className="flex items-center gap-3 mt-4">
                 <input type="checkbox" id="keepRemaining" checked={deleteProcess.keepRemaining} onChange={e=>setDeleteProcess({...deleteProcess, keepRemaining: e.target.checked})} className="w-5 h-5 accent-rose-500"/>
                 <label htmlFor="keepRemaining" className="text-xs text-slate-400 cursor-pointer transition-colors">Mantener el dinero perdido como gasto en el presupuesto</label>
              </div>
              <div className="flex space-x-3 pt-6 border-t border-white/10 transition-colors">
                <button type="button" onClick={() => setDeleteProcess(null)} className="flex-1 p-4 bg-white/5 border border-white/10 font-bold rounded-xl text-slate-400 uppercase tracking-widest text-[10px] transition-colors hover:text-white">Cancelar</button>
                <button type="button" onClick={() => executeDelete(deleteProcess.item, deleteProcess.refundAmount, deleteProcess.keepRemaining)} className="flex-1 p-4 bg-rose-500 text-white font-black rounded-xl shadow-[0_5px_15px_rgba(244,63,94,0.3)] hover:bg-rose-600 uppercase tracking-widest text-[10px] transition-colors">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: PROVEEDORES (DARK PREMIUM COMPLETO) ---
// ==========================================
const ProveedoresView = ({ proveedores, setProveedores, gastos, setGastos, addNotification }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingProvId, setEditingProvId] = useState(null); 
  const [deleteProvConfirm, setDeleteProvConfirm] = useState(null); 
  
  const [hireProcess, setHireProcess] = useState(null);
  const [viewContract, setViewContract] = useState(null);
  const [viewGallery, setViewGallery] = useState(null);
  const [categoriaFiltro, setCategoriaFiltro] = useState('Todas');
  const [cancelProvModal, setCancelProvModal] = useState(null); 
  const [infoModal, setInfoModal] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [globalData, setGlobalData] = useState(mockGlobalProviders);
  const [userLocation, setUserLocation] = useState(null);
  const [isFromGlobal, setIsFromGlobal] = useState(false);

  const [exportViewOpen, setExportViewOpen] = useState(false);
  const [isPreparingPrint, setIsPreparingPrint] = useState(false);

  const [formData, setFormData] = useState({ 
    nombre: '', facebook: '', categoria: 'Otros', servicio: '', costo: '', 
    status: 'Cotizado', telefono: '', email: '', notas: '', banco: '', clabe: '', titular: '', rating: 0, galeria: 0 
  });

  const categorias = ['Lugar', 'Música', 'Decoración', 'Recuerdos', 'Comida/Bebida', 'Ropa/Maquillaje', 'Papelería', 'Otros'];
  const statusColors = { 
    'Cotizado':'bg-white/5 text-slate-400 border-white/10', 
    'Negociando':'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/30', 
    'Contratado':'bg-emerald-500/10 text-emerald-400 border-emerald-500/30 shadow-[0_0_10px_rgba(16,185,129,0.15)]', 
    'Descartado':'bg-rose-500/10 text-rose-400 border-rose-500/20 opacity-70' 
  };
  const safeProveedores = proveedores || [];

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function(position) {
        setUserLocation({ lat: position.coords.latitude, lng: position.coords.longitude });
      });
    }
  }, []);

  const openNewProviderForm = (provName = '') => {
    setFormData({ nombre: provName, facebook: '', categoria: 'Otros', servicio: '', costo: '', status: 'Cotizado', telefono: '', email: '', notas: '', banco: '', clabe: '', titular: '', rating: 0, galeria: 0 });
    setEditingProvId(null);
    setIsFromGlobal(false);
    setIsFormOpen(true);
  };

  const openEditProvider = (prov) => {
    setFormData({
      nombre: prov.nombre || '', facebook: prov.facebook || '', categoria: prov.categoria || 'Otros',
      servicio: prov.servicio || '', costo: prov.costo || '', status: prov.status || 'Cotizado',
      telefono: prov.telefono || '', email: prov.email || '', notas: prov.notas || '',
      banco: prov.banco || '', clabe: prov.clabe || '', titular: prov.titular || '', rating: prov.rating || 0, galeria: prov.galeria || 0
    });
    setEditingProvId(prov.id);
    setIsFromGlobal(false); 
    setIsFormOpen(true);
  };

  const selectGlobalProvider = (prov) => {
    setFormData({
      nombre: prov.nombre, facebook: prov.facebook || '', categoria: prov.categoria, servicio: prov.servicio, costo: prov.costoPromedio, status: 'Cotizado', telefono: prov.telefono || '', email: '', notas: '', banco: '', clabe: '', titular: '', rating: 0, galeria: 0
    });
    setEditingProvId(null);
    setIsFromGlobal(true);
    setIsFormOpen(true);
  };

  const handleSaveProveedor = async (e) => {
      e.preventDefault();
      // 🔴 CERO FRICCIÓN: Se eliminó la validación estricta de URL aquí.

      if (editingProvId) {
         const prov = safeProveedores.find(p => p.id === editingProvId);
         const updatedProv = { ...prov, ...formData, costo: Number(formData.costo) };
         await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "proveedores", editingProvId.toString()), updatedProv);
         if(addNotification) addNotification('Proveedor Actualizado', 'Los datos se han guardado correctamente.', 'success');
      } else {
         const nuevoId = Date.now().toString();
         const nuevoProv = { id: nuevoId, ...formData, costo: Number(formData.costo), contratado: false, gastoId: null, contrato: null };
         await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "proveedores", nuevoId), nuevoProv);
           
         if (!isFromGlobal && formData.facebook && !globalData.find(p => p.facebook === formData.facebook)) {
             setGlobalData([...globalData, {
                id: `prov_new_${Date.now()}`, nombre: formData.nombre, facebook: formData.facebook, categoria: formData.categoria, servicio: formData.servicio, costoPromedio: Number(formData.costo), lat: userLocation ? userLocation.lat : 19.4326, lng: userLocation ? userLocation.lng : -99.1332, ratingPromedio: 0, telefono: formData.telefono
             }]);
         }
         if(addNotification) addNotification('Proveedor Guardado', 'El proveedor ha sido registrado exitosamente.', 'success');
      }
      setIsFormOpen(false);
      setEditingProvId(null);
      setSearchTerm('');
  };

  const executeDeleteProvider = async () => {
    if (deleteProvConfirm) {
       await deleteDoc(doc(db, "eventos", ID_DEL_EVENTO, "proveedores", deleteProvConfirm.id.toString()));
       setDeleteProvConfirm(null);
       if(addNotification) addNotification('Eliminado', 'Proveedor borrado permanentemente.', 'success');
    }
  };

  const setRating = async (provId, newRating) => { 
    const prov = safeProveedores.find(p => p.id === provId);
    if(prov) await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "proveedores", provId.toString()), { ...prov, rating: newRating });
  };

  const handleHireSubmit = async (e) => {
      e.preventDefault();
      const { prov, abono, file, fechaLimite } = hireProcess;
      const fileName = file ? file.name : null;
      const nuevoGastoId = Date.now().toString();
      const nuevoGasto = { id: nuevoGastoId, concepto: `${prov.servicio} (${prov.nombre})`, categoria: prov.categoria, estimado: prov.costo, pagado: Number(abono), proveedorId: prov.id, fechaLimite: fechaLimite, historial: abono > 0 ? [{ id: Date.now(), fecha: new Date().toISOString().split('T')[0], monto: Number(abono), metodo: 'Acuerdo Inicial', cuenta: prov.clabe || '' }] : [] };
      
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "gastos", nuevoGastoId), nuevoGasto);
    await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "proveedores", prov.id.toString()), { ...prov, status: 'Contratado', contratado: true, gastoId: nuevoGastoId, contrato: fileName });

      setHireProcess(null);
      if(addNotification) addNotification('¡Contratado!', `${prov.nombre} se vinculó al presupuesto automáticamente.`, 'success');
  };

  const confirmCancel = async () => {
      if(cancelProvModal) {
      await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "proveedores", cancelProvModal.id.toString()), { ...cancelProvModal, status: 'Descartado', contratado: false, gastoId: null });
         setCancelProvModal(null);
         if(addNotification) addNotification('Cancelado', 'Proveedor movido a descartados.', 'warning');
      }
  };

  const proveedoresFiltrados = categoriaFiltro === 'Todas' ? safeProveedores : safeProveedores.filter(p => p.categoria === categoriaFiltro);
  
  const searchedProviders = globalData
    .filter(p => p.nombre.toLowerCase().includes(searchTerm.toLowerCase()) || p.servicio.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => {
      if (!userLocation) return b.ratingPromedio - a.ratingPromedio;
      const distA = getDistanceFromLatLonInKm(userLocation.lat, userLocation.lng, a.lat, a.lng);
      const distB = getDistanceFromLatLonInKm(userLocation.lat, userLocation.lng, b.lat, b.lng);
      return distA - distB;
    });

  const formatMoney = (amount) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount || 0);

  const triggerPdfDownload = async () => {
    setIsPreparingPrint(true);
    setTimeout(async () => {
      try {
        const { jsPDF } = await import('jspdf');
        const html2canvas = (await import('html2canvas')).default;
        const pages = document.querySelectorAll('.providers-pdf-page');
        const pdf = new jsPDF('p', 'mm', 'letter');
        for (let i = 0; i < pages.length; i++) {
           const canvas = await html2canvas(pages[i], { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
           const imgData = canvas.toDataURL('image/jpeg', 0.95);
           if (i > 0) pdf.addPage();
           pdf.addImage(imgData, 'JPEG', 0, 0, 215.9, 279.4);
        }
        const fileName = categoriaFiltro === 'Todas' ? 'Directorio-Proveedores.pdf' : `Comparativa-${categoriaFiltro}.pdf`;
        pdf.save(fileName);
        if(addNotification) addNotification('¡PDF Guardado!', 'Revisa tu carpeta de descargas.', 'success');
      } catch (error) {}
      setIsPreparingPrint(false);
      setExportViewOpen(false);
    }, 500); 
  };

  if (exportViewOpen) {
    const isComparativa = categoriaFiltro !== 'Todas';
    const title = isComparativa ? `Cuadro Comparativo: ${categoriaFiltro}` : 'Directorio de Proveedores';
    const subtitle = isComparativa ? 'Análisis de opciones y cotizaciones para tomar decisión' : 'Contactos operativos para el día del evento';

    const PAGE_1_LIMIT = 8;
    const PAGE_N_LIMIT = 12;
    const firstPageItems = proveedoresFiltrados.slice(0, PAGE_1_LIMIT);
    const extraItems = proveedoresFiltrados.slice(PAGE_1_LIMIT);
    const extraPages = [];
    for(let i=0; i<extraItems.length; i+=PAGE_N_LIMIT) extraPages.push(extraItems.slice(i, i+PAGE_N_LIMIT));

    const renderTableRows = (rows) => (
      <table className="w-full text-left text-xs border-collapse">
        <thead>
          <tr className="bg-slate-100 text-slate-800 border-b-2 border-slate-800">
            <th className="px-3 py-3 font-bold w-1/3">Proveedor / Servicio</th>
            {!isComparativa && <th className="px-3 py-3 font-bold">Contacto</th>}
            <th className="px-3 py-3 font-bold text-center">Estatus</th>
            {isComparativa && <th className="px-3 py-3 font-bold text-center">Rating</th>}
            <th className="px-3 py-3 font-bold text-right">Costo Estimado</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((prov) => (
            <tr key={`print_${prov.id}`} className={prov.status === 'Descartado' ? 'opacity-50' : ''}>
              <td className="px-3 py-3 align-top">
                <p className="font-black text-slate-800 text-sm">{prov.nombre}</p>
                <p className="text-slate-500 mt-0.5">{prov.servicio}</p>
              </td>
              {!isComparativa && (
                <td className="px-3 py-3 align-top font-medium text-slate-700">
                  {prov.telefono ? <span className="block">Tel: {prov.telefono}</span> : null}
                  {prov.email ? <span className="block mt-0.5">Email: {prov.email}</span> : null}
                  {!prov.telefono && !prov.email ? <span className="text-slate-400 italic">Sin contacto</span> : null}
                </td>
              )}
              <td className="px-3 py-3 align-top text-center">
                <span className={`px-2 py-1 rounded text-[9px] font-black uppercase tracking-wider`}>{prov.status}</span>
              </td>
              {isComparativa && (
                <td className="px-3 py-3 align-top text-center text-amber-500 font-black text-sm">
                  {prov.rating > 0 ? '★'.repeat(prov.rating) : <span className="text-slate-300">S/C</span>}
                </td>
              )}
              <td className="px-3 py-3 align-top text-right font-black text-indigo-700 text-sm">
                {formatMoney(prov.costo)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );

    return (
      <div className="fixed inset-0 z-[120] bg-slate-900/95 flex flex-col overflow-hidden backdrop-blur-md">
        <div className="bg-[#0a0a0a] text-white p-4 flex flex-col sm:flex-row justify-between items-center border-b border-white/10 z-10 shrink-0 gap-4">
          <div className="flex items-center space-x-4 w-full sm:w-auto">
            <button onClick={() => setExportViewOpen(false)} className="p-2 hover:bg-white/10 rounded-full transition-colors"><X size={24}/></button>
            <div>
              <h3 className="font-bold text-sm">Previsualización de Documento</h3>
              <p className="text-[10px] text-slate-400">Paginado Automático Tamaño Carta</p>
            </div>
          </div>
          <button onClick={triggerPdfDownload} disabled={isPreparingPrint} className="px-6 py-3 bg-amber-500 hover:bg-amber-400 text-slate-900 rounded-xl text-sm font-black flex items-center shadow-[0_0_15px_rgba(245,158,11,0.3)] transition-all w-full sm:w-auto justify-center disabled:opacity-50">
            {isPreparingPrint ? <RefreshCw size={18} className="mr-2 animate-spin"/> : <Download size={18} className="mr-2"/>} 
            {isPreparingPrint ? 'Armando PDF...' : 'Descargar PDF'}
          </button>
        </div>

        <div className="flex-1 overflow-y-auto bg-[#111] flex flex-col items-center py-8 gap-8 relative custom-scrollbar">
          <div className="providers-pdf-page bg-white shadow-2xl shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden', position: 'relative' }}>
            <header className="flex justify-between items-center border-b-2 border-slate-200 pb-4 mb-6">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-slate-800 rounded flex items-center justify-center text-white font-black text-xl mr-3">E</div>
                <div><h2 className="text-xl font-black text-slate-800 tracking-wider">EVENT MASTER</h2><p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">Plataforma Premium</p></div>
              </div>
              <div className="text-right">
                <h1 className="text-lg font-serif text-slate-900 italic">{title}</h1>
                <p className="text-[10px] text-slate-500 uppercase tracking-widest mt-1">{subtitle}</p>
              </div>
            </header>
            <main>{renderTableRows(firstPageItems)}</main>
            <div className="absolute bottom-6 right-6 text-[10px] font-bold text-slate-400">Página 1 de {1 + extraPages.length}</div>
          </div>

          {extraPages.map((pageRows, pIdx) => (
            <div key={`extrapage_${pIdx}`} className="providers-pdf-page bg-white shadow-2xl shrink-0" style={{ width: '215.9mm', height: '279.4mm', padding: '15mm', boxSizing: 'border-box', overflow: 'hidden', position: 'relative' }}>
               <header className="border-b-2 border-slate-800 pb-3 mb-6">
                 <h1 className="text-xl font-black text-slate-900 uppercase tracking-tight">{title} (Cont.)</h1>
               </header>
               <main>{renderTableRows(pageRows)}</main>
               <div className="absolute bottom-6 right-6 text-[10px] font-bold text-slate-400">Página {pIdx + 2} de {1 + extraPages.length}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col space-y-6 pb-6 relative text-white bg-[#141210] min-h-[100vh] p-4 rounded-3xl transition-colors duration-500">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 bg-[#1C1917] p-5 sm:p-6 rounded-3xl border border-[#D4AF37]/25 shadow-xl">
        <div className="flex items-center gap-3.5">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-2xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
            <Store size={20} />
          </div>
          <div>
            <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block mb-0.5">Contactos, evaluaciones y contratos.</span>
            <h2 className="text-2xl sm:text-3xl font-editorial text-white tracking-wide leading-none">Directorio VIP</h2>
          </div>
        </div>
        <div className="flex w-full md:w-auto">
          <button onClick={() => openNewProviderForm('')} className="flex-1 md:flex-none flex items-center justify-center px-5 h-9 bg-[#D4AF37] text-[#1C1917] rounded-lg text-[10px] font-black hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)] uppercase tracking-widest shrink-0">
            <Plus size={14} className="mr-1.5" /> Nuevo Proveedor
          </button>
        </div>
      </div>

      {/* BUSCADOR INTEGRADO LUMINOSO */}
      <div className="relative z-10 px-2">
        <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
          <SearchIcon size={20} className="text-[#D4AF37]/70" />
        </div>
        <input 
          type="text" 
          placeholder="Buscar proveedor en la comunidad..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-14 pr-4 py-4 bg-[#1C1917] border border-[#D4AF37]/30 rounded-2xl shadow-xl text-base outline-none focus:border-[#D4AF37] text-white font-medium transition-all placeholder-slate-500"
        />
      </div>

      {searchTerm.length > 0 ? (
        <div className="flex-1 overflow-y-auto pb-10 custom-scrollbar px-2">
          <h3 className="font-bold text-slate-300 mb-4 flex items-center text-sm uppercase tracking-widest"><SearchIcon size={16} className="mr-2 text-[#D4AF37]"/> Resultados Globales</h3>
          
          {searchedProviders.length === 0 ? (
            <div className="text-center py-16 bg-[#1C1917] rounded-3xl border border-dashed border-white/10 transition-colors">
               <Store size={56} className="mx-auto mb-4 text-[#D4AF37]/50"/>
               <h3 className="text-xl font-editorial font-black text-white">Aún no dan de alta a este proveedor con nosotros</h3>
               <p className="text-slate-400 mt-2 mb-6 text-sm">¡Sé el primero en agregarlo a la Bóveda Privada!</p>
               <button onClick={() => openNewProviderForm(searchTerm)} className="px-6 py-3.5 bg-[#D4AF37] text-[#1C1917] font-black rounded-xl shadow-[0_5px_15px_rgba(212,175,55,0.2)] hover:scale-105 transition-transform inline-flex items-center text-xs uppercase tracking-widest">
                 <Plus size={16} className="mr-2"/> Agregar "{searchTerm}"
               </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {searchedProviders.map(prov => {
                const distancia = userLocation ? getDistanceFromLatLonInKm(userLocation.lat, userLocation.lng, prov.lat, prov.lng).toFixed(1) : null;
                return (
                  <div key={prov.id} className="bg-[#1C1917] rounded-3xl border border-[#D4AF37]/30 shadow-xl flex flex-col p-6 hover:border-[#D4AF37] transition-colors duration-300">
                    <div className="flex justify-between items-start mb-4">
                      <span className="px-2.5 py-1 bg-white/5 text-[#D4AF37] rounded-md border border-white/5 text-[10px] font-black uppercase tracking-widest">{prov.categoria}</span>
                      {distancia && <span className="text-[10px] font-bold text-slate-400 flex items-center bg-white/5 border border-white/10 px-2.5 py-1 rounded-full"><MapPin size={10} className="mr-1 text-rose-500"/> A {distancia} km</span>}
                    </div>
                    <h3 className="font-editorial font-black text-2xl text-white mb-1 leading-tight">{prov.nombre}</h3>
                    <p className="text-slate-400 text-sm mb-5 line-clamp-2">{prov.servicio}</p>
                    
                    <div className="flex items-center justify-between mb-5 bg-[#141210] p-3 rounded-xl border border-white/5 transition-colors">
                      <div className="flex items-center">
                        <Star size={16} className="text-[#D4AF37] fill-[#D4AF37] mr-1.5"/>
                        <span className="font-black text-white text-base">{prov.ratingPromedio}</span>
                      </div>
                      <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">Aprox: <span className="text-sm text-white">{formatMoney(prov.costoPromedio)}</span></span>
                    </div>

                    <div className="mt-auto pt-4 flex gap-2">
                      <button onClick={() => { if(prov.telefono) window.open(`https://wa.me/${prov.telefono.replace(/\D/g,'')}?text=Hola,%20te%20encontré%20en%20EventMaster`, '_blank'); }} className="p-3 bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 rounded-xl hover:bg-emerald-500/20 transition-colors" title="Contactar por WhatsApp">
                        <MessageCircle size={20} />
                      </button>
                      <button onClick={() => selectGlobalProvider(prov)} className="flex-1 bg-[#D4AF37] text-[#1C1917] px-4 py-3 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-[#c5a028] shadow-[0_5px_15px_rgba(212,175,55,0.2)] flex items-center justify-center transition-colors">
                        Cotizar
                      </button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="flex gap-2">
            <select value={categoriaFiltro} onChange={e=>setCategoriaFiltro(e.target.value)} className="px-4 py-2 border border-white/10 rounded-xl bg-[#1C1917] text-xs uppercase tracking-widest font-bold text-white outline-none shadow-sm transition-colors appearance-none"><option value="Todas">Todas las áreas</option>{categorias.map(c => <option key={c} value={c}>Giro: {c}</option>)}</select>
            <button onClick={() => { if(proveedoresFiltrados.length === 0) { if(addNotification) addNotification('Directorio Vacío', 'No hay proveedores para exportar.', 'warning'); return; } setExportViewOpen(true); }} className="flex items-center px-4 py-2 bg-transparent border border-white/10 text-slate-300 rounded-xl text-[10px] uppercase tracking-widest font-bold hover:bg-white/5 hover:text-white shadow-sm transition-colors">
              <FileDown size={14} className="mr-2 text-[#D4AF37]"/> {categoriaFiltro === 'Todas' ? 'Directorio PDF' : 'Comparativa PDF'}
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-y-auto pb-10 custom-scrollbar px-2">
            {proveedoresFiltrados.map(prov => (
              <div key={prov.id} className={`group bg-[#1C1917] p-6 rounded-3xl border shadow-xl flex flex-col relative overflow-hidden transition-all duration-500 ${prov.status === 'Descartado' ? 'opacity-50 bg-[#141210] border-white/5' : 'border-[#D4AF37]/30 hover:border-[#D4AF37]'}`}>
                
                <div className="absolute top-4 right-4 flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                   <button onClick={(e) => { e.stopPropagation(); openEditProvider(prov); }} className="p-2 bg-[#141210] border border-white/10 text-slate-400 hover:text-white rounded-lg shadow-sm transition-colors" title="Editar Proveedor"><Edit2 size={14}/></button>
                   <button onClick={(e) => { e.stopPropagation(); setDeleteProvConfirm(prov); }} className="p-2 bg-[#141210] border border-white/10 text-slate-400 hover:text-rose-400 rounded-lg shadow-sm transition-colors" title="Eliminar Proveedor"><Trash2 size={14}/></button>
                </div>

                <div className="flex justify-between items-start mb-3 pr-20">
                  <span className="px-2.5 py-1 bg-white/5 text-slate-400 border border-white/10 rounded-md text-[9px] font-black uppercase tracking-widest">{prov.categoria}</span>
                  <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-widest border ${statusColors[prov.status]}`}>{prov.status}</span>
                </div>
                
                <div className="flex justify-between items-start mb-2">
                  <h3 className="font-editorial font-black text-2xl text-white leading-tight pr-2 transition-colors">{prov.nombre}</h3>
                  <div className="flex space-x-0.5 mt-1.5 shrink-0">
                    {[1,2,3,4,5].map(star => (
                      <button key={star} onClick={()=>setRating(prov.id, star)} className={`transition-colors ${prov.rating >= star ? 'text-[#D4AF37]' : 'text-slate-600 hover:text-[#D4AF37]/50'}`}>
                        <Star size={14} fill={prov.rating >= star ? 'currentColor' : 'none'} />
                      </button>
                    ))}
                  </div>
                </div>
                
                <p className="text-slate-400 text-sm mb-5 font-medium transition-colors line-clamp-2">{prov.servicio}</p>
                
                <div className="flex space-x-2 mb-5">
                  {prov.telefono && (
                    <>
                      <a href={`tel:${prov.telefono}`} className="p-2.5 bg-[#141210] border border-white/5 text-slate-400 rounded-xl hover:bg-white/10 hover:text-white transition-colors"><Phone size={16} /></a>
                      <a href={`https://wa.me/${prov.telefono.replace(/\D/g,'')}`} target="_blank" rel="noreferrer" className="p-2.5 bg-[#141210] border border-white/5 text-slate-400 rounded-xl hover:bg-emerald-500/10 hover:text-emerald-400 transition-colors"><MessageCircle size={16} /></a>
                    </>
                  )}
                  {prov.email && <a href={`mailto:${prov.email}`} className="p-2.5 bg-[#141210] border border-white/5 text-slate-400 rounded-xl hover:bg-white/10 hover:text-white transition-colors"><Mail size={16} /></a>}
                  <button onClick={() => setViewGallery(prov)} className="p-2.5 bg-[#141210] border border-white/5 text-slate-400 rounded-xl hover:bg-white/10 hover:text-white transition-colors relative">
                    <ImageIcon size={16} />
                    {prov.galeria > 0 && <span className="absolute -top-1 -right-1 w-4 h-4 bg-sky-500 text-white rounded-full text-[8px] font-bold flex items-center justify-center border-2 border-[#1C1917]">{prov.galeria}</span>}
                  </button>
                </div>

                {(prov.banco || prov.clabe) && (
                  <div className="mb-4 bg-[#141210] border border-white/5 p-3 rounded-xl text-[10px] text-slate-400 flex flex-col space-y-1.5 transition-colors">
                    <div className="flex items-center font-bold text-slate-300 mb-1 uppercase tracking-widest"><Building size={12} className="mr-1.5 text-[#D4AF37]"/> Datos Bancarios</div>
                    {prov.titular && <div><span className="opacity-60 w-16 inline-block">Titular:</span> <span className="text-white font-bold">{prov.titular}</span></div>}
                    {prov.banco && <div><span className="opacity-60 w-16 inline-block">Banco:</span> <span className="text-white font-bold">{prov.banco}</span></div>}
                    {prov.clabe && <div><span className="opacity-60 w-16 inline-block">Cuenta:</span> <span className="font-mono bg-white/5 text-white px-1.5 py-0.5 rounded font-bold border border-white/10">{prov.clabe}</span></div>}
                  </div>
                )}

                {prov.notas && <div className="mb-4 bg-[#D4AF37]/5 border border-[#D4AF37]/20 p-3 rounded-xl text-xs text-[#D4AF37] italic flex items-start shadow-sm transition-colors"><MessageSquare size={14} className="mr-2 mt-0.5 flex-shrink-0"/> {prov.notas}</div>}

                {prov.contrato && (
                  <div className="mb-4 flex items-center justify-between bg-[#141210] border border-white/5 p-2.5 rounded-xl text-xs text-slate-300 font-bold shadow-sm transition-colors">
                    <span className="flex items-center truncate mr-2"><FileSignature size={14} className="mr-2 flex-shrink-0 text-[#D4AF37]"/> {prov.contrato}</span>
                    <button onClick={() => setViewContract(prov.contrato)} className="p-1.5 bg-white/5 text-slate-400 rounded border border-white/10 hover:bg-white/10 hover:text-white transition-colors flex-shrink-0"><Eye size={14}/></button>
                  </div>
                )}

                <div className="mt-auto pt-5 border-t border-white/10 flex justify-between items-center transition-colors">
                  <span className="font-editorial font-black text-2xl text-white">{formatMoney(prov.costo)}</span>
                  {prov.status === 'Contratado' ? (
                    <button onClick={() => setCancelProvModal(prov)} className="text-[10px] font-black uppercase tracking-widest text-rose-400 bg-rose-500/10 border border-rose-500/20 hover:bg-rose-500/20 px-3 py-2 rounded-lg transition-colors">Cancelar</button>
                  ) : prov.status !== 'Descartado' ? (
                    <button onClick={() => setHireProcess({ prov, abono: '', file: null, fechaLimite: '' })} className="text-[10px] font-black uppercase tracking-widest text-[#1C1917] bg-[#D4AF37] hover:bg-[#c5a028] px-4 py-2.5 rounded-lg shadow-[0_5px_15px_rgba(212,175,55,0.2)] transition-colors">Firmar / Contratar</button>
                  ) : null}
                </div>
              </div>
            ))}
            {proveedoresFiltrados.length === 0 && <div className="col-span-full text-center py-16 text-slate-500 font-medium">No hay cotizaciones registradas en esta categoría.</div>}
          </div>
        </>
      )}
      
      {/* MODAL: ALTA Y EDICIÓN DE PROVEEDOR */}
      {isFormOpen && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-2xl overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 flex flex-col max-h-[90vh] transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center shrink-0 transition-colors">
              <h3 className="font-editorial font-black text-2xl text-[#D4AF37] flex items-center tracking-wide">
                 <Store size={24} className="mr-2.5"/> 
                 {editingProvId ? 'Editar Proveedor' : 'Alta de Proveedor'}
              </h3>
              <button onClick={() => setIsFormOpen(false)} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button>
            </div>
            <form onSubmit={handleSaveProveedor} className="p-6 overflow-y-auto shrink custom-scrollbar">
              
              <div className="mb-6 bg-[#D4AF37]/10 border border-[#D4AF37]/20 p-4 rounded-2xl flex items-start text-[#D4AF37] text-xs font-medium shadow-sm transition-colors">
                <Info size={16} className="mr-3 mt-0.5 flex-shrink-0"/>
                <p><b>Tip Experto:</b> Si agregas las redes sociales o página web de tu proveedor, nos ayudas a crear una comunidad más segura y te habilitará la opción de calificar su servicio al finalizar tu evento.</p>
              </div>

              <div className="grid grid-cols-2 gap-5 mb-6">
                <div className="col-span-2">
                  <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Enlace / Redes Sociales (Opcional)</label>
                  <input type="text" readOnly={isFromGlobal} placeholder="Ej. instagram.com/djparty o www.su-pagina.com" value={formData.facebook} onChange={e=>setFormData({...formData, facebook: e.target.value})} className={`w-full p-4 rounded-xl outline-none shadow-sm transition-colors text-sm font-bold ${isFromGlobal ? 'bg-[#1C1917] border border-white/5 text-slate-500' : 'bg-[#141210] border border-white/10 text-white focus:border-[#D4AF37]'}`} />
                  {isFromGlobal && <p className="text-[10px] text-[#D4AF37] font-bold uppercase tracking-widest mt-2 flex items-center"><Lock size={10} className="mr-1"/> Bloqueado. Este dato proviene de la Bóveda Global.</p>}
                </div>
                <div className="col-span-2 md:col-span-1"><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Empresa / Nombre</label><input type="text" required value={formData.nombre} onChange={e=>setFormData({...formData, nombre: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white text-sm font-bold transition-colors" /></div>
                <div className="col-span-2 md:col-span-1"><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Servicio Ofrecido</label><input type="text" required value={formData.servicio} onChange={e=>setFormData({...formData, servicio: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white text-sm font-bold transition-colors" placeholder="Ej. Banquete 100 pax"/></div>
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Categoría</label><select value={formData.categoria} onChange={e=>setFormData({...formData, categoria: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white text-sm font-bold transition-colors appearance-none">{categorias.map(c => <option key={c} value={c}>{c}</option>)}</select></div>
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Costo Estimado ($)</label><input type="number" required value={formData.costo} onChange={e=>setFormData({...formData, costo: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-[#D4AF37] font-black text-lg transition-colors" /></div>
              </div>

              <h4 className="text-[10px] font-black text-[#D4AF37] uppercase tracking-widest mb-4 border-b border-white/10 pb-2 transition-colors">2. Medios de Contacto</h4>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Teléfono / WhatsApp</label><input type="text" value={formData.telefono} onChange={e=>setFormData({...formData, telefono: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white font-bold text-sm transition-colors" placeholder="10 dígitos"/></div>
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Correo Electrónico</label><input type="email" value={formData.email} onChange={e=>setFormData({...formData, email: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white font-bold text-sm transition-colors" placeholder="@"/></div>
              </div>

              <h4 className="text-[10px] font-black text-[#D4AF37] uppercase tracking-widest mb-4 border-b border-white/10 pb-2 transition-colors">3. Datos Bancarios (Opcional)</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Banco</label><input type="text" value={formData.banco} onChange={e=>setFormData({...formData, banco: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white font-bold text-sm transition-colors" placeholder="Ej. BBVA"/></div>
                <div className="col-span-2 md:col-span-1"><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Cuenta / CLABE</label><input type="text" value={formData.clabe} onChange={e=>setFormData({...formData, clabe: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white font-mono text-sm transition-colors" placeholder="18 dígitos"/></div>
                <div className="col-span-2 md:col-span-1"><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Titular</label><input type="text" value={formData.titular} onChange={e=>setFormData({...formData, titular: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white font-bold text-sm transition-colors" /></div>
              </div>

              <div><label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Notas Internas</label><textarea value={formData.notas} onChange={e=>setFormData({...formData, notas: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] bg-[#141210] text-white font-bold text-sm resize-none h-20 transition-colors" placeholder="Detalles extra a recordar..."></textarea></div>

              <div className="mt-8 pt-6 border-t border-white/10 flex justify-end gap-3 transition-colors">
                <button type="button" onClick={() => setIsFormOpen(false)} className="px-6 py-4 bg-white/5 text-slate-300 rounded-xl font-bold hover:bg-white/10 transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
                <button type="submit" className="px-6 py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black hover:bg-[#c5a028] transition-colors shadow-[0_10px_25px_rgba(212,175,55,0.25)] uppercase tracking-widest text-[10px]">
                   {editingProvId ? 'Guardar Cambios' : 'Guardar Proveedor'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {deleteProvConfirm && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden p-8 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-rose-500/20 animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="w-20 h-20 bg-rose-500/10 text-rose-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner border border-rose-500/20"><Trash2 size={36} /></div>
            <h3 className="font-editorial font-black text-2xl text-white mb-2 transition-colors">¿Eliminar Proveedor?</h3>
            <p className="text-slate-400 text-sm mb-8 leading-relaxed">Estás a punto de borrar a <b className="text-white">{deleteProvConfirm.nombre}</b>. Esta acción no se puede deshacer.</p>
            <div className="flex space-x-3">
              <button onClick={() => setDeleteProvConfirm(null)} className="flex-1 p-4 bg-white/5 text-slate-300 border border-white/10 rounded-xl font-bold hover:bg-white/10 transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
              <button onClick={executeDeleteProvider} className="flex-1 p-4 bg-rose-500 text-white rounded-xl font-black hover:bg-rose-600 transition-colors shadow-[0_5px_15px_rgba(244,63,94,0.3)] uppercase tracking-widest text-[10px]">Sí, Eliminar</button>
            </div>
          </div>
        </div>
      )}

      {/* MODALES ADICIONALES (Contrato, Galería, Cancelación, Contratación) */}
      {viewContract && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-[#D4AF37]/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors">
              <h3 className="font-bold text-lg text-white flex items-center truncate">
                <FileText size={20} className="mr-2 text-[#D4AF37] shrink-0"/> <span className="truncate">{viewContract}</span>
              </h3>
              <button onClick={() => setViewContract(null)} className="text-slate-400 hover:text-[#D4AF37] transition-colors shrink-0 ml-2"><X size={20}/></button>
            </div>
            <div className="p-8 text-center">
              <div className="w-20 h-20 bg-[#141210] border border-white/10 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner">
                 <FileSignature size={32} className="text-[#D4AF37]"/>
              </div>
              <p className="text-slate-300 font-bold text-lg mb-8">Visor de Documentos Seguro</p>
              <button onClick={() => setViewContract(null)} className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-[10px] uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors">Cerrar Previsualización</button>
            </div>
          </div>
        </div>
      )}

      {viewGallery && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 print:hidden animate-in fade-in transition-colors">
          <div className="bg-[#1C1917] border border-[#D4AF37]/30 rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors">
              <h3 className="font-bold text-lg text-white flex items-center truncate">
                <ImageIcon size={20} className="mr-2 text-[#D4AF37] shrink-0"/> <span className="truncate">Referencias</span>
              </h3>
              <button onClick={() => setViewGallery(null)} className="text-slate-400 hover:text-[#D4AF37] transition-colors shrink-0 ml-2"><X size={20}/></button>
            </div>
            <div className="p-6 text-center">
              <div className="w-full bg-[#141210] border border-dashed border-white/20 rounded-2xl p-8 flex flex-col items-center justify-center transition-colors mb-4">
                 <UploadCloud size={48} className="text-[#D4AF37] mb-4 opacity-50"/>
                 <h4 className="text-lg font-bold text-white mb-2">{viewGallery.nombre}</h4>
                 <p className="text-xs text-slate-400 mb-6">Sube fotos de inspiración para este proveedor.</p>
                 <button className="px-6 py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black shadow-[0_5px_15px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors flex items-center text-[10px] uppercase tracking-widest"><Camera size={16} className="mr-2"/> Seleccionar Archivos</button>
              </div>
              <button onClick={() => setViewGallery(null)} className="w-full py-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold text-[10px] uppercase tracking-widest hover:bg-white/10 transition-colors">Cerrar Ventana</button>
            </div>
          </div>
        </div>
      )}

      {cancelProvModal && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 transition-colors">
          <div className="bg-[#1C1917] border border-rose-500/20 rounded-3xl w-full max-w-sm overflow-hidden p-8 text-center shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="w-16 h-16 bg-rose-500/10 text-rose-500 rounded-full flex items-center justify-center mx-auto mb-4 border border-rose-500/20"><AlertTriangle size={32} /></div>
            <h3 className="font-editorial font-black text-2xl text-white mb-2 transition-colors">¿Cancelar contrato?</h3>
            <p className="text-slate-400 mb-8 text-sm leading-relaxed">Pasarás a <b className="text-white">{cancelProvModal.nombre}</b> a descartado. Si había un pago vinculado, recuerda borrarlo desde Presupuesto.</p>
            <div className="flex space-x-3">
              <button onClick={() => setCancelProvModal(null)} className="flex-1 p-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold hover:bg-white/10 transition-colors uppercase tracking-widest text-[10px]">Atrás</button>
              <button onClick={confirmCancel} className="flex-1 p-4 bg-rose-500 text-white rounded-xl font-black hover:bg-rose-600 transition-colors shadow-[0_5px_15px_rgba(244,63,94,0.3)] uppercase tracking-widest text-[10px]">Sí, Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {hireProcess && (
        <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 transition-colors">
          <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] border border-[#D4AF37]/30 animate-in zoom-in-95 duration-200 transition-colors text-white">
            <div className="p-8 bg-[#141210] border-b border-[#D4AF37]/20 text-center relative transition-colors">
              <Building size={36} className="mx-auto mb-4 text-[#D4AF37]"/>
              <h3 className="font-editorial font-black text-2xl text-[#D4AF37] tracking-wide mb-2">Contratar Proveedor</h3>
              <p className="text-slate-400 text-[10px] uppercase tracking-widest font-bold">{hireProcess.prov.nombre}</p>
              <button onClick={() => setHireProcess(null)} className="absolute top-4 right-4 text-slate-500 hover:text-[#D4AF37]"><X size={20}/></button>
            </div>
            <form onSubmit={handleHireSubmit} className="p-8 space-y-5">
              <div className="bg-white/5 p-4 rounded-xl border border-white/10 text-xs text-slate-400 mb-2 transition-colors flex items-center justify-between">
                <span className="uppercase tracking-widest font-bold">Costo acordado:</span> 
                <b className="text-lg font-black text-[#D4AF37] ml-2">{formatMoney(hireProcess.prov.costo)}</b>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Anticipo Hoy ($)</label><input type="number" max={hireProcess.prov.costo} value={hireProcess.abono} onChange={e=>setHireProcess({...hireProcess, abono: e.target.value})} placeholder="0.00" className="w-full p-4 border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none font-black text-lg text-emerald-400 bg-[#141210] transition-colors" /></div>
                <div><label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Fecha Límite Pago</label><input type="date" required value={hireProcess.fechaLimite} onChange={e=>setHireProcess({...hireProcess, fechaLimite: e.target.value})} className="w-full p-4 border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none bg-[#141210] text-white text-sm font-bold [color-scheme:dark] transition-colors" /></div>
              </div>
              <div>
                <label className="block text-[10px] font-bold uppercase tracking-widest mb-2 text-slate-400">Respaldar Contrato (Archivo)</label>
                <div className="flex gap-2">
                  <label className="flex-1 flex flex-col items-center justify-center p-5 border border-dashed border-white/20 rounded-xl cursor-pointer hover:bg-white/5 hover:border-[#D4AF37] transition-colors bg-[#141210]">
                    <UploadCloud size={24} className="text-[#D4AF37] mb-3 opacity-50"/>
                    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Subir PDF</span>
                    <input type="file" accept=".pdf,.doc,.docx" className="hidden" onChange={e => setHireProcess({...hireProcess, file: e.target.files[0]})} />
                  </label>
                </div>
              </div>
              <button type="submit" className="w-full p-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black mt-6 shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors uppercase tracking-widest text-[10px]">Confirmar Contratación</button>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

// ==========================================
// --- COMPONENTE: CABECERA INTELIGENTE ---
// ==========================================
const BauliaLogoBlanco = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 950.3 241.1">
    <g fill="#F8FAFC">
      <path d="M300.8,89.1h-.4c0-2-.7-3.8-2.2-5.3s-3.3-2.2-5.3-2.2h-1.4v-1.2c-.1,0,9.3,0,9.3,0v8.6h0ZM300.8,154.4v8.6h-9.4v-1.2h1.5c2,0,3.8-.7,5.3-2.2s2.2-3.2,2.2-5.3h.4ZM308.1,80.4v82.6h-7.7v-82.6h7.7ZM314.8,80.4c5.5,0,10.2.8,14,2.5s6.7,4,8.7,6.9c2,3,3,6.4,3,10.3s-.6,6.2-1.9,8.7-2.9,4.5-4.8,6c-2,1.5-4.1,2.6-6.3,3.2,4.2.6,7.8,2,10.8,4.1s5.4,4.8,7,8c1.6,3.2,2.4,6.7,2.4,10.7s-1.1,8.3-3.2,11.6-5.3,5.9-9.4,7.8c-4.1,1.9-9.1,2.8-14.9,2.8h-13.1c0-1.4.1-2.8.1-4.2h12.5c4.1,0,7.6-.7,10.4-2.2s5-3.6,6.5-6.4c1.5-2.8,2.2-6.2,2.2-10.2s-.8-8-2.5-10.7c-1.7-2.8-3.9-4.8-6.6-6.3-2.7-1.4-5.6-2.4-8.7-2.9s-6.1-.8-8.9-.8v-1.1c1.8,0,3.8-.2,6-.6s4.3-1.2,6.4-2.4c2-1.2,3.7-2.9,5.1-5.3,1.3-2.3,2-5.4,2-9.1s-.6-6.6-1.9-9.1-3.2-4.4-5.8-5.7c-2.6-1.3-5.7-1.9-9.5-1.9h-10.9s0-.4-.3-1c-.2-.6-.5-1.5-.9-2.8h12.5,0Z"/>
      <path d="M417.6,154.4c-.6,1.6-.6,2.9-.2,4s1,1.9,1.9,2.5,1.8.9,2.8.9h1.1v1.2h-23.7v-1.2h1.1c1.8,0,3.7-.6,5.6-1.7,1.9-1.1,3.5-3,4.8-5.7h6.7,0ZM443,78.8l1.1,8.3-29.6,75.7h-7.1l30.2-71.8c.9-2,1.6-3.7,2.2-5.1s1.1-2.8,1.5-4.1c.4-1.3.6-2.3.6-3h1.1,0ZM459.6,130.8v3.5h-36.9v-3.5h36.9ZM443,78.8l34.9,83.6h-10l-27.3-72.4s2.4-11.2,2.4-11.2ZM464.9,154.4h9.7c1.2,2.7,2.8,4.6,4.7,5.7,2,1.1,3.9,1.7,5.7,1.7h.9v1.2h-26.6v-1.2h1.1c1.5,0,2.8-.6,4-1.9,1.2-1.3,1.3-3.1.5-5.5h0Z"/>
      <path d="M542.1,80.4v7.1h-.4c0-1.7-.6-3.1-1.8-4.2s-2.7-1.7-4.4-1.7h-1.9v-1.2h8.5ZM549.5,80.4v51.9c0,5.7,1,10.7,3.1,15s5,7.7,8.8,10.1c3.8,2.4,8.1,3.6,13.1,3.6s9.9-1.1,13.8-3.4c3.9-2.3,7-5.4,9.2-9.5s3.3-8.8,3.3-14.2v-53.5h5.5v53.5c0,6.1-1.3,11.5-4,16.1-2.6,4.6-6.4,8.2-11.2,10.8s-10.4,3.9-16.8,3.9-12.3-1.3-17.2-3.8c-4.9-2.6-8.7-6.1-11.4-10.7-2.7-4.6-4.1-10-4.1-16.1v-53.6h7.9ZM557.6,80.4v1.2h-1.9c-1.7,0-3.2.6-4.4,1.7s-1.8,2.5-1.8,4.2h-.2v-7.1h8.4,0ZM574.4,72.1c1.7-1.8,3.3-3.6,5-5.4s3.3-3.5,5-5.2,3.4-3.3,5-4.9c.9.9,1.7,1.9,2.6,3,.9,1,1.6,2.1,2.2,3.3-2.1,1.2-4.2,2.4-6.4,3.5-2.1,1.2-4.2,2.3-6.3,3.4s-4.2,2.1-6.3,3.1c0,0-.8-.8-.8-.8ZM601.2,80.4v7.1h-.4c0-1.7-.6-3.1-1.8-4.2s-2.7-1.7-4.4-1.7h-1.9v-1.2h8.5ZM614.5,80.4v1.2h-1.9c-1.7,0-3.2.6-4.4,1.7s-1.8,2.5-1.8,4.2h-.2v-7.1h8.4,0Z"/>
      <path d="M682.6,89.1h-.4c0-2-.8-3.8-2.3-5.3s-3.2-2.2-5.3-2.2h-1.5v-1.2h9.4v8.6h0ZM682.6,154.4v8.6h-9.4v-1.2h1.5c2,0,3.8-.7,5.3-2.2s2.2-3.2,2.3-5.3h.4,0ZM689.9,80.4v82.6h-7.7v-82.6h7.7ZM689.6,89.1v-8.6h9.4v1.2h-1.5c-2,0-3.8.7-5.3,2.2s-2.2,3.2-2.3,5.3h-.4,0ZM721.8,159.4v3.7h-32.2v-3.7h32.2ZM729,143.9l-6.8,19.1h-19.6l4.2-3.7c4.2,0,7.6-.6,10.2-1.9,2.6-1.3,4.8-3.1,6.4-5.5,1.7-2.4,3.1-5,4.4-8h1.2,0Z"/>
      <path d="M794.4,89.1h-.4c0-2-.8-3.8-2.3-5.3s-3.2-2.2-5.3-2.2h-1.5v-1.2h9.4v8.6h0ZM794.4,154.4v8.6h-9.4v-1.2h1.5c2,0,3.8-.7,5.3-2.2s2.2-3.2,2.3-5.3h.4,0ZM801.7,80.4v82.6h-7.7v-82.6h7.7ZM801.3,89.1v-8.6h9.4v1.2h-1.5c-2,0-3.8.7-5.3,2.2s-2.2,3.2-2.3,5.3h-.4,0ZM801.3,154.4h.4c0,2,.8,3.8,2.3,5.3s3.2,2.2,5.3,2.2h1.5v1.2h-9.4v-8.6h0Z"/>
      <path d="M882,154.4c-.6,1.6-.6,2.9-.2,4,.4,1.1,1,1.9,1.9,2.5s1.8.9,2.8.9h1.1v1.2h-23.7v-1.2h1.1c1.8,0,3.7-.6,5.6-1.7,1.9-1.1,3.5-3,4.8-5.7h6.7,0ZM907.3,78.8l1.1,8.3-29.6,75.7h-7.1l30.2-71.8c.9-2,1.6-3.7,2.2-5.1.6-1.4,1.1-2.8,1.5-4.1.4-1.3.6-2.3.6-3h1.1ZM924,130.8v3.5h-36.9v-3.5h36.9ZM907.3,78.8l34.9,83.6h-10l-27.3-72.4,2.4-11.2h0ZM929.3,154.4h9.7c1.2,2.7,2.8,4.6,4.7,5.7,2,1.1,3.9,1.7,5.7,1.7h.9v1.2h-26.6v-1.2h1.1c1.5,0,2.8-.6,4-1.9s1.3-3.1.5-5.5h0Z"/>
    </g>
    <g>
      <path fill="#F8FAFC" d="M84.6,147.2c-8.9,11.8-13.3,19.9-13.3,24.2s.9,2.6,2.6,2.6h0c2.2,0,8.2-7.1,17.9-21.3,9.7-14.2,17.5-27.5,23.3-39.8-11.5,11-21.7,22.4-30.5,34.2Z"/>
      <path fill="#F8FAFC" d="M109.4,155.8c-5.9,0-8.9.9-8.9,2.6s1,1.9,3,2.8c2,.9,4.3,1.3,6.9,1.3,6.8,0,13.4-2.1,19.7-6.3l-20.8-.5Z"/>
      <path fill="#D4AF37" d="M127,98.5c0,0,.1-.1.2-.2,0-.2-.1-.2-.2.2Z"/>
      <path fill="#F8FAFC" d="M121.1,8L8.5,120.6l112.5,112.5,112.5-112.5L121.1,8ZM159.4,99.7c-7.9,6.9-16,12.3-24.3,16.1h0s5-.4,5-.4c5.5,0,9.5,1,12.2,3.1s4,4.9,4,8.6-1.7,8.1-5,13.1-7.8,9.5-13.1,13.6h6.5c2.7,0,4.5-.1,5.6-.3,1.1-.2,1.7-.3,1.8-.3,1.1,0,1.6.6,1.6,1.7s-.8,1.8-2.3,1.8c-5.9,0-11.6,0-17-.2-8.6,5.5-17,8.2-25.3,8.2s-7-.7-9.3-2.2c-2.3-1.5-3.5-2.9-3.5-4.4s.6-2.6,1.9-3.5c1.3-.8,3.1-1.3,5.4-1.3,9,0,19,.2,30.1.6,4.6-3.8,8.3-8.1,11-13.1,2.8-5,4.1-9.4,4.1-13.4,0-6.4-3.4-9.5-10.3-9.5s-5.5.4-8.4,1.3c-2.9.8-4.6,1.4-5.2,1.8-.6.3-.9.5-1.1.5-.5,0-.7-.3-.7-1s1-1.4,3-2.4c8.8-4.2,17.3-9.8,25.6-16.9s12.5-12,12.5-15-1.1-2.1-3.2-2.1c-8.8,0-20.8,6.6-36,19.7-3.1,7.9-8.1,17.6-15.1,29.1-7,11.5-14.4,21.8-22,30.9-7.7,9.1-13.4,13.6-17.1,13.6s-3.5-1.2-3.5-3.6c0-5.5,5.2-15.1,15.5-29.1,10.3-14,22-26.8,35-38.5,2.3-5.6,3.5-9.7,3.5-12.2s-.6-4.6-1.8-6.1c-1.2-1.5-3-2.6-5.4-3.3-3.8-1-7.7-1.5-11.9-1.5s-7.4,0-9.6.3c-2.2.2-4.9.6-8.1,1.2-3.2.6-5.8,1.6-7.8,3-2,1.4-3,3.2-3,5.4s1.1,3.9,3.2,5c2.2,1.2,4.8,2,7.9,2.5,3.1.5,6.2,1,9.3,1.5s5.7,1.6,7.8,3.2c2.2,1.6,3.2,3.8,3.2,6.6s-.2,1.2-.5,1.2-.6-.1-.8-.3c-.2-.2-.5-.7-1-1.4-.7-1-1.7-1.8-3.1-2.3s-3.4-1.1-6.2-1.6c-2.8-.5-5.5-1-7.9-1.6-2.5-.6-5-1.3-7.5-2.2-2.5-.9-4.6-2.2-6.1-3.9-1.5-1.7-2.3-3.7-2.3-5.9s1-4.3,2.9-6c1.9-1.8,4.5-3.1,7.6-4.1,6.5-1.9,13.2-2.9,20.1-2.9,18.1,0,27.1,4.8,27.1,14.3s0,2.6,0,3.4c15.2-12.2,27.6-18.3,37.2-18.3s6.5,1.3,6.5,3.9c0,3.8-3.9,9.1-11.8,16Z"/>
          <path fill="#F8FAFC" d="M121.1,0L.5,120.6l120.5,120.5,120.5-120.5L121.1,0ZM3.5,120.5L121.1,2.9l117.6,117.6-117.6,117.6L3.5,120.5Z"/>
        </g>
      </svg>
);

// ==========================================
// --- COMPONENTE: CABECERA INTELIGENTE ---
// ==========================================
const Header = ({ setIsOpen, setActiveTab, data, globalSearch, setGlobalSearch, bellAlerts, setBellAlerts, markAsRead, cycleTheme, themeSetting, authData, switchEvent, isSuperAdminMode, eventName, eventPlan, urlInvitacion }) => {
  const [showResults, setShowResults] = useState(false);
  const [showBellMenu, setShowBellMenu] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showQuickAdd, setShowQuickAdd] = useState(false);
  const headerRef = useRef(null); 
  const [showEventSwitcher, setShowEventSwitcher] = useState(false);
  const [extraPassModal, setExtraPassModal] = useState(null);
  const [whatsappPromptModal, setWhatsappPromptModal] = useState(null);

  const handleAprobarPases = async () => {
    try {
      const guestRef = doc(db, "eventos", ID_DEL_EVENTO, "invitados", extraPassModal.id);
      const nuevosPases = extraPassModal.passes + extraPassModal.extraRequested;
      const subGuestsArray = extraPassModal.subGuests || [];
      const nuevosOriginales = extraPassModal.originalPasses ? extraPassModal.originalPasses + extraPassModal.extraRequested : nuevosPases;
      
      const faltantes = nuevosPases - subGuestsArray.length;
      const nuevosSubGuests = [...subGuestsArray];
      for (let i=0; i<faltantes; i++) {
          nuevosSubGuests.push({
              id: `usr_extra_${Date.now()}_${i}`,
              name: '', // Lo dejamos en blanco para obligar al usuario a rellenarlo
              isChild: false,
              entered: false
          });
      }

      await updateDoc(guestRef, { 
         passes: nuevosPases, 
         originalPasses: nuevosOriginales,
         extraRequested: 0,
         subGuests: nuevosSubGuests,
         status: 'pendiente' // Regresamos la invitación a modo edición
      });
      
      // Abrimos el nuevo modal que pregunta si queremos enviar el WhatsApp
      setWhatsappPromptModal({
        id: extraPassModal.id,
        name: extraPassModal.name,
        phone: extraPassModal.phone,
        nuevosPases: nuevosPases
      });
      setExtraPassModal(null);
    } catch(e) {
      console.error(e);
    }
  };

  const handleSendExtraPassWhatsApp = () => {
    if (!whatsappPromptModal) return;
    const rawPhone = whatsappPromptModal.phone || '';
    const phone = String(rawPhone).replace(/\D/g,'');
    
    if (phone && phone.length >= 10) {
        let linkPersonalizado = '';
        if (urlInvitacion) {
          const separator = urlInvitacion.includes('?') ? '&' : '?';
          linkPersonalizado = `${urlInvitacion}${separator}u=${whatsappPromptModal.id}`;
        } else {
          const baseDomain = window.location.hostname.includes('localhost') ? window.location.origin : 'https://baulia.com';
          linkPersonalizado = `${baseDomain}/${ID_DEL_EVENTO}?u=${whatsappPromptModal.id}`;
        }

        const msg = `¡Hola *${whatsappPromptModal.name}*! Hemos aprobado tus pases extra. Ahora tienes *${whatsappPromptModal.nuevosPases} lugares* reservados.\n\nHemos habilitado tu invitación nuevamente para que registres los nombres de tus nuevos acompañantes. Por favor entra aquí y completa tu registro:\n${linkPersonalizado}`;
        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank');
    } else {
        alert("⚠️ No se pudo abrir WhatsApp porque este invitado no tiene un número de teléfono válido registrado en la lista.");
    }
    setWhatsappPromptModal(null);
  };

  const handleRechazarPases = async () => {
    try {
      const guestRef = doc(db, "eventos", ID_DEL_EVENTO, "invitados", extraPassModal.id);
      await updateDoc(guestRef, { extraRequested: 0 });
      setExtraPassModal(null);
    } catch(e) {
      console.error(e);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setShowBellMenu(false);
        setShowProfileMenu(false);
        setShowResults(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleNavigate = (tab) => { 
    if(tab) setActiveTab(tab); 
    setShowResults(false); 
    setGlobalSearch(''); 
    setShowBellMenu(false); 
    setShowProfileMenu(false); 
    setShowQuickAdd(false);
  };

  const isOverdue = (dateStr, deuda) => { if(!dateStr || deuda <= 0) return false; return new Date(dateStr) < new Date(); };
  const overdueGastos = (data?.gastos || []).filter(g => isOverdue(g.fechaLimite, g.estimado - g.pagado));
  
  // 🔴 NOTIFICACIONES EXCLUSIVAS (Dueño vs Cliente)
  const dynamicAlerts = isSuperAdminMode ? [
     { id: 'admin_sys', title: 'Mando Central', message: 'Sistema operando al 100%.', tab: 'licencias', type: 'success', isDynamic: true, isRead: false }
  ] : [
    ...overdueGastos.map(g => ({ id: `g_${g.id}`, title: 'Pago Vencido', message: `Adeudo en: ${g.concepto}`, tab: 'presupuesto', type: 'danger', isDynamic: true, isRead: false })),
    ...(data?.guests || []).filter(g => g.extraRequested > 0).map(g => ({ id: `ext_${g.id}`, title: 'Pases Extra', message: `${g.name} solicita +${g.extraRequested} pases.`, tab: 'invitados', type: 'warning', isDynamic: true, isRead: false }))
  ];

  const allAlerts = [...dynamicAlerts, ...bellAlerts];
  const unreadCount = allAlerts.filter(a => !a.isRead).length;

  const guestsData = data?.guests || [];
  const countTotal = guestsData.reduce((sum, g) => sum + g.passes, 0);
  const countConfirmados = guestsData.filter(g => g.status === 'confirmado' || g.status === 'ingreso').reduce((sum, g) => sum + g.passes, 0);
  const countCancelados = guestsData.reduce((sum, g) => {
    const pasesOriginales = g.originalPasses || g.passes;
    const pasesConfirmados = g.subGuests?.length || 0;
    if (g.status === 'cancelado') return sum + pasesOriginales;
    if (g.status === 'confirmado' || g.status === 'ingreso') return sum + Math.max(0, pasesOriginales - pasesConfirmados);
    return sum;
  }, 0);
  const countIngresos = guestsData.reduce((sum, g) => sum + (g.entered || 0), 0);

  const searchResults = [];
  if(globalSearch.length > 1) {
     const term = globalSearch.toLowerCase();
     (data?.guests || []).forEach(g => { if(g.name.toLowerCase().includes(term)) searchResults.push({ id: g.id, text: g.name, type: 'Invitado', tab: 'invitados', icon: <Users size={14}/> }) });
     (data?.proveedores || []).forEach(p => { if(p.nombre.toLowerCase().includes(term) || p.servicio.toLowerCase().includes(term)) searchResults.push({ id: p.id, text: p.nombre, type: 'Proveedor', tab: 'proveedores', icon: <Store size={14}/> }) });
     (data?.gastos || []).forEach(g => { if(g.concepto.toLowerCase().includes(term)) searchResults.push({ id: g.id, text: g.concepto, type: 'Gasto', tab: 'presupuesto', icon: <Wallet size={14}/> }) });
  }

  const handleLogout = async () => {
    await signOut(auth);
    window.location.reload(); 
  };

  const handleContactStaff = () => {
    window.open('https://wa.me/525512345678?text=Hola,%20necesito%20ayuda%20con%20mi%20panel%20EventMaster', '_blank');
    setShowProfileMenu(false);
  };

  const getPlanColors = (planName) => {
    switch(planName?.toLowerCase()) {
        case 'diamante': return { text: 'text-indigo-600 dark:text-indigo-400', gradient: 'from-indigo-400 to-purple-600' };
        case 'oro': return { text: 'text-amber-600 dark:text-amber-500', gradient: 'from-amber-400 to-yellow-600' };
        case 'plata': return { text: 'text-slate-600 dark:text-slate-400', gradient: 'from-slate-400 to-slate-600' };
        default: return { text: 'text-emerald-600 dark:text-emerald-400', gradient: 'from-emerald-400 to-teal-600' };
    }
  };
  const pColors = getPlanColors(eventPlan);

  const getInitials = (name) => {
    if(!name) return 'VIP';
    const words = name.split(' ').filter(w => w.length > 0 && w.toLowerCase() !== 'y' && w.toLowerCase() !== 'e');
    if(words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };
  const initials = getInitials(eventName);

  return (
    <>
      <style>{`
        @keyframes spin-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .animate-spin-slow { animation: spin-slow 4s linear infinite; }
      `}</style>

      <header ref={headerRef} className="bg-[#000000]/90 backdrop-blur-2xl h-16 flex items-center justify-between px-4 sm:px-6 relative z-50 print:hidden border-b border-white/5 transition-colors duration-700">
        
        {/* 📱 HEADER MÓVIL (Limpio: Logo centrado grande, campanita sólida y botón +) */}
        <div className="xl:hidden w-full flex items-center justify-between">
          <button onClick={() => { setShowQuickAdd(true); setShowBellMenu(false); }} className="p-2 text-white hover:bg-white/10 rounded-full transition-colors active:scale-95" title="Acciones Rápidas">
            <Plus size={26} strokeWidth={1.8} />
          </button>
          
          <div className="flex items-center justify-center pointer-events-none">
            <BauliaLogoBlanco className="h-7 sm:h-8 w-auto" />
          </div>
          
          <div className="relative">
            <button onClick={() => {setShowBellMenu(!showBellMenu); setShowProfileMenu(false); setShowResults(false); setShowQuickAdd(false);}} className="relative p-2 text-white hover:bg-white/10 rounded-full transition-colors active:scale-95">
              <Bell size={24} strokeWidth={1.5} fill="currentColor" className="text-white" />
              {unreadCount > 0 && <span className="absolute top-1.5 right-1.5 w-3.5 h-3.5 bg-rose-500 rounded-full border-2 border-[#000000] text-[7px] font-bold text-white flex items-center justify-center">{unreadCount}</span>}
            </button>
            {showBellMenu && (
              <div className="absolute right-0 top-full mt-2 w-80 bg-[#0A0A0A] shadow-[0_20px_50px_rgba(0,0,0,0.9)] rounded-2xl border border-white/10 overflow-hidden z-[100] animate-in slide-in-from-top-2">
                <div className="p-4 border-b border-white/5 bg-white/5 flex justify-between items-center">
                  <h4 className="font-bold text-white text-sm">Centro de Atención</h4>
                  {bellAlerts.length > 0 && <button onClick={(e) => { e.stopPropagation(); setBellAlerts([]); }} className="text-[10px] text-slate-500 hover:text-white font-bold transition-colors">Limpiar</button>}
                </div>
                <div className="max-h-80 overflow-y-auto custom-scrollbar">
                  {allAlerts.length === 0 ? (
                    <div className="p-8 text-center text-slate-500"><CheckCircle size={32} className="mx-auto mb-2 opacity-30"/> ¡Todo al día!</div>
                  ) : (
                    allAlerts.map(alert => (
                      <div key={alert.id} className={`w-full text-left px-4 py-3 flex items-start group cursor-pointer border-b border-white/5 ${alert.isRead ? 'opacity-60 hover:bg-white/5' : 'bg-white/5 hover:bg-white/10'}`} onClick={(e) => { e.stopPropagation(); if (alert.id.startsWith('ext_')) { const guestId = alert.id.replace('ext_', ''); const guest = data?.guests?.find(g => g.id === guestId); if (guest) setExtraPassModal(guest); setShowBellMenu(false); return; } if(markAsRead && !alert.isDynamic) markAsRead(alert.id); if(alert.tab) { handleNavigate(alert.tab); } else { setShowBellMenu(false); } }}>
                        <div className={`mt-0.5 mr-3 ${alert.type === 'success' ? 'text-emerald-400' : alert.type === 'danger' ? 'text-rose-400' : alert.type === 'warning' ? 'text-amber-400' : 'text-sky-400'}`}>
                          {alert.type === 'success' ? <CheckCircle size={16}/> : alert.type === 'warning' || alert.type === 'danger' ? <AlertCircle size={16}/> : <Bell size={16}/>}
                        </div>
                        <div className="flex-1">
                          <p className={`text-sm leading-tight ${alert.isRead ? 'font-medium text-slate-400' : 'font-bold text-white'}`}>{alert.title}</p>
                          <p className={`text-[10px] mt-1 leading-snug ${alert.isRead ? 'text-slate-500' : 'text-slate-400 font-medium'}`}>{alert.message}</p>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 💻 HEADER ESCRITORIO (Se mantiene igual con colores Platino) */}
        <div className="hidden xl:flex items-center flex-1">
          <button onClick={() => setIsOpen(true)} className="xl:hidden text-white mr-4 transition-colors"><Menu size={24} /></button>
          <div className="relative w-full max-w-md hidden sm:block ml-10 lg:ml-20">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" size={18} />
            <input type="text" placeholder="Buscar en la bóveda..." value={globalSearch} onChange={(e) => {setGlobalSearch(e.target.value); setShowResults(true);}} className="w-full pl-10 pr-4 py-2 bg-[#111111] border border-white/10 rounded-full text-sm text-white placeholder-slate-500 focus:outline-none focus:border-white transition-all"/>
            {showResults && globalSearch.length > 1 && (
              <div className="absolute top-full left-0 mt-2 w-full bg-[#0A0A0A] shadow-2xl rounded-2xl border border-white/10 py-2 max-h-80 overflow-y-auto z-[100] animate-in fade-in transition-colors">
                {searchResults.length === 0 ? <div className="p-4 text-center text-sm text-slate-500">No se encontraron resultados para "{globalSearch}"</div> : searchResults.map(res => (
                    <button key={`${res.type}_${res.id}`} onClick={() => handleNavigate(res.tab)} className="w-full text-left px-4 py-3 hover:bg-white/5 flex items-center border-b border-white/5 last:border-0 transition-colors">
                      <div className="w-8 h-8 rounded-full bg-white/5 text-white flex items-center justify-center mr-3 border border-white/10">{res.icon}</div>
                      <div><p className="font-bold text-white text-sm">{res.text}</p><p className="text-[10px] text-slate-500 font-bold uppercase tracking-wider mt-0.5">{res.type}</p></div>
                    </button>
                  ))
                }
              </div>
            )}
          </div>
        </div>

        <div className="hidden xl:flex items-center space-x-2 sm:space-x-4">
          {!isSuperAdminMode && (
            <div className="hidden md:flex items-center bg-transparent border border-white/10 rounded-lg p-0.5 sm:p-1 mr-1 sm:mr-2 space-x-0.5 sm:space-x-1 transition-colors">
              <div className="flex items-center px-1.5 sm:px-2 py-1 rounded-md text-slate-300"><Users size={14} className="opacity-70" /><span className="text-[10px] sm:text-xs font-bold ml-1">{countTotal}</span></div>
              <div className="flex items-center px-1.5 sm:px-2 py-1 rounded-md text-emerald-400 bg-emerald-500/10 border border-emerald-500/20"><CheckCircle size={14} className="opacity-80" /><span className="text-[10px] sm:text-xs font-bold ml-1">{countConfirmados}</span></div>
              <div className="flex items-center px-1.5 sm:px-2 py-1 rounded-md text-rose-400 bg-rose-500/10 border border-rose-500/20"><X size={14} className="opacity-80" /><span className="text-[10px] sm:text-xs font-bold ml-1">{countCancelados}</span></div>
              <div className="flex items-center px-1.5 sm:px-2 py-1 rounded-md text-sky-400 bg-sky-500/10 border border-sky-500/20"><Scan size={14} className="opacity-80" /><span className="text-[10px] sm:text-xs font-bold ml-1">{countIngresos}</span></div>
            </div>
          )}

          <div className="relative">
            <button onClick={() => {setShowBellMenu(!showBellMenu); setShowProfileMenu(false); setShowResults(false);}} className="relative p-2 text-white transition-colors rounded-full hover:bg-white/10">
              <Bell size={20} strokeWidth={2} />
              {unreadCount > 0 && <span className="absolute top-1 right-1 w-4 h-4 bg-rose-500 border-2 border-[#000000] rounded-full text-[9px] font-bold text-white flex items-center justify-center animate-in zoom-in">{unreadCount}</span>}
            </button>
            {/* ... Resto de la campanita de escritorio ... */}
          </div>

          <div className="relative">
            <button onClick={() => {setShowProfileMenu(!showProfileMenu); setShowBellMenu(false); setShowResults(false);}} className="flex items-center space-x-2 sm:space-x-3 hover:bg-white/5 p-1 sm:p-1.5 rounded-xl transition-colors text-right border border-transparent hover:border-white/10 group">
              <div className="hidden sm:block pl-1 text-right">
                <p className="text-xs font-bold text-white leading-tight truncate max-w-[130px]" title={eventName}>{isSuperAdminMode ? 'Mando Central' : eventName}</p>
                <p className={`text-[9px] text-slate-400 font-bold tracking-widest uppercase transition-colors`}>{isSuperAdminMode ? 'SUPER ADMIN' : `Plan ${eventPlan}`}</p>
              </div>
              <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-full flex items-center justify-center text-black font-black shadow-md text-xs shrink-0 relative bg-white`}>
                 <span className="font-editorial text-sm tracking-widest">{isSuperAdminMode ? 'BM' : initials}</span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {/* 🟢 HOJA DE ACCIONES RÁPIDAS MÓVIL (BOTÓN + LIBERADO CON PORTAL) */}
      {showQuickAdd && createPortal(
        <div className="xl:hidden fixed inset-0 z-[99999] flex flex-col justify-end font-sans">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setShowQuickAdd(false)}></div>
          <div className="bg-[#0A0A0A] w-full rounded-t-[2rem] border-t border-white/10 relative z-10 p-6 pb-12 animate-in slide-in-from-bottom-full duration-300 shadow-[0_-20px_50px_rgba(0,0,0,0.9)]">
             <div className="w-12 h-1 bg-white/20 rounded-full mx-auto mb-6"></div>
             <div className="flex items-center justify-between mb-4 px-2">
               <h3 className="text-slate-400 font-bold uppercase tracking-widest text-[10px]">Acciones Rápidas</h3>
               <button onClick={() => setShowQuickAdd(false)} className="text-slate-500 hover:text-white"><X size={16}/></button>
             </div>
             <div className="space-y-3">
               <button onClick={() => handleNavigate('invitados')} className="w-full bg-[#111111] hover:bg-white/10 border border-white/10 rounded-2xl p-4 flex items-center text-white transition-colors active:scale-[0.99]">
                 <UserPlus size={18} className="text-white mr-3.5"/> <span className="font-bold text-sm">Ir a Lista de Invitados</span>
               </button>
               <button onClick={() => handleNavigate('presupuesto')} className="w-full bg-[#111111] hover:bg-white/10 border border-white/10 rounded-2xl p-4 flex items-center text-white transition-colors active:scale-[0.99]">
                 <Wallet size={18} className="text-emerald-400 mr-3.5"/> <span className="font-bold text-sm">Ir a Control Financiero</span>
               </button>
               <button onClick={() => handleNavigate('tareas')} className="w-full bg-[#111111] hover:bg-white/10 border border-white/10 rounded-2xl p-4 flex items-center text-white transition-colors active:scale-[0.99]">
                 <CheckSquare size={18} className="text-sky-400 mr-3.5"/> <span className="font-bold text-sm">Ir a Checklist de Tareas</span>
               </button>
               <button onClick={() => handleNavigate('proveedores')} className="w-full bg-[#111111] hover:bg-white/10 border border-white/10 rounded-2xl p-4 flex items-center text-white transition-colors active:scale-[0.99]">
                 <Store size={18} className="text-amber-400 mr-3.5"/> <span className="font-bold text-sm">Ir a Directorio de Proveedores</span>
               </button>
             </div>
          </div>
        </div>,
        document.body
      )}

      {extraPassModal && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl p-6 text-center border border-transparent dark:border-white/10">
            <div className="w-16 h-16 bg-amber-100 dark:bg-amber-500/20 text-amber-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
              <Users size={32} />
            </div>
            <h3 className="text-xl font-black text-slate-800 dark:text-white mb-2 font-editorial">Solicitud de Pases Extra</h3>
            <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
              La familia <b>{extraPassModal.name}</b> está solicitando <b>+{extraPassModal.extraRequested}</b> pases adicionales.<br/><br/>Si apruebas, su invitación se actualizará a modo pendiente y podrás avisarle por WhatsApp al instante.
            </p>
            <div className="flex space-x-3 mb-4">
              <button onClick={handleRechazarPases} className="flex-1 py-3.5 bg-slate-100 dark:bg-[#111] text-slate-600 dark:text-slate-300 border border-transparent dark:border-white/10 rounded-xl font-bold hover:bg-slate-200 dark:hover:bg-white/5 transition-colors text-[10px] uppercase tracking-widest">
                Rechazar
              </button>
              <button onClick={handleAprobarPases} className="flex-1 py-3.5 bg-amber-500 text-slate-900 rounded-xl font-black shadow-lg hover:bg-amber-400 transition-transform active:scale-95 text-[10px] uppercase tracking-widest">
                Aprobar Pases
              </button>
            </div>
            <button onClick={() => setExtraPassModal(null)} className="text-[10px] font-bold text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 uppercase tracking-widest transition-colors py-2">
              Atender después (Desde la campanita)
            </button>
          </div>
        </div>
      )}

      {whatsappPromptModal && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-sm overflow-hidden shadow-2xl p-6 text-center border border-transparent dark:border-white/10">
            <div className="w-16 h-16 bg-emerald-100 dark:bg-emerald-500/20 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner">
              <MessageCircle size={32} />
            </div>
            <h3 className="text-xl font-black text-slate-800 dark:text-white mb-2 font-editorial">¡Pases Aprobados!</h3>
            <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
              Se ha habilitado la invitación para <b>{whatsappPromptModal.name}</b>.<br/><br/>¿Deseas enviarle un mensaje por WhatsApp ahora mismo para avisarle que registre a sus acompañantes?
            </p>
            <div className="flex space-x-3">
              <button onClick={() => setWhatsappPromptModal(null)} className="flex-1 py-3.5 bg-slate-100 dark:bg-[#111] text-slate-600 dark:text-slate-300 border border-transparent dark:border-white/10 rounded-xl font-bold hover:bg-slate-200 dark:hover:bg-white/5 transition-colors text-[10px] uppercase tracking-widest">
                Cerrar
              </button>
              <button onClick={handleSendExtraPassWhatsApp} className="flex-1 py-3.5 bg-emerald-500 text-white rounded-xl font-black shadow-lg hover:bg-emerald-600 transition-transform active:scale-95 text-[10px] uppercase tracking-widest flex items-center justify-center">
                Notificar por WhatsApp
              </button>
            </div>
          </div>
        </div>
      )}

      {showEventSwitcher && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-3xl w-full max-w-md shadow-2xl flex flex-col max-h-[85vh] border border-transparent dark:border-white/10 animate-in zoom-in-95 transition-colors">
            <div className="p-6 pb-4 border-b border-slate-100 dark:border-white/5 shrink-0">
               <h3 className="text-xl font-black text-slate-800 dark:text-white mb-1 font-editorial">Tus Proyectos</h3>
               <p className="text-xs text-slate-500">Selecciona el evento que deseas administrar:</p>
            </div>
            <div className="p-6 overflow-y-auto custom-scrollbar flex-1">
              <div className="space-y-3">
                {authData.availableEvents.map(ev => {
                  const isActive = ev.eventId === authData.eventId;
                  return (
                    <button key={ev.eventId} onClick={() => switchEvent(ev.eventId)} className={`w-full text-left p-4 rounded-2xl border transition-all flex items-center justify-center ${isActive ? 'bg-amber-50 dark:bg-amber-500/10 border-amber-200 dark:border-amber-500/30' : 'bg-slate-50 dark:bg-[#111] border-slate-200 dark:border-white/10 hover:border-amber-400'}`}>
                      <div className="flex-1 min-w-0 pr-3">
                        <p className={`font-bold text-base truncate ${isActive ? 'text-amber-700 dark:text-amber-500' : 'text-slate-800 dark:text-white'}`}>{ev.nombres}</p>
                        <p className="text-[10px] uppercase tracking-widest text-slate-400 mt-1 font-bold truncate">{ev.tipoEvento} • Plan {ev.plan}</p>
                      </div>
                      {isActive && <CheckCircle size={20} className="text-amber-500 shrink-0"/>}
                    </button>
                  )
                })}
              </div>
            </div>
            <div className="p-6 pt-4 border-t border-slate-100 dark:border-white/5 shrink-0">
               <button onClick={() => setShowEventSwitcher(false)} className="w-full py-3.5 bg-slate-100 dark:bg-white/5 text-slate-600 dark:text-white rounded-xl font-bold hover:bg-slate-200 dark:hover:bg-white/10 transition-colors uppercase tracking-widest text-[10px]">Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// ==========================================
// --- COMPONENTE: ATELIER PHYGITAL A PANTALLA COMPLETA (MODO INDEPENDIENTE: CABALLETE O PULSERA) ---
// ==========================================
const AtelierPhygitalModal = ({
  isOpen,
  onClose,
  mode = 'social_wall', // 'social_wall' | 'pulseras'
  eventoData = {},
  initialConfig = {},
  hashtag = '#MiEvento',
  qrUrl = '',
  isLocked = false,
  status = 'pendiente',
  onSaveDesign,
  onOpenShippingModal,
  addNotification
}) => {
  const isSocialWall = mode === 'social_wall';
  const logoInputRef = useRef(null);
  const bgInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const cloudName = "duy0mcqsh";
  const uploadPreset = "ml_default";

  // Catálogo de Papeles para Social Wall
  const PAPER_FINISHES = [
    { id: 'blanco_galeria', name: 'Blanco Galería', desc: 'Opalina / Couché • Permite heredar color de invitación', bg: '#FFFFFF', text: '#0F172A', accent: '#B45309', sub: '#64748B' },
    { id: 'marfil_algodon', name: 'Marfil Algodón', desc: 'Cálido Editorial • Tinta carbón y oro viejo', bg: '#FDFBF7', text: '#1C1917', accent: '#9A6F1A', sub: '#78716C' },
    { id: 'obsidiana', name: 'Negro Obsidiana', desc: 'Gala Nocturna • Textos en blanco y dorado imperial', bg: '#0B0B0E', text: '#FFFFFF', accent: '#F59E0B', sub: '#94A3B8' },
    { id: 'champagne', name: 'Champagne Perlado', desc: 'Satinado Suave • Tonos arena y dorado', bg: '#F7F1E5', text: '#27272A', accent: '#A16207', sub: '#71717A' }
  ];

  // Catálogo de Pulseras Tyvek para Black Label
  const WRISTBAND_COLORS = [
    { id: 'blanca_atelier', name: 'Blanca Alta Costura', desc: 'Permite heredar colores de la invitación o tinta negra', bg: '#FFFFFF', ink: '#000000', border: '#E2E8F0' },
    { id: 'negra_obsidiana', name: 'Negra Obsidiana VIP', desc: 'Impresión de alto contraste en Dorado, Plata o Blanco', bg: '#0F0F12', ink: '#D4AF37', border: '#27272A' },
    { id: 'oro_imperial', name: 'Oro Imperial', desc: 'Acabado metálico con tinta negra y Micro-QR', bg: '#D4AF37', ink: '#000000', border: '#B45309' },
    { id: 'plata_platino', name: 'Plata Platino', desc: 'Acabado frío con tinta negra de alta densidad', bg: '#CBD5E1', ink: '#000000', border: '#94A3B8' },
    { id: 'rose_gold', name: 'Rose Gold', desc: 'Tono cobrizo suave con tinta negra profunda', bg: '#F4C2C2', ink: '#000000', border: '#FDA4AF' }
  ];

  const FONT_STYLES = [
    { id: 'editorial', name: 'Editorial Clásica', family: "'Cormorant Garamond', serif" },
    { id: 'caligrafia', name: 'Caligrafía Imperial', family: "'Great Vibes', cursive" },
    { id: 'alta_moda', name: 'Alta Moda Romana', family: "'Cinzel', serif" },
    { id: 'minimal', name: 'Minimalista Moderna', family: "'Montserrat', sans-serif" }
  ];

  const [draft, setDraft] = useState({
    heredarInvitacion: false,
    preTitle: initialConfig.preTitle || (eventoData.tipoEvento ? String(eventoData.tipoEvento).replace(/_/g, ' ').toUpperCase() : 'NUESTRA BODA'),
    eventName: initialConfig.eventName || eventoData.nombres || 'Sofía & Alejandro',
    subtitle: initialConfig.subtitle || 'Escanea, sube tus fotos y cumple los retos en pantalla',
    logoUrl: initialConfig.logoUrl || initialConfig.logoBase64 || '',
    bgImageUrl: initialConfig.bgImageUrl || '',
    cantidadTarjetas: Number(initialConfig.cantidadTarjetas) || 15,
    papelId: initialConfig.papelId || 'blanco_galeria',
    pulseraColorId: initialConfig.pulseraColorId || 'blanca_atelier',
    pulseraInkColor: initialConfig.pulseraInkColor || '#000000',
    fontId: initialConfig.fontId || 'editorial',
    accentColor: initialConfig.accentColor || '#B45309'
  });

  useEffect(() => {
    if (isOpen) {
      setDraft(prev => ({
        ...prev,
        ...initialConfig,
        preTitle: initialConfig.preTitle || (eventoData.tipoEvento ? String(eventoData.tipoEvento).replace(/_/g, ' ').toUpperCase() : 'NUESTRA BODA'),
        eventName: initialConfig.eventName || eventoData.nombres || 'Sofía & Alejandro',
        logoUrl: initialConfig.logoUrl || initialConfig.logoBase64 || prev.logoUrl || ''
      }));
    }
  }, [isOpen, initialConfig, eventoData]);

  if (!isOpen) return null;

  // Activar/Desactivar Herencia Inteligente desde la Invitación Digital
  const handleToggleInheritance = () => {
    if (isLocked) return;
    const nextState = !draft.heredarInvitacion;
    if (nextState) {
      const inheritedPhoto =
        eventoData.portadaUrl ||
        eventoData.fotoPortada ||
        eventoData.heroImage ||
        eventoData.imagenPortada ||
        eventoData.configuracion?.portadaUrl ||
        draft.bgImageUrl ||
        '';
      const inheritedColor =
        eventoData.colorPrincipal ||
        eventoData.themeColor ||
        eventoData.colorTema ||
        eventoData.configuracion?.colorPrincipal ||
        '#B45309';
      const inheritedLogo =
        eventoData.logoUrl ||
        eventoData.monogramaUrl ||
        eventoData.pulserasConfig?.logoBase64 ||
        draft.logoUrl ||
        '';

      setDraft(prev => ({
        ...prev,
        heredarInvitacion: true,
        preTitle: eventoData.tipoEvento ? String(eventoData.tipoEvento).replace(/_/g, ' ').toUpperCase() : prev.preTitle,
        eventName: eventoData.nombres || prev.eventName,
        bgImageUrl: inheritedPhoto,
        logoUrl: inheritedLogo,
        accentColor: inheritedColor,
        papelId: 'blanco_galeria', // En papel blanco luce al 100% la herencia de la invitación
        pulseraColorId: 'blanca_atelier'
      }));
      if (addNotification) {
        addNotification('✨ Diseño Sincronizado', 'Se heredaron los datos, estética y colores de tu invitación.', 'success');
      }
    } else {
      setDraft(prev => ({ ...prev, heredarInvitacion: false }));
    }
  };

  const handleUploadAsset = async (e, field) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploading(true);
    if (addNotification) addNotification('Subiendo archivo...', 'Optimizando resolución para imprenta.', 'info');
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", uploadPreset);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, { method: "POST", body: formData });
      const data = await res.json();
      if (data.secure_url) {
        setDraft(prev => ({ ...prev, [field]: data.secure_url }));
        if (addNotification) addNotification('¡Imagen Lista!', 'Se actualizó el lienzo en vivo.', 'success');
      }
    } catch (err) {
      if (addNotification) addNotification('Error', 'No se pudo subir la imagen.', 'error');
    }
    setIsUploading(false);
    e.target.value = null;
  };

  const handleSave = async () => {
    setIsSaving(true);
    await onSaveDesign(draft);
    setIsSaving(false);
  };

  const activePaper = PAPER_FINISHES.find(p => p.id === draft.papelId) || PAPER_FINISHES[0];
  const activeWristband = WRISTBAND_COLORS.find(w => w.id === draft.pulseraColorId) || WRISTBAND_COLORS[0];
  const activeFont = FONT_STYLES.find(f => f.id === draft.fontId) || FONT_STYLES[0];
  const effectiveAccent = (draft.heredarInvitacion && draft.papelId === 'blanco_galeria') ? draft.accentColor : activePaper.accent;

  return createPortal(
    <div className="fixed inset-0 z-[99999] bg-[#1C1917]/95 backdrop-blur-2xl flex flex-col animate-in fade-in duration-300 text-white select-none">
      {/* Importación de fuentes de Alta Costura para la vista previa */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=Great+Vibes&family=Montserrat:wght@400;600;700;900&display=swap');
      `}</style>

      {/* BARRA SUPERIOR ESTILO APPLE STUDIO */}
      <div className="h-16 px-6 border-b border-[#D4AF37]/20 flex items-center justify-between bg-[#141210] shrink-0">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37]">
            <Sparkles size={18} />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37]">Baulia Atelier Phygital</span>
              <span className="text-[8px] font-black uppercase px-2 py-0.5 rounded bg-white/10 text-slate-300">
                {isSocialWall ? 'Caballetes de Mesa • Social Wall' : 'Brazaletes Tyvek • Black Label'}
              </span>
            </div>
            <h2 className="text-sm font-bold text-white leading-tight">
              {isSocialWall ? 'Estudio de Diseño para Tarjetas de Mesa Plegables' : 'Estudio de Diseño para Pulseras de Control VIP'}
            </h2>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {isLocked && (
            <span className="px-3.5 py-1.5 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] text-[10px] font-black uppercase tracking-widest flex items-center gap-1.5 shadow-[0_0_15px_rgba(212,175,55,0.15)]">
              <Lock size={12}/> {status === 'impreso' ? 'PRODUCIDO Y DESPACHADO' : 'ORDEN EN TALLER'}
            </span>
          )}
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-full bg-white/5 hover:bg-[#D4AF37]/20 border border-white/10 hover:border-[#D4AF37]/40 text-xs font-bold text-white flex items-center gap-1.5 transition-colors"
          >
            <X size={15}/> Cerrar Estudio
          </button>
        </div>
      </div>

      {/* CUERPO PRINCIPAL: VISOR INTERACTIVO + CONTROLES */}
      <div className="flex-1 overflow-y-auto lg:overflow-hidden grid grid-cols-1 lg:grid-cols-12">
        
        {/* LIENZO CENTRAL (VISTA PREVIA HIPERREALISTA) */}
        <div className="lg:col-span-7 bg-[radial-gradient(circle_at_center,#292421_0%,#141210_75%)] p-6 sm:p-10 flex flex-col items-center justify-center relative min-h-[460px] lg:h-full overflow-hidden">
          <div className="mb-5 flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1C1917]/80 border border-[#D4AF37]/30 backdrop-blur-md">
            <Eye size={13} className="text-[#D4AF37]"/>
            <span className="text-[10px] font-black uppercase tracking-widest text-slate-200">
              {isSocialWall
                ? `Vista Previa Real • Inserto para Portarretrato de Vidrio (2 por Hoja Carta • ${activePaper.name})`
                : `Vista Previa Real • Pulsera Tyvek 25.4 x 2.54 cm • QR 2x2 cm (${activeWristband.name})`}
            </span>
          </div>

          {isSocialWall ? (
            /* MOCKUP 3D DEL CABALLETE DE MESA (SOCIAL WALL) */
            <div className="relative group">
              {/* Sombra de base sobre la mesa */}
              <div className="absolute -bottom-5 inset-x-6 h-8 bg-black/80 blur-xl rounded-full"></div>

              {/* Tarjeta Caballete */}
              <div
                style={{ backgroundColor: activePaper.bg }}
                className="w-[270px] h-[375px] rounded-2xl border border-amber-500/40 shadow-[0_25px_70px_rgba(0,0,0,0.75)] overflow-hidden relative flex flex-col items-center text-center transition-all duration-500"
              >
                {/* Guías sutiles de corte en las esquinas (simulando imprenta) */}
                <div className="absolute top-2 left-2 w-2.5 h-2.5 border-t border-l border-amber-500/40 z-30 pointer-events-none"></div>
                <div className="absolute top-2 right-2 w-2.5 h-2.5 border-t border-r border-amber-500/40 z-30 pointer-events-none"></div>
                <div className="absolute bottom-2 left-2 w-2.5 h-2.5 border-b border-l border-amber-500/40 z-30 pointer-events-none"></div>
                <div className="absolute bottom-2 right-2 w-2.5 h-2.5 border-b border-r border-amber-500/40 z-30 pointer-events-none"></div>

                {/* Capa de Foto Superior con Degradado Inteligente que termina antes del QR */}
                <div className="absolute top-0 inset-x-0 h-[54%] overflow-hidden">
                  {draft.bgImageUrl ? (
                    <img src={draft.bgImageUrl} alt="Fondo" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div
                      className="w-full h-full"
                      style={{
                        background: `radial-gradient(circle at top, ${effectiveAccent}33 0%, transparent 75%)`
                      }}
                    ></div>
                  )}
                  {/* Degradado automático que funde la foto con el color exacto del papel antes del QR */}
                  <div
                    className="absolute inset-0"
                    style={{
                      background: `linear-gradient(to bottom, rgba(0,0,0,0.0) 0%, ${activePaper.bg}99 58%, ${activePaper.bg} 93%, ${activePaper.bg} 100%)`
                    }}
                  ></div>
                </div>

                {/* Contenido Editorial de la Tarjeta */}
                <div className="relative z-10 flex flex-col items-center justify-end h-full w-full px-5 pb-4 pt-6">
                  {draft.logoUrl && (
                    <img src={draft.logoUrl} alt="Logo" className="h-10 object-contain mb-1.5 drop-shadow-sm" />
                  )}

                  <span
                    style={{ color: effectiveAccent }}
                    className="text-[8px] font-black uppercase tracking-[0.28em] mb-1"
                  >
                    {draft.preTitle || 'SOCIAL WALL EN VIVO'}
                  </span>

                  <h4
                    style={{ fontFamily: activeFont.family, color: activePaper.text }}
                    className={`${draft.fontId === 'caligrafia' ? 'text-3xl py-0.5' : 'text-2xl font-bold'} leading-tight mb-1 line-clamp-1`}
                  >
                    {draft.eventName || 'Nombre del Evento'}
                  </h4>

                  <p
                    style={{ color: activePaper.sub }}
                    className="text-[8.5px] font-semibold leading-snug max-w-[200px] mb-3 line-clamp-2"
                  >
                    {draft.subtitle}
                  </p>

                  {/* Contenedor QR (Siempre con fondo blanco óptico para lectura instantánea de cámara) */}
                  <div className="bg-white p-2.5 rounded-2xl border border-slate-200/80 shadow-md mb-2 relative">
                    <img src={qrUrl} alt="QR Mesa" className="w-32 h-32 object-contain" />
                  </div>

                  <span
                    style={{ color: effectiveAccent }}
                    className="text-[8.5px] font-black uppercase tracking-[0.2em]"
                  >
                    {hashtag || '#MiEvento'} • MESA 1
                  </span>
                  <span
                    style={{ color: activePaper.sub }}
                    className="text-[6px] font-bold uppercase tracking-[0.25em] mt-1 opacity-75"
                  >
                    by BAULIA.COM
                  </span>
                </div>
              </div>
            </div>
          ) : (
            /* MOCKUP DE LA PULSERA TYVEK (BLACK LABEL) */
            <div className="w-full max-w-2xl px-2">
              <div
                style={{
                  backgroundColor: activeWristband.bg,
                  color: draft.pulseraColorId === 'negra_obsidiana' ? draft.pulseraInkColor : activeWristband.ink,
                  borderColor: activeWristband.border
                }}
                className="w-full h-28 rounded-2xl border-2 shadow-[0_20px_60px_rgba(0,0,0,0.8)] flex items-center overflow-hidden relative transition-all duration-300"
              >
                <div className="w-14 h-full border-r border-dashed border-current/25 flex items-center justify-center bg-black/5 shrink-0">
                  <span className="-rotate-90 text-[7px] font-black tracking-widest uppercase opacity-50 whitespace-nowrap">PEGAMENTO</span>
                </div>
                <div className="w-12 h-full border-r border-current/10 flex items-center justify-center shrink-0">
                  <span className="-rotate-90 text-[7px] font-bold tracking-widest uppercase opacity-60 whitespace-nowrap">by BAULIA</span>
                </div>
                <div className="flex-1 h-full flex flex-col items-center justify-center text-center px-4 border-r border-current/10">
                  <span className="text-[7px] font-black uppercase tracking-[0.25em] opacity-80 mb-0.5">{draft.preTitle}</span>
                  {draft.logoUrl ? (
                    <img src={draft.logoUrl} alt="Logo" className="h-9 object-contain my-0.5" />
                  ) : (
                    <span style={{ fontFamily: activeFont.family }} className="text-2xl leading-none my-0.5">{draft.eventName}</span>
                  )}
                  <span className="text-[7px] font-bold tracking-widest uppercase opacity-75">
                    {eventoData.fecha ? new Date(eventoData.fecha).toLocaleDateString('es-MX', { timeZone: 'UTC' }) : '24/10/2026'}
                  </span>
                </div>
                <div className="w-40 h-full flex flex-col justify-center px-4 border-r border-current/10 shrink-0">
                  <span className="text-[11px] font-black uppercase tracking-wider truncate">INVITADO VIP</span>
                  <span className="text-[8px] font-bold uppercase opacity-75">PASE ADULTO</span>
                </div>
                <div className="w-24 h-full flex items-center justify-center bg-white p-2 shrink-0">
                  <img src={qrUrl} alt="Micro QR" className="w-16 h-16 object-contain" />
                </div>
              </div>
            </div>
          )}

          <p className="text-[11px] text-slate-400 mt-6 text-center max-w-md">
            {isSocialWall
              ? '✨ Cada hoja tamaño Carta imprime 2 caballetes con guías de corte y pestaña inferior para doblar en triángulo y parar en las mesas.'
              : '✨ Impresión vectorial de alta precisión con Micro-QR de seguridad para lectura rápida en puerta.'}
          </p>
        </div>

        {/* BARRA LATERAL DERECHA: CONTROLES DE PERSONALIZACIÓN */}
        <div className="lg:col-span-5 bg-[#1C1917] border-l border-[#D4AF37]/20 p-6 sm:p-8 overflow-y-auto custom-scrollbar space-y-6">
          
          {/* 1. INTERRUPTOR DE HERENCIA DE DISEÑO DE LA INVITACIÓN (DESACTIVADO TEMPORALMENTE) */}

          {/* 2. SELECTOR DE COLOR DE PAPEL O COLOR DE PULSERA */}
          {isSocialWall ? (
            <div>
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-400 mb-2.5">
                1. Color y Acabado del Papel del Caballete
              </label>
              <div className="grid grid-cols-2 gap-2.5">
                {PAPER_FINISHES.map(paper => (
                  <button
                    key={paper.id}
                    type="button"
                    disabled={isLocked}
                    onClick={() => setDraft({ ...draft, papelId: paper.id })}
                    className={`p-3 rounded-xl border text-left transition-all flex items-start gap-2.5 ${
                      draft.papelId === paper.id
                        ? 'bg-[#D4AF37]/15 border-[#D4AF37] shadow-md'
                        : 'bg-white/5 border-white/10 hover:border-[#D4AF37]/40'
                    }`}
                  >
                    <span
                      style={{ backgroundColor: paper.bg }}
                      className="w-5 h-5 rounded-full border border-white/30 shrink-0 mt-0.5 shadow-inner"
                    ></span>
                    <div className="min-w-0">
                      <p className="text-xs font-bold text-white truncate">{paper.name}</p>
                      <p className="text-[9px] text-slate-400 leading-tight mt-0.5 line-clamp-2">{paper.desc}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div>
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-400 mb-2.5">
                1. Color del Brazalete Tyvek
              </label>
              <div className="grid grid-cols-2 gap-2.5">
                {WRISTBAND_COLORS.map(wb => (
                  <button
                    key={wb.id}
                    type="button"
                    disabled={isLocked}
                    onClick={() => setDraft({ ...draft, pulseraColorId: wb.id })}
                    className={`p-3 rounded-xl border text-left transition-all flex items-start gap-2.5 ${
                      draft.pulseraColorId === wb.id
                        ? 'bg-[#D4AF37]/15 border-[#D4AF37] shadow-md'
                        : 'bg-white/5 border-white/10 hover:border-[#D4AF37]/40'
                    }`}
                  >
                    <span
                      style={{ backgroundColor: wb.bg }}
                      className="w-5 h-5 rounded-full border border-white/30 shrink-0 mt-0.5"
                    ></span>
                    <div className="min-w-0">
                      <p className="text-xs font-bold text-white truncate">{wb.name}</p>
                      <p className="text-[9px] text-slate-400 leading-tight mt-0.5 line-clamp-2">{wb.desc}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* 3. ESTILO TIPOGRÁFICO */}
          <div>
            <label className="block text-[10px] font-black uppercase tracking-widest text-slate-400 mb-2">
              2. Tipografía del Nombre Principal
            </label>
            <div className="grid grid-cols-2 gap-2">
              {FONT_STYLES.map(font => (
                <button
                  key={font.id}
                  type="button"
                  disabled={isLocked}
                  onClick={() => setDraft({ ...draft, fontId: font.id })}
                  className={`px-3 py-2.5 rounded-xl border text-left transition-all ${
                    draft.fontId === font.id
                      ? 'bg-[#D4AF37]/15 border-[#D4AF37] text-[#D4AF37]'
                      : 'bg-white/5 border-white/10 text-slate-300 hover:border-[#D4AF37]/40'
                  }`}
                >
                  <span className="text-[9px] uppercase tracking-wider block opacity-60">{font.name}</span>
                  <span style={{ fontFamily: font.family }} className="text-base block truncate mt-0.5">
                    {draft.eventName || 'Sofía & Alejandro'}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* 4. SUBIDA DE LOGO E IMAGEN DE FONDO */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="p-3.5 rounded-2xl border border-dashed border-[#D4AF37]/30 bg-white/5 text-center">
              <input type="file" accept="image/*" ref={logoInputRef} onChange={e => handleUploadAsset(e, 'logoUrl')} className="hidden" disabled={isLocked} />
              <p className="text-[9px] font-black uppercase tracking-widest text-slate-400 mb-2">Logo / Monograma</p>
              {draft.logoUrl ? (
                <div className="flex flex-col items-center gap-1.5">
                  <img src={draft.logoUrl} alt="Logo" className="h-10 object-contain" />
                  {!isLocked && (
                    <div className="flex gap-3 text-[9px] font-bold">
                      <button type="button" onClick={() => logoInputRef.current.click()} className="text-[#D4AF37] underline">Cambiar</button>
                      <button type="button" onClick={() => setDraft({ ...draft, logoUrl: '' })} className="text-rose-400 underline">Quitar</button>
                    </div>
                  )}
                </div>
              ) : (
                <button type="button" disabled={isLocked || isUploading} onClick={() => logoInputRef.current.click()} className="w-full py-2 flex flex-col items-center text-slate-400 hover:text-[#D4AF37] transition-colors">
                  <ImageIcon size={20} className="mb-1"/>
                  <span className="text-[10px] font-bold">Subir Logo PNG</span>
                </button>
              )}
            </div>

            {isSocialWall && (
              <div className="p-3.5 rounded-2xl border border-dashed border-[#D4AF37]/30 bg-white/5 text-center">
                <input type="file" accept="image/*" ref={bgInputRef} onChange={e => handleUploadAsset(e, 'bgImageUrl')} className="hidden" disabled={isLocked} />
                <p className="text-[9px] font-black uppercase tracking-widest text-slate-400 mb-2">Foto con Degradado</p>
                {draft.bgImageUrl ? (
                  <div className="flex flex-col items-center gap-1.5">
                    <img src={draft.bgImageUrl} alt="Fondo" className="h-10 w-16 object-cover rounded border border-white/15" />
                    {!isLocked && (
                      <div className="flex gap-3 text-[9px] font-bold">
                        <button type="button" onClick={() => bgInputRef.current.click()} className="text-[#D4AF37] underline">Cambiar</button>
                        <button type="button" onClick={() => setDraft({ ...draft, bgImageUrl: '' })} className="text-rose-400 underline">Quitar</button>
                      </div>
                    )}
                  </div>
                ) : (
                  <button type="button" disabled={isLocked || isUploading} onClick={() => bgInputRef.current.click()} className="w-full py-2 flex flex-col items-center text-slate-400 hover:text-[#D4AF37] transition-colors">
                    <Camera size={20} className="mb-1"/>
                    <span className="text-[10px] font-bold">Subir Foto de Fondo</span>
                  </button>
                )}
              </div>
            )}
          </div>

          {/* 5. TEXTOS Y CANTIDAD DE MESAS */}
          <div className="space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1">Tipo de Evento (Pre-título)</label>
                <input
                  type="text"
                  disabled={isLocked}
                  value={draft.preTitle}
                  onChange={e => setDraft({ ...draft, preTitle: e.target.value })}
                  className="w-full p-3 rounded-xl bg-[#141210] border border-white/10 text-xs font-bold text-white outline-none focus:border-[#D4AF37]"
                />
              </div>
              <div>
                <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1">Nombre del Evento</label>
                <input
                  type="text"
                  disabled={isLocked}
                  value={draft.eventName}
                  onChange={e => setDraft({ ...draft, eventName: e.target.value })}
                  className="w-full p-3 rounded-xl bg-[#141210] border border-white/10 text-xs font-bold text-white outline-none focus:border-[#D4AF37]"
                />
              </div>
            </div>

            {isSocialWall && (
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="sm:col-span-2">
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1">Instrucción antes del QR</label>
                  <input
                    type="text"
                    disabled={isLocked}
                    value={draft.subtitle}
                    onChange={e => setDraft({ ...draft, subtitle: e.target.value })}
                    className="w-full p-3 rounded-xl bg-[#141210] border border-white/10 text-xs text-white outline-none focus:border-[#D4AF37]"
                  />
                </div>
                <div>
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1">Cant. de Mesas</label>
                  <input
                    type="number"
                    min="1"
                    max="150"
                    disabled={isLocked}
                    value={draft.cantidadTarjetas}
                    onChange={e => setDraft({ ...draft, cantidadTarjetas: Math.max(1, parseInt(e.target.value) || 1) })}
                    className="w-full p-3 rounded-xl bg-[#141210] border border-white/10 text-xs font-black text-[#D4AF37] text-center outline-none focus:border-[#D4AF37]"
                  />
                </div>
              </div>
            )}
          </div>

          {/* 6. BOTONES DE GUARDADO Y ENVÍO A TALLER */}
          {!isLocked ? (
            <div className="pt-3 border-t border-[#D4AF37]/20 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                disabled={isSaving}
                onClick={handleSave}
                className="flex-1 py-4 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white font-black text-[10px] uppercase tracking-widest transition-colors"
              >
                {isSaving ? 'Guardando...' : 'Guardar Diseño'}
              </button>
              <button
                type="button"
                onClick={async () => {
                  await onSaveDesign(draft);
                  onOpenShippingModal(draft);
                }}
                className="flex-1 py-4 rounded-xl bg-[#D4AF37] hover:bg-[#c5a028] text-[#1C1917] font-black text-[10px] uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] transition-all flex items-center justify-center gap-2"
              >
                <Send size={14}/> Enviar a Taller Baulia
              </button>
            </div>
          ) : (
            <div className="p-4 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-bold text-center shadow-[0_0_20px_rgba(212,175,55,0.1)]">
              ✓ Este diseño ya se encuentra en producción dentro del Taller Baulia.
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

// ==========================================
// --- COMPONENTE: GALERÍA EN VIVO + TALLER DE TARJETAS DE MESA (SOCIAL WALL) ---
// ==========================================
const GaleriaView = ({ photos, addNotification, eventoId }) => {
  const [showQR, setShowQR] = useState(false); 
  const [showProyectorModal, setShowProyectorModal] = useState(false); 
  const [djPhone, setDjPhone] = useState(''); 
  const [config, setConfig] = useState({ modoPublico: true, hashtag: '#MiEvento', moderacion: false, marcoUrl: '' });
  const [viewingPost, setViewingPost] = useState(null);
  const [isZipping, setIsZipping] = useState(false);

  // 🟢 ESTADOS DEL ATELIER PHYGITAL DE TARJETAS DE MESA (SOCIAL WALL)
  const [showCardStudio, setShowCardStudio] = useState(false);
  const [eventoRawData, setEventoRawData] = useState({});
  const [cardConfig, setCardConfig] = useState({
    heredarInvitacion: false,
    preTitle: 'NUESTRA BODA',
    eventName: 'Mis XV / Boda',
    subtitle: 'Escanea, sube tus fotos y cumple los retos en pantalla',
    logoUrl: '',
    bgImageUrl: '',
    cantidadTarjetas: 15,
    papelId: 'blanco_galeria',
    fontId: 'editorial',
    accentColor: '#B45309'
  });
  const [socialWallStatus, setSocialWallStatus] = useState('pendiente');
  const [mesasEvento, setMesasEvento] = useState([]);
  const [sentTableIds, setSentTableIds] = useState([]);
  const [showExtraCaballetesModal, setShowExtraCaballetesModal] = useState(false);
  const [extraCaballetesMode, setExtraCaballetesMode] = useState('nuevas'); // 'nuevas' | 'manual'
  const [manualExtraTablesCount, setManualExtraTablesCount] = useState(1);
  const [showShippingModal, setShowShippingModal] = useState(false);
  const [shippingForm, setShippingForm] = useState({
    recipient: '',
    country: 'México',
    state: '',
    city: '',
    zipCode: '',
    address: '',
    references: '',
    phoneCode: '+52',
    phone: ''
  });

  const fileInputRef = useRef(null);
  const cloudName = "duy0mcqsh"; 
  const uploadPreset = "ml_default"; 

  const idReal = eventoId || new URLSearchParams(window.location.search).get('e') || 'demo_id';
  const getCleanBaseUrl = () => window.location.hostname.includes('localhost') ? window.location.origin : 'https://baulia.com';
  
  const guestLink = `${getCleanBaseUrl()}/?modo=camara&e=${idReal}`;
  const proyectorLink = `${getCleanBaseUrl()}/?modo=proyector&e=${idReal}`; 
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(guestLink)}&margin=10`;

  useEffect(() => {
    if (!idReal || idReal === 'demo_id') return;
    const unsub = onSnapshot(doc(db, "eventos", idReal), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setEventoRawData(data);
        if (data.galeriaConfig) setConfig(data.galeriaConfig);
        if (data.socialWallStatus) setSocialWallStatus(data.socialWallStatus);
        if (data.socialWallSentTableIds) setSentTableIds(data.socialWallSentTableIds);
        if (data.socialWallCardConfig) {
          setCardConfig(prev => ({ ...prev, ...data.socialWallCardConfig }));
        } else if (data.nombres) {
          setCardConfig(prev => ({
            ...prev,
            eventName: data.nombres,
            preTitle: data.tipoEvento ? data.tipoEvento.replace(/_/g, ' ').toUpperCase() : 'EVENTO ESPECIAL'
          }));
        }
        if (data.direccionEnvioSocialWall) {
          setShippingForm(prev => ({ ...prev, ...data.direccionEnvioSocialWall }));
        } else if (data.direccionEnvioTaller) {
          setShippingForm(prev => ({ ...prev, ...data.direccionEnvioTaller }));
        }
      }
    });

    const unsubMesas = onSnapshot(collection(db, "eventos", idReal, "mesas"), (snap) => {
      const listaMesas = snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => {
        const numA = parseInt(String(a.name || '').replace(/\D/g, '')) || 0;
        const numB = parseInt(String(b.name || '').replace(/\D/g, '')) || 0;
        return numA - numB;
      });
      setMesasEvento(listaMesas);
      if (listaMesas.length > 0) {
        setCardConfig(prev => ({ ...prev, cantidadTarjetas: listaMesas.length }));
      }
    });

    return () => { unsub(); unsubMesas(); };
  }, [idReal]);

  const updateConfig = async (key, value) => {
    if (!idReal || idReal === 'demo_id') return;
    const newConfig = { ...config, [key]: value };
    setConfig(newConfig);
    try {
      await updateDoc(doc(db, "eventos", idReal), { galeriaConfig: newConfig });
      if(addNotification) addNotification('Ajuste Guardado', 'La configuración se actualizó en vivo.', 'success');
    } catch (err) {
      if(addNotification) addNotification('Error', 'No se pudo guardar la configuración.', 'error');
    }
  };

  const handleSaveCardDesign = async (updatedDraft) => {
    if (!idReal || idReal === 'demo_id') return;
    const toSave = updatedDraft || cardConfig;
    setCardConfig(toSave);
    try {
      await updateDoc(doc(db, "eventos", idReal), { socialWallCardConfig: toSave });
      if(addNotification) addNotification('Diseño Guardado', 'Tu diseño de caballete de mesa se guardó en la bóveda.', 'success');
    } catch (err) {
      if(addNotification) addNotification('Error', 'No se pudo guardar el diseño.', 'error');
    }
  };

  const handleSendCardOrderToWorkshop = async (e) => {
    e.preventDefault();
    if (!idReal || idReal === 'demo_id') return;
    const currentTableIds = mesasEvento.map(m => m.id);
    const updatedCardConfig = {
      ...cardConfig,
      cantidadTarjetas: mesasEvento.length > 0 ? mesasEvento.length : cardConfig.cantidadTarjetas
    };
    try {
      await updateDoc(doc(db, "eventos", idReal), {
        socialWallCardConfig: updatedCardConfig,
        socialWallStatus: 'enviado',
        socialWallSentTableIds: currentTableIds,
        fechaEnvioSocialWall: new Date().toISOString(),
        direccionEnvioSocialWall: shippingForm
      });
      setSentTableIds(currentTableIds);
      setSocialWallStatus('enviado');
      setShowShippingModal(false);
      setShowCardStudio(false);
      if(addNotification) addNotification('¡Orden Enviada a Taller!', 'Tus caballetes de mesa han entrado a producción.', 'success');
    } catch (err) {
      if(addNotification) addNotification('Error', 'No se pudo enviar la orden al taller.', 'error');
    }
  };

  const mesasNuevasPostTaller = (socialWallStatus === 'enviado' || socialWallStatus === 'impreso')
    ? mesasEvento.filter(m => !sentTableIds.includes(m.id))
    : [];

  const handlePrintCaballetesPDF = (tablesToPrint) => {
    if (!tablesToPrint || tablesToPrint.length === 0) {
      if (addNotification) addNotification('Sin mesas para imprimir', 'No hay mesas seleccionadas para generar el PDF.', 'warning');
      return;
    }
    const FONT_MAP = {
      editorial: "'Cormorant Garamond', serif",
      caligrafia: "'Great Vibes', cursive",
      alta_moda: "'Cinzel', serif",
      minimal: "'Montserrat', sans-serif"
    };
    const chosenFont = FONT_MAP[cardConfig.fontId] || FONT_MAP.editorial;
    const printWin = window.open('', '_blank', 'width=1000,height=800');
    if (!printWin) {
      alert('Por favor permite las ventanas emergentes para generar el PDF.');
      return;
    }

    const pagesHtml = tablesToPrint.map((mesaObj) => {
      const tableName = (mesaObj.name || 'MESA').toUpperCase();
      const renderSingleCaballete = () => `
        <div class="caballete-card">
          <div class="crop-tl"></div><div class="crop-tr"></div><div class="crop-bl"></div><div class="crop-br"></div>
          <div class="card-inner">
            ${cardConfig.logoUrl ? `<img src="${cardConfig.logoUrl}" class="logo-img" crossorigin="anonymous" />` : ''}
            <div class="pre-title">${cardConfig.preTitle || 'SOCIAL WALL EN VIVO'}</div>
            <div class="event-name">${cardConfig.eventName || 'Nuestro Evento'}</div>
            <div class="subtitle">${cardConfig.subtitle || 'Escanea, sube tus fotos y comparte en pantalla'}</div>
            <div class="qr-box">
              <img src="${qrUrl}" class="qr-img" crossorigin="anonymous" />
            </div>
            <div class="hashtag-row">${config.hashtag || '#MiEvento'} • ${tableName}</div>
            <div class="brand-row">by BAULIA.COM</div>
          </div>
        </div>
      `;
      return `
        <div class="letter-page">
          <div class="sheet-header">HOJA DE PRODUCCIÓN BAULIA • ${tableName} (2 CABALLETES PARA VIDRIO EN ESTA HOJA)</div>
          <div class="cards-grid">
            ${renderSingleCaballete()}
            ${renderSingleCaballete()}
          </div>
        </div>
      `;
    }).join('');

    printWin.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8" />
        <title>Caballetes_SocialWall_${cardConfig.eventName || 'Baulia'}</title>
        <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=Great+Vibes&family=Montserrat:wght@400;600;700;900&display=swap" rel="stylesheet">
        <style>
          @page { size: letter landscape; margin: 0; }
          * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          body { margin: 0; padding: 0; background: #ffffff; font-family: 'Montserrat', sans-serif; color: #000000; }
          .letter-page {
            width: 27.94cm;
            height: 21.59cm;
            page-break-after: always;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            background: #ffffff;
          }
          .letter-page:last-child { page-break-after: auto; }
          .sheet-header {
            position: absolute;
            top: 0.6cm;
            font-size: 8px;
            letter-spacing: 0.25em;
            color: #94a3b8;
            font-weight: 700;
            text-transform: uppercase;
          }
          .cards-grid {
            display: flex;
            gap: 1.5cm;
            align-items: center;
            justify-content: center;
          }
          .caballete-card {
            width: 11.5cm;
            height: 16.5cm;
            border: 0.5pt dashed #cbd5e1;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1cm;
            background: #ffffff;
          }
          .crop-tl, .crop-tr, .crop-bl, .crop-br { position: absolute; width: 10px; height: 10px; border-color: #64748b; border-style: solid; }
          .crop-tl { top: -1px; left: -1px; border-width: 1.5px 0 0 1.5px; }
          .crop-tr { top: -1px; right: -1px; border-width: 1.5px 1.5px 0 0; }
          .crop-bl { bottom: -1px; left: -1px; border-width: 0 0 1.5px 1.5px; }
          .crop-br { bottom: -1px; right: -1px; border-width: 0 1.5px 1.5px 0; }
          .card-inner { display: flex; flex-direction: column; align-items: center; text-align: center; width: 100%; }
          .logo-img { height: 1.6cm; object-fit: contain; margin-bottom: 0.35cm; }
          .pre-title { font-size: 8pt; font-weight: 900; letter-spacing: 0.28em; text-transform: uppercase; color: #000000; margin-bottom: 0.25cm; }
          .event-name { font-family: ${chosenFont}; font-size: ${cardConfig.fontId === 'caligrafia' ? '28pt' : '21pt'}; font-weight: 700; color: #000000; line-height: 1.15; margin-bottom: 0.3cm; }
          .subtitle { font-size: 8.5pt; font-weight: 600; color: #334155; max-width: 7.5cm; line-height: 1.35; margin-bottom: 0.55cm; }
          .qr-box { padding: 0.3cm; border: 1px solid #e2e8f0; border-radius: 14px; margin-bottom: 0.45cm; background: #ffffff; }
          .qr-img { width: 4.6cm; height: 4.6cm; object-fit: contain; display: block; }
          .hashtag-row { font-size: 9.5pt; font-weight: 900; letter-spacing: 0.2em; text-transform: uppercase; color: #000000; }
          .brand-row { font-size: 6.5pt; font-weight: 800; letter-spacing: 0.28em; text-transform: uppercase; color: #64748b; margin-top: 0.25cm; }
        </style>
      </head>
      <body>
        ${pagesHtml}
        <script>
          window.onload = function() {
            setTimeout(function() { window.print(); }, 500);
          };
        </script>
      </body>
      </html>
    `);
    printWin.document.close();
  };

  const handleFrameUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if(addNotification) addNotification('Subiendo Marco...', 'Procesando archivo PNG transparente.', 'info');
    try {
      const formData = new FormData(); formData.append("file", file); formData.append("upload_preset", uploadPreset);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, { method: "POST", body: formData });
      const data = await res.json();
      if (data.secure_url) {
        updateConfig('marcoUrl', data.secure_url);
        if(addNotification) addNotification('Marco Aplicado', 'El diseño ahora se mostrará en todas las fotos.', 'success');
      }
    } catch (err) { alert("Error al subir el marco."); }
  };

  const handleDelete = async (id) => {
    if (!idReal || idReal === 'demo_id') return;
    await deleteDoc(doc(db, "eventos", idReal, "fotos", id));
    setViewingPost(null); 
  };

  const toggleApproval = async (foto, approved) => {
    if (!idReal || idReal === 'demo_id') return;
    await setDoc(doc(db, "eventos", idReal, "fotos", foto.id), { ...foto, status: approved ? 'approved' : 'rejected' });
    if(addNotification) addNotification(approved ? 'Foto Aprobada' : 'Foto Rechazada', approved ? 'Ya se ve en el proyector' : 'Oculta para todos', 'success');
  };

  const forceDownloadQR = async () => {
    try {
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'QR_Mesa_Galeria.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      window.open(qrUrl, '_blank'); 
    }
  };

  const downloadAllPhotos = () => {
    if (photos.length === 0) return;
    setIsZipping(true);
    if(addNotification) addNotification('Empaquetando Fotos', 'Esto puede tardar unos segundos...', 'info');

    const executeZip = async () => {
      const zip = new window.JSZip();
      const folder = zip.folder("Album_Evento");
      let count = 0;

      for (let f of photos) {
        const urls = f.urls || [f.url];
        for (let i = 0; i < urls.length; i++) {
          try {
            const response = await fetch(urls[i]);
            const blob = await response.blob();
            folder.file(`${f.autor}_${f.id}_${i}.jpg`, blob);
            count++;
          } catch(e) {}
        }
      }
      
      zip.generateAsync({type:"blob"}).then(function(content) {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(content);
        link.download = "Album_Evento.zip";
        link.click();
        setIsZipping(false);
        if(addNotification) addNotification('¡Descarga Lista!', `Se descargaron ${count} fotos.`, 'success');
      });
    };

    if (!window.JSZip) {
      const script = document.createElement('script');
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
      document.head.appendChild(script);
      script.onload = executeZip;
    } else { executeZip(); }
  };

  const sendProyectorWhatsApp = () => {
     const phone = djPhone.replace(/\D/g,'');
     if (!phone) { alert('Ingresa un número válido'); return; }
     const msg = `¡Hola! Aquí tienes el enlace de acceso directo para las Pantallas Gigantes (Proyector):\n\n${proyectorLink}`;
     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  const renderTextWithHashtags = (text) => {
    if (!text) return null;
    return text.split(/(#[a-zA-Z0-9_áéíóúñÁÉÍÓÚÑ]+)/g).map((part, i) => {
      if (part.startsWith('#')) return <span key={i} className="font-bold text-indigo-500 dark:text-amber-500">{part}</span>;
      return part;
    });
  };

  const isLockedInWorkshop = socialWallStatus === 'enviado' || socialWallStatus === 'impreso';

  return (
    <div className="h-full flex flex-col space-y-4 pb-6 relative z-10 transition-colors duration-500 max-w-[1200px] mx-auto w-full">
      
      <div className="bg-[#1C1917] rounded-[2rem] border border-[#D4AF37]/25 shadow-xl p-6 shrink-0 transition-colors text-white">
        
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6 border-b border-[#D4AF37]/15 pb-4">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-[#D4AF37]/15 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37]">
              <Camera size={20} />
            </div>
            <div>
              <span className="text-[9px] font-black uppercase tracking-[0.25em] text-[#D4AF37] block">Baulia Social Wall</span>
              <h2 className="text-xl font-editorial font-bold text-white leading-tight">Muro Social y Caballetes en Vivo</h2>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center gap-2.5">
            {/* 🟢 BOTÓN QUE ABRE EL ATELIER A PANTALLA COMPLETA (MODO INDEPENDIENTE CABALLETE) */}
            <button
              type="button"
              onClick={() => setShowCardStudio(true)}
              className={`flex items-center justify-center px-5 py-2.5 rounded-xl text-[10px] uppercase tracking-widest font-black transition-all border ${
                isLockedInWorkshop
                  ? 'bg-[#141210] text-[#D4AF37] border-[#D4AF37]/50 shadow-[0_0_15px_rgba(212,175,55,0.15)]'
                  : 'bg-[#D4AF37] hover:bg-[#c5a028] text-[#1C1917] border-[#D4AF37] shadow-[0_10px_25px_rgba(212,175,55,0.25)]'
              }`}
            >
              {isLockedInWorkshop ? (
                <><Lock size={14} className="mr-2"/> {socialWallStatus === 'impreso' ? 'Tarjetas Despachadas (Ver Diseño)' : 'Tarjetas en Taller (Ver Diseño)'}</>
              ) : (
                <><Sparkles size={14} className="mr-2"/> Abrir Atelier de Tarjetas de Mesa ({mesasEvento.length || cardConfig.cantidadTarjetas} Mesas)</>
              )}
            </button>

            {isLockedInWorkshop && (
              <button
                type="button"
                onClick={() => {
                  setExtraCaballetesMode(mesasNuevasPostTaller.length > 0 ? 'nuevas' : 'manual');
                  setShowExtraCaballetesModal(true);
                }}
                className="flex items-center justify-center px-5 py-2.5 rounded-xl text-[10px] uppercase tracking-widest font-black transition-all bg-[#D4AF37] hover:bg-[#c5a028] text-[#1C1917] shadow-[0_10px_25px_rgba(212,175,55,0.25)]"
              >
                <Download size={14} className="mr-2"/>
                Generar Caballetes Extra (PDF)
                {mesasNuevasPostTaller.length > 0 && (
                  <span className="ml-2 px-2 py-0.5 rounded-full bg-[#1C1917] text-[#D4AF37] text-[9px]">
                    +{mesasNuevasPostTaller.length} {mesasNuevasPostTaller.length === 1 ? 'Mesa Nueva' : 'Mesas Nuevas'}
                  </span>
                )}
              </button>
            )}

            {showExtraCaballetesModal && createPortal(
              <div className="fixed inset-0 z-[999999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
                <div className="bg-[#1C1917] border border-[#D4AF37]/30 rounded-[2rem] w-full max-w-md p-6 sm:p-8 shadow-2xl text-white space-y-5">
                  <div className="flex justify-between items-start">
                    <div>
                      <span className="text-[9px] font-black uppercase tracking-widest text-[#D4AF37]">Impresión de Emergencia • Social Wall</span>
                      <h3 className="text-xl font-bold text-white mt-1">Generar Caballetes Extra (PDF)</h3>
                    </div>
                    <button type="button" onClick={() => setShowExtraCaballetesModal(false)} className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-slate-400"><X size={18}/></button>
                  </div>

                  <p className="text-xs text-slate-300 leading-relaxed">
                    Cada hoja tamaño Carta imprime <b>2 caballetes idénticos para la misma mesa</b> (listos para recortar y colocar en portarretrato de vidrio).
                  </p>

                  <div className="grid grid-cols-2 gap-2.5">
                    <button
                      type="button"
                      onClick={() => setExtraCaballetesMode('nuevas')}
                      className={`p-3.5 rounded-xl border text-left transition-all ${extraCaballetesMode === 'nuevas' ? 'border-[#D4AF37] bg-[#D4AF37]/15 text-white' : 'border-white/10 bg-[#141210] text-slate-400'}`}
                    >
                      <span className="text-[10px] font-black uppercase tracking-wider block text-[#D4AF37]">Mesas Nuevas ({mesasNuevasPostTaller.length})</span>
                      <span className="text-[10px] text-slate-300 mt-1 block">Detectadas después del envío a taller</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => setExtraCaballetesMode('manual')}
                      className={`p-3.5 rounded-xl border text-left transition-all ${extraCaballetesMode === 'manual' ? 'border-[#D4AF37] bg-[#D4AF37]/15 text-white' : 'border-white/10 bg-[#141210] text-slate-400'}`}
                    >
                      <span className="text-[10px] font-black uppercase tracking-wider block text-[#D4AF37]">Cantidad Manual</span>
                      <span className="text-[10px] text-slate-300 mt-1 block">Elegir cuántas mesas/hojas imprimir</span>
                    </button>
                  </div>

                  {extraCaballetesMode === 'nuevas' ? (
                    <div className="p-4 rounded-xl bg-[#141210] border border-[#D4AF37]/20">
                      {mesasNuevasPostTaller.length === 0 ? (
                        <p className="text-xs text-slate-400 text-center">No has agregado mesas nuevas en el Gestor de Mesas después de enviar a taller. Usa el modo "Cantidad Manual" si necesitas reposiciones.</p>
                      ) : (
                        <div className="space-y-2">
                          <p className="text-[10px] font-black uppercase tracking-widest text-[#D4AF37]">
                            Se imprimirán {mesasNuevasPostTaller.length} hojas ({mesasNuevasPostTaller.length * 2} caballetes):
                          </p>
                          <div className="flex flex-wrap gap-1.5">
                            {mesasNuevasPostTaller.map(m => (
                              <span key={m.id} className="px-2.5 py-1 rounded-lg bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] text-xs font-bold">
                                {m.name} (2 caballetes)
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="p-4 rounded-xl bg-[#141210] border border-[#D4AF37]/20 space-y-3">
                      <label className="block text-[10px] font-black uppercase tracking-widest text-slate-300">
                        ¿Cuántas mesas extra necesitas imprimir? (2 caballetes por hoja)
                      </label>
                      <input
                        type="number"
                        min="1"
                        max="100"
                        value={manualExtraTablesCount}
                        onChange={e => setManualExtraTablesCount(Math.max(1, parseInt(e.target.value) || 1))}
                        className="w-full p-3 rounded-xl bg-[#1C1917] border border-[#D4AF37]/40 text-center text-lg font-black text-[#D4AF37] outline-none focus:border-[#D4AF37]"
                      />
                      <p className="text-[11px] text-slate-400 text-center">
                        Se generarán <b>{manualExtraTablesCount} hojas Carta</b> ({manualExtraTablesCount * 2} caballetes en total).
                      </p>
                    </div>
                  )}

                  <div className="flex gap-3 pt-2">
                    <button type="button" onClick={() => setShowExtraCaballetesModal(false)} className="flex-1 py-3.5 rounded-xl bg-white/5 hover:bg-white/10 text-xs font-bold uppercase tracking-widest text-slate-300">
                      Cancelar
                    </button>
                    <button
                      type="button"
                      disabled={extraCaballetesMode === 'nuevas' && mesasNuevasPostTaller.length === 0}
                      onClick={() => {
                        const baseNum = sentTableIds.length || mesasEvento.length || 0;
                        const targetTables = extraCaballetesMode === 'nuevas'
                          ? mesasNuevasPostTaller
                          : Array.from({ length: manualExtraTablesCount }, (_, i) => ({
                              id: `extra_${i}`,
                              name: `Mesa ${baseNum + i + 1}`
                            }));
                        handlePrintCaballetesPDF(targetTables);
                        setShowExtraCaballetesModal(false);
                      }}
                      className="flex-1 py-3.5 rounded-xl bg-[#D4AF37] hover:bg-[#c5a028] disabled:opacity-40 text-[#1C1917] font-black text-xs uppercase tracking-widest flex items-center justify-center gap-2 shadow-lg"
                    >
                      <Download size={15}/> Descargar / Imprimir PDF
                    </button>
                  </div>
                </div>
              </div>,
              document.body
            )}

            <button onClick={downloadAllPhotos} disabled={isZipping || photos.length === 0} className={`flex items-center justify-center px-6 py-2.5 rounded-xl text-[10px] uppercase tracking-widest font-black transition-all border ${isZipping ? 'bg-white/10 text-white border-white/20' : photos.length === 0 ? 'bg-white/5 text-slate-500 border-white/10 cursor-not-allowed' : 'bg-[#141210] hover:bg-[#D4AF37]/20 text-[#D4AF37] border-[#D4AF37]/40 hover:scale-105'}`}>
              {isZipping ? <RefreshCw size={16} className="mr-2 animate-spin"/> : <Download size={16} className="mr-2"/>} 
              {isZipping ? 'Empaquetando...' : 'Descargar Álbum (.ZIP)'}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="bg-[#141210] border border-[#D4AF37]/20 rounded-2xl p-4 flex flex-col justify-between">
            <div className="mb-4">
               <h4 className="font-bold text-sm text-white flex items-center gap-1.5"><MonitorPlay size={16} className="text-[#D4AF37]"/> Proyección y Acceso</h4>
               <p className="text-[10px] text-slate-400 mt-1 leading-relaxed">QR para las mesas e interfaz para la pantalla gigante del salón.</p>
            </div>
            <div className="grid grid-cols-2 gap-2">
               <button onClick={() => setShowQR(true)} className="flex items-center justify-center px-2 py-2.5 bg-[#1C1917] text-[#D4AF37] rounded-lg border border-[#D4AF37]/30 hover:bg-[#D4AF37]/15 text-[9px] font-black uppercase tracking-wider transition-colors">
                 <QrCode size={14} className="mr-1.5"/> QR Mesas
               </button>
               <button onClick={() => setShowProyectorModal(true)} className="flex items-center justify-center px-2 py-2.5 bg-[#D4AF37] text-[#1C1917] rounded-lg hover:bg-[#c5a028] text-[9px] font-black uppercase tracking-wider transition-colors shadow-md">
                 <PlayCircle size={14} className="mr-1.5"/> Proyector
               </button>
            </div>
          </div>

          <div className="bg-[#141210] border border-[#D4AF37]/20 rounded-2xl p-4 flex flex-col justify-between">
            <div className="mb-4">
               <h4 className="font-bold text-sm text-white flex items-center gap-1.5"><ShieldCheck size={16} className="text-[#D4AF37]"/> Seguridad y Filtros</h4>
               <p className="text-[9px] text-slate-400 mt-1 leading-tight">
                 <b className="text-[#D4AF37]">Público:</b> Escaneo QR general + Nombre.<br/>
                 <b className="text-[#D4AF37]">Privado:</b> Solo con Pase QR personal.<br/>
                 <b className="text-[#D4AF37]">Moderador:</b> Aprobar fotos antes de proyectar.
               </p>
            </div>
            <div className="flex gap-2 items-center">
               <div className="flex items-center bg-[#1C1917] p-0.5 rounded-lg border border-[#D4AF37]/25 shrink-0">
                  <button onClick={() => updateConfig('modoPublico', true)} className={`text-[8px] font-black uppercase tracking-widest px-2.5 py-1.5 rounded-md transition-all ${config.modoPublico ? 'bg-[#D4AF37] text-[#1C1917]' : 'text-slate-400 hover:text-white'}`}>Público</button>
                  <button onClick={() => updateConfig('modoPublico', false)} className={`text-[8px] font-black uppercase tracking-widest px-2.5 py-1.5 rounded-md transition-all ${!config.modoPublico ? 'bg-[#D4AF37] text-[#1C1917]' : 'text-slate-400 hover:text-white'}`}>Privado</button>
               </div>
               <div className="flex items-center bg-[#1C1917] px-2.5 py-1.5 rounded-lg border border-[#D4AF37]/25 flex-1 justify-between gap-1">
                  <span className="text-[8px] font-black uppercase text-slate-300 tracking-widest truncate">Moderador</span>
                  <button onClick={() => updateConfig('moderacion', !config.moderacion)} className={`relative w-7 h-3.5 rounded-full transition-colors shrink-0 ${config.moderacion ? 'bg-[#D4AF37]' : 'bg-white/15'}`} title="Activar/Desactivar Moderador">
                    <div className={`absolute top-[2px] left-[2px] w-2.5 h-2.5 rounded-full transition-transform ${config.moderacion ? 'translate-x-3.5 bg-[#1C1917]' : 'translate-x-0 bg-white'}`}></div>
                  </button>
               </div>
            </div>
          </div>

          <div className="bg-[#141210] border border-[#D4AF37]/20 rounded-2xl p-4 flex flex-col justify-between">
            <div className="mb-4">
               <h4 className="font-bold text-sm text-white flex items-center gap-1.5"><Palette size={16} className="text-[#D4AF37]"/> Personalización</h4>
               <p className="text-[10px] text-slate-400 mt-1 leading-relaxed">Agrega un marco a las fotos (PNG transparente) y un hashtag al muro.</p>
            </div>
            <div className="flex gap-2">
               <div className="flex items-center bg-[#1C1917] border border-[#D4AF37]/30 rounded-lg px-3 py-1.5 flex-1 focus-within:border-[#D4AF37] transition-colors">
                 <span className="text-[#D4AF37] font-bold mr-1 text-[10px]">#</span>
                 <input type="text" value={config.hashtag?.replace('#', '') || ''} onChange={(e) => setConfig({...config, hashtag: '#' + e.target.value.replace(/\s+/g, '')})} onBlur={() => updateConfig('hashtag', config.hashtag)} placeholder="Boda" className="bg-transparent text-white font-bold text-[10px] uppercase outline-none w-full placeholder:text-slate-500"/>
               </div>
               <input type="file" accept="image/png" ref={fileInputRef} onChange={handleFrameUpload} className="hidden" />
               <button onClick={() => fileInputRef.current.click()} className="flex items-center justify-center px-3 bg-[#D4AF37]/15 text-[#D4AF37] rounded-lg text-[9px] uppercase tracking-widest font-black hover:bg-[#D4AF37]/25 border border-[#D4AF37]/40 transition-all shrink-0">
                 <ImageIcon size={14} className="mr-1.5" /> {config.marcoUrl ? 'Cambiar' : 'Marco'}
               </button>
            </div>
          </div>
        </div>
      </div>

      {/* 🟢 ATELIER PHYGITAL A PANTALLA COMPLETA (MODO CABALLETE DE MESA) */}
      <AtelierPhygitalModal
        isOpen={showCardStudio}
        onClose={() => setShowCardStudio(false)}
        mode="social_wall"
        eventoData={eventoRawData}
        initialConfig={cardConfig}
        hashtag={config.hashtag}
        qrUrl={qrUrl}
        isLocked={isLockedInWorkshop}
        status={socialWallStatus}
        onSaveDesign={handleSaveCardDesign}
        onOpenShippingModal={(draftToSave) => {
          setCardConfig(draftToSave);
          setShowShippingModal(true);
        }}
        addNotification={addNotification}
      />

      {/* 🟢 MODAL DE DIRECCIÓN DE ENVÍO A TALLER */}
      {showShippingModal && createPortal(
        <div className="fixed inset-0 z-[999999] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
          <div className="bg-[#0d0d0d] border border-white/10 rounded-[2rem] w-full max-w-lg p-6 sm:p-8 shadow-2xl text-white max-h-[92vh] overflow-y-auto custom-scrollbar">
            <form onSubmit={handleSendCardOrderToWorkshop} className="space-y-4">
              <div>
                <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Quien recibe (Nombre Completo)</label>
                <input type="text" required value={shippingForm.recipient} onChange={e => setShippingForm({...shippingForm, recipient: e.target.value})} placeholder="Ej. Maricela Estudillo" className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">País</label>
                  <input type="text" required value={shippingForm.country} onChange={e => setShippingForm({...shippingForm, country: e.target.value})} className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
                </div>
                <div>
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Estado / Provincia</label>
                  <input type="text" required value={shippingForm.state} onChange={e => setShippingForm({...shippingForm, state: e.target.value})} placeholder="Ej. Veracruz" className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Ciudad / Municipio</label>
                  <input type="text" required value={shippingForm.city} onChange={e => setShippingForm({...shippingForm, city: e.target.value})} placeholder="Ej. Minatitlán" className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
                </div>
                <div>
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Código Postal</label>
                  <input type="text" required value={shippingForm.zipCode} onChange={e => setShippingForm({...shippingForm, zipCode: e.target.value})} placeholder="96790" className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
                </div>
              </div>

              <div>
                <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Calle y Número</label>
                <input type="text" required value={shippingForm.address} onChange={e => setShippingForm({...shippingForm, address: e.target.value})} placeholder="Calle, Número exterior e interior, Colonia" className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
              </div>

              <div>
                <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Referencias de Entrega (Opcional)</label>
                <input type="text" value={shippingForm.references} onChange={e => setShippingForm({...shippingForm, references: e.target.value})} placeholder="Color de fachada, entre qué calles..." className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
              </div>

              <div className="grid grid-cols-3 gap-3">
                <div>
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Lada</label>
                  <input type="text" required value={shippingForm.phoneCode} onChange={e => setShippingForm({...shippingForm, phoneCode: e.target.value})} className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white text-center outline-none focus:border-amber-500" />
                </div>
                <div className="col-span-2">
                  <label className="block text-[9px] font-black uppercase tracking-widest text-slate-400 mb-1.5">Teléfono Móvil</label>
                  <input type="tel" required value={shippingForm.phone} onChange={e => setShippingForm({...shippingForm, phone: e.target.value})} placeholder="10 dígitos" className="w-full p-3.5 rounded-xl bg-black border border-white/10 text-sm font-bold text-white outline-none focus:border-amber-500" />
                </div>
              </div>

              <div className="p-3.5 rounded-xl bg-rose-500/10 border border-rose-500/20 text-rose-400 text-xs flex items-start gap-2.5">
                <AlertTriangle size={16} className="shrink-0 mt-0.5"/>
                <span>Una vez enviada la orden a taller, <b>NO podrás editar el diseño de tus tarjetas de mesa</b>. Verifica que todo esté perfecto antes de continuar.</span>
              </div>

              <div className="grid grid-cols-2 gap-3 pt-2">
                <button type="button" onClick={() => setShowShippingModal(false)} className="py-4 rounded-xl bg-white/5 hover:bg-white/10 text-slate-300 font-black text-[10px] uppercase tracking-widest">
                  Revisar Diseño
                </button>
                <button type="submit" className="py-4 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-black text-[10px] uppercase tracking-widest shadow-lg flex items-center justify-center gap-2">
                  <Send size={14}/> Enviar Orden Definitiva
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}

      <div className="flex-1 bg-[#1C1917] rounded-[2.5rem] border border-[#D4AF37]/25 shadow-2xl p-6 overflow-y-auto custom-scrollbar transition-colors">
        {photos.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-slate-400 min-h-[300px]">
            <div className="w-24 h-24 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center mb-6 text-[#D4AF37]">
              <ImageIcon size={40} />
            </div>
            <h3 className="text-2xl font-bold text-white font-editorial tracking-wide mb-2">Aún no hay fotos</h3>
            <p className="text-sm font-medium text-slate-400">Invita a tus asistentes a escanear el QR de las mesas.</p>
          </div>
        ) : (
          <div className="columns-2 md:columns-4 gap-4 pb-10">
            {photos.map((foto) => {
              const urls = foto.urls || [foto.url];
              const portada = urls[0]; 
              const isPending = config.moderacion && foto.status === 'pending';
              
              const likesCount = Array.isArray(foto.likes) ? foto.likes.length : (foto.likes || 0);
              const commentCount = (foto.comentarios || []).length;
              const isCarousel = urls.length > 1;

              return (
                <div 
                  key={foto.id} 
                  onClick={() => setViewingPost(foto)} 
                  style={{ WebkitColumnBreakInside: 'avoid', pageBreakInside: 'avoid', breakInside: 'avoid' }}
                  className={`group mb-4 w-full rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border cursor-pointer ${isPending ? 'border-amber-400 ring-2 ring-amber-200 dark:border-amber-500/50 dark:ring-amber-500/20' : 'border-slate-200 dark:border-white/10'}`}
                >
                  <div className="relative w-full aspect-[3/4] bg-slate-200 dark:bg-slate-800">
                    <img src={portada} alt="Foto" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                    {config.marcoUrl && <img src={config.marcoUrl} className="absolute inset-0 w-full h-full object-cover pointer-events-none" />}
                    
                    {isPending && (
                       <div className="absolute top-3 left-3 z-20 bg-amber-500 text-white text-[10px] font-black px-3 py-1.5 rounded-full flex items-center shadow-lg uppercase tracking-widest">
                          <AlertCircle size={14} className="mr-1.5"/> PENDIENTE
                       </div>
                    )}

                    {isCarousel && (
                      <div className="absolute top-3 right-3 bg-black/60 text-white p-2 rounded-xl backdrop-blur-md z-10 shadow-md">
                        <Layers size={16} />
                      </div>
                    )}

                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/95 via-slate-900/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-between p-4 z-20">
                      <div className="flex justify-end gap-2">
                        {isPending && (
                          <>
                             <button onClick={(e) => { e.stopPropagation(); toggleApproval(foto, true); }} className="p-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full backdrop-blur-md shadow-xl hover:scale-110 transition-transform"><CheckCircle size={18} /></button>
                             <button onClick={(e) => { e.stopPropagation(); toggleApproval(foto, false); }} className="p-3 bg-rose-500 hover:bg-rose-600 text-white rounded-full backdrop-blur-md shadow-xl hover:scale-110 transition-transform"><X size={18} /></button>
                          </>
                        )}
                        {!isPending && (
                          <button onClick={(e) => { e.stopPropagation(); handleDelete(foto.id); }} className="p-3 bg-white/20 hover:bg-rose-500 text-white rounded-full backdrop-blur-md transition-colors shadow-lg" title="Borrar Publicación">
                            <Trash2 size={18} />
                          </button>
                        )}
                      </div>
                      
                      <div className="mt-auto">
                        {foto.mensaje && <p className="text-white/90 text-xs mb-2 line-clamp-2 drop-shadow-md leading-relaxed">{renderTextWithHashtags(foto.mensaje)}</p>}
                        <div className="flex justify-between items-end">
                          <div className="flex flex-col">
                             <p className="text-white font-bold text-sm drop-shadow-md">{foto.autor}</p>
                             <p className="text-white/70 text-[10px] font-bold uppercase tracking-wider">{foto.fecha}</p>
                          </div>
                          <div className="flex gap-2">
                            <span className="flex items-center text-white bg-white/20 px-2.5 py-1.5 rounded-full backdrop-blur-md text-[10px] font-bold shadow-sm">
                              <MessageCircle size={12} className="mr-1.5" /> {commentCount}
                            </span>
                            <span className="flex items-center text-white bg-rose-500/80 px-2.5 py-1.5 rounded-full backdrop-blur-md text-[10px] font-bold shadow-sm">
                              <Heart size={12} className="mr-1.5 fill-white" /> {likesCount}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {viewingPost && (
        <div className="fixed inset-0 z-[200] bg-slate-900/80 dark:bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] w-full max-w-lg overflow-hidden shadow-2xl flex flex-col max-h-[90vh] animate-in zoom-in-95 border border-transparent dark:border-white/10 transition-colors">
            <div className="p-5 border-b border-slate-100 dark:border-white/5 flex items-center justify-between bg-slate-50 dark:bg-[#111] shrink-0 transition-colors">
              <div className="flex items-center">
                <div className="w-12 h-12 rounded-full bg-indigo-100 dark:bg-amber-500/20 overflow-hidden mr-4 border border-transparent dark:border-amber-500/30">
                  <img src={viewingPost.avatar || ''} className="w-full h-full object-cover" alt="Avatar"/>
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 dark:text-white text-base">{viewingPost.autor}</h3>
                  <p className="text-[10px] text-slate-500 uppercase tracking-widest font-bold">{viewingPost.fecha}</p>
                </div>
              </div>
              <button onClick={() => setViewingPost(null)} className="p-3 bg-slate-200 dark:bg-white/10 rounded-full text-slate-600 dark:text-white hover:bg-slate-300 dark:hover:bg-white/20 transition-colors"><X size={18}/></button>
            </div>
            
            <div className="flex-1 overflow-y-auto bg-slate-900 dark:bg-black custom-scrollbar transition-colors relative">
              <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar relative">
                 {(viewingPost.urls || [viewingPost.url]).map((u, idx) => (
                   <div key={idx} className="w-full flex-shrink-0 snap-center relative flex items-center justify-center min-h-[50vh]">
                     <img src={u} className="w-full max-h-[70vh] object-contain mx-auto" alt="Post"/>
                     {config.marcoUrl && <img src={config.marcoUrl} className="absolute inset-0 w-full h-full object-contain pointer-events-none" alt="Marco"/>}
                   </div>
                 ))}
              </div>
            </div>

            <div className="p-6 flex justify-between items-center bg-slate-50 dark:bg-[#111] border-t border-slate-100 dark:border-white/5 transition-colors shrink-0">
              <button onClick={() => handleDelete(viewingPost.id)} className="text-[10px] font-black uppercase tracking-widest text-rose-500 bg-rose-50 dark:bg-rose-500/10 px-6 py-3.5 rounded-xl hover:bg-rose-100 dark:hover:bg-rose-500/20 transition-colors shadow-sm flex items-center">
                <Trash2 size={16} className="mr-2"/> Borrar
              </button>
              
              {config.moderacion && viewingPost.status === 'pending' && (
                <div className="flex gap-3">
                  <button onClick={() => toggleApproval(viewingPost, false)} className="text-[10px] font-black uppercase tracking-widest text-white bg-rose-500 px-6 py-3.5 rounded-xl shadow-lg hover:bg-rose-600 hover:scale-105 transition-all flex items-center">
                    <X size={16} className="mr-2"/> Rechazar
                  </button>
                  <button onClick={() => toggleApproval(viewingPost, true)} className="text-[10px] font-black uppercase tracking-widest text-white bg-emerald-500 px-6 py-3.5 rounded-xl shadow-lg hover:bg-emerald-600 hover:scale-105 transition-all flex items-center">
                    <CheckCircle size={16} className="mr-2"/> Aprobar
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showProyectorModal && (
        <div className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
          <div className="bg-[#1C1917] rounded-[2.5rem] w-full max-w-md overflow-hidden shadow-2xl p-10 relative animate-in zoom-in-95 border border-[#D4AF37]/30 text-white">
             <button onClick={() => setShowProyectorModal(false)} className="absolute top-6 right-6 text-slate-400 hover:text-[#D4AF37] bg-white/5 p-2 rounded-full transition-colors"><X size={20}/></button>
             
             <div className="w-20 h-20 bg-[#D4AF37]/15 text-[#D4AF37] rounded-2xl flex items-center justify-center mx-auto mb-6 border border-[#D4AF37]/40 shadow-inner">
               <PlayCircle size={40}/>
             </div>
             
             <h3 className="font-editorial font-black text-3xl text-white mb-2 text-center">Modo Proyector</h3>
             <p className="text-xs text-slate-400 text-center mb-8">Este es el enlace que debe abrirse en la computadora conectada a las pantallas de tu salón.</p>
             
             <button onClick={() => {navigator.clipboard.writeText(proyectorLink); if(addNotification) addNotification('Copiado', 'Enlace copiado al portapapeles', 'success');}} className="w-full py-4 mb-8 bg-[#141210] text-[#D4AF37] border border-[#D4AF37]/30 rounded-xl font-black hover:bg-[#D4AF37]/15 flex items-center justify-center transition-colors uppercase tracking-widest text-[10px]">
               <Link size={16} className="mr-2"/> Copiar enlace directo
             </button>
             
             <div className="border-t border-[#D4AF37]/20 pt-8">
                <label className="block text-[10px] font-black mb-4 text-[#D4AF37] text-center uppercase tracking-widest">Enviar por WhatsApp al DJ</label>
                <div className="flex gap-3">
                  <input type="text" placeholder="10 dígitos del celular..." value={djPhone} onChange={e=>setDjPhone(e.target.value)} className="w-full px-5 py-4 border border-white/10 bg-[#141210] rounded-xl font-bold text-white outline-none focus:border-[#D4AF37] transition-colors placeholder:text-slate-500" />
                  <button onClick={sendProyectorWhatsApp} className="px-6 bg-[#D4AF37] text-[#1C1917] rounded-xl hover:bg-[#c5a028] transition-colors shadow-lg flex items-center justify-center shrink-0">
                    <Send size={20}/>
                  </button>
                </div>
             </div>
          </div>
        </div>
      )}

      {showQR && (
        <div className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
          <div className="bg-[#1C1917] rounded-[2.5rem] w-full max-w-sm overflow-hidden shadow-2xl p-10 text-center relative animate-in zoom-in-95 border border-[#D4AF37]/30 text-white">
            <button onClick={() => setShowQR(false)} className="absolute top-5 right-5 text-slate-400 hover:text-[#D4AF37] bg-white/5 p-2 rounded-full transition-colors"><X size={20}/></button>
            
            <h3 className="font-editorial font-black text-3xl text-white mb-2">Tu Código QR</h3>
            <p className="text-[10px] text-[#D4AF37] uppercase tracking-widest mb-8 font-bold">Imprime y ponlo en las mesas</p>
            
            <div className="bg-white p-4 rounded-3xl border-4 border-[#D4AF37]/50 inline-block mb-10 shadow-lg transform hover:scale-105 transition-transform">
              <img src={qrUrl} alt="QR Code" className="w-56 h-56 mx-auto mix-blend-multiply" />
            </div>
            
            <div className="flex flex-col gap-3">
              <button onClick={forceDownloadQR} className="w-full py-4 bg-[#D4AF37] hover:bg-[#c5a028] transition-colors text-[#1C1917] rounded-xl font-black shadow-[0_10px_25px_rgba(212,175,55,0.25)] uppercase tracking-widest text-[10px]">
                <Download size={16} className="inline mr-2"/> Descargar PNG
              </button>
              <button onClick={() => {navigator.clipboard.writeText(guestLink); if(addNotification) addNotification('Copiado', 'Link manual copiado al portapapeles', 'success');}} className="w-full py-4 bg-[#141210] border border-[#D4AF37]/30 text-slate-200 rounded-xl font-bold hover:bg-white/5 flex items-center justify-center transition-colors uppercase tracking-widest text-[10px]">
                <Link size={16} className="mr-2 text-[#D4AF37]"/> Copiar enlace manual
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: VISTA PÚBLICA DEL INVITADO (W/ CÁMARA CUADRADA TIPO SUPERMERCADO) ---
// ==========================================
const GuestCameraView = ({ eventId }) => {
  const [config, setConfig] = useState({ modoPublico: true, hashtag: '', moderacion: false, marcoUrl: '' });
  const [isUploading, setIsUploading] = useState(false);
  const [isAvatarUploading, setIsAvatarUploading] = useState(false);
  
  const [toast, setToast] = useState(null);
  const toastTimerRef = useRef(null);

  const showToast = (text, type = 'info') => {
    setToast({ text, type });
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    toastTimerRef.current = setTimeout(() => setToast(null), 3500);
  };
  
  const publicNameKey = `baulia_public_${eventId}`;
  const privateIdKey = `baulia_privId_${eventId}`;
  const privateNameKey = `baulia_privName_${eventId}`;
  const avatarKey = `baulia_avatar_${eventId}`;

  const [guestName, setGuestName] = useState(() => localStorage.getItem(publicNameKey) || '');
  const [tempPublicName, setTempPublicName] = useState(''); 

  const [authGuest, setAuthGuest] = useState(() => {
    const savedId = localStorage.getItem(privateIdKey);
    const savedName = localStorage.getItem(privateNameKey);
    return savedId ? { id: savedId, name: savedName } : null;
  });
  
  const [guestAvatar, setGuestAvatar] = useState(() => localStorage.getItem(avatarKey) || ''); 
  const [guestCode, setGuestCode] = useState('');
  const [allGuests, setAllGuests] = useState([]); 

  const [feedFotos, setFeedFotos] = useState([]);
  const [postDraft, setPostDraft] = useState(null); 
  const [showChallengeModal, setShowChallengeModal] = useState(false);
  const [activeChallenge, setActiveChallenge] = useState(null);

  const retos = ["¡Selfie con alguien que no conocías! 📸", "El mejor paso de baile en la pista 💃", "Una foto brindando con tu mesa 🥂", "Atrapa un beso de los novios/festejados 💋", "¡Foto haciendo una cara graciosa! 🤪", "Fotografía el detalle más bonito del salón ✨", "Selfie con el invitado más prendido de la fiesta 🔥", "Una foto estilo paparazzi a alguien distraído 🕶️", "Foto grupal con TODOS los de tu mesa 🍽️", "Encuentra a alguien con tu mismo color de ropa y tómense foto 👗", "Captura el momento exacto de una carcajada 😂", "Selfie haciendo 'pico de pato' con la abuela o tía mayor 🦆"];
  
  const [activePostComments, setActivePostComments] = useState(null);
  const [commentText, setCommentText] = useState('');
  const [replyingTo, setReplyingTo] = useState(null);
  
  const [socialActivity, setSocialActivity] = useState([]);
  const [showSocialBell, setShowSocialBell] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  
  const bellRef = useRef(null); 
  const menuRef = useRef(null);
  const fileInputRef = useRef(null);
  
  const cloudName = "duy0mcqsh"; 
  const uploadPreset = "ml_default"; 

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('eventmaster_theme');
    if (saved === 'dark') return true;
    if (saved === 'light') return false;
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) return true;
    const hr = new Date().getHours();
    return hr >= 19 || hr < 6;
  });

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem('eventmaster_theme', newTheme ? 'dark' : 'light');
    setShowMenu(false);
  };

  const tBgBase = isDarkMode ? 'bg-zinc-950' : 'bg-slate-50';
  const tBgCard = isDarkMode ? 'bg-zinc-900' : 'bg-white';
  const tBorder = isDarkMode ? 'border-zinc-800' : 'border-slate-200';
  const tTextMain = isDarkMode ? 'text-slate-100' : 'text-slate-900';
  const tTextSub = isDarkMode ? 'text-zinc-400' : 'text-slate-500';
  const tInputBg = isDarkMode ? 'bg-zinc-800 focus:bg-zinc-700' : 'bg-slate-50 focus:bg-white';

  const currentUserName = config?.modoPublico ? guestName : authGuest?.name;

  const DiceIcon = ({ className, size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="4" ry="4"></rect>
      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"></circle>
      <circle cx="15.5" cy="15.5" r="1.5" fill="currentColor"></circle>
      <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor"></circle>
      <circle cx="8.5" cy="15.5" r="1.5" fill="currentColor"></circle>
      <circle cx="12" cy="12" r="1.5" fill="currentColor"></circle>
    </svg>
  );

  const allGuestsRef = useRef([]);
  useEffect(() => { allGuestsRef.current = allGuests; }, [allGuests]);
  const scannerRef = useRef(null);

  const handlePublicLogin = (e) => {
    e.preventDefault();
    const finalName = tempPublicName.trim();
    if (!finalName) return;
    setGuestName(finalName);
    localStorage.setItem(publicNameKey, finalName);
  };

  const handleGuestLogout = () => {
    setAuthGuest(null);
    setGuestName('');
    setGuestAvatar('');
    localStorage.removeItem(publicNameKey);
    localStorage.removeItem(privateIdKey);
    localStorage.removeItem(privateNameKey);
    localStorage.removeItem(avatarKey);
    setShowMenu(false);
  };

  const ejecutarLogin = async (codigoIngresado) => {
    const code = (codigoIngresado || '').trim().toLowerCase();
    if (!code) return;
    
    let foundUser = null;
    for (const g of allGuestsRef.current) {
      if (g.id && g.id.toLowerCase() === code) { foundUser = { id: g.id, name: g.name }; break; }
      if (g.subGuests && g.subGuests.length > 0) {
        const sub = g.subGuests.find(sg => (sg.id || '').toLowerCase() === code);
        if (sub) { foundUser = { id: sub.id, name: sub.name }; break; }
      }
    }

    if (!foundUser) {
       let parentId = code;
       if (code.startsWith('usr_')) {
          const parts = code.split('_');
          if (parts.length >= 3) parentId = parts[1]; 
       }
       try {
         const docSnap = await getDoc(doc(db, "eventos", eventId, "invitados", parentId));
         if (docSnap.exists()) {
           const gData = docSnap.data();
           if (docSnap.id.toLowerCase() === code) foundUser = { id: docSnap.id, name: gData.name };
           else if (gData.subGuests) {
             const sub = gData.subGuests.find(sg => (sg.id || '').toLowerCase() === code);
             if (sub) foundUser = { id: sub.id, name: sub.name };
           }
         }
       } catch(e) {}
    }

    if (foundUser) {
      setAuthGuest(foundUser);
      localStorage.setItem(privateIdKey, foundUser.id);
      localStorage.setItem(privateNameKey, foundUser.name);
      window.history.replaceState({}, document.title, window.location.pathname + "?modo=camara&e=" + eventId);
    } else {
      showToast("Código no reconocido. Revisa tu pulsera.", "error");
      setTimeout(() => { if (!authGuest) startLoginScanner(); }, 2000);
    }
  };

  const startLoginScanner = () => {
    if (!window.Html5Qrcode) {
      setTimeout(startLoginScanner, 500);
      return;
    }
    setIsScanning(true);
    setTimeout(() => {
      try {
        const html5QrCode = new window.Html5Qrcode("qr-reader-login");
        scannerRef.current = html5QrCode;
        html5QrCode.start(
          { facingMode: "environment" },
          { fps: 15, aspectRatio: 1.0, qrbox: function(width, height) { return { width: width * 0.95, height: height * 0.95 }; }},
          (decodedText) => {
             if (scannerRef.current && scannerRef.current.isScanning) scannerRef.current.pause();
             let code = decodedText;
             try {
                const parsedUrl = new URL(decodedText);
                code = parsedUrl.searchParams.get('u') || parsedUrl.searchParams.get('usr') || parsedUrl.searchParams.get('uid') || parsedUrl.searchParams.get('invitado') || code;
             } catch(e) {}
             
             if (!code || code === 'null' || code === 'undefined') { 
                showToast("Código inválido", "error"); 
                if (scannerRef.current) scannerRef.current.resume();
                return; 
             }
             setGuestCode(code);
             if (scannerRef.current) {
                scannerRef.current.stop().then(() => {
                   scannerRef.current.clear();
                   setIsScanning(false);
                   ejecutarLogin(code); 
                }).catch(() => {
                   setIsScanning(false);
                   ejecutarLogin(code);
                });
             } else {
                setIsScanning(false);
                ejecutarLogin(code);
             }
          },
          (err) => {}
        ).catch(err => {
           setIsScanning(false);
           showToast("Permite el uso de la Cámara para acceder.", "error");
        });
      } catch(e) { setIsScanning(false); }
    }, 200);
  };

  useEffect(() => {
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = "viewport"; document.head.appendChild(meta); }
    meta.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0";
    try { if (typeof setGlobalEventId === 'function') setGlobalEventId(eventId); } catch(e){}

    if (!window.Html5QrcodeScanner && !document.getElementById('qr-script')) {
      const script = document.createElement('script');
      script.id = 'qr-script';
      script.src = "https://unpkg.com/html5-qrcode";
      script.async = true;
      document.body.appendChild(script);
    }

    const unsubConfig = onSnapshot(doc(db, "eventos", eventId), (docSnap) => {
      if (docSnap.exists()) {
         const data = docSnap.data();
         if (data.galeriaConfig) setConfig(data.galeriaConfig);
      }
    });

    const unsubFotos = onSnapshot(collection(db, "eventos", eventId, "fotos"), (snap) => {
      const fotosOrdenadas = snap.docs.map(doc => ({ id: doc.id, ...doc.data() })).sort((a, b) => b.id - a.id);
      setFeedFotos(fotosOrdenadas);
      if (activePostComments) {
        const updatedPost = fotosOrdenadas.find(f => f.id === activePostComments.id);
        if (updatedPost) setActivePostComments(updatedPost);
      }
    });

    const unsubGuests = onSnapshot(collection(db, "eventos", eventId, "invitados"), (snap) => {
      setAllGuests(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    const unsubActivity = onSnapshot(collection(db, "eventos", eventId, "actividad_social"), (snap) => {
      setSocialActivity(snap.docs.map(doc => doc.data()).sort((a, b) => b.timestamp - a.timestamp));
    });

    return () => { unsubConfig(); unsubFotos(); unsubGuests(); unsubActivity(); };
  }, [activePostComments, eventId]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target)) setShowSocialBell(false);
      if (menuRef.current && !menuRef.current.contains(event.target)) setShowMenu(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let uid = urlParams.get('u') || urlParams.get('usr') || urlParams.get('invitado'); 
    if (uid && allGuests.length > 0 && !authGuest) ejecutarLogin(uid);
  }, [allGuests]);

  useEffect(() => {
     let timer;
     if (config && config.modoPublico === false && !authGuest) {
         timer = setTimeout(() => { startLoginScanner(); }, 1000); 
     }
     return () => {
         if (timer) clearTimeout(timer);
         if (scannerRef.current && scannerRef.current.isScanning) {
            scannerRef.current.stop().catch(e=>e);
         }
     }
  }, [config, authGuest]);

  // 🟢 1. BLINDAJE DE NOTIFICACIONES
  const notifySocial = async (tipo, targetUser, fotoId, textoExtra = '', fotoUrl = '') => {
    try {
      if (!currentUserName) return; 
      const id = Date.now().toString() + Math.random().toString(36).substring(2);
      
      const safeData = JSON.parse(JSON.stringify({
        id: id, 
        tipo: tipo || '', 
        actorName: currentUserName || 'Anónimo', 
        actorAvatar: guestAvatar || '', 
        targetUser: targetUser || 'Anónimo', 
        fotoId: String(fotoId) || '', 
        textoExtra: textoExtra || '', 
        fotoUrl: fotoUrl || '', 
        timestamp: Date.now()
      }));

      await setDoc(doc(db, "eventos", eventId, "actividad_social", id), safeData);
    } catch (err) {
      console.error("Error silenciado en notifySocial:", err);
    }
  };

  const handleAvatarSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsAvatarUploading(true);
    setShowMenu(false);
    try {
      const formData = new FormData(); formData.append("file", file); formData.append("upload_preset", uploadPreset);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, { method: "POST", body: formData });
      const data = await res.json();
      if (data.secure_url) {
        const urlParts = data.secure_url.split('/upload/');
        const avatarUrl = `${urlParts[0]}/upload/c_thumb,g_face,h_150,w_150,f_auto,q_auto/${urlParts[1]}`;
        
        setGuestAvatar(avatarUrl);
        localStorage.setItem(avatarKey, avatarUrl);

        if (currentUserName) {
          const promesasUpdate = feedFotos.map(foto => {
            let changesMade = false;
            let updatedFoto = { ...foto };
            if (updatedFoto.autor === currentUserName && updatedFoto.avatar !== avatarUrl) { updatedFoto.avatar = avatarUrl; changesMade = true; }
            if (updatedFoto.comentarios) {
              updatedFoto.comentarios = updatedFoto.comentarios.map(c => {
                let newC = { ...c };
                if (newC.autor === currentUserName && newC.avatar !== avatarUrl) { newC.avatar = avatarUrl; changesMade = true; }
                if (newC.replies) {
                  newC.replies = newC.replies.map(r => {
                    if (r.autor === currentUserName && r.avatar !== avatarUrl) { changesMade = true; return { ...r, avatar: avatarUrl }; }
                    return r;
                  });
                }
                return newC;
              });
            }
            if (changesMade) {
               const cleanData = JSON.parse(JSON.stringify(updatedFoto));
               return setDoc(doc(db, "eventos", eventId, "fotos", foto.id), cleanData, { merge: true });
            }
            return Promise.resolve();
          });
          await Promise.all(promesasUpdate);
        }
      }
    } catch (error) { 
      showToast("Error al subir foto de perfil.", "error"); 
    } finally { 
      setIsAvatarUploading(false); 
    }
  };

  const generarReto = () => {
    const retoAzar = retos[Math.floor(Math.random() * retos.length)];
    setActiveChallenge(retoAzar);
  };

  const openChallengeModal = () => {
    generarReto();
    setShowChallengeModal(true);
  };

  const initiatePost = (e) => {
    const files = Array.from(e.target.files).slice(0, 10);
    if (files.length === 0) return;
    const previewUrls = files.map(f => URL.createObjectURL(f));
    const initialCaption = activeChallenge ? `¡Reto cumplido! 🎲\n${activeChallenge}` : '';
    setPostDraft({ files, previewUrls, caption: initialCaption, emotion: '', location: '' });
    if (fileInputRef.current) fileInputRef.current.value = "";
    setActiveChallenge(null); 
  };

  const cancelPost = () => {
    if (postDraft && postDraft.previewUrls) {
       postDraft.previewUrls.forEach(url => URL.revokeObjectURL(url));
    }
    setPostDraft(null);
  };

  const publishPost = async () => {
    if (!currentUserName) { showToast("Ingresa tu nombre para publicar.", "error"); return; }
    setIsUploading(true);

    try {
      const uploadPromises = postDraft.files.map(async (file) => {
        const formData = new FormData(); formData.append("file", file); formData.append("upload_preset", uploadPreset);
        const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, { method: "POST", body: formData });
        const data = await res.json();
        if (data.secure_url) {
          const urlParts = data.secure_url.split('/upload/');
          return `${urlParts[0]}/upload/c_fill,g_auto,ar_4:5,w_1080,f_auto,q_auto/${urlParts[1]}`;
        }
        return null;
      });

      const uploadedUrls = await Promise.all(uploadPromises);
      const validUrls = uploadedUrls.filter(url => url !== null);
      if (validUrls.length === 0) throw new Error("Fallo al procesar fotos.");

      let finalCaption = (postDraft.caption || '').trim();
      if (config?.hashtag && !finalCaption.toLowerCase().includes(config.hashtag.toLowerCase())) {
         finalCaption = finalCaption ? `${finalCaption} ${config.hashtag}` : config.hashtag;
      }

      const nuevaFoto = JSON.parse(JSON.stringify({
        id: Date.now().toString(), 
        urls: validUrls, 
        autor: currentUserName, 
        avatar: guestAvatar || '', 
        mensaje: finalCaption,
        emotion: postDraft.emotion || "",
        location: postDraft.location || "",
        fecha: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        likes: [], 
        comentarios: [],
        status: config?.moderacion ? 'pending' : 'approved'
      }));
      
      await setDoc(doc(db, "eventos", eventId, "fotos", nuevaFoto.id), nuevaFoto);
      
      if (postDraft && postDraft.previewUrls) {
         postDraft.previewUrls.forEach(url => URL.revokeObjectURL(url));
      }
      setPostDraft(null);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      if(config?.moderacion) showToast("¡Subida! Se mostrará en pantalla en breve.", "info");
    } catch (error) { 
      showToast("Hubo un error al intentar publicar.", "error"); 
      if (postDraft && postDraft.previewUrls) postDraft.previewUrls.forEach(url => URL.revokeObjectURL(url));
      setPostDraft(null);
    } finally {
      setIsUploading(false);
    }
  };

  // 🟢 2. LIMPIEZA PROFUNDA DE LIKES Y COMENTARIOS
  const toggleLike = async (foto) => {
    try {
      if (!currentUserName) { showToast("Por favor, ingresa tu nombre para interactuar.", "error"); return; }
      let likesArray = Array.isArray(foto.likes) ? [...foto.likes] : [];
      const isLiking = !likesArray.includes(currentUserName);
      
      if (isLiking) {
        likesArray.push(currentUserName);
        const coverUrl = foto.urls ? foto.urls[0] : (foto.url || '');
        notifySocial('like_foto', foto.autor || 'Anónimo', String(foto.id), '', coverUrl);
      } else {
        likesArray = likesArray.filter(name => name !== currentUserName);
      }
      
      // 🟢 GUARDAMOS LA FOTO COMPLETA, PERO LIMPIA
      const updatedPhoto = { ...foto, likes: likesArray };
      const cleanPhoto = JSON.parse(JSON.stringify(updatedPhoto));
      await setDoc(doc(db, "eventos", eventId, "fotos", String(foto.id)), cleanPhoto);
    } catch (error) {
      console.error("Error guardando like:", error);
      showToast("Error FB: " + error.message, "error"); // 🔴 REVELADOR DE ERRORES
    }
  };

  const toggleCommentLike = async (foto, isReply = false, commentId, replyId = null) => {
    try {
      if (!currentUserName) return;
      let updatedComments = Array.isArray(foto.comentarios) ? [...foto.comentarios] : (foto.comentarios ? Object.values(foto.comentarios) : []);
      const cIndex = updatedComments.findIndex(c => c.id === commentId);
      if (cIndex === -1) return;

      const coverUrl = foto.urls ? foto.urls[0] : (foto.url || '');

      if (!isReply) {
        let likes = Array.isArray(updatedComments[cIndex].likes) ? updatedComments[cIndex].likes : [];
        const isLiking = !likes.includes(currentUserName);
        if (isLiking) {
          likes.push(currentUserName);
          notifySocial('like_comment', updatedComments[cIndex].autor || 'Anónimo', String(foto.id), '', coverUrl);
        } else likes = likes.filter(n => n !== currentUserName);
        updatedComments[cIndex].likes = likes;
      } else {
        let replies = Array.isArray(updatedComments[cIndex].replies) ? updatedComments[cIndex].replies : [];
        const rIndex = replies.findIndex(r => r.id === replyId);
        if (rIndex > -1) {
          let likes = Array.isArray(replies[rIndex].likes) ? replies[rIndex].likes : [];
          const isLiking = !likes.includes(currentUserName);
          if (isLiking) {
            likes.push(currentUserName);
            notifySocial('like_comment', replies[rIndex].autor || 'Anónimo', String(foto.id), '', coverUrl); 
          } else likes = likes.filter(n => n !== currentUserName);
          replies[rIndex].likes = likes;
        }
      }
      
      // 🟢 GUARDAMOS LA FOTO COMPLETA, PERO LIMPIA
      const updatedPhoto = { ...foto, comentarios: updatedComments };
      const cleanPhoto = JSON.parse(JSON.stringify(updatedPhoto));
      await setDoc(doc(db, "eventos", eventId, "fotos", String(foto.id)), cleanPhoto);
    } catch (error) {
      console.error("Error like en comentario:", error);
      showToast("Error FB: " + error.message, "error"); // 🔴 REVELADOR DE ERRORES
    }
  };

  const handleAddComment = async () => {
    try {
      const foto = activePostComments;
      if (!currentUserName || !commentText.trim() || !foto) return;

      let finalComment = commentText.trim();
      if (!replyingTo && config?.hashtag && !finalComment.toLowerCase().includes(config.hashtag.toLowerCase())) finalComment += ` ${config.hashtag}`;

      let updatedComments = Array.isArray(foto.comentarios) ? [...foto.comentarios] : (foto.comentarios ? Object.values(foto.comentarios) : []);
      const newObj = { id: Date.now().toString(), autor: currentUserName, avatar: guestAvatar || '', texto: finalComment, likes: [] };
      const coverUrl = foto.urls ? foto.urls[0] : (foto.url || '');

      if (replyingTo) {
        const cIndex = updatedComments.findIndex(c => c.id === replyingTo.commentId);
        if (cIndex > -1) {
          let currentReplies = Array.isArray(updatedComments[cIndex].replies) ? updatedComments[cIndex].replies : [];
          updatedComments[cIndex].replies = [...currentReplies, newObj];
          notifySocial('reply_comment', replyingTo.autor || 'Anónimo', String(foto.id), finalComment, coverUrl); 
        }
      } else {
        newObj.replies = [];
        updatedComments.push(newObj);
        notifySocial('comment_foto', foto.autor || 'Anónimo', String(foto.id), finalComment, coverUrl); 
      }
      
      // 🟢 GUARDAMOS LA FOTO COMPLETA, PERO LIMPIA
      const updatedPhoto = { ...foto, comentarios: updatedComments };
      const cleanPhoto = JSON.parse(JSON.stringify(updatedPhoto));
      await setDoc(doc(db, "eventos", eventId, "fotos", String(foto.id)), cleanPhoto);
      
      setCommentText(''); setReplyingTo(null);
    } catch (error) {
      console.error("Error guardando comentario:", error);
      showToast("Error FB: " + error.message, "error"); // 🔴 REVELADOR DE ERRORES
    }
  };

  const storageKey = `baulia_lastReadSocial_${eventId}_${currentUserName}`;
  const lastReadStamp = Number(localStorage.getItem(storageKey) || 0);
  const myNotifications = socialActivity.filter(a => a.targetUser === currentUserName);
  const unreadCount = myNotifications.filter(a => a.timestamp > lastReadStamp).length;

  const handleOpenBell = () => {
    setShowSocialBell(!showSocialBell);
    setShowMenu(false);
    if (!showSocialBell) localStorage.setItem(storageKey, Date.now()); 
  };

  const openNotificationPost = (fotoId, tipo) => {
    setShowSocialBell(false); 
    const postEl = document.getElementById(`post_${fotoId}`);
    if (postEl) {
      const yOffset = -70; 
      const y = postEl.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      
      postEl.classList.add('ring-4', 'ring-pink-500', 'ring-offset-2', 'transition-all', 'duration-500');
      setTimeout(() => postEl.classList.remove('ring-4', 'ring-pink-500', 'ring-offset-2'), 2500);
      
      if (tipo.includes('comment')) {
        setTimeout(() => {
          const fotoDestino = feedFotos.find(f => String(f.id) === String(fotoId));
          if (fotoDestino) setActivePostComments(fotoDestino);
        }, 600);
      }
    } else {
      showToast("Esta foto ya no está disponible.", "info");
    }
  };

  const renderLikesText = (likesArr) => {
    if(!likesArr || likesArr.length === 0) return 'Sé el primero en dar Me gusta';
    if(likesArr.length === 1) return `Le gusta a ${likesArr[0]}`;
    if(likesArr.length === 2) return `Le gusta a ${likesArr[0]} y ${likesArr[1]}`;
    return `Le gusta a ${likesArr[0]}, ${likesArr[1]} y ${likesArr.length - 2} más`;
  };

  const renderTextWithHashtags = (text) => {
    if (!text) return null;
    return text.split(/(#[a-zA-Z0-9_áéíóúñÁÉÍÓÚÑ]+)/g).map((part, i) => {
      if (part.startsWith('#')) return <span key={i} className="font-bold text-pink-500 cursor-pointer">{part}</span>;
      if (part.startsWith('@')) return <span key={i} className="font-bold text-indigo-500">{part}</span>;
      return part;
    });
  };

  const ToastOverlay = () => {
    if (!toast) return null;
    return (
      <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[9999] animate-in slide-in-from-top-4 fade-in duration-300">
        <div className={`px-5 py-3 rounded-full shadow-2xl flex items-center gap-3 text-sm font-bold text-white border border-white/20 ${toast.type === 'error' ? 'bg-rose-600' : toast.type === 'success' ? 'bg-emerald-600' : 'bg-slate-800'}`}>
          {toast.type === 'error' ? <AlertCircle size={18} /> : toast.type === 'success' ? <CheckCircle size={18} /> : <Info size={18} />}
          {toast.text}
        </div>
      </div>
    );
  };

  if (config && config.modoPublico === false && !authGuest) {
    return (
      <div className={`min-h-screen ${tBgBase} flex flex-col items-center justify-center p-6 relative overflow-hidden font-sans`}>
        <style>{`
          #qr-reader-login { width: 100% !important; height: 100% !important; border: none !important; position: absolute !important; inset: 0 !important; }
          #qr-reader-login video { object-fit: cover !important; width: 100% !important; height: 100% !important; border-radius: 1.5rem !important; }
          #qr-reader-login canvas { display: none !important; }
        `}</style>
        <ToastOverlay />
        <div className="absolute top-0 w-full h-64 bg-pink-600/10 hidden md:block blur-[100px] rounded-full pointer-events-none"></div>
        <div className={`w-full max-w-sm ${tBgCard} border ${tBorder} backdrop-blur-xl rounded-3xl shadow-2xl p-8 text-center z-10 flex flex-col`}>
          <h1 className={`text-2xl font-black ${tTextMain} mb-2 tracking-tight`}>Red Privada</h1>
          <p className={`${tTextSub} text-xs mb-6`}>Apunta a la pulsera para ingresar a la fiesta.</p>
          
          <div className="w-full max-w-[350px] mx-auto bg-slate-900 rounded-3xl overflow-hidden relative shadow-2xl flex-shrink-0 aspect-square mb-6 border-4 border-pink-500/30">
            {isScanning ? (
              <>
                 <div id="qr-reader-login"></div>
                 <div className="absolute inset-0 border-[30px] border-black/40 pointer-events-none z-10"></div>
                 <div className="absolute inset-0 border-2 border-pink-400 m-[30px] pointer-events-none z-10 opacity-70">
                   <div className="w-full h-0.5 bg-pink-400 shadow-[0_0_15px_#f472b6] absolute top-1/2 -translate-y-1/2 opacity-60 animate-pulse"></div>
                 </div>
              </>
            ) : (
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white bg-slate-800 p-6 text-center z-50">
                <Camera size={48} className="text-pink-500 mb-4 animate-pulse"/>
                <span className="font-bold text-sm text-slate-400">Iniciando cámara...</span>
              </div>
            )}
          </div>
          
          <div className="relative flex items-center justify-center mb-6 mt-auto">
            <div className={`border-t ${tBorder} w-full`}></div>
            <span className={`${tBgCard} px-3 text-xs ${tTextSub} font-bold uppercase tracking-widest absolute`}>O escribe tu código</span>
          </div>

          <div className="flex gap-2">
            <input type="text" placeholder="Ej. usr_123_0" value={guestCode} onChange={(e) => setGuestCode(e.target.value)} className={`w-full ${tInputBg} border ${tBorder} p-4 rounded-xl outline-none focus:ring-2 focus:ring-pink-500 transition-all text-center font-bold ${tTextMain} text-base sm:text-lg uppercase`} />
            <button onClick={() => ejecutarLogin(guestCode)} className="px-5 bg-pink-600 text-white font-bold rounded-xl shadow-lg hover:bg-pink-700 transition-transform active:scale-95"><ArrowRight size={24}/></button>
          </div>
        </div>
      </div>
    );
  }

  if (config?.modoPublico && !guestName) {
    return (
      <div className={`min-h-screen ${tBgBase} flex flex-col items-center justify-center p-6 relative overflow-hidden font-sans`}>
        <ToastOverlay />
        <div className="absolute top-0 w-full h-64 bg-indigo-600/10 hidden md:block blur-[100px] rounded-full pointer-events-none"></div>
        <div className={`w-full max-w-sm ${tBgCard} border ${tBorder} backdrop-blur-xl rounded-3xl shadow-2xl p-8 text-center z-10 flex flex-col animate-in zoom-in-95 duration-500`}>
          <div className="w-16 h-16 bg-indigo-500/20 text-indigo-500 rounded-full flex items-center justify-center mx-auto mb-4 border border-indigo-500/30">
             <Users size={32} />
          </div>
          <h1 className={`text-2xl font-black ${tTextMain} mb-2 tracking-tight`}>¡Bienvenido!</h1>
          <p className={`${tTextSub} text-xs mb-8`}>Ingresa tu nombre para firmar tus fotos y comentarios en el Muro Social.</p>
          
          <form onSubmit={handlePublicLogin} className="flex flex-col gap-4">
            <input type="text" placeholder="Ej. Familia López" value={tempPublicName} onChange={(e) => setTempPublicName(e.target.value)} required className={`w-full ${tInputBg} border ${tBorder} p-4 rounded-xl outline-none focus:ring-2 focus:ring-indigo-500 transition-all text-center font-bold ${tTextMain} text-base`} />
            <button type="submit" className="w-full py-4 bg-indigo-600 text-white font-black uppercase tracking-widest text-[10px] rounded-xl shadow-lg hover:bg-indigo-700 transition-transform active:scale-95">
               Entrar a la Galería
            </button>
          </form>
        </div>
      </div>
    );
  }

  const hasPosted = feedFotos.some(f => f.autor === currentUserName);

  return (
    <div className={`min-h-screen ${tBgBase} font-sans relative w-full flex flex-col`}>
      <ToastOverlay />

      <div className={`sticky top-0 z-[150] w-full ${tBgCard} border-b ${tBorder} shadow-sm flex justify-center transition-colors duration-300`}>
        <div className="w-full max-w-lg px-4 py-3 flex items-center justify-between">
          
          <div className="flex items-center gap-3 relative" ref={menuRef}>
            <button onClick={() => {setShowMenu(!showMenu); setShowSocialBell(false);}} className={`p-1.5 rounded-lg ${tTextMain} hover:bg-zinc-500/10 transition-colors`}>
              <Menu size={24} />
            </button>

            {showMenu && (
              <div className={`absolute top-12 left-0 w-56 ${tBgCard} border ${tBorder} shadow-2xl rounded-2xl p-2 z-[200] animate-in slide-in-from-top-2`}>
                <label className={`flex items-center w-full px-4 py-3 rounded-xl hover:bg-indigo-500 hover:text-white cursor-pointer transition-colors ${tTextMain}`}>
                  <Camera size={16} className="mr-3"/> <span className="text-sm font-bold">Cambiar foto</span>
                  <input type="file" accept="image/*" className="hidden" onChange={handleAvatarSelect} />
                </label>
                <button onClick={toggleTheme} className={`flex items-center w-full px-4 py-3 rounded-xl hover:bg-indigo-500 hover:text-white transition-colors ${tTextMain}`}>
                  <Moon size={16} className="mr-3"/> <span className="text-sm font-bold">{isDarkMode ? 'Modo Día' : 'Modo Noche'}</span>
                </button>
                <div className={`w-full h-px ${tBorder} my-1`}></div>
                
                <button onClick={handleGuestLogout} className={`flex items-center w-full px-4 py-3 rounded-xl hover:bg-rose-500 hover:text-white transition-colors text-rose-500`}>
                  <LogOut size={16} className="mr-3"/> <span className="text-sm font-bold">Cerrar Sesión</span>
                </button>
              </div>
            )}

            <div onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})} className="flex items-center gap-2 cursor-pointer">
              <div className={`w-9 h-9 rounded-full ${tBgBase} overflow-hidden border ${tBorder} flex-shrink-0 relative`}>
                 {isAvatarUploading ? <RefreshCw size={14} className="absolute inset-0 m-auto text-indigo-500 animate-spin"/> : guestAvatar ? <img src={guestAvatar} className="w-full h-full object-cover"/> : <span className={`font-bold ${tTextSub} flex items-center justify-center h-full`}>{(currentUserName || '?').charAt(0).toUpperCase()}</span>}
              </div>
              <span className={`font-black text-sm ${tTextMain} truncate max-w-[120px] tracking-tight`}>{currentUserName}</span>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button onClick={openChallengeModal} className={`relative p-1 text-amber-500 hover:text-amber-400 hover:scale-110 transition-transform group`} title="Jugar un Reto">
              <div className="absolute inset-0 bg-amber-400/20 rounded-full blur-md animate-pulse"></div>
              <DiceIcon size={24} className="relative z-10 drop-shadow-[0_0_5px_rgba(245,158,11,0.5)]" />
            </button>

            <button onClick={() => { setActiveChallenge(null); if (fileInputRef.current) fileInputRef.current.click(); }} className={`${tTextMain} hover:text-pink-500 transition-colors`} title="Subir foto libre">
              <div className="border-[2.5px] border-current rounded-[8px] p-0.5 flex items-center justify-center">
                <Plus size={16} strokeWidth={3} />
              </div>
            </button>

            <div className="relative" ref={bellRef}>
              <button onClick={handleOpenBell} className={`relative mt-1 ${showSocialBell ? 'text-pink-500' : tTextMain} hover:text-pink-500 transition-colors`}>
                <Heart size={24} className={showSocialBell ? 'fill-pink-500' : ''}/>
                {unreadCount > 0 && <span className="absolute -top-1 -right-1 w-4 h-4 bg-rose-500 border-2 border-white rounded-full text-[9px] font-bold text-white flex items-center justify-center animate-bounce">{unreadCount}</span>}
              </button>

              {showSocialBell && (
                <div className={`absolute right-0 mt-3 w-80 sm:w-80 w-[90vw] ${tBgCard} shadow-2xl rounded-2xl border ${tBorder} overflow-hidden z-[200] text-left animate-in slide-in-from-top-2`}>
                  <div className={`p-3 border-b ${tBorder} font-bold ${tTextMain} text-sm flex justify-between items-center`}>
                    Actividad <button onClick={() => setShowSocialBell(false)} className={`${tTextSub} hover:text-rose-500`}><X size={14}/></button>
                  </div>
                  <div className="max-h-72 overflow-y-auto">
                     {myNotifications.length === 0 ? <p className={`p-6 text-center text-xs ${tTextSub} font-medium`}>Aún no tienes notificaciones.</p> :
                       myNotifications.map((n, idx) => {
                         const isNew = n.timestamp > lastReadStamp;
                         return (
                            <div key={idx} onClick={() => openNotificationPost(n.fotoId, n.tipo)} className={`flex items-start p-3 border-b ${tBorder} cursor-pointer transition-colors ${isNew ? (isDarkMode ? 'bg-indigo-900/40' : 'bg-pink-50/40') : `hover:${tBgBase}`}`}>
                               <div className={`w-8 h-8 rounded-full ${tBgBase} mr-3 flex-shrink-0 overflow-hidden border ${tBorder}`}>
                                  {n.actorAvatar ? <img src={n.actorAvatar} className="w-full h-full object-cover" /> : <span className={`w-full h-full flex items-center justify-center text-xs font-bold ${tTextSub}`}>{(n.actorName || '?').charAt(0).toUpperCase()}</span>}
                               </div>
                               <div className="flex-1 pr-2">
                                  <p className={`text-xs ${tTextMain} leading-snug`}>
                                     {n.tipo === 'like_foto' && <span><b className="font-bold">{n.actorName || 'Alguien'}</b> le dio Me gusta a tu foto.</span>}
                                     {n.tipo === 'comment_foto' && <span><b className="font-bold">{n.actorName || 'Alguien'}</b> comentó: {n.textoExtra}</span>}
                                     {n.tipo === 'like_comment' && <span>A <b className="font-bold">{n.actorName || 'Alguien'}</b> le gustó tu comentario.</span>}
                                     {n.tipo === 'reply_comment' && <span><b className="font-bold">{n.actorName || 'Alguien'}</b> te respondió: {n.textoExtra}</span>}
                                  </p>
                                  <p className={`text-[9px] ${tTextSub} mt-1`}>{new Date(n.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                               </div>
                               {n.fotoUrl && (
                                 <div className={`w-10 h-10 flex-shrink-0 rounded-md border ${tBorder} overflow-hidden shadow-sm ml-1`}>
                                   <img src={n.fotoUrl} className="w-full h-full object-cover" />
                                 </div>
                               )}
                               {isNew && <div className="w-2 h-2 rounded-full bg-pink-500 ml-2 mt-4 flex-shrink-0"></div>}
                            </div>
                         )
                       })
                     }
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-lg mx-auto pt-6 px-4 pb-20 flex flex-col items-center">
        <input type="file" accept="image/*" multiple ref={fileInputRef} onChange={initiatePost} className="hidden" />

        {!hasPosted && !postDraft && (
           <div className={`w-full ${tBgCard} rounded-3xl shadow-sm p-8 text-center z-10 mb-8 border ${tBorder} flex flex-col items-center`}>
              <div className="w-16 h-16 bg-gradient-to-tr from-pink-500 to-indigo-500 rounded-full flex items-center justify-center text-white mb-4 shadow-lg">
                 <Camera size={28} />
              </div>
              <h2 className={`text-xl font-black ${tTextMain} mb-2`}>¡Bienvenido a la fiesta!</h2>
              <p className={`${tTextSub} text-xs mb-6 px-4`}>Eres el alma de este evento. Sube una foto o completa un reto divertido.</p>
              
              <button onClick={() => { setActiveChallenge(null); if (fileInputRef.current) fileInputRef.current.click(); }} className="w-full py-3.5 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl shadow-md transition-all active:scale-95 flex items-center justify-center mb-3">
                 <ImageIcon size={18} className="mr-2"/> Subir foto libre
              </button>

              <button onClick={openChallengeModal} className="relative w-full py-3.5 bg-slate-900 border border-amber-500/50 text-amber-400 font-black rounded-xl shadow-[0_0_15px_rgba(245,158,11,0.2)] transition-all active:scale-95 flex items-center justify-center overflow-hidden">
                 <div className="absolute inset-0 bg-amber-400/10 animate-pulse"></div>
                 <DiceIcon size={20} className="mr-2 relative z-10 drop-shadow-[0_0_5px_rgba(245,158,11,0.8)]" />
                 <span className="relative z-10 tracking-wide uppercase">Misión Secreta</span>
              </button>
           </div>
        )}

        <div className="w-full space-y-8">
          {feedFotos.map((foto) => {
            if (config?.moderacion && foto.status === 'pending' && foto.autor !== currentUserName) return null;
            const isPending = config?.moderacion && foto.status === 'pending';

            const likesArr = Array.isArray(foto.likes) ? foto.likes : (foto.likes ? Object.values(foto.likes) : []);
            const hasLiked = currentUserName && likesArr.includes(currentUserName);
            const urls = foto.urls || [foto.url || '']; 
            
            const comentariosArr = Array.isArray(foto.comentarios) ? foto.comentarios : (foto.comentarios ? Object.values(foto.comentarios) : []);
            const commentCount = comentariosArr.reduce((acc, c) => {
               const repArr = Array.isArray(c.replies) ? c.replies : (c.replies ? Object.values(c.replies) : []);
               return acc + 1 + repArr.length;
            }, 0);
            
            return (
              <div id={`post_${foto.id}`} key={foto.id} className={`${tBgCard} rounded-3xl border ${isPending ? 'border-amber-500' : tBorder} shadow-sm overflow-hidden animate-in slide-in-from-bottom-4 transition-colors duration-300 relative`}>
                
                {isPending && <div className="absolute top-3 left-3 z-20 bg-amber-500 text-white text-[10px] font-black px-3 py-1 rounded-full shadow-md flex items-center"><AlertCircle size={12} className="mr-1"/> PENDIENTE DE APROBACIÓN</div>}

                <div className="p-3.5 flex items-center">
                  <div className={`w-9 h-9 ${tBgBase} rounded-full flex items-center justify-center text-slate-400 font-bold text-xs mr-3 shadow-inner overflow-hidden border ${tBorder} shrink-0`}>
                    {foto.avatar ? <img src={foto.avatar} alt="P" className="w-full h-full object-cover"/> : (foto.autor || '?').charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <p className={`font-bold text-sm ${tTextMain} leading-tight`}>{foto.autor || 'Anónimo'}</p>
                    <p className={`text-[10px] ${tTextSub} font-medium`}>{foto.fecha}</p>
                  </div>
                </div>

                <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar">
                   {urls.map((u, idx) => (
                     <div key={idx} className={`w-full flex-shrink-0 snap-center relative border-y ${tBorder}`}>
                       <img src={u} alt={`Post ${idx}`} className={`w-full h-auto object-cover max-h-[70vh] sm:max-h-[600px] ${tBgBase}`} loading="lazy" />
                       {config?.marcoUrl && <img src={config.marcoUrl} className="absolute inset-0 w-full h-full object-cover pointer-events-none z-10" />}
                       {urls.length > 1 && <div className="absolute top-3 right-3 bg-black/60 text-white text-[10px] font-bold px-2 py-1 rounded-full backdrop-blur-md z-20">{idx + 1} / {urls.length}</div>}
                     </div>
                   ))}
                </div>
                
                <div className="px-4 py-3">
                  <div className="flex items-center space-x-4 mb-2.5">
                    <button onClick={() => toggleLike(foto)} className={`transition-transform active:scale-75 flex items-center ${hasLiked ? 'text-rose-500' : `${tTextMain} opacity-80 hover:opacity-100`}`}>
                      <Heart size={24} className={hasLiked ? 'fill-rose-500' : ''} />
                    </button>
                    <button onClick={() => setActivePostComments(foto)} className={`${tTextMain} opacity-80 hover:opacity-100 transition-transform active:scale-75`}>
                      <MessageCircle size={24} />
                    </button>
                  </div>
                  
                  {likesArr.length > 0 && <p className={`font-bold text-xs ${tTextMain} mb-1.5`}>{renderLikesText(likesArr)}</p>}
                  
                  {(foto.emotion || foto.location) && (
                     <p className={`text-[10px] ${tTextSub} mb-1.5 flex items-center gap-1.5`}>
                        {foto.emotion && <span>Se siente <b>{foto.emotion}</b></span>}
                        {foto.emotion && foto.location && <span>•</span>}
                        {foto.location && <span className="flex items-center"><MapPin size={10} className="mr-0.5"/> {foto.location}</span>}
                     </p>
                  )}

                  {foto.mensaje && <p className={`text-sm ${tTextMain} mb-1.5 leading-snug`}><span className="font-bold mr-2">{foto.autor || 'Anónimo'}</span>{renderTextWithHashtags(foto.mensaje || '')}</p>}
                  
                  {commentCount > 0 && (
                    <button onClick={() => setActivePostComments(foto)} className={`text-xs ${tTextSub} font-medium hover:${tTextMain} transition-colors mt-1 mb-2`}>
                      Ver los {commentCount} comentarios
                    </button>
                  )}
                </div>
              </div>
            );
          })}
          {feedFotos.length === 0 && hasPosted && <p className={`text-center ${tTextSub} font-medium py-10`}>Aún no hay fotos en el muro.</p>}
        </div>
      </div>
      
      {showChallengeModal && (
        <div className="fixed inset-0 z-[400] bg-black/80 backdrop-blur-md flex items-center justify-center p-4 animate-in zoom-in-95 duration-200">
          <div className={`w-full max-w-sm ${tBgCard} border border-amber-500/30 rounded-3xl shadow-[0_0_50px_rgba(245,158,11,0.1)] p-8 text-center flex flex-col items-center relative overflow-hidden`}>
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-400 to-orange-500"></div>
            
            <div className="w-20 h-20 bg-slate-900 border-2 border-amber-400/50 rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(245,158,11,0.3)] mb-6 animate-pulse relative">
              <DiceIcon size={40} className="text-amber-400 drop-shadow-[0_0_10px_rgba(245,158,11,0.8)] relative z-10" />
            </div>
            
            <h3 className={`text-2xl font-black ${tTextMain} mb-2 tracking-tight`}>Misión Secreta</h3>
            <p className={`${tTextSub} text-sm mb-6`}>Cumple este reto y sé la estrella de las pantallas:</p>
            
            <div className="bg-amber-50 border border-amber-200 text-amber-900 p-5 rounded-2xl w-full mb-8 shadow-inner relative overflow-hidden">
              <p className="font-black text-lg leading-snug relative z-10">{activeChallenge}</p>
            </div>

            <div className="w-full space-y-3">
              <button onClick={() => { setShowChallengeModal(false); if(fileInputRef.current) fileInputRef.current.click(); }} className="w-full py-4 bg-gradient-to-r from-amber-400 to-orange-500 text-white font-black rounded-xl shadow-[0_5px_15px_rgba(245,158,11,0.4)] hover:scale-105 transition-transform flex items-center justify-center text-lg">
                <Camera size={20} className="mr-2" /> ¡Aceptar Reto!
              </button>
              <button onClick={generarReto} className={`w-full py-3 ${tBgBase} ${tTextMain} font-bold rounded-xl border ${tBorder} hover:opacity-80 transition-colors flex justify-center items-center`}>
                <RefreshCw size={16} className="mr-2"/> Cambiar misión
              </button>
              <button onClick={() => { setShowChallengeModal(false); setActiveChallenge(null); }} className={`text-sm ${tTextSub} font-bold mt-4 hover:text-rose-500 block w-full`}>
                No quiero jugar
              </button>
            </div>
          </div>
        </div>
      )}

      {postDraft && (
        <div className="fixed inset-0 z-[300] bg-black/60 backdrop-blur-sm flex justify-center items-end sm:items-center sm:p-4 animate-in fade-in duration-200">
           <div className={`w-full sm:max-w-lg h-[95vh] sm:h-auto sm:max-h-[85vh] ${tBgCard} border ${tBorder} flex flex-col rounded-t-3xl sm:rounded-3xl shadow-2xl animate-in slide-in-from-bottom-8 sm:slide-in-from-bottom-0 sm:zoom-in-95`}>
             
             <div className={`flex justify-between items-center p-4 border-b ${tBorder} ${tBgCard} sm:rounded-t-3xl shrink-0`}>
               <button onClick={cancelPost} className={`${tTextSub} text-sm font-bold hover:text-rose-500`}>Cancelar</button>
               <h3 className={`font-black text-lg ${tTextMain}`}>Nueva Publicación</h3>
               <button onClick={publishPost} disabled={isUploading} className="text-pink-500 font-bold text-sm hover:text-pink-600 disabled:opacity-50 transition-opacity">
                 {isUploading ? 'Subiendo...' : 'Publicar'}
               </button>
             </div>

             <div className={`flex-1 overflow-y-auto p-4 space-y-5 custom-scrollbar ${tBgBase} sm:rounded-b-3xl`}>
               <div className="flex overflow-x-auto gap-3 pb-2 snap-x hide-scrollbar">
                 {postDraft.previewUrls.map((url, i) => (
                    <div key={i} className={`relative w-64 sm:w-80 h-80 sm:h-96 flex-shrink-0 snap-center rounded-2xl overflow-hidden border ${tBorder} shadow-sm`}>
                       <img src={url} className="w-full h-full object-cover" />
                       {config?.marcoUrl && <img src={config.marcoUrl} className="absolute inset-0 w-full h-full object-cover pointer-events-none" />}
                    </div>
                 ))}
               </div>

               <div>
                 <textarea placeholder="Escribe un pie de foto..." value={postDraft.caption} onChange={e=>setPostDraft({...postDraft, caption: e.target.value})} className={`w-full p-4 rounded-2xl ${tInputBg} ${tTextMain} outline-none border ${tBorder} resize-none min-h-[100px] text-base sm:text-sm shadow-inner`} />
               </div>
               
               <div className="grid grid-cols-2 gap-3">
                 <div className={`flex items-center px-3 py-3 rounded-xl ${tInputBg} border ${tBorder}`}>
                   <span className="mr-2 text-lg">😀</span>
                   <select value={postDraft.emotion} onChange={e=>setPostDraft({...postDraft, emotion: e.target.value})} className={`bg-transparent outline-none w-full ${tTextMain} text-base sm:text-xs font-bold appearance-none`}>
                     <option value="" className="text-slate-400">¿Cómo te sientes?</option>
                     <option value="Feliz 😊">Feliz 😊</option>
                     <option value="De fiesta 🎉">De fiesta 🎉</option>
                     <option value="Enamorado ❤️">Enamorado ❤️</option>
                     <option value="Bailando 💃">Bailando 💃</option>
                     <option value="Nostálgico ✨">Nostálgico ✨</option>
                   </select>
                 </div>
                 <div className={`flex items-center px-3 py-3 rounded-xl ${tInputBg} border ${tBorder}`}>
                   <button 
                     onClick={() => {
                        showToast("Obteniendo ubicación...", "info");
                        setTimeout(() => setPostDraft({...postDraft, location: "📍 Recepción del Evento"}), 600);
                     }} 
                     className={`mr-2 ${tTextSub} hover:text-indigo-500 transition-colors p-1`}
                     title="Usar ubicación actual"
                   >
                     <MapPin size={16} />
                   </button>
                   <input type="text" placeholder="Añadir ubicación..." value={postDraft?.location || ''} onChange={e=>setPostDraft({...postDraft, location: e.target.value})} className={`w-full bg-transparent outline-none text-base sm:text-xs font-bold ${tTextMain}`} />
                 </div>
               </div>

               {isUploading && (
                  <div className="w-full bg-indigo-100 rounded-full h-2 mt-6 overflow-hidden">
                     <div className="bg-indigo-500 h-2 rounded-full animate-pulse w-full"></div>
                  </div>
               )}
             </div>
           </div>
        </div>
      )}

      {activePostComments && (
        <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex justify-center items-end sm:items-center sm:p-4 animate-in fade-in duration-200">
          <div className={`${tBgCard} w-full sm:max-w-md h-[80vh] sm:h-[600px] rounded-t-3xl sm:rounded-3xl shadow-2xl flex flex-col animate-in slide-in-from-bottom-8 sm:slide-in-from-bottom-0 sm:zoom-in-95 border ${tBorder}`}>
            <div className={`p-4 border-b ${tBorder} flex items-center justify-between shrink-0 ${tBgCard} rounded-t-3xl`}>
              <div className="w-8"></div>
              <h3 className={`font-bold ${tTextMain} text-sm`}>Comentarios</h3>
              <button onClick={() => { setActivePostComments(null); setReplyingTo(null); }} className={`p-1.5 ${tBgBase} rounded-full ${tTextSub} hover:text-rose-500 transition-colors`}><X size={16}/></button>
            </div>
            
            <div className={`flex-1 overflow-y-auto p-4 space-y-4 ${tBgCard} custom-scrollbar`}>
              {activePostComments.mensaje && (
                <div className={`flex items-start mb-4 border-b ${tBorder} pb-4`}>
                  <div className={`w-8 h-8 ${tBgBase} rounded-full mr-3 flex-shrink-0 overflow-hidden border ${tBorder}`}>
                    {activePostComments.avatar ? <img src={activePostComments.avatar} className="w-full h-full object-cover"/> : <span className={`font-bold text-xs ${tTextSub} h-full flex items-center justify-center`}>{(activePostComments.autor || '?').charAt(0).toUpperCase()}</span>}
                  </div>
                  <div>
                    <p className={`text-sm ${tTextMain}`}><span className="font-bold mr-2">{activePostComments.autor || 'Anónimo'}</span>{renderTextWithHashtags(activePostComments.mensaje || '')}</p>
                    <p className={`text-[10px] ${tTextSub} mt-1`}>{activePostComments.fecha}</p>
                  </div>
                </div>
              )}

              {(activePostComments.comentarios || []).length === 0 ? (
                <div className={`text-center ${tTextSub} py-10 text-sm font-medium`}>No hay comentarios aún. ¡Sé el primero!</div>
              ) : (
                (Array.isArray(activePostComments.comentarios) ? activePostComments.comentarios : Object.values(activePostComments.comentarios)).map(c => {
                  const cLiked = Array.isArray(c.likes) && c.likes.includes(currentUserName);
                  return (
                    <div key={c.id} className="flex flex-col">
                      <div className="flex items-start group">
                        <div className={`w-8 h-8 ${tBgBase} rounded-full mr-3 flex-shrink-0 overflow-hidden border ${tBorder}`}>
                          {c.avatar ? <img src={c.avatar} className="w-full h-full object-cover"/> : <span className={`font-bold text-xs ${tTextSub} h-full flex items-center justify-center`}>{(c.autor || '?').charAt(0).toUpperCase()}</span>}
                        </div>
                        <div className="flex-1 pr-2">
                          <p className={`text-sm ${tTextMain}`}><span className="font-bold mr-2">{c.autor || 'Anónimo'}</span>{renderTextWithHashtags(c.texto || '')}</p>
                          <div className="flex items-center gap-3 mt-1">
                            <span className={`text-[10px] ${tTextSub} font-medium`}>{c.likes?.length > 0 ? `${c.likes.length} Me gusta` : ''}</span>
                            <button onClick={() => setReplyingTo({ commentId: c.id, autor: c.autor })} className={`text-[10px] font-bold ${tTextSub} hover:${tTextMain} transition-colors`}>Responder</button>
                          </div>
                        </div>
                        <button onClick={() => toggleCommentLike(activePostComments, false, c.id)} className={`pt-1 transition-transform active:scale-75 ${cLiked ? 'text-rose-500' : `${tTextSub} hover:text-pink-400`}`}><Heart size={12} className={cLiked ? 'fill-rose-500' : ''}/></button>
                      </div>

                      {c.replies && (Array.isArray(c.replies) ? c.replies : Object.values(c.replies)).length > 0 && (
                        <div className="ml-11 mt-3 space-y-3">
                          {(Array.isArray(c.replies) ? c.replies : Object.values(c.replies)).map(r => {
                            const rLiked = Array.isArray(r.likes) && r.likes.includes(currentUserName);
                            return (
                              <div key={r.id} className="flex items-start">
                                <div className={`w-6 h-6 ${tBgBase} rounded-full mr-2 flex-shrink-0 overflow-hidden border ${tBorder}`}>
                                  {r.avatar ? <img src={r.avatar} className="w-full h-full object-cover"/> : <span className={`font-bold text-[9px] ${tTextSub} h-full flex items-center justify-center`}>{(r.autor || '?').charAt(0).toUpperCase()}</span>}
                                </div>
                                <div className="flex-1 pr-2">
                                  <p className={`text-xs ${tTextMain}`}><span className="font-bold mr-1.5">{r.autor || 'Anónimo'}</span>{renderTextWithHashtags(r.texto || '')}</p>
                                  <span className={`text-[9px] ${tTextSub} font-medium mt-0.5 block`}>{r.likes?.length > 0 ? `${r.likes.length} Me gusta` : ''}</span>
                                </div>
                                <button onClick={() => toggleCommentLike(activePostComments, true, c.id, r.id)} className={`pt-1 transition-transform active:scale-75 ${rLiked ? 'text-rose-500' : `${tTextSub} hover:text-pink-400`}`}><Heart size={10} className={rLiked ? 'fill-rose-500' : ''}/></button>
                              </div>
                            )
                          })}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>

            <div className={`p-3 border-t ${tBorder} ${tBgBase} shrink-0 rounded-b-3xl sm:rounded-b-3xl`}>
              {replyingTo && (
                <div className={`flex justify-between items-center text-[10px] ${tTextSub} ${tBgCard} px-3 py-1.5 rounded-t-lg mx-1 -mt-3 mb-2 font-medium border ${tBorder}`}>
                  <span>Respondiendo a <b className={tTextMain}>@{replyingTo.autor}</b></span>
                  <button onClick={() => setReplyingTo(null)} className="hover:text-rose-500"><X size={12}/></button>
                </div>
              )}
              <div className={`flex items-center ${tBgCard} border ${tBorder} rounded-full pl-4 pr-1.5 py-1.5 shadow-sm focus-within:border-indigo-400 transition-colors`}>
                <div className={`w-7 h-7 ${tBgBase} rounded-full mr-2 flex-shrink-0 overflow-hidden border ${tBorder}`}>
                  {guestAvatar ? <img src={guestAvatar} className="w-full h-full object-cover"/> : <span className={`font-bold text-[10px] ${tTextSub} h-full flex items-center justify-center`}>{(currentUserName || '?').charAt(0).toUpperCase()}</span>}
                </div>
                <input 
                  type="text" 
                  placeholder={replyingTo ? `Escribe tu respuesta...` : `Agrega un comentario...`}
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  className={`flex-1 bg-transparent outline-none text-base sm:text-sm ${tTextMain} font-medium`}
                />
                <button onClick={handleAddComment} disabled={!commentText.trim()} className="p-2 bg-indigo-600 text-white rounded-full hover:bg-indigo-700 disabled:bg-slate-400 disabled:text-slate-200 transition-all active:scale-90 ml-1">
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

// ==========================================
// --- COMPONENTE: MODO PROYECTOR (CÓDIGO DE EVENTO DINÁMICO) ---
// ==========================================
const GuestProyectorView = ({ eventId }) => {
  const [photos, setPhotos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentSubIndex, setCurrentSubIndex] = useState(0); 
  const [config, setConfig] = useState({ hashtag: '', moderacion: false, marcoUrl: '' });
  const [isHallOfFame, setIsHallOfFame] = useState(false); 
  
  const [flyingHearts, setFlyingHearts] = useState([]);
  const [liveComments, setLiveComments] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem('proyector_theme') !== 'light');
  const [screenRotation, setScreenRotation] = useState(() => Number(localStorage.getItem('proyector_rotation')) || 0);
  const [windowPortrait, setWindowPortrait] = useState(window.innerHeight > window.innerWidth);

  const [showControls, setShowControls] = useState(true);
  const controlsTimeoutRef = useRef(null);
  const lastPhotoCount = useRef(0);

  // 🟢 LA MAGIA: Memoria de likes y comentarios por foto
  const knownStats = useRef({}); 

  const getCleanBaseUrl = () => {
    let base = window.location.href.split('?')[0];
    if (base.endsWith('/')) base = base.slice(0, -1);
    return base;
  };
  const guestLink = `${getCleanBaseUrl()}/?modo=camara&e=${eventId}`;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(guestLink)}&margin=0`;

  useEffect(() => {
    const unsubConfig = onSnapshot(doc(db, "eventos", eventId), (docSnap) => {
      if (docSnap.exists()) {
         const data = docSnap.data();
         if (data.galeriaConfig) setConfig(data.galeriaConfig);
      }
    });

    const unsubFotos = onSnapshot(collection(db, "eventos", eventId, "fotos"), (snap) => {
      let fotosLimpias = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      fotosLimpias = fotosLimpias.sort((a, b) => b.id - a.id);
      
      if (lastPhotoCount.current > 0 && fotosLimpias.length > lastPhotoCount.current) {
        setCurrentIndex(0);
        setCurrentSubIndex(0);
        setIsHallOfFame(false);
      }
      lastPhotoCount.current = fotosLimpias.length;
      setPhotos(fotosLimpias);
    });

    return () => { unsubConfig(); unsubFotos(); };
  }, [eventId]);

  const displayPhotos = config.moderacion ? photos.filter(f => f.status !== 'pending' && f.status !== 'rejected') : photos;

  // 🟢 REFERENCIA A LA FOTO ACTUAL EN PANTALLA (Para saber a quién lanzarle corazones en vivo)
  const currentPhotoIdRef = useRef(null);
  useEffect(() => {
    if (displayPhotos[currentIndex]) {
      currentPhotoIdRef.current = String(displayPhotos[currentIndex].id);
    }
  }, [currentIndex, displayPhotos]);

  // 🟢 ESCUCHA SOCIAL: Solo lanza en vivo si la foto está en pantalla
  useEffect(() => {
    const timeOnLoad = Date.now(); 
    const unsubActivity = onSnapshot(collection(db, "eventos", eventId, "actividad_social"), (snap) => {
      snap.docChanges().forEach((change) => {
        if (change.type === "added") {
          const data = change.doc.data();
          if (data.timestamp > timeOnLoad) {
             // REGLA DEL CARRUSEL SAGRADO: Solo lanza animaciones en vivo si la foto afectada está en pantalla AHORA MISMO.
             if (String(data.fotoId) === currentPhotoIdRef.current) {
                 if (data.tipo.includes('like')) triggerHearts(12); 
                 if (data.tipo.includes('comment')) showLiveComment(data); 
             }
          }
        }
      });
    });
    return () => unsubActivity();
  }, [eventId]);

  // 🟢 EL REPRODUCTOR INTELIGENTE (Detecta si la foto acumuló cosas mientras estaba escondida)
  useEffect(() => {
    const currentPhoto = displayPhotos[currentIndex];
    if (!currentPhoto || isHallOfFame) return;

    const pid = currentPhoto.id;
    const currentLikesCount = currentPhoto.likes ? currentPhoto.likes.length : 0;
    const currentCommentsList = currentPhoto.comentarios ? (Array.isArray(currentPhoto.comentarios) ? currentPhoto.comentarios : Object.values(currentPhoto.comentarios)) : [];

    const known = knownStats.current[pid] || { likes: 0, comments: [] };

    // 1. ¿Recibió likes nuevos mientras estaba escondida?
    if (currentLikesCount > known.likes) {
       const newLikes = currentLikesCount - known.likes;
       setTimeout(() => triggerHearts(Math.min(newLikes * 3, 20)), 500); 
    }

    // 2. ¿Recibió comentarios nuevos mientras estaba escondida?
    const knownCommentIds = known.comments.map(c => c.id);
    const newComments = currentCommentsList.filter(c => !knownCommentIds.includes(c.id));

    if (newComments.length > 0) {
       newComments.forEach((c, idx) => {
          setTimeout(() => {
             showLiveComment({ actorName: c.autor || c.usuario, actorAvatar: c.avatar, textoExtra: c.texto });
          }, 1000 + (idx * 2000)); // Los lanza uno por uno para que se puedan leer
       });
    }

    // 3. Actualizamos la memoria de la foto
    knownStats.current[pid] = {
       likes: currentLikesCount,
       comments: currentCommentsList
    };

  }, [displayPhotos, currentIndex, isHallOfFame]);

  // EL CARRUSEL SAGRADO (7 Segundos ininterrumpidos)
  useEffect(() => {
    if (displayPhotos.length <= 1 && (!displayPhotos[0]?.urls || displayPhotos[0].urls.length <= 1)) return;

    const currentPost = displayPhotos[currentIndex];
    if (!currentPost) return;

    const urlsCount = (currentPost.urls || [currentPost.url]).filter(u => u !== undefined).length;
    const delay = urlsCount > 1 ? 3000 : 7000; 

    const timer = setTimeout(() => {
      if (isHallOfFame) {
         setIsHallOfFame(false);
         setCurrentIndex((prev) => (prev + 1) % displayPhotos.length);
         setCurrentSubIndex(0);
         return;
      }

      if (currentSubIndex < urlsCount - 1) {
         setCurrentSubIndex(prev => prev + 1);
      } else {
         if (currentIndex > 0 && currentIndex % 5 === 0) {
            setIsHallOfFame(true);
         } else {
            setCurrentIndex((prev) => (prev + 1) % displayPhotos.length);
            setCurrentSubIndex(0);
         }
      }
    }, delay); 

    return () => clearTimeout(timer);
  }, [displayPhotos, currentIndex, currentSubIndex, isHallOfFame]);

  useEffect(() => {
    const onFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    const handleResize = () => setWindowPortrait(window.innerHeight > window.innerWidth);
    document.addEventListener('fullscreenchange', onFullscreenChange);
    window.addEventListener('resize', handleResize);
    return () => {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const resetActivityTimer = () => {
      setShowControls(true);
      if (controlsTimeoutRef.current) clearTimeout(controlsTimeoutRef.current);
      controlsTimeoutRef.current = setTimeout(() => setShowControls(false), 3000); 
    };
    resetActivityTimer(); 
    window.addEventListener('mousemove', resetActivityTimer);
    window.addEventListener('touchstart', resetActivityTimer);
    window.addEventListener('click', resetActivityTimer);
    window.addEventListener('keydown', resetActivityTimer);
    return () => {
      window.removeEventListener('mousemove', resetActivityTimer);
      window.removeEventListener('touchstart', resetActivityTimer);
      window.removeEventListener('click', resetActivityTimer);
      window.removeEventListener('keydown', resetActivityTimer);
      if (controlsTimeoutRef.current) clearTimeout(controlsTimeoutRef.current);
    };
  }, []);

  const triggerHearts = (cantidad) => {
    const newHearts = Array(cantidad).fill(null).map(() => ({
      id: Math.random().toString(36).substr(2, 9),
      left: Math.random() * 80 + 10, 
      size: Math.random() * 30 + 20, 
      duration: Math.random() * 2 + 3  
    }));
    setFlyingHearts(prev => [...prev, ...newHearts]);
    setTimeout(() => {
      setFlyingHearts(prev => prev.filter(h => !newHearts.map(nh => nh.id).includes(h.id)));
    }, 5000);
  };

  const showLiveComment = (action) => {
    const newComment = { 
      id: Math.random().toString(36).substr(2, 9), 
      actor: action.actorName, 
      avatar: action.actorAvatar, 
      text: action.textoExtra,
      left: Math.random() * 50 + 10, 
      duration: Math.random() * 3 + 8 
    };
    setLiveComments(prev => [...prev, newComment]);
    setTimeout(() => {
      setLiveComments(prev => prev.filter(c => c.id !== newComment.id));
    }, 12000);
  };

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) document.documentElement.requestFullscreen().catch(err => console.log(err));
    else if (document.exitFullscreen) document.exitFullscreen();
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    localStorage.setItem('proyector_theme', newTheme ? 'dark' : 'light');
  };

  const cycleRotation = () => {
    const next = screenRotation === 0 ? 90 : (screenRotation === 90 ? -90 : 0);
    setScreenRotation(next);
    localStorage.setItem('proyector_rotation', next);
  };

  if (displayPhotos.length === 0) {
    return (
      <div className="w-screen h-screen bg-slate-900 flex flex-col items-center justify-center text-white relative">
        <Camera size={80} className="animate-pulse mb-6 text-slate-600" />
        <h1 className="text-4xl font-black uppercase text-slate-400 text-center px-4">Esperando Fotos...</h1>
        <p className="text-slate-500 mt-4 text-xl text-center px-4">Escanea el QR para ser el primero en aparecer aquí.</p>
        <div className="mt-12 bg-white p-4 rounded-3xl shadow-[0_0_50px_rgba(255,255,255,0.2)]">
           <img src={qrUrl} alt="QR" className="w-64 h-64 mix-blend-multiply" />
        </div>
      </div>
    );
  }

  let currentPhoto = displayPhotos[currentIndex];
  if (isHallOfFame) currentPhoto = [...displayPhotos].sort((a,b) => (b.likes?.length || 0) - (a.likes?.length || 0))[0];
  if (!currentPhoto) return null;

  const urls = currentPhoto.urls || [currentPhoto.url];
  const safeSubIndex = isHallOfFame ? 0 : (currentSubIndex >= urls.length ? 0 : currentSubIndex);
  const imageUrl = urls[safeSubIndex];

  const tBg = isDarkMode ? 'bg-black' : 'bg-slate-200';
  const tAmbilight = isDarkMode ? 'from-black/95 via-black/40 to-black/80' : 'from-slate-200/95 via-white/40 to-slate-200/80';
  const tCard = isDarkMode ? 'bg-black/60 border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.5)]' : 'bg-white/80 border-slate-200 shadow-[0_20px_50px_rgba(0,0,0,0.1)]';
  const tTextMain = isDarkMode ? 'text-white' : 'text-slate-900';
  const tTextSub = isDarkMode ? 'text-white/80' : 'text-slate-600';
  const tCommentsArea = isDarkMode ? 'bg-white/5 border-white/5' : 'bg-slate-100/50 border-slate-200';
  const isPortraitMode = screenRotation !== 0 || windowPortrait;

  return (
    <div className={`w-screen h-screen ${tBg} overflow-hidden relative font-sans transition-colors duration-1000`}>
      <style>{`
        @keyframes flyUp { 0% { top: 110%; transform: scale(0.5) rotate(0deg); opacity: 0; } 10% { opacity: 1; transform: scale(1.2) rotate(5deg); } 100% { top: -20%; transform: scale(1) rotate(15deg); opacity: 0; } }
        @keyframes floatComment { 0% { top: 110%; transform: scale(0.8); opacity: 0; } 10% { top: 75%; transform: scale(1); opacity: 1; } 90% { top: 15%; transform: scale(1); opacity: 1; } 100% { top: -10%; transform: scale(0.8); opacity: 0; } }
        .animate-fly { animation: flyUp linear forwards; }
        .animate-float-comment { animation: floatComment linear forwards; }
      `}</style>

      <div className={`absolute top-6 right-6 z-[999] flex gap-3 transition-opacity duration-500 ${showControls ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <button onClick={cycleRotation} className={`p-3 rounded-full backdrop-blur-md border shadow-lg transition-all ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border-white/20' : 'bg-black/10 hover:bg-black/20 text-slate-800 border-black/10'}`}><RotateCw size={24} className={!isDarkMode ? 'text-slate-800' : ''} /></button>
        <button onClick={toggleTheme} className={`p-3 rounded-full backdrop-blur-md border shadow-lg transition-all ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border-white/20' : 'bg-black/10 hover:bg-black/20 text-slate-800 border-black/10'}`}><Moon size={24} className={!isDarkMode ? 'fill-slate-800' : ''} /></button>
        <button onClick={toggleFullscreen} className={`p-3 rounded-full backdrop-blur-md border shadow-lg transition-all ${isDarkMode ? 'bg-white/10 hover:bg-white/20 text-white border-white/20' : 'bg-black/10 hover:bg-black/20 text-slate-800 border-black/10'}`}>
           {isFullscreen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"/></svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg>}
        </button>
      </div>

      <div 
        className="absolute bg-transparent overflow-hidden"
        style={{ width: screenRotation === 0 ? '100vw' : '100vh', height: screenRotation === 0 ? '100vh' : '100vw', top: '50%', left: '50%', transform: `translate(-50%, -50%) rotate(${screenRotation}deg)`, transition: 'transform 0.7s cubic-bezier(0.4, 0, 0.2, 1), width 0.7s, height 0.7s' }}
      >
        <div className="absolute inset-0 z-0">
           <img src={imageUrl} className="w-full h-full object-cover hidden md:block blur-[100px] opacity-50 transform scale-110 transition-all duration-1000" />
           <div className={`absolute inset-0 bg-gradient-to-t ${tAmbilight} transition-colors duration-1000`}></div>
        </div>

        <div className={`absolute inset-0 z-10 flex items-center justify-center ${isPortraitMode ? 'p-6 pb-72' : 'p-12'}`}>
          <div className="relative shadow-2xl rounded-2xl overflow-hidden bg-black/10 animate-in fade-in zoom-in-95 duration-700 flex justify-center items-center" style={{ maxHeight: isPortraitMode ? '70%' : '80%', maxWidth: '85%', aspectRatio: '4/5' }}>
             <img key={`${currentPhoto.id}_${safeSubIndex}`} src={imageUrl} className="w-full h-full object-cover" />
             {config.marcoUrl && <img src={config.marcoUrl} className="absolute inset-0 w-full h-full object-cover pointer-events-none z-20" />}
          </div>
        </div>

        {isHallOfFame && (
           <div className="absolute top-16 left-1/2 -translate-x-1/2 z-50 text-center animate-in slide-in-from-top-10 duration-1000 w-[90%]">
              <div className="bg-gradient-to-r from-amber-400 to-yellow-600 text-white px-6 md:px-10 py-3 rounded-full shadow-[0_0_40px_rgba(251,191,36,0.6)] inline-flex items-center justify-center border-2 border-yellow-200">
                 <Star size={28} className="mr-3 fill-white animate-spin-slow hidden sm:block"/>
                 <h2 className="text-xl md:text-3xl font-black tracking-widest uppercase text-shadow-lg text-center">¡Foto más popular!</h2>
                 <Star size={28} className="ml-3 fill-white animate-spin-slow hidden sm:block"/>
              </div>
              <div className="w-full"></div>
              <p className={`mt-4 text-sm md:text-xl font-bold inline-block px-6 py-2 rounded-full backdrop-blur-md border ${isDarkMode ? 'bg-black/40 text-white border-white/10' : 'bg-white/60 text-slate-800 border-slate-200'}`}>
                 Con {currentPhoto.likes?.length || 0} Me gusta ❤️
              </p>
           </div>
        )}

        <div className={`absolute inset-x-0 bottom-0 z-20 pointer-events-none flex ${isPortraitMode ? 'flex-col items-center justify-end gap-6 p-6 pb-8' : 'flex-row items-end justify-between gap-6 p-12'}`}>
           <div className={`w-[280px] sm:w-[320px] max-w-[85vw] pointer-events-auto ${tCard} backdrop-blur-2xl px-6 pb-6 pt-12 rounded-[2rem] animate-in slide-in-from-bottom-12 duration-700 flex flex-col items-center text-center relative max-h-[50vh] sm:max-h-[60vh] shrink-0`}>
              {!isHallOfFame && urls.length > 1 && (
                 <div className="absolute -top-4 right-4 bg-pink-600 text-white px-3 py-1.5 rounded-full text-[10px] font-black shadow-lg flex items-center border border-white/20 z-30">
                   <Layers size={12} className="mr-1.5"/> {safeSubIndex + 1} / {urls.length}
                 </div>
              )}
              <div className={`absolute -top-10 w-20 h-20 rounded-full bg-indigo-600 overflow-hidden border-4 shadow-xl z-20 ${isDarkMode ? 'border-zinc-800' : 'border-white'}`}>
                 {currentPhoto.avatar ? <img src={currentPhoto.avatar} className="w-full h-full object-cover"/> : <div className="w-full h-full flex items-center justify-center text-white text-3xl font-black">{currentPhoto.autor.charAt(0).toUpperCase()}</div>}
              </div>
              <h2 className={`text-2xl font-black ${tTextMain} leading-tight drop-shadow-sm`}>{currentPhoto.autor}</h2>
              <span className={`px-3 py-1 rounded-full text-[10px] font-bold mt-1.5 mb-3 flex items-center shrink-0 ${isDarkMode ? 'bg-white/10 text-white' : 'bg-slate-200 text-slate-600'}`}>
                 <Clock size={12} className="mr-1"/> {currentPhoto.fecha}
              </span>
              {(currentPhoto.emotion || currentPhoto.location) && (
                 <div className="flex flex-col items-center gap-1.5 mb-3 w-full shrink-0">
                   {currentPhoto.emotion && <span className="bg-indigo-500 text-white px-3 py-1 rounded-full text-[10px] font-bold shadow-sm">{currentPhoto.emotion}</span>}
                   {currentPhoto.location && <span className="bg-rose-500 text-white px-3 py-1 rounded-full text-[10px] font-bold shadow-sm flex items-center"><MapPin size={10} className="mr-1"/> {currentPhoto.location}</span>}
                 </div>
              )}
              <div className="w-full overflow-y-auto hide-scrollbar flex-1 min-h-0 pt-2">
                {currentPhoto.mensaje && <p className={`text-sm ${tTextMain} font-medium italic leading-snug drop-shadow-sm px-2 mb-4`}>"{currentPhoto.mensaje}"</p>}
                {currentPhoto.comentarios && Object.values(currentPhoto.comentarios).length > 0 && (
                  <div className={`pt-3 border-t w-full text-left ${isDarkMode ? 'border-white/10' : 'border-slate-300'}`}>
                    {Object.values(currentPhoto.comentarios).slice(-4).map((c, i) => (
                      <div key={i} className={`mb-1.5 p-2.5 rounded-xl shadow-sm ${tCommentsArea}`}>
                         <span className="font-black text-pink-500 text-[9px] uppercase block mb-0.5">{c.usuario || c.autor}</span>
                         <span className={`text-xs ${tTextSub} leading-tight block`}>{c.texto}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
           </div>

           <div className={`flex flex-col items-center pointer-events-auto animate-in slide-in-from-right-12 duration-1000 shrink-0 ${isPortraitMode ? 'mt-2' : ''}`}>
              <div className={`backdrop-blur-xl p-4 rounded-[2rem] border-4 shadow-2xl mb-4 transform hover:scale-105 transition-transform ${isDarkMode ? 'bg-white/95 border-white/50' : 'bg-white border-white'}`}>
                <img src={qrUrl} alt="QR" className="w-24 h-24 sm:w-32 sm:h-32 mix-blend-multiply" />
              </div>
              <div className={`backdrop-blur-xl px-6 py-2.5 rounded-full shadow-lg text-center border ${isDarkMode ? 'bg-black/50 border-white/10' : 'bg-white/80 border-slate-200'}`}>
                 <p className={`font-black text-sm tracking-widest uppercase ${tTextMain}`}>¡Sube tu foto!</p>
                 <p className="text-pink-500 font-bold text-xs">{config.hashtag || 'Galería en vivo'}</p>
              </div>
           </div>
        </div>

        <div className="absolute inset-0 z-[100] pointer-events-none overflow-hidden">
          {flyingHearts.map(h => (
            <div key={h.id} className="absolute animate-fly drop-shadow-[0_5px_15px_rgba(225,29,72,0.8)]" style={{ left: `${h.left}%`, animationDuration: `${h.duration}s` }}>
              <Heart fill="#f43f5e" color="#e11d48" size={h.size} />
            </div>
          ))}
          {liveComments.map(c => (
            <div key={c.id} className={`absolute animate-float-comment flex items-center gap-3 p-3 rounded-2xl shadow-2xl max-w-xs border-l-4 border-indigo-500 backdrop-blur-md ${isDarkMode ? 'bg-white/95 text-slate-800' : 'bg-slate-900/95 text-white'}`} style={{ left: `${c.left}%`, animationDuration: `${c.duration}s` }}>
              <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 shadow-inner">
                 {c.avatar ? <img src={c.avatar} className="w-full h-full object-cover"/> : <div className="w-full h-full bg-slate-200 flex items-center justify-center font-bold text-slate-500">{c.actor.charAt(0)}</div>}
              </div>
              <div>
                 <p className={`text-[10px] font-black uppercase tracking-widest ${isDarkMode ? 'text-slate-400' : 'text-slate-400'}`}>{c.actor}</p>
                 <p className="text-sm font-bold leading-tight">{c.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ==========================================
// --- 1. MÓDULO DE STRIPE (Paso 2 del Pago) ---
// ==========================================
const StripeCaja = ({ planSeleccionado, datosCliente, onSuccess, onVolver }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handlePayment = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true); setError(null);

    const { error: submitError } = await elements.submit();
    if (submitError) { setError(submitError.message); setLoading(false); return; }

    const { error: pError, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: `${window.location.origin}/` },
      redirect: 'if_required'
    });

    if (pError) {
      setError(pError.message);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      if (window.fbq) {
        const precioLimpio = planSeleccionado.precio.toString().replace(/,/g, '');
        window.fbq('track', 'Purchase', { value: Number(precioLimpio), currency: planSeleccionado.moneda || 'MXN' });
      }
      onSuccess({ success: true }, planSeleccionado);
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handlePayment} className="animate-in slide-in-from-bottom-4 fade-in duration-500">
       <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1 flex items-center"><Lock size={12} className="mr-1.5 text-emerald-500"/> Información Bancaria Segura</label>
       
       {/* 🔴 CORRECCIÓN: Fondo blanco de día (bg-white) y súper oscuro de noche (dark:bg-[#050505]) con bordes dinámicos */}
       <div className="relative p-5 bg-white dark:bg-[#050505] border border-slate-200 dark:border-white/10 rounded-2xl shadow-xl overflow-hidden group min-h-[250px] mb-6">
         <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-0 dark:opacity-20 pointer-events-none"></div>
         <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 blur-3xl rounded-full pointer-events-none"></div>
         <div className="relative z-10">
           {/* 🔴 STRIPE INTELIGENTE: Recibe tus datos y tu País para saber qué mostrar */}
           <PaymentElement options={{ 
             layout: "tabs",
             defaultValues: {
               billingDetails: {
                 name: datosCliente.nombre,
                 email: datosCliente.email,
                 phone: datosCliente.telefono,
                 address: { country: datosCliente.pais }
               }
             }
           }} />
         </div>
       </div>
       
       {error && <p className="text-rose-500 text-xs mb-4 ml-1 flex items-center font-bold bg-rose-50 dark:bg-rose-500/10 p-2 rounded-lg border border-rose-200 dark:border-rose-500/20"><AlertCircle size={14} className="mr-1.5 shrink-0"/> {error}</p>}
       
       <div className="flex gap-3">
         <button type="button" onClick={onVolver} className="px-5 py-4 rounded-xl font-bold text-slate-500 bg-slate-100 dark:bg-white/5 hover:bg-slate-200 dark:hover:bg-white/10 transition-colors uppercase text-[10px] tracking-widest">
           Volver
         </button>
         <button type="submit" disabled={!stripe || loading} className="flex-1 py-4 bg-gradient-to-r from-amber-500 to-yellow-600 text-white font-black rounded-xl text-xs uppercase tracking-widest shadow-[0_10px_25px_rgba(245,158,11,0.4)] transition-all flex justify-center items-center">
         {loading ? "Procesando..." : `Pagar ${planSeleccionado.precio} ${planSeleccionado.moneda || 'MXN'}`}
      </button>
       </div>
    </form>
  );
};

// ==========================================
// --- 2. GESTOR PRINCIPAL DE PAGO (Paso 1 del Pago) ---
// ==========================================
const CheckoutForm = ({ planSeleccionado, onSuccess, onCancel }) => {
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [fecha, setFecha] = useState('');
  const [pais, setPais] = useState('MX');
  const [lada, setLada] = useState('+52');
  const [telefono, setTelefono] = useState('');

  // 🟢 ESTADOS DE CUPONES Y ANTICIPOS
  const [configPublica, setConfigPublica] = useState({ anticipos: { activo: false, porcentaje: 10 }, cupones: [] });
  const [codigoInput, setCodigoInput] = useState('');
  const [cuponAplicado, setCuponAplicado] = useState(null);
  const [mensajeCupon, setMensajeCupon] = useState(null);
  const [modalidadPago, setModalidadPago] = useState('completo'); // 'completo' | 'anticipo'

  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorTexto, setErrorTexto] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "ajustes_baulia", "precios_publicos"), (snap) => {
      if (snap.exists()) {
        const d = snap.data();
        setConfigPublica({
          anticipos: d.anticipos || { activo: false, porcentaje: 10 },
          cupones: d.cupones || []
        });
        if (!d.anticipos?.activo) setModalidadPago('completo');
      }
    });
    return () => unsub();
  }, []);

  const precioOriginal = Number(planSeleccionado.precio) || 0;

  // 1. Calculamos precio tras aplicar cupón
  const precioConDescuento = React.useMemo(() => {
    if (!cuponAplicado) return precioOriginal;
    if (cuponAplicado.tipo === 'porcentaje') {
      return Math.max(10, Math.round(precioOriginal * (1 - cuponAplicado.valor / 100)));
    }
    return Math.max(10, precioOriginal - cuponAplicado.valor);
  }, [precioOriginal, cuponAplicado]);

  // 2. Calculamos cuánto paga hoy y cuánto queda de deuda
  const porcentajeReserva = configPublica.anticipos?.porcentaje || 10;
  const esAnticipoActivo = configPublica.anticipos?.activo && modalidadPago === 'anticipo';
  const montoACobrarHoy = esAnticipoActivo
    ? Math.max(10, Math.round(precioConDescuento * (porcentajeReserva / 100)))
    : precioConDescuento;
  const deudaRestante = esAnticipoActivo ? Math.max(0, precioConDescuento - montoACobrarHoy) : 0;

  const validarCupon = () => {
    const limpio = codigoInput.trim().toUpperCase();
    if (!limpio) return;
    const encontrado = (configPublica.cupones || []).find(
      c => c.activo && c.codigo.toUpperCase() === limpio && (c.usados || 0) < c.limite
    );
    if (encontrado) {
      setCuponAplicado(encontrado);
      setMensajeCupon({ tipo: 'ok', texto: `¡Cupón ${encontrado.codigo} aplicado con éxito!` });
    } else {
      setCuponAplicado(null);
      setMensajeCupon({ tipo: 'error', texto: 'Código inválido, pausado o agotado.' });
    }
  };

  const generarOrden = async (e) => {
    e.preventDefault();
    setLoading(true); setErrorTexto(null);
    try {
      const emailKey = email.trim().toLowerCase();
      // Guardamos preventa en Firebase antes de pagar para que el panel sepa cuánto debe aunque el webhook tarde
      if (deudaRestante > 0 || cuponAplicado) {
        await setDoc(doc(db, "ajustes_baulia", "precios_publicos"), {
          preventasPendientes: {
            ...(configPublica.preventasPendientes || {}),
            [emailKey]: {
              email: emailKey,
              montoPagado: montoACobrarHoy,
              deudaPlataforma: deudaRestante,
              cuponAplicado: cuponAplicado ? cuponAplicado.codigo : '',
              timestamp: Date.now()
            }
          }
        }, { merge: true }).catch(() => {});
      }

      const telCompleto = `${lada} ${telefono}`;
      const respuesta = await fetch("https://us-central1-panel-de-control-intelig-db278.cloudfunctions.net/crearIntentoAsincrono", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan: planSeleccionado.plan === 'Black Label' ? 'security_kit' : 
                planSeleccionado.plan === 'Social Wall' ? 'social_wall' : 
                planSeleccionado.plan.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
          precio: montoACobrarHoy,
          deudaPlataforma: deudaRestante,
          cuponAplicado: cuponAplicado ? cuponAplicado.codigo : '',
          esAnticipo: esAnticipoActivo,
          moneda: planSeleccionado.moneda || 'MXN', 
          nombre, email, fecha, telefono: telCompleto, pais
        })
      });
      const data = await respuesta.json();
      if (data.clientSecret) setClientSecret(data.clientSecret);
      else setErrorTexto(data.error || "Error al conectar con el servidor.");
    } catch (err) { setErrorTexto("Fallo de comunicación con la base de Baulia."); }
    setLoading(false);
  };

  // 🟢 Al terminar el pago en Stripe, sellamos la deuda en la bóveda más reciente del cliente
  const handleSuccessConCandado = async (resData) => {
    try {
      if (cuponAplicado) {
        const nuevosCupones = (configPublica.cupones || []).map(c =>
          c.id === cuponAplicado.id ? { ...c, usados: (c.usados || 0) + 1 } : c
        );
        await updateDoc(doc(db, "ajustes_baulia", "precios_publicos"), { cupones: nuevosCupones }).catch(() => {});
      }
      if (deudaRestante > 0 || cuponAplicado) {
        const sellarDeuda = async () => {
          try {
            const snapUsers = await getDocs(collection(db, "usuarios"));
            const coincidencias = snapUsers.docs
              .map(d => ({ id: d.id, ...d.data() }))
              .filter(u => (u.email || '').toLowerCase() === email.trim().toLowerCase());
            coincidencias.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
            const clienteDoc = coincidencias[0];
            if (clienteDoc) {
              const targetEventId = clienteDoc.eventId || clienteDoc.id;
              await setDoc(doc(db, "usuarios", clienteDoc.id), {
                deudaPlataforma: deudaRestante,
                montoPagado: montoACobrarHoy,
                cuponAplicado: cuponAplicado ? cuponAplicado.codigo : '',
                bloqueadoPorPago: false
              }, { merge: true });
              await setDoc(doc(db, "eventos", targetEventId), {
                deudaPlataforma: deudaRestante,
                bloqueadoPorPago: false
              }, { merge: true });
            }
          } catch (e) { console.error("Sync post-pago:", e); }
        };
        setTimeout(sellarDeuda, 1500);
        setTimeout(sellarDeuda, 4000);
      }
    } catch (err) { console.error(err); }
    if (onSuccess) onSuccess(resData);
  };

  const nombrePlanLimpio = planSeleccionado.plan === 'social_wall' ? 'Social Wall' : planSeleccionado.plan;

  return (
    <div className="flex flex-col w-full max-w-full overflow-x-hidden box-border">
      <div className="mb-5 relative overflow-hidden bg-gradient-to-br from-amber-50 to-white dark:from-amber-500/10 dark:to-[#111] border border-amber-200 dark:border-amber-500/30 rounded-2xl p-5 sm:p-6 shadow-sm shrink-0 w-full box-border">
         <div className="flex justify-between items-center gap-3 relative z-10">
           <div className="min-w-0">
             <p className="text-amber-600 dark:text-amber-500 text-[10px] font-black uppercase tracking-widest mb-1">Suscripción Premium</p>
             <p className="text-slate-900 dark:text-white font-editorial text-2xl md:text-3xl leading-none truncate">{nombrePlanLimpio}</p>
             {cuponAplicado && (
               <span className="inline-block mt-2 text-[9px] font-black uppercase tracking-widest bg-emerald-500/20 text-emerald-600 dark:text-emerald-400 border border-emerald-500/30 px-2 py-0.5 rounded">
                 Cupón {cuponAplicado.codigo} Aplicado
               </span>
             )}
           </div>
           <div className="text-right shrink-0">
             {cuponAplicado && (
               <p className="text-xs text-slate-400 line-through font-bold">${precioOriginal}</p>
             )}
             <p className="text-slate-900 dark:text-white font-black text-2xl md:text-3xl">${String(montoACobrarHoy).split('.')[0]}</p>
             <p className="text-slate-500 dark:text-slate-400 text-[9px] uppercase tracking-widest font-bold mt-1">
               {planSeleccionado.moneda || 'MXN'} / {esAnticipoActivo ? `Reserva (${porcentajeReserva}%)` : 'Pago Único'}
             </p>
           </div>
         </div>
         {esAnticipoActivo && (
           <div className="mt-3 pt-3 border-t border-amber-500/20 flex justify-between items-center text-[10px] font-bold text-amber-700 dark:text-amber-400">
             <span>Saldo restante (a liquidar 24h después de recibir tu invitación):</span>
             <span className="font-black">${deudaRestante} {planSeleccionado.moneda || 'MXN'}</span>
           </div>
         )}
      </div>

      {!clientSecret ? (
        <form onSubmit={generarOrden} className="space-y-4 shrink-0 animate-in fade-in w-full max-w-full overflow-x-hidden">
          
          {/* 🟢 SELECTOR DE PAGO COMPLETO VS ANTICIPO (SI ESTÁ HABILITADO EN GOD MODE) */}
          {configPublica.anticipos?.activo && (
            <div className="space-y-2">
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 ml-1">Modalidad de Pago</label>
              <div className="grid grid-cols-2 gap-3">
                <button
                  type="button"
                  onClick={() => setModalidadPago('completo')}
                  className={`p-3.5 rounded-xl border text-left transition-all ${modalidadPago === 'completo' ? 'bg-amber-500/15 border-amber-500 text-slate-900 dark:text-white shadow-md' : 'bg-slate-50 dark:bg-[#111] border-slate-200 dark:border-white/10 text-slate-500'}`}
                >
                  <p className="text-[9px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400">Liquidar 100%</p>
                  <p className="text-lg font-black mt-0.5">${precioConDescuento} <span className="text-[9px] font-normal">{planSeleccionado.moneda || 'MXN'}</span></p>
                  <p className="text-[9px] opacity-75 mt-0.5">Acceso total sin adeudos</p>
                </button>

                <button
                  type="button"
                  onClick={() => setModalidadPago('anticipo')}
                  className={`p-3.5 rounded-xl border text-left transition-all ${modalidadPago === 'anticipo' ? 'bg-amber-500/15 border-amber-500 text-slate-900 dark:text-white shadow-md' : 'bg-slate-50 dark:bg-[#111] border-slate-200 dark:border-white/10 text-slate-500'}`}
                >
                  <p className="text-[9px] font-black uppercase tracking-widest text-emerald-600 dark:text-emerald-400">Reservar con {porcentajeReserva}%</p>
                  <p className="text-lg font-black mt-0.5">${Math.max(10, Math.round(precioConDescuento * (porcentajeReserva / 100)))} <span className="text-[9px] font-normal">{planSeleccionado.moneda || 'MXN'}</span></p>
                  <p className="text-[9px] opacity-75 mt-0.5">Liquida al recibir tu invitación</p>
                </button>
              </div>
            </div>
          )}

          {/* 🟢 CAMPO DE CUPÓN PROMOCIONAL */}
          <div className="w-full min-w-0">
            <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1">¿Tienes un código de descuento?</label>
            <div className="flex gap-2">
              <input
                type="text"
                value={codigoInput}
                onChange={(e) => setCodigoInput(e.target.value.toUpperCase())}
                placeholder="Ej. BODA2026"
                className="flex-1 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3 text-xs font-black uppercase tracking-widest text-slate-900 dark:text-white focus:border-amber-500 outline-none"
              />
              <button
                type="button"
                onClick={validarCupon}
                className="px-5 py-3 bg-slate-900 dark:bg-white/10 text-white rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-amber-500 hover:text-black transition-colors shrink-0"
              >
                Aplicar
              </button>
            </div>
            {mensajeCupon && (
              <p className={`text-[10px] font-bold mt-1.5 ml-1 ${mensajeCupon.tipo === 'ok' ? 'text-emerald-500' : 'text-rose-500'}`}>
                {mensajeCupon.texto}
              </p>
            )}
          </div>

          <div className="w-full min-w-0">
            <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1">Nombre de los Festejados</label>
            <input type="text" required value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Ej. Carlos & María" className="w-full max-w-full box-border bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3.5 text-sm text-slate-900 dark:text-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none transition-all shadow-sm font-medium" />
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
            <div className="w-full min-w-0">
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1">Correo Electrónico</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" className="w-full max-w-full box-border bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3.5 text-sm text-slate-900 dark:text-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none transition-all shadow-sm font-medium" />
            </div>
            <div className="w-full min-w-0 overflow-hidden">
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1">Fecha del Evento</label>
              <input type="date" required value={fecha} onChange={(e) => setFecha(e.target.value)} className="block w-full max-w-full min-w-0 box-border appearance-none bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3.5 text-sm text-slate-900 dark:text-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none transition-all shadow-sm font-medium [color-scheme:light] dark:[color-scheme:dark]" />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1">País de Facturación</label>
              <select value={pais} onChange={(e) => setPais(e.target.value)} className="w-full bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3.5 text-sm text-slate-900 dark:text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 transition-all shadow-sm font-medium appearance-none cursor-pointer">
                <option value="MX">🇲🇽 México</option>
                <option value="US">🇺🇸 Estados Unidos</option>
                <option value="ES">🇪🇸 España</option>
                <option value="CO">🇨🇴 Colombia</option>
                <option value="AR">🇦🇷 Argentina</option>
                <option value="CL">🇨🇱 Chile</option>
                <option value="PE">🇵🇪 Perú</option>
                <option value="CA">🇨🇦 Canadá</option>
                <option value="BR">🇧🇷 Brasil</option>
                <option value="FR">🇫🇷 Francia</option>
              </select>
            </div>
            <div>
              <label className="block text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-2 ml-1">Teléfono (WhatsApp)</label>
              <div className="flex gap-2">
                <select value={lada} onChange={(e) => setLada(e.target.value)} className="w-24 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-2 py-3.5 text-sm text-slate-900 dark:text-white outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 transition-all shadow-sm font-bold text-center appearance-none cursor-pointer">
                  <option value="+52">+52</option><option value="+1">+1</option><option value="+34">+34</option><option value="+57">+57</option><option value="+54">+54</option><option value="+56">+56</option><option value="+51">+51</option>
                </select>
                <input type="tel" required value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="Ej. 5512345678" className="w-full bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-xl px-4 py-3.5 text-sm text-slate-900 dark:text-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none transition-all shadow-sm font-medium" />
              </div>
            </div>
          </div>

          <button type="submit" disabled={loading} className="w-full mt-8 py-4 sm:py-5 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-black rounded-xl text-xs sm:text-sm uppercase tracking-widest shadow-xl hover:scale-[1.02] transition-all flex justify-center items-center">
            {loading ? <><RefreshCw size={18} className="animate-spin mr-2"/> Conectando al Banco...</> : `Pagar $${montoACobrarHoy} ${planSeleccionado.moneda || 'MXN'} Ahora`}
          </button>
          {errorTexto && <p className="text-rose-500 text-xs mt-3 text-center font-bold">{errorTexto}</p>}
        </form>
      ) : (
        <div className="mt-2 flex-1">
          {(() => {
            const esModoOscuro = document.documentElement.classList.contains('dark') || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
            
            return (
              <Elements stripe={stripePromise} options={{ 
                clientSecret, 
                appearance: { 
                  theme: esModoOscuro ? 'night' : 'stripe', 
                  variables: { 
                    colorPrimary: '#fbbf24', 
                    colorBackground: esModoOscuro ? '#050505' : '#ffffff', 
                    colorText: esModoOscuro ? '#ffffff' : '#0f172a', 
                    colorDanger: '#f87171', 
                    fontFamily: '"Montserrat", sans-serif' 
                  },
                  rules: { 
                    '.Tab': { padding: '12px', fontSize: '14px' }, 
                    '.TabLabel': { fontWeight: 'bold' } 
                  }
                } 
              }}>
                <StripeCaja 
                  planSeleccionado={{ ...planSeleccionado, precio: montoACobrarHoy, deudaPlataforma: deudaRestante, cuponAplicado: cuponAplicado?.codigo || '' }} 
                  datosCliente={{ nombre, email, telefono: `${lada} ${telefono}`, pais, deudaPlataforma: deudaRestante, cuponAplicado: cuponAplicado?.codigo || '' }} 
                  onSuccess={handleSuccessConCandado} 
                  onVolver={() => setClientSecret(null)} 
                />
              </Elements>
            );
          })()}
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- MICRO-COMPONENTE: ANIMACIÓN AL SCROLL (Efecto Apple) ---
// ==========================================
const RevealSection = ({ children, className = '', delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();
  
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) setIsVisible(true);
    }, { threshold: 0.15 });
    
    if (domRef.current) observer.observe(domRef.current);
    return () => { if (domRef.current) observer.unobserve(domRef.current); }
  }, []);
  
  return (
    <div ref={domRef} className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: REVISTA EDITORIAL (ANATOMÍA DE LA INVITACIÓN) ---
// ==========================================
const AnatomyOverlay = ({ onClose }) => {
  useEffect(() => {
    if (!document.getElementById('anatomy-fonts')) {
      const link = document.createElement('link');
      link.id = 'anatomy-fonts';
      link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400&family=Montserrat:wght@200;300;400;500&family=Pinyon+Script&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
  }, []);

  const invTheme = {
    fontSerif: '"Cormorant Garamond", serif',
    fontSans: '"Montserrat", sans-serif',
    fontScript: '"Pinyon Script", cursive',
    springDark: '#2A2A2A',
    goldDark: '#AA8529',
    goldWarm: '#B48E2F',
    springPink: '#F76C82',
    springGreen: '#8DB580',
    bg: '#FDFBF7'
  };

  const FloralCorner = ({ className, style }) => (
    <svg viewBox="0 0 200 200" className={className} style={style} xmlns="http://www.w3.org/2000/svg">
      <g transform="scale(0.8) translate(20, 20)">
        <path d="M 40 100 C 10 70, 20 20, 80 10 C 80 60, 60 90, 40 100 Z" fill="#8DB580" opacity="0.8"/>
        <path d="M 100 40 C 70 10, 20 20, 10 80 C 60 80, 90 60, 100 40 Z" fill="#A3C697" opacity="0.9"/>
        <path d="M 130 140 C 160 170, 180 130, 170 80 C 140 90, 120 120, 130 140 Z" fill="#8DB580" opacity="0.8"/>
        <circle cx="120" cy="70" r="30" fill="#FFD166" />
        <circle cx="120" cy="70" r="15" fill="#FFB347" />
        <path d="M 120 40 C 130 20, 150 20, 145 45 C 165 40, 175 60, 150 70 C 175 80, 165 100, 145 95 C 150 120, 130 120, 120 100 C 110 120, 90 120, 95 95 C 75 100, 65 80, 90 70 C 65 60, 75 40, 95 45 C 90 20, 110 20, 120 40 Z" fill="#FFE28A" opacity="0.9"/>
        <circle cx="70" cy="120" r="35" fill="#F76C82" />
        <circle cx="70" cy="120" r="15" fill="#D84A63" />
        <path d="M 70 85 C 85 60, 110 65, 100 90 C 125 80, 140 105, 110 120 C 140 135, 125 160, 100 150 C 110 175, 85 180, 70 155 C 55 180, 30 175, 40 150 C 15 160, 0 135, 30 120 C 0 105, 15 80, 40 90 C 30 65, 55 60, 70 85 Z" fill="#FF8FA3" opacity="0.9"/>
        <circle cx="120" cy="70" r="5" fill="#D4AF37" />
        <circle cx="70" cy="120" r="6" fill="#D4AF37" />
        <path d="M 90 90 Q 100 100, 110 90" stroke="#D4AF37" strokeWidth="2" fill="none"/>
      </g>
    </svg>
  );

  return (
    // OVERLAY OSCURO CON DESENFOQUE
    <div className="fixed inset-0 z-[9999] bg-slate-900/60 dark:bg-black/80 backdrop-blur-md flex items-end sm:items-center justify-center sm:p-4 lg:p-8 animate-in fade-in duration-500 font-sans">
      
      {/* CAJA FLOTANTE REDONDEADA (FORZADA SIEMPRE A MODO CLARO/REVISTA) */}
      <div className="w-[96vw] max-w-[1300px] h-[96vh] sm:h-[94vh] bg-[#FDFBF7] rounded-t-[2rem] sm:rounded-[2.5rem] shadow-2xl flex flex-col relative overflow-hidden animate-in slide-in-from-bottom-10 sm:zoom-in-95 duration-700 border border-slate-200">
        
        {/* NAVEGACIÓN PEGADA ARRIBA */}
        <nav className="sticky top-0 w-full bg-[#FDFBF7]/90 backdrop-blur-xl z-50 px-5 sm:px-10 py-4 flex justify-between items-center border-b border-[#D4AF37]/20 shrink-0">
          <span className="font-editorial text-lg sm:text-xl font-bold tracking-widest uppercase text-[#D4AF37]">Baulia <span className="font-light italic text-[#2A2A2A]">Magazine</span></span>
          <button onClick={onClose} className="group flex items-center text-[10px] font-black uppercase tracking-widest text-slate-500 hover:text-[#D4AF37] transition-colors bg-slate-100 px-3 py-1.5 rounded-full sm:bg-transparent sm:px-0 sm:py-0">
            <span className="hidden sm:block">Cerrar Edición</span> <X size={16} className="sm:ml-2 transform group-hover:rotate-90 transition-transform duration-300"/>
          </button>
        </nav>

        {/* ÁREA ESCROLEABLE */}
        <main className="flex-1 overflow-y-auto custom-scrollbar px-5 sm:px-10 lg:px-16 pt-10 sm:pt-16 pb-24 text-[#2A2A2A]">
          
          <header className="mb-12 sm:mb-20 border-b border-[#D4AF37]/20 pb-12 sm:pb-16">
            <p className="text-[#8DB580] font-bold tracking-[0.3em] sm:tracking-[0.4em] uppercase text-[9px] sm:text-[10px] mb-4 sm:mb-6 text-center md:text-left">La Colección · Primavera Vibrante</p>
            
            <div className="flex flex-col lg:flex-row gap-6 sm:gap-10 items-start">
              <h1 className="text-5xl sm:text-7xl lg:text-[100px] font-editorial font-black tracking-tighter leading-[0.9] w-full lg:w-3/5 text-[#2A2A2A] text-center md:text-left">
                Anatomía <br className="hidden md:block"/>
                <span className="italic font-light text-[#D4AF37]">del diseño.</span>
              </h1>
              
              <div className="w-full lg:w-2/5 pt-2">
                <div className="text-sm sm:text-base font-light leading-relaxed text-justify text-slate-600 block">
                  <FloralCorner className="float-right w-20 h-20 sm:w-28 sm:h-28 ml-4 mb-2 opacity-90 drop-shadow-xl" />
                  <span className="float-left text-[60px] sm:text-[80px] leading-[45px] sm:leading-[60px] pt-1 sm:pt-2 pr-3 sm:pr-4 font-editorial font-black text-[#F76C82]">
                    E
                  </span>
                  n nuestra boutique, cada historia de amor y celebración comienza con un lienzo en blanco. Rechazamos categóricamente lo genérico. Cada trazo, paleta de color y tipografía nace exclusivamente para ti. Lo que ves aquí es pura alta costura digital: un arte interactivo diseñado no solo para informar, sino para enamorar, emocionar e inspirar a tus invitados desde el segundo en que abren tu invitación.
                </div>
              </div>
            </div>
          </header>

          <div className="space-y-12 sm:space-y-20">

            {/* FILA 1 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">01. El Emblema y La Jerarquía</span>
                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 mb-6 sm:mb-8 pl-0 sm:pl-4 border-l-0 sm:border-l-2 border-[#D4AF37]/30 text-center sm:text-left">
                   <div className="w-20 h-20 sm:w-24 sm:h-24 shrink-0 mb-4 sm:mb-0">
                      <img src="/maricela-estudillo-gonzalez/monograma.svg" alt="Monograma" className="w-full h-full drop-shadow-md object-contain" />
                   </div>
                   <div className="flex flex-col">
                      <span style={{ fontFamily: invTheme.fontSans, color: invTheme.springGreen }} className="text-[8px] sm:text-[9px] tracking-[0.3em] sm:tracking-[0.4em] uppercase font-semibold mb-2">Celebrando la vida</span>
                      <h1 style={{ fontFamily: invTheme.fontSerif, color: invTheme.springDark }} className="text-4xl sm:text-5xl leading-none drop-shadow-sm mb-1">Miranda</h1>
                      <h2 style={{ fontFamily: invTheme.fontSans, color: invTheme.goldDark }} className="text-[8px] sm:text-[9px] tracking-[0.3em] sm:tracking-[0.5em] uppercase font-medium">Gómez Villarreal</h2>
                   </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-3 text-slate-900">El Primer Impacto</h3>
                <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                  Como la portada de una revista de lujo, establecemos la identidad visual de inmediato. Creamos un monograma exclusivo entrelazando tus iniciales (como la M y la G en este ejemplo) que actúa como el sello real de tu celebración. Acompañado de una arquitectura tipográfica experta que fusiona fuentes clásicas con trazos modernos, dotamos a tu nombre de una majestuosidad absoluta. Todo es personalizable a tus gustos.
                </p>
              </section>

              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">02. Arte Visual y Literario</span>
                <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 mb-6 sm:mb-8 pl-0 sm:pl-4 border-l-0 sm:border-l-2 border-[#D4AF37]/30 text-center sm:text-left">
                   <div className="w-24 h-32 sm:w-28 sm:h-36 rounded-[100px] p-1.5 border border-[#D4AF37]/50 shadow-xl overflow-hidden shrink-0 mb-4 sm:mb-0">
                      <div className="w-full h-full rounded-[100px] overflow-hidden bg-slate-200">
                          <img src="/maricela-estudillo-gonzalez/portada.jpg" className="w-full h-full object-cover animate-slow-zoom" onError={(e) => e.target.style.display = 'none'} />
                      </div>
                   </div>
                   <div className="flex flex-col justify-center">
                      <span style={{ fontFamily: invTheme.fontScript, color: invTheme.springPink }} className="text-2xl sm:text-3xl font-semibold drop-shadow-sm mb-2 sm:mb-3">
                          50 Primaveras
                      </span>
                      <p style={{ fontFamily: invTheme.fontSerif }} className="italic text-sm sm:text-base text-gray-700 leading-tight">
                          "Llegar a esta primavera es celebrar las flores de ayer y las semillas del mañana."
                      </p>
                   </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-3 text-slate-900">El Camafeo y el Alma</h3>
                <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                  Tu fotografía principal puede presentarse en este hermoso formato de camafeo clásico con sutiles animaciones, o si lo prefieres, como una portada panorámica inmersiva que se adapta perfectamente a la pantalla de cualquier dispositivo. Justo debajo, redactamos la frase que dictará el sentimiento de la noche, anclando la emoción antes de entregar los detalles operativos.
                </p>
              </section>
            </div>

            {/* FILA 2 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">03. La Experiencia del Invitado</span>
                <div className="flex flex-col items-center text-center mb-6 sm:mb-8">
                   <span className="font-sans text-[7px] sm:text-[8px] tracking-[0.2em] sm:tracking-[0.3em] uppercase text-[#D4AF37] font-bold mb-2">Pase VIP Personal</span>
                   <h3 className="font-serif text-xl sm:text-2xl text-[#2A2A2A] mb-4 sm:mb-6">
                      ¡Qué alegría tenerte aquí, <br className="sm:hidden"/><span className="text-[#F76C82] italic">Familia Fuentes</span>!
                   </h3>
                   <div className="flex justify-center gap-3 sm:gap-4">
                      {[ { label: 'Días', value: '45' }, { label: 'Hrs', value: '12' }, { label: 'Min', value: '30' }].map((item, idx) => (
                          <div key={idx} className="flex flex-col items-center">
                              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full border border-[#D4AF37]/50 shadow-md flex items-center justify-center mb-2">
                                  <span style={{ fontFamily: invTheme.fontSerif, color: invTheme.springDark }} className="text-lg sm:text-xl">{item.value}</span>
                              </div>
                              <span style={{ fontFamily: invTheme.fontSans }} className="text-[7px] sm:text-[8px] tracking-[0.2em] uppercase text-gray-500 font-medium">{item.label}</span>
                          </div>
                      ))}
                   </div>
                </div>
                <div>
                  <FloralCorner className="float-left w-12 h-12 sm:w-16 sm:h-16 mr-3 sm:mr-4 opacity-50" />
                  <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-2 sm:mb-3 text-slate-900 text-center sm:text-left">Hospitalidad y Expectativa</h3>
                  <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                    Nuestras obras son inteligentes. La invitación reconoce el nombre exacto de la persona o familia que la abre, haciéndolos sentir honrados y esperados. Justo debajo, un reloj estructurado en esferas de cristal marca el pulso del evento, generando anticipación física y emocional hacia el gran día.
                  </p>
                </div>
              </section>

              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">04. Logística de Precisión</span>
                <div className="flex flex-col items-center sm:items-start text-center sm:text-left mb-6 sm:mb-8 pl-0 sm:pl-4 border-l-0 sm:border-l-2 border-[#D4AF37]/30">
                   <h3 className="font-serif text-2xl sm:text-3xl text-[#2A2A2A] mb-2 sm:mb-3">La Recepción</h3>
                   <p className="font-sans text-[11px] sm:text-xs text-gray-500 leading-relaxed mb-4">
                       Hacienda San Gabriel<br/>Carretera Central Km 14.5, Valle Verde.<br/>
                       <span className="font-medium text-[#D4AF37] tracking-[0.1em] sm:tracking-widest uppercase mt-2 block text-[8px] sm:text-[9px]">Sábado, 23 de Mayo • 15:00 hrs</span>
                   </p>
                   <div className="flex flex-wrap justify-center sm:justify-start gap-2 sm:gap-3 w-full">
                       <div className="px-3 sm:px-4 py-2 bg-[#2A2A2A] text-white rounded-full font-sans text-[8px] sm:text-[9px] tracking-[0.1em] sm:tracking-[0.2em] uppercase flex items-center shadow-md cursor-pointer text-center">Ver en GPS</div>
                       <div className="px-3 sm:px-4 py-2 bg-transparent text-[#2A2A2A] border border-[#D4AF37] rounded-full font-sans text-[8px] sm:text-[9px] tracking-[0.1em] sm:tracking-[0.2em] uppercase flex items-center shadow-sm cursor-pointer text-center">Agendar</div>
                   </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-3 text-slate-900 text-center sm:text-left">Ingeniería al Servicio del Asistente</h3>
                <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                  Evitamos indicaciones confusas. Integramos hipervínculos directos a Waze, Google Maps y Apple Maps para guiar a tus invitados de puerta a puerta. Sincronizamos la fecha con sus calendarios personales y mostramos pronósticos del clima en tiempo real para prever cualquier eventualidad y asegurar su comodidad.
                </p>
              </section>
            </div>

            {/* FILA 3 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">05. Ritmo y Sincronía</span>
                <div className="pl-4 sm:pl-6 border-l border-[#D4AF37]/30 mb-6 sm:mb-8 py-2">
                   <div className="relative mb-4 sm:mb-6">
                      <div className="absolute -left-[21px] sm:-left-[29px] top-1 w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-white border-[2px] border-[#D4AF37]"></div>
                      <span className="font-sans text-[8px] sm:text-[9px] text-[#D4AF37] tracking-[0.2em] font-bold block uppercase">15:00 hrs</span>
                      <h4 className="font-serif text-lg sm:text-xl text-gray-800">Llegada de Invitados</h4>
                      <p className="font-sans text-[9px] sm:text-[10px] text-gray-500 italic">Cóctel de bienvenida</p>
                   </div>
                   <div className="relative">
                      <div className="absolute -left-[21px] sm:-left-[29px] top-1 w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-white border-[2px] border-[#D4AF37]"></div>
                      <span className="font-sans text-[8px] sm:text-[9px] text-[#D4AF37] tracking-[0.2em] font-bold block uppercase">16:00 hrs</span>
                      <h4 className="font-serif text-lg sm:text-xl text-gray-800">Banquete Especial</h4>
                      <p className="font-sans text-[9px] sm:text-[10px] text-gray-500 italic">Comida exquisita y música</p>
                   </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-3 text-slate-900 text-center sm:text-left">El Minuto a Minuto</h3>
                <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                  Un diseño fluido que comunica la agenda de tu celebración sin abrumar. Mediante una línea de tiempo elegante, los invitados conocen los momentos cumbre de la noche, asegurando puntualidad y manteniendo la fluidez de la velada que planeaste con tanto esmero.
                </p>
              </section>

              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">06. Estética Colectiva</span>
                <div className="flex justify-center gap-6 sm:gap-10 mb-6 sm:mb-8 pl-0 sm:pl-4 border-l-0 sm:border-l-2 border-[#D4AF37]/30 py-2">
                    <div className="flex flex-col items-center">
                        <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-[#D4AF37]/50 shadow-md flex items-center justify-center mb-2 sm:mb-3 text-[#F76C82]">
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                            <path d="M9.5 3c1.5 2.5 3.5 2.5 5 0L16.5 8c.3.5.5 1.1.5 1.7v1.8a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 11.5V9.7c0-.6.2-1.2.5-1.7L9.5 3zM8.5 13L4.5 20.5a1 1 0 0 0 .9 1.5h13.2a1 1 0 0 0 .9-1.5L15.5 13M8 10h8" />
                          </svg>
                        </div>
                        <span className="font-sans text-[8px] sm:text-[9px] tracking-widest text-gray-600 uppercase font-bold text-center leading-tight">Vestido<br/>Floral</span>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-[#D4AF37]/50 shadow-md flex items-center justify-center mb-2 sm:mb-3 text-[#8DB580]">
                          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                            <path d="M20.38 3.46L16 2 12 5 8 2 3.62 3.46a2 2 0 00-1.35 2.22l.87 5.23a2 2 0 002 1.67h.54V21a1 1 0 001 1h10.64a1 1 0 001-1V12.58h.54a2 2 0 002-1.67l.87-5.23a2 2 0 00-1.35-2.22zM8 2v5a4 4 0 108 0V2M12 12v10M8 13h2v2H8zM14 13h2v2h-2z" />
                          </svg>
                        </div>
                        <span className="font-sans text-[8px] sm:text-[9px] tracking-widest text-gray-600 uppercase font-bold text-center leading-tight">Guayabera<br/>Fina</span>
                    </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-3 text-slate-900 text-center sm:text-left">Etiqueta Ilustrada</h3>
                <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                  La perfección estética de un evento se logra cuando todos los asistentes armonizan visualmente. A través de iconografía exclusiva, paletas de color sugeridas o moodboards de inspiración, guiamos la indumentaria de tus invitados de forma sutil, elegante y muy clara.
                </p>
              </section>
            </div>

            {/* FILA 4 */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">07. Un Viaje en el Tiempo</span>
                <div className="grid grid-cols-2 gap-2 sm:gap-3 auto-rows-[80px] sm:auto-rows-[100px] mb-6 sm:mb-8 pl-0 sm:pl-4 border-l-0 sm:border-l-2 border-[#D4AF37]/30">
                    <div className="row-span-2 col-span-1 rounded-xl sm:rounded-2xl overflow-hidden shadow-sm bg-slate-200"><img src="/maricela-estudillo-gonzalez/foto1.jpg" className="w-full h-full object-cover grayscale-[10%]" onError={(e) => e.target.style.display = 'none'} /></div>
                    <div className="row-span-1 col-span-1 rounded-xl sm:rounded-2xl overflow-hidden shadow-sm bg-slate-300"><img src="/maricela-estudillo-gonzalez/foto2.jpg" className="w-full h-full object-cover grayscale-[10%]" onError={(e) => e.target.style.display = 'none'} /></div>
                    <div className="row-span-1 col-span-1 rounded-xl sm:rounded-2xl overflow-hidden shadow-sm bg-slate-200"><img src="/maricela-estudillo-gonzalez/foto4.jpg" className="w-full h-full object-cover grayscale-[10%]" onError={(e) => e.target.style.display = 'none'} /></div>
                </div>
                <div>
                  <FloralCorner className="float-right w-12 h-12 sm:w-16 sm:h-16 ml-3 sm:ml-4 opacity-50" />
                  <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-2 sm:mb-3 text-slate-900 text-center sm:text-left">El Mosaico Fotográfico</h3>
                  <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                    Toda celebración tiene un trayecto previo. Tienes la libertad de elegir entre distintos estilos arquitectónicos para tu galería: retículas dinámicas (Masonry), carruseles elegantes o composiciones con formas geométricas asimétricas que rompen la monotonía y sumergen a los visitantes en tus recuerdos.
                  </p>
                </div>
              </section>

              <section className="flex flex-col border-t border-slate-200 pt-6 sm:pt-8">
                <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">08. Comodidad Financiera y Social</span>
                <div className="flex flex-col gap-3 sm:gap-4 mb-6 sm:mb-8 pl-0 sm:pl-4 border-l-0 sm:border-l-2 border-[#D4AF37]/30 py-2">
                   <div className="border border-[#D4AF37]/30 p-2 sm:p-3 rounded-2xl flex items-center gap-3 sm:gap-4 bg-white">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#D4AF37]/10 flex items-center justify-center text-[#D4AF37] shrink-0"><Gift size={16}/></div>
                      <div className="min-w-0">
                         <h4 className="font-bold text-[11px] sm:text-xs text-slate-800 truncate">Mesa de Regalos y Tiendas</h4>
                         <p className="text-[8px] sm:text-[9px] text-slate-500 font-mono mt-0.5 truncate">CLABE / Liverpool / Palacio</p>
                      </div>
                   </div>
                   <div className="border border-[#F76C82]/30 p-2 sm:p-3 rounded-2xl flex items-center gap-3 sm:gap-4 bg-white">
                      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#F76C82]/10 flex items-center justify-center text-[#F76C82] shrink-0"><Hash size={16}/></div>
                      <div className="min-w-0">
                         <h4 className="font-bold text-[11px] sm:text-xs text-slate-800 truncate">Conexión con Instagram</h4>
                         <p className="text-[9px] sm:text-[10px] font-bold text-[#F76C82] mt-0.5 truncate">#BodaMirandaYLuis</p>
                      </div>
                   </div>
                </div>
                <h3 className="text-xl sm:text-2xl font-editorial font-bold mb-3 text-slate-900 text-center sm:text-left">Gifting y Omnicanalidad</h3>
                <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify">
                  Tus invitados pueden transferir regalos en efectivo directamente a tus cuentas bancarias. Y si lo prefieren, integramos el código y enlace directo a la mesa de regalos de tus tiendas departamentales favoritas. Además, vinculamos tu hashtag oficial y filtros de Realidad Aumentada (AR) para que tu evento sea tendencia desde semanas antes de ocurrir.
                </p>
              </section>
            </div>

            {/* ÚLTIMA FILA: RSVP CENTRADO */}
            <section className="flex flex-col items-center border-t border-slate-200 pt-10 sm:pt-12 max-w-3xl mx-auto text-center">
               <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-widest text-[#D4AF37] mb-4 sm:mb-6 block">09. El Blindaje Final</span>
               <div className="w-full max-w-md bg-white p-5 sm:p-6 border border-slate-200 shadow-lg rounded-2xl sm:rounded-3xl mb-6 sm:mb-8">
                  <h4 className="font-serif text-xl sm:text-2xl text-slate-800 mb-4 sm:mb-6">Confirmación</h4>
                  <div className="p-2 sm:p-3 border border-slate-200 rounded-xl mb-4 sm:mb-6 text-left flex justify-between items-center">
                     <label className="text-[9px] sm:text-[10px] font-bold uppercase tracking-widest text-slate-500 block">Pase #1</label>
                     <div className="w-12 sm:w-16 h-5 sm:h-6 bg-[#8DB580]/20 rounded"></div>
                  </div>
                  <button className="w-full py-3 sm:py-4 bg-[#F76C82] text-white rounded-full font-bold text-[10px] sm:text-xs uppercase tracking-widest shadow-md">Confirmar Asistencia</button>
               </div>
               <h3 className="text-2xl sm:text-3xl md:text-4xl font-editorial font-bold mb-3 sm:mb-4 text-slate-900">RSVP Inteligente y Cero Colados</h3>
               <p className="text-slate-600 leading-relaxed font-light text-xs sm:text-sm text-justify sm:text-center px-0 sm:px-4">
                  La pieza maestra de nuestra ingeniería. Se acabaron los formularios genéricos donde los invitados anotan a 5 personas cuando solo invitaste a 2. El sistema reconoce la cuota asignada a cada familia y genera pases QR personales e intransferibles tras la confirmación, sincronizándose instantáneamente con tu panel de control y el escáner de la puerta.
               </p>
            </section>

          </div>

          <footer className="mt-20 sm:mt-32 border-t border-[#D4AF37]/30 pt-8 sm:pt-12 flex flex-col md:flex-row justify-between items-center text-slate-400 text-[10px] sm:text-xs font-bold uppercase tracking-widest transition-colors gap-4 text-center md:text-left">
            <span>Baulia Technologies Inc.</span>
            <span className="text-[#8DB580]">Inspiración: Primavera Vibrante</span>
          </footer>

        </main>
      </div>
    </div>
  );
};

// ==========================================
// --- COMPONENTE: ARQUITECTURA DEL SISTEMA (ANATOMÍA DEL PANEL / BÓVEDA) ---
// ==========================================
const PanelAnatomyOverlay = ({ onClose }) => {
  const GridPattern = () => (
    <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-[0.03]" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="techGrid" width="30" height="30" patternUnits="userSpaceOnUse">
          <path d="M 30 0 L 0 0 0 30" fill="none" stroke="#0f172a" strokeWidth="1"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#techGrid)" />
    </svg>
  );

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-md flex items-end sm:items-center justify-center sm:p-4 lg:p-8 animate-in fade-in duration-500 font-sans text-slate-900">
      
      <div className="w-[96vw] max-w-[1300px] h-[96vh] sm:h-[94vh] bg-slate-50 rounded-t-[2rem] sm:rounded-[2.5rem] shadow-2xl flex flex-col relative overflow-hidden animate-in slide-in-from-bottom-10 sm:zoom-in-95 duration-700 border border-slate-200">
        
        {/* NAVEGACIÓN SUPERIOR (TECH STYLE) */}
        <nav className="sticky top-0 w-full bg-white/90 backdrop-blur-xl z-50 px-6 sm:px-10 py-4 flex justify-between items-center border-b border-slate-200 shrink-0 shadow-sm">
          <div className="flex items-center gap-3">
             <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-white shadow-md">
                <Settings2 size={18} />
             </div>
             <span className="font-bold text-lg tracking-tight text-slate-800">Baulia <span className="font-medium text-slate-500">System Architecture</span></span>
          </div>
          <button onClick={onClose} className="group flex items-center text-[10px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600 transition-colors bg-slate-100 px-4 py-2 rounded-full">
            <span className="hidden sm:block">Cerrar Arquitectura</span> <X size={16} className="sm:ml-2 transform group-hover:rotate-90 transition-transform duration-300"/>
          </button>
        </nav>

        <main className="flex-1 overflow-y-auto custom-scrollbar relative bg-slate-50">
          <GridPattern />
          
          {/* HERO TECH */}
          <div className="px-6 sm:px-10 lg:px-16 pt-16 pb-16 relative z-10">
             <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-100 text-indigo-700 text-[10px] font-black uppercase tracking-widest mb-6 shadow-sm">
                <Settings2 size={12} /> Entorno Operativo Nivel 2
             </div>
             <h1 className="text-5xl sm:text-6xl lg:text-[80px] font-black tracking-tighter text-slate-900 leading-[0.95] mb-6">
                La Ingeniería detrás <br className="hidden md:block"/> de tu evento.
             </h1>
             <p className="text-base sm:text-lg text-slate-600 font-medium max-w-4xl leading-relaxed">
                La verdadera magia no solo radica en lo que los invitados ven, sino en el control absoluto que ocurre detrás del telón. Baulia te entrega una <b>Bóveda Digital</b> diseñada con los más altos estándares de ingeniería de software. Transformamos el caos logístico en una plataforma fluida, automatizada y elegante que te permite dominar cada variable de tu gran día.
             </p>
          </div>

          <div className="px-6 sm:px-10 lg:px-16 pb-24 space-y-8 relative z-10">

            {/* FILA 1: DASHBOARD Y DIRECTORIO */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              
              {/* 01. Dashboard & Notificaciones */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow relative overflow-hidden">
                <div className="flex items-center gap-3 mb-6 relative z-10">
                   <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center text-slate-600"><LayoutDashboard size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">01. Centro de Mando</h3>
                </div>
                
                <div className="relative mb-6 z-10">
                   <div className="grid grid-cols-2 gap-3 mb-3">
                      <div className="bg-slate-50 border border-slate-100 p-4 rounded-2xl">
                         <p className="text-[9px] uppercase tracking-widest font-bold text-slate-500 mb-1">Pases Asignados</p>
                         <p className="text-3xl font-black text-slate-800">185</p>
                         <span className="text-[8px] bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded font-bold uppercase mt-2 inline-block">85% Confirmado</span>
                      </div>
                      <div className="bg-slate-50 border border-slate-100 p-4 rounded-2xl">
                         <p className="text-[9px] uppercase tracking-widest font-bold text-slate-500 mb-1">Gasto Estimado</p>
                         <p className="text-3xl font-black text-slate-800">$150k</p>
                         <div className="w-full bg-slate-200 h-1 rounded-full mt-3"><div className="w-[45%] h-1 bg-amber-500 rounded-full"></div></div>
                      </div>
                   </div>
                   
                   <div className="absolute -bottom-4 -right-2 bg-white p-3 rounded-xl shadow-xl border border-slate-100 flex items-start gap-3 w-64 animate-pulse-slow">
                      <div className="text-amber-500 mt-0.5"><Bell size={16}/></div>
                      <div>
                         <p className="text-xs font-black uppercase text-slate-800">Notificación Inteligente</p>
                         <p className="text-[10px] text-slate-500">Familia Torres solicita +2 pases extra.</p>
                      </div>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto relative z-10 pt-6">
                  Tu tablero principal te ofrece telemetría en tiempo real. Un <b>sistema de notificaciones inteligentes</b> te avisa de pagos vencidos, nuevas confirmaciones o asistentes que requieren pases extra. Todo exportable en elegantes reportes PDF (Ejecutivos o Directorio completo) con un solo clic.
                </p>
              </section>

              {/* 02. Directorio Inteligente */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center text-indigo-600"><Users size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">02. Directorio Inteligente</h3>
                </div>
                
                <div className="bg-slate-50 border border-slate-100 rounded-2xl overflow-hidden mb-6 relative">
                   <div className="p-3 border-b border-slate-200 bg-white flex justify-between items-center">
                      <div className="flex items-center gap-2 bg-slate-100 p-1 rounded-xl">
                         <span className="text-[9px] font-bold text-slate-500 uppercase tracking-widest px-2">Boda</span>
                         <div className="w-8 h-4 bg-indigo-500 rounded-full relative"><div className="absolute top-0.5 right-0.5 w-3 h-3 bg-white rounded-full"></div></div>
                      </div>
                      <div className="flex gap-2">
                         <button className="bg-rose-500 text-white text-[8px] font-bold uppercase px-2 py-1 rounded shadow-sm">+ Novia</button>
                         <button className="bg-indigo-600 text-white text-[8px] font-bold uppercase px-2 py-1 rounded shadow-sm">+ Novio</button>
                      </div>
                   </div>
                   <div className="p-4 flex flex-col gap-3">
                      <div className="flex justify-between items-center bg-white p-3 rounded-xl border border-slate-200 shadow-sm">
                         <div>
                            <span className="font-bold text-sm text-slate-800 block mb-1">Familia Torres <span className="bg-rose-100 text-rose-600 px-1.5 py-0.5 rounded text-[8px] uppercase tracking-widest ml-1">Novia</span></span>
                            <span className="text-[10px] text-slate-500 flex items-center gap-2">
                               <MapPin size={10} className="text-indigo-400"/> Mesa 5 <span className="text-slate-300">|</span> 
                               Pin: <span className="font-mono bg-slate-100 px-1 rounded">7A9X</span>
                            </span>
                         </div>
                         <div className="text-right">
                            <span className="font-black text-indigo-600 text-sm block">4 Pases</span>
                            <span className="bg-emerald-100 text-emerald-700 text-[8px] px-1.5 py-0.5 rounded font-black uppercase">Confirmado</span>
                         </div>
                      </div>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  Tú creas la invitación y <b>los invitados se encargan de llenar la lista</b> con sus nombres cuando confirman. En bodas, activa el "Modo Boda" para separar invitados del Novio y la Novia. Visualiza la mesa asignada, el código PIN de acceso y el estatus en tiempo real. Además, el sistema separa pases infantiles para que sepas cuántos platillos <i>Kids</i> pedir.
                </p>
              </section>
            </div>

            {/* FILA 2: GESTIÓN DE MESAS Y CROQUIS (LA JOYA DE LA CORONA) */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              
              {/* 03. Gestión y Auto-Acomodo */}
              <section className="bg-slate-900 p-8 rounded-3xl border border-slate-800 shadow-2xl flex flex-col hover:shadow-indigo-500/20 transition-all relative overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10"></div>
                <div className="flex items-center gap-3 mb-6 relative z-10">
                   <div className="w-10 h-10 rounded-xl bg-amber-500/20 flex items-center justify-center text-amber-400"><Wand2 size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-white">03. Gestión de Mesas Automática</h3>
                </div>
                
                <div className="bg-[#111] border border-white/10 rounded-2xl p-4 mb-6 relative z-10">
                   <div className="flex justify-between items-center mb-4">
                      <span className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">Sin mesa (12)</span>
                      <button className="bg-amber-500 text-slate-900 text-[9px] font-black uppercase px-3 py-1.5 rounded flex items-center shadow-[0_0_15px_rgba(245,158,11,0.4)] hover:scale-105 transition-transform"><Wand2 size={10} className="mr-1"/> Auto-Acomodar</button>
                   </div>
                   
                   <div className="flex gap-4">
                      <div className="w-1/2 bg-[#1a1a1a] p-3 rounded-xl border border-white/5 cursor-grab shadow-lg">
                         <div className="flex justify-between items-center">
                            <span className="text-xs font-bold text-white"><GripVertical size={10} className="inline text-slate-500 mr-1"/> Fam. López</span>
                            <span className="text-xs font-black text-amber-500 bg-amber-500/10 px-2 rounded">4p</span>
                         </div>
                      </div>
                      <div className="w-1/2 bg-indigo-500/10 p-3 rounded-xl border border-indigo-500/30 border-dashed flex flex-col justify-center items-center">
                         <span className="text-xs font-bold text-white mb-1">Mesa 5</span>
                         <span className="text-[10px] text-indigo-400">Libres: 6/10</span>
                      </div>
                   </div>
                </div>

                <p className="text-sm text-slate-300 leading-relaxed font-medium mt-auto relative z-10">
                  Deja que el sistema piense por ti. El algoritmo <b>asigna a tus invitados automáticamente</b> priorizando <i>nunca separar a las familias</i> y optimizando cada espacio del salón. ¿Prefieres el control manual? Arrastra a los invitados entre mesas, visualiza en tiempo real cuántas sillas quedan libres, si la mesa se llenó, o crea mesas mixtas al gusto.
                </p>
              </section>

              {/* 04. Croquis Espacial */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-sky-50 flex items-center justify-center text-sky-600"><MapIcon size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">04. Croquis Arquitectónico</h3>
                </div>
                
                <div className="bg-slate-50 border border-slate-100 rounded-2xl h-48 mb-6 relative overflow-hidden flex items-center justify-center p-4">
                   <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
                   
                   {/* Mesa Redonda (Estilo Real) */}
                   <div className="relative w-[72px] h-[72px] flex items-center justify-center mx-4">
                      {/* Sillas */}
                      {[0, 36, 72, 108, 144, 180, 216, 252, 288, 324].map((deg, i) => (
                         <div key={i} className={`absolute w-3 h-3 rounded-full border-[1.5px] ${i < 6 ? 'bg-emerald-400 border-emerald-600' : 'bg-slate-200 border-slate-400'} z-0`} style={{ transform: `rotate(${deg}deg) translate(36px)` }}>
                           <div className={`absolute w-[45%] h-[115%] right-[-12%] rounded-full ${i < 6 ? 'bg-emerald-600' : 'bg-slate-400'}`}></div>
                         </div>
                      ))}
                      {/* Centro de la mesa */}
                      <div className="absolute inset-0 m-auto w-14 h-14 bg-white border-[3px] border-slate-400 rounded-full shadow-lg flex items-center justify-center z-10">
                         <span className="text-[10px] font-black text-slate-500">1</span>
                      </div>
                   </div>

                   {/* Mesa Cuadrada Realista */}
                   <div className="relative w-[72px] h-[72px] flex items-center justify-center mx-4">
                      {/* Centro de la mesa */}
                      <div className="absolute inset-0 m-auto w-14 h-14 bg-white border-[3px] border-slate-400 rounded-sm shadow-lg flex items-center justify-center z-10">
                         <span className="text-[10px] font-black text-slate-500">2</span>
                      </div>
                      {/* Sillas (3x4 = 12 total) */}
                      {/* Top */}
                      <div className="absolute -top-1 flex gap-1"><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div></div>
                      {/* Bottom */}
                      <div className="absolute -bottom-1 flex gap-1"><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div></div>
                      {/* Left */}
                      <div className="absolute -left-1.5 h-full flex flex-col justify-center gap-1.5"><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div></div>
                      {/* Right */}
                      <div className="absolute -right-1.5 h-full flex flex-col justify-center gap-1.5"><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div><div className="w-3 h-3 bg-slate-200 border-[1.5px] border-slate-400 rounded-full"><div className="absolute w-[45%] h-[115%] right-[-12%] rounded-full bg-slate-400"></div></div></div>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  Dibuja tu evento con medidas y proporciones exactas. Te permite asignar el número de sillas y acomodar mesas redondas, cuadradas, tablones o serpentinas en un croquis que tú mismo creas. Así tendrás un panorama realista de la capacidad de tu salón o jardín. Todo el acomodo que hagas se refleja visualmente aquí al instante.
                </p>
              </section>
            </div>

            {/* FILA 3: FINANZAS Y ESCÁNER */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              
              {/* 05. Bóveda Financiera */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center text-amber-600"><Wallet size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">05. Finanzas y Contratos</h3>
                </div>
                
                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-5 mb-6">
                   <div className="flex justify-between items-start mb-4">
                      <div>
                         <p className="font-bold text-slate-900 text-sm">Banquete Gourmet</p>
                         <p className="text-[9px] text-slate-500 uppercase tracking-widest mt-0.5">Límite de pago: 15 Oct</p>
                      </div>
                      <span className="bg-indigo-50 text-indigo-600 border border-indigo-200 px-2 py-1 rounded text-[9px] font-black uppercase tracking-widest flex items-center shadow-sm">
                        <FileSignature size={10} className="mr-1"/> Contrato.pdf
                      </span>
                   </div>
                   <div className="flex justify-between items-end bg-white p-3 rounded-xl border border-slate-100 shadow-sm mb-3">
                      <div>
                        <p className="text-[9px] text-slate-400 uppercase tracking-widest mb-0.5 font-bold">Costo Estimado</p>
                        <p className="font-medium text-slate-700 text-sm">$85,000.00</p>
                      </div>
                      <div className="text-right">
                        <p className="text-[9px] text-slate-400 uppercase tracking-widest mb-0.5 font-bold">Por Pagar</p>
                        <p className="font-black text-amber-600 text-lg">$45,000.00</p>
                      </div>
                   </div>
                   <div className="flex gap-2">
                      <button className="flex-1 bg-emerald-500 text-white text-[9px] font-black uppercase tracking-widest py-2 rounded-lg shadow-sm hover:scale-105 transition-transform">Abonar</button>
                      <button className="flex-1 bg-slate-100 text-slate-600 text-[9px] font-black uppercase tracking-widest py-2 rounded-lg border border-slate-200 flex justify-center items-center hover:bg-slate-200 transition-colors"><UploadCloud size={12} className="mr-1"/> Subir Recibo</button>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  Establece tu presupuesto y lleva el control milimétrico de tus gastos. Gestiona proveedores, sube comprobantes de abonos y <b>contratos en PDF</b>, todo centralizado al alcance de tu dedo. El sistema te genera reportes financieros corporativos al instante para compartir con tu equipo.
                </p>
              </section>

              {/* 06. Control de Accesos */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center text-emerald-600"><Scan size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">06. Escáner y Puerta QR</h3>
                </div>
                
                <div className="bg-slate-50 border border-slate-100 rounded-2xl h-48 mb-6 flex flex-col items-center justify-center p-4 relative overflow-hidden">
                   {/* Generador Pulseras Hint */}
                   <div className="absolute top-3 left-3 bg-white border border-slate-200 shadow-md px-3 py-1.5 rounded-lg flex items-center gap-2 hover:scale-105 transition-transform cursor-pointer">
                      <Printer size={12} className="text-indigo-500"/>
                      <span className="text-[8px] font-black uppercase tracking-widest text-slate-600">Descargar Pulseras PDF</span>
                   </div>

                   <div className="w-20 h-20 bg-slate-900 rounded-2xl border-4 border-slate-800 shadow-lg relative flex items-center justify-center overflow-hidden mb-3 mt-4">
                      <div className="absolute w-full h-1 bg-emerald-400 shadow-[0_0_15px_#34d399] animate-pulse"></div>
                      <QrCode size={28} className="text-white opacity-40"/>
                   </div>
                   <div className="bg-emerald-100 border border-emerald-200 text-emerald-700 px-4 py-2 rounded-xl shadow-sm w-full max-w-[220px] text-center">
                     <p className="text-[8px] font-black uppercase tracking-widest mb-0.5">Acceso Aprobado</p>
                     <p className="text-sm font-bold truncate">Familia Fuentes (4)</p>
                     <p className="text-[10px] font-bold opacity-80 mt-0.5">Mesa 5</p>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  El blindaje definitivo. Las *Hostess* o cadeneros usarán su propio celular como escáner láser. El sistema valida los pases QR al instante, evitando falsificaciones y mostrando la mesa asignada. Además, incluye un <b>generador de pulseras de ingreso</b> (PDF imprimible) para eventos de acceso súper restringido.
                </p>
              </section>
            </div>

            {/* FILA 4: TAREAS Y BOCETADOR */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              
              {/* 07. Checklist Kanban */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-rose-50 flex items-center justify-center text-rose-600"><CheckSquare size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">07. Tablero Táctil (Kanban)</h3>
                </div>
                
                <div className="flex gap-3 mb-6 h-48 overflow-hidden">
                   <div className="flex-1 bg-slate-50 rounded-xl border border-slate-100 p-2 flex flex-col">
                     <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-2 flex items-center"><Circle size={10} className="mr-1"/> Hacer</p>
                     <div className="bg-white p-2.5 rounded-lg border border-slate-200 shadow-sm">
                       <p className="font-bold text-[11px] text-slate-800 leading-tight">Prueba de Menú</p>
                     </div>
                   </div>
                   <div className="flex-1 bg-indigo-50/50 rounded-xl border border-indigo-100/50 p-2 flex flex-col">
                     <p className="text-[9px] font-black text-indigo-500 uppercase tracking-widest mb-2 flex items-center"><Clock size={10} className="mr-1"/> Proceso</p>
                     <div className="bg-white p-2.5 rounded-lg border border-slate-200 shadow-sm cursor-grab">
                       <span className="bg-slate-100 text-slate-500 text-[8px] px-1.5 py-0.5 rounded font-black uppercase mb-1 block w-max">Logística</span>
                       <p className="font-bold text-[11px] text-slate-800 leading-tight">Permisos Alcaldía</p>
                     </div>
                   </div>
                   <div className="flex-1 bg-emerald-50/50 rounded-xl border border-emerald-100/50 p-2 flex flex-col">
                     <p className="text-[9px] font-black text-emerald-600 uppercase tracking-widest mb-2 flex items-center"><CheckCircle2 size={10} className="mr-1"/> Listo</p>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  Gestiona la planeación paso a paso con una interfaz táctil profesional. Arrastra tus tareas entre columnas visuales. Asigna categorías y fechas límite; el sistema se encarga de priorizarlas y recordarte las tareas urgentes para que tengas control absoluto de los meses previos.
                </p>
              </section>

              {/* 08. Bocetador Decorativo */}
              <section className="bg-slate-900 p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-pink-500/20 transition-all relative overflow-hidden">
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10"></div>
                <div className="flex items-center gap-3 mb-6 relative z-10">
                   <div className="w-10 h-10 rounded-xl bg-pink-500/20 flex items-center justify-center text-pink-400"><Palette size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-white">08. Estudio Decorativo 2D</h3>
                </div>
                
                <div className="bg-[#111] border border-white/10 rounded-2xl h-48 mb-6 relative flex items-end justify-center p-4 overflow-hidden z-10 shadow-inner">
                   <div className="absolute inset-0 bg-slate-800 opacity-30"></div>
                   
                   {/* Vectores Decorativos */}
                   <div className="relative z-10 flex flex-col items-center">
                      <div className="absolute -top-6 -right-6 flex gap-1">
                         <div className="w-6 h-6 rounded-full bg-yellow-400 shadow-md"></div>
                         <div className="w-8 h-8 rounded-full bg-white shadow-md"></div>
                         <div className="w-6 h-6 rounded-full bg-yellow-400 shadow-md"></div>
                      </div>
                      <div className="w-24 h-32 border-8 border-pink-300 rounded-t-full relative flex items-center justify-center shadow-lg">
                         <span className="text-pink-300 font-editorial text-xl italic">Ana</span>
                      </div>
                   </div>

                   {/* Regla de medición */}
                   <div className="absolute bottom-4 left-4 right-4 border-b-2 border-dashed border-sky-400 flex justify-between items-end px-2">
                      <div className="w-1 h-3 bg-sky-400"></div>
                      <span className="bg-sky-500 text-white text-[8px] font-mono px-2 py-0.5 rounded -mb-2">Escala Exacta: 2.5 Metros</span>
                      <div className="w-1 h-3 bg-sky-400"></div>
                   </div>
                </div>

                <p className="text-sm text-slate-300 leading-relaxed font-medium mt-auto relative z-10">
                  Crea bocetos espectaculares de tus sets de fotos o mesas de honor. <b>Importa una foto real de tu locación</b>, cálibrala a medidas reales y arrastra vectores arquitectónicos (mamparas, guirnaldas de globos, luces neón, mobiliario lounge). Envíale el diseño en PDF a tu decorador junto a un listado automático de materiales (BOM).
                </p>
              </section>
            </div>

            {/* FILA 5: MINUTO A MINUTO Y PANTALLA GIGANTE */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              
              {/* 09. Minuto a Minuto */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center text-white"><Clock size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">09. El Minuto a Minuto</h3>
                </div>
                
                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-5 mb-6 relative">
                   <div className="absolute left-6 top-6 bottom-6 w-0.5 bg-slate-200"></div>
                   <div className="relative pl-6 mb-4">
                      <div className="absolute left-[-21px] top-1 w-3 h-3 bg-white border-2 border-indigo-500 rounded-full"></div>
                      <div className="flex justify-between items-center mb-1">
                        <span className="font-black text-indigo-600 text-lg">15:00</span>
                        <span className="bg-slate-200 text-slate-600 px-2 py-0.5 rounded text-[8px] font-black uppercase tracking-widest">Hostess</span>
                      </div>
                      <p className="font-bold text-slate-800 text-sm">Apertura de Puertas</p>
                   </div>
                   <div className="relative pl-6">
                      <div className="absolute left-[-21px] top-1 w-3 h-3 bg-white border-2 border-indigo-500 rounded-full"></div>
                      <div className="flex justify-between items-center mb-1">
                        <span className="font-black text-indigo-600 text-lg">16:30</span>
                        <span className="bg-slate-200 text-slate-600 px-2 py-0.5 rounded text-[8px] font-black uppercase tracking-widest">DJ</span>
                      </div>
                      <p className="font-bold text-slate-800 text-sm">Entrada Estelar</p>
                      <p className="text-[10px] text-slate-500 mt-1 italic bg-white p-1.5 rounded border border-slate-100">Canción: Viva la Vida</p>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  Sincroniza al staff y a los proveedores con un guion operativo impecable. Crea el itinerario del evento especificando la hora, actividad, responsable, lugar y notas. El sistema te permite generar un <b>Rundown Operativo en PDF</b> al instante para imprimirlo o enviarlo por WhatsApp al equipo la mañana del evento.
                </p>
              </section>

              {/* 10. Muro Social y Proyector */}
              <section className="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm flex flex-col hover:shadow-lg transition-shadow">
                <div className="flex items-center gap-3 mb-6">
                   <div className="w-10 h-10 rounded-xl bg-pink-50 flex items-center justify-center text-pink-600"><PlayCircle size={20}/></div>
                   <h3 className="text-2xl font-black tracking-tight text-slate-900">10. Galería y Muro Social</h3>
                </div>
                
                {/* Mockup Muro Social + Likes/Retos */}
                <div className="bg-slate-50 border border-slate-100 rounded-2xl h-48 mb-6 p-4 flex gap-4 overflow-x-auto hide-scrollbar relative">
                   <div className="w-40 bg-white rounded-2xl shadow-md border border-slate-200 overflow-hidden flex flex-col shrink-0">
                      <div className="h-24 bg-slate-200 relative">
                         <img src="/maricela-estudillo-gonzalez/foto2.jpg" className="w-full h-full object-cover" onError={(e) => e.target.style.display = 'none'} />
                      </div>
                      <div className="p-3 flex-1 flex flex-col justify-between">
                         <div className="flex items-center justify-between mb-1">
                            <span className="font-bold text-[10px] text-slate-800">Ana Ruiz</span>
                            <div className="flex items-center gap-2">
                               <span className="flex items-center text-[9px] font-bold text-rose-500"><Heart size={10} className="fill-rose-500 mr-0.5"/> 12</span>
                               <span className="flex items-center text-[9px] font-bold text-slate-400"><MessageCircle size={10} className="mr-0.5"/> 3</span>
                            </div>
                         </div>
                         <p className="text-[9px] text-slate-500 leading-tight">¡Qué gran noche! ✨</p>
                      </div>
                   </div>

                   <div className="w-32 bg-amber-50 rounded-2xl shadow-md border border-amber-200 p-3 flex flex-col items-center justify-center text-center shrink-0 relative overflow-hidden">
                      <div className="absolute inset-0 bg-amber-400/10 animate-pulse"></div>
                      <span className="text-2xl mb-2 relative z-10">🎲</span>
                      <p className="text-[10px] font-black text-amber-900 uppercase tracking-wide relative z-10">Misión Secreta</p>
                      <p className="text-[9px] text-amber-800 mt-1 relative z-10 leading-tight">"Foto brindando con tu mesa 🥂"</p>
                   </div>
                </div>

                <p className="text-sm text-slate-600 leading-relaxed font-medium mt-auto">
                  La invitación web se transforma el día del evento en una red social. Tus invitados suben fotos, reciben <i>likes</i>, comentarios y juegan "Retos Fotográficos". Integramos un enlace especial para <b>proyectores o pantallas gigantes</b> que muestra este contenido en tiempo real (con opción de moderar el contenido previamente).
                </p>
              </section>
            </div>

            {/* FILA 6: PANTALLA GIGANTE (PROYECTOR) */}
            <section className="bg-slate-900 rounded-3xl p-8 lg:p-12 border border-slate-800 shadow-2xl flex flex-col items-center text-center relative overflow-hidden">
               <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10"></div>
               
               <span className="text-[10px] font-black uppercase tracking-widest text-indigo-400 mb-6 block relative z-10">Proyección en Tiempo Real</span>
               <h3 className="text-3xl sm:text-4xl font-black text-white mb-8 relative z-10">El Muro Social Inmersivo (Proyector)</h3>

               <div className="w-full max-w-2xl aspect-video bg-black rounded-2xl border-4 border-slate-800 shadow-2xl relative overflow-hidden mb-8 z-10 flex">
                  {/* Foto gigante con dinámica de likes y comentarios */}
                  <div className="w-2/3 h-full relative">
                     <img src="/maricela-estudillo-gonzalez/foto1.jpg" className="w-full h-full object-cover opacity-80" onError={(e) => e.target.style.display = 'none'} />
                     <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                     
                     {/* 🎲 CORAZONES FLOTANTES ESTILO TIKTOK */}
                     {[10, 20, 30, 40, 50, 60, 70, 80].map((left, i) => (
                        <div key={i} className="absolute text-rose-500 animate-tiktok-heart opacity-0" style={{ left: `${left}%`, animationDelay: `${i * 0.4}s`, bottom: `${i*10}%` }}>
                           <Heart size={20} className="fill-rose-500"/>
                        </div>
                     ))}

                     {/* 💬 COMENTARIOS FLOTANTES */}
                     <div className="absolute top-1/4 right-4 bg-white/20 backdrop-blur rounded-full px-3 py-1.5 flex items-center gap-2 shadow-lg animate-in slide-in-from-right fade-in transition-all">
                        <MessageCircle size={10} className="text-white"/>
                        <span className="text-white text-[9px] font-bold">¡Guapísimos! ✨</span>
                     </div>
                     <div className="absolute top-1/3 left-4 bg-white/10 backdrop-blur rounded-full px-3 py-1.5 flex items-center gap-2 shadow-lg animate-in slide-in-from-left fade-in transition-all Delay-500">
                        <Heart size={10} className="text-white fill-rose-500"/>
                        <span className="text-white text-[9px] font-bold">¡Qué noche! 🥂</span>
                     </div>

                     <div className="absolute bottom-4 left-4 text-left">
                        <p className="text-white font-bold text-lg drop-shadow-md">Familia López</p>
                        <p className="text-white/80 text-xs italic">"Disfrutando muchísimo la fiesta de Maricela"</p>
                     </div>
                  </div>
                  {/* Barra lateral */}
                  <div className="w-1/3 h-full bg-slate-900/90 backdrop-blur border-l border-white/10 p-4 flex flex-col justify-center items-center">
                     <QrCode size={48} className="text-white/50 mb-3" />
                     <p className="text-white font-black text-[6px] uppercase tracking-widest text-center leading-tight">¡Sube tu foto!<br/><span className="text-indigo-400">#NuestraBoda</span></p>
                  </div>
               </div>

               <p className="text-sm sm:text-base text-slate-400 leading-relaxed font-light max-w-3xl relative z-10">
                 Integramos un modo especial diseñado para conectarse a las pantallas o proyectores del salón. Las fotografías que tus invitados suban desde sus celulares durante la fiesta, aparecerán en tiempo real en las pantallas del evento, creando una experiencia interactiva majestuosa. Los likes (corazones) y comentarios flotando sobre la pantalla harán que la interacción se sienta vibrante y en vivo, multiplicando los recuerdos de tu noche. Todo cuenta con un sistema de moderación opcional para tu total tranquilidad.
               </p>
            </section>

          </div>

        </main>
      </div>
    </div>
  );
};

// ==========================================
// --- COMPONENTE: PÁGINA DE VENTAS WEB (BAULIA - BOUTIQUE DIGITAL) ---
// ==========================================
const LandingPageView = ({ isDarkMode, themeSetting, cycleTheme }) => {
  const [legalModal, setLegalModal] = useState(null);
  const [checkoutModal, setCheckoutModal] = useState(null);
  const [checkoutSuccess, setCheckoutSuccess] = useState(false);
  const [fakeRsvp, setFakeRsvp] = useState(false);

  // 🟢 ESTADOS PARA LOS MINI-SIMULADORES INTERACTIVOS DEL BENTO BOX
  const [rsvpDemoMode, setRsvpDemoMode] = useState('qr'); // 'qr' | 'whatsapp'
  const [acomodoSimulated, setAcomodoSimulated] = useState(false);
  const [demoTagsActivas, setDemoTagsActivas] = useState(['Primos', 'Amigos']);
  const [croquisDemoMesas, setCroquisDemoMesas] = useState([
    { id: 1, nombre: 'Mesa 1', tipo: 'redonda', cap: 10, ocupadas: 10, x: 20, y: 34 },
    { id: 2, nombre: 'Mesa 2', tipo: 'redonda', cap: 10, ocupadas: 7, x: 80, y: 34 },
    { id: 3, nombre: 'Mesa 3', tipo: 'tablon', cap: 10, ocupadas: 8, x: 50, y: 76 }
  ]);
  const [draggingMesaId, setDraggingMesaId] = useState(null);
  const croquisCanvasRef = useRef(null);
  const [galeriaDemoEstilo, setGaleriaDemoEstilo] = useState('carrusel'); // 'carrusel' | 'masonry' | 'arcos'
  const [regaloDemoTipo, setRegaloDemoTipo] = useState('sobres'); // 'sobres' | 'tiendas'
  const [clabeDemoCopiada, setClabeDemoCopiada] = useState(false);
  const [gpsDemoActivo, setGpsDemoActivo] = useState(false);
  const [agendaDemoGuardada, setAgendaDemoGuardada] = useState(false);

  // 🟢 ESTADOS PARA EL SIMULADOR INTERACTIVO DE LA BÓVEDA (7 PESTAÑAS EN VIVO)
  const [bovedaPreviewTab, setBovedaPreviewTab] = useState('resumen');
  const [bovedaChecklistDemo, setBovedaChecklistDemo] = useState([
    { id: 1, t: 'Degustación de Banquete', cat: 'Comida', done: true },
    { id: 2, t: 'Aprobar Pases Extra (Fam. Villarreal)', cat: 'Logística', done: false },
    { id: 3, t: 'Liquidar anticipo de DJ y Audio', cat: 'Finanzas', done: false }
  ]);
  const [bovedaScanCount, setBovedaScanCount] = useState(184);

  // 🟢 ESTADOS PASO 3: FICHA TÉCNICA POR PLAN Y PORTAL COMPARATIVO
  const [fichaPlanModal, setFichaPlanModal] = useState(null); // 'basico' | 'plata' | 'oro' | 'diamante' | null
  const [fichaTab, setFichaTab] = useState('invitacion'); // 'invitacion' | 'boveda'
  const [portalComparativoOpen, setPortalComparativoOpen] = useState(false);
  const [mobileComparePlan, setMobileComparePlan] = useState('oro');

  // 🟢 ESTADOS PASO 4: SIMULADORES INTERACTIVOS DE SOCIAL WALL (LLUVIA DE CORAZONES + COMENTARIOS) Y BLACK LABEL
  const [socialFotoActiva, setSocialFotoActiva] = useState(1); // 1 (/social1.jpg) | 2 (/social2.jpg)
  const [socialModoAcceso, setSocialModoAcceso] = useState('publico'); // 'publico' | 'privado'
  const [socialRetoActivo, setSocialRetoActivo] = useState('📸 Reto: Selfie de toda la mesa');
  const [socialFotosData, setSocialFotosData] = useState({
    1: { autor: 'Familia Montemayor (Mesa 1)', comentario: '¡Que vivan los novios! La mejor noche 🥂✨', likes: 28 },
    2: { autor: 'Amigos de la Universidad (Mesa 4)', comentario: '¡Reto cumplido! La pista está encendida 🔥🕺', likes: 42 }
  });
  const [socialNuevoComentario, setSocialNuevoComentario] = useState('');
  const [socialHeartRain, setSocialHeartRain] = useState([]);
  const [socialCardFinish, setSocialCardFinish] = useState('obsidiana'); // 'obsidiana' | 'marfil' | 'champagne'
  const [pulseraColor, setPulseraColor] = useState('oro'); // 'oro' | 'negro' | 'plata' | 'rosa'
  const [radarCount, setRadarCount] = useState(184);
  const [radarGuestIdx, setRadarGuestIdx] = useState(0);

  const dispararLluviaCorazones = () => {
    setSocialFotosData(prev => ({
      ...prev,
      [socialFotoActiva]: {
        ...prev[socialFotoActiva],
        likes: prev[socialFotoActiva].likes + 1
      }
    }));
    const batchId = Date.now();
    const nuevosCorazones = [15, 28, 42, 55, 68, 78, 88].map((leftPos, idx) => ({
      id: `${batchId}-${idx}`,
      left: leftPos + (idx % 2 === 0 ? 3 : -3),
      delay: idx * 0.08,
      emoji: idx % 3 === 0 ? '💖' : idx % 2 === 0 ? '❤️' : '✨'
    }));
    setSocialHeartRain(prev => [...prev.slice(-14), ...nuevosCorazones]);
    setTimeout(() => {
      setSocialHeartRain(prev => prev.filter(h => !String(h.id).startsWith(String(batchId))));
    }, 1600);
  };

  const enviarComentarioSocial = (e) => {
    e.preventDefault();
    if (!socialNuevoComentario.trim()) return;
    setSocialFotosData(prev => ({
      ...prev,
      [socialFotoActiva]: {
        ...prev[socialFotoActiva],
        autor: 'Tú (Invitado en Vivo ✨)',
        comentario: socialNuevoComentario.trim()
      }
    }));
    setSocialNuevoComentario('');
    dispararLluviaCorazones();
  };

  const [timeLeft, setTimeLeft] = useState({ d: 45, h: 12, m: 30, s: 59 });
  const [accentColor, setAccentColor] = useState('monochrome');
  
  // ESTADO PARA ABRIR LA REVISTA
  const [showAnatomy, setShowAnatomy] = useState(false);
  const [showPanelAnatomy, setShowPanelAnatomy] = useState(false);

  // ESTADOS PARA EL SHOWROOM INCRUSTADO
  const [activeCategory, setActiveCategory] = useState('boda');
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // 🔴 ESTADO VITAL PARA EL VISOR MÓVIL (Evita la pantalla negra)
  const [fullScreenDemo, setFullScreenDemo] = useState(null);

  // 🟢 BLOQUEO INTELIGENTE DE SCROLL DE FONDO (Ahora ubicado después de declarar todos los estados)
  useEffect(() => {
    const isAnyModalOpen = Boolean(checkoutModal || checkoutSuccess || legalModal || fullScreenDemo || fichaPlanModal || portalComparativoOpen || showAnatomy || showPanelAnatomy);
    if (isAnyModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [checkoutModal, checkoutSuccess, legalModal, fullScreenDemo, fichaPlanModal, portalComparativoOpen, showAnatomy, showPanelAnatomy]);

  const updateMesaPositionFromClientXY = (clientX, clientY, targetId = draggingMesaId) => {
    if (!targetId || !croquisCanvasRef.current) return;
    const rect = croquisCanvasRef.current.getBoundingClientRect();
    const relX = Math.max(15, Math.min(85, ((clientX - rect.left) / rect.width) * 100));
    const relY = Math.max(22, Math.min(80, ((clientY - rect.top) / rect.height) * 100));
    setCroquisDemoMesas(prev => prev.map(m => m.id === targetId ? { ...m, x: relX, y: relY } : m));
  };

  const handleCroquisPointerMove = (e) => {
    if (!draggingMesaId) return;
    updateMesaPositionFromClientXY(e.clientX, e.clientY);
  };

  const handleCroquisTouchMove = (e) => {
    if (!draggingMesaId || !e.touches || !e.touches[0]) return;
    updateMesaPositionFromClientXY(e.touches[0].clientX, e.touches[0].clientY);
  };

  // ESTADOS PARA NOTIFICACIONES DINÁMICAS (HERO)
  const [notifIndex, setNotifIndex] = useState(0);
  
  const macIframeRef = useRef(null);
  const iphoneIframeRef = useRef(null);
  const [activeDevice, setActiveDevice] = useState('iphone'); 
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [moneda, setMoneda] = useState('MXN');

  // 🔴 1. ESTADO DE LA BASE DE DATOS (Precios Netos con IVA Incluido sincronizados con el Panel)
  const [preciosDB, setPreciosDB] = useState(() => {
    try {
      const cached = localStorage.getItem('baulia_precios_live');
      if (cached) return JSON.parse(cached);
    } catch (e) {}
    return {
      preciosBase: {
        basico: { MXN: 990, USD: 59 },
        plata: { MXN: 1690, USD: 95 },
        oro: { MXN: 2490, USD: 139 },
        diamante: { MXN: 3990, USD: 219 },
        social_wall: { MXN: 1290, USD: 79 },
        black_label: { MXN: 1490, USD: 89 }
      },
      promocion: { activa: false, porcentaje: 0, productos: {} }
    };
  });

  // 🟢 ESTADO Y ESCUCHADOR DE RESEÑAS APROBADAS DESDE EL PANEL ("resenas")
  const testimoniosEditorialFallback = [
    {
      id: 't1',
      nombre: 'Ana Sofía V.',
      evento: 'Boda en Jardín • Anfitriona',
      texto: 'Se los juro que el acomodo de mesas me tenía al borde del colapso porque mis papás están divorciados. Separarlos por etiquetas en la bóveda fue la salvación. Y cuando nos llegó la caja negra con las pulseras a la casa... uf, se sintió súper premium.',
      estrellas: 5
    },
    {
      id: 't2',
      nombre: 'Marcela Garza',
      evento: 'XV Años de mi hija • Anfitriona',
      texto: 'Cero colados en los XV de mi niña!! Le pasé el link a la chica de la entrada y con su propio celular iba escaneando rapidísimo. Las tías batallaron un poquito al inicio con el QR de la mesa, pero cuando vieron que sus fotos salían en la pantalla gigante no soltaron el celular jaja.',
      estrellas: 5
    },
    {
      id: 't3',
      nombre: 'Carlos y Andrea',
      evento: 'Boda Civil & Religiosa',
      texto: 'Yo solo quería llevar el control de pagos a proveedores para no pasarnos del presupuesto, pero el Social Wall se robó la noche. Ni gastamos en cabina de fotos porque todos subían sus selfies directo al proyector. Lo desquitamos peso por peso.',
      estrellas: 5
    }
  ];
  const [testimoniosPublicos, setTestimoniosPublicos] = useState(testimoniosEditorialFallback);
  const [verTodosTestimoniosModal, setVerTodosTestimoniosModal] = useState(false);

  // 🔴 2. ESCUCHADOR EN TIEMPO REAL AL PANEL (Precios y Colección "resenas")
  useEffect(() => {
    const unsubPrecios = onSnapshot(doc(db, 'ajustes_baulia', 'precios_publicos'), (docSnap) => {
      if (docSnap.exists()) {
        const liveData = docSnap.data();
        setPreciosDB(liveData);
        try { localStorage.setItem('baulia_precios_live', JSON.stringify(liveData)); } catch (e) {}
      }
    });

    let unsubResenas = () => {};
    try {
      if (typeof collection === 'function') {
        unsubResenas = onSnapshot(collection(db, 'resenas'), (snap) => {
          const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
          docs.sort((a, b) => {
            const tA = a.createdAt?.toMillis ? a.createdAt.toMillis() : (a.createdAt?.seconds ? a.createdAt.seconds * 1000 : 0);
            const tB = b.createdAt?.toMillis ? b.createdAt.toMillis() : (b.createdAt?.seconds ? b.createdAt.seconds * 1000 : 0);
            return tB - tA;
          });
          const aprobadas = docs
            .filter(data => data.status === 'aprobada' || data.aprobado === true || data.status === 'approved')
            .map(data => ({
              id: data.id,
              nombre: data.authorName || data.nombre || 'Anfitrión Baulia',
              evento: data.authorType || data.evento || 'Evento Verificado Baulia',
              texto: data.comment || data.comentario || data.texto || '',
              estrellas: Number(data.rating || data.estrellas || 5)
            }));

          if (aprobadas.length >= 3) {
            setTestimoniosPublicos(aprobadas);
          } else if (aprobadas.length > 0) {
            setTestimoniosPublicos([...aprobadas, ...testimoniosEditorialFallback.slice(aprobadas.length)]);
          } else {
            setTestimoniosPublicos(testimoniosEditorialFallback);
          }
        });
      }
    } catch (e) {}

    return () => {
      unsubPrecios();
      unsubResenas();
    };
  }, []);

  // 🔴 3. CONSTRUCTOR DE PRECIOS BLINDADO (100% Dinámico)
  const obtenerPrecio = (productoId) => {
    if (!preciosDB || !preciosDB.preciosBase) {
      return { precios: { MXN: '990', USD: '59' }, preciosOriginales: { MXN: null, USD: null }, raw: { MXN: '990', USD: '59' } };
    }
    
    const res = { precios: {}, preciosOriginales: {}, raw: {} };
    ['MXN', 'USD'].forEach(m => {
      const base = Number(preciosDB.preciosBase[productoId]?.[m]) || 0;
      const promoActiva = preciosDB.promocion?.activa && preciosDB.promocion?.productos?.[productoId];
      
      if (promoActiva) {
        const porcentaje = Number(preciosDB.promocion?.porcentaje) || 0;
        const desc = Math.round(base * (porcentaje / 100));
        const final = base - desc;
        res.precios[m] = final.toLocaleString('en-US');
        res.preciosOriginales[m] = base.toLocaleString('en-US');
        // 🔴 Convertimos a TEXTO (.toString) para que el Checkout no crashee
        res.raw[m] = final.toString(); 
      } else {
        res.precios[m] = base.toLocaleString('en-US');
        res.preciosOriginales[m] = null;
        // 🔴 Convertimos a TEXTO (.toString) para que el Checkout no crashee
        res.raw[m] = base.toString(); 
      }
    });
    return res;
  };

  // 🔴 4. ARREGLO "planes" CON ENFOQUE ARTÍSTICO Y ALTA COSTURA + SOFTWARE VIP
  // 🔴 4. ARREGLO "planes" CON FICHA TÉCNICA COMPLETA Y PRECIOS DINÁMICOS DE FIREBASE
  const planes = [
    { 
      id: 'basico', 
      nombre: 'Básico', 
      subtitulo: 'La Esencia Artística',
      ...obtenerPrecio('basico'), 
      desc: 'El anuncio elegante con diseño de alta costura para quienes desean simplicidad con estética impecable.', 
      icon: <Smartphone size={24}/>, 
      f: [
        'Diseño de Alta Costura + 1 Foto de Portada (Slow Zoom)',
        'Reproductor de Música sin bloqueo y Frase Emotiva',
        'Cuenta Regresiva en vivo y 1 Ubicación GPS nativa',
        'Confirmación de asistencia directa a tu WhatsApp',
        'Bóveda Baulia en Modo Bienvenida (Enlace listo)'
      ],
      fichaInvitacion: [
        { t: '1 Fotografía de Portada (Efecto Slow Zoom)', d: 'Encuadre protagónico con movimiento cinematográfico suave y tipografía de alta costura.' },
        { t: 'Música de Fondo sin Bloqueos', d: 'Tu canción especial se reproduce al abrir la invitación con botón flotante tipo ecualizador.' },
        { t: 'Frase Emotiva y Cuenta Regresiva', d: 'Cita especial en caligrafía serif fina y reloj en tiempo real hasta el día del evento.' },
        { t: '1 Ubicación GPS Inteligente', d: 'Detecta iOS o Android para abrir Apple Maps o Google Maps con la ruta exacta.' },
        { t: 'Confirmación Directa por WhatsApp', d: 'Tus invitados confirman con un toque enviando un mensaje directo a tu teléfono.' }
      ],
      fichaBoveda: [
        { t: 'Panel de Bienvenida y Enlace Oficial', d: 'Acceso a tu cuenta Baulia con tu invitación lista para compartir.', ok: true },
        { t: 'Vista Previa de Herramientas Pro (Con Candado)', d: 'Podrás visualizar los módulos de Mesas, QRs y Finanzas por si deseas hacer Upgrade en cualquier momento.', ok: true },
        { t: 'Lista de Invitados para Envíos WhatsApp', d: 'Disponible a partir del Plan Plata.', ok: false },
        { t: 'Pases QR Vivos y Auto-Acomodo de Mesas', d: 'Disponible a partir del Plan Oro.', ok: false },
        { t: 'Croquis 2D, Social Wall y Black Label', d: 'Exclusivo del Plan Diamante.', ok: false }
      ]
    },
    { 
      id: 'plata', 
      nombre: 'Plata', 
      subtitulo: 'Retorno de Inversión',
      ...obtenerPrecio('plata'), 
      desc: 'Se paga solo: integra Lluvia de Sobres a 1 clic, mesa de regalos, galería fotográfica e itinerario.', 
      icon: <Wallet size={24}/>, 
      f: [
        'Todo el Plan Básico + Monograma de Iniciales',
        'Galería Fotográfica en Carrusel (Hasta 5 fotos)',
        'Lluvia de Sobres (CLABE 1-clic) y Mesa de Regalos',
        'Sección de Padres, Itinerario y Dress Code visual',
        '2 Ubicaciones GPS + Botón Agendar en Calendario',
        'Bóveda: Lista de Invitados para envíos por WhatsApp'
      ],
      fichaInvitacion: [
        { t: 'Todo el Arte del Plan Básico + Monograma', d: 'Incluye sello o monograma elegante con las iniciales de los festejados.' },
        { t: 'Galería Fotográfica Estándar (Hasta 5 Fotos)', d: 'Carrusel táctil de alta resolución con tus mejores fotografías.' },
        { t: 'Lluvia de Sobres (1-Clic) y Mesa de Regalos', d: 'Tus invitados copian tu CLABE bancaria en un toque (0% comisión) o abren tus mesas de Liverpool, Palacio de Hierro o Amazon.' },
        { t: 'Mención de Padres, Itinerario y Dress Code', d: 'Línea de tiempo minuto a minuto e íconos de código de vestimenta.' },
        { t: '2 Ubicaciones GPS + Agendar en Calendario', d: 'Ceremonia y Recepción con descarga directa a Apple y Google Calendar.' }
      ],
      fichaBoveda: [
        { t: 'Módulo de Invitados Desbloqueado (Modo Envío)', d: 'Registra a tus familias y envíales su invitación por WhatsApp en 1 clic llevando el control de a quién ya invitaste.', ok: true },
        { t: 'Simulador de Invitación en Vivo', d: 'Previsualiza tu invitación dentro de tu panel en todo momento.', ok: true },
        { t: 'RSVP Blindado y Pases QR con Mesa', d: 'Bloqueado con candado (Desbloquéalo subiendo a Plan Oro).', ok: false },
        { t: 'Gestión de Mesas + Algoritmo por Afinidad', d: 'Bloqueado con candado (Desbloquéalo subiendo a Plan Oro).', ok: false },
        { t: 'Croquis 2D, Social Wall y Black Label', d: 'Exclusivo del Plan Diamante.', ok: false }
      ]
    },
    { 
      id: 'oro', 
      nombre: 'Oro', 
      subtitulo: 'Cero Colados & Mesas IA',
      ...obtenerPrecio('oro'), 
      desc: 'El estándar de lujo: Saludo VIP, Pases QR con número de mesa y Auto-Acomodo inteligente por Afinidad.', 
      icon: <ShieldCheck size={24}/>, 
      popular: true, 
      d2: true, 
      f: [
        'Todo el Plan Plata + Saludo VIP por Nombre en Portada',
        'Hasta 3 Fotos de Portada (Fade-out) + Galería 10 Fotos (Masonry/Arcos)',
        'Padres, Padrinos, Sugerencias de Hospedaje y Filtro IG',
        'RSVP Blindado + Pases QR Vivos con Número de Mesa',
        'Gestión de Mesas + Auto-Acomodo (Afinidad y Tetris)',
        'App Escáner Hostess + Finanzas, Proveedores y Checklist'
      ],
      fichaInvitacion: [
        { t: 'Hasta 3 Fotos de Portada (Transición Fade-Out)', d: 'Atenuación cinematográfica suave estilo revista editorial.' },
        { t: 'Saludo VIP Personalizado por Familia', d: 'Extrae el nombre de cada invitado desde la nube y lo recibe en portada ("Pase Especial para: Familia Montemayor").' },
        { t: 'Galería Extendida (10 Fotos: Carrusel, Masonry o Arcos)', d: 'Arquitectura fotográfica asimétrica o con marcos curvos de alta costura.' },
        { t: 'Padres, Padrinos, Hospedaje y Filtro de Instagram', d: 'Créditos completos de honor, hoteles recomendados, 3 GPS y botón para filtro social.' },
        { t: 'Carrusel de Pases QR Vivos con Número de Mesa', d: 'Al confirmar asistencia, la invitación entrega los pases descargables indicando exactamente en qué mesa se sienta cada integrante.' }
      ],
      fichaBoveda: [
        { t: 'RSVP Blindado + Solicitudes de Pases Extra', d: 'Control estricto de lugares por familia y aprobación de pases adicionales en 1 clic.', ok: true },
        { t: 'Gestión de Mesas + Motor Dual (Afinidad y Tetris)', d: 'Etiqueta invitados (#Primos, #Amigos), ponle imanes a tus mesas y deja que el algoritmo acomode todo el salón respetando a tus VIPs.', ok: true },
        { t: 'App Escáner QR para Hostess en Recepción', d: 'Tu staff escanea desde su celular validando el ingreso y viendo la mesa asignada.', ok: true },
        { t: 'Bóveda Financiera, Proveedores, Checklist y Reportes PDF/Excel', d: 'Control total de presupuesto, abonos y exportación de listas oficiales para el banquetero.', ok: true },
        { t: 'Croquis 2D Arrastrable, Social Wall y Black Label', d: 'Disponibles como Add-on o incluidos en el Plan Diamante.', ok: false }
      ]
    },
    { 
      id: 'diamante', 
      nombre: 'Diamante', 
      subtitulo: 'La Obra Maestra All-Inclusive',
      ...obtenerPrecio('diamante'), 
      desc: 'La suite definitiva Phygital: Croquis 2D, proyección en vivo y Caja VIP enviada a tu domicilio con Brazaletes Tyvek 2.5 cm y Tarjetas de Mesa.', 
      icon: <Gem size={24}/>, 
      d1: true, 
      f: [
        'Todo lo del Plan Oro + Galería y GPS Ilimitados',
        'Croquis Arquitectónico 2D Interactivo (Arrastra Mesas)',
        'Social Wall + Tarjetas Impresas para Mesas (Envío Incluido)',
        'Black Label + Brazaletes Tyvek 2.5 cm Impresos (Envío Incluido)',
        'Unboxing en Caja de Lujo Baulia directo a tu domicilio',
        'Radar de Aforo en Tiempo Real + Respaldo PDF Vectorial'
      ],
      fichaInvitacion: [
        { t: 'Todo el Poder Artístico del Plan Oro sin Límites', d: 'Hasta 3 portadas cinematográficas, monograma a medida, saludo VIP por familia y ubicaciones GPS ilimitadas.' },
        { t: 'Galería Fotográfica Ilimitada Multi-Estilo', d: 'Exhibe tu sesión completa en formato Carrusel, Masonry Editorial o Arcos.' },
        { t: 'Pases QR Ópticos Sincronizados con el Croquis 2D', d: 'Cada tarjeta VIP descargable muestra el nombre del evento, el integrante y su mesa actualizada en tiempo real.' },
        { t: 'Acceso Directo al Muro Social desde la Invitación', d: 'Tus invitados pueden subir y compartir las fotos que toman durante la fiesta sin instalar aplicaciones.' }
      ],
      fichaBoveda: [
        { t: 'Bóveda Baulia 100% Desbloqueada (Sin Candados)', d: 'Incluye RSVP Blindado, Etiquetas, Auto-Acomodo por Afinidad, Finanzas, Proveedores, Checklist y Escáner Hostess.', ok: true },
        { t: 'Croquis Arquitectónico 2D Interactivo', d: 'Diseña el plano real de tu salón moviendo mesas redondas, cuadradas, tablones, serpentinas, pista y escenario.', ok: true },
        { t: 'Social Wall + Tarjetas Físicas para Mesas (Envío Incluido)', d: 'Personaliza tus tarjetas con tu logo y nombre del evento; las imprimimos en papel de alto gramaje y te las enviamos sin costo extra.', ok: true },
        { t: 'Black Label + Brazaletes Tyvek 2.5 cm Impresos (Envío Incluido)', d: 'Elige color de pulsera, personalízalas con tu logo y recíbelas impresas con QR macro de enfoque rápido en una Caja VIP Baulia.', ok: true },
        { t: 'Monitor y Radar de Puerta en Vivo + PDF de Emergencia', d: 'Velocímetro de aforo en tiempo real en tu celular y opción de descarga PDF vectorial inmediata.', ok: true }
      ]
    }
  ];

  const pSocialWall = obtenerPrecio('social_wall');
  const pBlackLabel = obtenerPrecio('black_label');

  // 👇 DE AQUÍ PARA ABAJO, TODO SE QUEDA EXACTAMENTE IGUAL 👇
  useEffect(() => {
    setActiveDevice('iphone');
  }, [activeCategory]);

  useEffect(() => {
    setActiveDevice('iphone');
  }, [activeCategory]);

  const switchFocus = (device) => {
    setActiveDevice(device);
    const inactiveRef = device === 'mac' ? iphoneIframeRef : macIframeRef;
    if (inactiveRef.current && inactiveRef.current.contentWindow) {
      inactiveRef.current.contentWindow.postMessage('pause_baulia_audio', '*');
    }
  };

  useEffect(() => {
    const escucharDemos = (event) => {
      if (event.data === 'open_checkout') setCheckoutModal('selector');
    };
    window.addEventListener('message', escucharDemos);
    return () => window.removeEventListener('message', escucharDemos);
  }, []);

  const heroNotifications = [
    { title: 'RSVP Confirmado', desc: 'Familia Fuentes (4 Pases)', icon: <CheckCircle size={20}/>, color: 'text-emerald-500', bg: 'bg-emerald-100 dark:bg-emerald-500/20' },
    { title: 'Regalo Recibido', desc: 'Transferencia ($5,000)', icon: <Wallet size={20}/>, color: 'text-amber-500', bg: 'bg-amber-100 dark:bg-amber-500/20' },
    { title: 'Acomodo Automático', desc: 'Mesa 5 optimizada', icon: <Wand2 size={20}/>, color: 'text-indigo-500', bg: 'bg-indigo-100 dark:bg-indigo-500/20' },
    { title: 'Acceso Seguro', desc: 'Código QR Validado', icon: <Scan size={20}/>, color: 'text-rose-500', bg: 'bg-rose-100 dark:bg-rose-500/20' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setNotifIndex(prev => (prev + 1) % heroNotifications.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkDevice = () => setIsMobileDevice(window.innerWidth < 1024);
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  // 🔴 DEMOS CON ADN VISUAL Y RIQUEZA ARTÍSTICA PARA IA Y BUSCADORES
  const demos = {
    boda: { id: 'boda', label: 'Bodas de Lujo', url: '/demos/boda/index.html', desc: 'Romanticismo puro con ilustraciones florales, texturas de acuarela y mármol, caída de pétalos, monogramas caligráficos dorados y fotografía protagónica de los novios.', features: ['Arte Floral y Acuarela', 'Fotografía Romántica', 'Pases QR VIP', 'Mesa de Regalos'], blob1: 'bg-[#D4AF37]', blob2: 'bg-[#FDFBF7]' },
    xv: { id: 'xv', label: 'XV Años Glamour', url: '/demos/xv/index.html', desc: 'Magia de cuento de hadas, destellos dorados, boho chic o glamour neón con galerías interactivas y música envolvente desde el primer segundo.', features: ['Brillos y Destellos', 'Galería Editorial', 'Itinerario de Gala', 'Música Envolvente'], blob1: 'bg-fuchsia-500', blob2: 'bg-cyan-400' },
    baby_shower: { id: 'baby_shower', label: 'Baby Shower', url: '/demos/baby_shower/index.html', desc: 'Calidez maternal, ilustraciones tiernas en tonos pastel, animaciones flotantes y emoción visual para celebrar la llegada del bebé.', features: ['Ilustración Pastel', 'Galería Emotiva', 'Mesa de Regalos', 'Música Suave'], blob1: 'bg-sky-300', blob2: 'bg-pink-300' },
    cumple_formal: { id: 'cumple_formal', label: 'Cumpleaños', url: '/demos/cumple_formal/index.html', desc: 'Composiciones florales vibrantes, tipografías caligráficas finas y calidez festiva para celebrar décadas memorables rodeado de familia.', features: ['Diseño Floral Cálido', 'Lluvia de Sobres', 'Pases VIP', 'Música Automática'], blob1: 'bg-amber-600', blob2: 'bg-slate-800' },
    tematicas: { id: 'tematicas', label: 'Fiestas Temáticas', url: '/demos/infantil/index.html', desc: 'Mundos inmersivos llenos de color, texturas personalizadas, efectos de sonido y creatividad ilimitada para sorprender a chicos y grandes.', features: ['Arte 100% Temático', 'Efectos Interactivos', 'Cuenta Regresiva', 'GPS Directo'], blob1: 'bg-emerald-400', blob2: 'bg-yellow-400' }, 
    bautizo: { id: 'bautizo', label: 'Bautizos', url: '/demos/bautizo/index.html', desc: 'Acabados angelicales, nubes suaves, detalles en hoja de oro y una carta de celebración íntima y luminosa para toda la familia.', features: ['Acabados Dorados', 'Estética Angelical', 'Mesa de Regalos', 'Pases Familiares'], blob1: 'bg-blue-100', blob2: 'bg-amber-100' },
    corporativo: { id: 'corporativo', label: 'Galas y Eventos', url: '/demos/corporativo/index.html', desc: 'Arquitectura visual ejecutiva para galas, congresos y festivales con acreditaciones QR intransferibles y control de aforo en vivo.', features: ['Acreditaciones QR', 'Control de Acceso', 'Auto-Acomodo', 'Mapeo 2D'], blob1: 'bg-slate-700', blob2: 'bg-indigo-400' }
  };
  const currentDemo = demos[activeCategory];

  const handlePaymentSuccess = (datosCliente) => {
    setCheckoutModal(null);
    setCheckoutSuccess(true);
  };

  const IconFB = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.469h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.469h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>;
  const IconIG = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 1.727-6.98 6.077-.058 1.28-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 1.718 6.781 6.077 6.98 1.28.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-1.718 6.979-6.077.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-1.717-6.78-6.077-6.98-1.28-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>;
  const IconTK = () => <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93v7.2c0 1.63-.31 3.23-1.11 4.6-1.18 2.01-3.21 3.44-5.5 3.86-2.5.46-5.22-.09-7.25-1.67-1.95-1.52-3.13-3.87-3.2-6.38-.08-2.82 1.25-5.61 3.54-7.24 1.48-1.06 3.32-1.5 5.12-1.37v4.03c-1.04-.15-2.15.02-3.05.62-.92.6-1.53 1.57-1.64 2.66-.1 1.05.28 2.11 1.02 2.85.76.76 1.86 1.1 2.92 1.03 1.16-.08 2.21-.71 2.78-1.7.35-.61.54-1.32.55-2.03V.02z"/></svg>;

  const accentThemes = {
    amber: { text: 'text-amber-500', bg: 'bg-amber-500', glow: 'shadow-[0_0_40px_rgba(245,158,11,0.4)]' },
    rose: { text: 'text-rose-500', bg: 'bg-rose-500', glow: 'shadow-[0_0_40px_rgba(244,63,94,0.4)]' },
    emerald: { text: 'text-emerald-500', bg: 'bg-emerald-500', glow: 'shadow-[0_0_40px_rgba(16,185,129,0.4)]' },
    indigo: { text: 'text-indigo-500', bg: 'bg-indigo-500', glow: 'shadow-[0_0_40px_rgba(99,102,241,0.4)]' }
  };

  const currentNotif = heroNotifications[notifIndex];

  const característicasTabla = [
    // GRUPO 1: ARTE Y DISEÑO DE LA INVITACIÓN
    { n: 'Diseño Inmersivo de Alta Costura (Cero Plantillas Genéricas)', b: true, p: true, o: true, d: true, icon: <Palette size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },
    { n: 'Fotografías en Portada Principal', b: '1 (Slow Zoom)', p: '1 (Slow Zoom)', o: 'Hasta 3 (Fade-out)', d: 'Hasta 3 (Fade-out)', icon: <Camera size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },
    { n: 'Monograma con Iniciales de los Festejados', b: false, p: 'Estándar', o: 'Personalizado', d: 'Personalizado VIP', icon: <Gem size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },
    { n: 'Galería de Sesión Fotográfica', b: false, p: 'Hasta 5 (Carrusel)', o: 'Hasta 10 (Masonry/Arcos)', d: 'Ilimitadas (Multi-Estilo)', icon: <Camera size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },
    { n: 'Música de Fondo sin Bloqueo y Cuenta Regresiva', b: true, p: true, o: true, d: true, icon: <PlayCircle size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },
    { n: 'Sección de Padres y Padrinos de Honor', b: false, p: 'Padres', o: 'Padres y Padrinos', d: 'Padres y Padrinos', icon: <Users size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },
    { n: 'Saludo VIP Automático con el Nombre de cada Invitado', b: false, p: false, o: true, d: true, icon: <UserCheck size={16}/>, grupo: '1. ARTE Y DISEÑO DE LA INVITACIÓN' },

    // GRUPO 2: EXPERIENCIA Y LOGÍSTICA DEL INVITADO
    { n: 'Ubicaciones con GPS Nativo (Apple Maps / Google Maps)', b: '1 Ubicación', p: '2 Ubicaciones', o: '3 Ubicaciones', d: 'Ilimitadas', icon: <MapPin size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },
    { n: 'Lluvia de Sobres (CLABE 1-Clic) y Mesa de Regalos', b: false, p: true, o: true, d: true, icon: <Gift size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },
    { n: 'Itinerario (Minuto a Minuto) y Código de Vestimenta', b: false, p: true, o: true, d: true, icon: <CheckSquare size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },
    { n: 'Botón Agendar en Calendario (iCal / Google)', b: false, p: true, o: true, d: true, icon: <CheckCircle size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },
    { n: 'Sugerencias de Hospedaje y Filtro de Instagram', b: false, p: false, o: true, d: true, icon: <Smartphone size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },
    { n: 'Sistema de Confirmación de Asistencia (RSVP)', b: 'Directo a WhatsApp', p: 'Directo a WhatsApp', o: 'Bóveda Inteligente', d: 'Bóveda Inteligente', icon: <UserCheck size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },
    { n: 'Pases QR Descargables con Número de Mesa Asignada', b: false, p: false, o: 'Sí (Con su Mesa)', d: 'Sí (Con su Mesa)', icon: <QrCode size={16}/>, grupo: '2. EXPERIENCIA Y LOGÍSTICA DEL INVITADO' },

    // GRUPO 3: TU BÓVEDA DE CONTROL (EL PODER DEL SOFTWARE)
    { n: 'Acceso a tu Bóveda Baulia (Panel de Control)', b: 'Modo Bienvenida', p: 'Lista Envío WhatsApp', o: 'Bóveda VIP Activa', d: 'Bóveda Total 100%', icon: <LayoutDashboard size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'Gestión de Mesas + Auto-Acomodo (Afinidad y Tetris)', b: false, p: false, o: true, d: true, icon: <Wand2 size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'Banco de Etiquetas (#Primos, #Amigos) y Pases Extra', b: false, p: false, o: true, d: true, icon: <Users size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'App Escáner QR de Recepción para Hostess', b: false, p: false, o: true, d: true, icon: <Scan size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'Finanzas, Proveedores, Checklist y Reportes PDF/Excel', b: false, p: false, o: true, d: true, icon: <Wallet size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'Croquis Arquitectónico 2D Interactivo (Mover Mesas)', b: false, p: false, o: false, d: true, icon: <LayoutGrid size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'Baulia Social Wall (Proyección + Tarjetas Impresas con Envío)', b: 'Add-on Opcional', p: 'Add-on Opcional', o: 'Add-on Opcional', d: 'Incluido + Envío VIP', icon: <Camera size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' },
    { n: 'Baulia Black Label (Brazaletes Tyvek 2.5cm Impresos + Envío + Radar)', b: 'Add-on Opcional', p: 'Add-on Opcional', o: 'Add-on Opcional', d: 'Incluido + Envío VIP', icon: <Lock size={16}/>, grupo: '3. TU BÓVEDA DE CONTROL (SOFTWARE)' }
  ];

  return (
    <div className="dark baulia-gala-landing min-h-screen bg-[#1C1917] font-sans text-slate-100 selection:bg-[#D4AF37] selection:text-[#1C1917] transition-colors duration-700 overflow-clip relative">
      
      {/* INCRUSTACIÓN DE LAS REVISTAS */}
      {showAnatomy && <AnatomyOverlay onClose={() => setShowAnatomy(false)} />}
      {showPanelAnatomy && <PanelAnatomyOverlay onClose={() => setShowPanelAnatomy(false)} />}

      {/* BOTÓN FLOTANTE DE CONCIERGE EN DORADO Y NEGRO GALA */}
      {!showAnatomy && !showPanelAnatomy && (
        <a href="https://wa.me/529222107575?text=Hola,%20quiero%20reservar%20una%20Bóveda%20Baulia" target="_blank" rel="noreferrer" className="fixed bottom-6 right-6 bg-[#D4AF37] text-[#1C1917] p-4 rounded-full shadow-[0_10px_25px_rgba(212,175,55,0.4)] hover:scale-110 hover:bg-[#e3be42] border border-[#D4AF37] transition-all z-50 group flex items-center justify-center">
          <MessageCircle size={28} />
          <span className="absolute right-full mr-4 bg-[#141210] text-[#D4AF37] border border-[#D4AF37]/40 text-xs font-bold px-3.5 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-lg pointer-events-none">
            Asesoría Concierge
          </span>
        </a>
      )}

      {/* 🟢 MOTOR DE GALA PERMANENTE (#1C1917 + #D4AF37) Y ESCUDO MÓVIL */}
      <style>{`
        @media screen and (max-width: 768px) {
          input, select, textarea { font-size: 16px !important; }
        }
        .baulia-gala-landing {
          background-color: #1C1917 !important;
          color: #F5F5F4 !important;
        }
        .baulia-gala-landing .dark\\:bg-\\[\\#050505\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#07070b\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#080808\\],
        .baulia-gala-landing .dark\\:bg-slate-950\\/50 {
          background-color: #1C1917 !important;
        }
        .baulia-gala-landing .dark\\:bg-\\[\\#0a0a0a\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#0b0b0b\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#0d0d0d\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#0d0d12\\],
        .baulia-gala-landing .dark\\:bg-slate-950,
        .baulia-gala-landing .bg-slate-900 {
          background-color: #141210 !important;
        }
        .baulia-gala-landing .dark\\:bg-\\[\\#111\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#121212\\],
        .baulia-gala-landing .dark\\:bg-\\[\\#14141c\\] {
          background-color: #24201D !important;
        }
        .baulia-gala-landing .dark\\:border-white\\/10,
        .baulia-gala-landing .dark\\:border-white\\/5 {
          border-color: rgba(212, 175, 55, 0.16) !important;
        }
      `}</style>

      {/* 🔴 MODAL 1: SELECTOR DE NIVELES (100% Adaptable a Móvil y Escritorio con Scroll Fluido) */}
      {checkoutModal === 'selector' && (
        <div 
          onClick={() => setCheckoutModal(null)}
          className="fixed inset-0 z-[99999] bg-slate-900/85 dark:bg-black/90 backdrop-blur-md flex items-end sm:items-center justify-center p-0 sm:p-4 animate-in fade-in transition-colors overflow-hidden"
        >
          <div 
            onClick={(e) => e.stopPropagation()}
            className="bg-white dark:bg-[#0a0a0a] rounded-t-[2rem] sm:rounded-[2.5rem] w-full max-w-4xl shadow-2xl border border-slate-200 dark:border-white/10 animate-in zoom-in-95 flex flex-col h-[92dvh] sm:h-auto sm:max-h-[90dvh] overflow-hidden transition-all duration-300"
          >
            {/* Cabecera Fija (Siempre visible en móvil y escritorio) */}
            <div className="p-4 sm:p-7 border-b border-slate-100 dark:border-white/10 bg-white dark:bg-[#0a0a0a] shrink-0">
              <div className="flex items-start sm:items-center justify-between gap-3">
                <div className="min-w-0">
                  <h3 className="font-editorial text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white leading-tight">Selecciona tu Nivel</h3>
                  <p className="text-slate-500 dark:text-slate-400 text-[11px] sm:text-xs mt-0.5">Elige la bóveda o el servicio que necesites.</p>
                </div>
                
                <div className="flex items-center gap-2 shrink-0">
                  {/* Selector de Moneda compacto */}
                  <div className="flex items-center bg-slate-100 dark:bg-white/5 p-1 rounded-full border border-slate-200 dark:border-white/10">
                    <button type="button" onClick={() => setMoneda('MXN')} className={`px-2.5 sm:px-3.5 py-1 rounded-full text-[9px] sm:text-[10px] font-black uppercase tracking-widest transition-all ${moneda === 'MXN' ? 'bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm' : 'text-slate-500'}`}>MXN</button>
                    <button type="button" onClick={() => setMoneda('USD')} className={`px-2.5 sm:px-3.5 py-1 rounded-full text-[9px] sm:text-[10px] font-black uppercase tracking-widest transition-all ${moneda === 'USD' ? 'bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm' : 'text-slate-500'}`}>USD</button>
                  </div>

                  {/* Botón Cerrar siempre accesible */}
                  <button 
                    type="button"
                    onClick={() => setCheckoutModal(null)} 
                    className="px-3 py-2 sm:p-2 text-slate-600 dark:text-slate-300 hover:text-rose-500 bg-slate-100 dark:bg-white/10 rounded-full transition-colors flex items-center gap-1 text-[10px] font-black uppercase tracking-wider shrink-0"
                  >
                    <X size={18}/> <span className="sm:hidden">Cerrar</span>
                  </button>
                </div>
              </div>
            </div>
            
            {/* Contenedor con Scroll Independiente (Sube y baja completo sin mover el fondo) */}
            <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain p-4 sm:p-7 custom-scrollbar">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pb-6">
                
                {/* COLUMNA 1: PLANES COMPLETOS */}
                <div className="space-y-3.5">
                  <h4 className="text-[10px] font-black uppercase tracking-widest text-slate-400 border-b border-slate-100 dark:border-white/5 pb-2 mb-3">Ecosistema Completo (Invitación + Bóveda)</h4>
                  {planes.map(plan => (
                    <button 
                      key={plan.id}
                      type="button"
                      onClick={() => { setPlanSeleccionado({ plan: plan.nombre, precio: plan.raw[moneda], moneda: moneda }); setCheckoutModal('pago'); }}
                      className={`w-full text-left p-4 sm:p-5 rounded-2xl border transition-all duration-300 group relative overflow-hidden ${plan.popular ? 'border-amber-500/50 bg-amber-50 dark:bg-amber-500/5 hover:bg-amber-100 dark:hover:bg-amber-500/10' : 'border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-[#111] hover:border-indigo-300 dark:hover:border-white/30'}`}
                    >
                      {plan.popular && <div className="absolute top-0 right-0 bg-amber-500 text-slate-900 text-[8px] font-black uppercase tracking-widest px-3 py-1 rounded-bl-lg">Más Vendido</div>}
                      {plan.id === 'diamante' && <div className="absolute top-0 right-0 bg-indigo-600 text-white text-[8px] font-black uppercase tracking-widest px-3 py-1 rounded-bl-lg flex items-center"><Gem size={10} className="mr-1"/> Suite Todo Incluido</div>}

                      <div className="flex items-center gap-3.5 pt-2 sm:pt-0">
                        <div className={`w-11 h-11 sm:w-12 sm:h-12 rounded-full flex items-center justify-center shrink-0 shadow-inner ${plan.popular ? 'bg-amber-100 dark:bg-amber-500/20 text-amber-600 dark:text-amber-500' : plan.id === 'diamante' ? 'bg-indigo-100 dark:bg-indigo-500/20 text-indigo-600 dark:text-indigo-400' : 'bg-slate-200 dark:bg-white/5 text-slate-500 dark:text-slate-400'}`}>
                          {plan.icon}
                        </div>
                        <div className="flex-1 min-w-0">
                          <h4 className="font-bold text-base sm:text-lg text-slate-900 dark:text-white mb-0.5">{plan.nombre}</h4>
                          <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight line-clamp-2">{plan.desc}</p>
                        </div>
                        <div className="text-right shrink-0 pl-2">
                          {plan.preciosOriginales[moneda] !== null && <p className="text-[10px] text-rose-500 font-bold line-through mb-[-2px]">${plan.preciosOriginales[moneda]}</p>}
                          <p className="font-black text-lg sm:text-xl text-slate-900 dark:text-white">${plan.precios[moneda]}</p>
                          <p className="text-[8px] text-slate-500 font-bold uppercase tracking-widest">{moneda}</p>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>

                {/* COLUMNA 2: PRODUCTOS INDEPENDIENTES */}
                <div className="space-y-4">
                  <h4 className="text-[10px] font-black uppercase tracking-widest text-slate-400 border-b border-slate-100 dark:border-white/5 pb-2 mb-3">Experiencias y Complementos</h4>
                  
                  {/* SOCIAL WALL CARD */}
                  <button 
                    type="button"
                    onClick={() => { setPlanSeleccionado({ plan: 'social_wall', precio: pSocialWall.raw[moneda], moneda: moneda }); setCheckoutModal('pago'); }}
                    className="w-full text-left p-5 sm:p-6 rounded-3xl border-2 border-indigo-500/30 dark:border-indigo-500/50 bg-indigo-50 dark:bg-[#111] hover:border-indigo-500 transition-all duration-300 group relative overflow-hidden"
                  >
                    <div className="flex flex-col gap-3 relative z-10">
                      <div className="flex justify-between items-start">
                        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-indigo-600 text-white flex items-center justify-center shadow-lg">
                          <Camera size={26} />
                        </div>
                        <div className="text-right">
                          <span className="bg-indigo-600 text-white text-[8px] font-black uppercase tracking-widest px-3 py-1 rounded-full shadow-sm mb-1.5 inline-block">MÁS VENDIDO</span>
                          {pSocialWall.preciosOriginales[moneda] !== null && <p className="text-[11px] text-rose-500 font-bold line-through mb-[-4px]">${pSocialWall.preciosOriginales[moneda]}</p>}
                          <p className="font-black text-2xl sm:text-3xl text-slate-900 dark:text-white leading-none">${pSocialWall.precios[moneda]}</p>
                          <p className="text-[9px] text-slate-500 font-bold uppercase tracking-widest mt-0.5">{moneda} / Pago Único</p>
                        </div>
                      </div>
                      
                      <div>
                        <h4 className="font-editorial font-bold text-xl sm:text-2xl text-slate-900 dark:text-white mb-1.5">Baulia Social Wall</h4>
                        <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed mb-3">
                          Convierte las pantallas de tu salón en una <b>experiencia inmersiva en vivo</b> donde las fotos de tus invitados vuelan al proyector.
                        </p>
                        <div className="bg-white/60 dark:bg-black/30 border border-indigo-200 dark:border-indigo-500/20 p-2 rounded-lg text-[9px] font-bold text-indigo-700 dark:text-indigo-400 flex items-center">
                           <Gem size={12} className="mr-1.5 shrink-0"/> INCLUIDO SIN COSTO EN PLAN DIAMANTE
                        </div>
                      </div>
                    </div>
                  </button>

                  {/* BLACK LABEL CARD */}
                  <button 
                    type="button"
                    onClick={() => { setPlanSeleccionado({ plan: 'Black Label', precio: pBlackLabel.raw[moneda], moneda: moneda }); setCheckoutModal('pago'); }}
                    className="w-full text-left p-5 sm:p-6 rounded-3xl border-2 border-[#1a1a1a] dark:border-white/10 bg-[#050505] hover:border-amber-500/50 transition-all duration-300 group relative overflow-hidden"
                  >
                    <div className="flex flex-col gap-3 relative z-10">
                      <div className="flex justify-between items-start">
                        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-tr from-amber-600 to-yellow-400 text-slate-900 flex items-center justify-center shadow-[0_0_15px_rgba(245,158,11,0.5)]">
                          <Lock size={26} />
                        </div>
                        <div className="text-right">
                          <span className="bg-amber-500 text-slate-900 text-[8px] font-black uppercase tracking-widest px-3 py-1 rounded-full shadow-sm mb-1.5 inline-block">VIP / PARA IMPRIMIR</span>
                          {pBlackLabel.preciosOriginales[moneda] !== null && <p className="text-[11px] text-rose-500 font-bold line-through mb-[-4px]">${pBlackLabel.preciosOriginales[moneda]}</p>}
                          <p className="font-black text-2xl sm:text-3xl text-white leading-none">${pBlackLabel.precios[moneda]}</p>
                          <p className="text-[9px] text-slate-400 font-bold uppercase tracking-widest mt-0.5">{moneda} / Pago Único</p>
                        </div>
                      </div>
                      
                      <div>
                        <h4 className="font-editorial font-bold text-xl sm:text-2xl text-white mb-1.5">Baulia Black Label</h4>
                        <p className="text-xs text-slate-400 leading-relaxed mb-3">
                          Gestor de producción para brazaletes físicos VIP y <b>Monitor en Tiempo Real</b> de la puerta para el anfitrión.
                        </p>
                        <div className="bg-amber-500/10 border border-amber-500/20 p-2 rounded-lg text-[9px] font-bold text-amber-500 flex items-center">
                           <Gem size={12} className="mr-1.5 shrink-0"/> INCLUIDO SIN COSTO EN PLAN DIAMANTE
                        </div>
                      </div>
                    </div>
                  </button>

                </div>
              </div>
            </div>

            {/* Barra inferior móvil para cerrar con 1 toque */}
            <div className="sm:hidden p-3.5 border-t border-slate-200 dark:border-white/10 bg-white dark:bg-[#0a0a0a] shrink-0">
              <button
                type="button"
                onClick={() => setCheckoutModal(null)}
                className="w-full py-3 rounded-xl bg-slate-100 dark:bg-white/10 text-slate-700 dark:text-white font-black text-xs uppercase tracking-widest"
              >
                Cerrar y volver a la página
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔴 MODAL 2: PASARELA DE PAGO (Bloqueo estricto de movimiento horizontal en iPhone/Android) */}
      {checkoutModal === 'pago' && planSeleccionado && (
        <div className="fixed inset-0 z-[99999] h-[100dvh] w-screen max-w-[100vw] bg-[#FAFAFA] dark:bg-[#0a0a0a] flex flex-col overflow-x-hidden overflow-y-hidden animate-in fade-in duration-300">
          
          {/* Cabecera Fija */}
          <div className="shrink-0 w-full bg-white/95 dark:bg-[#0a0a0a]/95 backdrop-blur-md border-b border-slate-200 dark:border-white/10 shadow-sm z-20">
            <div className="max-w-4xl mx-auto px-4 py-3.5 flex items-center justify-between gap-2">
              <div className="flex items-center gap-2.5 min-w-0">
                <ShieldCheck size={22} className="text-emerald-500 shrink-0" />
                <div className="min-w-0">
                  <h2 className="font-editorial text-lg sm:text-xl font-bold text-slate-900 dark:text-white leading-none truncate">Baulia Secure Checkout</h2>
                  <p className="text-[9px] font-black uppercase tracking-widest text-slate-500 mt-1">Transacción Encriptada</p>
                </div>
              </div>

              <div className="flex items-center gap-2 shrink-0">
                <button 
                  type="button"
                  onClick={() => setCheckoutModal('selector')} 
                  className="hidden sm:flex items-center text-[11px] font-bold text-slate-500 hover:text-slate-900 dark:hover:text-white bg-slate-100 dark:bg-white/5 px-3.5 py-2 rounded-full transition-all"
                >
                  Cambiar Plan
                </button>
                <button 
                  type="button"
                  onClick={() => setCheckoutModal(null)} 
                  className="flex items-center text-xs font-black uppercase tracking-wider text-white bg-rose-500 hover:bg-rose-600 px-4 py-2 rounded-full shadow-md transition-all shrink-0"
                >
                  <X size={15} className="mr-1"/> Cerrar
                </button>
              </div>
            </div>
          </div>
          
          {/* Cuerpo con Scroll 100% Vertical (touch-pan-y y overflow-x-hidden) */}
          <div className="flex-1 min-h-0 w-full max-w-full overflow-y-auto overflow-x-hidden overscroll-contain touch-pan-y custom-scrollbar px-4 py-5 md:py-10 pb-28 box-border">
            <div className="w-full max-w-xl mx-auto overflow-x-hidden">
               <CheckoutForm 
                  planSeleccionado={planSeleccionado} 
                  onSuccess={handlePaymentSuccess} 
                  onCancel={() => setCheckoutModal(null)} 
               />
               <div className="mt-6 text-center">
                 <button 
                   type="button"
                   onClick={() => setCheckoutModal(null)}
                   className="text-xs font-bold text-slate-400 hover:text-slate-700 dark:hover:text-white uppercase tracking-widest py-2 px-4"
                 >
                   ← Volver a la página principal
                 </button>
               </div>
            </div>
          </div>
        </div>
      )}

      {/* 🔴 MODAL ÉXITO PAGO */}
      {checkoutSuccess && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#FDFBF7] dark:bg-[#0a0a0a] rounded-[2.5rem] w-full max-w-md overflow-hidden shadow-2xl p-10 text-center border border-[#D4AF37]/30 dark:border-white/10 animate-in zoom-in-95 relative">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600"></div>
            
            <div className="mx-auto mb-6 relative w-24 h-24 flex items-center justify-center">
               <div className="absolute inset-0 border border-amber-300 dark:border-amber-500/30 rounded-full animate-ping opacity-50"></div>
               <div className="absolute inset-3 border border-amber-400 dark:border-amber-500/50 rounded-full"></div>
               <CheckCircle size={40} className="text-amber-500 dark:text-amber-400 relative z-10"/>
            </div>
            
            <p className="text-[10px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-500 mb-2">Transacción Exitosa</p>
            <h3 className="font-editorial font-bold text-4xl text-slate-900 dark:text-white mb-4 leading-tight">
              Bienvenido <br/>
              <span className="italic font-light text-slate-600 dark:text-slate-400">a Baulia.</span>
            </h3>
            
            <p className="text-slate-600 dark:text-slate-400 text-sm mb-10 font-light leading-relaxed">
              Tu servicio ha sido creado con éxito. Hemos enviado las credenciales de acceso a tu correo electrónico para que comiences a disfrutar de la plataforma.
            </p>
            
            <button onClick={() => {setCheckoutSuccess(false); window.location.href = 'https://panel.baulia.com';}} className="w-full py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-bold rounded-full shadow-xl hover:bg-slate-800 dark:hover:bg-slate-200 hover:scale-[1.02] transition-all uppercase tracking-widest text-[10px]">
              Entrar a mi Panel de Control
            </button>
          </div>
        </div>
      )}

      <div className={`${showAnatomy ? 'hidden' : 'block'}`}>
        
        {/* LUCES DE AMBIENTE SUTILES */}
        <div className="absolute top-[-20%] left-[-10%] w-[50vw] h-[50vw] bg-amber-500/5 dark:bg-amber-600/10  hidden md:block  hidden md:block  hidden md:block blur-[150px] rounded-full pointer-events-none z-0 transition-colors duration-700"></div>
        <div className="absolute top-[20%] right-[-10%] w-[40vw] h-[40vw] bg-indigo-500/5 dark:bg-indigo-600/10  hidden md:block  hidden md:block blur-[150px] rounded-full pointer-events-none z-0 transition-colors duration-700"></div>

      {/* NAVEGACIÓN FLOTANTE DE GALA (#1C1917 + #D4AF37) */}
      <nav className="fixed w-full z-50 top-0 pt-4 md:pt-6 px-4 md:px-8 pointer-events-none">
        
        {/* BARRA PRINCIPAL */}
        <div className="max-w-[1400px] mx-auto bg-[#1C1917]/85 backdrop-blur-2xl border border-[#D4AF37]/30 h-14 sm:h-16 md:h-20 rounded-full flex items-center justify-between px-3 sm:px-5 md:px-6 gap-2 shadow-[0_12px_40px_rgba(0,0,0,0.65)] pointer-events-auto transition-colors duration-700 relative z-50 overflow-hidden">
            
            {/* LOGO SIEMPRE EN BLANCO Y DORADO */}
            <a href="/" className="flex items-center group shrink-0 pr-1">
               <BauliaLogo className="h-5 sm:h-7 md:h-10 w-auto" forceWhite={true} />
            </a>

            {/* MENÚ DE ESCRITORIO */}
            <div className="hidden lg:flex gap-8 text-[11px] font-bold uppercase tracking-widest text-slate-300 items-center">
              <a href="#showroom" className="hover:text-[#D4AF37] transition-colors">La Colección</a>
              <a href="#experiencia" className="hover:text-[#D4AF37] transition-colors">Características</a>
              <a href="#boveda" className="hover:text-[#D4AF37] transition-colors">El Software</a>
              
              <button 
                onClick={() => setShowAnatomy(true)} 
                className="bg-[#141210] border border-[#D4AF37]/50 px-5 py-2 rounded-full shadow-[0_4px_20px_rgba(212,175,55,0.15)] hover:shadow-[0_6px_25px_rgba(212,175,55,0.3)] hover:scale-105 transition-all flex items-center group ml-2"
              >
                <BookOpenText size={16} className="text-[#D4AF37] mr-2.5 group-hover:-rotate-12 transition-transform duration-300"/>
                <span style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 600 }} className="text-white text-[13px] tracking-[0.2em] uppercase mr-2">
                  Baulia
                </span>
                <span style={{ fontFamily: '"Pinyon Script", cursive' }} className="text-[#D4AF37] text-[24px] lowercase tracking-normal leading-none mt-1">
                  Magazine
                </span>
              </button>
            </div>

            {/* CONTROLES DERECHOS (SIN BOTÓN DÍA/NOCHE) */}
            <div className="flex items-center gap-1.5 sm:gap-2.5 md:gap-3.5 shrink-0">
              
              {/* SELECTOR GLOBAL DE MONEDA */}
              <div className="flex items-center bg-[#141210] p-0.5 sm:p-1 rounded-full shadow-inner border border-[#D4AF37]/25 shrink-0">
                 <button type="button" onClick={() => setMoneda('MXN')} className={`px-2 sm:px-2.5 md:px-3 py-1 rounded-full text-[7.5px] sm:text-[8.5px] md:text-[9px] font-black uppercase tracking-wider transition-all ${moneda === 'MXN' ? 'bg-[#D4AF37] text-[#1C1917] shadow-sm' : 'text-slate-400 hover:text-white'}`}>MXN</button>
                 <button type="button" onClick={() => setMoneda('USD')} className={`px-2 sm:px-2.5 md:px-3 py-1 rounded-full text-[7.5px] sm:text-[8.5px] md:text-[9px] font-black uppercase tracking-wider transition-all ${moneda === 'USD' ? 'bg-[#D4AF37] text-[#1C1917] shadow-sm' : 'text-slate-400 hover:text-white'}`}>USD</button>
              </div>

              {/* BOTÓN ENTRAR EN DORADO IMPERIAL */}
              <button type="button" onClick={() => window.location.href = 'https://panel.baulia.com'} className="text-[8.5px] sm:text-[10px] md:text-xs font-black uppercase tracking-widest text-[#1C1917] bg-[#D4AF37] hover:bg-[#e3be42] px-3.5 sm:px-4 md:px-5 py-1.5 sm:py-2 md:py-2.5 rounded-full hover:scale-105 transition-all shadow-[0_0_20px_rgba(212,175,55,0.3)] whitespace-nowrap shrink-0">
                Entrar
              </button>

              {/* BOTÓN MENÚ MÓVIL */}
              <button 
                type="button"
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
                className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center lg:hidden text-[#D4AF37] rounded-full hover:bg-[#D4AF37]/10 shrink-0"
              >
                {isMobileMenuOpen ? <X size={18} /> : <Menu size={18} />}
              </button>
            </div>
        </div>

        {/* PANEL DESPLEGABLE MÓVIL */}
        {isMobileMenuOpen && (
          <div className="absolute top-20 md:top-24 left-4 right-4 md:left-8 md:right-8 bg-white/95 dark:bg-[#0a0a0a]/95 backdrop-blur-3xl border border-slate-200/50 dark:border-white/10 rounded-[2rem] shadow-2xl p-6 flex flex-col gap-6 lg:hidden pointer-events-auto animate-in slide-in-from-top-4 duration-300">
            <a href="#showroom" onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-bold uppercase tracking-widest text-slate-800 dark:text-slate-200 hover:text-amber-500 transition-colors border-b border-slate-100 dark:border-white/5 pb-4">
              La Colección
            </a>
            <a href="#experiencia" onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-bold uppercase tracking-widest text-slate-800 dark:text-slate-200 hover:text-amber-500 transition-colors border-b border-slate-100 dark:border-white/5 pb-4">
              Características
            </a>
            <a href="#boveda" onClick={() => setIsMobileMenuOpen(false)} className="text-sm font-bold uppercase tracking-widest text-slate-800 dark:text-slate-200 hover:text-amber-500 transition-colors border-b border-slate-100 dark:border-white/5 pb-4">
              El Software
            </a>
            <button 
              onClick={() => { setShowAnatomy(true); setIsMobileMenuOpen(false); }} 
              className="w-full bg-[#FDFBF7] dark:bg-white/5 border border-[#D4AF37]/50 px-5 py-4 rounded-xl shadow-sm flex items-center justify-center group"
            >
              <BookOpenText size={18} className="text-[#8DB580] mr-3"/>
              <span style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 600 }} className="text-slate-900 dark:text-white text-sm tracking-[0.2em] uppercase mr-2">
                Baulia
              </span>
              <span style={{ fontFamily: '"Pinyon Script", cursive' }} className="text-[#F76C82] text-2xl lowercase tracking-normal leading-none mt-1">
                Magazine
              </span>
            </button>
          </div>
        )}
      </nav>

      {/* 🟢 CAPA SEMÁNTICA DINÁMICA (Lee en tiempo real los precios y descuentos de Firebase) */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "DesignAgency",
        "name": "Baulia - Atelier de Invitaciones Digitales de Alta Costura y Gestión de Eventos",
        "url": "https://baulia.com",
        "description": "Estudio líder en invitaciones digitales artísticas, cálidas y personalizadas para Bodas, XV Años, Bautizos y Eventos VIP, con tecnología de Pases QR y Auto-Acomodo de Mesas por Afinidad.",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Colección de Invitaciones Digitales y Bóvedas Baulia",
          "itemListElement": planes.map(p => ({
            "@type": "Offer",
            "itemOffered": { "@type": "Service", "name": `Plan ${p.nombre} Baulia`, "description": p.desc },
            "price": p.raw[moneda],
            "priceCurrency": moneda
          }))
        }
      })}} />
      <article className="sr-only" aria-label="Catálogo Artístico y Precios Oficiales de Baulia">
        <h2>Diseños de Invitaciones Digitales de Lujo y Precios Oficiales en Baulia</h2>
        <p>Baulia combina la calidez de un estudio de arte nupcial (acuarelas, ilustraciones florales, brillos dorados, texturas de mármol, música envolvente y fotografías románticas) con ingeniería de eventos (Pases QR dinámicos, Croquis 2D y Auto-Acomodo de mesas por etiquetas de afinidad).</p>
        <ul>
          {planes.map(p => (
            <li key={p.id}>
              Plan {p.nombre}: ${p.precios.MXN} MXN (${p.precios.USD} USD){p.preciosOriginales.MXN ? ` (Precio regular $${p.preciosOriginales.MXN} MXN, promoción activa)` : ''}. {p.desc} Incluye: {p.f.join(', ')}.
            </li>
          ))}
          <li>Baulia Social Wall (Muro Social en Vivo): ${pSocialWall.precios.MXN} MXN (${pSocialWall.precios.USD} USD).</li>
          <li>Baulia Black Label (Generador de Pases y Brazaletes VIP + Radar de Puerta): ${pBlackLabel.precios.MXN} MXN (${pBlackLabel.precios.USD} USD).</li>
        </ul>
      </article>

      {/* HERO SECTION CON VENTANA CENTRAL LIBRE PARA EL ROSTRO DE LOS NOVIOS */}
      <section className="relative min-h-[100dvh] md:min-h-[94vh] pt-24 sm:pt-28 md:pt-28 pb-24 sm:pb-14 md:pb-12 px-4 md:px-8 w-full z-10 flex flex-col justify-between items-center text-center overflow-hidden">
        <style>{`
          @keyframes heroSlowBreathe {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}</style>

        {/* 🟢 LIENZO GALA NOCTURNA PERMANENTE (#1C1917 + #D4AF37) */}
        <div className="absolute inset-0 w-full h-full z-0 pointer-events-none overflow-hidden">
          <img 
            src="/modonoche.jpg" 
            alt="Invitaciones Digitales de Lujo Baulia Gala" 
            style={{ animation: 'heroSlowBreathe 24s ease-in-out infinite' }}
            className="absolute inset-0 w-full h-full object-cover object-[center_48%] md:object-[center_38%] opacity-100"
            onError={(e) => { e.target.style.opacity = '0'; }}
          />

          {/* Velo calibrado en Negro Cálido #1C1917 (rgb 28,25,23) */}
          <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(28,25,23,0.76)_0%,rgba(28,25,23,0.42)_34%,rgba(28,25,23,0.04)_44%,rgba(28,25,23,0.08)_54%,rgba(28,25,23,0.78)_68%,rgba(28,25,23,0.98)_100%)] md:bg-[linear-gradient(to_bottom,rgba(28,25,23,0.74)_0%,rgba(28,25,23,0.40)_34%,rgba(28,25,23,0.04)_46%,rgba(28,25,23,0.04)_62%,rgba(28,25,23,0.76)_78%,rgba(28,25,23,0.98)_100%)]"></div>
        </div>

        {/* 🟢 ZONA SUPERIOR: ETIQUETA FINA + TÍTULO */}
        <RevealSection className="relative z-10 max-w-[1200px] mx-auto flex flex-col items-center mt-0 md:mt-2">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3.5 sm:px-4 py-1 sm:py-1.5 rounded-full bg-[#1C1917]/80 backdrop-blur-md border border-[#D4AF37]/40 shadow-[0_0_20px_rgba(212,175,55,0.15)] mb-2.5 sm:mb-4">
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] animate-pulse shrink-0"></span>
            <span className="text-[7.5px] sm:text-[9px] md:text-[10px] font-black uppercase tracking-[0.16em] sm:tracking-[0.24em] text-[#D4AF37] whitespace-nowrap">
              Atelier de Alta Costura Digital
            </span>
          </div>

          <h1 className="text-[2.5rem] sm:text-6xl md:text-6xl lg:text-[5.6rem] font-medium text-white tracking-tighter leading-[0.92] font-editorial drop-shadow-[0_4px_20px_rgba(0,0,0,0.9)]">
            El arte de celebrar <br/>
            <span className="italic text-transparent bg-clip-text bg-gradient-to-r from-[#FDF1A9] via-[#D4AF37] to-[#AA8529] pr-1">sin estrés.</span>
          </h1>
        </RevealSection>

        {/* 🟢 VENTANA CENTRAL DESPEJADA */}
        <div className="flex-1 min-h-[210px] sm:min-h-[220px] md:min-h-[190px] lg:min-h-[210px] pointer-events-none"></div>

        {/* 🟢 ZONA INFERIOR: DESCRIPCIÓN + BOTONES EN DORADO Y NEGRO */}
        <RevealSection className="relative z-10 max-w-[1000px] mx-auto flex flex-col items-center w-full">
          <p className="text-xs sm:text-base md:text-xl text-slate-100 mb-4 sm:mb-7 max-w-2xl mx-auto font-medium md:font-normal leading-relaxed drop-shadow-[0_2px_12px_rgba(0,0,0,0.95)] px-2">
            Diseñamos invitaciones que <b>emocionan desde el primer segundo</b> —con acuarelas, arte floral, caligrafía dorada y música envolvente— conectadas al único sistema con <b>Pases QR vivos y Auto-Acomodo de Mesas por Afinidad</b>.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto justify-center relative px-2 sm:px-0">
            <button onClick={() => setCheckoutModal('selector')} className="w-full sm:w-auto px-7 sm:px-8 py-3.5 sm:py-4 bg-[#D4AF37] hover:bg-[#e3be42] text-[#1C1917] rounded-full font-black text-xs sm:text-sm uppercase tracking-widest hover:scale-105 transition-all flex items-center justify-center shadow-[0_10px_35px_rgba(212,175,55,0.4)] border border-[#D4AF37]">
              Reservar mi Bóveda <ArrowRight size={16} className="ml-2.5"/>
            </button>
            <a href="#showroom" className="w-full sm:w-auto px-7 sm:px-8 py-3.5 sm:py-4 bg-[#1C1917]/90 hover:bg-[#D4AF37]/15 backdrop-blur-md text-[#D4AF37] border border-[#D4AF37]/50 rounded-full font-bold text-xs sm:text-sm uppercase tracking-widest hover:scale-105 transition-all flex items-center justify-center shadow-xl">
              Ver Colección Privada
            </a>
          </div>
        </RevealSection>
      </section>

      {/* AUTHORITY BANNER */}
      <section className="w-full border-y border-slate-200 dark:border-white/5 bg-slate-50 dark:bg-[#080808] py-10 overflow-hidden relative z-10 transition-colors">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-8 opacity-60 dark:opacity-40 grayscale hover:grayscale-0 transition-all duration-500">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500 shrink-0">Tecnología de élite confiada por:</p>
            <div className="flex items-center gap-8 md:gap-16 font-editorial font-black text-2xl text-slate-800 dark:text-white flex-wrap justify-center">
                <span>Hacienda San Gabriel</span>
                <span>Elite Planners</span>
                <span className="font-sans font-bold">Bodas.com.mx</span>
                <span className="italic">Zankyou</span>
            </div>
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section className="py-24 px-4 md:px-8 max-w-7xl mx-auto relative z-10">
        <RevealSection className="text-center mb-16">
          <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-xs mb-4 block">El Servicio Concierge</span>
          <h2 className="text-4xl md:text-5xl font-editorial font-medium text-slate-900 dark:text-white tracking-tight transition-colors duration-700">Diseñado para tu paz mental.</h2>
        </RevealSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <RevealSection delay={100} className="bg-white dark:bg-[#0a0a0a] rounded-[2rem] p-8 border border-slate-200 dark:border-white/10 shadow-sm hover:shadow-xl transition-all flex flex-col items-center text-center group">
                <div className="w-16 h-16 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center text-xl font-black text-slate-900 dark:text-white mb-6 border border-slate-200 dark:border-white/10 group-hover:bg-amber-500 group-hover:text-slate-900 group-hover:border-amber-400 transition-colors">1</div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">Reserva tu Espacio</h3>
                <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">Selecciona el nivel de tecnología que deseas para tu evento. Un solo pago, sin suscripciones ocultas ni letras pequeñas.</p>
            </RevealSection>
            <RevealSection delay={200} className="bg-white dark:bg-[#0a0a0a] rounded-[2rem] p-8 border border-slate-200 dark:border-white/10 shadow-sm hover:shadow-xl transition-all flex flex-col items-center text-center group">
                <div className="w-16 h-16 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center text-xl font-black text-slate-900 dark:text-white mb-6 border border-slate-200 dark:border-white/10 group-hover:bg-amber-500 group-hover:text-slate-900 group-hover:border-amber-400 transition-colors">2</div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">Recibe tu Bóveda</h3>
                <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">Te entregamos las llaves de tu Panel de Control Privado. Tu invitación estará lista para ser enviada por WhatsApp al instante.</p>
            </RevealSection>
            <RevealSection delay={300} className="bg-white dark:bg-[#0a0a0a] rounded-[2rem] p-8 border border-slate-200 dark:border-white/10 shadow-sm hover:shadow-xl transition-all flex flex-col items-center text-center group">
                <div className="w-16 h-16 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center text-xl font-black text-slate-900 dark:text-white mb-6 border border-slate-200 dark:border-white/10 group-hover:bg-amber-500 group-hover:text-slate-900 group-hover:border-amber-400 transition-colors">3</div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">Delega el Control</h3>
                <p className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed">Relájate. El sistema recopilará las confirmaciones, asignará los códigos de acceso y acomodará tus mesas de forma automática.</p>
            </RevealSection>
        </div>
      </section>

      {/* SHOWROOM INTERACTIVO */}
      <section id="showroom" className="py-24 bg-slate-50 dark:bg-[#050505] relative z-10 border-y border-slate-200 dark:border-white/5 transition-colors duration-700 overflow-hidden flex items-center">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 dark:bg-amber-600/10  hidden md:block  hidden md:block blur-[150px] rounded-full pointer-events-none"></div>

        <div className="max-w-[1400px] mx-auto px-4 md:px-8 relative z-10 w-full flex flex-col items-center">

            {!isMobileDevice ? (
                // ==========================================
                // --- VERSIÓN ESCRITORIO (INTACTA) ---
                // ==========================================
                <RevealSection delay={200} className="w-full relative bg-slate-100 dark:bg-[#0a0a0a] border border-slate-200 dark:border-white/5 rounded-[3rem] overflow-hidden shadow-inner transition-colors duration-700 items-stretch flex group p-12 min-h-[680px]">
                    
                    <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-white dark:from-[#080808] to-transparent opacity-40 z-0 transition-colors pointer-events-none"></div>

                    <div className="w-5/12 xl:w-1/3 relative z-30 flex flex-col justify-center h-full gap-10 py-6">
                        
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-col gap-3">
                                <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-xs block transition-colors">La Colección Privada</span>
                                <h2 className="text-4xl md:text-5xl lg:text-6xl font-editorial font-medium text-slate-900 dark:text-white tracking-tight transition-colors duration-700 leading-tight">
                                    Tu evento es único. <br className="hidden md:block"/> tu diseño también.
                                </h2>
                            </div>
                            
                            <p className="text-base lg:text-lg text-slate-600 dark:text-slate-400 font-light leading-relaxed transition-colors duration-700 max-w-md">
                                Explora nuestras galerías interactivas. En Baulia no usamos plantillas genéricas; operamos como un estudio de diseño de élite. Adaptamos la estética al nivel y la sofisticación de tu evento.
                            </p>
                        </div>

                        <div className="flex flex-col gap-5">
                            <div className="relative w-full max-w-[280px] z-10">
                                <select
                                    value={activeCategory}
                                    onChange={(e) => setActiveCategory(e.target.value)}
                                    className="w-full appearance-none bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10 text-slate-800 dark:text-white py-3.5 px-6 rounded-2xl font-bold text-xs uppercase tracking-widest shadow-sm focus:outline-none focus:border-amber-500 cursor-pointer transition-colors"
                                >
                                    {Object.values(demos).map(demo => (
                                        <option key={demo.id} value={demo.id}>{demo.label}</option>
                                    ))}
                                </select>
                                <div className="absolute inset-y-0 right-0 flex items-center px-5 pointer-events-none text-amber-500">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                                </div>
                            </div>

                            {/* Reseña artística visible para clientes y buscadores */}
                            <div className="max-w-sm space-y-2.5">
                                <p className="text-xs text-slate-600 dark:text-slate-400 italic leading-relaxed">
                                    "{currentDemo.desc}"
                                </p>
                                <div className="flex flex-wrap gap-1.5">
                                    {currentDemo.features.map((feat, i) => (
                                        <span key={i} className="text-[9px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full bg-white/80 dark:bg-white/5 border border-slate-200 dark:border-white/10 text-slate-600 dark:text-slate-300">
                                            {feat}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            <button onClick={() => setShowAnatomy(true)} className="relative overflow-hidden w-full sm:w-max px-6 py-3.5 bg-[#FDFBF7] border border-[#D4AF37]/50 rounded-2xl shadow-[0_10px_30px_rgba(212,175,55,0.2)] hover:shadow-[0_10px_40px_rgba(212,175,55,0.4)] transition-all group flex items-center justify-start text-left mt-1">
                             <svg viewBox="0 0 200 200" className="absolute -top-4 -right-4 w-20 h-20 opacity-30 group-hover:scale-110 group-hover:opacity-50 transition-all duration-500" xmlns="http://www.w3.org/2000/svg">
                                <g transform="scale(0.8) translate(20, 20)">
                                   <path d="M 40 100 C 10 70, 20 20, 80 10 C 80 60, 60 90, 40 100 Z" fill="#8DB580"/>
                                   <path d="M 100 40 C 70 10, 20 20, 10 80 C 60 80, 90 60, 100 40 Z" fill="#A3C697"/>
                                   <circle cx="120" cy="70" r="30" fill="#FFD166" />
                                   <circle cx="70" cy="120" r="35" fill="#F76C82" />
                                   <path d="M 90 90 Q 100 100, 110 90" stroke="#D4AF37" strokeWidth="2" fill="none"/>
                                </g>
                             </svg>
                             <div className="relative z-10 flex items-center">
                                <BookOpenText size={26} className="text-[#F76C82] mr-3.5 shrink-0" strokeWidth={1.5} />
                                <div>
                                   <span className="block font-sans text-[9px] tracking-[0.3em] uppercase text-[#8DB580] font-bold mb-0.5">Baulia Magazine</span>
                                   <span className="block font-editorial text-lg sm:text-xl font-bold text-[#2A2A2A] leading-none">Explorar Anatomía</span>
                                </div>
                             </div>
                            </button>
                        </div>
                    </div>

                    <div className="w-7/12 xl:w-2/3 relative flex items-center justify-end z-20">
                        <div className="relative w-full max-w-[850px] aspect-[16/10] translate-x-[15%]">
                            
                            <div className={`absolute top-0 right-0 w-[90%] h-full bg-black rounded-t-3xl border-[8px] border-slate-800 shadow-[0_30px_60px_rgba(0,0,0,0.5)] flex flex-col transition-all duration-700 ${activeDevice === 'mac' ? 'scale-[1.02] z-30' : 'scale-100 z-10 opacity-70  hidden md:block  hidden md:block blur-[1px]'}`}>
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-6 bg-black rounded-b-2xl z-30"></div>
                                <div className="w-full h-full bg-[#111] relative overflow-hidden rounded-t-xl border border-white/5 transition-colors">
                                    <iframe 
                                      ref={macIframeRef}
                                      src={currentDemo.url} 
                                      className="absolute top-0 left-0 border-0 origin-top-left" 
                                      style={{ width: '250%', height: '250%', transform: 'scale(0.4)' }} 
                                      title={`Mac Demo ${currentDemo.label}`}
                                    ></iframe>
                                    
                                    {activeDevice !== 'mac' && (
                                      <div onClick={() => switchFocus('mac')} className="absolute inset-0 z-20 bg-black/10 backdrop- hidden md:block  hidden md:block blur-[2px] cursor-pointer flex items-center justify-center group transition-all duration-500">
                                         <div className="bg-slate-900/90 text-white text-xs font-bold px-6 py-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity border border-white/20 shadow-2xl flex items-center transform scale-95 group-hover:scale-100">
                                            <PlayCircle size={18} className="mr-2 text-amber-500"/> Haz clic para explorar en Mac
                                         </div>
                                      </div>
                                    )}
                                </div>
                                <div className="absolute -bottom-4 left-[-2.5%] w-[105%] h-4 bg-slate-400 dark:bg-slate-700 rounded-b-3xl shadow-xl z-30 transition-colors">
                                   <div className="w-40 h-1.5 bg-slate-300 dark:bg-slate-600 mx-auto rounded-b-md"></div>
                                </div>
                            </div>

                            <div className={`absolute bottom-[0%] left-[0%] transition-all duration-700 ease-out origin-bottom ${activeDevice === 'iphone' ? 'z-40 scale-[1.05]' : 'z-20 scale-95 opacity-80  hidden md:block  hidden md:block blur-[1px]'}`}>
                                <div style={{ width: '220px', height: '458px' }} className="relative bg-black rounded-[2.5rem] border-[8px] border-slate-800 shadow-[0_30px_80px_rgba(0,0,0,0.8)] overflow-hidden flex-shrink-0">
                                    <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-[30%] h-[16px] bg-black rounded-full z-30 flex justify-end items-center pr-1.5">
                                      <div className="w-1.5 h-1.5 rounded-full bg-slate-800/80 mr-1"></div>
                                      <div className="w-1.5 h-1.5 rounded-full bg-indigo-900/50"></div>
                                    </div>
                                    
                                    <div className="absolute inset-0 overflow-hidden rounded-[1.8rem] z-10 bg-[#111]">
                                      <iframe 
                                        ref={iphoneIframeRef}
                                        src={currentDemo.url} 
                                        className="border-0 absolute top-0 left-0" 
                                        title={`iPhone Demo ${currentDemo.label}`}
                                        style={{ 
                                            width: '390px', 
                                            height: '844px', 
                                            transform: 'scale(0.523)', 
                                            transformOrigin: 'top left' 
                                        }}
                                      ></iframe>

                                      {activeDevice !== 'iphone' && (
                                        <div onClick={() => switchFocus('iphone')} className="absolute inset-0 z-20 bg-black/10 backdrop- hidden md:block  hidden md:block blur-[2px] cursor-pointer flex items-center justify-center group transition-all duration-500">
                                           <div className="bg-slate-900/90 text-white text-[10px] font-bold px-4 py-3 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity border border-white/20 shadow-2xl text-center flex flex-col items-center transform scale-95 group-hover:scale-100">
                                              <Smartphone size={24} className="mb-1 text-amber-500"/>
                                              Tocar para usar<br/>en Móvil
                                           </div>
                                        </div>
                                      )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </RevealSection>
            ) : (
                // ==========================================
                // --- VERSIÓN MÓVIL (LISTA DE DEMOS CON ADN VISUAL) ---
                // ==========================================
                <RevealSection delay={200} className="w-full flex flex-col gap-6 px-2 max-w-md mx-auto">
                    
                    <div className="text-center mb-2">
                        <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-[10px] block mb-3 transition-colors">La Colección Privada</span>
                        <h2 className="text-4xl font-editorial font-medium text-slate-900 dark:text-white tracking-tight leading-tight mb-4">
                            Tu evento es único.<br/>Tu diseño también.
                        </h2>
                        <p className="text-slate-500 dark:text-slate-400 text-sm font-light">Toca cualquier diseño para vivir la experiencia interactiva a pantalla completa.</p>
                    </div>
                    
                    {/* 🔴 LISTA DE BOTONES CON ADN VISUAL (OPTIMIZADA Y ESBELTA) */}
                    <div className="flex flex-col gap-3 relative z-50">
                        
                        {/* INYECTAMOS LAS ANIMACIONES */}
                        <style>{`
                            @keyframes petalFallMini {
                                0% { transform: translateY(-10px) rotate(0deg) scale(0.8); opacity: 0; }
                                20% { opacity: 0.6; }
                                80% { opacity: 0.6; }
                                100% { transform: translateY(80px) rotate(360deg) scale(1); opacity: 0; }
                            }
                            @keyframes floatMini {
                                0%, 100% { transform: translateY(0px); }
                                50% { transform: translateY(-6px); }
                            }
                            @keyframes floatCloudMini {
                                0% { transform: translate(-60px, var(--y-offset)) scale(var(--scale)) rotate(var(--rot)); }
                                100% { transform: translate(350px, var(--y-offset)) scale(var(--scale)) rotate(var(--rot)); }
                            }
                            @keyframes floatItemMini {
                                0% { transform: translateY(10px) translateX(0px) rotate(0deg) scale(0.8); opacity: 0; }
                                20% { opacity: 1; }
                                50% { transform: translateY(-20px) translateX(10px) rotate(10deg) scale(1); }
                                80% { opacity: 1; }
                                100% { transform: translateY(-50px) translateX(-10px) rotate(-10deg) scale(1.1); opacity: 0; }
                            }
                            @keyframes radarPulse {
                                0% { transform: scale(0.5); opacity: 1; border-width: 2px; }
                                100% { transform: scale(2.5); opacity: 0; border-width: 0px; }
                            }
                        `}</style>

                        {Object.values(demos).map(demo => {
                            
                            // 💎 1. ESTILOS: INVITACIÓN DE BODA
                            if (demo.id === 'boda') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-[#FDFBF7] border border-[#D4AF37]/30 py-2.5 px-5 rounded-[1.5rem] shadow-[0_8px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_25px_rgba(212,175,55,0.15)] hover:-translate-y-0.5 transition-all duration-500 relative overflow-hidden group flex items-center justify-between text-left"
                                    >
                                        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-[0.03]"></div>
                                        <div className="absolute top-0 left-[20%] w-1.5 h-2.5 bg-[#F4AAB9] opacity-0 pointer-events-none" style={{ animation: 'petalFallMini 4s linear infinite', borderRadius: '50% 0 50% 50%' }}></div>
                                        <div className="absolute top-0 left-[50%] w-2 h-3 bg-[#D4AF37] opacity-0 pointer-events-none" style={{ animation: 'petalFallMini 5s linear infinite 1.5s', borderRadius: '50% 0 50% 50%' }}></div>
                                        <div className="absolute top-0 left-[80%] w-1.5 h-2.5 bg-[#F4AAB9] opacity-0 pointer-events-none" style={{ animation: 'petalFallMini 4.5s linear infinite 2.5s', borderRadius: '50% 0 50% 50%' }}></div>

                                        <div className="flex flex-col items-start relative z-10">
                                            <div className="absolute -left-2 -top-2 opacity-5 pointer-events-none" style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '2.5rem', lineHeight: '1' }}>
                                                I<span style={{ fontFamily: '"Pinyon Script", cursive' }}>&</span>A
                                            </div>
                                            <span className="text-[7px] tracking-[0.35em] text-[#8DB580] uppercase font-bold" style={{ fontFamily: '"Montserrat", sans-serif' }}>Alta Costura</span>
                                            <span className="text-xl text-[#2C3531] font-light tracking-wide group-hover:text-[#D4AF37] transition-colors duration-300 leading-tight" style={{ fontFamily: '"Cormorant Garamond", serif' }}>{demo.label}</span>
                                            <span className="text-[7px] uppercase tracking-widest text-[#2C3531]/50 font-bold flex items-center mt-0.5" style={{ fontFamily: '"Montserrat", sans-serif' }}><PlayCircle size={9} className="mr-1 text-[#D4AF37]" /> Toca para abrir</span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 rounded-full bg-white flex items-center justify-center border border-[#D4AF37]/30 shadow-sm text-[#2C3531] group-hover:bg-[#F4AAB9]/10 group-hover:border-[#F4AAB9] transition-colors duration-500 shrink-0">
                                            <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300 text-[#D4AF37] group-hover:text-[#D88A9B]" />
                                        </div>
                                    </button>
                                );
                            }

                            // 👑 2. ESTILOS: INVITACIÓN XV AÑOS
                            if (demo.id === 'xv') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-[#12080a] border border-[#e8a598]/30 py-2.5 px-5 rounded-[1.5rem] shadow-[0_8px_20px_rgba(0,0,0,0.4)] hover:shadow-[0_12px_25px_rgba(232,165,152,0.15)] hover:-translate-y-0.5 transition-all duration-500 relative overflow-hidden group flex items-center justify-between text-left"
                                    >
                                        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40 group-hover:opacity-80 transition-opacity duration-700">
                                            <div className="absolute left-[20%]" style={{ animation: 'floatItemMini 10s linear infinite', animationDelay: '0s' }}><svg viewBox="0 0 24 24" fill="none" stroke="#e8a598" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><path d="M12 3L14.5 9.5L21 12L14.5 14.5L12 21L9.5 14.5L3 12L9.5 9.5L12 3Z" /></svg></div>
                                            <div className="absolute left-[60%]" style={{ animation: 'floatItemMini 14s linear infinite', animationDelay: '2s' }}><svg viewBox="0 0 24 24" fill="none" stroke="#e8a598" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5"><path d="M12 3L14.5 9.5L21 12L14.5 14.5L12 21L9.5 14.5L3 12L9.5 9.5L12 3Z" /></svg></div>
                                            <div className="absolute left-[80%]" style={{ animation: 'floatItemMini 12s linear infinite', animationDelay: '5s' }}><svg viewBox="0 0 24 24" fill="none" stroke="#e8a598" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3"><path d="M12 3L14.5 9.5L21 12L14.5 14.5L12 21L9.5 14.5L3 12L9.5 9.5L12 3Z" /></svg></div>
                                        </div>

                                        <div className="flex flex-col items-start relative z-10">
                                            <div className="absolute -left-2 -top-4 opacity-[0.05] pointer-events-none text-[#e8a598]" style={{ fontFamily: '"Great Vibes", cursive', fontSize: '3.2rem', lineHeight: '1' }}>V</div>
                                            <span className="text-[7px] tracking-[0.35em] text-[#e8a598] uppercase font-bold" style={{ fontFamily: '"Montserrat", sans-serif' }}>Mis XV Años</span>
                                            <span className="text-xl text-white font-light tracking-wide group-hover:text-[#e8a598] transition-colors duration-300 drop-shadow-[0_0_8px_rgba(232,165,152,0.3)] leading-tight" style={{ fontFamily: '"Cormorant Garamond", serif' }}>{demo.label}</span>
                                            <span className="text-[7px] uppercase tracking-widest text-white/50 font-bold flex items-center mt-0.5" style={{ fontFamily: '"Montserrat", sans-serif' }}><PlayCircle size={9} className="mr-1 text-[#e8a598]" /> Toca para abrir</span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 rounded-full bg-white/10 backdrop-blur-md flex items-center justify-center border border-[#e8a598]/30 shadow-sm text-white group-hover:bg-[#e8a598] group-hover:text-black transition-colors duration-500 shrink-0">
                                            <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300" />
                                        </div>
                                    </button>
                                );
                            }

                            // 🍼 3. ESTILOS: INVITACIÓN BABY SHOWER
                            if (demo.id === 'baby_shower') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-[#FFF0F2] border border-[#C5A059]/30 py-2.5 px-5 rounded-[1.5rem] shadow-[0_8px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_25px_rgba(197,160,89,0.15)] hover:-translate-y-0.5 transition-all duration-500 relative overflow-hidden group flex items-center justify-between text-left"
                                    >
                                        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40 group-hover:opacity-70 transition-opacity duration-700">
                                            <div className="absolute left-[15%] text-[#D8A7B1]" style={{ animation: 'floatItemMini 12s linear infinite', animationDelay: '0s' }}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6"><circle cx="12" cy="7" r="5" /><circle cx="12" cy="7" r="1" fill="currentColor" /><path d="M12 12v6" /><circle cx="12" cy="20" r="2" /></svg></div>
                                            <div className="absolute left-[45%] text-[#D8A7B1]" style={{ animation: 'floatItemMini 15s linear infinite', animationDelay: '3s' }}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6"><path d="M9 10c0-3 1.5-5 3-5s3 2 3 5" /><rect x="5" y="10" width="14" height="4" rx="2" /><circle cx="12" cy="18" r="3" /></svg></div>
                                        </div>

                                        <div className="flex flex-col items-start relative z-10">
                                            <div className="absolute -left-2 -top-4 opacity-[0.07] pointer-events-none text-[#C5A059]" style={{ fontFamily: '"Great Vibes", cursive', fontSize: '3.2rem', lineHeight: '1' }}>TE</div>
                                            <span className="text-[7px] tracking-[0.35em] text-[#D8A7B1] uppercase font-bold" style={{ fontFamily: '"Montserrat", sans-serif' }}>Baby Shower de</span>
                                            <span className="text-xl text-[#111827] font-light tracking-wide group-hover:text-[#D8A7B1] transition-colors duration-300 leading-tight" style={{ fontFamily: '"Great Vibes", cursive' }}>{demo.label}</span>
                                            <span className="text-[7px] uppercase tracking-widest text-[#4B5563] font-bold flex items-center mt-0.5" style={{ fontFamily: '"Montserrat", sans-serif' }}><PlayCircle size={9} className="mr-1 text-[#C5A059]" /> Toca para abrir</span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 rounded-full bg-white/70 backdrop-blur-sm flex items-center justify-center border border-[#C5A059]/30 shadow-sm text-[#4B5563] group-hover:bg-[#D8A7B1] group-hover:border-[#D8A7B1] group-hover:text-white transition-colors duration-500 shrink-0">
                                            <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300" />
                                        </div>
                                    </button>
                                );
                            }

                            // 💎 4. ESTILOS: INVITACIÓN DE CUMPLEAÑOS
                            if (demo.id === 'cumple_formal') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-[#FDFBF7] border border-[#D4AF37]/30 py-2.5 px-5 rounded-[1.5rem] shadow-[0_8px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_12px_25px_rgba(212,175,55,0.15)] hover:-translate-y-0.5 transition-all duration-500 relative overflow-hidden group flex items-center justify-between text-left"
                                    >
                                        <div className="absolute -bottom-14 -right-16 pointer-events-none opacity-60 z-0 group-hover:scale-110 transition-transform duration-1000 delay-100" style={{ animation: 'floatMini 6s ease-in-out infinite' }}>
                                            <svg viewBox="0 0 200 200" className="w-52 h-52" xmlns="http://www.w3.org/2000/svg">
                                                <g transform="scale(0.8) translate(20, 20)">
                                                    <path d="M 40 100 C 10 70, 20 20, 80 10 C 80 60, 60 90, 40 100 Z" fill="#8DB580" opacity="0.8"/>
                                                    <path d="M 100 40 C 70 10, 20 20, 10 80 C 60 80, 90 60, 100 40 Z" fill="#A3C697" opacity="0.9"/>
                                                    <circle cx="120" cy="70" r="30" fill="#FFD166" />
                                                    <circle cx="70" cy="120" r="35" fill="#F76C82" />
                                                    <path d="M 90 90 Q 100 100, 110 90" stroke="#D4AF37" strokeWidth="2" fill="none"/>
                                                </g>
                                            </svg>
                                        </div>

                                        <div className="flex flex-col items-start relative z-10">
                                            <div className="absolute -left-2 -top-2 opacity-5 pointer-events-none text-[#D4AF37]" style={{ fontFamily: '"Pinyon Script", cursive', fontSize: '2.5rem', lineHeight: '1' }}>50</div>
                                            <span className="text-[7px] tracking-[0.35em] text-[#8DB580] uppercase font-bold" style={{ fontFamily: '"Montserrat", sans-serif' }}>Celebrando la vida</span>
                                            <span className="text-xl text-[#1a1a1a] font-light tracking-wide group-hover:text-[#F76C82] transition-colors duration-300 leading-tight" style={{ fontFamily: '"Cormorant Garamond", serif' }}>{demo.label}</span>
                                            <span className="text-[7px] uppercase tracking-widest text-[#2C3531]/60 font-bold flex items-center mt-0.5" style={{ fontFamily: '"Montserrat", sans-serif' }}><PlayCircle size={9} className="mr-1 text-[#D4AF37]" /> Toca para abrir</span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 rounded-full bg-white flex items-center justify-center border border-[#D4AF37]/30 shadow-sm text-[#2A2A2A] group-hover:bg-[#F76C82]/10 group-hover:border-[#F76C82] transition-colors duration-500 shrink-0">
                                            <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300 text-[#D4AF37] group-hover:text-[#F76C82]" />
                                        </div>
                                    </button>
                                );
                            }

                            // 🎮 5. ESTILOS: INVITACIÓN MINECRAFT 
                            if (demo.id === 'tematicas') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-[#5d4037] border-[3px] border-black py-2.5 px-5 rounded-[1.5rem] shadow-[inset_-3px_-3px_0px_0px_rgba(0,0,0,0.5),_inset_3px_3px_0px_0px_rgba(255,255,255,0.5)] active:translate-y-0.5 transition-all relative overflow-hidden group flex items-center justify-between text-left"
                                        style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'40\' height=\'40\' viewBox=\'0 0 40 40\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%233e2723\' fill-opacity=\'0.4\' fill-rule=\'evenodd\'%3E%3Cpath d=\'M0 0h40v40H0V0zm20 20h20v20H20V20zM0 20h20v20H0V20zM20 0h20v20H20V0z\'/%3E%3C/g%3E%3C/svg%3E")' }}
                                    >
                                        <div className="absolute top-0 left-0 w-full h-3 bg-[#388e3c] border-b-[3px] border-[#1b5e20] pointer-events-none"></div>

                                        <div className="flex flex-col items-start relative z-10 pt-1.5">
                                            <span className="text-[10px] tracking-[0.2em] text-[#388e3c] drop-shadow-[1px_1px_0_#000] uppercase" style={{ fontFamily: '"VT323", monospace' }}>Mundo Gamer</span>
                                            <span className="text-2xl text-white drop-shadow-[2px_2px_0_#000] group-hover:text-green-400 transition-colors leading-none" style={{ fontFamily: '"VT323", monospace' }}>{demo.label}</span>
                                            <span className="text-[10px] uppercase tracking-widest text-white/70 drop-shadow-[1px_1px_0_#000] flex items-center mt-0.5" style={{ fontFamily: '"VT323", monospace' }}><PlayCircle size={9} className="mr-1 text-white" /> Start Game</span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 bg-[#C6C6C6] border-2 border-black flex items-center justify-center shadow-[inset_-2px_-2px_0px_0px_#555,_inset_2px_2px_0px_0px_#FFF] text-[#202020] group-hover:bg-green-500 transition-colors duration-200 shrink-0">
                                            <ChevronRight size={15} className="text-black" />
                                        </div>
                                    </button>
                                );
                            }

                            // 🕊️ 6. ESTILOS: INVITACIÓN BAUTIZO
                            if (demo.id === 'bautizo') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-[#FAF9F6] border border-[#D4AF37]/30 py-2.5 px-5 rounded-[1.5rem] shadow-[0_8px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_25px_rgba(212,175,55,0.15)] hover:-translate-y-0.5 transition-all duration-500 relative overflow-hidden group flex items-center justify-between text-left"
                                    >
                                        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-30 group-hover:opacity-60 transition-opacity duration-700">
                                            <div className="absolute top-0 left-0 w-8 h-8 text-[#D4AF37]" style={{ animation: 'floatCloudMini 12s linear infinite', animationDelay: '0s', '--y-offset': '8px', '--scale': '0.9', '--rot': '-5deg' }}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" /></svg></div>
                                            <div className="absolute top-0 left-0 w-8 h-8 text-[#D4AF37]" style={{ animation: 'floatCloudMini 18s linear infinite', animationDelay: '-5s', '--y-offset': '28px', '--scale': '0.7', '--rot': '10deg' }}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="14" r="4.5" /><circle cx="12" cy="8" r="3.5" /></svg></div>
                                        </div>

                                        <div className="flex flex-col items-start relative z-10">
                                            <div className="absolute -left-2 -top-4 opacity-5 pointer-events-none text-[#D4AF37]" style={{ fontFamily: '"Great Vibes", cursive', fontSize: '3.2rem', lineHeight: '1' }}>JA</div>
                                            <span className="text-[7px] tracking-[0.35em] text-[#8A9A86] uppercase font-bold" style={{ fontFamily: '"Montserrat", sans-serif' }}>Con la bendición</span>
                                            <span className="text-xl text-[#333333] font-light tracking-wide group-hover:text-[#D4AF37] transition-colors duration-300 leading-tight" style={{ fontFamily: '"Cormorant Garamond", serif' }}>{demo.label}</span>
                                            <span className="text-[7px] uppercase tracking-widest text-[#7A7A7A] font-bold flex items-center mt-0.5" style={{ fontFamily: '"Montserrat", sans-serif' }}><PlayCircle size={9} className="mr-1 text-[#D4AF37]" /> Toca para abrir</span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 rounded-full bg-white flex items-center justify-center border border-[#D4AF37]/30 shadow-sm text-[#333333] group-hover:bg-[#D4AF37]/10 group-hover:border-[#D4AF37] transition-colors duration-500 shrink-0">
                                            <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300 text-[#D4AF37]" />
                                        </div>
                                    </button>
                                );
                            }

                            // 🏢 7. ESTILOS: CORPORATIVO / GALAS
                            if (demo.id === 'corporativo') {
                                return (
                                    <button 
                                        key={demo.id}
                                        type="button"
                                        onClick={() => setFullScreenDemo(demo.url)}
                                        className="w-full bg-gradient-to-br from-[#002855] to-[#001530] border border-[#00B2E3]/20 py-2.5 px-5 rounded-[1.5rem] shadow-[0_8px_20px_rgba(0,40,85,0.4)] hover:shadow-[0_12px_25px_rgba(0,178,227,0.2)] hover:-translate-y-0.5 transition-all duration-500 relative overflow-hidden group flex items-center justify-between text-left"
                                    >
                                        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: "radial-gradient(#ffffff 1px, transparent 1px)", backgroundSize: "20px 20px" }}></div>
                                        <div className="absolute -bottom-8 -right-8 w-28 h-28 flex items-center justify-center pointer-events-none opacity-40 group-hover:opacity-100 transition-opacity duration-700">
                                            <div className="absolute w-7 h-7 rounded-full border-2 border-[#00B2E3] opacity-0" style={{ animation: 'radarPulse 3s cubic-bezier(0.16, 1, 0.3, 1) infinite' }}></div>
                                            <div className="absolute w-7 h-7 rounded-full border-2 border-[#00B2E3] opacity-0" style={{ animation: 'radarPulse 3s cubic-bezier(0.16, 1, 0.3, 1) infinite 1s' }}></div>
                                        </div>

                                        <div className="flex flex-col items-start relative z-10">
                                            <span className="text-[7px] tracking-widest text-[#00B2E3] uppercase font-bold" style={{ fontFamily: '"Inter", sans-serif' }}>
                                                Eventos Corporativos
                                            </span>
                                            <span className="text-lg text-white font-bold tracking-tight group-hover:text-[#00B2E3] transition-colors duration-300 leading-tight" style={{ fontFamily: '"Inter", sans-serif' }}>
                                                {demo.label}
                                            </span>
                                            <span className="text-[7px] uppercase tracking-widest text-gray-400 font-semibold flex items-center mt-0.5" style={{ fontFamily: '"Inter", sans-serif' }}>
                                                <PlayCircle size={9} className="mr-1 text-[#00B2E3]" /> Acceso Exclusivo
                                            </span>
                                        </div>
                                        
                                        <div className="relative z-10 w-8 h-8 rounded-lg bg-[#00B2E3]/10 flex items-center justify-center border border-[#00B2E3]/30 shadow-sm text-white group-hover:bg-[#00B2E3] group-hover:text-[#002855] transition-colors duration-500 shrink-0">
                                            <ChevronRight size={15} className="group-hover:translate-x-0.5 transition-transform duration-300" />
                                        </div>
                                    </button>
                                );
                            }

                            // ⚪ FALLBACK
                            return (
                                <button 
                                    key={demo.id}
                                    type="button"
                                    onClick={() => setFullScreenDemo(demo.url)}
                                    className="w-full bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10 py-2.5 px-5 rounded-[1.5rem] shadow-sm hover:shadow-md transition-all relative overflow-hidden group flex items-center justify-between text-left"
                                >
                                    <div className="flex flex-col items-start relative z-10">
                                        <span className="font-bold text-base text-slate-900 dark:text-white drop-shadow-sm">
                                            {demo.label}
                                        </span>
                                        <span className="text-[7px] uppercase tracking-widest text-slate-500 dark:text-slate-400 font-bold flex items-center mt-0.5">
                                            <PlayCircle size={9} className="mr-1" /> Toca para abrir
                                        </span>
                                    </div>
                                    <div className="relative z-10 w-8 h-8 rounded-full bg-white/50 dark:bg-black/20 backdrop-blur-md flex items-center justify-center border border-white/50 dark:border-white/10 shadow-sm text-slate-700 dark:text-white group-hover:translate-x-0.5 transition-transform shrink-0">
                                        <ChevronRight size={15} />
                                    </div>
                                </button>
                            );
                        })}
                    </div>

                    <button 
                        type="button"
                        onClick={() => setShowAnatomy(true)} 
                        className="w-full mt-4 py-5 bg-transparent border-2 border-amber-500/30 text-amber-600 dark:text-amber-500 rounded-[2rem] font-bold text-xs uppercase tracking-widest hover:bg-amber-50 dark:hover:bg-amber-500/10 transition-colors flex items-center justify-center shadow-sm"
                    >
                        <BookOpenText size={18} className="mr-2"/> Explorar Anatomía
                    </button>
                    
                </RevealSection>
            )}

        </div>
      </section>

      {/* BENTO BOX INTERACTIVO: DEMOSTRACIÓN EN VIVO DE ALTA COSTURA E INGENIERÍA */}
      <section id="experiencia" className="py-28 px-4 md:px-8 max-w-7xl mx-auto relative z-10">
        <RevealSection className="mb-16 text-center md:text-left flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-xs mb-4 block">Laboratorio Interactivo en Vivo</span>
            <h2 className="text-5xl md:text-6xl font-editorial font-medium text-slate-900 dark:text-white tracking-tight transition-colors duration-700 leading-tight">
              Cálida por fuera.<br/><span className="italic text-slate-500 dark:text-slate-400">Superdotada por dentro.</span>
            </h2>
          </div>
          <p className="text-slate-500 dark:text-slate-400 text-sm md:text-base max-w-md font-light leading-relaxed">
            Toca y prueba cada módulo aquí mismo. Mientras tus invitados disfrutan una invitación llena de emoción visual, tú tienes el motor logístico más avanzado del mercado.
          </p>
        </RevealSection>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          
          {/* 👑 TARJETA 1 (2 cols): ARTE CÁLIDO & SALUDO VIP PERSONALIZADO */}
          <RevealSection delay={100} className="lg:col-span-2 bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] p-8 sm:p-10 border border-slate-200 dark:border-white/10 flex flex-col justify-between relative overflow-hidden group shadow-sm transition-colors duration-700 min-h-[420px]">
            <div className={`absolute inset-0 opacity-5 dark:opacity-10 transition-colors duration-700 ${accentColor === 'monochrome' ? 'bg-slate-500' : (accentThemes[accentColor]?.bg || '')}`}></div>
            
            <div className="relative z-20 flex flex-col items-start gap-3">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-2xl bg-[#FDFBF7] dark:bg-white/5 border border-[#D4AF37]/40 shadow-md">
                <Gem size={14} className="text-amber-500 shrink-0"/>
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400">Pase Especial Para:</span>
                <span className="font-editorial italic font-bold text-sm text-slate-900 dark:text-white">Familia Montemayor (4 Lugares)</span>
              </div>

              <div className={`mt-2 transition-all duration-700 transform group-hover:scale-105 group-hover:-rotate-2 drop-shadow-xl ${accentColor === 'monochrome' ? 'text-slate-800 dark:text-white' : accentThemes[accentColor]?.text}`}>
                <h3 style={{ fontFamily: '"Birthstone", cursive', fontSize: '4.2rem', lineHeight: '1' }} className="font-medium -rotate-3">
                  Sofía y Alejandro
                </h3>
              </div>
            </div>

            {/* Fotos reales desde /demos/boda/ */}
            <div className="relative sm:absolute sm:top-12 sm:right-6 w-full sm:w-56 h-52 sm:h-64 pointer-events-none perspective-[1000px] flex items-center justify-center my-4 sm:my-0">
               <img src="/demos/boda/foto2.jpg" alt="Fotografía romántica de boda Baulia" className="absolute w-36 sm:w-40 h-48 sm:h-52 object-cover rounded-2xl border-[4px] border-white dark:border-[#111] transform rotate-[10deg] translate-x-12 sm:translate-x-14 translate-y-4 group-hover:rotate-[15deg] group-hover:translate-x-18 shadow-xl transition-all duration-700 ease-out" />
               <img src="/demos/boda/foto4.jpg" alt="Diseño de invitación de alta costura" className="absolute w-36 sm:w-40 h-48 sm:h-52 object-cover rounded-2xl border-[4px] border-white dark:border-[#111] transform -rotate-[5deg] group-hover:-rotate-[10deg] group-hover:-translate-x-4 shadow-xl transition-all duration-700 ease-out z-10" />
            </div>
            
            <div className="relative z-30 w-full sm:w-3/4 mt-auto pt-4">
               <div className="flex items-center gap-2 p-2 bg-white/90 dark:bg-black/60 backdrop-blur-md rounded-full border border-slate-200 dark:border-white/10 w-max mb-4 shadow-sm">
                 <span className="text-[9px] font-black uppercase tracking-widest text-slate-400 px-2">Paleta:</span>
                 <button type="button" onMouseEnter={()=>setAccentColor('monochrome')} onClick={()=>setAccentColor('monochrome')} className={`w-5 h-5 rounded-full bg-[linear-gradient(135deg,_#0f172a_50%,_#ffffff_50%)] border border-slate-300 transition-all ${accentColor === 'monochrome' ? 'scale-125 ring-2 ring-amber-500' : 'hover:scale-110'}`}></button>
                 <button type="button" onMouseEnter={()=>setAccentColor('amber')} onClick={()=>setAccentColor('amber')} className={`w-5 h-5 rounded-full bg-amber-500 transition-all ${accentColor === 'amber' ? 'scale-125 ring-2 ring-amber-500' : 'hover:scale-110'}`}></button>
                 <button type="button" onMouseEnter={()=>setAccentColor('rose')} onClick={()=>setAccentColor('rose')} className={`w-5 h-5 rounded-full bg-rose-500 transition-all ${accentColor === 'rose' ? 'scale-125 ring-2 ring-rose-500' : 'hover:scale-110'}`}></button>
                 <button type="button" onMouseEnter={()=>setAccentColor('emerald')} onClick={()=>setAccentColor('emerald')} className={`w-5 h-5 rounded-full bg-emerald-500 transition-all ${accentColor === 'emerald' ? 'scale-125 ring-2 ring-emerald-500' : 'hover:scale-110'}`}></button>
                 <button type="button" onMouseEnter={()=>setAccentColor('indigo')} onClick={()=>setAccentColor('indigo')} className={`w-5 h-5 rounded-full bg-indigo-500 transition-all ${accentColor === 'indigo' ? 'scale-125 ring-2 ring-indigo-500' : 'hover:scale-110'}`}></button>
               </div>

               <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-white mb-2 leading-tight">
                 Arte Cálido & Saludo VIP por Invitado
               </h3>
               <p className="text-slate-600 dark:text-slate-400 text-xs sm:text-sm leading-relaxed">
                 Acuarelas, música envolvente sin bloqueos y <b className={accentColor === 'monochrome' ? 'text-slate-900 dark:text-white' : accentThemes[accentColor]?.text}>extracción inteligente</b> que saluda a cada familia por su nombre desde la portada.
               </p>
            </div>
          </RevealSection>

          {/* 👑 TARJETA 2 (2 cols): CONFIRMACIÓN DUAL INTERACTIVA (PASES QR VIVOS VS WHATSAPP) */}
          <RevealSection delay={150} className="lg:col-span-2 bg-slate-900 dark:bg-[#0d0d0d] rounded-[2.5rem] p-8 sm:p-10 border border-slate-800 dark:border-white/10 flex flex-col justify-between relative overflow-hidden shadow-xl min-h-[420px]">
            <div className="absolute -right-12 -top-12 w-52 h-52 bg-amber-500/10 blur-3xl rounded-full pointer-events-none"></div>

            {/* Selector Interactivo de Modalidad */}
            <div className="relative z-10 flex flex-wrap items-center justify-between gap-3 mb-6">
              <span className="text-[10px] font-black uppercase tracking-widest text-amber-400 flex items-center gap-1.5">
                <QrCode size={14}/> Modalidad de Confirmación
              </span>
              <div className="flex bg-white/10 p-1 rounded-full border border-white/10">
                <button
                  type="button"
                  onClick={() => setRsvpDemoMode('qr')}
                  className={`px-3.5 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest transition-all ${rsvpDemoMode === 'qr' ? 'bg-amber-500 text-slate-900 shadow-md' : 'text-slate-300 hover:text-white'}`}
                >
                  Pases QR (Oro/Diamante)
                </button>
                <button
                  type="button"
                  onClick={() => setRsvpDemoMode('whatsapp')}
                  className={`px-3.5 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest transition-all ${rsvpDemoMode === 'whatsapp' ? 'bg-emerald-500 text-white shadow-md' : 'text-slate-300 hover:text-white'}`}
                >
                  WhatsApp (Básico/Plata)
                </button>
              </div>
            </div>

            {/* Vista Dinámica según el botón seleccionado */}
            <div className="relative z-10 flex flex-col sm:flex-row items-center justify-between gap-6 my-auto">
              <div className="flex-1 text-left">
                {rsvpDemoMode === 'qr' ? (
                  <div className="animate-in fade-in duration-300">
                    <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2.5 leading-tight">
                      Pases QR Vivos con Mesa Asignada
                    </h3>
                    <p className="text-slate-400 text-xs sm:text-sm leading-relaxed mb-4">
                      Al confirmar sin salir de su invitación, el sistema genera un carrusel con el <b>Pase VIP descargable de cada integrante</b> e imprime automáticamente la mesa que le asignaste.
                    </p>
                    <div className="inline-flex items-center gap-2 text-[10px] font-bold text-amber-400 bg-amber-500/10 px-3 py-1.5 rounded-lg border border-amber-500/20">
                      <CheckCircle size={13}/> Cero colados • Intransferible
                    </div>
                  </div>
                ) : (
                  <div className="animate-in fade-in duration-300">
                    <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2.5 leading-tight">
                      Confirmación Directa vía WhatsApp
                    </h3>
                    <p className="text-slate-400 text-xs sm:text-sm leading-relaxed mb-4">
                      ¿Prefieres una recepción tradicional y cálida sin escáneres? Tus invitados confirman con un toque enviando un mensaje prellenado directo a tu WhatsApp personal.
                    </p>
                    <div className="inline-flex items-center gap-2 text-[10px] font-bold text-emerald-400 bg-emerald-500/10 px-3 py-1.5 rounded-lg border border-emerald-500/20">
                      <MessageCircle size={13}/> Incluido en Planes Básico y Plata
                    </div>
                  </div>
                )}
              </div>

              {/* Tarjeta Derecha Simulada */}
              {rsvpDemoMode === 'qr' ? (
                <div className="w-48 bg-[#FDFBF7] text-slate-900 rounded-2xl p-4 shadow-2xl border border-amber-500/40 shrink-0 text-center animate-in zoom-in-95 duration-300">
                  <div className="w-full h-1.5 bg-amber-500 rounded-full mb-2.5"></div>
                  <p className="text-[7px] font-black uppercase tracking-widest text-slate-400">Entrada Personal</p>
                  <p className="font-editorial font-bold text-sm text-slate-900 truncate mt-0.5">Alejandro Montemayor</p>
                  <div className="bg-white p-2 rounded-xl w-24 h-24 mx-auto my-2.5 shadow-inner border border-slate-200">
                    <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=BAULIA-VIP-DEMO" alt="Pase QR VIP Baulia" className="w-full h-full mix-blend-multiply" />
                  </div>
                  <p className="text-[7px] font-bold uppercase tracking-widest text-slate-400">Asiento Asignado</p>
                  <p className="text-[10px] font-black uppercase tracking-widest text-amber-600 mt-0.5">Mesa 1 • VIP</p>
                </div>
              ) : (
                <div className="w-52 bg-[#0b141a] text-white rounded-2xl p-4 shadow-2xl border border-emerald-500/40 shrink-0 text-left animate-in zoom-in-95 duration-300">
                  <div className="flex items-center gap-2 border-b border-white/10 pb-2.5 mb-3">
                    <div className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center text-white font-bold text-xs">S&A</div>
                    <div>
                      <p className="text-[10px] font-bold leading-none">Sofía y Alejandro</p>
                      <p className="text-[8px] text-emerald-400 mt-0.5">En línea • WhatsApp</p>
                    </div>
                  </div>
                  <div className="bg-[#005c4b] p-2.5 rounded-xl rounded-tr-none text-[10px] leading-relaxed text-white/95 mb-3 shadow">
                    ¡Hola! Somos la <b>Familia Montemayor</b> ✨ Confirmamos con mucha alegría nuestra asistencia a la boda.
                  </div>
                  <div className="w-full py-2 bg-emerald-500 text-slate-950 rounded-lg text-center font-black text-[9px] uppercase tracking-widest">
                    Respuesta Instantánea
                  </div>
                </div>
              )}
            </div>
          </RevealSection>

          {/* 👑 TARJETA 3 (2 cols): SIMULADOR INTERACTIVO EN VIVO DE AUTO-ACOMODO POR AFINIDAD */}
          <RevealSection delay={200} className="lg:col-span-2 bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] p-7 sm:p-9 border border-slate-200 dark:border-white/10 flex flex-col justify-between relative overflow-hidden shadow-sm">
            {/* Barra superior interactiva del simulador */}
            <div className="flex flex-wrap items-center justify-between gap-2 pb-4 mb-4 border-b border-slate-100 dark:border-white/10">
              <div className="flex items-center gap-1.5 flex-wrap">
                <span className="text-[9px] font-black uppercase tracking-widest text-slate-400 mr-1">Etiquetas:</span>
                {['Primos', 'Amigos'].map(tag => {
                  const active = demoTagsActivas.includes(tag);
                  return (
                    <button
                      key={tag}
                      type="button"
                      onClick={() => {
                        setAcomodoSimulated(false);
                        setDemoTagsActivas(prev => prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]);
                      }}
                      className={`px-2.5 py-1 rounded-lg text-[10px] font-bold transition-all border ${active ? 'bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 border-transparent shadow-sm' : 'bg-slate-100 dark:bg-[#111] text-slate-400 border-slate-200 dark:border-white/10'}`}
                    >
                      #{tag}
                    </button>
                  );
                })}
              </div>

              <button
                type="button"
                onClick={() => setAcomodoSimulated(!acomodoSimulated)}
                className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all flex items-center gap-1.5 shadow-md active:scale-95 ${acomodoSimulated ? 'bg-slate-200 dark:bg-white/10 text-slate-700 dark:text-white' : 'bg-emerald-500 text-white hover:bg-emerald-600 animate-pulse'}`}
              >
                <Wand2 size={13}/> {acomodoSimulated ? 'Reiniciar Demo' : '¡Probar Auto-Acomodar!'}
              </button>
            </div>

            {/* Escenario: Lista de No Asignados (Izquierda) + 2 Mesas estilo MesasView (Derecha) */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-3 my-auto">
              {/* Columna Izquierda: No Asignados */}
              <div className="sm:col-span-5 bg-slate-50 dark:bg-[#111] rounded-2xl p-3.5 border border-slate-200/80 dark:border-white/10 flex flex-col">
                <div className="flex items-center justify-between mb-2.5 pb-2 border-b border-slate-200/60 dark:border-white/5">
                  <span className="text-[9px] font-black uppercase tracking-widest text-slate-700 dark:text-slate-200 flex items-center gap-1">
                    <Users size={11} className="text-amber-500"/> No Asignados
                  </span>
                  <span className="text-[9px] font-black bg-slate-200 dark:bg-white/10 px-1.5 py-0.5 rounded text-slate-700 dark:text-white">
                    {acomodoSimulated ? 0 : 3}
                  </span>
                </div>

                {!acomodoSimulated ? (
                  <div className="space-y-2 animate-in fade-in duration-300">
                    <div className="p-2 rounded-xl bg-white dark:bg-[#050505] border border-slate-200 dark:border-white/10 flex items-center justify-between">
                      <div>
                        <p className="text-[11px] font-bold text-slate-800 dark:text-white leading-none">Fam. Montemayor</p>
                        <span className="text-[8px] font-black uppercase text-emerald-600 dark:text-emerald-400">Familiar</span>
                      </div>
                      <span className="text-[9px] font-black bg-slate-100 dark:bg-white/10 px-1.5 py-0.5 rounded">4p</span>
                    </div>
                    <div className="p-2 rounded-xl bg-white dark:bg-[#050505] border border-slate-200 dark:border-white/10 flex items-center justify-between">
                      <div>
                        <p className="text-[11px] font-bold text-slate-800 dark:text-white leading-none">Jóvenes Villarreal</p>
                        <span className="text-[8px] font-black uppercase text-indigo-500 dark:text-amber-400">#Primos</span>
                      </div>
                      <span className="text-[9px] font-black bg-slate-100 dark:bg-white/10 px-1.5 py-0.5 rounded">3p</span>
                    </div>
                    <div className="p-2 rounded-xl bg-white dark:bg-[#050505] border border-slate-200 dark:border-white/10 flex items-center justify-between">
                      <div>
                        <p className="text-[11px] font-bold text-slate-800 dark:text-white leading-none">Grupo Universidad</p>
                        <span className="text-[8px] font-black uppercase text-indigo-500 dark:text-amber-400">#Amigos</span>
                      </div>
                      <span className="text-[9px] font-black bg-slate-100 dark:bg-white/10 px-1.5 py-0.5 rounded">3p</span>
                    </div>
                  </div>
                ) : (
                  <div className="flex-1 flex flex-col items-center justify-center text-center py-6 text-emerald-600 dark:text-emerald-400 animate-in zoom-in-95 duration-300">
                    <CheckCircle size={24} className="mb-1.5"/>
                    <p className="text-[10px] font-black uppercase tracking-widest">¡Salón Optimizado!</p>
                    <p className="text-[9px] text-slate-400 mt-0.5">0 pendientes</p>
                  </div>
                )}
              </div>

              {/* Columna Derecha: 2 Mesas idénticas a MesasView */}
              <div className="sm:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-2.5">
                {/* Mesa 1 */}
                <div className="bg-slate-50 dark:bg-[#111] p-3 rounded-2xl border border-slate-200/80 dark:border-white/10 flex flex-col">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="font-bold text-xs text-slate-800 dark:text-white">Mesa 1</span>
                    <span className="text-[9px] font-black text-emerald-600 dark:text-emerald-400">{acomodoSimulated ? '8 / 10' : '4 / 10'}</span>
                  </div>
                  <span className="text-[8px] font-black uppercase tracking-wider px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20 w-max mb-2">
                    📌 VIP / Familia
                  </span>
                  <div className="space-y-1.5 mt-auto">
                    <div className="text-[9px] font-bold px-2 py-1 rounded-lg bg-white dark:bg-[#050505] border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-300 flex justify-between">
                      <span>Papás Novios (Fijos)</span>
                      <span className="opacity-60">(4)</span>
                    </div>
                    {acomodoSimulated && (
                      <div className="text-[9px] font-bold px-2 py-1 rounded-lg bg-emerald-500 text-white flex justify-between animate-in zoom-in-95 duration-300 shadow-sm">
                        <span>Fam. Montemayor</span>
                        <span>(4)</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Mesa 2 con Imán */}
                <div className="bg-slate-50 dark:bg-[#111] p-3 rounded-2xl border border-slate-200/80 dark:border-white/10 flex flex-col">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="font-bold text-xs text-slate-800 dark:text-white">Mesa 2</span>
                    <span className="text-[9px] font-black text-indigo-600 dark:text-amber-400">{acomodoSimulated ? '6 / 10' : '0 / 10'}</span>
                  </div>
                  <div className="flex gap-1 mb-2 flex-wrap">
                    <span className="text-[8px] font-black uppercase px-1.5 py-0.5 rounded bg-indigo-500/10 text-indigo-600 dark:text-amber-400 border border-indigo-500/20 flex items-center">
                      <Magnet size={8} className="mr-0.5"/> #Primos
                    </span>
                    <span className="text-[8px] font-black uppercase px-1.5 py-0.5 rounded bg-indigo-500/10 text-indigo-600 dark:text-amber-400 border border-indigo-500/20 flex items-center">
                      <Magnet size={8} className="mr-0.5"/> #Amigos
                    </span>
                  </div>
                  <div className="space-y-1.5 mt-auto">
                    {!acomodoSimulated ? (
                      <p className="text-[9px] italic text-slate-400 text-center py-3">Esperando imán...</p>
                    ) : (
                      <>
                        <div className="text-[9px] font-bold px-2 py-1 rounded-lg bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 flex justify-between animate-in zoom-in-95 duration-300 shadow-sm">
                          <span>Jóvenes Villarreal</span>
                          <span>(3)</span>
                        </div>
                        <div className="text-[9px] font-bold px-2 py-1 rounded-lg bg-indigo-600 dark:bg-amber-500 text-white dark:text-slate-900 flex justify-between animate-in zoom-in-95 duration-500 shadow-sm">
                          <span>Grupo Universidad</span>
                          <span>(3)</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5 pt-3 border-t border-slate-100 dark:border-white/5">
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-1 flex items-center gap-2">
                <Wand2 size={18} className="text-indigo-600 dark:text-amber-400"/> Motor Dual: Auto-Acomodo por Afinidad y Tetris
              </h3>
              <p className="text-slate-500 dark:text-slate-400 text-xs leading-relaxed">
                Fija a los papás en la Mesa 1, ponle imanes (`#Primos`, `#Amigos`) a las mesas y presiona el botón: Baulia agrupa por afinidad y optimiza los lugares libres en un segundo.
              </p>
            </div>
          </RevealSection>

          {/* 👑 TARJETA 4 (2 cols): SIMULADOR INTERACTIVO DE CROQUIS 2D (ARRASTRA LAS MESAS CON EL DEDO O MOUSE) */}
          <RevealSection delay={250} className="lg:col-span-2 bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] p-7 sm:p-9 border border-slate-200 dark:border-white/10 flex flex-col justify-between relative overflow-hidden shadow-sm">
            {/* Controles para agregar o quitar mesas en vivo */}
            <div className="flex flex-wrap items-center justify-between gap-2 pb-4 mb-4 border-b border-slate-100 dark:border-white/10">
              <div className="flex items-center gap-1.5">
                <button
                  type="button"
                  onClick={() => {
                    if (croquisDemoMesas.length < 6) {
                      const nextNum = croquisDemoMesas.length + 1;
                      const posPreset = [
                        { x: 22, y: 74 },
                        { x: 80, y: 74 },
                        { x: 50, y: 26 }
                      ][(nextNum - 4) % 3];
                      setCroquisDemoMesas([...croquisDemoMesas, { id: Date.now(), nombre: `Mesa ${nextNum}`, tipo: 'redonda', cap: 10, ocupadas: 6, x: posPreset.x, y: posPreset.y }]);
                    }
                  }}
                  className="px-3 py-1.5 rounded-xl bg-indigo-50 dark:bg-amber-500/10 text-indigo-600 dark:text-amber-400 border border-indigo-200 dark:border-amber-500/20 text-[10px] font-black uppercase tracking-wider hover:scale-105 transition-transform"
                >
                  + Redonda
                </button>
                <button
                  type="button"
                  onClick={() => {
                    if (croquisDemoMesas.length < 6) {
                      const nextNum = croquisDemoMesas.length + 1;
                      const posPreset = [
                        { x: 80, y: 74 },
                        { x: 22, y: 74 },
                        { x: 50, y: 26 }
                      ][(nextNum - 4) % 3];
                      setCroquisDemoMesas([...croquisDemoMesas, { id: Date.now(), nombre: `Mesa ${nextNum}`, tipo: 'tablon', cap: 10, ocupadas: 8, x: posPreset.x, y: posPreset.y }]);
                    }
                  }}
                  className="px-3 py-1.5 rounded-xl bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/20 text-[10px] font-black uppercase tracking-wider hover:scale-105 transition-transform"
                >
                  + Tablón
                </button>
                {croquisDemoMesas.length > 2 && (
                  <button
                    type="button"
                    onClick={() => setCroquisDemoMesas(croquisDemoMesas.slice(0, -1))}
                    className="px-2.5 py-1.5 rounded-xl bg-rose-50 dark:bg-rose-500/10 text-rose-500 text-[10px] font-black uppercase tracking-wider"
                  >
                    - Quitar
                  </button>
                )}
              </div>

              <div className="flex items-center gap-3 text-[9px] font-bold uppercase tracking-wider text-slate-400">
                <span className="text-amber-500 animate-pulse hidden sm:inline">✋ Arrastra las mesas</span>
                <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-amber-500 inline-block"></span> Ocupada</span>
                <span className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-slate-300 dark:bg-slate-700 inline-block"></span> Libre</span>
              </div>
            </div>

            {/* Lienzo Arquitectónico 2D con Drag & Drop Táctil y Mouse 100% Fluido */}
            <div 
              ref={croquisCanvasRef}
              onPointerMove={handleCroquisPointerMove}
              onPointerUp={() => setDraggingMesaId(null)}
              onPointerCancel={() => setDraggingMesaId(null)}
              onTouchMove={handleCroquisTouchMove}
              onTouchEnd={() => setDraggingMesaId(null)}
              className="relative bg-slate-50 dark:bg-[#0d0d0d] rounded-2xl border border-slate-200/80 dark:border-white/10 h-[220px] w-full overflow-hidden select-none touch-none" 
              style={{ touchAction: 'none', WebkitUserSelect: 'none', backgroundImage: 'radial-gradient(rgba(148,163,184,0.25) 1px, transparent 1px)', backgroundSize: '14px 14px' }}
            >
              {/* Pista de Baile Central de Referencia */}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-20 rounded-xl border border-dashed border-slate-300 dark:border-white/10 bg-white/40 dark:bg-white/[0.02] flex flex-col items-center justify-center pointer-events-none">
                <span className="text-[7px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">Pista Principal</span>
                <span className="text-[7px] text-slate-400/70 mt-0.5">Mueve las mesas</span>
              </div>

              {croquisDemoMesas.map((m) => {
                const isDragging = draggingMesaId === m.id;
                return (
                  <div
                    key={m.id}
                    onPointerDown={(e) => {
                      e.stopPropagation();
                      setDraggingMesaId(m.id);
                    }}
                    onTouchStart={(e) => {
                      e.stopPropagation();
                      setDraggingMesaId(m.id);
                    }}
                    style={{ left: `${m.x}%`, top: `${m.y}%`, transform: 'translate(-50%, -50%)', touchAction: 'none' }}
                    className={`absolute flex flex-col items-center justify-center cursor-grab active:cursor-grabbing p-2 ${isDragging ? 'z-30 scale-110 drop-shadow-[0_10px_20px_rgba(245,158,11,0.4)]' : 'z-10 hover:scale-105'}`}
                  >
                    {m.tipo === 'redonda' ? (
                      <div className="relative w-16 h-16 flex items-center justify-center">
                        {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, sIdx) => {
                          const isOccupied = sIdx < Math.round((m.ocupadas / m.cap) * 8);
                          return (
                            <span
                              key={deg}
                              style={{ transform: `rotate(${deg}deg) translateY(-26px)` }}
                              className={`absolute w-2.5 h-2.5 rounded-full border ${isOccupied ? 'bg-amber-500 border-amber-600 shadow-[0_0_6px_rgba(245,158,11,0.5)]' : 'bg-slate-200 dark:bg-slate-800 border-slate-300 dark:border-white/10'}`}
                            />
                          );
                        })}
                        <div className={`w-11 h-11 rounded-full bg-white dark:bg-[#1a1a1a] border-2 ${isDragging ? 'border-amber-500' : 'border-slate-300 dark:border-white/20'} shadow-md flex flex-col items-center justify-center`}>
                          <span className="text-[8px] font-black text-slate-800 dark:text-white leading-none">{m.nombre}</span>
                          <span className="text-[7px] font-bold text-amber-600 dark:text-amber-400 mt-0.5">{m.ocupadas}/{m.cap}</span>
                        </div>
                      </div>
                    ) : (
                      <div className="relative w-20 h-14 flex flex-col items-center justify-center">
                        <div className="flex gap-1.5 mb-1">
                          {[0, 1, 2, 3].map(sIdx => (
                            <span key={sIdx} className={`w-2.5 h-2 rounded-sm ${sIdx < 3 ? 'bg-emerald-500' : 'bg-slate-300 dark:bg-slate-700'}`} />
                          ))}
                        </div>
                        <div className={`w-16 h-7 rounded-lg bg-white dark:bg-[#1a1a1a] border-2 ${isDragging ? 'border-emerald-400' : 'border-emerald-500/40'} shadow-md flex flex-col items-center justify-center`}>
                          <span className="text-[8px] font-black text-slate-800 dark:text-white leading-none">{m.nombre}</span>
                          <span className="text-[7px] font-bold text-emerald-600 dark:text-emerald-400">{m.ocupadas}/{m.cap}</span>
                        </div>
                        <div className="flex gap-1.5 mt-1">
                          {[0, 1, 2, 3].map(sIdx => (
                            <span key={sIdx} className={`w-2.5 h-2 rounded-sm ${sIdx < 3 ? 'bg-emerald-500' : 'bg-slate-300 dark:bg-slate-700'}`} />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div className="mt-5 pt-3 border-t border-slate-100 dark:border-white/5">
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-1 flex items-center gap-2">
                <LayoutGrid size={18} className="text-amber-500"/> Croquis 2D Interactivo (¡Mueve las Mesas!)
              </h3>
              <p className="text-slate-500 dark:text-slate-400 text-xs leading-relaxed">
                Arrastra las mesas con tu cursor o tu dedo para diseñar el plano de tu salón y supervisa en vivo qué sillas están ocupadas y cuáles libres.
              </p>
            </div>
          </RevealSection>

          {/* 👑 TARJETA 5 (2 cols): GALERÍAS FOTOGRÁFICAS INTERACTIVAS CON MASONRY EDITORIAL ASIMÉTRICO REAL */}
          <RevealSection delay={300} className="lg:col-span-2 bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] p-7 sm:p-9 border border-slate-200 dark:border-white/10 flex flex-col justify-between relative overflow-hidden shadow-sm">
            <div className="flex flex-wrap items-center justify-between gap-2 pb-4 mb-4 border-b border-slate-100 dark:border-white/10">
              <span className="text-[10px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400 flex items-center gap-1.5">
                <Camera size={14}/> Galerías Editoriales
              </span>
              <div className="flex bg-slate-100 dark:bg-[#111] p-1 rounded-xl border border-slate-200 dark:border-white/10">
                {[
                  { id: 'carrusel', lbl: '1. Carrusel' },
                  { id: 'masonry', lbl: '2. Masonry' },
                  { id: 'arcos', lbl: '3. Arcos y Formas' }
                ].map(st => (
                  <button
                    key={st.id}
                    type="button"
                    onClick={() => setGaleriaDemoEstilo(st.id)}
                    className={`px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-wider transition-all ${galeriaDemoEstilo === st.id ? 'bg-white dark:bg-amber-500 text-slate-900 shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'}`}
                  >
                    {st.lbl}
                  </button>
                ))}
              </div>
            </div>

            {/* Contenedor Dinámico con tus 6 fotos de /demos/cumple_formal/ */}
            <div className="my-auto min-h-[215px] flex items-center justify-center w-full">
              {galeriaDemoEstilo === 'carrusel' && (
                <div className="flex gap-3 overflow-x-auto pb-2 hide-scrollbar w-full snap-x snap-mandatory animate-in fade-in duration-300">
                  {[1, 2, 3, 4, 5, 6].map(n => (
                    <div key={n} className="w-36 h-48 shrink-0 snap-center rounded-2xl overflow-hidden border-2 border-amber-500/30 shadow-md relative group">
                      <img src={`/demos/cumple_formal/foto${n}.jpg`} alt={`Galería Carrusel ${n}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    </div>
                  ))}
                </div>
              )}

              {/* 🟢 MASONRY EDITORIAL ASIMÉTRICO REAL (Combina 4 proporciones distintas sin huecos) */}
              {galeriaDemoEstilo === 'masonry' && (
                <div className="grid grid-cols-4 grid-rows-3 gap-2.5 w-full h-[215px] animate-in zoom-in-95 duration-300">
                  {/* Foto 1: Protagonista Grande (2x2) */}
                  <div className="col-span-2 row-span-2 overflow-hidden rounded-2xl border border-amber-500/30 shadow-md relative group">
                    <img src="/demos/cumple_formal/foto1.jpg" alt="Masonry Principal" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  {/* Foto 2: Columna Vertical Alta (1x3) */}
                  <div className="col-span-1 row-span-3 overflow-hidden rounded-2xl border border-slate-200 dark:border-white/10 shadow-md relative group">
                    <img src="/demos/cumple_formal/foto2.jpg" alt="Masonry Vertical" className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  {/* Foto 3: Detalle Superior Derecho (1x1) */}
                  <div className="col-span-1 row-span-1 overflow-hidden rounded-2xl border border-slate-200 dark:border-white/10 shadow-sm relative group">
                    <img src="/demos/cumple_formal/foto3.jpg" alt="Masonry Detalle" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  {/* Foto 4: Retrato Vertical Inferior Derecho (1x2) */}
                  <div className="col-span-1 row-span-2 overflow-hidden rounded-2xl border border-amber-500/30 shadow-md relative group">
                    <img src="/demos/cumple_formal/foto4.jpg" alt="Masonry Retrato" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  {/* Foto 5: Encuadre Inferior Izquierdo (1x1) */}
                  <div className="col-span-1 row-span-1 overflow-hidden rounded-2xl border border-slate-200 dark:border-white/10 shadow-sm relative group">
                    <img src="/demos/cumple_formal/foto5.jpg" alt="Masonry Inferior 1" className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  {/* Foto 6: Encuadre Inferior Central (1x1) */}
                  <div className="col-span-1 row-span-1 overflow-hidden rounded-2xl border border-slate-200 dark:border-white/10 shadow-sm relative group">
                    <img src="/demos/cumple_formal/foto6.jpg" alt="Masonry Inferior 2" className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" />
                  </div>
                </div>
              )}

              {galeriaDemoEstilo === 'arcos' && (
                <div className="grid grid-cols-3 sm:grid-cols-6 gap-2.5 w-full items-center animate-in zoom-in-95 duration-300">
                  {[
                    { n: 1, shape: 'rounded-t-full rounded-b-xl' },
                    { n: 2, shape: 'rounded-full aspect-square' },
                    { n: 3, shape: 'rounded-tl-[2rem] rounded-br-[2rem] rounded-tr-md rounded-bl-md' },
                    { n: 4, shape: 'rounded-t-full rounded-b-xl' },
                    { n: 5, shape: 'rounded-full aspect-square' },
                    { n: 6, shape: 'rounded-tr-[2rem] rounded-bl-[2rem] rounded-tl-md rounded-br-md' }
                  ].map(item => (
                    <div key={item.n} className={`h-32 w-full overflow-hidden border-2 border-[#D4AF37]/60 shadow-md p-0.5 bg-[#FDFBF7] dark:bg-[#111] ${item.shape}`}>
                      <img src={`/demos/cumple_formal/foto${item.n}.jpg`} alt={`Galería Formas ${item.n}`} className={`w-full h-full object-cover ${item.shape}`} />
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="mt-5 pt-3 border-t border-slate-100 dark:border-white/5">
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-1">
                Sesiones Fotográficas con Arquitectura Editorial
              </h3>
              <p className="text-slate-500 dark:text-slate-400 text-xs leading-relaxed">
                Cambia arriba entre <b>Carrusel</b>, <b>Masonry Asimétrico</b> o <b>Arcos y Formas</b>. Tus fotografías lucen con encuadres artísticos dignos de revista.
              </p>
            </div>
          </RevealSection>

          {/* 👑 TARJETA 6 (1 col): MESA DE REGALOS DINÁMICA (SOBRES CLABE / PALACIO DE HIERRO / LIVERPOOL) */}
          <RevealSection delay={350} className="bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] p-7 border border-slate-200 dark:border-white/10 flex flex-col justify-between relative overflow-hidden shadow-sm">
            <div className="flex items-center justify-between gap-1 mb-3">
              <div className="flex bg-slate-100 dark:bg-[#111] p-1 rounded-xl border border-slate-200 dark:border-white/10 w-full">
                <button
                  type="button"
                  onClick={() => setRegaloDemoTipo('sobres')}
                  className={`flex-1 py-1 rounded-lg text-[9px] font-black uppercase tracking-wider transition-all ${regaloDemoTipo === 'sobres' ? 'bg-amber-500 text-slate-900 shadow-sm' : 'text-slate-500'}`}
                >
                  Sobres / CLABE
                </button>
                <button
                  type="button"
                  onClick={() => setRegaloDemoTipo('tiendas')}
                  className={`flex-1 py-1 rounded-lg text-[9px] font-black uppercase tracking-wider transition-all ${regaloDemoTipo === 'tiendas' ? 'bg-amber-500 text-slate-900 shadow-sm' : 'text-slate-500'}`}
                >
                  Tiendas VIP
                </button>
              </div>
            </div>

            {regaloDemoTipo === 'sobres' ? (
              <div className="my-auto bg-slate-50 dark:bg-[#111] p-4 rounded-2xl border border-slate-200/80 dark:border-white/10 text-center animate-in fade-in duration-300">
                <p className="text-[8px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400">BBVA • 0% Comisión</p>
                <p className="font-mono text-[11px] font-bold text-slate-800 dark:text-white my-2">0121 8000 4589 1234 56</p>
                <button
                  type="button"
                  onClick={() => {
                    setClabeDemoCopiada(true);
                    setTimeout(() => setClabeDemoCopiada(false), 2000);
                  }}
                  className={`w-full py-2.5 rounded-xl text-[9px] font-black uppercase tracking-widest transition-all ${clabeDemoCopiada ? 'bg-emerald-500 text-white' : 'bg-slate-900 dark:bg-white text-white dark:text-slate-900'}`}
                >
                  {clabeDemoCopiada ? '¡CLABE Copiada! ✓' : 'Copiar CLABE (1-Clic)'}
                </button>
              </div>
            ) : (
              <div className="my-auto space-y-2 animate-in fade-in duration-300">
                <div className="p-2.5 rounded-xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-between">
                  <div>
                    <p className="text-[10px] font-black text-amber-700 dark:text-amber-400">El Palacio de Hierro</p>
                    <p className="text-[8px] text-slate-500">Evento #409281</p>
                  </div>
                  <span className="text-[8px] font-black uppercase px-2 py-1 rounded bg-amber-500 text-slate-900">Abrir</span>
                </div>
                <div className="p-2.5 rounded-xl bg-rose-500/10 border border-rose-500/30 flex items-center justify-between">
                  <div>
                    <p className="text-[10px] font-black text-rose-600 dark:text-rose-400">Liverpool / Amazon</p>
                    <p className="text-[8px] text-slate-500">Evento #992814</p>
                  </div>
                  <span className="text-[8px] font-black uppercase px-2 py-1 rounded bg-rose-500 text-white">Abrir</span>
                </div>
              </div>
            )}

            <div className="mt-4 pt-3 border-t border-slate-100 dark:border-white/5">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-1">Mesa de Regalos y Sobres</h3>
              <p className="text-slate-500 dark:text-slate-400 text-[11px] leading-relaxed">
                Combina transferencia CLABE con copiado en 1 clic y mesas en Liverpool, Palacio de Hierro o Amazon.
              </p>
            </div>
          </RevealSection>

          {/* 👑 TARJETA 7 (1 col): RADAR GPS EN VIVO + BOTÓN DE AGENDAR EN CALENDARIO (.ICS) */}
          <RevealSection delay={400} className="bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] p-7 border border-slate-200 dark:border-white/10 flex flex-col justify-between relative overflow-hidden shadow-sm">
            <div className="space-y-2.5 my-auto">
              {/* Mini Mapa Interactivo con Ruta Animada */}
              <div className="relative h-32 rounded-2xl bg-slate-900 overflow-hidden border border-slate-800 p-3 flex flex-col justify-between">
                <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'linear-gradient(to right, #334155 1px, transparent 1px), linear-gradient(to bottom, #334155 1px, transparent 1px)', backgroundSize: '16px 16px' }}></div>
                
                <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 200 120">
                  <path
                    d="M 25 90 Q 80 80, 105 50 T 170 26"
                    fill="none"
                    stroke={gpsDemoActivo ? '#10b981' : '#f59e0b'}
                    strokeWidth="3"
                    strokeDasharray="6 4"
                  />
                  <circle cx="25" cy="90" r="4" fill="#94a3b8" />
                  <circle cx="170" cy="26" r="6" fill={gpsDemoActivo ? '#10b981' : '#f59e0b'} />
                </svg>

                <div className="relative z-10 flex justify-between items-center">
                  <span className="px-2 py-0.5 rounded bg-black/70 text-[8px] font-black uppercase tracking-widest text-amber-400 border border-white/10">
                    {gpsDemoActivo ? '🚗 En Ruta • 12 min' : '📍 Hacienda San Gabriel'}
                  </span>
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-ping"></span>
                </div>

                <button
                  type="button"
                  onClick={() => setGpsDemoActivo(!gpsDemoActivo)}
                  className="relative z-10 w-full py-1.5 rounded-xl bg-white/95 text-slate-900 font-black text-[9px] uppercase tracking-widest shadow-lg hover:bg-amber-400 transition-colors flex items-center justify-center gap-1.5"
                >
                  <MapPin size={11} className="text-rose-500"/> {gpsDemoActivo ? 'Abriendo Apple / Google Maps' : '1. Trazar Ruta GPS'}
                </button>
              </div>

              {/* Widget Interactivo de Agendar en Calendario (.ICS) */}
              <div className="p-3 rounded-2xl bg-slate-50 dark:bg-[#111] border border-slate-200/80 dark:border-white/10 flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                  <div className="w-8 h-8 rounded-xl bg-amber-500/10 border border-amber-500/30 flex flex-col items-center justify-center shrink-0">
                    <span className="text-[6px] font-black uppercase text-amber-600 dark:text-amber-400 leading-none">MAY</span>
                    <span className="text-[11px] font-black text-slate-900 dark:text-white leading-none mt-0.5">23</span>
                  </div>
                  <div className="truncate">
                    <p className="text-[10px] font-bold text-slate-800 dark:text-white truncate">Sábado • 15:00 hrs</p>
                    <p className="text-[8px] text-slate-400 truncate">iCal / Google Calendar</p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setAgendaDemoGuardada(!agendaDemoGuardada)}
                  className={`px-2.5 py-1.5 rounded-xl text-[8px] font-black uppercase tracking-wider shrink-0 transition-all ${agendaDemoGuardada ? 'bg-emerald-500 text-white' : 'bg-slate-900 dark:bg-white text-white dark:text-slate-900 hover:scale-105'}`}
                >
                  {agendaDemoGuardada ? '✓ Agendado' : '+ Agendar'}
                </button>
              </div>
            </div>

            <div className="mt-4 pt-3 border-t border-slate-100 dark:border-white/5">
              <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-1">GPS Inteligente y Agenda</h3>
              <p className="text-slate-500 dark:text-slate-400 text-[11px] leading-relaxed">
                Abre Apple Maps o Google Maps nativamente según el celular del invitado y agenda el evento en su calendario.
              </p>
            </div>
          </RevealSection>

        </div>
      </section>

      {/* PANEL ADAPTATIVO (LA BÓVEDA INTERACTIVA EN VIVO) */}
      <section id="boveda" className="py-32 relative z-10 border-y border-slate-200 dark:border-white/5 bg-slate-50/50 dark:bg-slate-950/50 transition-colors duration-700">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row gap-14 items-center">
            
            <div className="lg:w-5/12">
              <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-xs mb-4 block flex items-center"><Lock size={14} className="mr-2"/> Tu Bóveda Privada Interactiva</span>
              <h2 className="text-5xl md:text-6xl font-editorial font-medium text-slate-900 dark:text-white mb-6 tracking-tight leading-tight transition-colors">El evento bajo tu <span className="italic text-slate-500">dominio absoluto.</span></h2>
              <p className="text-slate-600 dark:text-slate-400 text-base md:text-lg mb-8 font-light leading-relaxed transition-colors">
                Se acabó el caos de los excels y las listas perdidas. <b>Toca cualquier módulo o las pestañas de la pantalla derecha</b> para explorar tu Centro de Comando en vivo:
              </p>
              
              <div className="space-y-4">
                {[
                  { tab: 'mesas', i: <Wand2 strokeWidth={1.5}/>, t: 'Auto-Acomodo Dual (Afinidad + Tetris)', d: 'Etiqueta invitados (#Primos, #Amigos) y ponle imanes a tus mesas. El algoritmo agrupa por afinidad respetando a tus VIPs.' },
                  { tab: 'invitados', i: <Users strokeWidth={1.5}/>, t: 'Lista de Invitados, Etiquetas y Pases Extra', d: 'Envía invitaciones por WhatsApp en 1 clic, micro-etiqueta familias, aprueba pases adicionales y descarga reportes PDF/Excel.' },
                  { tab: 'escaner', i: <Scan strokeWidth={1.5}/>, t: 'Control QR de Recepción en Tiempo Real', d: 'Tu staff valida el código de cada asistente en la puerta desde su celular mostrando su mesa asignada al instante.' },
                  { tab: 'presupuesto', i: <Wallet strokeWidth={1.5}/>, t: 'Finanzas, Proveedores y Tablero Kanban', d: 'Controla tu presupuesto, registra pagos y contratos de proveedores y organiza pendientes en tu Checklist.' }
                ].map((item, idx) => {
                  const isSelected = bovedaPreviewTab === item.tab || (item.tab === 'presupuesto' && ['presupuesto', 'proveedores', 'checklist'].includes(bovedaPreviewTab));
                  return (
                    <div 
                      key={idx} 
                      onClick={() => setBovedaPreviewTab(item.tab)}
                      className={`flex items-start p-3.5 rounded-2xl border cursor-pointer transition-all ${isSelected ? 'bg-white dark:bg-[#111] border-amber-500/50 shadow-md scale-[1.01]' : 'bg-transparent border-transparent hover:bg-white/60 dark:hover:bg-white/5'}`}
                    >
                      <div className={`w-11 h-11 rounded-full border flex items-center justify-center shrink-0 mr-4 transition-colors ${isSelected ? 'bg-amber-500 text-slate-900 border-amber-400 shadow-sm' : 'bg-white dark:bg-white/5 border-slate-200 dark:border-white/10 text-slate-800 dark:text-white'}`}>
                        {item.i}
                      </div>
                      <div className="pt-0.5">
                        <h4 className="font-bold text-base text-slate-900 dark:text-slate-100 mb-0.5 transition-colors flex items-center gap-2">
                          {item.t}
                          {isSelected && <span className="text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-600 dark:text-amber-400">Activo</span>}
                        </h4>
                        <p className="text-slate-500 dark:text-slate-400 text-xs leading-relaxed transition-colors">{item.d}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              <button onClick={() => setShowPanelAnatomy(true)} className="hidden lg:flex mt-8 px-8 py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-full font-bold text-sm uppercase tracking-widest hover:scale-105 transition-all items-center justify-center shadow-xl">
                 Explorar la Bóveda a Fondo <ArrowRight size={18} className="ml-3"/>
              </button>
            </div>

            {/* 🟢 SIMULADOR INTERACTIVO DE 7 PESTAÑAS A LA DERECHA */}
            <div className="lg:w-7/12 w-full relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-indigo-500/10 dark:from-indigo-500/20 to-amber-500/10 dark:to-amber-500/20 hidden md:block blur-[120px] rounded-full pointer-events-none transition-colors"></div>
              
              {/* Indicador superior invitando a hacer clic */}
              <div className="flex items-center justify-between mb-3 px-2">
                <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-700 dark:text-amber-400 text-[10px] font-black uppercase tracking-widest">
                  <span className="w-2 h-2 rounded-full bg-amber-500 animate-ping"></span>
                  Simulador Interactivo • Toca las pestañas del menú
                </div>
                <span className="text-[10px] font-bold text-slate-400 hidden sm:inline">7 Módulos en Vivo</span>
              </div>

              <div className="bg-white/60 dark:bg-black/60 p-2 md:p-3.5 rounded-[2rem] border border-slate-200/70 dark:border-white/10 shadow-2xl dark:shadow-[0_30px_80px_rgba(0,0,0,0.8)] relative z-10 backdrop-blur-xl">
                
                <div className="bg-slate-50 dark:bg-slate-950 rounded-[1.5rem] border border-slate-200 dark:border-white/10 w-full overflow-hidden flex flex-col relative transition-colors shadow-inner h-[460px] sm:h-[510px]">
                  {/* Barra de navegador superior adaptativa */}
                  <div className="h-10 border-b border-slate-200 dark:border-white/5 flex items-center justify-between px-3 sm:px-4 gap-2 bg-white dark:bg-[#111] shrink-0 transition-colors">
                    <div className="flex items-center gap-1.5 shrink-0">
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-rose-400/80"></div>
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-amber-400/80"></div>
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-emerald-400/80"></div>
                    </div>
                    <div className="text-[9px] sm:text-[10px] font-bold text-slate-400 dark:text-slate-500 flex items-center truncate">
                      <Lock size={10} className="mr-1 text-emerald-500 shrink-0"/> <span className="truncate">panel.baulia.com/{bovedaPreviewTab}</span>
                    </div>
                    <span className="text-[8px] sm:text-[9px] font-black uppercase tracking-widest text-amber-500 whitespace-nowrap shrink-0">Diamante</span>
                  </div>
                  
                  <div className="flex-1 flex overflow-hidden select-none min-w-0">
                     {/* MENÚ LATERAL INTERACTIVO DE 7 PESTAÑAS (Sin desbordamiento de logo en móvil) */}
                     <div className="w-14 sm:w-44 border-r border-slate-200 dark:border-white/5 bg-white/80 dark:bg-[#050505]/70 flex flex-col p-2 sm:p-3.5 gap-1 transition-colors overflow-y-auto overflow-x-hidden custom-scrollbar shrink-0">
                        <div className="hidden sm:flex justify-start items-center mb-4 mt-1 px-1">
                           <BauliaLogo className="h-5 w-auto" forceWhite={isDarkMode} />
                        </div>
                        <div className="flex sm:hidden justify-center items-center mb-2 mt-1">
                           <div className="w-8 h-8 rounded-xl bg-slate-900 dark:bg-amber-500/15 border border-amber-500/40 flex items-center justify-center text-amber-500 font-editorial font-bold text-sm">
                             B
                           </div>
                        </div>
                        
                        <p className="hidden sm:block text-[8px] text-slate-400 font-black uppercase tracking-widest mt-1 mb-1 ml-2">Planeación</p>
                        {[
                          { id: 'resumen', lbl: 'Resumen', icon: <LayoutDashboard size={15}/> },
                          { id: 'checklist', lbl: 'Checklist', icon: <CheckSquare size={15}/> },
                          { id: 'presupuesto', lbl: 'Presupuesto', icon: <Wallet size={15}/> },
                          { id: 'proveedores', lbl: 'Proveedores', icon: <Store size={15}/> }
                        ].map(t => (
                          <button
                            key={t.id}
                            type="button"
                            onClick={() => setBovedaPreviewTab(t.id)}
                            className={`w-full flex items-center justify-center sm:justify-start gap-2.5 p-2 sm:px-3 sm:py-2 rounded-xl text-left transition-all ${bovedaPreviewTab === t.id ? 'bg-amber-500 text-slate-900 font-black shadow-md' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 font-medium'}`}
                          >
                            {t.icon}<span className="hidden sm:inline text-xs">{t.lbl}</span>
                          </button>
                        ))}
                        
                        <p className="hidden sm:block text-[8px] text-slate-400 font-black uppercase tracking-widest mt-3 mb-1 ml-2">Gestión</p>
                        {[
                          { id: 'invitados', lbl: 'Invitados', icon: <Users size={15}/> },
                          { id: 'mesas', lbl: 'Mesas', icon: <LayoutGrid size={15}/> }
                        ].map(t => (
                          <button
                            key={t.id}
                            type="button"
                            onClick={() => setBovedaPreviewTab(t.id)}
                            className={`w-full flex items-center justify-center sm:justify-start gap-2.5 p-2 sm:px-3 sm:py-2 rounded-xl text-left transition-all ${bovedaPreviewTab === t.id ? 'bg-amber-500 text-slate-900 font-black shadow-md' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 font-medium'}`}
                          >
                            {t.icon}<span className="hidden sm:inline text-xs">{t.lbl}</span>
                          </button>
                        ))}

                        <p className="hidden sm:block text-[8px] text-slate-400 font-black uppercase tracking-widest mt-3 mb-1 ml-2">El Día</p>
                        <button
                          type="button"
                          onClick={() => setBovedaPreviewTab('escaner')}
                          className={`w-full flex items-center justify-center sm:justify-start gap-2.5 p-2 sm:px-3 sm:py-2 rounded-xl text-left transition-all ${bovedaPreviewTab === 'escaner' ? 'bg-amber-500 text-slate-900 font-black shadow-md' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 font-medium'}`}
                        >
                          <Scan size={15}/><span className="hidden sm:inline text-xs">Control QR</span>
                        </button>
                     </div>
                     
                     {/* CONTENIDO DINÁMICO DE LAS 7 PESTAÑAS (100% Contenido en Móvil y Escritorio) */}
                     <div className="flex-1 min-w-0 p-3 sm:p-5 bg-slate-50/50 dark:bg-[#0a0a0a]/50 flex flex-col gap-3 overflow-y-auto overflow-x-hidden custom-scrollbar transition-colors">
                        
                        {/* 1. VISTA: RESUMEN */}
                        {bovedaPreviewTab === 'resumen' && (
                          <div className="flex flex-col gap-3 h-full animate-in fade-in duration-300 min-w-0">
                            <div className="flex justify-between items-center gap-2 shrink-0">
                               <div className="min-w-0">
                                 <h2 className="text-sm sm:text-xl font-black text-slate-900 dark:text-white leading-tight truncate">Centro de Mando</h2>
                                 <p className="text-[9px] sm:text-[10px] text-slate-500 mt-0.5 truncate">Monitoreo ejecutivo en tiempo real.</p>
                               </div>
                               <button type="button" onClick={() => setBovedaPreviewTab('invitados')} className="px-2.5 py-1.5 bg-slate-900 dark:bg-white/10 text-white rounded-lg text-[9px] sm:text-xs font-bold flex items-center shadow-md shrink-0">
                                 <Download size={12} className="sm:mr-1.5"/> <span className="hidden sm:inline">Reporte PDF / Excel</span>
                               </button>
                            </div>
                            
                            <div className="grid grid-cols-2 gap-2.5 shrink-0">
                               <div onClick={() => setBovedaPreviewTab('invitados')} className="bg-white dark:bg-[#111] p-3 rounded-2xl border border-slate-200 dark:border-white/5 shadow-sm flex flex-col cursor-pointer hover:border-amber-500/40 transition-colors min-w-0">
                                  <div className="flex justify-between items-start gap-1">
                                    <div className="min-w-0">
                                      <p className="text-slate-500 text-[7px] sm:text-[9px] font-black uppercase tracking-wider truncate">Pases Asignados</p>
                                      <h3 className="text-lg sm:text-3xl font-black text-slate-900 dark:text-white mt-0.5">240</h3>
                                    </div>
                                    <div className="p-1.5 bg-indigo-100 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 rounded-lg shrink-0"><Users size={14}/></div>
                                  </div>
                                  <div className="mt-2 text-[7px] sm:text-[9px] text-emerald-700 dark:text-emerald-400 bg-emerald-100 dark:bg-emerald-500/10 px-1.5 py-0.5 rounded font-bold w-max uppercase tracking-wider">95% Confirmado</div>
                               </div>

                               <div onClick={() => setBovedaPreviewTab('presupuesto')} className="bg-white dark:bg-[#111] p-3 rounded-2xl border border-slate-200 dark:border-white/5 shadow-sm flex flex-col cursor-pointer hover:border-amber-500/40 transition-colors min-w-0">
                                  <div className="flex justify-between items-start gap-1">
                                    <div className="min-w-0">
                                      <p className="text-slate-500 text-[7px] sm:text-[9px] font-black uppercase tracking-wider truncate">Presupuesto</p>
                                      <h3 className="text-lg sm:text-3xl font-black text-slate-900 dark:text-white mt-0.5">$285k</h3>
                                    </div>
                                    <div className="p-1.5 bg-amber-100 dark:bg-amber-500/10 text-amber-600 dark:text-amber-400 rounded-lg shrink-0"><Wallet size={14}/></div>
                                  </div>
                                  <div className="mt-3 w-full bg-slate-100 dark:bg-white/5 h-1.5 rounded-full overflow-hidden"><div className="bg-amber-500 h-1.5 rounded-full w-[80%]"></div></div>
                               </div>
                            </div>

                            <div className="flex-1 bg-white dark:bg-[#111] rounded-2xl border border-slate-200 dark:border-white/5 shadow-sm flex flex-col overflow-hidden min-w-0">
                               <div className="p-2.5 sm:p-3 border-b border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/5 flex justify-between items-center gap-2">
                                 <h3 className="text-[10px] sm:text-xs font-bold text-slate-800 dark:text-white flex items-center truncate"><CheckSquare size={13} className="mr-1.5 text-indigo-500 shrink-0"/> Alertas Operativas</h3>
                                 <button type="button" onClick={() => setBovedaPreviewTab('checklist')} className="text-[8px] sm:text-[9px] font-black text-amber-500 uppercase hover:underline whitespace-nowrap shrink-0">Checklist →</button>
                               </div>
                               <div className="p-2.5 sm:p-3 space-y-2">
                                 <div onClick={() => setBovedaPreviewTab('proveedores')} className="flex items-center gap-2.5 p-2 rounded-xl bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 cursor-pointer hover:border-rose-500/30">
                                   <div className="w-2 h-2 rounded-full bg-rose-500 animate-pulse shrink-0"></div>
                                   <div className="flex-1 min-w-0">
                                     <p className="text-[10px] sm:text-xs font-bold text-slate-800 dark:text-white truncate">Liquidación Banquete Hacienda</p>
                                     <p className="text-[8px] sm:text-[9px] text-slate-500 truncate">Proveedores • Finanzas</p>
                                   </div>
                                   <div className="text-[7px] sm:text-[8px] text-rose-500 font-bold bg-rose-50 dark:bg-rose-500/10 px-1.5 py-0.5 rounded border border-rose-200 dark:border-rose-500/20 whitespace-nowrap shrink-0">VENCE HOY</div>
                                 </div>
                                 <div onClick={() => setBovedaPreviewTab('mesas')} className="flex items-center gap-2.5 p-2 rounded-xl bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 cursor-pointer hover:border-amber-500/30">
                                   <div className="w-2 h-2 rounded-full bg-amber-400 shrink-0"></div>
                                   <div className="flex-1 min-w-0">
                                     <p className="text-[10px] sm:text-xs font-bold text-slate-800 dark:text-white truncate">Auto-Acomodo por Afinidad</p>
                                     <p className="text-[8px] sm:text-[9px] text-slate-500 truncate">228 de 240 lugares asignados</p>
                                   </div>
                                   <div className="text-[8px] text-emerald-500 font-black uppercase whitespace-nowrap shrink-0">Mesas →</div>
                                 </div>
                               </div>
                            </div>
                          </div>
                        )}

                        {/* 2. VISTA: CHECKLIST INTERACTIVO */}
                        {bovedaPreviewTab === 'checklist' && (
                          <div className="flex flex-col gap-3 h-full animate-in fade-in duration-300 min-w-0">
                            <div className="flex justify-between items-center gap-2">
                              <div className="min-w-0">
                                <h2 className="text-sm sm:text-lg font-black text-slate-900 dark:text-white truncate">Tablero de Actividades</h2>
                                <p className="text-[9px] sm:text-[10px] text-slate-500 truncate">Toca una tarea para marcarla como lista.</p>
                              </div>
                              <span className="px-2 py-1 rounded-lg bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 text-[9px] font-black whitespace-nowrap shrink-0">
                                {bovedaChecklistDemo.filter(t => t.done).length}/{bovedaChecklistDemo.length} Listas
                              </span>
                            </div>

                            <div className="space-y-2 my-auto">
                              {bovedaChecklistDemo.map(tarea => (
                                <div 
                                  key={tarea.id}
                                  onClick={() => setBovedaChecklistDemo(prev => prev.map(item => item.id === tarea.id ? { ...item, done: !item.done } : item))}
                                  className={`p-3 rounded-2xl border flex items-center justify-between gap-2 cursor-pointer transition-all ${tarea.done ? 'bg-emerald-50/40 dark:bg-emerald-500/5 border-emerald-500/20 opacity-75' : 'bg-white dark:bg-[#111] border-slate-200 dark:border-white/10 hover:border-amber-500/40 shadow-sm'}`}
                                >
                                  <div className="flex items-center gap-2.5 min-w-0">
                                    <div className={`w-4 h-4 sm:w-5 sm:h-5 rounded-md flex items-center justify-center border transition-colors shrink-0 ${tarea.done ? 'bg-emerald-500 border-emerald-500 text-white' : 'border-slate-300 dark:border-white/20'}`}>
                                      {tarea.done && <Check size={11}/>}
                                    </div>
                                    <div className="min-w-0">
                                      <p className={`text-[11px] sm:text-xs font-bold leading-snug ${tarea.done ? 'line-through text-slate-400' : 'text-slate-800 dark:text-white'}`}>{tarea.t}</p>
                                      <span className="text-[8px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400">{tarea.cat}</span>
                                    </div>
                                  </div>
                                  <span className={`text-[7px] sm:text-[8px] font-black uppercase px-1.5 py-0.5 rounded shrink-0 ${tarea.done ? 'bg-emerald-500/10 text-emerald-500' : 'bg-amber-500/10 text-amber-500'}`}>
                                    {tarea.done ? 'Listo' : 'Activo'}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* 3. VISTA: PRESUPUESTO (3 columnas calibradas sin desbordamiento en móvil) */}
                        {bovedaPreviewTab === 'presupuesto' && (
                          <div className="flex flex-col gap-3 h-full animate-in fade-in duration-300 min-w-0">
                            <div>
                              <h2 className="text-sm sm:text-lg font-black text-slate-900 dark:text-white">Bóveda Financiera</h2>
                              <p className="text-[9px] sm:text-[10px] text-slate-500">Control de anticipos, liquidaciones y saldo.</p>
                            </div>

                            <div className="grid grid-cols-3 gap-1.5 sm:gap-2.5">
                              <div className="bg-white dark:bg-[#111] p-2 sm:p-3 rounded-xl sm:rounded-2xl border border-slate-200 dark:border-white/10 min-w-0">
                                <p className="text-[7px] sm:text-[8px] font-black uppercase text-slate-400 truncate">Presupuesto</p>
                                <p className="text-[11px] sm:text-base font-black text-slate-900 dark:text-white mt-0.5 truncate">$350,000</p>
                              </div>
                              <div className="bg-white dark:bg-[#111] p-2 sm:p-3 rounded-xl sm:rounded-2xl border border-amber-500/20 min-w-0">
                                <p className="text-[7px] sm:text-[8px] font-black uppercase text-amber-500 truncate">Pagado</p>
                                <p className="text-[11px] sm:text-base font-black text-amber-500 mt-0.5 truncate">$285,000</p>
                              </div>
                              <div className="bg-white dark:bg-[#111] p-2 sm:p-3 rounded-xl sm:rounded-2xl border border-emerald-500/20 min-w-0">
                                <p className="text-[7px] sm:text-[8px] font-black uppercase text-emerald-500 truncate">Disponible</p>
                                <p className="text-[11px] sm:text-base font-black text-emerald-500 mt-0.5 truncate">$65,000</p>
                              </div>
                            </div>

                            <div className="bg-white dark:bg-[#111] rounded-2xl border border-slate-200 dark:border-white/10 p-3 space-y-2 my-auto">
                              {[
                                { c: 'Hacienda & Banquete VIP', m: '$180,000', st: 'Liquidado', col: 'text-emerald-500' },
                                { c: 'Producción Floral y Diseño', m: '$65,000', st: 'Anticipo 70%', col: 'text-amber-500' },
                                { c: 'Fotografía, Video y DJ', m: '$40,000', st: 'Liquidado', col: 'text-emerald-500' }
                              ].map((g, i) => (
                                <div key={i} className="flex items-center justify-between gap-2 text-[11px] sm:text-xs border-b border-slate-100 dark:border-white/5 last:border-0 pb-2 last:pb-0">
                                  <div className="min-w-0">
                                    <p className="font-bold text-slate-800 dark:text-white truncate">{g.c}</p>
                                    <p className={`text-[8px] sm:text-[9px] font-black uppercase ${g.col}`}>{g.st}</p>
                                  </div>
                                  <span className="font-black text-slate-900 dark:text-white shrink-0">{g.m}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* 4. VISTA: PROVEEDORES */}
                        {bovedaPreviewTab === 'proveedores' && (
                          <div className="flex flex-col gap-3 h-full animate-in fade-in duration-300 min-w-0">
                            <div>
                              <h2 className="text-sm sm:text-lg font-black text-slate-900 dark:text-white">Directorio de Proveedores</h2>
                              <p className="text-[9px] sm:text-[10px] text-slate-500">Contratos, WhatsApp directo y saldos.</p>
                            </div>

                            <div className="space-y-2 my-auto">
                              {[
                                { n: 'Hacienda San Gabriel', rub: 'Locación & Catering', sal: 'Pagado 100%', ok: true },
                                { n: 'Atelier Botánico Floral', rub: 'Decoración y Flores', sal: 'Restan $19,500', ok: false },
                                { n: 'String Quartet & DJ Pro', rub: 'Música e Iluminación', sal: 'Pagado 100%', ok: true }
                              ].map((p, i) => (
                                <div key={i} className="p-3 rounded-2xl bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10 flex items-center justify-between gap-2">
                                  <div className="min-w-0">
                                    <p className="text-[11px] sm:text-xs font-bold text-slate-900 dark:text-white truncate">{p.n}</p>
                                    <p className="text-[8px] sm:text-[9px] text-slate-400 truncate">{p.rub}</p>
                                  </div>
                                  <div className="flex items-center gap-1.5 shrink-0">
                                    <span className={`text-[8px] font-black uppercase px-2 py-1 rounded-md whitespace-nowrap ${p.ok ? 'bg-emerald-500/10 text-emerald-500' : 'bg-amber-500/10 text-amber-500'}`}>
                                      {p.sal}
                                    </span>
                                    <span className="p-1.5 rounded-lg bg-emerald-500/10 text-emerald-500"><MessageCircle size={12}/></span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* 5. VISTA: INVITADOS (Nombres 100% visibles en móvil y escritorio) */}
                        {bovedaPreviewTab === 'invitados' && (
                          <div className="flex flex-col gap-3 h-full animate-in fade-in duration-300 min-w-0">
                            <div className="flex justify-between items-center gap-2">
                              <div className="min-w-0">
                                <h2 className="text-sm sm:text-lg font-black text-slate-900 dark:text-white truncate">Gestión de Invitados</h2>
                                <p className="text-[9px] sm:text-[10px] text-slate-500 truncate">Etiquetas de afinidad, mesas y QRs.</p>
                              </div>
                              <span className="px-2 py-1 rounded-lg bg-amber-500/10 text-amber-500 text-[8px] sm:text-[9px] font-black uppercase border border-amber-500/20 whitespace-nowrap shrink-0">
                                228 Confirmados
                              </span>
                            </div>

                            <div className="space-y-2 my-auto">
                              {[
                                { n: 'Familia Montemayor', tag: '#FamiliaVIP', p: '4 Pases', m: 'Mesa 1', st: 'CONFIRMADO' },
                                { n: 'Jóvenes Villarreal', tag: '#Primos', p: '3 Pases', m: 'Mesa 2', st: 'CONFIRMADO' },
                                { n: 'Grupo Universidad', tag: '#AmigosNovio', p: '4 Pases', m: 'Mesa 2', st: 'EN EVENTO' }
                              ].map((inv, i) => (
                                <div key={i} className="p-2.5 sm:p-3 rounded-2xl bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10 flex flex-col sm:flex-row sm:items-center justify-between gap-1.5 sm:gap-2">
                                  <div className="min-w-0">
                                    <p className="text-[11px] sm:text-xs font-bold text-slate-900 dark:text-white leading-snug">{inv.n}</p>
                                    <div className="flex items-center gap-1.5 mt-0.5 flex-wrap">
                                      <span className="px-1.5 py-0.5 rounded text-[7px] sm:text-[8px] font-bold bg-indigo-500/10 text-indigo-500 dark:text-indigo-400 border border-indigo-500/20">{inv.tag}</span>
                                      <span className="text-[8px] sm:text-[9px] text-slate-400">{inv.p} • <b className="text-amber-500">{inv.m}</b></span>
                                    </div>
                                  </div>
                                  <div className="flex items-center justify-between sm:justify-end gap-1.5 shrink-0 pt-1 sm:pt-0 border-t sm:border-t-0 border-slate-100 dark:border-white/5">
                                    <span className="p-1 rounded-lg bg-indigo-500/10 text-indigo-400"><QrCode size={12}/></span>
                                    <span className="px-2 py-0.5 rounded-md bg-emerald-500 text-white text-[7px] sm:text-[8px] font-black uppercase">{inv.st}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* 6. VISTA: MESAS Y AUTO-ACOMODO POR AFINIDAD */}
                        {bovedaPreviewTab === 'mesas' && (
                          <div className="flex flex-col gap-2.5 h-full animate-in fade-in duration-300 min-w-0">
                            <div className="flex justify-between items-center gap-2">
                              <div className="min-w-0">
                                <h2 className="text-sm sm:text-lg font-black text-slate-900 dark:text-white truncate">Mesas e Imanes</h2>
                                <p className="text-[9px] sm:text-[10px] text-slate-500 truncate">Agrupación por etiquetas y Tetris.</p>
                              </div>
                              <span className="px-2 py-1 rounded-lg bg-emerald-500/15 text-emerald-500 text-[8px] sm:text-[9px] font-black uppercase flex items-center gap-1 shrink-0">
                                <Wand2 size={10}/> Optimizado
                              </span>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 my-auto">
                              <div className="p-3 rounded-2xl bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10">
                                <div className="flex justify-between items-center mb-1">
                                  <span className="font-bold text-xs text-slate-900 dark:text-white">Mesa 1 • Redonda</span>
                                  <span className="text-[9px] font-black text-emerald-500">10/10</span>
                                </div>
                                <span className="inline-block text-[7px] sm:text-[8px] font-black uppercase px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-500 border border-emerald-500/20 mb-2">
                                  📌 VIP / Familia Directa
                                </span>
                                <div className="space-y-1 text-[9px] text-slate-500 dark:text-slate-400">
                                  <div className="p-1.5 rounded bg-slate-50 dark:bg-black flex justify-between"><span>Papás de los Novios</span><b>(4)</b></div>
                                  <div className="p-1.5 rounded bg-slate-50 dark:bg-black flex justify-between"><span>Fam. Montemayor</span><b>(6)</b></div>
                                </div>
                              </div>

                              <div className="p-3 rounded-2xl bg-white dark:bg-[#111] border border-slate-200 dark:border-white/10">
                                <div className="flex justify-between items-center mb-1">
                                  <span className="font-bold text-xs text-slate-900 dark:text-white">Mesa 2 • Tablón</span>
                                  <span className="text-[9px] font-black text-amber-500">10/10</span>
                                </div>
                                <span className="inline-block text-[7px] sm:text-[8px] font-black uppercase px-2 py-0.5 rounded bg-amber-500/10 text-amber-500 border border-amber-500/20 mb-2">
                                  🧲 Imán: #Primos + #Amigos
                                </span>
                                <div className="space-y-1 text-[9px] text-slate-500 dark:text-slate-400">
                                  <div className="p-1.5 rounded bg-slate-50 dark:bg-black flex justify-between"><span>Jóvenes Villarreal</span><b>(5)</b></div>
                                  <div className="p-1.5 rounded bg-slate-50 dark:bg-black flex justify-between"><span>Grupo Universidad</span><b>(5)</b></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* 7. VISTA: CONTROL QR DE PUERTA EN VIVO (Sin desbordamiento lateral en móvil) */}
                        {bovedaPreviewTab === 'escaner' && (
                          <div className="flex flex-col gap-3 h-full animate-in fade-in duration-300 min-w-0">
                            <div className="flex flex-wrap justify-between items-center gap-2">
                              <div className="min-w-0">
                                <h2 className="text-sm sm:text-lg font-black text-slate-900 dark:text-white truncate">Escáner QR de Recepción</h2>
                                <p className="text-[9px] sm:text-[10px] text-slate-500 truncate">Simula el escaneo en puerta en vivo.</p>
                              </div>
                              <button
                                type="button"
                                onClick={() => setBovedaScanCount(c => c < 240 ? c + 1 : 184)}
                                className="px-2.5 py-1.5 rounded-xl bg-amber-500 text-slate-900 text-[8px] sm:text-[9px] font-black uppercase tracking-wider shadow-md active:scale-95 transition-transform shrink-0"
                              >
                                + Simular Escaneo QR
                              </button>
                            </div>

                            <div className="my-auto p-3.5 rounded-2xl bg-white dark:bg-[#111] border border-emerald-500/30 flex flex-col sm:flex-row sm:items-center justify-between gap-3 shadow-md">
                              <div className="flex items-center gap-2.5 min-w-0">
                                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-2xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center text-emerald-500 shrink-0">
                                  <CheckCircle size={22}/>
                                </div>
                                <div className="min-w-0">
                                  <span className="block text-[7px] sm:text-[8px] font-black uppercase tracking-widest text-emerald-500">Acceso Concedido • QR Válido</span>
                                  <h4 className="text-xs sm:text-sm font-black text-slate-900 dark:text-white truncate">Alejandro Montemayor</h4>
                                  <p className="text-[9px] sm:text-[10px] font-bold text-amber-500 truncate">Dirigir a: Mesa 1 VIP (Pase 1 de 4)</p>
                                </div>
                              </div>
                              <div className="flex sm:flex-col items-center sm:items-end justify-between border-t sm:border-t-0 border-slate-100 dark:border-white/5 pt-2 sm:pt-0 shrink-0">
                                <p className="text-[8px] font-black uppercase text-slate-400">Aforo Adentro</p>
                                <p className="text-base sm:text-xl font-black text-emerald-500">{bovedaScanCount}/240</p>
                              </div>
                            </div>
                          </div>
                    )}

                   </div>
                 </div>
               </div>

               {/* Botón al final de la sección en versión móvil */}
               <div className="mt-6 flex lg:hidden justify-center">
                 <button type="button" onClick={() => setShowPanelAnatomy(true)} className="w-full sm:w-auto px-8 py-4 bg-slate-900 dark:bg-white text-white dark:text-slate-900 rounded-full font-bold text-xs uppercase tracking-widest hover:scale-105 transition-all flex items-center justify-center shadow-xl">
                   Explorar la Bóveda a Fondo <ArrowRight size={16} className="ml-2.5"/>
                 </button>
               </div>
             </div>
           </div>

         </div>
       </div>
     </section>

      {/* ========================================== */}
      {/* 🔴 PASO 4A: BAULIA SOCIAL WALL (DISEÑO DESPEJADO Y PULIDO EN MÓVIL Y ESCRITORIO) */}
      {/* ========================================== */}
      <section id="muro-social" className="py-24 sm:py-28 bg-indigo-50/70 dark:bg-[#07070b] relative overflow-hidden transition-colors duration-700 border-t border-indigo-200/70 dark:border-white/5">
        <style>{`
          @keyframes bauliaHeartFloat {
            0% { transform: translateY(0) scale(0.6) rotate(0deg); opacity: 1; }
            50% { transform: translateY(-110px) scale(1.25) rotate(-8deg); opacity: 0.95; }
            100% { transform: translateY(-220px) scale(0.9) rotate(10deg); opacity: 0; }
          }
        `}</style>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] bg-indigo-500/10 hidden md:block blur-[150px] rounded-full pointer-events-none"></div>

        <div className="max-w-[1400px] mx-auto px-4 md:px-8 relative z-10 flex flex-col items-center">
            
          {/* CABECERA CON INSIGNIA ESTILIZADA EN DORADO Y NEGRO */}
          <RevealSection className="text-center mb-10 sm:mb-12 max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-[#141210] backdrop-blur-md px-4 py-2 rounded-full border border-[#D4AF37]/40 shadow-sm mb-5">
              <Gem size={14} className="text-[#D4AF37] shrink-0" />
              <span className="text-[#D4AF37] font-black uppercase tracking-[0.2em] text-[9px] sm:text-[10px] whitespace-nowrap">
                Incluido en el Plan Diamante
              </span>
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-editorial font-medium text-white mb-5 tracking-tight leading-tight">
              Baulia Social Wall.<br/>
              <span className="italic text-[#D4AF37] pr-1">Tus invitados son los fotógrafos.</span>
            </h2>
            <p className="text-slate-600 dark:text-slate-400 text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-2xl mx-auto">
              Convierte las pantallas de tu salón en un espectáculo interactivo sin instalar aplicaciones. Tus invitados <b>suben fotos al instante, cumplen retos divertidos, comentan en pantalla y desatan lluvias de corazones en vivo</b> con cada like. Úsalo en <b>Modo Público</b> (escaneando el QR de su mesa) o en <b>Modo Privado</b> (validando su pase o pulsera Black Label), y <b>recibe tu software junto con tus tarjetas impresas en una Caja VIP de colección en la puerta de tu casa completamente gratis</b>.
            </p>
          </RevealSection>

          {/* CONSOLA MAESTRA UNIFICADA SOCIAL WALL */}
          <RevealSection delay={150} className="w-full bg-white/95 dark:bg-[#0d0d12] rounded-[2.2rem] sm:rounded-[3rem] p-4 sm:p-8 md:p-10 border border-indigo-200/80 dark:border-white/10 shadow-2xl">
            
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 items-stretch">
              
              {/* MÓDULO 1: PROYECTOR INTERACTIVO EN VIVO */}
              <div className="lg:col-span-7 bg-slate-50 dark:bg-[#14141c] rounded-[1.8rem] p-4 sm:p-6 border border-indigo-100 dark:border-white/10 flex flex-col justify-between">
                <div>
                  {/* Encabezado limpio + Selector de Fotos */}
                  <div className="flex flex-wrap items-center justify-between gap-2 pb-3.5 mb-3.5 border-b border-slate-200/80 dark:border-white/10">
                    <div>
                      <span className="text-[9px] font-black uppercase tracking-widest text-emerald-600 dark:text-emerald-400 block">
                        Prueba el Software en Vivo
                      </span>
                      <h3 className="text-lg sm:text-2xl font-bold text-slate-900 dark:text-white">
                        Pantalla Gigante Interactiva
                      </h3>
                    </div>

                    <div className="flex items-center gap-1.5">
                      {[1, 2].map(num => (
                        <button
                          key={num}
                          type="button"
                          onClick={() => setSocialFotoActiva(num)}
                          className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl border text-[10px] font-black uppercase tracking-wider transition-all ${socialFotoActiva === num ? 'bg-indigo-600 text-white border-indigo-500 shadow-md' : 'bg-white dark:bg-black/50 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-white/10'}`}
                        >
                          <img 
                            src={`/social${num}.jpg`} 
                            alt={`Foto ${num}`} 
                            className="w-4 h-4 rounded object-cover"
                            onError={(e) => { e.target.src = '/demos/boda/foto2.jpg'; }}
                          />
                          Foto #{num}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Cola de Moderación del DJ (Botón debajo en móvil para que el texto luzca amplio y ordenado) */}
                  <div className="bg-white dark:bg-[#0a0a0f] p-3 rounded-2xl border border-slate-200/80 dark:border-white/10 flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 mb-3.5 shadow-sm">
                    <div className="flex items-center gap-2.5 min-w-0">
                      <img 
                        src={socialFotoActiva === 1 ? '/social2.jpg' : '/social1.jpg'} 
                        alt="En cola de moderación" 
                        className="w-10 h-10 rounded-xl object-cover border border-indigo-500/30 shrink-0"
                        onError={(e) => { e.target.src = '/demos/boda/foto4.jpg'; }}
                      />
                      <div className="min-w-0">
                        <span className="text-[8px] font-black uppercase tracking-widest text-indigo-600 dark:text-indigo-400 block">
                          En Cola del DJ • Lista para proyectar
                        </span>
                        <p className="text-xs font-bold text-slate-900 dark:text-white leading-snug">
                          {socialFotoActiva === 1 ? 'Foto #2 • Amigos Universidad (Mesa 4)' : 'Foto #1 • Familia Montemayor (Mesa 1)'}
                        </p>
                      </div>
                    </div>
                    <button 
                      type="button"
                      onClick={() => setSocialFotoActiva(prev => prev === 1 ? 2 : 1)}
                      className="w-full sm:w-auto py-2 px-3.5 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-black text-[9px] uppercase tracking-widest flex items-center justify-center gap-1.5 shadow-sm active:scale-95 transition-all shrink-0"
                    >
                      <Check size={13}/> Proyectar en pantalla
                    </button>
                  </div>
                </div>

                {/* Franja del Reto Activo (Fuera de la foto para no tapar los rostros) */}
                <div className="flex items-center justify-between gap-2 px-3 py-1.5 rounded-t-2xl bg-slate-900 text-amber-300 border-x border-t border-indigo-500/30 text-[9px] font-black uppercase tracking-wider">
                  <span className="truncate">{socialRetoActivo}</span>
                  <span className="text-emerald-400 flex items-center gap-1 shrink-0">
                    <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-ping"></span> En Vivo
                  </span>
                </div>

                {/* PANTALLA DEL PROYECTOR DESPEJADA (La foto luce limpia y completa) */}
                <div className="relative w-full aspect-[4/3] sm:aspect-video bg-slate-950 rounded-b-2xl border-x-2 border-b-2 border-indigo-500/40 shadow-xl overflow-hidden group select-none">
                  <img 
                    key={socialFotoActiva}
                    src={`/social${socialFotoActiva}.jpg`} 
                    alt="Proyección Social Wall en Vivo" 
                    className="absolute inset-0 w-full h-full object-cover animate-in fade-in duration-500"
                    onError={(e) => { e.target.src = '/demos/boda/foto2.jpg'; }}
                  />
                  {/* Degradado sutil únicamente en la base para leer el comentario sin tapar la foto */}
                  <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/85 via-black/40 to-transparent pointer-events-none"></div>

                  {/* LLUVIA DE CORAZONES EN VIVO */}
                  <div className="absolute inset-0 pointer-events-none overflow-hidden z-20">
                    {socialHeartRain.map(h => (
                      <span
                        key={h.id}
                        style={{
                          left: `${h.left}%`,
                          bottom: '16%',
                          animation: `bauliaHeartFloat 1.5s ease-out ${h.delay}s forwards`
                        }}
                        className="absolute text-2xl sm:text-3xl drop-shadow-[0_4px_10px_rgba(244,63,94,0.6)]"
                      >
                        {h.emoji}
                      </span>
                    ))}
                  </div>

                  {/* Botón compacto de Like en la esquina superior derecha */}
                  <button
                    type="button"
                    onClick={dispararLluviaCorazones}
                    className="absolute top-2.5 right-2.5 z-30 bg-rose-500/95 hover:bg-rose-600 text-white px-3 py-1 rounded-full text-[11px] font-black flex items-center gap-1 shadow-lg active:scale-90 transition-all"
                  >
                    <Heart size={12} className="fill-white"/> 
                    <span>{socialFotosData[socialFotoActiva].likes}</span>
                    <span className="text-[8px] uppercase tracking-wider ml-0.5">Like</span>
                  </button>

                  {/* Comentario limpio al pie de la foto sin cajas invasivas */}
                  <div className="absolute bottom-2.5 left-3 right-3 z-30 flex items-center justify-between gap-2 text-left">
                    <div className="min-w-0">
                      <p className="text-white/90 font-bold text-[10px] sm:text-xs leading-none truncate drop-shadow">
                        {socialFotosData[socialFotoActiva].autor}
                      </p>
                      <p className="text-amber-300 font-medium text-xs sm:text-sm italic truncate mt-0.5 drop-shadow">
                        "{socialFotosData[socialFotoActiva].comentario}"
                      </p>
                    </div>
                  </div>
                </div>

                {/* Controles debajo del proyector: Cambiar Reto y Comentar */}
                <div className="mt-3.5 space-y-2.5">
                  <div className="flex items-center gap-1.5 overflow-x-auto hide-scrollbar py-0.5">
                    <span className="text-[8.5px] font-black uppercase tracking-wider text-slate-400 shrink-0">Retos:</span>
                    {[
                      '📸 Reto: Selfie de toda la mesa',
                      '🕺 Reto: El más bailador',
                      '🥂 Reto: Brindis con los novios'
                    ].map((reto, idx) => (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => setSocialRetoActivo(reto)}
                        className={`px-2.5 py-1 rounded-lg text-[9px] font-bold whitespace-nowrap transition-all border ${socialRetoActivo === reto ? 'bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/40' : 'bg-white dark:bg-black/40 text-slate-500 border-slate-200 dark:border-white/10'}`}
                      >
                        {reto}
                      </button>
                    ))}
                  </div>

                  <form onSubmit={enviarComentarioSocial} className="flex items-center gap-2">
                    <input
                      type="text"
                      value={socialNuevoComentario}
                      onChange={(e) => setSocialNuevoComentario(e.target.value)}
                      placeholder={`Comentar la Foto #${socialFotoActiva}...`}
                      className="flex-1 min-w-0 bg-white dark:bg-[#09090d] border border-slate-200 dark:border-white/10 rounded-xl px-3.5 py-2.5 text-xs text-slate-900 dark:text-white focus:border-indigo-500 outline-none"
                    />
                    <button
                      type="submit"
                      className="px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white font-black text-[10px] uppercase tracking-wider shrink-0 shadow-md active:scale-95 transition-transform"
                    >
                      Publicar
                    </button>
                  </form>
                </div>
              </div>

              {/* MÓDULO 2: TARJETAS DE MESA IMPRESAS + MODO PÚBLICO / PRIVADO */}
              <div className="lg:col-span-5 bg-slate-50 dark:bg-[#14141c] rounded-[1.8rem] p-4 sm:p-6 border border-indigo-100 dark:border-white/10 flex flex-col justify-between">
                <div>
                  <div className="flex flex-wrap items-center justify-between gap-2 pb-3.5 mb-3.5 border-b border-slate-200/80 dark:border-white/10">
                    <div>
                      <span className="text-[9px] font-black uppercase tracking-widest text-indigo-600 dark:text-indigo-400 block">
                        Kit Físico Incluido • Taller Baulia
                      </span>
                      <h3 className="text-lg sm:text-2xl font-bold text-slate-900 dark:text-white">
                        Tarjetas para tus Mesas
                      </h3>
                    </div>

                    <div className="flex items-center gap-1 bg-white dark:bg-black/60 p-1 rounded-xl border border-slate-200 dark:border-white/10">
                      {[
                        { id: 'obsidiana', lbl: 'Obsidiana' },
                        { id: 'marfil', lbl: 'Marfil' },
                        { id: 'champagne', lbl: 'Champagne' }
                      ].map(fin => (
                        <button
                          key={fin.id}
                          type="button"
                          onClick={() => setSocialCardFinish(fin.id)}
                          className={`px-2 py-1 rounded-lg text-[8.5px] font-black uppercase tracking-wider transition-all ${socialCardFinish === fin.id ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-500 hover:text-slate-800 dark:hover:text-white'}`}
                        >
                          {fin.lbl}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Selector de Modalidad de Privacidad */}
                  <div className="mb-4">
                    <div className="grid grid-cols-2 gap-1.5 p-1 bg-white dark:bg-black/50 rounded-xl border border-slate-200 dark:border-white/10">
                      <button
                        type="button"
                        onClick={() => setSocialModoAcceso('publico')}
                        className={`py-2 px-2 rounded-lg text-[9px] font-black uppercase tracking-wider transition-all ${socialModoAcceso === 'publico' ? 'bg-indigo-600 text-white shadow-sm' : 'text-slate-500'}`}
                      >
                        🔓 Modo Público (QR Mesa)
                      </button>
                      <button
                        type="button"
                        onClick={() => setSocialModoAcceso('privado')}
                        className={`py-2 px-2 rounded-lg text-[9px] font-black uppercase tracking-wider transition-all ${socialModoAcceso === 'privado' ? 'bg-amber-500 text-slate-950 shadow-sm' : 'text-slate-500'}`}
                      >
                        🔐 Modo Privado (Con Pase)
                      </button>
                    </div>
                    <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                      {socialModoAcceso === 'publico'
                        ? 'En Modo Público, cualquier invitado en su mesa escanea esta tarjeta y sube fotos, likes y comentarios al instante.'
                        : 'En Modo Privado, el sistema solicita escanear su Pase QR o Pulsera Black Label para identificar a quien sube cada foto.'}
                    </p>
                  </div>

                  {/* Tarjeta Física Personalizable */}
                  <div className="py-2 flex justify-center">
                    <div className={`w-full max-w-[235px] rounded-3xl p-5 border-2 shadow-2xl transition-all duration-500 flex flex-col items-center text-center relative ${
                      socialCardFinish === 'obsidiana'
                        ? 'bg-[#09090d] text-white border-amber-500/40'
                        : socialCardFinish === 'marfil'
                        ? 'bg-[#FDFBF7] text-slate-900 border-[#D4AF37]/50'
                        : 'bg-gradient-to-b from-[#fdf6e9] to-[#f5e6c8] text-slate-900 border-amber-600/40'
                    }`}>
                      <span className="text-[7px] font-black uppercase tracking-[0.28em] text-amber-500 mb-1">
                        Boda Civil & Religiosa
                      </span>
                      <h4 className="font-editorial font-bold text-xl leading-none mb-1">
                        Sofía & Alejandro
                      </h4>
                      <p className={`text-[8px] uppercase tracking-widest mb-3 ${socialCardFinish === 'obsidiana' ? 'text-slate-400' : 'text-slate-500'}`}>
                        {socialModoAcceso === 'publico' ? 'Escanea, sube fotos y cumple los retos' : 'Acceso Privado • Valida tu Pase o Pulsera'}
                      </p>

                      <div className="bg-white p-2.5 rounded-2xl shadow-inner border border-amber-500/30 w-28 h-28 flex items-center justify-center relative">
                        <svg viewBox="0 0 100 100" className="w-full h-full text-slate-900">
                          <rect x="6" y="6" width="26" height="26" rx="5" fill="none" stroke="currentColor" strokeWidth="5"/>
                          <rect x="13" y="13" width="12" height="12" rx="2.5" fill="currentColor"/>
                          
                          <rect x="68" y="6" width="26" height="26" rx="5" fill="none" stroke="currentColor" strokeWidth="5"/>
                          <rect x="75" y="13" width="12" height="12" rx="2.5" fill="currentColor"/>
                          
                          <rect x="6" y="68" width="26" height="26" rx="5" fill="none" stroke="currentColor" strokeWidth="5"/>
                          <rect x="13" y="75" width="12" height="12" rx="2.5" fill="currentColor"/>

                          {[
                            [42,10],[50,10],[58,10],[42,18],[54,18],[46,26],[58,26],
                            [10,42],[18,42],[26,42],[14,50],[24,50],[10,58],[20,58],
                            [72,42],[82,42],[90,42],[76,50],[88,50],[72,58],[84,58],
                            [42,72],[52,72],[62,72],[72,72],[84,72],[46,82],[58,82],[70,82],[88,82],[42,90],[54,90],[66,90],[78,90]
                          ].map(([cx, cy], idx) => (
                            <circle key={idx} cx={cx} cy={cy} r="3.2" fill="currentColor" />
                          ))}

                          <rect x="36" y="36" width="28" height="28" rx="7" fill="#0f172a" stroke="#f59e0b" strokeWidth="2.5"/>
                          <text x="50" y="54" textAnchor="middle" fill="#f59e0b" fontSize="11" fontWeight="bold" fontFamily="serif">S&A</text>
                        </svg>
                      </div>

                      <span className="mt-3 text-[8px] font-black uppercase tracking-widest px-3 py-1 rounded-full bg-indigo-600 text-white shadow-sm">
                        📱 Cero Apps • Subida Instantánea
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-4 p-3.5 rounded-2xl bg-white dark:bg-black/40 border border-indigo-200/70 dark:border-white/10 flex items-start gap-3">
                  <div className="w-8 h-8 rounded-xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-500 shrink-0 mt-0.5">
                    <Gift size={16}/>
                  </div>
                  <p className="text-[11px] sm:text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
                    <b>Impresión y Envío Gratis:</b> Personalízalas con tu logo en el panel y recíbelas impresas en papel de alto gramaje dentro de tu <b>Caja VIP Baulia</b>.
                  </p>
                </div>
              </div>

            </div>

            {/* BARRA INFERIOR DE COMPRA CON BOTÓN EN DORADO IMPERIAL */}
            <div className="mt-7 pt-5 border-t border-[#D4AF37]/20 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-center sm:text-left">
                <span className="text-[10px] font-black uppercase tracking-widest text-[#D4AF37] block">
                  Software en Vivo + Tarjetas Impresas + Envío Gratis
                </span>
                <p className="text-xs text-slate-400 mt-0.5">
                  Incluido sin costo al contratar el <b>Plan Diamante</b> o actívalo de forma independiente.
                </p>
              </div>
              <button 
                type="button"
                onClick={() => { setPlanSeleccionado({ plan: 'Social Wall', precio: pSocialWall.raw[moneda], moneda: moneda }); setCheckoutModal('pago'); }} 
                className="w-full sm:w-auto px-8 py-4 bg-[#D4AF37] hover:bg-[#e3be42] text-[#1C1917] rounded-2xl font-black text-xs sm:text-sm uppercase tracking-widest hover:scale-[1.02] transition-all flex items-center justify-center shadow-[0_10px_30px_rgba(212,175,55,0.35)] shrink-0"
              >
                <Camera size={17} className="mr-2 text-[#1C1917] shrink-0" /> Activar por ${pSocialWall.precios[moneda]} {moneda}
              </button>
            </div>

          </RevealSection>
        </div>
      </section>

      {/* ========================================== */}
      {/* 🔴 PASO 4B: BAULIA BLACK LABEL (DISEÑO DESAHOGADO, ELEGANTE Y CON BOTÓN LIMPIO AL FINAL) */}
      {/* ========================================== */}
      <section id="black-label" className="py-24 sm:py-28 bg-slate-50 dark:bg-[#050505] text-slate-900 dark:text-white relative overflow-hidden transition-colors duration-700 border-t border-slate-200 dark:border-white/5">
        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[60vw] h-[60vw] bg-amber-500/5 hidden md:block blur-[150px] rounded-full pointer-events-none"></div>

        <div className="max-w-[1400px] mx-auto px-4 md:px-8 relative z-10 flex flex-col items-center">
          
          {/* CABECERA CON INSIGNIA ESTILIZADA EN UN SOLO RENGLÓN */}
          <RevealSection className="text-center mb-10 sm:mb-12 max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-white/90 dark:bg-[#111]/90 backdrop-blur-md px-4 py-2 rounded-full border border-amber-300 dark:border-amber-500/30 shadow-sm mb-5">
              <Gem size={14} className="text-amber-500 shrink-0" />
              <span className="text-amber-700 dark:text-amber-400 font-black uppercase tracking-[0.2em] text-[9px] sm:text-[10px] whitespace-nowrap">
                Incluido en el Plan Diamante
              </span>
            </div>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-editorial font-medium text-slate-900 dark:text-white mb-5 tracking-tight leading-tight">
              Baulia Black Label.<br/>
              <span className="italic text-amber-500 pr-1">Control de Acceso & Brazaletes VIP.</span>
            </h2>
            <p className="text-slate-600 dark:text-slate-400 text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-2xl mx-auto">
              Olvídate de los colados y los invitados inesperados. Toma el control absoluto de las entradas de tu evento con <b>cero filas</b>: al pasar por la puerta, cada asistente queda acreditado en una fracción de segundo sabiendo exactamente qué mesa le corresponde. Dale ese toque de exclusividad blindada a <b>bodas, XV años, fiestas privadas, convenciones, conciertos o festivales</b>, y <b>recibe tu software junto con tu kit en una Caja VIP de colección en la puerta de tu casa completamente gratis</b>.
            </p>
          </RevealSection>

          {/* CONSOLA MAESTRA UNIFICADA BLACK LABEL (Espacios amplios y desahogados en móvil) */}
          <RevealSection delay={150} className="w-full bg-white dark:bg-[#0b0b0b] rounded-[2.2rem] sm:rounded-[3rem] p-4 sm:p-8 md:p-10 border border-slate-200 dark:border-white/10 shadow-2xl">
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-stretch">
              
              {/* MÓDULO 1: BRAZALETES VIP PERSONALIZADOS (Sin bordes redundantes que aprieten en móvil) */}
              <div className="bg-slate-50 dark:bg-[#121212] rounded-[1.8rem] p-4 sm:p-7 border border-slate-200/80 dark:border-white/10 flex flex-col justify-between">
                <div>
                  <div className="flex flex-wrap items-center justify-between gap-2 pb-3.5 mb-4 border-b border-slate-200/80 dark:border-white/10">
                    <div>
                      <span className="text-[9px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400 block">
                        1. El Kit Físico • Taller Baulia
                      </span>
                      <h3 className="text-lg sm:text-2xl font-bold text-slate-900 dark:text-white">
                        Brazaletes VIP Personalizados
                      </h3>
                    </div>

                    {/* Selector de color limpio */}
                    <div className="flex items-center gap-1.5 bg-white dark:bg-black/60 px-3 py-1.5 rounded-full border border-slate-200 dark:border-white/10">
                      <span className="text-[8px] font-black uppercase tracking-wider text-slate-400 mr-1">Color:</span>
                      {[
                        { id: 'oro', bg: 'bg-gradient-to-tr from-amber-500 to-yellow-300', lbl: 'Oro Imperial' },
                        { id: 'negro', bg: 'bg-slate-950', lbl: 'Negro Obsidiana' },
                        { id: 'plata', bg: 'bg-gradient-to-tr from-slate-400 to-slate-200', lbl: 'Plata Titanio' },
                        { id: 'rosa', bg: 'bg-gradient-to-tr from-rose-400 to-pink-200', lbl: 'Rosa Champagne' }
                      ].map(c => (
                        <button
                          key={c.id}
                          type="button"
                          onClick={() => setPulseraColor(c.id)}
                          title={c.lbl}
                          className={`w-5 h-5 rounded-full ${c.bg} border border-white/40 transition-transform ${pulseraColor === c.id ? 'scale-125 ring-2 ring-amber-500' : 'opacity-70 hover:opacity-100'}`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Brazalete Tyvek con espacio completo para que el nombre nunca se corte */}
                  <div className="mb-5">
                    <div className={`w-full rounded-2xl p-3.5 sm:p-4 border-2 shadow-xl transition-all duration-500 flex items-center justify-between gap-3 relative overflow-hidden ${
                      pulseraColor === 'oro'
                        ? 'bg-gradient-to-r from-[#d4af37] via-[#f3e5ab] to-[#aa7c11] text-slate-950 border-amber-300'
                        : pulseraColor === 'negro'
                        ? 'bg-gradient-to-r from-[#09090b] via-[#18181b] to-[#09090b] text-white border-amber-500/50'
                        : pulseraColor === 'plata'
                        ? 'bg-gradient-to-r from-slate-300 via-white to-slate-300 text-slate-900 border-slate-400'
                        : 'bg-gradient-to-r from-[#e8a598] via-[#fce4df] to-[#d88a9b] text-slate-900 border-rose-300'
                    }`}>
                      <div className="flex-1 min-w-0 text-left pl-1">
                        <span className="text-[7px] sm:text-[8px] font-black uppercase tracking-[0.18em] opacity-75 block">
                          BAULIA BLACK LABEL • TYVEK 2.5 CM
                        </span>
                        <h4 className="font-editorial font-bold text-lg sm:text-2xl leading-tight mt-0.5">
                          Sofía & Alejandro
                        </h4>
                        <div className="mt-1.5 flex items-center gap-1.5 flex-wrap">
                          <span className={`text-[8px] font-black uppercase px-2 py-0.5 rounded ${pulseraColor === 'negro' ? 'bg-amber-500 text-slate-950' : 'bg-slate-950 text-amber-400'}`}>
                            FAM. MONTEMAYOR
                          </span>
                          <span className="text-[8px] font-black uppercase tracking-wider opacity-85">
                            • MESA 1 VIP
                          </span>
                        </div>
                      </div>

                      {/* Macro QR Óptico */}
                      <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-xl p-1.5 shadow-md border border-slate-900/20 shrink-0 flex items-center justify-center">
                        <svg viewBox="0 0 100 100" className="w-full h-full text-slate-950">
                          <rect x="5" y="5" width="30" height="30" rx="6" fill="none" stroke="currentColor" strokeWidth="7"/>
                          <rect x="14" y="14" width="12" height="12" rx="2" fill="currentColor"/>
                          
                          <rect x="65" y="5" width="30" height="30" rx="6" fill="none" stroke="currentColor" strokeWidth="7"/>
                          <rect x="74" y="14" width="12" height="12" rx="2" fill="currentColor"/>
                          
                          <rect x="5" y="65" width="30" height="30" rx="6" fill="none" stroke="currentColor" strokeWidth="7"/>
                          <rect x="14" y="74" width="12" height="12" rx="2" fill="currentColor"/>

                          {[
                            [46,12],[54,12],[46,24],[54,24],
                            [12,46],[24,46],[12,54],[24,54],
                            [76,46],[88,46],[76,54],[88,54],
                            [46,76],[56,76],[68,76],[82,76],[46,88],[60,88],[74,88],[88,88]
                          ].map(([cx, cy], i) => (
                            <circle key={i} cx={cx} cy={cy} r="4.2" fill="currentColor"/>
                          ))}

                          <circle cx="50" cy="50" r="11" fill="#0f172a"/>
                          <circle cx="50" cy="50" r="5" fill="#f59e0b"/>
                        </svg>
                      </div>
                    </div>
                    <p className="text-[9px] text-slate-400 text-right mt-1.5 italic">*Tono de pulsera sujeto a disponibilidad.</p>
                  </div>
                </div>

                {/* Imagen /pulsera.jpg y descripción sin doble marco apretado */}
                <div className="flex flex-col sm:flex-row items-center gap-4 pt-2 border-t border-slate-200/60 dark:border-white/5 mt-auto">
                  <div className="w-full sm:w-44 h-40 sm:h-36 rounded-2xl overflow-hidden border border-amber-500/30 relative bg-slate-900 shrink-0">
                    <img 
                      src="/pulsera.jpg" 
                      alt="Pulsera Tyvek Baulia Black Label" 
                      className="w-full h-full object-cover"
                      onError={(e) => { e.target.src = '/demos/boda/foto4.jpg'; }}
                    />
                    <span className="absolute bottom-2 left-2 bg-black/80 backdrop-blur-md text-amber-400 text-[8px] font-black uppercase tracking-widest px-2.5 py-1 rounded-lg border border-amber-500/30">
                      Caja VIP Incluida
                    </span>
                  </div>
                  <div className="space-y-1.5 text-left">
                    <span className="text-[10px] font-black uppercase tracking-wider text-amber-600 dark:text-amber-400 flex items-center gap-1.5">
                      <CheckCircle size={13}/> Impresión + Respaldo PDF
                    </span>
                    <p className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
                      Fabricamos tus brazaletes Tyvek de <b>2.5 cm resistentes al agua</b> con tu logo y los enviamos gratis a tu puerta. ¿Invitados de último minuto? También incluye exportación PDF inmediata.
                    </p>
                  </div>
                </div>
              </div>

              {/* MÓDULO 2: ESCÁNER Y MONITOR EN VIVO (Diseño limpio y espacioso) */}
              <div className="bg-slate-50 dark:bg-[#121212] rounded-[1.8rem] p-4 sm:p-7 border border-slate-200/80 dark:border-white/10 flex flex-col justify-between">
                <div>
                  <div className="pb-3.5 mb-3.5 border-b border-slate-200/80 dark:border-white/10">
                    <span className="text-[9px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400 block">
                      2. Sin Equipos Costosos • Cero Apps
                    </span>
                    <h3 className="text-lg sm:text-2xl font-bold text-slate-900 dark:text-white">
                      Escáner y Monitor en Vivo
                    </h3>
                  </div>

                  <p className="text-slate-600 dark:text-slate-400 text-xs sm:text-sm leading-relaxed mb-4">
                    Convierte tu teléfono, el del <b>cadenero o el de tu Hostess en un lector óptico ultra-rápido incluso de noche</b>, sincronizado en tiempo real sin instalar aplicaciones.
                  </p>
                </div>

                {/* Consola de Radar Espaciosa y Ordenada */}
                {(() => {
                  const porcentaje = Math.round((radarCount / 200) * 100);
                  const strokeOffset = Math.round(283 - (283 * porcentaje) / 100);
                  const invitadosDemo = [
                    { nombre: 'Familia Garza Villarreal', mesa: 'Mesa 1 • VIP' },
                    { nombre: 'Alejandro Montemayor', mesa: 'Mesa 2 • Honor' },
                    { nombre: 'Sofía Elizondo & Esposo', mesa: 'Mesa 4 • Amigos' },
                    { nombre: 'Mesa Directiva Corporativa', mesa: 'Mesa 1 • Presídium' }
                  ];
                  const guestActual = invitadosDemo[radarGuestIdx];

                  return (
                    <div className="mt-auto w-full bg-slate-950 rounded-3xl border border-slate-800 dark:border-white/10 shadow-xl p-5 flex flex-col justify-between gap-4">
                      
                      {/* Fila Superior: Estado y Botón de Simulación bien separados */}
                      <div className="flex items-center justify-between gap-2 border-b border-white/10 pb-3.5">
                        <div>
                          <span className="text-emerald-400 font-black text-[8px] uppercase tracking-widest flex items-center gap-1.5">
                            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-ping"></span> Puerta Principal
                          </span>
                          <p className="text-white font-bold text-sm sm:text-base mt-0.5">
                            {radarCount} <span className="text-slate-500 text-xs font-normal">/ 200 ingresos</span>
                          </p>
                        </div>

                        <button
                          type="button"
                          onClick={() => {
                            setRadarCount(c => c < 200 ? c + 1 : 184);
                            setRadarGuestIdx(i => (i + 1) % 4);
                          }}
                          className="px-3.5 py-2 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-black text-[9.5px] uppercase tracking-wider shadow-md active:scale-95 transition-all flex items-center gap-1.5 shrink-0"
                        >
                          <Scan size={13}/> + Escanear
                        </button>
                      </div>

                      {/* Centro: Velocímetro e Invitado Verificado lado a lado en escritorio y limpios en móvil */}
                      <div className="flex flex-col sm:flex-row items-center justify-around gap-4 py-1">
                        <div className="relative flex items-center justify-center shrink-0">
                          <svg className="w-28 h-28 sm:w-32 sm:h-32 -rotate-90 transform" viewBox="0 0 100 100">
                            <circle cx="50" cy="50" r="45" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="8" />
                            <circle cx="50" cy="50" r="45" fill="none" stroke="#f59e0b" strokeWidth="8" strokeDasharray="283" strokeDashoffset={strokeOffset} className="transition-all duration-500 ease-out" />
                          </svg>
                          <div className="absolute flex flex-col items-center">
                            <span className="text-2xl sm:text-3xl font-black text-amber-500 leading-none">{porcentaje}%</span>
                            <span className="text-[7px] uppercase tracking-widest text-slate-400 font-bold mt-1">Aforo</span>
                          </div>
                        </div>

                        {/* Tarjeta del invitado recién escaneado */}
                        <div key={radarCount} className="w-full sm:flex-1 bg-white/[0.05] p-3.5 rounded-2xl border border-emerald-500/30 flex items-center gap-3 animate-in zoom-in-95 duration-200">
                          <div className="w-9 h-9 rounded-xl bg-emerald-500 flex items-center justify-center text-slate-950 shrink-0">
                            <CheckCircle size={18} />
                          </div>
                          <div className="min-w-0 text-left">
                            <span className="text-[8px] font-black uppercase tracking-widest text-emerald-400 block">
                              ✓ Acceso Concedido
                            </span>
                            <p className="text-white font-bold text-xs sm:text-sm truncate mt-0.5">{guestActual.nombre}</p>
                            <p className="text-amber-400 text-[10px] font-bold mt-0.5">{guestActual.mesa}</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  );
                })()}
              </div>

            </div>

            {/* BARRA INFERIOR DE COMPRA CON BOTÓN DIRECTO Y CONCISO */}
            <div className="mt-7 pt-5 border-t border-slate-200/80 dark:border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="text-center sm:text-left">
                <span className="text-[10px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400 block">
                  Software de Escaneo + Brazaletes Impresos + Envío Gratis
                </span>
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                  Incluido sin costo al contratar el <b>Plan Diamante</b> o actívalo de forma independiente.
                </p>
              </div>
              <button 
                type="button"
                onClick={() => { setPlanSeleccionado({ plan: 'Black Label', precio: pBlackLabel.raw[moneda], moneda: moneda }); setCheckoutModal('pago'); }} 
                className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-amber-500 to-yellow-600 text-slate-950 rounded-2xl font-black text-xs sm:text-sm uppercase tracking-widest hover:scale-[1.02] transition-all flex items-center justify-center shadow-[0_10px_30px_rgba(245,158,11,0.35)] shrink-0"
              >
                <Printer size={17} className="mr-2 text-slate-950/90 shrink-0" /> Activar por ${pBlackLabel.precios[moneda]} {moneda}
              </button>
            </div>

          </RevealSection>
        </div>
      </section>

      {/* ========================================== */}
      {/* 🔴 SECCIÓN DE PLANES Y PORTAL COMPARATIVO DE ALTA COSTURA */}
      {/* ========================================== */}
      <div id="planes" className="py-32 px-4 max-w-[1400px] mx-auto relative">
        <RevealSection className="text-center mb-14">
          <span className="px-4 py-1 rounded-full bg-amber-500/10 text-amber-600 dark:text-amber-400 text-xs font-black uppercase tracking-[0.2em] border border-amber-500/20 shadow-sm mb-6 inline-block">
            Atelier & Software de Gestión
          </span>
          <h2 className="text-5xl md:text-6xl font-editorial font-medium text-slate-900 dark:text-white mt-2 mb-5 transition-colors leading-tight">
            La Colección Sagrada.
          </h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto text-sm md:text-base transition-colors font-light leading-relaxed mb-7">
            Todos nuestros planes incluyen una invitación de Alta Costura y acceso a tu Bóveda Privada. Un solo pago único, <b>precios netos con IVA incluido</b> y acompañamiento hasta el último baile.
          </p>

          {/* 🟢 GATILLO DE EXCLUSIVIDAD (50 Eventos por Mes sin contador artificial fijo) */}
          <div className="max-w-2xl mx-auto bg-white dark:bg-[#111] border border-amber-500/40 rounded-2xl p-3.5 sm:px-6 sm:py-3.5 shadow-[0_10px_30px_rgba(245,158,11,0.12)] flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex items-center gap-2.5 text-left">
              <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-ping shrink-0"></span>
              <p className="text-xs text-slate-700 dark:text-slate-200 leading-snug">
                <b>Exclusividad Garantizada:</b> Para brindar un diseño artesanal impecable y soporte Concierge 1 a 1, limitamos nuestra agenda a <b>50 eventos por mes</b>.
              </p>
            </div>
            <span className="px-3 py-1 rounded-full bg-amber-500/15 border border-amber-500/30 text-amber-700 dark:text-amber-400 text-[9px] font-black uppercase tracking-widest whitespace-nowrap shrink-0">
              Cupo Mensual Limitado
            </span>
          </div>
        </RevealSection>

        {/* TARJETAS DE LOS 4 PLANES CON BOTÓN DE FICHA TÉCNICA COMPLETA */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch mb-14 relative z-10">
          {planes.map((plan, idx) => {
            const tienePromo = plan.preciosOriginales[moneda] !== null;
            
            return (
            <RevealSection key={idx} delay={idx * 100} className={`relative flex flex-col ${plan.d2 ? 'lg:-translate-y-4' : ''}`}>
               {plan.d2 && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#D4AF37] text-[#1C1917] text-[10px] font-black uppercase tracking-widest py-1 px-4 rounded-full shadow-md whitespace-nowrap z-20">Más Vendido</div>}
               {plan.d1 && <div className="absolute top-0 right-0 bg-[#D4AF37] text-[#1C1917] text-[8px] font-black uppercase tracking-widest px-3 py-1.5 rounded-bl-lg whitespace-nowrap z-20"><Gem size={10} className="mr-1 inline"/> Suite Todo Incluido</div>}

               <div className={`h-full bg-[#141210] rounded-3xl p-7 sm:p-8 border ${plan.d2 || plan.d1 ? 'border-2 border-[#D4AF37] shadow-[0_10px_35px_rgba(212,175,55,0.12)]' : 'border-[#D4AF37]/20'} flex flex-col justify-between group overflow-hidden relative shadow-lg transition-colors`}>
                 
                 {(plan.d1 || plan.d2) && <div className="absolute inset-0 opacity-10 bg-[linear-gradient(45deg,_transparent_70%,_#D4AF37_100%)] rounded-3xl transition-opacity group-hover:opacity-20 pointer-events-none"></div>}

                 <div className="relative z-10 mb-6 flex-1">
                    <span className="text-[9px] font-black uppercase tracking-widest block mb-1 text-[#D4AF37]">
                      {plan.subtitulo}
                    </span>
                    <h3 className="text-2xl sm:text-3xl font-editorial font-bold text-white mb-2">{plan.nombre}</h3>
                    <p className="text-xs text-slate-400 mb-5 font-medium leading-relaxed">{plan.desc}</p>
                    
                    {/* PRECIO DINÁMICO DESDE FIREBASE */}
                    <div className="text-4xl font-light text-white mb-6 relative flex items-baseline">
                       {tienePromo && <span className="text-lg text-rose-500 line-through font-bold mr-2.5">${plan.preciosOriginales[moneda]}</span>}
                       <span className="font-editorial text-transparent bg-clip-text bg-gradient-to-tr from-white to-[#FDF1A9]">${plan.precios[moneda]}</span> 
                       <span className="text-xs text-[#D4AF37] font-bold uppercase tracking-widest ml-2">{moneda}</span>
                    </div>

                    <ul className="space-y-3 text-xs sm:text-sm text-slate-300 relative">
                       {plan.f.map((feat, fIdx) => (
                          <li key={fIdx} className="flex items-start leading-snug"><Check size={15} className="text-[#D4AF37] mr-2.5 shrink-0 mt-0.5" /> <span>{feat}</span></li>
                       ))}
                    </ul>
                 </div>
                 
                 <div className="space-y-2.5 relative z-10 mt-auto pt-4 border-t border-[#D4AF37]/15">
                   <button 
                     type="button"
                     onClick={() => { setFichaPlanModal(plan.id); setFichaTab('invitacion'); }}
                     className="w-full py-3 rounded-2xl bg-[#1C1917] hover:bg-[#D4AF37]/15 text-[#D4AF37] font-bold text-[10px] uppercase tracking-widest transition-all flex items-center justify-center gap-1.5 border border-[#D4AF37]/40"
                   >
                     <BookOpenText size={13} className="text-[#D4AF37]"/> Ver todo lo que incluye
                   </button>

                   <button 
                     type="button"
                     onClick={() => { setPlanSeleccionado({ plan: plan.nombre, precio: plan.raw[moneda], moneda: moneda }); setCheckoutModal('pago'); }} 
                     className={`w-full py-4 rounded-2xl ${plan.d2 || plan.d1 ? 'bg-[#D4AF37] hover:bg-[#e3be42] text-[#1C1917] shadow-[0_8px_25px_rgba(212,175,55,0.35)]' : 'bg-[#D4AF37]/15 hover:bg-[#D4AF37] text-[#D4AF37] hover:text-[#1C1917] border border-[#D4AF37]/50'} font-black text-[10px] uppercase tracking-widest hover:scale-[1.02] transition-all`}
                   >
                     Reservar mi Bóveda {plan.nombre}
                   </button>
                 </div>
              </div>
            </RevealSection>
          )})}
        </div>

        {/* 🟢 BANNER EJECUTIVO PARA ABRIR EL PORTAL COMPARATIVO DE 22 CARACTERÍSTICAS */}
        <RevealSection delay={300} className="max-w-5xl mx-auto relative z-10">
          <div className="bg-gradient-to-r from-slate-900 via-[#111] to-slate-900 dark:from-[#0d0d0d] dark:via-[#15120c] dark:to-[#0d0d0d] rounded-[2.5rem] p-8 sm:p-10 border border-slate-800 dark:border-amber-500/20 shadow-2xl flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div className="max-w-xl">
              <span className="text-[10px] font-black uppercase tracking-[0.25em] text-amber-400 block mb-2">
                Radiografía Completa • 22 Puntos
              </span>
              <h3 className="text-2xl sm:text-3xl font-editorial font-medium text-white mb-2">
                ¿Dudas entre dos planes? Compáralos lado a lado.
              </h3>
              <p className="text-slate-400 text-xs sm:text-sm font-light leading-relaxed">
                Revisa cuántas fotos de portada y galería incluye cada paquete, ubicaciones GPS, monograma, padrinos, filtro de Instagram y qué módulos se desbloquean en tu Bóveda.
              </p>
            </div>
            <button
              type="button"
              onClick={() => setPortalComparativoOpen(true)}
              className="w-full md:w-auto px-8 py-4 rounded-full bg-gradient-to-r from-amber-500 to-yellow-500 text-slate-950 font-black text-xs uppercase tracking-widest shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:scale-105 transition-all shrink-0 flex items-center justify-center gap-2"
            >
              <Layers size={16}/> Comparar los 4 Planes a Fondo
            </button>
          </div>
        </RevealSection>

        {/* ========================================================= */}
        {/* 🟢 MODAL 1: FICHA TÉCNICA DETALLADA POR PLAN (INVITACIÓN + BÓVEDA) */}
        {/* ========================================================= */}
        {fichaPlanModal && (() => {
          const planActual = planes.find(p => p.id === fichaPlanModal) || planes[2];
          const tienePromo = planActual.preciosOriginales[moneda] !== null;

          return (
            <div 
              onClick={() => setFichaPlanModal(null)}
              className="fixed inset-0 z-[99999] bg-slate-950/85 backdrop-blur-xl flex items-end sm:items-center justify-center p-0 sm:p-4 animate-in fade-in duration-200 overflow-hidden"
            >
              <div 
                onClick={(e) => e.stopPropagation()}
                className="bg-white dark:bg-[#0a0a0a] w-full max-w-2xl rounded-t-[2rem] sm:rounded-[2.5rem] border border-slate-200 dark:border-white/10 shadow-2xl overflow-hidden flex flex-col h-[90dvh] sm:h-auto sm:max-h-[88dvh] animate-in zoom-in-95 duration-200"
              >
                {/* Cabecera con selector rápido de los 4 planes y botón Cerrar destacado */}
                <div className="p-4 sm:p-6 bg-slate-50 dark:bg-[#111] border-b border-slate-200 dark:border-white/10 shrink-0">
                  <div className="flex items-center justify-between gap-2 mb-4">
                    <div className="flex items-center gap-1.5 overflow-x-auto hide-scrollbar py-0.5">
                      {planes.map(p => (
                        <button
                          key={p.id}
                          type="button"
                          onClick={() => setFichaPlanModal(p.id)}
                          className={`px-3 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest transition-all shrink-0 ${fichaPlanModal === p.id ? 'bg-amber-500 text-slate-950 shadow-sm' : 'bg-white dark:bg-white/5 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-white/10'}`}
                        >
                          {p.nombre}
                        </button>
                      ))}
                    </div>
                    <button
                      type="button"
                      onClick={() => setFichaPlanModal(null)}
                      className="px-3.5 py-1.5 rounded-full bg-rose-500 text-white font-black text-[10px] uppercase tracking-widest flex items-center gap-1 hover:bg-rose-600 transition-colors shrink-0 shadow-sm"
                    >
                      <X size={15}/> Cerrar
                    </button>
                  </div>

                  <div className="flex flex-wrap items-end justify-between gap-4">
                    <div>
                      <span className="text-[9px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400 block">
                        Ficha Técnica Oficial • {planActual.subtitulo}
                      </span>
                      <h3 className="text-3xl font-editorial font-bold text-slate-900 dark:text-white mt-0.5">
                        Plan {planActual.nombre}
                      </h3>
                    </div>
                    <div className="text-right">
                      {tienePromo && <span className="text-xs text-rose-500 line-through font-bold mr-2">${planActual.preciosOriginales[moneda]}</span>}
                      <span className="text-3xl font-editorial font-bold text-slate-900 dark:text-white">${planActual.precios[moneda]}</span>
                      <span className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-1.5">{moneda}</span>
                    </div>
                  </div>

                  {/* Pestañas Internas: Invitación vs Bóveda */}
                  <div className="grid grid-cols-2 gap-2 mt-5 p-1 bg-slate-200/70 dark:bg-black/60 rounded-2xl border border-slate-300/60 dark:border-white/10">
                    <button
                      type="button"
                      onClick={() => setFichaTab('invitacion')}
                      className={`py-2.5 px-3 rounded-xl text-[10px] sm:text-xs font-black uppercase tracking-wider transition-all flex items-center justify-center gap-1.5 ${fichaTab === 'invitacion' ? 'bg-white dark:bg-[#1a1a1a] text-slate-900 dark:text-white shadow-sm' : 'text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'}`}
                    >
                      <Palette size={14} className="text-amber-500 shrink-0"/> 1. Tu Invitación
                    </button>
                    <button
                      type="button"
                      onClick={() => setFichaTab('boveda')}
                      className={`py-2.5 px-3 rounded-xl text-[10px] sm:text-xs font-black uppercase tracking-wider transition-all flex items-center justify-center gap-1.5 ${fichaTab === 'boveda' ? 'bg-white dark:bg-[#1a1a1a] text-slate-900 dark:text-white shadow-sm' : 'text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'}`}
                    >
                      <LayoutDashboard size={14} className="text-indigo-500 shrink-0"/> 2. Tu Bóveda
                    </button>
                  </div>
                </div>

                {/* Cuerpo desplazable con el desglose */}
                <div className="p-5 sm:p-6 overflow-y-auto custom-scrollbar flex-1 space-y-3">
                  {fichaTab === 'invitacion' ? (
                    planActual.fichaInvitacion.map((item, i) => (
                      <div key={i} className="p-4 rounded-2xl bg-slate-50 dark:bg-[#111] border border-slate-200/80 dark:border-white/10 flex items-start gap-3.5">
                        <div className="w-7 h-7 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-500 shrink-0 mt-0.5">
                          <Check size={14}/>
                        </div>
                        <div>
                          <h4 className="font-bold text-sm text-slate-900 dark:text-white">{item.t}</h4>
                          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 leading-relaxed">{item.d}</p>
                        </div>
                      </div>
                    ))
                  ) : (
                    planActual.fichaBoveda.map((item, i) => (
                      <div key={i} className={`p-4 rounded-2xl border flex items-start gap-3.5 ${item.ok ? 'bg-slate-50 dark:bg-[#111] border-slate-200/80 dark:border-white/10' : 'bg-slate-50/50 dark:bg-white/[0.02] border-dashed border-slate-200 dark:border-white/5 opacity-75'}`}>
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 mt-0.5 border ${item.ok ? 'bg-emerald-500/15 border-emerald-500/30 text-emerald-500' : 'bg-slate-200 dark:bg-white/10 border-transparent text-slate-400'}`}>
                          {item.ok ? <Check size={14}/> : <Lock size={13}/>}
                        </div>
                        <div>
                          <div className="flex items-center gap-2 flex-wrap">
                            <h4 className="font-bold text-sm text-slate-900 dark:text-white">{item.t}</h4>
                            {!item.ok && <span className="text-[8px] font-black uppercase px-2 py-0.5 rounded bg-amber-500/15 text-amber-600 dark:text-amber-400">Upgrade Disponible</span>}
                          </div>
                          <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 leading-relaxed">{item.d}</p>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {/* Pie de acción */}
                <div className="p-4 sm:p-5 bg-white dark:bg-[#0a0a0a] border-t border-slate-200 dark:border-white/10 flex flex-col sm:flex-row gap-2.5 shrink-0">
                  <button
                    type="button"
                    onClick={() => { setFichaPlanModal(null); setPortalComparativoOpen(true); }}
                    className="py-3.5 px-5 rounded-2xl bg-slate-100 dark:bg-white/5 text-slate-700 dark:text-slate-300 font-bold text-[10px] uppercase tracking-widest hover:bg-slate-200 transition-colors"
                  >
                    Comparar con otros planes
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setFichaPlanModal(null);
                      setPlanSeleccionado({ plan: planActual.nombre, precio: planActual.raw[moneda], moneda: moneda });
                      setCheckoutModal('pago');
                    }}
                    className="flex-1 py-3.5 px-6 rounded-2xl bg-gradient-to-r from-amber-500 to-yellow-600 text-slate-950 font-black text-xs uppercase tracking-widest shadow-lg hover:scale-[1.01] transition-all flex items-center justify-center gap-2"
                  >
                    Elegir Plan {planActual.nombre} (${planActual.precios[moneda]} {moneda}) <ArrowRight size={15}/>
                  </button>
                </div>

              </div>
            </div>
          );
        })()}

        {/* ========================================================= */}
        {/* 🟢 MODAL 2: PORTAL COMPARATIVO DE ALTA COSTURA (22 PUNTOS - PC Y MÓVIL) */}
        {/* ========================================================= */}
        {portalComparativoOpen && (
          <div className="fixed inset-0 z-[99999] bg-slate-950/90 backdrop-blur-xl flex flex-col animate-in fade-in duration-200">
            
            {/* Barra fija superior */}
            <div className="px-4 sm:px-8 py-4 bg-white/95 dark:bg-[#0a0a0a]/95 border-b border-slate-200 dark:border-white/10 flex items-center justify-between gap-4 shrink-0">
              <div>
                <span className="text-[9px] font-black uppercase tracking-[0.25em] text-amber-600 dark:text-amber-400 block">
                  Portal Comparativo de Alta Costura
                </span>
                <h3 className="text-lg sm:text-2xl font-editorial font-bold text-slate-900 dark:text-white leading-tight">
                  Anatomía de los 4 Planes Baulia
                </h3>
              </div>

              <div className="flex items-center gap-2.5">
                <button
                  type="button"
                  onClick={() => setPortalComparativoOpen(false)}
                  className="px-4 py-2.5 rounded-full bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-black text-[10px] uppercase tracking-widest flex items-center gap-1.5 shadow-md"
                >
                  <X size={14}/> Cerrar Portal
                </button>
              </div>
            </div>

            {/* Selector pegajoso en Móvil para comparar sin hacer zoom ni desbordar */}
            <div className="lg:hidden px-4 py-3 bg-slate-100 dark:bg-[#111] border-b border-slate-200 dark:border-white/10 shrink-0">
              <p className="text-[9px] font-black uppercase tracking-widest text-slate-400 text-center mb-2">
                Toca un plan para resaltar su columna o revisa los 4 abajo:
              </p>
              <div className="grid grid-cols-4 gap-1.5">
                {planes.map(p => (
                  <button
                    key={p.id}
                    type="button"
                    onClick={() => setMobileComparePlan(p.id)}
                    className={`py-2 px-1 rounded-xl text-center transition-all border ${mobileComparePlan === p.id ? 'bg-amber-500 text-slate-950 border-amber-400 font-black shadow-sm scale-[1.02]' : 'bg-white dark:bg-[#0a0a0a] text-slate-600 dark:text-slate-300 border-slate-200 dark:border-white/10 font-bold'}`}
                  >
                    <span className="block text-[10px] uppercase tracking-wider">{p.nombre}</span>
                    <span className="block text-[9px] opacity-80">${p.precios[moneda]}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Cuerpo scrollable de comparación */}
            <div className="flex-1 overflow-y-auto custom-scrollbar p-4 sm:p-8">
              <div className="max-w-6xl mx-auto">
                
                {/* VISTA ESCRITORIO: TABLA COMPLETA DE 22 PUNTOS */}
                <div className="hidden lg:block bg-white dark:bg-[#0a0a0a] rounded-[2rem] border border-slate-200 dark:border-white/10 shadow-2xl overflow-hidden">
                  <table className="w-full text-left border-collapse">
                    <thead>
                      <tr className="bg-slate-50 dark:bg-[#111] border-b border-slate-200 dark:border-white/10">
                        <th className="py-5 px-6 font-black text-xs uppercase tracking-widest text-slate-500 w-[36%]">Característica Incluida</th>
                        {planes.map(p => (
                          <th key={p.id} className={`py-5 px-4 text-center w-[16%] ${p.d2 ? 'bg-amber-500/10' : p.d1 ? 'bg-indigo-500/10' : ''}`}>
                            <span className={`block text-xs font-black uppercase tracking-widest ${p.d2 ? 'text-amber-500' : p.d1 ? 'text-indigo-400' : 'text-slate-700 dark:text-slate-200'}`}>{p.nombre}</span>
                            <span className="block font-editorial text-lg font-bold text-slate-900 dark:text-white mt-0.5">${p.precios[moneda]} <small className="text-[9px] font-sans text-slate-400">{moneda}</small></span>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="text-xs">
                      {Object.entries(característicasTabla.reduce((acc, current) => {
                        (acc[current.grupo] = acc[current.grupo] || []).push(current);
                        return acc;
                      }, {})).map(([grupo, feats], gIdx) => (
                        <React.Fragment key={gIdx}>
                          <tr>
                            <td colSpan="5" className="bg-slate-100 dark:bg-white/5 py-3 px-6 text-[10px] font-black uppercase tracking-widest text-amber-600 dark:text-amber-400">
                              {grupo}
                            </td>
                          </tr>
                          {feats.map((row, i) => (
                            <tr key={i} className="border-b border-slate-100 dark:border-white/5 hover:bg-slate-50/80 dark:hover:bg-white/[0.03] transition-colors">
                              <td className="py-3.5 px-6 text-slate-800 dark:text-slate-200 font-medium flex items-center gap-2.5">
                                <span className="text-amber-500 shrink-0">{row.icon}</span>
                                <span>{row.n}</span>
                              </td>
                              <td className="py-3.5 px-3 text-center">{row.b === true ? <Check size={17} className="mx-auto text-emerald-500"/> : row.b === false ? <span className="text-slate-300 dark:text-slate-700">—</span> : <span className="font-bold text-slate-600 dark:text-slate-400">{row.b}</span>}</td>
                              <td className="py-3.5 px-3 text-center">{row.p === true ? <Check size={17} className="mx-auto text-emerald-500"/> : row.p === false ? <span className="text-slate-300 dark:text-slate-700">—</span> : <span className="font-bold text-slate-600 dark:text-slate-400">{row.p}</span>}</td>
                              <td className="py-3.5 px-3 text-center bg-amber-500/[0.04]">{row.o === true ? <Check size={17} className="mx-auto text-amber-500"/> : row.o === false ? <span className="text-slate-300 dark:text-slate-700">—</span> : <span className="font-black text-amber-600 dark:text-amber-400">{row.o}</span>}</td>
                              <td className="py-3.5 px-3 text-center bg-indigo-500/[0.04]">{row.d === true ? <Check size={17} className="mx-auto text-indigo-400"/> : row.d === false ? <span className="text-slate-300 dark:text-slate-700">—</span> : <span className="font-black text-indigo-600 dark:text-indigo-400">{row.d}</span>}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* VISTA MÓVIL: TARJETAS COMPARATIVAS CON LOS 4 PLANES VISIBLES DE UN VISTAZO */}
                <div className="lg:hidden space-y-6 pb-10">
                  {Object.entries(característicasTabla.reduce((acc, current) => {
                    (acc[current.grupo] = acc[current.grupo] || []).push(current);
                    return acc;
                  }, {})).map(([grupo, feats], gIdx) => (
                    <div key={gIdx} className="space-y-2.5">
                      <h4 className="text-[10px] font-black uppercase tracking-widest text-amber-500 px-2">
                        {grupo}
                      </h4>
                      {feats.map((row, i) => (
                        <div key={i} className="bg-white dark:bg-[#0a0a0a] rounded-2xl p-3.5 border border-slate-200 dark:border-white/10 shadow-sm space-y-2.5">
                          <div className="flex items-center gap-2 text-xs font-bold text-slate-900 dark:text-white">
                            <span className="text-amber-500 shrink-0">{row.icon}</span>
                            <span>{row.n}</span>
                          </div>
                          <div className="grid grid-cols-4 gap-1.5 text-center">
                            {[
                              { id: 'basico', lbl: 'Básico', val: row.b },
                              { id: 'plata', lbl: 'Plata', val: row.p },
                              { id: 'oro', lbl: 'Oro', val: row.o },
                              { id: 'diamante', lbl: 'Diamante', val: row.d }
                            ].map(col => {
                              const isHighlighted = mobileComparePlan === col.id;
                              return (
                                <div key={col.id} className={`p-2 rounded-xl border flex flex-col items-center justify-center min-h-[52px] transition-all ${isHighlighted ? 'bg-amber-500/15 border-amber-500/50 ring-1 ring-amber-500/30' : 'bg-slate-50 dark:bg-[#111] border-slate-100 dark:border-white/5'}`}>
                                  <span className={`text-[8px] font-black uppercase mb-1 ${isHighlighted ? 'text-amber-500' : 'text-slate-400'}`}>{col.lbl}</span>
                                  {col.val === true ? (
                                    <Check size={14} className="text-emerald-500"/>
                                  ) : col.val === false ? (
                                    <span className="text-[10px] text-slate-300 dark:text-slate-700 font-bold">—</span>
                                  ) : (
                                    <span className="text-[9px] font-black text-slate-800 dark:text-slate-200 leading-tight">{col.val}</span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

              </div>
            </div>

          </div>
        )}
      </div>

      {/* ========================================== */}
      {/* 🟢 PRUEBA SOCIAL EMOCIONAL: TESTIMONIOS DE ALTA COSTURA (Conectados a "resenas" + Modal Ver Todos) */}
      {/* ========================================== */}
      <section id="testimonios" className="py-20 px-4 md:px-8 max-w-7xl mx-auto relative z-10 border-t border-slate-200/70 dark:border-white/5">
        <RevealSection className="text-center mb-12">
          <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-xs mb-3 block">
            El Efecto Baulia • Opiniones Reales
          </span>
          <h2 className="text-3xl sm:text-5xl font-editorial font-medium text-slate-900 dark:text-white mb-4 leading-tight">
            La tranquilidad de quienes ya <span className="italic text-amber-500">celebraron sin estrés.</span>
          </h2>
          <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base font-light max-w-xl mx-auto">
            Anfitriones y parejas que vivieron la experiencia desde su Bóveda Privada.
          </p>
        </RevealSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          {testimoniosPublicos.slice(0, 3).map((item, idx) => (
            <RevealSection key={item.id || idx} delay={idx * 100} className="bg-white dark:bg-[#0a0a0a] rounded-[2rem] p-7 sm:p-8 border border-slate-200 dark:border-white/10 shadow-lg flex flex-col justify-between relative overflow-hidden group hover:border-amber-500/40 transition-all">
              <div>
                <div className="flex items-center gap-1 text-amber-500 mb-4">
                  {Array.from({ length: item.estrellas || 5 }).map((_, sIdx) => (
                    <svg key={sIdx} className="w-4 h-4 fill-amber-400 text-amber-400" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-slate-700 dark:text-slate-300 text-xs sm:text-sm font-light italic leading-relaxed mb-6">
                  "{item.texto}"
                </p>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-slate-100 dark:border-white/5">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="w-9 h-9 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-600 dark:text-amber-400 font-editorial font-bold text-sm shrink-0">
                    {String(item.nombre || 'B').charAt(0)}
                  </div>
                  <div className="min-w-0">
                    <h4 className="font-bold text-xs sm:text-sm text-slate-900 dark:text-white truncate">{item.nombre}</h4>
                    <span className="text-[9px] font-black uppercase tracking-wider text-amber-600 dark:text-amber-400 block truncate">
                      {item.evento}
                    </span>
                  </div>
                </div>
                <span className="text-[8px] font-black uppercase px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20 shrink-0">
                  ✓ Verificado
                </span>
              </div>
            </RevealSection>
          ))}
        </div>

        <div className="mt-8 text-center">
          <button
            type="button"
            onClick={() => setVerTodosTestimoniosModal(true)}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-100 dark:bg-white/5 hover:bg-amber-500/15 border border-slate-200 dark:border-white/10 hover:border-amber-500/40 text-slate-700 dark:text-slate-200 text-[11px] font-black uppercase tracking-widest transition-all"
          >
            <Star size={14} className="text-amber-500 fill-amber-500"/> Ver todas las opiniones ({testimoniosPublicos.length})
          </button>
        </div>

        {verTodosTestimoniosModal && (
          <div onClick={() => setVerTodosTestimoniosModal(false)} className="fixed inset-0 z-[99999] bg-slate-950/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
            <div onClick={e => e.stopPropagation()} className="bg-white dark:bg-[#0a0a0a] rounded-[2.5rem] w-full max-w-4xl max-h-[85vh] border border-slate-200 dark:border-white/10 shadow-2xl flex flex-col overflow-hidden animate-in zoom-in-95">
              <div className="p-6 border-b border-slate-100 dark:border-white/10 flex items-center justify-between bg-slate-50 dark:bg-[#111]">
                <div>
                  <span className="text-[9px] font-black uppercase tracking-widest text-amber-500 block">Bóveda de Reseñas Verificadas</span>
                  <h3 className="text-2xl font-editorial font-bold text-slate-900 dark:text-white">Opiniones de Anfitriones Baulia ({testimoniosPublicos.length})</h3>
                </div>
                <button type="button" onClick={() => setVerTodosTestimoniosModal(false)} className="p-2 rounded-full bg-slate-200/70 dark:bg-white/10 text-slate-600 dark:text-white hover:bg-rose-500 hover:text-white transition-colors">
                  <X size={18}/>
                </button>
              </div>
              <div className="p-6 overflow-y-auto custom-scrollbar grid grid-cols-1 md:grid-cols-2 gap-4">
                {testimoniosPublicos.map((item, idx) => (
                  <div key={item.id || idx} className="p-6 rounded-2xl bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-1 text-amber-500 mb-3">
                        {Array.from({ length: item.estrellas || 5 }).map((_, sIdx) => (
                          <Star key={sIdx} size={14} className="fill-amber-400 text-amber-400" />
                        ))}
                      </div>
                      <p className="text-slate-700 dark:text-slate-300 text-xs sm:text-sm italic leading-relaxed mb-4">"{item.texto}"</p>
                    </div>
                    <div className="flex items-center justify-between pt-3 border-t border-slate-200/60 dark:border-white/5">
                      <div>
                        <p className="font-bold text-xs text-slate-900 dark:text-white">{item.nombre}</p>
                        <p className="text-[9px] font-black uppercase tracking-wider text-amber-600 dark:text-amber-400">{item.evento}</p>
                      </div>
                      <span className="text-[8px] font-black uppercase px-2 py-0.5 rounded bg-emerald-500/10 text-emerald-500 border border-emerald-500/20">✓ Verificado</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </section>

      {/* ========================================== */}
      {/* 🟢 SECCIÓN B2B RENOVADA: WEDDING PLANNERS Y AGENCIAS (Ubicada después de los precios) */}
      {/* ========================================== */}
      <section id="planners" className="py-20 px-4 md:px-8 max-w-7xl mx-auto relative z-10">
        <RevealSection className="bg-slate-900 dark:bg-[#0a0a0a] rounded-[2.5rem] sm:rounded-[3rem] p-7 sm:p-12 md:p-16 border border-slate-800 dark:border-amber-500/20 relative overflow-hidden shadow-2xl">
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-amber-500/10 hidden md:block blur-[100px] rounded-full pointer-events-none"></div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-12 items-center relative z-10">
            <div className="lg:col-span-7 text-left">
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 text-[9px] sm:text-[10px] font-black uppercase tracking-[0.2em] mb-5">
                <Gem size={13}/> Programa Partner B2B • Marca Blanca
              </div>
              <h2 className="text-3xl sm:text-5xl font-editorial font-medium text-white mb-4 leading-tight">
                ¿Eres Wedding Planner, Salón o Agencia de Eventos?
              </h2>
              <p className="text-slate-300 text-sm sm:text-base font-light leading-relaxed mb-6">
                Diferénciate de tu competencia entregando a tus clientes una <b>Bóveda de Control e Invitaciones bajo tu propia marca (White-Label)</b>. Tu logotipo, tus colores corporativos, precios preferenciales de socio y un panel maestro para administrar múltiples bodas y eventos en simultáneo.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-7">
                {[
                  { t: 'Tu Propia Marca', d: 'Tus novios ven el logotipo y sello de tu agencia en su panel.' },
                  { t: 'Control Multievento', d: 'Supervisa listas, croquis 2D y recepciones QR desde una sola cuenta.' },
                  { t: 'Margen Preferencial', d: 'Tarifas exclusivas para Planners y prioridad en Taller de Impresión.' }
                ].map((item, i) => (
                  <div key={i} className="p-3.5 rounded-2xl bg-white/[0.04] border border-white/10">
                    <h4 className="text-amber-400 font-bold text-xs mb-1">{item.t}</h4>
                    <p className="text-slate-400 text-[11px] leading-relaxed">{item.d}</p>
                  </div>
                ))}
              </div>

              <button 
                type="button"
                onClick={() => window.open('https://wa.me/529222107575?text=Hola,%20soy%20Wedding%20Planner%20/%20Agencia%20y%20quiero%20información%20del%20Programa%20Partner%20Baulia', '_blank')} 
                className="w-full sm:w-auto px-8 py-4 bg-white hover:bg-amber-400 text-slate-950 font-black rounded-2xl transition-all text-xs uppercase tracking-widest shadow-xl flex items-center justify-center gap-2"
              >
                Solicitar Alianzas y Precios Partner <ArrowRight size={15}/>
              </button>
            </div>

            {/* Tarjeta Visual del Workspace Pro para Planners */}
            <div className="lg:col-span-5 w-full">
              <div className="bg-[#050505] rounded-[2rem] border border-white/10 p-6 sm:p-7 shadow-2xl">
                <div className="flex items-center justify-between mb-6 pb-4 border-b border-white/10">
                  <div className="flex items-center gap-3.5">
                    <div className="w-11 h-11 rounded-2xl bg-gradient-to-tr from-amber-500 to-yellow-300 flex items-center justify-center text-slate-950 font-editorial font-bold text-xl shadow-md">
                      E
                    </div>
                    <div>
                      <p className="text-white font-bold text-sm sm:text-base leading-tight">Elite Planners Studio</p>
                      <p className="text-amber-400 text-[9px] font-black uppercase tracking-widest mt-0.5">Panel Maestro White-Label</p>
                    </div>
                  </div>
                  <span className="px-2.5 py-1 rounded-full bg-emerald-500/15 text-emerald-400 text-[8px] font-black uppercase tracking-wider border border-emerald-500/30">
                    Partner Activo
                  </span>
                </div>

                <div className="space-y-2.5">
                  {[
                    { ev: 'Boda Sofía & Alejandro', fec: '23 Mayo • 240 Pases', st: 'Croquis 2D Listo' },
                    { ev: 'XV Años Valentina', fec: '14 Junio • 180 Pases', st: 'Kit VIP Enviado' },
                    { ev: 'Gala Anual Corporativa', fec: '08 Julio • 400 Pases', st: 'RSVP Activo' }
                  ].map((row, idx) => (
                    <div key={idx} className="p-3 rounded-xl bg-white/[0.04] border border-white/5 flex items-center justify-between gap-2">
                      <div className="min-w-0">
                        <p className="text-white font-bold text-xs truncate">{row.ev}</p>
                        <p className="text-slate-400 text-[10px]">{row.fec}</p>
                      </div>
                      <span className="text-[8px] font-black uppercase tracking-wider px-2 py-1 rounded-md bg-amber-500/15 text-amber-300 shrink-0">
                        {row.st}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </RevealSection>
      </section>

      {/* ========================================== */}
      {/* 🟢 PREGUNTAS FRECUENTES (FAQ AMPLIADO Y ESTRATÉGICO) */}
      {/* ========================================== */}
      <section id="faq" className="py-24 px-4 md:px-8 max-w-4xl mx-auto relative z-10">
        <RevealSection className="text-center mb-14">
          <span className="text-amber-600 dark:text-amber-500 font-bold tracking-widest uppercase text-xs mb-3 block">
            Transparencia Total
          </span>
          <h2 className="text-3xl sm:text-5xl font-editorial font-medium text-slate-900 dark:text-white mb-4 transition-colors">
            Dudas Frecuentes
          </h2>
          <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base font-light max-w-xl mx-auto">
            Todo lo que necesitas saber sobre el diseño de tu invitación, tu Bóveda Privada y el envío de tu Caja VIP.
          </p>
        </RevealSection>

        <div className="space-y-2">
          {[
            { 
              q: '¿Mis invitados o mi staff tienen que descargar alguna aplicación?', 
              a: 'No, cero descargas. Tanto tu invitación interactiva como el Muro Social y el Escáner QR de recepción funcionan al instante desde el navegador de cualquier celular (Safari en iPhone o Chrome en Android).' 
            },
            { 
              q: '¿Puedo contratar hoy aunque aún no tenga todas mis fotos o mi lista final de invitados?', 
              a: '¡Sí! De hecho es lo más recomendable para asegurar tu promoción vigente. Al reservar recibes las llaves de tu Bóveda Privada de inmediato y puedes ir cargando o modificando tus fotografías, horarios, ubicaciones GPS y lista de invitados a tu propio ritmo.' 
            },
            { 
              q: '¿Cómo funciona el envío gratis de la Caja VIP en Social Wall y Black Label?', 
              a: 'Una vez que personalizas tus tarjetas de mesa o tus brazaletes Tyvek dentro de tu panel (con tu logotipo, nombre del evento y color elegido), presionas "Enviar a Taller Baulia". Nosotros absorbemos el costo de impresión, empaque en nuestra Caja VIP de colección y el envío directo a tu domicilio dentro de México. Además, siempre cuentas con el botón de descarga en PDF vectorial por si necesitas imprimir pases de último minuto.' 
            },
            { 
              q: '¿Cómo evita Baulia los colados el día del evento?', 
              a: 'A partir del Plan Oro, cada invitación es única y está blindada. Si asignas 4 lugares a la Familia Montemayor, el sistema genera únicamente 4 códigos QR encriptados con su número de mesa. Cuando llegan a la puerta y tu Hostess o cadenero los escanea con su celular, el sistema descuenta el ingreso en tiempo real e impide que un código vuelto a reenviar por WhatsApp pase dos veces.' 
            },
            { 
              q: '¿Qué pasa si cambio a alguien de mesa un día antes de la fiesta?', 
              a: 'Como los Pases QR de Baulia están conectados en vivo a la nube, cualquier ajuste que hagas en tu Bóveda o en tu Croquis 2D actualiza automáticamente el número de mesa en el celular de tu invitado y en el escáner de la Hostess, sin tener que reenviar enlaces.' 
            },
            { 
              q: '¿Cobran alguna comisión por la Lluvia de Sobres o Mesa de Regalos?', 
              a: '0% de comisión. En la modalidad de Lluvia de Sobres Digital, tus invitados copian tu cuenta CLABE en un toque y te transfieren directamente a tu banco sin intermediarios. También puedes enlazar tus mesas de regalos de Liverpool, El Palacio de Hierro, Amazon o cualquier tienda.' 
            },
            { 
              q: '¿Puedo empezar con un plan Básico o Plata y subir a Oro o Diamante más adelante?', 
              a: 'Por supuesto. Dentro de tu Bóveda Baulia puedes desbloquear un nivel superior o activar complementos como Social Wall y Black Label en cualquier momento cubriendo únicamente la diferencia.' 
            },
            { 
              q: '¿Por cuánto tiempo estará activa mi invitación y mi Bóveda de control?', 
              a: 'Es un pago único sin mensualidades. Tu cuenta permanece activa desde el minuto en que contratas hasta 30 días naturales después de la fecha de tu evento, dándote tiempo de sobra para descargar todas las fotografías de alta resolución del Social Wall y tus reportes finales.' 
            },
            { 
              q: '¿Qué métodos de pago aceptan y qué tan inmediata es la entrega?', 
              a: 'Aceptamos todas las tarjetas de crédito y débito, transferencia interbancaria SPEI y pago en efectivo en OXXO a través de la pasarela encriptada de Stripe. En cuanto se confirma tu pago, tus credenciales de acceso se envían automáticamente a tu correo electrónico.' 
            }
          ].map((faq, idx) => (
            <RevealSection key={idx} delay={idx * 60}>
              <details className="group bg-white/60 dark:bg-white/[0.02] border border-slate-200/80 dark:border-white/10 rounded-2xl px-5 sm:px-6 py-4 sm:py-5 transition-all duration-300 cursor-pointer hover:border-amber-500/40">
                <summary className="font-bold text-sm sm:text-base text-slate-800 dark:text-white list-none flex justify-between items-center gap-4 select-none outline-none transition-colors">
                  <span>{faq.q}</span>
                  <span className="w-7 h-7 rounded-full bg-slate-100 dark:bg-white/10 flex items-center justify-center text-amber-500 shrink-0 group-open:rotate-45 transition-transform duration-300">
                    <Plus size={16} />
                  </span>
                </summary>
                <p className="mt-3.5 pt-3 border-t border-slate-100 dark:border-white/5 text-slate-600 dark:text-slate-400 leading-relaxed text-xs sm:text-sm font-light animate-in fade-in transition-colors">
                  {faq.a}
                </p>
              </details>
            </RevealSection>
          ))}
        </div>
      </section>

      {/* FOOTER VIP EDITORIAL */}
      <footer className="border-t border-slate-200 dark:border-white/5 bg-white dark:bg-[#050505] pt-20 pb-10 relative z-10 transition-colors duration-700">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-5 gap-12 mb-16">
           <div className="md:col-span-2">
              <div className="flex items-center gap-3 mb-6">
                 <BauliaLogo className="h-10 w-auto" forceWhite={true} />
              </div>
              
              <h4 className="text-slate-900 dark:text-white font-bold mb-4 tracking-widest uppercase text-[10px] transition-colors">Nuestra Visión</h4>
              <p className="text-slate-500 dark:text-slate-400 text-sm font-light leading-relaxed max-w-sm mb-8 transition-colors">
                Elevar el estándar de la industria mediante diseño de alta costura y software de élite. Elegancia en la invitación, poder absoluto en la ejecución.
              </p>
              
              <div className="flex space-x-3">
                 <button onClick={() => window.open('https://www.instagram.com/bauliaoficial/', '_blank')} className="w-10 h-10 rounded-full bg-slate-50 dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 border border-slate-200 dark:border-white/5 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors" title="Instagram">
                   <IconIG />
                 </button>
                 <button onClick={() => window.open('https://www.facebook.com/bauliaoficial', '_blank')} className="w-10 h-10 rounded-full bg-slate-50 dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 border border-slate-200 dark:border-white/5 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors" title="Facebook">
                   <IconFB />
                 </button>
                 <button onClick={() => window.open('https://tiktok.com/@baulia', '_blank')} className="w-10 h-10 rounded-full bg-slate-50 dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 border border-slate-200 dark:border-white/5 flex items-center justify-center text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors" title="TikTok">
                   <IconTK />
                 </button>
              </div>
           </div>
           
           <div>
              <h4 className="text-slate-900 dark:text-white font-bold mb-6 tracking-widest uppercase text-[10px] transition-colors">Plataforma</h4>
              <ul className="space-y-4 text-xs text-slate-500 font-medium transition-colors">
                 <li><a href="#showroom" className="hover:text-slate-900 dark:hover:text-white transition-colors">Características</a></li>
                 <li><a href="#planes" className="hover:text-slate-900 dark:hover:text-white transition-colors">Colección</a></li>
                 <li><a href="#planners" className="hover:text-slate-900 dark:hover:text-white transition-colors">Para Planners</a></li>
                 <li><button onClick={() => setShowPanelAnatomy(true)} className="hover:text-amber-600 dark:hover:text-amber-400 transition-colors">Arquitectura del Sistema</button></li>
                 <li><button onClick={() => window.location.href = 'https://panel.baulia.com'} className="hover:text-slate-900 dark:hover:text-white transition-colors">Login Clientes</button></li>
              </ul>
           </div>
           
           <div>
              <h4 className="text-slate-900 dark:text-white font-bold mb-6 tracking-widest uppercase text-[10px] transition-colors">Compañía</h4>
              <ul className="space-y-4 text-xs text-slate-500 font-medium transition-colors">
                 <li><button onClick={() => setShowAnatomy(true)} className="text-amber-600 dark:text-amber-500 font-bold hover:text-slate-900 dark:hover:text-white transition-colors">Baulia Magazine</button></li>
                 <li><button onClick={() => setLegalModal('about_us')} className="hover:text-slate-900 dark:hover:text-white transition-colors">Quiénes Somos</button></li>
                 <li><button onClick={() => window.open('mailto:hola@baulia.com')} className="hover:text-slate-900 dark:hover:text-white transition-colors flex items-center">hola@baulia.com</button></li>
              </ul>
           </div>

           <div>
              <h4 className="text-slate-900 dark:text-white font-bold mb-6 tracking-widest uppercase text-[10px] transition-colors">Legal</h4>
              <ul className="space-y-4 text-xs text-slate-500 font-medium transition-colors">
                 <li><button onClick={() => setLegalModal('terms')} className="hover:text-slate-900 dark:hover:text-white transition-colors">Términos de Servicio</button></li>
                 <li><button onClick={() => setLegalModal('privacy')} className="hover:text-slate-900 dark:hover:text-white transition-colors">Aviso de Privacidad</button></li>
              </ul>
           </div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 border-t border-slate-200 dark:border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-6 transition-colors">
           <div className="flex items-center gap-3 px-4 py-2 bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-xl shadow-sm transition-colors">
              <ShieldCheck size={16} className="text-emerald-500 dark:text-emerald-400" />
              <span className="text-[9px] text-slate-500 dark:text-slate-400 uppercase tracking-widest font-bold">
                Pagos encriptados y procesados por <span className="text-slate-800 dark:text-white">Stripe</span>
              </span>
           </div>

           <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-right">
             <p className="text-[9px] text-slate-400 uppercase tracking-widest transition-colors">&copy; {new Date().getFullYear()} Baulia Technologies.</p>
             <div className="hidden md:block w-1 h-1 rounded-full bg-slate-300 dark:bg-slate-700"></div>
             <p className="text-[9px] text-slate-500 font-bold flex items-center justify-center uppercase tracking-widest transition-colors">
                Hecho con <Heart size={10} className="mx-1.5 fill-slate-300 dark:fill-slate-700 text-slate-300 dark:text-slate-700"/> en México.
             </p>
           </div>
        </div>
      </footer>

      {/* 🔴 OVERLAY: DEMO A PANTALLA COMPLETA (VISOR INTERNO MÓVIL) */}
      {fullScreenDemo && (
        <div className="fixed inset-0 z-[999999] bg-black flex flex-col h-[100dvh] overscroll-none touch-none">
           
           {/* HEADER PARA CERRAR EL DEMO */}
           <div className="bg-[#050505] border-b border-white/10 px-4 py-4 flex items-center justify-between z-10 shadow-md">
               <div className="flex items-center gap-2 text-white">
                  <span className="text-xs font-editorial font-bold italic tracking-widest text-white">Baulia</span>
                  <span className="text-[10px] text-slate-400 font-bold uppercase tracking-widest border-l border-white/20 pl-2 ml-1">Demo en Vivo</span>
               </div>
               <button 
                 type="button"
                 onClick={() => setFullScreenDemo(null)} 
                 className="bg-white/10 hover:bg-rose-500 text-white px-5 py-2 rounded-full font-bold text-[10px] uppercase tracking-widest transition-colors flex items-center border border-white/10 shadow-sm"
               >
                  <X size={14} className="mr-1.5" /> Volver
               </button>
           </div>

           {/* IFRAME DE LA INVITACIÓN */}
           <iframe 
             src={fullScreenDemo} 
             className="w-full flex-1 border-0 bg-white" 
             title="Demo a Pantalla Completa"
           />
        </div>
      )}

      </div> {/* <--- CIERRE DEL WRAPPER DEL CONTENIDO PRINCIPAL */}

      {/* MODALES LEGALES Y ACERCA DE (OVERLAYS) */}
      {legalModal && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 dark:bg-slate-900/90 backdrop-blur-md flex justify-center items-center p-4 md:p-8 animate-in fade-in duration-200">
          <div className="bg-white dark:bg-[#0a0a0a] border border-slate-200 dark:border-white/10 w-full max-w-3xl h-[80vh] rounded-[2rem] shadow-2xl flex flex-col relative overflow-hidden animate-in zoom-in-95 transition-colors duration-300">
            
            <div className="p-6 md:p-8 border-b border-slate-100 dark:border-white/5 flex justify-between items-center bg-slate-50 dark:bg-[#050505] shrink-0 transition-colors">
              <h2 className="text-xl font-editorial font-bold text-slate-900 dark:text-white tracking-wide transition-colors">
                {legalModal === 'terms' ? 'Términos de Servicio' : legalModal === 'privacy' ? 'Aviso de Privacidad' : legalModal === 'about_us' ? 'Quiénes Somos' : 'La Visión Baulia'}
              </h2>
              <button onClick={() => setLegalModal(null)} className="p-2 bg-white dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 rounded-full transition-colors text-slate-500 border border-slate-200 dark:border-transparent">
                <X size={16} />
              </button>
            </div>
            
            <div className="p-6 md:p-10 overflow-y-auto flex-1 text-slate-600 dark:text-slate-400 text-sm leading-relaxed space-y-6 custom-scrollbar transition-colors font-light">
              {legalModal === 'terms' && (
                <div className="space-y-4">
                  <p><strong>Última actualización:</strong> {new Date().toLocaleDateString('es-MX')}</p>
                  <p>Bienvenido a Baulia. Estos Términos de Servicio ("Términos") regulan el uso de nuestra plataforma web, panel de control y servicios relacionados. Al acceder o utilizar Baulia, usted ("el Usuario", "el Cliente" o "el Planner") acepta estar sujeto a estos Términos.</p>
                  <h3 className="text-base font-bold text-slate-900 dark:text-white mt-8 mb-2 font-editorial transition-colors">1. Descripción del Servicio</h3>
                  <p>Baulia provee un entorno digital (Software as a Service) para la gestión y logística de eventos, que incluye pero no se limita a: creación de invitaciones web, gestión de confirmaciones (RSVP), acomodo de mesas, control financiero, muros sociales interactivos y escaneo de pases QR.</p>
                  <h3 className="text-base font-bold text-slate-900 dark:text-white mt-8 mb-2 font-editorial transition-colors">2. Pagos y Suscripciones</h3>
                  <p>El pago del Servicio consiste en una tarifa única por evento. La licencia otorga acceso al panel de control desde el momento del pago hasta 30 días naturales posteriores a la fecha del evento programado.</p>
                </div>
              )}
              {legalModal === 'privacy' && (
                <div className="space-y-4">
                  <p><strong>Última actualización:</strong> {new Date().toLocaleDateString('es-MX')}</p>
                  <p>En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) de México, <strong>Baulia Technologies</strong> expide el presente Aviso de Privacidad.</p>
                  
                  <h3 className="text-base font-bold text-slate-900 dark:text-white mt-8 mb-2 font-editorial transition-colors">1. Protección de Pagos y Datos Financieros</h3>
                  <div className="bg-emerald-50 dark:bg-emerald-500/10 border border-emerald-200 dark:border-emerald-500/20 p-4 rounded-xl text-emerald-800 dark:text-emerald-300 mb-4">
                    <p><strong>Baulia NO recopila, NO procesa y NO almacena datos de tarjetas de crédito o débito.</strong></p>
                    <p className="mt-2">Todas las transacciones financieras son procesadas de manera externa, encriptada y segura a través de <strong>Stripe, Inc.</strong>, un proveedor de pagos de nivel internacional certificado bajo las estrictas normas de seguridad bancaria <strong>PCI-DSS</strong>.</p>
                  </div>

                  <h3 className="text-base font-bold text-slate-900 dark:text-white mt-8 mb-2 font-editorial transition-colors">2. Datos Recabados</h3>
                  <p>Para la correcta prestación de nuestros servicios de gestión de eventos, Baulia únicamente almacena en servidores seguros de Google (Firebase):</p>
                  <ul className="list-disc pl-6 space-y-2 mt-2">
                    <li><strong>Del Administrador:</strong> Nombres, correo electrónico de contacto y datos generales del evento.</li>
                    <li><strong>De los Invitados:</strong> Nombres, estado de confirmación de asistencia (RSVP) y fotografías subidas voluntariamente al muro social.</li>
                  </ul>
                </div>
              )}
              {legalModal === 'about_us' && (
                <div className="space-y-4">
                  <div className="flex flex-col items-center text-center mb-8 mt-4">
                    <BauliaLogo className="h-12 w-auto mb-6 opacity-80" />
                    <h3 className="text-2xl font-editorial font-medium text-slate-900 dark:text-white tracking-widest uppercase transition-colors">Nuestra Historia</h3>
                  </div>
                  <p className="mb-4">Nacimos de una premisa simple pero poderosa: la tecnología detrás de los eventos más importantes de tu vida no debería ser aburrida, genérica ni complicada. Debería ser tan espectacular como el evento mismo.</p>
                  <p className="mb-4">En Baulia, operamos como un Estudio de Alta Costura Digital. Somos un equipo de diseñadores, ingenieros de software y expertos en hospitalidad obsesionados con la perfection. Fusionamos el arte del diseño inmersivo con el poder del código moderno para crear una experiencia impecable desde que se envía la primera invitación, hasta el último baile de la noche.</p>
                  <p className="mb-4">Nuestra Bóveda Inteligente no es solo un gestor de invitados, es tu Centro de Comando. Hemos ayudado a cientos de anfitriones y agencias a eliminar el estrés de la planificación, dándoles el control absoluto para que puedan enfocarse en lo que realmente importa: celebrar el amor, el éxito y la vida.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: PANEL DE ADMINISTRACIÓN PROTEGIDO ---
// ==========================================
const SuperAdminView = ({ onImpersonate, authData }) => {
  const [adminTab, setAdminTab] = useState('licencias'); 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  
  const [formData, setFormData] = useState({ nombres: '', email: '', telefono: '', plan: 'diamante', tipoEvento: 'boda', role: 'cliente', urlInvitacion: '', referenciaPago: '', fechaEvento: '', horaEvento: '18:00', isQrEnabled: true, isPassCountEnabled: true, hasSocialWall: false, hasBlackLabel: false, codigoCupon: '', esAnticipo: false });
  const [editingLic, setEditingLic] = useState(null);
  const [configPrecios, setConfigPrecios] = useState({
    promocion: { activa: false, porcentaje: 50, productos: { basico: true, plata: true, oro: true, diamante: true, social_wall: false, black_label: true } },
    preciosBase: { basico: { MXN: 990 }, plata: { MXN: 1490 }, oro: { MXN: 1990 }, diamante: { MXN: 2990 }, social_wall: { MXN: 1490 }, black_label: { MXN: 1490 } },
    anticipos: { activo: false, porcentaje: 10 },
    cupones: [],
    preventasPendientes: {}
  });

  const [isCreating, setIsCreating] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const [clientPhone, setClientPhone] = useState('');
  
  const [licencias, setLicencias] = useState([]);
  const [resenasList, setResenasList] = useState([]);
  const [ventas, setVentas] = useState([]); 
  
  const [pedidosTaller, setPedidosTaller] = useState([]);
  const [ordenActiva, setOrdenActiva] = useState(null);
  const [isFetchingOrden, setIsFetchingOrden] = useState(false);

  const [correosVisibles, setCorreosVisibles] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [tallerSearchQuery, setTallerSearchQuery] = useState('');
  
  const currentMonthYear = new Date().toISOString().slice(0, 7);
  const [mesSeleccionado, setMesSeleccionado] = useState(currentMonthYear);

  const [dialog, setDialog] = useState({ isOpen: false, type: 'alert', title: '', message: '', onConfirm: null });

  // 🟢 ESTADOS EXCLUSIVOS SUPERADMIN: MODO PRUEBA Y REINICIO DE FINANZAS
  const [modoPrueba, setModoPrueba] = useState(false);
  const [modoPruebaDesde, setModoPruebaDesde] = useState(0);
  const [isResettingFinanzas, setIsResettingFinanzas] = useState(false);

  const isSuperAdmin = authData?.role === 'superadmin';

  // 🟢 PRECIOS DINÁMICOS CONECTADOS A TU GESTOR DE PRECIOS Y PROMOCIONES EN VIVO
  const PRECIOS = React.useMemo(() => {
    const calcular = (keyConfig, fallback) => {
      const base = Number(configPrecios.preciosBase?.[keyConfig]?.MXN) || fallback;
      const promoActiva = configPrecios.promocion?.activa && configPrecios.promocion?.productos?.[keyConfig];
      const pct = Number(configPrecios.promocion?.porcentaje) || 0;
      return promoActiva ? Math.round(base * (1 - pct / 100)) : base;
    };
    return {
      basico: calcular('basico', 990),
      plata: calcular('plata', 1490),
      oro: calcular('oro', 1990),
      diamante: calcular('diamante', 2990),
      social_wall: calcular('social_wall', 1490),
      security_kit: calcular('black_label', 1490)
    };
  }, [configPrecios]);

  const tiposDeEvento = [
    { id: 'boda', label: 'Boda', placeholder: 'Ej. Carlos y Sofia', labelNombre: 'Nombre de los Novios' },
    { id: 'xv_anos', label: 'XV Años', placeholder: 'Ej. Maria Fernanda', labelNombre: 'Nombre de la Quinceañera' },
    { id: 'cumpleanos', label: 'Cumpleaños', placeholder: 'Ej. Juan Perez', labelNombre: 'Nombre del Festejado' },
    { id: 'empresarial', label: 'Empresarial', placeholder: 'Ej. Convencion Telcel', labelNombre: 'Nombre de la Empresa' },
    { id: 'general', label: 'General / Otro', placeholder: 'Ej. Posada Anual', labelNombre: 'Nombre del Evento' }
  ];

  const eventoSeleccionado = tiposDeEvento.find(t => t.id === formData.tipoEvento) || tiposDeEvento[0];

  useEffect(() => {
    const getSafeTime = (field) => {
      if (!field) return 0;
      if (typeof field.toMillis === 'function') return field.toMillis();
      if (field.seconds) return field.seconds * 1000;
      return 0;
    };

    const unsubAjustes = onSnapshot(doc(db, "ajustes_baulia", "precios_publicos"), (docSnap) => {
      if (docSnap.exists()) {
        const d = docSnap.data();
        setModoPrueba(d.modoPrueba === true);
        setModoPruebaDesde(d.modoPruebaDesde || 0);
        setConfigPrecios(prev => ({
          ...prev,
          ...d,
          anticipos: d.anticipos || { activo: false, porcentaje: 10 },
          cupones: d.cupones || [],
          preventasPendientes: d.preventasPendientes || {}
        }));
      }
    });

    const unsubLic = onSnapshot(collection(db, "usuarios"), (snap) => {
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const clientes = data.filter(u => u.role !== 'superadmin' && u.role !== 'staff');
      clientes.sort((a, b) => getSafeTime(b.createdAt) - getSafeTime(a.createdAt));
      setLicencias(clientes);
    });

    const unsubRes = onSnapshot(collection(db, "resenas"), (snap) => {
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      data.sort((a, b) => getSafeTime(b.createdAt) - getSafeTime(a.createdAt));
      setResenasList(data);
    });

    const unsubVentas = onSnapshot(collection(db, "ventas"), (snap) => {
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      data.sort((a, b) => getSafeTime(b.fecha) - getSafeTime(a.fecha));
      setVentas(data);
    });

    const unsubEventosTaller = onSnapshot(collection(db, "eventos"), (snap) => {
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const pedidos = [];
      data.forEach(e => {
        if (e.pulserasStatus === 'enviado' || e.pulserasStatus === 'impreso') {
          pedidos.push({
            ...e,
            orderUniqueKey: `${e.id}_pulseras`,
            orderType: 'pulseras',
            orderStatus: e.pulserasStatus,
            orderDate: e.fechaEnvioTaller
          });
        }
        if (e.socialWallStatus === 'enviado' || e.socialWallStatus === 'impreso') {
          pedidos.push({
            ...e,
            orderUniqueKey: `${e.id}_social_wall`,
            orderType: 'social_wall',
            orderStatus: e.socialWallStatus,
            orderDate: e.fechaEnvioSocialWall
          });
        }
      });
      pedidos.sort((a, b) => new Date(b.orderDate || 0) - new Date(a.orderDate || 0));
      setPedidosTaller(pedidos);
    });

    return () => { unsubAjustes(); unsubLic(); unsubRes(); unsubVentas(); unsubEventosTaller(); };
  }, []);

  // 🟢 Si entra una compra por Stripe mientras Modo Prueba está encendido, la marca automáticamente como prueba para no sumar en Finanzas
  useEffect(() => {
    if (!isSuperAdmin || !modoPrueba || !modoPruebaDesde) return;
    ventas.forEach(v => {
      const vTime = v.fecha?.toMillis ? v.fecha.toMillis() : (v.fecha?.seconds ? v.fecha.seconds * 1000 : 0);
      if (v.esPrueba !== true && vTime >= modoPruebaDesde) {
        updateDoc(doc(db, "ventas", v.id), { esPrueba: true }).catch(() => {});
        updateDoc(doc(db, "usuarios", v.id), { esPrueba: true }).catch(() => {});
      }
    });
  }, [ventas, modoPrueba, modoPruebaDesde, isSuperAdmin]);

  // 🟢 SINCRONIZADOR AUTOMÁTICO DE ANTICIPOS Y LIQUIDACIONES DE STRIPE
  useEffect(() => {
    if (!licencias.length) return;
    licencias.forEach(async (lic) => {
      const targetEventId = lic.eventId || lic.id;

      // 1. Si es un pago de LIQUIDACIÓN hecho desde la bóveda del cliente por Stripe:
      if (lic.nombres && String(lic.nombres).startsWith('LIQUIDACION_')) {
        const originalEventId = String(lic.nombres).replace('LIQUIDACION_', '').trim();
        if (originalEventId) {
          await setDoc(doc(db, "usuarios", originalEventId), { deudaPlataforma: 0, bloqueadoPorPago: false }, { merge: true }).catch(() => {});
          await setDoc(doc(db, "eventos", originalEventId), { deudaPlataforma: 0, bloqueadoPorPago: false }, { merge: true }).catch(() => {});
          await deleteDoc(doc(db, "usuarios", lic.id)).catch(() => {});
          await deleteDoc(doc(db, "eventos", lic.id)).catch(() => {});
        }
        return;
      }

      // 2. Si es una compra anterior que aún no tiene sellada su deudaPlataforma, solo la calculamos cuando su venta ya cargó:
      if (lic.deudaPlataforma === undefined) {
        const emailKey = (lic.email || '').trim().toLowerCase();
        const preventa = configPrecios.preventasPendientes?.[emailKey];
        const ventaDoc = ventas.find(v => v.id === lic.id || v.id === targetEventId);
        if (!ventaDoc && !preventa) return; // Esperamos a que cargue la venta para no pisar con $0

        const montoPagadoStripe = ventaDoc ? Number(ventaDoc.monto) : 0;
        const precioEsperadoPlan = PRECIOS[lic.plan] || 0;
        const pctAnticipo = Number(configPrecios.anticipos?.porcentaje) || 10;

        let deudaDetectada = Number(ventaDoc?.deudaPendiente) || 0;
        if (!deudaDetectada && preventa && Number(preventa.deudaPlataforma) > 0 && (Date.now() - (preventa.timestamp || 0) < 86400000)) {
          deudaDetectada = Number(preventa.deudaPlataforma);
        } else if (!deudaDetectada && montoPagadoStripe > 0 && precioEsperadoPlan > 0 && montoPagadoStripe <= precioEsperadoPlan * 0.65) {
          const totalConDescuento = Math.round(montoPagadoStripe / (pctAnticipo / 100));
          deudaDetectada = Math.max(0, totalConDescuento - montoPagadoStripe);
        }

        await setDoc(doc(db, "usuarios", lic.id), {
          deudaPlataforma: deudaDetectada,
          bloqueadoPorPago: false
        }, { merge: true }).catch(() => {});

        await setDoc(doc(db, "eventos", targetEventId), {
          nombres: lic.nombres || 'Evento Baulia',
          plan: lic.plan || 'diamante',
          deudaPlataforma: deudaDetectada,
          bloqueadoPorPago: false
        }, { merge: true }).catch(() => {});
      }
    });
  }, [licencias, ventas, configPrecios, PRECIOS]);

  const toggleModoPrueba = async () => {
    if (!isSuperAdmin) return;
    const nuevoEstado = !modoPrueba;
    const ahora = Date.now();
    setModoPrueba(nuevoEstado);
    if (nuevoEstado) setModoPruebaDesde(ahora);
    try {
      await setDoc(doc(db, "ajustes_baulia", "precios_publicos"), {
        modoPrueba: nuevoEstado,
        ...(nuevoEstado ? { modoPruebaDesde: ahora } : {})
      }, { merge: true });
    } catch (e) { console.error(e); }
  };

  const handleReiniciarFinanzas = () => {
    if (!isSuperAdmin) return;
    setDialog({
      isOpen: true,
      type: 'confirm',
      title: '¿Reiniciar Finanzas a $0?',
      message: '⚠️ Se borrarán todas las transacciones registradas en Finanzas para dejar el contador limpio en $0.00 (las bóvedas de tus clientes NO se eliminarán). ¿Deseas continuar?',
      onConfirm: async () => {
        setDialog({ ...dialog, isOpen: false });
        setIsResettingFinanzas(true);
        try {
          const snap = await getDocs(collection(db, "ventas"));
          await Promise.all(snap.docs.map(d => deleteDoc(doc(db, "ventas", d.id))));
          setDialog({ isOpen: true, type: 'alert', title: '¡Finanzas en $0.00!', message: 'Todos los registros anteriores fueron eliminados. Tu contabilidad está en cero.' });
        } catch (err) {
          setDialog({ isOpen: true, type: 'alert', title: 'Error', message: 'Fallo al reiniciar finanzas: ' + err.message });
        }
        setIsResettingFinanzas(false);
      }
    });
  };

  const procesarOrdenTaller = async (evento) => {
    setIsFetchingOrden(true);
    try {
      if (evento.orderType === 'social_wall') {
        const cardCfg = evento.socialWallCardConfig || {};
        setOrdenActiva({
          orderUniqueKey: evento.orderUniqueKey,
          orderType: 'social_wall',
          eventoId: evento.id,
          nombres: evento.nombres || 'Cliente Baulia',
          cliente: evento.nombres || 'Cliente Baulia',
          fechaPedido: evento.fechaEnvioSocialWall,
          cardConfig: {
            preTitle: cardCfg.preTitle || 'EVENTO ESPECIAL',
            eventName: cardCfg.eventName || evento.nombres || 'Evento Baulia',
            subtitle: cardCfg.subtitle || 'Escanea, sube tus fotos y cumple los retos en pantalla',
            logoUrl: cardCfg.logoUrl || '',
            bgImageUrl: cardCfg.bgImageUrl || '',
            cantidadTarjetas: Number(cardCfg.cantidadTarjetas) || 15,
            papelId: cardCfg.papelId || 'blanco_galeria',
            fontId: cardCfg.fontId || 'editorial',
            accentColor: cardCfg.accentColor || '#B45309',
            heredarInvitacion: cardCfg.heredarInvitacion || false
          },
          hashtag: evento.galeriaConfig?.hashtag || '#MiEvento',
          fechaEvento: evento.fecha,
          status: evento.socialWallStatus,
          direccionEnvioTaller: evento.direccionEnvioSocialWall || evento.direccionEnvioTaller
        });
        setIsFetchingOrden(false);
        return;
      }

      const listRef = collection(db, "eventos", evento.id, "invitados");
      const listSnap = await getDocs(listRef);
      const invitadosDB = listSnap.docs.map(d => ({ id: d.id, ...d.data() }));
      
      const invitadosVIP = invitadosDB.filter(g => g.status === 'confirmado' || g.status === 'ingreso' || (g.passes && g.passes > 0));

      const flattened = [];
      invitadosVIP.forEach(guest => {
        if (guest.subGuests && guest.subGuests.length > 0) {
            guest.subGuests.forEach((sg) => {
              flattened.push({
                idReal: sg.id,
                nombreAImprimir: sg.name || (sg.isChild ? 'Niño' : 'Acompañante'),
                esNino: sg.isChild,
                qrDataUrl: sg.id 
              });
            });
        } else {
            flattened.push({
                idReal: guest.id,
                nombreAImprimir: guest.name || 'Invitado VIP',
                esNino: false,
                qrDataUrl: guest.id
            });
        }
      });

      setOrdenActiva({
         orderUniqueKey: evento.orderUniqueKey,
         orderType: 'pulseras',
         eventoId: evento.id,
         nombres: evento.nombres || 'Cliente Desconocido',
         cliente: evento.nombres || 'Cliente Desconocido',
         fechaPedido: evento.fechaEnvioTaller,
         config: evento.pulserasConfig || {},
         fechaEvento: evento.fecha,
         listaImpresion: flattened,
         status: evento.pulserasStatus,
         direccionEnvioTaller: evento.direccionEnvioTaller 
      });
    } catch (error) {
      console.error("Error procesando orden:", error);
      setDialog({ isOpen: true, type: 'alert', title: 'Error', message: 'No se pudo descargar la lista de este evento.' });
    }
    setIsFetchingOrden(false);
  };

  const marcarComoImpreso = async () => {
     try {
        const field = ordenActiva.orderType === 'social_wall' ? 'socialWallStatus' : 'pulserasStatus';
        await updateDoc(doc(db, "eventos", ordenActiva.eventoId), { [field]: 'impreso' });
        setOrdenActiva({...ordenActiva, status: 'impreso'});
        setDialog({ isOpen: true, type: 'alert', title: '¡Éxito!', message: 'El lote se marcó como impreso y despachado.' });
     } catch (error) {
        setDialog({ isOpen: true, type: 'alert', title: 'Error', message: 'Fallo al actualizar el estatus.' });
     }
  };

  const desbloquearOrden = async () => {
     setDialog({ 
         isOpen: true, 
         type: 'confirm', 
         title: 'Desbloquear Bóveda', 
         message: '¿Estás seguro que deseas regresar este pedido a modo edición? El cliente podrá modificar su diseño y la orden desaparecerá de esta bandeja hasta que vuelva a enviarla.', 
         onConfirm: async () => { 
             setDialog({ ...dialog, isOpen: false }); 
             try {
                const field = ordenActiva.orderType === 'social_wall' ? 'socialWallStatus' : 'pulserasStatus';
                await updateDoc(doc(db, "eventos", ordenActiva.eventoId), { [field]: 'pendiente' });
                setOrdenActiva(null);
             } catch (error) {
                setDialog({ isOpen: true, type: 'alert', title: 'Error', message: 'Fallo al desbloquear la orden.' });
             }
         } 
     });
  };

  const generarPDFNativo = () => {
    const printWindow = window.open('', '_blank', 'width=1100,height=850');
    if (!printWindow) return;
    const cfg = ordenActiva.config || {};
    const evtName = cfg.eventName || 'Evento VIP';
    const preTitle = cfg.preTitle || '';
    const dateStr = ordenActiva.fechaEvento ? new Date(ordenActiva.fechaEvento).toLocaleDateString('es-MX', { timeZone: 'UTC' }) : '';
    const logo = cfg.logoBase64 || '';

    const FONT_MAP = {
      caligrafia: "'Great Vibes', cursive",
      editorial: "'Cormorant Garamond', serif",
      alta_moda: "'Cinzel', serif",
      minimal: "'Montserrat', sans-serif"
    };
    const chosenFont = FONT_MAP[cfg.fontId] || FONT_MAP.caligrafia;

    const BANDS_PER_SHEET = 10;
    const sheets = [];
    for (let i = 0; i < ordenActiva.listaImpresion.length; i += BANDS_PER_SHEET) {
      sheets.push(ordenActiva.listaImpresion.slice(i, i + BANDS_PER_SHEET));
    }

    const pagesHtml = sheets.map((sheetRows) => {
      const slots = Array.from({ length: BANDS_PER_SHEET }, (_, idx) => sheetRows[idx] || null);
      const bandsHtml = slots.map((item) => {
        if (!item) {
          return `<div class="tyvek-band empty-band"></div>`;
        }
        const qrImgUrl = `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(item.qrDataUrl)}&margin=0`;
        return `
          <div class="tyvek-band">
            <div class="zone-glue"></div>
            <div class="zone-safe">
              <div class="qr-block">
                <img src="${qrImgUrl}" class="qr-2cm" crossorigin="anonymous" />
              </div>
              <div class="guest-block">
                <div class="guest-name">${item.nombreAImprimir}</div>
                <div class="guest-type">${item.esNino ? 'PASE NIÑO VIP' : 'PASE ADULTO VIP'}</div>
              </div>
              <div class="event-center-block">
                ${preTitle ? `<div class="event-pre">${preTitle}</div>` : ''}
                ${logo
                  ? `<img src="${logo}" class="event-logo" crossorigin="anonymous" />`
                  : `<div class="event-title">${evtName}</div>`
                }
                ${dateStr ? `<div class="event-date">${dateStr}</div>` : ''}
              </div>
              <div class="brand-block">
                <span>by baulia.com</span>
              </div>
            </div>
            <div class="zone-overlap"></div>
          </div>
        `;
      }).join('');

      return `<div class="tyvek-sheet">${bandsHtml}</div>`;
    }).join('');

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8" />
        <title>Producción_Tyvek_${evtName}</title>
        <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=Great+Vibes&family=Montserrat:wght@400;600;700;900&display=swap" rel="stylesheet">
        <style>
          @page { size: letter landscape; margin: 0; }
          * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          body, html { margin: 0; padding: 0; background: #ffffff; font-family: 'Montserrat', sans-serif; color: #000000; }
          .tyvek-sheet {
            width: 27.94cm;
            min-height: 21.59cm;
            page-break-after: always;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin: 0 auto;
            background: #ffffff;
          }
          .tyvek-sheet:last-child { page-break-after: auto; }
          /* Pulsera acostada horizontalmente a lo largo de la hoja (25.4 cm de largo x 2.54 cm de ancho) */
          .tyvek-band {
            width: 25.4cm;
            height: 2.54cm;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 0.25pt dashed #e2e8f0;
            position: relative;
            overflow: hidden;
            page-break-inside: avoid;
          }
          .empty-band { border-bottom: 0.25pt dashed #f1f5f9; }
          /* 3.0 cm pegamento + 17.4 cm área segura centrada + 5.0 cm cierre libre = 25.4 cm */
          .zone-glue { width: 3.0cm; height: 2.54cm; flex-shrink: 0; }
          .zone-safe {
            width: 17.4cm;
            height: 2.54cm;
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 0.35cm;
          }
          .zone-overlap { width: 5.0cm; height: 2.54cm; flex-shrink: 0; }
          .qr-block {
            width: 2.16cm;
            height: 2.16cm;
            background: #ffffff;
            padding: 0.08cm;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
          .qr-2cm { width: 2.0cm; height: 2.0cm; object-fit: contain; display: block; image-rendering: pixelated; }
          .guest-block {
            width: 4.4cm;
            padding-left: 0.3cm;
            padding-right: 0.2cm;
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex-shrink: 0;
          }
          .guest-name { font-size: 8.5pt; font-weight: 900; text-transform: uppercase; letter-spacing: 0.05em; line-height: 1.15; word-break: break-word; }
          .guest-type { font-size: 6.5pt; font-weight: 700; text-transform: uppercase; letter-spacing: 0.14em; margin-top: 2px; opacity: 0.8; }
          .event-center-block {
            flex: 1;
            height: 2.54cm;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 0 0.3cm;
            border-left: 0.5pt solid #cbd5e1;
            border-right: 0.5pt solid #cbd5e1;
          }
          .event-pre { font-size: 5.5pt; font-weight: 900; text-transform: uppercase; letter-spacing: 0.25em; margin-bottom: 1px; }
          .event-logo { height: 1.1cm; max-width: 5.5cm; object-fit: contain; margin: 1px 0; }
          .event-title { font-family: ${chosenFont}; font-size: ${cfg.fontId === 'caligrafia' || !cfg.fontId ? '17pt' : '12.5pt'}; font-weight: 700; line-height: 1.05; margin: 1px 0; }
          .event-date { font-size: 5.5pt; font-weight: 800; letter-spacing: 0.2em; text-transform: uppercase; margin-top: 1px; }
          .brand-block {
            width: 1.8cm;
            height: 2.54cm;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }
          .brand-block span {
            writing-mode: vertical-rl;
            transform: rotate(180deg);
            font-size: 6pt;
            font-weight: 900;
            letter-spacing: 0.22em;
            text-transform: uppercase;
          }
        </style>
      </head>
      <body onload="setTimeout(function(){ window.print(); }, 800)">
        ${pagesHtml}
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  // 🟢 GENERADOR PDF DE ALTA COSTURA PARA TARJETAS SOCIAL WALL (Con Marcas de Corte, Tipografía y Color de Papel)
  const generarPDFTarjetasSocialWall = () => {
    if (!ordenActiva || ordenActiva.orderType !== 'social_wall') return;
    const printWindow = window.open('', '_blank');
    const cfg = ordenActiva.cardConfig || {};
    const total = Number(cfg.cantidadTarjetas) || 15;
    const guestCameraUrl = `https://baulia.com/?modo=camara&e=${ordenActiva.eventoId}`;
    const qrImgUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(guestCameraUrl)}&margin=2`;
    const hashtag = ordenActiva.hashtag || '#MiEvento';

    const PAPER_MAP = {
      blanco_galeria: { bg: '#FFFFFF', text: '#0F172A', accent: cfg.accentColor || '#B45309', sub: '#64748B' },
      marfil_algodon: { bg: '#FDFBF7', text: '#1C1917', accent: '#9A6F1A', sub: '#78716C' },
      obsidiana: { bg: '#0B0B0E', text: '#FFFFFF', accent: '#F59E0B', sub: '#94A3B8' },
      champagne: { bg: '#F7F1E5', text: '#27272A', accent: '#A16207', sub: '#71717A' }
    };
    const FONT_MAP = {
      editorial: "'Cormorant Garamond', serif",
      caligrafia: "'Great Vibes', cursive",
      alta_moda: "'Cinzel', serif",
      minimal: "'Montserrat', sans-serif"
    };

    const paper = PAPER_MAP[cfg.papelId] || PAPER_MAP.blanco_galeria;
    const titleFont = FONT_MAP[cfg.fontId] || FONT_MAP.editorial;
    const sheetsCount = Math.ceil(total / 2);

    const renderFaceHTML = (mesaNum) => `
      <div class="face-inner" style="background-color: ${paper.bg};">
        <div class="bg-layer">
          ${cfg.bgImageUrl ? `<img src="${cfg.bgImageUrl}" class="bg-img" crossorigin="anonymous" />` : `<div class="bg-fallback"></div>`}
          <div class="bg-gradient" style="background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, ${paper.bg}99 58%, ${paper.bg} 93%, ${paper.bg} 100%);"></div>
        </div>
        <div class="face-content">
          ${cfg.logoUrl ? `<img src="${cfg.logoUrl}" class="logo-img" crossorigin="anonymous" />` : ''}
          <div class="pre-title" style="color: ${paper.accent};">${cfg.preTitle || 'SOCIAL WALL EN VIVO'}</div>
          <div class="event-name" style="font-family: ${titleFont}; color: ${paper.text};">${cfg.eventName || 'Nuestro Evento'}</div>
          <div class="subtitle" style="color: ${paper.sub};">${cfg.subtitle || 'Escanea, sube tus fotos y cumple los retos en pantalla'}</div>
          <div class="qr-box">
            <img src="${qrImgUrl}" class="qr-img" crossorigin="anonymous" />
          </div>
          <div class="hashtag" style="color: ${paper.accent};">${hashtag} • MESA ${mesaNum}</div>
          <div class="brand" style="color: ${paper.sub};">by BAULIA.COM</div>
        </div>
      </div>
    `;

    let html = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Impresión Alta Costura Social Wall - ${cfg.eventName}</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Cormorant+Garamond:ital,wght@0,600;0,700;1,600&family=Great+Vibes&family=Montserrat:wght@400;600;700;900&display=swap');
          * { box-sizing: border-box; -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
          body, html { margin: 0; padding: 0; background: #fff; font-family: 'Montserrat', sans-serif; }
          @page { size: letter portrait; margin: 0; }
          .sheet {
            width: 215.9mm;
            height: 279.4mm;
            page-break-after: always;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 8mm;
            padding: 5mm;
          }
          .sheet:last-child { page-break-after: auto; }
          .tent-wrapper {
            position: relative;
            padding: 2mm;
          }
          /* Marcas de corte profesionales tipo imprenta (Crop Marks) */
          .crop-tl, .crop-tr, .crop-bl, .crop-br {
            position: absolute; width: 4mm; height: 4mm; pointer-events: none; z-index: 20;
          }
          .crop-tl { top: 0; left: 0; border-top: 0.35mm solid #0f172a; border-left: 0.35mm solid #0f172a; }
          .crop-tr { top: 0; right: 0; border-top: 0.35mm solid #0f172a; border-right: 0.35mm solid #0f172a; }
          .crop-bl { bottom: 0; left: 0; border-bottom: 0.35mm solid #0f172a; border-left: 0.35mm solid #0f172a; }
          .crop-br { bottom: 0; right: 0; border-bottom: 0.35mm solid #0f172a; border-right: 0.35mm solid #0f172a; }

          .tent-card {
            width: 95mm;
            height: 268mm;
            border: 0.25mm solid #cbd5e1;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            background: ${paper.bg};
          }
          .tent-face {
            width: 95mm;
            height: 124mm;
            position: relative;
            overflow: hidden;
          }
          .tent-face.upside-down {
            transform: rotate(180deg);
            border-bottom: 0.4mm dashed #94a3b8;
          }
          .tent-tab {
            width: 95mm;
            height: 20mm;
            border-top: 0.4mm dashed #94a3b8;
            background: #f8fafc;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 6.5pt;
            font-weight: 700;
            color: #64748b;
            text-transform: uppercase;
            letter-spacing: 2px;
          }
          .face-inner {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: center;
            text-align: center;
            padding: 6mm 5mm 5mm 5mm;
          }
          .bg-layer {
            position: absolute;
            top: 0; left: 0; right: 0;
            height: 55%;
            overflow: hidden;
            z-index: 1;
          }
          .bg-img { width: 100%; height: 100%; object-fit: cover; }
          .bg-fallback { width: 100%; height: 100%; background: radial-gradient(circle at top, ${paper.accent}25 0%, transparent 75%); }
          .bg-gradient { position: absolute; inset: 0; }
          .face-content {
            position: relative;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
          }
          .logo-img { max-height: 12mm; max-width: 45mm; object-fit: contain; margin-bottom: 1.5mm; }
          .pre-title { font-size: 6.5pt; font-weight: 900; letter-spacing: 2.5px; text-transform: uppercase; margin-bottom: 1mm; }
          .event-name { font-size: 21pt; font-weight: 700; line-height: 1.08; margin-bottom: 1.5mm; }
          .subtitle { font-size: 6.5pt; font-weight: 600; max-width: 74mm; line-height: 1.35; margin-bottom: 3mm; }
          .qr-box { padding: 2.5mm; background: #ffffff; border: 0.3mm solid #e2e8f0; border-radius: 3mm; margin-bottom: 2.5mm; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
          .qr-img { width: 34mm; height: 34mm; display: block; }
          .hashtag { font-size: 7.5pt; font-weight: 900; letter-spacing: 1.5px; text-transform: uppercase; }
          .brand { font-size: 5.5pt; font-weight: 700; letter-spacing: 2px; margin-top: 1.5mm; }
        </style>
      </head>
      <body onload="setTimeout(function(){ window.print(); }, 1000)">
    `;

    for (let mesaNum = 1; mesaNum <= total; mesaNum++) {
      html += `<div class="sheet">`;
      for (let col = 0; col < 2; col++) {
        html += `
          <div class="tent-wrapper">
            <div class="crop-tl"></div><div class="crop-tr"></div><div class="crop-bl"></div><div class="crop-br"></div>
            <div class="tent-card">
              <div class="tent-face upside-down">${renderFaceHTML(mesaNum)}</div>
              <div class="tent-face">${renderFaceHTML(mesaNum)}</div>
              <div class="tent-tab">▲ Mesa ${mesaNum} (Caballete ${col + 1} de 2) ▲</div>
            </div>
          </div>
        `;
      }
      html += `</div>`;
    }

    html += `</body></html>`;
    printWindow.document.write(html);
    printWindow.document.close();
  };

  const handlePrintShippingLabel = (shippingData, eventName) => {
    if (!shippingData) return;
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    
    const recipient = shippingData.recipient || eventName;
    const address = shippingData.address || 'Sin dirección proporcionada';
    const zipCode = shippingData.zipCode || '00000';
    const city = shippingData.city || 'Ciudad Desconocida';
    const state = shippingData.state || 'Estado Desconocido';
    const country = shippingData.country || 'MÉXICO';
    const phone = (shippingData.phoneCode || '+52') + ' ' + (shippingData.phone || '0000000000');
    const references = shippingData.references || '';

    printWindow.document.write(`
      <html>
        <head>
          <title>Etiqueta de Envío - ${eventName}</title>
          <style>
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 0; margin: 0; background: #fff; color: #000; display: flex; justify-content: center; align-items: center; min-height: 100vh; }
            .label-box { width: 10cm; min-height: 15cm; border: 3px solid #000; padding: 25px; box-sizing: border-box; border-radius: 12px; position: relative; background: #fff;}
            .priority { font-size: 26px; font-weight: 900; border-bottom: 4px solid #000; padding-bottom: 12px; margin-bottom: 20px; text-transform: uppercase; letter-spacing: 2px; text-align: center; }
            .section { margin-bottom: 20px; }
            .title { font-size: 10px; color: #555; text-transform: uppercase; margin-bottom: 5px; font-weight: bold; letter-spacing: 1px; }
            .big-text { font-size: 20px; font-weight: 900; text-transform: uppercase; margin-bottom: 5px; line-height: 1.1;}
            .text { font-size: 15px; margin-bottom: 4px; line-height: 1.4; font-weight: 500;}
            .barcode-area { border: 2px dashed #000; height: 80px; display: flex; align-items: center; justify-content: center; margin-top: 30px; font-size: 12px; font-weight: bold; color: #000; text-align: center; padding: 10px;}
            .footer { position: absolute; bottom: 25px; left: 25px; right: 25px; border-top: 2px solid #000; padding-top: 15px; font-size: 10px; text-align: center; color: #000; font-weight: bold; line-height: 1.4;}
          </style>
        </head>
        <body>
          <div class="label-box">
            <div class="priority">PAQUETE ESTÁNDAR</div>
            
            <div class="section">
              <div class="title">DESTINATARIO:</div>
              <div class="big-text">${recipient}</div>
            </div>
            
            <div class="section">
              <div class="title">DIRECCIÓN DE ENTREGA:</div>
              <div class="text">${address}</div>
              <div class="text">C.P.: <strong>${zipCode}</strong></div>
              <div class="text">${city}, ${state}</div>
              <div class="text" style="font-weight: 900; font-size: 18px; margin-top: 5px;">${country}</div>
            </div>
            
            ${references ? `
            <div class="section">
              <div class="title">REFERENCIAS DE ENTREGA:</div>
              <div class="text" style="font-style: italic; font-size: 13px;">${references}</div>
            </div>` : ''}
            
            <div class="section" style="margin-top: 25px;">
              <div class="title">CONTACTO MÓVIL (WHATSAPP):</div>
              <div class="big-text">${phone}</div>
            </div>

            <div class="barcode-area">
               ESPACIO RESERVADO PARA<br/>GUÍA DE PAQUETERÍA
            </div>
            
            <div class="footer">
              REMITENTE:<br/>
              BAULIA TECHNOLOGIES S.A. DE C.V.<br/>
              TALLER DE PRODUCCIÓN VIP
            </div>
          </div>
          <script>
            setTimeout(() => { window.print(); window.close(); }, 500);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const handleCreateLicense = async (e) => {
    e.preventDefault();
    setIsCreating(true);
    try {
      const slug = formData.nombres.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
      const newEventId = slug + '-' + Math.random().toString(36).slice(-4); 
      const newEmail = formData.email.trim().toLowerCase();
      let newPassword = Math.random().toString(36).slice(-8) + "!";
      let esClienteRecurrente = false;

      try {
        await createUserWithEmailAndPassword(secondaryAuth, newEmail, newPassword);
        await signOut(secondaryAuth); 
      } catch (authError) {
        if (authError.code === 'auth/email-already-exists' || authError.code === 'auth/email-already-in-use') {
          esClienteRecurrente = true;
          newPassword = "Tu contraseña actual de Baulia"; 
        } else {
          throw authError; 
        }
      }

      // 🟢 CÁLCULO DE CUPÓN Y ANTICIPO EN VENTA MANUAL
      let precioBasePlan = PRECIOS[formData.plan] || 0;
      const codigoLimpio = (formData.codigoCupon || '').trim().toUpperCase();
      const cuponEncontrado = (configPrecios.cupones || []).find(c => c.activo && c.codigo.toUpperCase() === codigoLimpio && (c.usados || 0) < c.limite);

      if (cuponEncontrado) {
        if (cuponEncontrado.tipo === 'porcentaje') {
          precioBasePlan = Math.max(0, Math.round(precioBasePlan * (1 - cuponEncontrado.valor / 100)));
        } else {
          precioBasePlan = Math.max(0, precioBasePlan - cuponEncontrado.valor);
        }
      }

      const porcentajeAnticipo = configPrecios.anticipos?.porcentaje || 10;
      const montoPagadoHoy = formData.esAnticipo ? Math.round(precioBasePlan * (porcentajeAnticipo / 100)) : precioBasePlan;
      const deudaCalculada = formData.esAnticipo ? Math.max(0, precioBasePlan - montoPagadoHoy) : 0;
      const tieneUrlInicial = (formData.urlInvitacion || '').trim() !== '';
      const timestampEntrega = tieneUrlInicial ? Date.now() : null;

      await setDoc(doc(db, "usuarios", newEventId), { 
        email: newEmail, role: formData.role, plan: formData.plan, tipoEvento: formData.tipoEvento, eventId: newEventId, 
        nombres: formData.nombres, status: tieneUrlInicial ? 'activo' : 'nuevo', urlInvitacion: formData.urlInvitacion, creadoPor: authData.email, 
        referenciaPago: modoPrueba ? (formData.referenciaPago || 'MODO PRUEBA') : formData.referenciaPago, createdAt: serverTimestamp(),
        isQrEnabled: formData.isQrEnabled, 
        isPassCountEnabled: formData.isPassCountEnabled,
        fechaEvento: formData.fechaEvento, 
        horaEvento: formData.horaEvento,
        telefono: formData.telefono,
        hasSocialWall: formData.hasSocialWall === true,
        hasBlackLabel: formData.hasBlackLabel === true,
        esPrueba: modoPrueba === true,
        deudaPlataforma: deudaCalculada,
        montoPagado: montoPagadoHoy,
        cuponAplicado: cuponEncontrado ? cuponEncontrado.codigo : '',
        fechaEntrega: timestampEntrega,
        bloqueadoPorPago: false
      });

      await setDoc(doc(db, "eventos", newEventId), { 
          presupuestoTotal: 150000, 
          nombres: formData.nombres, 
          plan: formData.plan, 
          tipoEvento: formData.tipoEvento,
          isQrEnabled: formData.isQrEnabled,
          isPassCountEnabled: formData.isPassCountEnabled,
          fecha: formData.fechaEvento, 
          horaEvento: formData.horaEvento,
          hasSocialWall: formData.hasSocialWall === true,
          hasBlackLabel: formData.hasBlackLabel === true,
          esPrueba: modoPrueba === true,
          deudaPlataforma: deudaCalculada,
          fechaEntrega: timestampEntrega,
          bloqueadoPorPago: false
      });

      // 🟢 Si usó un cupón válido, sumamos +1 al contador de usos
      if (cuponEncontrado && !modoPrueba) {
        const nuevosCupones = configPrecios.cupones.map(c => c.id === cuponEncontrado.id ? { ...c, usados: (c.usados || 0) + 1 } : c);
        await updateDoc(doc(db, "ajustes_baulia", "precios_publicos"), { cupones: nuevosCupones }).catch(() => {});
      }

      // 🟢 Si Modo Prueba está activo, NO suma la venta en Finanzas
      if (!modoPrueba) {
        const mesAnioAct = new Date().toISOString().slice(0, 7);
        await setDoc(doc(db, "ventas", newEventId), {
          fecha: serverTimestamp(),
          mesAnio: mesAnioAct,
          monto: montoPagadoHoy,
          deudaPendiente: deudaCalculada,
          cupon: cuponEncontrado ? cuponEncontrado.codigo : '',
          plan: formData.plan,
          vendedor: authData.email,
          referencia: formData.referenciaPago,
          cliente: formData.nombres,
          esPrueba: false
        });
      }

      if (!esClienteRecurrente) {
          try {
            await fetch("https://us-central1-panel-de-control-intelig-db278.cloudfunctions.net/enviarCorreoManual", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email: newEmail, password: newPassword, nombre: formData.nombres })
            });
          } catch(e) { console.error("Error al pedir envío de correo", e); }
      }

      setSuccessData({ email: newEmail, password: newPassword, eventId: newEventId, nombres: formData.nombres, plan: formData.plan, tipoEvento: eventoSeleccionado.label, role: formData.role, urlInvitacion: formData.urlInvitacion, esRecurrente: esClienteRecurrente });
      setClientPhone('');
      setDialog({ isOpen: true, type: 'alert', title: 'Nueva Licencia Creada', message: `La bóveda para ${formData.nombres} está lista y sus credenciales fueron enviadas a su correo automáticamente.` });
    } catch (error) {
      setDialog({ isOpen: true, type: 'alert', title: 'Error del Sistema', message: `Ocurrió un error al crear la licencia: ${error.message}` });
    }
    setIsCreating(false);
  };

  const handleUpdateLicense = async (e) => {
    e.preventDefault();
    try {
      const oldPrice = PRECIOS[editingLic.originalPlan] || 0;
      const newPrice = PRECIOS[editingLic.plan] || 0;

      if (newPrice < oldPrice) {
         setDialog({ isOpen: true, type: 'alert', title: 'Acción no permitida', message: 'No se puede reducir (downgrade) el plan de un cliente. Solo se permiten Upgrades a planes superiores.' });
         return;
      }

      const safeUrl = editingLic.urlInvitacion || "";
      const safeNombre = editingLic.nombres || "";
      const safeTipo = editingLic.tipoEvento || "general";
      const isQrChecked = editingLic.isQrEnabled !== false; 
      const isPassChecked = editingLic.isPassCountEnabled !== false;
      const deudaActualizada = Number(editingLic.deudaPlataforma) || 0;
      const desbloquearPorLiquidacion = deudaActualizada === 0 ? false : (editingLic.bloqueadoPorPago || false);

      let updateData = { 
        urlInvitacion: safeUrl, 
        plan: editingLic.plan, 
        nombres: safeNombre, 
        tipoEvento: safeTipo,
        isQrEnabled: isQrChecked,
        isPassCountEnabled: isPassChecked,
        fechaEvento: editingLic.fechaEvento || '',
        horaEvento: editingLic.horaEvento || '18:00',
        hasSocialWall: editingLic.hasSocialWall === true,
        hasBlackLabel: editingLic.hasBlackLabel === true,
        deudaPlataforma: deudaActualizada,
        bloqueadoPorPago: desbloquearPorLiquidacion
      };

      // 🟢 DISPARADOR DE 24 HORAS: Si se asigna link por primera vez, arranca el reloj
      let nuevaFechaEntrega = editingLic.fechaEntrega || null;
      if (safeUrl !== "" && (editingLic.status === 'en_proceso' || editingLic.status === 'nuevo' || !editingLic.fechaEntrega)) {
          updateData.status = 'activo';
          nuevaFechaEntrega = editingLic.fechaEntrega || Date.now();
          updateData.fechaEntrega = nuevaFechaEntrega;
      }

      await setDoc(doc(db, "usuarios", editingLic.id), updateData, { merge: true });

      try {
        await setDoc(doc(db, "eventos", editingLic.eventId || editingLic.id), {
           nombres: safeNombre,
           plan: editingLic.plan,
           tipoEvento: safeTipo,
           isQrEnabled: isQrChecked,
           isPassCountEnabled: isPassChecked,
           fecha: editingLic.fechaEvento || '',
           horaEvento: editingLic.horaEvento || '18:00',
           hasSocialWall: editingLic.hasSocialWall === true,
           hasBlackLabel: editingLic.hasBlackLabel === true,
           deudaPlataforma: deudaActualizada,
           fechaEntrega: nuevaFechaEntrega,
           bloqueadoPorPago: desbloquearPorLiquidacion
        }, { merge: true });
      } catch(err) { console.log("Error al sincronizar evento:", err); }

      if (newPrice > oldPrice && !modoPrueba && !editingLic.esPrueba) {
         try {
           await updateDoc(doc(db, "ventas", editingLic.eventId), { plan: editingLic.plan, monto: newPrice });
         } catch(err) { console.log("Doc venta no listo", err); }
      }

      setIsEditModalOpen(false); 
      setEditingLic(null);
      setDialog({ isOpen: true, type: 'alert', title: 'Bóveda Actualizada', message: newPrice > oldPrice ? 'El Upgrade se realizó y el estado financiero se actualizó.' : 'Los cambios se guardaron correctamente.' });
    } catch (error) { 
      console.error(error);
      setDialog({ isOpen: true, type: 'alert', title: 'Error', message: 'Fallo al conectar con la base de datos: ' + error.message }); 
    }
  };

  const contactarCliente = async (lic) => {
    let phone = lic.telefono || '';
    if (!phone) {
      phone = prompt(`No tenemos el WhatsApp de ${lic.nombres}. Ingresa el número a 10 dígitos para contactarlo:`);
      if (!phone) return;
    }
    
    let msg = '';
    let nuevoStatus = lic.status;
    const nombreEmpleado = auth.currentUser?.displayName || "tu asesor";

    if (lic.status === 'nuevo') {
      msg = `¡Hola *${lic.nombres}*, bienvenidos a Baulia!\n\nSoy ${nombreEmpleado} y seré la persona encargada de apoyarles con su Bóveda. Ya hemos enviado sus credenciales de acceso a su correo electrónico.\n\nPor este medio estaré a sus órdenes para cualquier duda o ayuda que requieran con la configuración de su evento. ¡Estamos muy emocionados de acompañarlos! ✨`;
      nuevoStatus = 'en_proceso'; // Cambia el semáforo a amarillo
    } else {
      msg = `¡Hola *${lic.nombres}*! Te escribo de Baulia para dar seguimiento a tu bóveda...`;
    }

    window.open(`https://wa.me/${phone.replace(/\D/g, '')}?text=${encodeURIComponent(msg)}`, '_blank');

    if (nuevoStatus !== lic.status) {
      await updateDoc(doc(db, "usuarios", lic.id), { status: nuevoStatus });
    }
  };

  const toggleStatus = (lic) => {
    const isSuspended = lic.status === 'suspendido';
    const nuevoEstatus = isSuspended ? 'activo' : 'suspendido';
    const accionText = isSuspended ? 'ACTIVAR' : 'SUSPENDER';
    
    setDialog({ 
      isOpen: true, 
      type: 'confirm', 
      title: `${accionText === 'SUSPENDER' ? 'Suspender' : 'Activar'} Licencia`, 
      message: `¿Estás seguro que deseas ${accionText.toLowerCase()} la plataforma de ${lic.nombres}?`, 
      onConfirm: async () => { 
        // 1. Cerramos el modal de forma segura para no trabar React
        setDialog(prev => ({ ...prev, isOpen: false })); 
        
        try {
          const targetId = lic.id;
          const eventIdTarget = lic.eventId || lic.id; // Blindaje: Si falta eventId, usamos su ID base
          
          // 2. Actualizamos el panel de control de usuarios
          await updateDoc(doc(db, "usuarios", targetId), { status: nuevoEstatus });
          
          // 3. Actualizamos la BÓVEDA real del cliente de forma aislada para evitar "crashes"
          if (eventIdTarget) {
              try {
                  await updateDoc(doc(db, "eventos", eventIdTarget), { status: nuevoEstatus });
              } catch (e) {
                  console.warn("Advertencia: No se encontró la colección de eventos para este ID", e);
              }
          }
          
          // 4. Lanzamos la notificación de confirmación
          setTimeout(() => {
            setDialog({ 
              isOpen: true, 
              type: 'alert', 
              title: nuevoEstatus === 'activo' ? 'Bóveda Reactivada' : 'Bóveda Suspendida', 
              message: `El estatus de ${lic.nombres} ahora es: ${nuevoEstatus.toUpperCase()}. El cliente ya puede entrar.` 
            });
          }, 400);

        } catch (error) {
          console.error("Error al cambiar estatus:", error);
          setTimeout(() => {
            setDialog({ isOpen: true, type: 'alert', title: 'Error del Sistema', message: 'No se pudo sincronizar el estatus en la base de datos.' });
          }, 400);
        }
      } 
    });
  };

  const handleDelete = (lic) => {
    if (!isSuperAdmin) { setDialog({ isOpen: true, type: 'alert', title: 'Acceso Denegado', message: 'Solo la Dirección puede eliminar cuentas permanentemente. Usa el botón "Suspender".' }); return; }
    setDialog({ isOpen: true, type: 'confirm', title: 'Eliminar Permanentemente', message: `⚠️ PELIGRO: ¿Seguro de eliminar la información de ${lic.nombres}? (El registro de ventas y finanzas NO se borrará, quedará como histórico).`, onConfirm: async () => { setDialog({ ...dialog, isOpen: false }); await deleteDoc(doc(db, "usuarios", lic.id)); await deleteDoc(doc(db, "eventos", lic.eventId)); } });
  };

  const toggleVerCorreo = (id) => setCorreosVisibles(prev => ({ ...prev, [id]: !prev[id] }));
  const formatMoney = (amount) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount || 0);

  const filteredLicencias = licencias.filter(lic => 
    (lic.nombres && lic.nombres.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (lic.email && lic.email.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (lic.eventId && lic.eventId.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const pedidosFiltrados = pedidosTaller.filter(p =>
      (p.nombres && p.nombres.toLowerCase().includes(tallerSearchQuery.toLowerCase())) ||
      (p.id && p.id.toLowerCase().includes(tallerSearchQuery.toLowerCase())) ||
      (p.plan && p.plan.toLowerCase().includes(tallerSearchQuery.toLowerCase()))
  );

  // 🟢 SOLO CONTABILIZAMOS VENTAS REALES (Ignora todo lo hecho en Modo Prueba)
  const ventasReales = ventas.filter(v => v.esPrueba !== true);
  const mesesDisponibles = [...new Set(ventasReales.map(v => v.mesAnio))].sort().reverse();
  if (!mesesDisponibles.includes(currentMonthYear)) mesesDisponibles.unshift(currentMonthYear);
  const ventasDelMes = ventasReales.filter(v => v.mesAnio === mesSeleccionado);
  const ingresoMensualTotal = ventasDelMes.reduce((sum, v) => sum + (Number(v.monto) || 0), 0);
  
  const desglosePlanes = { basico: 0, plata: 0, oro: 0, diamante: 0, social_wall: 0, security_kit: 0 };
  ventasDelMes.forEach(v => { 
      const planKey = v.plan === 'security_kit' ? 'security_kit' : v.plan;
      if(desglosePlanes[planKey] !== undefined) desglosePlanes[planKey] += (Number(v.monto) || 0); 
  });

  const totalesPorLicencia = licencias.reduce((acc, user) => {
    if (user.esPrueba === true) return acc;
    let tipo = (user.plan || 'basico').toLowerCase().trim();
    acc[tipo] = (acc[tipo] || 0) + 1;
    return acc;
  }, { basico: 0, plata: 0, oro: 0, diamante: 0, social_wall: 0, security_kit: 0 });

  const pedidosNuevos = pedidosTaller.filter(p => p.pulserasStatus === 'enviado').length;

  const exportarCorteContador = () => {
    const csvRows = ventasDelMes.map(v => {
      const fechaLimpia = v.fecha?.toDate ? v.fecha.toDate().toLocaleDateString('es-MX') : 'Reciente';
      const planLimpio = v.plan === 'security_kit' ? 'BLACK LABEL' : v.plan.toUpperCase().replace(/_/g, ' ');
      return `${fechaLimpia},${v.cliente},${planLimpio},${v.vendedor},${v.referencia},${v.monto}`;
    });
    const headers = "Fecha,Cliente,Plan Vendido,Vendedor,Referencia Bancaria,Monto MXN\n";
    const csvContent = "data:text/csv;charset=utf-8," + encodeURI(headers + csvRows.join("\n"));
    const link = document.createElement("a");
    link.setAttribute("href", csvContent);
    link.setAttribute("download", `Corte_Baulia_${mesSeleccionado}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="w-full relative">
      <div className="max-w-7xl mx-auto space-y-6 pb-10 animate-in fade-in relative print:hidden">
        
        {dialog.isOpen && (
          <div className="fixed inset-0 z-[200] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 transition-colors">
            <div className="bg-[#1C1917] rounded-3xl w-full max-w-sm overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] p-8 text-center border border-[#D4AF37]/30 transition-colors text-white">
              <div className={`w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-inner border ${dialog.type === 'alert' ? 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/20' : 'bg-rose-500/10 text-rose-500 border-rose-500/20'}`}>
                {dialog.type === 'alert' ? <AlertTriangle size={36} /> : <AlertCircle size={36} />}
              </div>
              <h3 className="text-2xl font-editorial font-black text-white mb-3">{dialog.title}</h3>
              <p className="text-sm text-slate-400 mb-8 leading-relaxed">{dialog.message}</p>
              <div className="flex gap-3">
                {dialog.type === 'confirm' && <button onClick={() => setDialog({ ...dialog, isOpen: false })} className="flex-1 py-4 bg-white/5 text-slate-300 border border-white/10 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition-colors">Cancelar</button>}
                <button onClick={() => { if(dialog.onConfirm) dialog.onConfirm(); else setDialog({ ...dialog, isOpen: false }); }} className={`flex-1 py-4 text-[#1C1917] rounded-xl font-black uppercase tracking-widest text-[10px] shadow-[0_10px_25px_rgba(0,0,0,0.5)] transition-transform active:scale-95 ${dialog.type === 'alert' ? 'bg-[#D4AF37] hover:bg-[#c5a028]' : 'bg-rose-500 text-white hover:bg-rose-600'}`}>
                  {dialog.type === 'confirm' ? 'Sí, proceder' : 'Entendido'}
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="bg-[#1C1917] rounded-3xl p-5 shadow-xl text-white flex flex-col md:flex-row items-start md:items-center justify-between border border-[#D4AF37]/25 relative overflow-hidden group gap-4">
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/10 to-transparent pointer-events-none opacity-50 group-hover:opacity-100 transition-opacity duration-1000"></div>
          <div className="relative z-10 flex items-center gap-4">
            <div className="w-12 h-12 bg-[#141210] rounded-2xl flex items-center justify-center border border-[#D4AF37]/30 shadow-inner shrink-0">
              {isSuperAdmin ? <Lock size={20} className="text-[#D4AF37]" /> : <Users size={20} className="text-[#D4AF37]" />}
            </div>
            <div>
              <span className="text-[#D4AF37] text-[9px] font-black uppercase tracking-[0.25em] block mb-0.5">
                {isSuperAdmin ? 'God Mode: Acceso Maestro' : 'Workspace Staff'}
              </span>
              <h2 className="text-2xl font-editorial font-black flex items-center leading-none">{isSuperAdmin ? 'Centro de Operaciones' : 'Panel Operativo'}</h2>
            </div>
          </div>
          
          <div className="relative z-10 flex gap-2 bg-[#141210] p-1.5 rounded-xl border border-white/10 shadow-sm w-full md:w-auto overflow-x-auto custom-scrollbar shrink-0">
            <button onClick={() => setAdminTab('licencias')} className={`px-4 py-2 rounded-lg font-bold text-[10px] tracking-widest uppercase transition-colors flex items-center gap-1.5 ${adminTab === 'licencias' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_2px_10px_rgba(212,175,55,0.2)]' : 'text-slate-500 hover:text-white hover:bg-white/5 border border-transparent'}`}>
              <Building size={14}/> Clientes
            </button>
            {isSuperAdmin && (
              <button onClick={() => setAdminTab('taller')} className={`px-4 py-2 rounded-lg font-bold text-[10px] tracking-widest uppercase transition-colors flex items-center gap-1.5 ${adminTab === 'taller' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_2px_10px_rgba(212,175,55,0.2)]' : 'text-slate-500 hover:text-white hover:bg-white/5 border border-transparent'}`}>
                <Factory size={14}/> Taller 
                {pedidosNuevos > 0 && <span className="bg-rose-500 text-white text-[9px] px-1.5 py-0.5 rounded ml-1">{pedidosNuevos}</span>}
              </button>
            )}
            {isSuperAdmin && (
              <>
                <button onClick={() => setAdminTab('finanzas')} className={`px-4 py-2 rounded-lg font-bold text-[10px] tracking-widest uppercase transition-colors flex items-center gap-1.5 ${adminTab === 'finanzas' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_2px_10px_rgba(212,175,55,0.2)]' : 'text-slate-500 hover:text-white hover:bg-white/5 border border-transparent'}`}>
                  <PieChart size={14}/> Finanzas
                </button>
                <button onClick={() => setAdminTab('resenas')} className={`px-4 py-2 rounded-lg font-bold text-[10px] tracking-widest uppercase transition-colors flex items-center gap-1.5 ${adminTab === 'resenas' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_2px_10px_rgba(212,175,55,0.2)]' : 'text-slate-500 hover:text-white hover:bg-white/5 border border-transparent'}`}>
                  <Star size={14}/> Reseñas
                </button>
                <button onClick={() => setAdminTab('precios')} className={`px-4 py-2 rounded-lg font-bold text-[10px] tracking-widest uppercase transition-colors flex items-center gap-1.5 ${adminTab === 'precios' ? 'bg-[#D4AF37] text-[#1C1917] shadow-[0_2px_10px_rgba(212,175,55,0.2)]' : 'text-slate-500 hover:text-white hover:bg-white/5 border border-transparent'}`}>
                  <DollarSign size={14}/> Precios
                </button>
              </>
            )}
          </div>
        </div>

        {/* 🔴 VISTA DEL TALLER DE PRODUCCIÓN (PULSERAS BLACK LABEL + TARJETAS SOCIAL WALL) */}
        {adminTab === 'taller' && isSuperAdmin && (
          <div className="animate-in fade-in space-y-6">
            <div className="bg-[#1C1917] rounded-3xl border border-white/10 shadow-xl overflow-hidden flex flex-col md:flex-row transition-colors">
              
              <div className="w-full md:w-1/2 lg:w-2/5 border-r border-white/10 flex flex-col">
                <div className="p-5 border-b border-white/5 bg-[#141210]">
                  <h3 className="font-bold text-white text-sm mb-3">Bandeja de Pedidos ({pedidosTaller.length})</h3>
                  <div className="relative">
                    <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
                    <input type="text" placeholder="Buscar por ID o nombre..." value={tallerSearchQuery} onChange={e => setTallerSearchQuery(e.target.value)} className="w-full pl-9 pr-3 py-2.5 bg-[#1C1917] border border-white/10 rounded-xl text-xs text-white outline-none focus:border-[#D4AF37] transition-colors placeholder-slate-500" />
                  </div>
                </div>
                <div className="overflow-y-auto h-[600px] custom-scrollbar">
                    {pedidosFiltrados.length === 0 ? (
                        <div className="p-10 text-center text-slate-500 flex flex-col items-center">
                          <Factory size={40} className="mb-3 opacity-20" />
                          <p className="text-sm font-bold">No hay pedidos que coincidan.</p>
                        </div>
                    ) : (
                        <ul className="divide-y divide-white/5">
                          {pedidosFiltrados.map(p => {
                            const isNuevo = p.orderStatus === 'enviado';
                            const isSocialWallOrder = p.orderType === 'social_wall';
                            return (
                                <li key={p.orderUniqueKey} onClick={() => procesarOrdenTaller(p)} className={`p-4 cursor-pointer hover:bg-white/5 transition-colors ${ordenActiva?.orderUniqueKey === p.orderUniqueKey ? 'bg-white/5 border-l-4 border-[#D4AF37]' : 'border-l-4 border-transparent'}`}>
                                  <div className="flex justify-between items-start gap-2 mb-1.5">
                                      <span className="font-black text-white text-sm truncate">{p.nombres}</span>
                                      <div className="flex items-center gap-1.5 shrink-0">
                                        <span className={`text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded border ${
                                          isSocialWallOrder
                                            ? 'bg-pink-500/10 text-pink-400 border-pink-500/20'
                                            : 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/20'
                                        }`}>
                                          {isSocialWallOrder ? 'TARJETAS • SOCIAL WALL' : 'PULSERAS • BLACK LABEL'}
                                        </span>
                                        {isNuevo ? (
                                            <span className="bg-rose-500/20 text-rose-400 text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded border border-rose-500/30">Nuevo</span>
                                        ) : (
                                            <span className="bg-emerald-500/20 text-emerald-400 text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded border border-emerald-500/30">Impreso</span>
                                        )}
                                      </div>
                                  </div>
                                  <div className="flex justify-between items-end mt-2 text-xs text-slate-400">
                                      <div>
                                        <p className="font-mono text-[9px] text-[#D4AF37] mb-0.5">ID: {p.id}</p>
                                        <p className="flex items-center"><Calendar size={10} className="mr-1"/> {p.orderDate ? new Date(p.orderDate).toLocaleDateString() : 'Desconocida'}</p>
                                      </div>
                                      <span className="uppercase">{p.plan === 'security_kit' ? 'BLACK LABEL' : p.plan?.replace(/_/g, ' ')}</span>
                                  </div>
                                </li>
                            )
                          })}
                        </ul>
                    )}
                </div>
              </div>

              <div className="w-full md:w-1/2 lg:w-3/5 bg-[#141210]">
                {!ordenActiva ? (
                    <div className="h-full flex flex-col items-center justify-center text-slate-500 p-10 text-center min-h-[500px]">
                        <Printer size={60} className="mb-4 opacity-20" />
                        <p className="text-lg font-black text-slate-300">Selecciona un pedido</p>
                        <p className="text-xs mt-2 max-w-sm">Haz clic en una orden de la izquierda para extraer el diseño y generar los archivos de impresión PDF.</p>
                    </div>
                ) : isFetchingOrden ? (
                    <div className="h-full flex items-center justify-center text-[#D4AF37] font-bold animate-pulse min-h-[500px]">Extrayendo datos de la bóveda...</div>
                ) : ordenActiva.orderType === 'social_wall' ? (
                    <div className="p-6 space-y-6 animate-in fade-in">
                      <div className="bg-[#1C1917] p-5 rounded-2xl border border-white/5 shadow-sm flex items-center gap-5">
                        {ordenActiva.cardConfig.logoUrl ? (
                          <div className="w-20 h-20 bg-white/5 rounded-xl flex items-center justify-center p-2 shrink-0 border border-white/10">
                            <img src={ordenActiva.cardConfig.logoUrl} alt="Logo" className="max-h-full max-w-full object-contain" />
                          </div>
                        ) : (
                          <div className="w-20 h-20 bg-pink-500/10 rounded-xl flex items-center justify-center shrink-0 border border-pink-500/20">
                            <Camera size={30} className="text-pink-400" />
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <span className="inline-block text-[8px] font-black uppercase tracking-widest px-2 py-0.5 rounded bg-pink-500/10 text-pink-400 border border-pink-500/20 mb-2">
                            ORDEN DE IMPRESIÓN • TARJETAS SOCIAL WALL
                          </span>
                          <p className="text-xs text-slate-400"><span className="font-bold text-white">Tipo de Evento:</span> {ordenActiva.cardConfig.preTitle}</p>
                          <p className="text-xs text-slate-400"><span className="font-bold text-white">Nombre Principal:</span> {ordenActiva.cardConfig.eventName}</p>
                          <p className="text-xs text-slate-400 truncate"><span className="font-bold text-white">Hashtag / Fondo:</span> {ordenActiva.hashtag} • {ordenActiva.cardConfig.bgImageUrl ? 'Con Foto de Fondo' : 'Fondo Limpio'}</p>
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div className="bg-pink-600 text-white rounded-2xl p-5 shadow-[0_5px_15px_rgba(219,39,119,0.2)] flex flex-col items-center justify-center text-center">
                          <p className="text-[10px] uppercase font-black tracking-widest opacity-80 mb-1">Total a Producir</p>
                          <p className="text-4xl font-editorial font-black">{ordenActiva.cardConfig.cantidadTarjetas}</p>
                          <p className="text-[10px] opacity-80 mt-1">Caballetes de Mesa</p>
                        </div>
                        <div className="bg-[#1C1917] border border-white/5 rounded-2xl p-5 shadow-sm flex flex-col justify-center space-y-3">
                          <div className="flex justify-between items-center text-sm">
                            <span className="text-slate-400 font-bold">Hojas Carta</span>
                            <span className="font-black text-white">{Math.ceil(ordenActiva.cardConfig.cantidadTarjetas / 2)} hojas</span>
                          </div>
                          <div className="flex justify-between items-center text-sm">
                            <span className="text-pink-400 font-bold">Formato</span>
                            <span className="font-black text-pink-400 text-xs">2 por Hoja (Triángulo)</span>
                          </div>
                        </div>
                      </div>

                      <div className="space-y-4 pt-4 border-t border-white/10">
                        {ordenActiva.direccionEnvioTaller ? (
                          <div className="bg-[#1C1917] p-5 rounded-2xl border border-white/5 mb-4 flex items-center justify-between">
                            <div>
                              <h4 className="text-xs font-black uppercase tracking-widest text-slate-400 mb-2 flex items-center"><MapPin size={14} className="mr-1.5 text-pink-400"/> Datos de Envío Listos</h4>
                              <p className="text-sm font-bold text-white">{ordenActiva.direccionEnvioTaller.recipient}</p>
                              <p className="text-xs text-slate-400 mt-0.5">{ordenActiva.direccionEnvioTaller.city}, {ordenActiva.direccionEnvioTaller.country}</p>
                            </div>
                            <button 
                              onClick={() => handlePrintShippingLabel(ordenActiva.direccionEnvioTaller, ordenActiva.nombres)}
                              className="px-4 py-3 bg-white/5 text-slate-300 rounded-xl text-[10px] font-black uppercase tracking-widest border border-white/10 hover:bg-white/10 transition-colors flex items-center">
                              <Printer size={16} className="mr-2"/> Etiqueta
                            </button>
                          </div>
                        ) : (
                          <div className="bg-rose-500/10 p-4 rounded-xl mb-4 text-xs font-medium text-rose-400 border border-rose-500/20 flex items-center">
                            <AlertTriangle size={16} className="mr-2 shrink-0"/> Sin dirección de envío registrada.
                          </div>
                        )}

                        <div className="bg-sky-500/10 border border-sky-500/20 p-4 rounded-xl flex items-start gap-2 mb-3">
                          <Info size={16} className="text-sky-400 mt-0.5 shrink-0" />
                          <p className="text-xs text-sky-200">
                            Imprime en papel Couché o Opalina gruesa tamaño <b>CARTA VERTICAL (100% escala)</b>. Salen <b>2 caballetes por hoja</b>.
                          </p>
                        </div>

                        <button onClick={generarPDFTarjetasSocialWall} className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-xs uppercase tracking-widest shadow-[0_5px_15px_rgba(212,175,55,0.2)] hover:bg-[#c5a028] transition-colors flex items-center justify-center">
                          <Printer size={18} className="mr-2" /> Generador PDF de Tarjetas
                        </button>

                        {ordenActiva.status !== 'impreso' && (
                          <div className="flex gap-3 mt-4">
                            <button onClick={desbloquearOrden} className="flex-1 py-4 bg-rose-500/10 text-rose-400 border border-rose-500/20 rounded-xl font-bold text-[10px] uppercase tracking-widest hover:bg-rose-500/20 transition-colors flex items-center justify-center">
                              <Edit3 size={16} className="mr-2" /> Revertir a Edición
                            </button>
                            <button onClick={marcarComoImpreso} className="flex-[2] py-4 bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 rounded-xl font-bold text-[10px] uppercase tracking-widest hover:bg-emerald-500/20 transition-colors flex items-center justify-center">
                              <CheckCircle2 size={16} className="mr-2" /> Marcar Impreso
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                ) : (
                    <div className="p-6 space-y-6 animate-in fade-in">
                        <div className="bg-[#1C1917] p-5 rounded-2xl border border-white/5 shadow-sm flex items-center gap-5">
                            {ordenActiva.config.logoBase64 ? (
                                <div className="w-20 h-20 bg-white/5 rounded-xl flex items-center justify-center p-2 shrink-0 border border-white/10">
                                  <img src={ordenActiva.config.logoBase64} alt="Logo" className="max-h-full max-w-full object-contain" />
                                </div>
                            ) : (
                                <div className="w-20 h-20 bg-[#D4AF37]/10 rounded-xl flex items-center justify-center shrink-0 border border-[#D4AF37]/20">
                                  <Palette size={30} className="text-[#D4AF37]" />
                                </div>
                            )}
                            <div className="flex-1">
                              <p className="text-[10px] text-slate-400 uppercase tracking-widest font-bold mb-2">Datos en Pulsera</p>
                              <p className="text-xs text-slate-400 mb-1"><span className="font-bold text-white">Pre-título:</span> {ordenActiva.config.preTitle || '(Vacío)'}</p>
                              <p className="text-xs text-slate-400 mb-1"><span className="font-bold text-white">Nombre Principal:</span> {ordenActiva.config.eventName || 'No asignado'}</p>
                              <p className="text-xs text-slate-400"><span className="font-bold text-white">Fecha del Evento:</span> {ordenActiva.fechaEvento ? new Date(ordenActiva.fechaEvento).toLocaleDateString('es-MX', { timeZone: 'UTC' }) : 'No asignada'}</p>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="bg-[#D4AF37] text-[#1C1917] rounded-2xl p-5 shadow-[0_5px_15px_rgba(212,175,55,0.2)] flex flex-col items-center justify-center text-center">
                                <p className="text-[10px] uppercase font-black tracking-widest mb-1">Total a Producir</p>
                                <p className="text-4xl font-editorial font-black">{ordenActiva.listaImpresion.length}</p>
                                <p className="text-[10px] opacity-80 mt-1">Brazaletes Físicos</p>
                            </div>
                            <div className="bg-[#1C1917] border border-white/5 rounded-2xl p-5 shadow-sm flex flex-col justify-center space-y-3">
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-slate-400 font-bold">Adultos</span>
                                    <span className="font-black text-white">{ordenActiva.listaImpresion.filter(i=>!i.esNino).length}</span>
                                </div>
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-sky-400 font-bold">Niños</span>
                                    <span className="font-black text-sky-400">{ordenActiva.listaImpresion.filter(i=>i.esNino).length}</span>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-4 pt-4 border-t border-white/10">
                            {ordenActiva.direccionEnvioTaller ? (
                              <div className="bg-[#1C1917] p-5 rounded-2xl border border-white/5 mb-4 flex items-center justify-between">
                                <div>
                                   <h4 className="text-xs font-black uppercase tracking-widest text-slate-400 mb-2 flex items-center"><MapPin size={14} className="mr-1.5 text-[#D4AF37]"/> Datos de Envío Listos</h4>
                                   <p className="text-sm font-bold text-white">{ordenActiva.direccionEnvioTaller.recipient}</p>
                                   <p className="text-xs text-slate-400 mt-0.5">{ordenActiva.direccionEnvioTaller.city}, {ordenActiva.direccionEnvioTaller.country}</p>
                                </div>
                                <button 
                                  onClick={() => handlePrintShippingLabel(ordenActiva.direccionEnvioTaller, ordenActiva.nombres)}
                                  className="px-4 py-3 bg-white/5 text-slate-300 rounded-xl text-[10px] font-black uppercase tracking-widest border border-white/10 hover:bg-white/10 transition-colors flex items-center">
                                  <Printer size={16} className="mr-2"/> Etiqueta
                                </button>
                              </div>
                            ) : (
                              <div className="bg-rose-500/10 p-4 rounded-xl mb-4 text-xs font-medium text-rose-400 border border-rose-500/20 flex items-center">
                                 <AlertTriangle size={16} className="mr-2 shrink-0"/> Sin dirección de envío registrada.
                              </div>
                            )}

                            <div className="bg-sky-500/10 border border-sky-500/20 p-4 rounded-xl flex items-start gap-2 mb-3">
                                <Info size={16} className="text-sky-400 mt-0.5 shrink-0" />
                                <p className="text-xs text-sky-200">Al abrir el PDF, asegúrate de configurar tu impresora en tamaño <b>CARTA</b>, orientación <b>HORIZONTAL</b>, y escala <b>100%</b> o "Tamaño Real".</p>
                            </div>
                            <button onClick={generarPDFNativo} className="w-full py-4 bg-white/5 text-white border border-white/10 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-white/10 transition-colors flex items-center justify-center">
                                <Printer size={18} className="mr-2" /> Generador PDF (Vectorial)
                            </button>

                            {ordenActiva.status !== 'impreso' && (
                                <div className="flex gap-3 mt-4">
                                    <button onClick={desbloquearOrden} className="flex-1 py-4 bg-rose-500/10 text-rose-400 border border-rose-500/20 rounded-xl font-bold text-[10px] uppercase tracking-widest hover:bg-rose-500/20 transition-colors flex items-center justify-center">
                                        <Edit3 size={16} className="mr-2" /> Revertir a Edición
                                    </button>
                                    <button onClick={marcarComoImpreso} className="flex-[2] py-4 bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 rounded-xl font-bold text-[10px] uppercase tracking-widest hover:bg-emerald-500/20 transition-colors flex items-center justify-center">
                                        <CheckCircle2 size={16} className="mr-2" /> Marcar Impreso
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* 🔴 TABLA DE CLIENTES COMPACTA */}
        {adminTab === 'licencias' && (
          <div className="flex flex-col space-y-4">
            
            {/* CONTROLES SUPERIORES Y MÉTRICAS COMPACTAS */}
            <div className="flex flex-col xl:flex-row gap-4 items-start xl:items-center justify-between w-full">
              <div className="flex gap-2 w-full xl:w-auto shrink-0">
                <button onClick={() => { setIsModalOpen(true); setSuccessData(null); setFormData({ nombres: '', email: '', telefono: '', plan: 'diamante', tipoEvento: 'boda', role: 'cliente', urlInvitacion: '', referenciaPago: modoPrueba ? 'MODO PRUEBA' : '', fechaEvento: '', horaEvento: '18:00', isQrEnabled: true, isPassCountEnabled: true, hasSocialWall: false, hasBlackLabel: false, codigoCupon: '', esAnticipo: false }); }} className="px-5 py-2.5 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black shadow-[0_5px_15px_rgba(212,175,55,0.25)] hover:scale-[1.02] hover:bg-[#c5a028] transition-all flex items-center justify-center uppercase tracking-widest text-[10px]">
                    <Plus size={14} className="mr-1.5"/> Nueva Bóveda
                </button>
                <div className="relative flex-1 xl:w-[280px]">
                  <SearchIcon size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" />
                  <input type="text" placeholder="Buscar cliente..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-[#141210] border border-white/10 rounded-xl text-xs text-white outline-none focus:border-[#D4AF37] shadow-sm transition-colors font-bold placeholder-slate-500" />
                </div>
              </div>

              {/* MINI CARDS (Pills) SCROLLABLES */}
              <div className="flex gap-2 overflow-x-auto w-full xl:w-auto pb-1 custom-scrollbar">
                <div className="bg-[#1C1917] px-3 py-2.5 rounded-lg border border-white/10 flex items-center shrink-0">
                  <p className="text-[9px] font-bold text-slate-500 uppercase tracking-widest mr-3">Básico</p><p className="text-xs font-black text-white">{totalesPorLicencia.basico}</p>
                </div>
                <div className="bg-[#1C1917] px-3 py-2.5 rounded-lg border border-slate-600 flex items-center shrink-0">
                  <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest mr-3">Plata</p><p className="text-xs font-black text-white">{totalesPorLicencia.plata}</p>
                </div>
                <div className="bg-[#1C1917] px-3 py-2.5 rounded-lg border border-[#D4AF37]/50 flex items-center shrink-0">
                  <p className="text-[9px] font-bold text-[#D4AF37] uppercase tracking-widest mr-3">Oro</p><p className="text-xs font-black text-[#D4AF37]">{totalesPorLicencia.oro}</p>
                </div>
                <div className="bg-[#1C1917] px-3 py-2.5 rounded-lg border border-indigo-500/50 flex items-center shrink-0">
                  <p className="text-[9px] font-bold text-indigo-400 uppercase tracking-widest mr-3">Diamante</p><p className="text-xs font-black text-indigo-400">{totalesPorLicencia.diamante}</p>
                </div>
                <div className="bg-[#1C1917] px-3 py-2.5 rounded-lg border border-pink-500/50 flex items-center shrink-0">
                  <p className="text-[9px] font-bold text-pink-400 uppercase tracking-widest mr-3">Social Wall</p><p className="text-xs font-black text-pink-400">{totalesPorLicencia.social_wall}</p>
                </div>
                <div className="bg-[#141210] px-3 py-2.5 rounded-lg border border-[#D4AF37] shadow-[0_0_10px_rgba(212,175,55,0.1)] flex items-center shrink-0">
                  <p className="text-[9px] font-bold text-[#D4AF37] uppercase tracking-widest mr-3">Black Label</p><p className="text-xs font-black text-[#D4AF37]">{totalesPorLicencia.security_kit}</p>
                </div>
              </div>
            </div>

            {/* TABLA: Traducción visual */}
            <div className="animate-in fade-in">
              <div className="bg-[#1C1917] rounded-2xl border border-white/10 shadow-xl overflow-hidden transition-colors">
                <div className="p-4 border-b border-white/5 bg-[#141210] flex justify-between items-center transition-colors">
                  <h3 className="font-bold text-white text-xs uppercase tracking-widest">Directorio de Clientes Activos ({filteredLicencias.length})</h3>
                </div>
                
                <div className="overflow-x-auto pb-6 custom-scrollbar">
                  <table className="w-full text-left whitespace-nowrap min-w-[1000px]">
                    <thead className="bg-[#141210] border-b border-white/10 text-slate-400 text-[10px] uppercase tracking-widest transition-colors">
                      <tr>
                        <th className="px-5 py-4 font-bold">Cliente / ID</th>
                        <th className="px-5 py-4 font-bold">Acceso (Correo)</th>
                        <th className="px-5 py-4 font-bold text-center">Tipo</th>
                        <th className="px-5 py-4 font-bold text-center">Plan</th>
                        <th className="px-5 py-4 font-bold">Link Invitación</th>
                        <th className="px-5 py-4 font-bold text-center">Estatus</th>
                        <th className="px-5 py-4 font-bold text-right">Controles</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5 text-xs">
                      {filteredLicencias.length === 0 ? (
                        <tr><td colSpan="7" className="px-5 py-16 text-center text-slate-500 font-medium text-sm">No se encontraron clientes.</td></tr>
                      ) : (
                        filteredLicencias.map((lic) => {
                          const estaSuspendido = lic.status === 'suspendido';
                          const correoVisible = correosVisibles[lic.id];
                          const noTienePanel = lic.plan === 'basico' || lic.plan === 'plata';
                          
                          const isBlackLabel = lic.plan === 'baulia_black_label' || lic.plan === 'security_kit';
                          
                          return (
                            <tr key={lic.id} className={`transition-colors ${estaSuspendido ? 'bg-rose-500/10' : 'hover:bg-white/5'}`}>
                              <td className="px-5 py-4">
                                <p className={`font-black text-sm ${estaSuspendido ? 'text-rose-500' : 'text-white'}`}>
                                  {lic.nombres || 'Sin Nombre'} 
                                  {lic.role === 'planner' && <span className="ml-2 text-[8px] bg-indigo-500/20 text-indigo-400 border border-indigo-500/30 px-1.5 py-0.5 rounded uppercase font-bold tracking-widest">Planner</span>}
                                </p>
                                <p className="text-[10px] text-slate-500 font-mono mt-0.5">{lic.eventId}</p>
                              </td>
                              <td className="px-5 py-4">
                                <div className="flex items-center text-slate-300 bg-[#141210] px-3 py-2 rounded-lg w-max border border-white/5 transition-colors">
                                  <span className="mr-3 font-mono text-[11px]">{correoVisible ? lic.email : '••••••••••••@••••.com'}</span>
                                  <button onClick={() => toggleVerCorreo(lic.id)} className="text-slate-500 hover:text-[#D4AF37] transition-colors">
                                    {correoVisible ? <EyeOff size={14} /> : <Eye size={14} />}
                                  </button>
                                </div>
                              </td>
                              <td className="px-5 py-4 text-center">
                                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{lic.tipoEvento || 'Boda'}</span>
                              </td>
                              <td className="px-5 py-4 text-center">
                                <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-widest border shadow-sm
                                  ${lic.plan === 'diamante' ? 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20' : 
                                    lic.plan === 'oro' ? 'bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/30' : 
                                    lic.plan === 'plata' ? 'bg-slate-700 text-slate-300 border-slate-600' :
                                    lic.plan === 'social_wall' ? 'bg-pink-500/10 text-pink-400 border-pink-500/20' :
                                    isBlackLabel ? 'bg-[#141210] text-[#D4AF37] border-[#D4AF37]/50 shadow-[0_0_10px_rgba(212,175,55,0.2)]' :
                                    'bg-white/5 text-slate-400 border-white/10'}`}>
                                  {isBlackLabel ? 'BLACK LABEL' : lic.plan.replace(/_/g, ' ')}
                                </span>
                              </td>
                              <td className="px-5 py-4 max-w-[200px] truncate">
                                {lic.urlInvitacion ? (
                                  <a href={lic.urlInvitacion} target="_blank" rel="noreferrer" className="text-sky-400 hover:text-white hover:underline text-[10px] font-bold truncate block transition-colors" title={lic.urlInvitacion}>
                                    {lic.urlInvitacion}
                                  </a>
                                ) : (
                                  <span className="text-[10px] text-slate-500 italic">Pendiente de subir</span>
                                )}
                              </td>
                              <td className="px-5 py-4 text-center">
                                <div className="flex flex-col items-center gap-1">
                                  <span className={`px-2.5 py-1 rounded-md text-[9px] font-black uppercase tracking-widest border shadow-sm ${lic.bloqueadoPorPago ? 'bg-rose-500/20 text-rose-400 border-rose-500/40 animate-pulse' : lic.status === 'nuevo' ? 'bg-[#D4AF37] text-[#141210] border-[#D4AF37] shadow-[0_0_10px_rgba(212,175,55,0.3)] animate-pulse' : lic.status === 'en_proceso' ? 'bg-amber-500/20 text-amber-500 border-amber-500/30' : lic.status === 'activo' ? 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' : 'bg-white/10 text-slate-400 border-white/20'}`}>
                                    {lic.bloqueadoPorPago ? '🔒 BLOQUEADO (IMPAGO)' : lic.status === 'nuevo' ? '¡NUEVO!' : lic.status ? lic.status.replace('_', ' ') : 'Pendiente'}
                                  </span>
                                  {Number(lic.deudaPlataforma) > 0 && (
                                    <span className="text-[8px] font-black uppercase tracking-widest text-amber-400 bg-amber-500/10 px-2 py-0.5 rounded border border-amber-500/20">
                                      Debe: {formatMoney(lic.deudaPlataforma)}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="px-5 py-4 text-right">
                                  <div className="flex items-center justify-end space-x-2">
                                    <button onClick={() => contactarCliente(lic)} title="Contactar por WhatsApp" className="p-2.5 rounded-lg text-emerald-400 bg-emerald-500/10 hover:bg-emerald-500/20 transition-colors">
                                      <MessageCircle size={16} />
                                    </button>
                                    <button onClick={() => { 
                                        setEditingLic({...lic, originalPlan: lic.plan, isQrEnabled: lic.isQrEnabled !== false, isPassCountEnabled: lic.isPassCountEnabled !== false}); 
                                        setIsEditModalOpen(true); 
                                      }} 
                                      title="Editar URL o Plan" className="p-2.5 rounded-lg text-slate-400 hover:text-white bg-[#141210] border border-white/5 hover:border-white/20 transition-colors"><Edit3 size={16} />
                                    </button>
                                    
                                    {!noTienePanel && <button onClick={() => onImpersonate({ id: lic.eventId, nombre: lic.nombres, role: lic.role, plan: lic.plan, tipoEvento: lic.tipoEvento || 'general', urlInvitacion: lic.urlInvitacion || '' })} title="Entrar al Panel (Modo Soporte)" className="p-2.5 rounded-lg text-[#D4AF37] bg-[#D4AF37]/10 hover:bg-[#D4AF37]/20 transition-colors"><ExternalLink size={16} /></button>}
                                    
                                    <button onClick={() => toggleStatus(lic)} title={estaSuspendido ? "Reactivar Cuenta" : "Suspender Cuenta"} className={`p-2.5 rounded-lg transition-colors ${estaSuspendido ? 'text-emerald-400 bg-emerald-500/10 hover:bg-emerald-500/20' : 'text-amber-500 bg-amber-500/10 hover:bg-amber-500/20'}`}><Power size={16} /></button>
                                    {isSuperAdmin && (
                                      <button onClick={() => handleDelete(lic)} title="Eliminar Bóveda Permanentemente" className="p-2.5 rounded-lg text-rose-500 bg-rose-500/10 hover:bg-rose-500 hover:text-white transition-colors"><Trash2 size={16} /></button>
                                    )}
                                  </div>
                              </td>
                            </tr>
                          )
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* FINANZAS (EXCLUSIVO SUPERADMIN NIVEL 3) */}
        {adminTab === 'finanzas' && isSuperAdmin && (
          <div className="animate-in fade-in space-y-6">
             <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 bg-[#1C1917] p-5 rounded-3xl border border-white/10 shadow-xl transition-colors">
                <div className="flex items-center bg-[#141210] pr-4 rounded-2xl border border-[#D4AF37]/30">
                  <div className="w-14 h-14 bg-[#D4AF37]/10 text-[#D4AF37] rounded-xl flex items-center justify-center mr-4 border-r border-[#D4AF37]/20 shrink-0"><Wallet size={24}/></div>
                  <div>
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-0.5">Periodo a evaluar</p>
                    <select value={mesSeleccionado} onChange={(e) => setMesSeleccionado(e.target.value)} className="text-lg font-black text-white bg-transparent outline-none cursor-pointer hover:text-[#D4AF37] transition-colors appearance-none">
                      {mesesDisponibles.map(m => {
                        const date = new Date(m + '-02'); 
                        const mesNombre = date.toLocaleString('es-MX', { month: 'long', year: 'numeric' });
                        return <option key={m} value={m} className="bg-[#1C1917]">{mesNombre.charAt(0).toUpperCase() + mesNombre.slice(1)} {m === currentMonthYear ? '(Mes Actual)' : ''}</option>
                      })}
                    </select>
                  </div>
                </div>

                {/* 🟢 CONTROLES EXCLUSIVOS SUPERADMIN DENTRO DE FINANZAS */}
                <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto justify-end">
                  {/* SWITCH MODO PRUEBA */}
                  <div className={`flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl border transition-all flex-1 sm:flex-none ${modoPrueba ? 'bg-amber-500/10 border-amber-500/40' : 'bg-white/5 border-white/10'}`}>
                    <div className="flex flex-col">
                      <span className={`text-[9px] font-black uppercase tracking-widest ${modoPrueba ? 'text-amber-500' : 'text-slate-400'}`}>
                        {modoPrueba ? '🧪 MODO PRUEBA ACTIVO' : 'Modo Prueba'}
                      </span>
                      <span className="text-[8px] text-slate-500 uppercase tracking-widest mt-1">
                        {modoPrueba ? 'Compras no suman' : 'Contabilidad en vivo'}
                      </span>
                    </div>
                    <button
                      type="button"
                      onClick={toggleModoPrueba}
                      className={`relative w-11 h-6 rounded-full transition-colors shrink-0 ${modoPrueba ? 'bg-amber-500' : 'bg-slate-600'}`}
                    >
                      <div className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow transition-transform ${modoPrueba ? 'translate-x-5' : 'translate-x-0'}`}></div>
                    </button>
                  </div>

                  {/* BOTÓN REINICIAR FINANZAS A $0 */}
                  <button 
                    type="button"
                    onClick={handleReiniciarFinanzas} 
                    disabled={isResettingFinanzas || ventas.length === 0}
                    className="px-5 py-3.5 bg-rose-500/10 text-rose-500 border border-rose-500/20 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-rose-500/20 transition-colors flex items-center justify-center disabled:opacity-40 flex-1 sm:flex-none"
                  >
                    <Trash2 size={16} className="mr-1.5 shrink-0"/> {isResettingFinanzas ? 'Reiniciando...' : 'Reiniciar a $0'}
                  </button>

                  {/* BOTÓN DESCARGAR EXCEL */}
                  <button onClick={exportarCorteContador} className="px-5 py-3.5 bg-white border border-white/10 text-[#1C1917] rounded-xl text-[10px] font-black uppercase tracking-widest shadow-[0_5px_15px_rgba(255,255,255,0.1)] hover:bg-slate-200 transition-colors flex items-center justify-center flex-1 sm:flex-none">
                    <FileSpreadsheet size={16} className="mr-2 text-emerald-600 shrink-0"/> Descargar Excel
                  </button>
                </div>
             </div>
             
             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#1C1917] rounded-3xl p-8 border border-white/10 shadow-xl">
                  <h3 className="text-slate-400 font-bold uppercase tracking-widest text-[10px] mb-2">Ingreso Bruto del Mes</h3>
                  <p className="text-5xl font-editorial font-black text-emerald-400 mb-8">{formatMoney(ingresoMensualTotal)}</p>
                  <div className="space-y-4">
                    <div className="flex justify-between items-center text-sm"><span className="text-slate-400 font-medium">Plan Básico ({Math.floor(desglosePlanes.basico / PRECIOS.basico) || 0})</span><span className="font-bold text-white/50">{formatMoney(desglosePlanes.basico)}</span></div>
                    <div className="flex justify-between items-center text-sm"><span className="text-slate-400 font-medium">Plan Plata ({Math.floor(desglosePlanes.plata / PRECIOS.plata) || 0})</span><span className="font-bold text-white/50">{formatMoney(desglosePlanes.plata)}</span></div>
                    <div className="flex justify-between items-center text-sm"><span className="text-[#D4AF37] font-medium">Plan Oro ({Math.floor(desglosePlanes.oro / PRECIOS.oro) || 0})</span><span className="font-bold text-[#D4AF37]">{formatMoney(desglosePlanes.oro)}</span></div>
                    <div className="flex justify-between items-center text-sm"><span className="text-indigo-400 font-medium">Plan Diamante ({Math.floor(desglosePlanes.diamante / PRECIOS.diamante) || 0})</span><span className="font-bold text-indigo-400">{formatMoney(desglosePlanes.diamante)}</span></div>
                    <div className="flex justify-between items-center text-sm"><span className="text-pink-400 font-medium">Social Wall ({Math.floor(desglosePlanes.social_wall / PRECIOS.social_wall) || 0})</span><span className="font-bold text-pink-400">{formatMoney(desglosePlanes.social_wall)}</span></div>
                    <div className="flex justify-between items-center text-sm"><span className="text-white font-medium">Black Label ({Math.floor(desglosePlanes.security_kit / PRECIOS.security_kit) || 0})</span><span className="font-bold text-white">{formatMoney(desglosePlanes.security_kit)}</span></div>
                  </div>
                </div>
                <div className="bg-[#1C1917] rounded-3xl border border-white/10 shadow-xl overflow-hidden flex flex-col">
                  <div className="p-6 border-b border-white/5 bg-[#141210] shrink-0"><h3 className="font-bold text-sm text-white">Últimas Transacciones ({ventasDelMes.length})</h3></div>
                  <div className="overflow-y-auto flex-1 custom-scrollbar p-2">
                    {ventasDelMes.length === 0 ? <p className="text-center text-slate-500 p-10 text-sm">No hay ventas registradas en este mes.</p> : ventasDelMes.map((v, i) => (
                      <div key={i} className="p-4 border-b border-white/5 last:border-0 flex justify-between items-center hover:bg-white/5 transition-colors rounded-xl">
                        <div>
                          <p className="font-bold text-white text-sm leading-none mb-2">{v.cliente}</p>
                          <p className="text-[10px] text-slate-500 uppercase tracking-widest">{v.plan === 'security_kit' ? 'BLACK LABEL' : v.plan.replace(/_/g, ' ')} • Ref: {v.referencia}</p>
                        </div>
                        <div className="text-right">
                          <p className="font-black text-emerald-400 text-lg mb-1">{formatMoney(v.monto)}</p>
                          <p className="text-[9px] text-slate-500">{v.fecha?.toDate ? v.fecha.toDate().toLocaleDateString('es-MX') : ''}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
             </div>
          </div>
        )}

        {/* RESEÑAS */}
        {adminTab === 'resenas' && isSuperAdmin && (
          <div className="animate-in fade-in bg-[#1C1917] rounded-3xl border border-white/10 shadow-xl overflow-hidden transition-colors">
            <div className="p-5 border-b border-white/5 bg-[#141210] flex justify-between items-center transition-colors">
               <h3 className="font-bold text-white text-sm">Auditoría de Calidad ({resenasList.length})</h3>
               <p className="text-[9px] text-slate-500 uppercase tracking-widest font-black">Solo las "Aprobadas" se ven en la Landing Page</p>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
               {resenasList.map(r => (
                 <div key={r.id} className={`p-6 rounded-3xl border transition-colors relative shadow-sm ${r.status === 'aprobada' ? 'bg-[#D4AF37]/5 border-[#D4AF37]/30' : 'bg-[#141210] border-white/10'}`}>
                   <div className="absolute top-5 right-5">
                     <button onClick={() => updateDoc(doc(db, "resenas", r.id), { status: r.status === 'aprobada' ? 'pendiente' : 'aprobada' })} className={`text-[9px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg shadow-sm transition-colors border ${r.status === 'aprobada' ? 'bg-[#D4AF37] text-[#1C1917] border-[#D4AF37]' : 'bg-white/5 border-white/10 text-slate-400 hover:text-white hover:border-white/30'}`}>
                       {r.status === 'aprobada' ? 'Pública' : 'Aprobar'}
                     </button>
                   </div>
                   <div className="flex gap-1 mb-4">
                     {[1,2,3,4,5].map(star => <Star key={star} size={16} className={r.rating >= star ? 'fill-[#D4AF37] text-[#D4AF37]' : 'text-slate-600'} />)}
                   </div>
                   <p className="text-sm text-slate-300 italic mb-6 font-light leading-relaxed">"{r.comment}"</p>
                   <div className="border-t border-white/10 pt-4">
                     <input type="text" value={r.authorName} onChange={(e) => updateDoc(doc(db, "resenas", r.id), { authorName: e.target.value })} className="font-bold text-sm bg-transparent outline-none border-b border-transparent focus:border-[#D4AF37] w-full text-white transition-colors pb-1" />
                     <p className="text-[10px] text-slate-500 uppercase tracking-widest mt-2 font-bold">{r.authorType}</p>
                   </div>
                 </div>
               ))}
               {resenasList.length === 0 && <div className="col-span-full text-center py-16 text-slate-500 font-bold">Aún no hay reseñas registradas.</div>}
            </div>
          </div>
        )}

        {/* 🔴 NUEVA VISTA: PRECIOS Y PROMOS */}
        {adminTab === 'precios' && isSuperAdmin && (
          <div className="animate-in fade-in transition-colors mt-6">
            <GestorPreciosView />
          </div>
        )}
        {/* MODAL CREAR LICENCIA */}
        {isModalOpen && (
          <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
            <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 max-h-[90vh] overflow-y-auto custom-scrollbar border border-[#D4AF37]/30 transition-colors text-white">
              {!successData ? (
                <form onSubmit={handleCreateLicense} className="p-8">
                  <div className="text-center mb-6">
                    <div className="w-14 h-14 bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30 rounded-full flex items-center justify-center mx-auto mb-4"><Key size={24} /></div>
                    <h3 className="text-2xl font-editorial font-black text-white transition-colors">Registrar Venta Directa</h3>
                    <p className="text-[10px] text-slate-400 mt-2 uppercase tracking-widest transition-colors">El vendedor y el monto se registrarán en el libro mayor.</p>
                  </div>
                  
                  <div className="space-y-4 mb-6">
                    <div className={`${modoPrueba ? 'bg-amber-500/10 border-amber-500/20' : 'bg-[#141210] border-white/10'} border p-4 rounded-xl transition-colors`}>
                      <label className={`block text-[10px] font-bold ${modoPrueba ? 'text-amber-400' : 'text-slate-400'} uppercase tracking-widest mb-2 flex items-center transition-colors`}>
                        <Wallet size={12} className="mr-1"/> {modoPrueba ? 'Referencia (Modo Prueba Activo)' : 'Referencia de Pago (Obligatorio)'}
                      </label>
                      <input 
                        type="text" 
                        required={!modoPrueba} 
                        value={modoPrueba && !formData.referenciaPago ? 'MODO PRUEBA' : formData.referenciaPago} 
                        onChange={e => setFormData({...formData, referenciaPago: e.target.value})} 
                        placeholder="Ej: Pago en Efectivo, Transf BBVA..." 
                        className="w-full p-4 bg-[#1C1917] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors" 
                      />
                    </div>

                    <div className="flex gap-4">
                      <div className="flex-1">
                        <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 transition-colors">Tipo de Evento</label>
                        <select value={formData.tipoEvento} onChange={e => setFormData({...formData, tipoEvento: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm cursor-pointer transition-colors appearance-none">
                          {tiposDeEvento.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
                        </select>
                      </div>
                      <div className="flex-1">
                        <label className="block text-[10px] font-bold text-[#D4AF37] uppercase tracking-widest mb-2 flex items-center transition-colors"><Users size={12} className="mr-1"/> Rol</label>
                        <select value={formData.role} onChange={e => setFormData({...formData, role: e.target.value})} className="w-full p-4 bg-[#D4AF37]/10 border border-[#D4AF37]/20 text-[#D4AF37] rounded-xl outline-none focus:border-[#D4AF37] font-black text-sm cursor-pointer transition-colors appearance-none">
                          <option value="cliente">Cliente Final</option>
                          <option value="planner">Agencia Planner</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 transition-colors">{formData.role === 'planner' ? 'Nombre de la Agencia' : eventoSeleccionado.labelNombre}</label>
                      <input type="text" autoFocus required value={formData.nombres} onChange={e => setFormData({...formData, nombres: e.target.value})} placeholder={formData.role === 'planner' ? 'Ej. Elite Planners' : eventoSeleccionado.placeholder} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Mail size={12} className="mr-1.5" /> Correo de Acceso</label>
                      <input type="email" required value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} placeholder="ejemplo@gmail.com" className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Phone size={12} className="mr-1.5" /> Teléfono (WhatsApp)</label>
                      <input type="tel" required value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})} placeholder="10 dígitos del cliente..." className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors" />
                    </div>
                    
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 transition-colors">Paquete Vendido (Precio Actualizado)</label>
                      <select value={formData.plan} onChange={e => setFormData({...formData, plan: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm cursor-pointer transition-colors mb-3 appearance-none">
                        <option value="basico">Plan Básico ({formatMoney(PRECIOS.basico)})</option>
                        <option value="plata">Plan Plata ({formatMoney(PRECIOS.plata)})</option>
                        <option value="oro">Plan Oro ({formatMoney(PRECIOS.oro)})</option>
                        <option value="diamante">Plan Diamante ({formatMoney(PRECIOS.diamante)})</option>
                        <option value="social_wall">Social Wall ({formatMoney(PRECIOS.social_wall)})</option>
                        <option value="security_kit">Black Label ({formatMoney(PRECIOS.security_kit)})</option>
                      </select>

                      {/* 🔴 NUEVO: ADD-ONS HÍBRIDOS PARA NUEVA LICENCIA */}
                      {['basico', 'plata', 'oro'].includes(formData.plan) && (
                        <div className="mt-3 space-y-2 mb-3">
                          <div className="flex items-center justify-between bg-pink-500/10 p-3 rounded-lg border border-pink-500/20">
                            <span className="text-[9px] font-bold text-pink-400 uppercase tracking-widest">+ Social Wall (Extra)</span>
                            <button type="button" onClick={() => setFormData({...formData, hasSocialWall: !formData.hasSocialWall})} className={`relative w-8 h-4 rounded-full transition-colors shrink-0 ${formData.hasSocialWall ? 'bg-pink-500' : 'bg-slate-600'}`}>
                              <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${formData.hasSocialWall ? 'translate-x-4' : 'translate-x-0'}`}></div>
                            </button>
                          </div>
                          <div className="flex items-center justify-between bg-white/5 p-3 rounded-lg border border-white/10">
                            <span className="text-[9px] font-bold text-slate-300 uppercase tracking-widest">+ Black Label (Extra)</span>
                            <button type="button" onClick={() => setFormData({...formData, hasBlackLabel: !formData.hasBlackLabel})} className={`relative w-8 h-4 rounded-full transition-colors shrink-0 ${formData.hasBlackLabel ? 'bg-slate-400' : 'bg-slate-600'}`}>
                              <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${formData.hasBlackLabel ? 'translate-x-4' : 'translate-x-0'}`}></div>
                            </button>
                          </div>
                        </div>
                      )}

                      <div className="grid grid-cols-2 gap-4 mb-3">
                        <div>
                          <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Calendar size={12} className="mr-1"/> Fecha del Evento</label>
                          <input type="date" required={formData.plan === 'security_kit'} value={formData.fechaEvento} onChange={e => setFormData({...formData, fechaEvento: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-xs transition-colors [color-scheme:dark]" />
                        </div>
                        <div>
                          <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Clock size={12} className="mr-1"/> Hora de Inicio</label>
                          <input type="time" value={formData.horaEvento} onChange={e => setFormData({...formData, horaEvento: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-xs transition-colors [color-scheme:dark]" />
                        </div>
                      </div>

                      {['oro', 'diamante', 'security_kit'].includes(formData.plan) && (
                        <>
                          <div className="flex items-center justify-between bg-indigo-500/10 p-4 rounded-xl border border-indigo-500/20 mb-2">
                            <div>
                              <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest flex items-center"><QrCode size={12} className="mr-1"/> QRs Únicos</p>
                              <p className="text-[9px] text-indigo-300/70 mt-1">Apágalo para invitación simple.</p>
                            </div>
                            <button type="button" onClick={() => setFormData({...formData, isQrEnabled: !formData.isQrEnabled})} className={`relative w-10 h-5 rounded-full transition-colors shrink-0 ${formData.isQrEnabled ? 'bg-indigo-500' : 'bg-slate-600'}`}>
                               <div className={`absolute top-1 left-1 w-3 h-3 bg-white rounded-full transition-transform ${formData.isQrEnabled ? 'translate-x-5' : 'translate-x-0'}`}></div>
                            </button>
                          </div>

                          <div className="flex items-center justify-between bg-emerald-500/10 p-4 rounded-xl border border-emerald-500/20">
                            <div>
                              <p className="text-[10px] font-black text-emerald-400 uppercase tracking-widest flex items-center"><Users size={12} className="mr-1"/> Contar Pases (RSVP)</p>
                              <p className="text-[9px] text-emerald-300/70 mt-1">Para confirmación general.</p>
                            </div>
                            <button type="button" onClick={() => setFormData({...formData, isPassCountEnabled: !formData.isPassCountEnabled})} className={`relative w-10 h-5 rounded-full transition-colors shrink-0 ${formData.isPassCountEnabled ? 'bg-emerald-500' : 'bg-slate-600'}`}>
                               <div className={`absolute top-1 left-1 w-3 h-3 bg-white rounded-full transition-transform ${formData.isPassCountEnabled ? 'translate-x-5' : 'translate-x-0'}`}></div>
                            </button>
                          </div>
                        </>
                      )}
                    </div>

                    {/* 🟢 CUPÓN DE DESCUENTO, ANTICIPO DINÁMICO Y DESGLOSE EN VIVO */}
                    {(() => {
                      let precioPlanActual = PRECIOS[formData.plan] || 0;
                      const cod = (formData.codigoCupon || '').trim().toUpperCase();
                      const cup = (configPrecios.cupones || []).find(c => c.activo && c.codigo.toUpperCase() === cod && (c.usados || 0) < c.limite);
                      if (cup) {
                        precioPlanActual = cup.tipo === 'porcentaje'
                          ? Math.max(0, Math.round(precioPlanActual * (1 - cup.valor / 100)))
                          : Math.max(0, precioPlanActual - cup.valor);
                      }
                      const pctAnt = Number(configPrecios.anticipos?.porcentaje) || 10;
                      const cobraHoy = formData.esAnticipo ? Math.round(precioPlanActual * (pctAnt / 100)) : precioPlanActual;
                      const deudaQueda = formData.esAnticipo ? Math.max(0, precioPlanActual - cobraHoy) : 0;

                      return (
                        <div className="bg-[#141210] p-4 rounded-xl border border-[#D4AF37]/20 space-y-3">
                          <div>
                            <label className="block text-[10px] font-bold text-[#D4AF37] uppercase tracking-widest mb-1.5">Código de Descuento (Opcional)</label>
                            <input type="text" value={formData.codigoCupon || ''} onChange={e => setFormData({...formData, codigoCupon: e.target.value.toUpperCase()})} placeholder="Ej. PRUEBA50" className="w-full p-3 bg-[#1C1917] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-black text-white text-xs uppercase tracking-widest" />
                            {cod && (
                              <p className={`text-[9px] font-bold mt-1 ${cup ? 'text-emerald-400' : 'text-rose-400'}`}>
                                {cup ? `✓ Cupón aplicado (-${cup.tipo === 'porcentaje' ? `${cup.valor}%` : `$${cup.valor}`})` : '✕ Cupón no encontrado o inactivo'}
                              </p>
                            )}
                          </div>

                          <div className="flex items-center justify-between pt-2 border-t border-white/5">
                            <div>
                              <p className="text-[10px] font-black text-white uppercase tracking-widest">¿Entró con Anticipo ({pctAnt}%)?</p>
                              <p className="text-[9px] text-slate-400 mt-0.5">Activa el candado de cobro a las 24 hrs de entregar link.</p>
                            </div>
                            <button type="button" onClick={() => setFormData({...formData, esAnticipo: !formData.esAnticipo})} className={`relative w-10 h-5 rounded-full transition-colors shrink-0 ${formData.esAnticipo ? 'bg-[#D4AF37]' : 'bg-slate-600'}`}>
                              <div className={`absolute top-1 left-1 w-3 h-3 bg-[#1C1917] rounded-full transition-transform ${formData.esAnticipo ? 'translate-x-5' : 'translate-x-0'}`}></div>
                            </button>
                          </div>

                          <div className="bg-[#1C1917] p-3 rounded-lg border border-white/5 text-[10px] space-y-1">
                            <div className="flex justify-between text-slate-400"><span>Valor del Paquete:</span><span className="font-bold text-white">{formatMoney(precioPlanActual)}</span></div>
                            <div className="flex justify-between text-emerald-400"><span>Se registra en Finanzas hoy ({formData.esAnticipo ? `${pctAnt}%` : '100%'}):</span><span className="font-black">{formatMoney(cobraHoy)}</span></div>
                            {formData.esAnticipo && (
                              <div className="flex justify-between text-amber-400 pt-1 border-t border-white/5"><span>Deuda a cobrar en 24h:</span><span className="font-black">{formatMoney(deudaQueda)}</span></div>
                            )}
                          </div>
                        </div>
                      );
                    })()}

                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Link size={12} className="mr-1.5"/> Link Invitación URL (Opcional)</label>
                      <input type="url" value={formData.urlInvitacion} onChange={e => setFormData({...formData, urlInvitacion: e.target.value})} placeholder="https://baulia.com/..." className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-medium text-sky-400 text-sm transition-colors" />
                    </div>
                  </div>

                  <div className="flex space-x-3 mt-8">
                    <button type="button" onClick={() => setIsModalOpen(false)} className="flex-1 py-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold text-[10px] uppercase tracking-widest hover:bg-white/10 transition-colors">Cancelar</button>
                    <button type="submit" disabled={isCreating} className="flex-1 py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-[10px] uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] disabled:opacity-50 transition-colors">
                      {isCreating ? 'Procesando...' : 'Crear Licencia y Registrar Venta'}
                    </button>
                  </div>
                </form>
              ) : (
                <div className="p-8 text-center transition-colors">
                  <div className="w-20 h-20 bg-emerald-500/20 text-emerald-400 rounded-full flex items-center justify-center mx-auto mb-6 border border-emerald-500/30"><CheckCircle2 size={40} /></div>
                  <h3 className="text-2xl font-editorial font-black text-white mb-2 transition-colors">¡Accesos Creados!</h3>
                  <p className="text-sm text-slate-400 mb-6 transition-colors">La venta se registró en el Libro Mayor por <b className="text-white">{authData.email.split('@')[0]}</b>.</p>
                  <div className="bg-[#141210] p-5 rounded-2xl border border-white/10 text-left text-sm mb-8 shadow-sm transition-colors">
                    <p className="mb-3"><span className="text-slate-500 font-bold w-24 inline-block transition-colors">Usuario:</span> <b className="text-white transition-colors">{successData.email}</b></p>
                    <p><span className="text-slate-500 font-bold w-24 inline-block transition-colors">Contraseña:</span> <b className="text-[#D4AF37] font-mono text-lg transition-colors">{successData.password}</b></p>
                  </div>
                  
                  <button onClick={() => setIsModalOpen(false)} className="w-full py-4 bg-white/5 border border-white/10 text-white rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition-colors">Cerrar Ventana</button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* 🔴 MODAL PARA EDITAR LICENCIA */}
        {isEditModalOpen && editingLic && (
          <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in transition-colors">
            <div className="bg-[#1C1917] rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_70px_rgba(0,0,0,0.9)] animate-in zoom-in-95 max-h-[90vh] overflow-y-auto custom-scrollbar border border-[#D4AF37]/30 transition-colors text-white">
               <div className="px-6 py-5 border-b border-[#D4AF37]/20 bg-[#141210] flex justify-between items-center transition-colors"><h3 className="font-editorial font-black text-2xl text-[#D4AF37] tracking-wide">Editar Licencia</h3><button onClick={() => {setIsEditModalOpen(false); setEditingLic(null);}} className="text-slate-400 hover:text-[#D4AF37] transition-colors"><X size={20}/></button></div>
               <form onSubmit={handleUpdateLicense} className="p-6 space-y-5">
                  <div>
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 transition-colors">Nombre del Cliente / Evento</label>
                    <input type="text" required value={editingLic.nombres || ''} onChange={e => setEditingLic({...editingLic, nombres: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors" />
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Link size={12} className="mr-1.5"/> URL de su Invitación Pública</label>
                    <input type="url" value={editingLic.urlInvitacion || ''} onChange={e => setEditingLic({...editingLic, urlInvitacion: e.target.value})} placeholder="https://baulia.com/bodas/su-boda" className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-medium text-sky-400 text-sm transition-colors" />
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 transition-colors">Tipo de Evento</label>
                      <select value={editingLic.tipoEvento || 'general'} onChange={e => setEditingLic({...editingLic, tipoEvento: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors cursor-pointer appearance-none">
                        {tiposDeEvento.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 transition-colors">Plan</label>
                      <select value={editingLic.plan === 'security_kit' ? 'security_kit' : editingLic.plan} onChange={e => setEditingLic({...editingLic, plan: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-sm transition-colors cursor-pointer appearance-none">
                        <option value="basico">Básico</option>
                        <option value="plata">Plata</option>
                        <option value="oro">Oro</option>
                        <option value="diamante">Diamante</option>
                        <option value="social_wall">Social Wall</option>
                        <option value="security_kit">Black Label</option>
                      </select>
                    </div>
                  </div>

                  {/* 🔴 NUEVO: ADD-ONS HÍBRIDOS PARA EDITAR LICENCIA */}
                  {['basico', 'plata', 'oro'].includes(editingLic.plan) && (
                    <div className="space-y-2 mt-[-10px] mb-2">
                      <div className="flex items-center justify-between bg-pink-900/10 p-3 rounded-lg border border-pink-800/20">
                        <span className="text-[9px] font-bold text-pink-400 uppercase tracking-widest">+ Social Wall (Extra)</span>
                        <button type="button" onClick={() => setEditingLic({...editingLic, hasSocialWall: !editingLic.hasSocialWall})} className={`relative w-8 h-4 rounded-full transition-colors shrink-0 ${editingLic.hasSocialWall ? 'bg-pink-500' : 'bg-slate-600'}`}>
                          <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${editingLic.hasSocialWall ? 'translate-x-4' : 'translate-x-0'}`}></div>
                        </button>
                      </div>
                      <div className="flex items-center justify-between bg-white/5 p-3 rounded-lg border border-white/10">
                        <span className="text-[9px] font-bold text-slate-300 uppercase tracking-widest">+ Black Label (Extra)</span>
                        <button type="button" onClick={() => setEditingLic({...editingLic, hasBlackLabel: !editingLic.hasBlackLabel})} className={`relative w-8 h-4 rounded-full transition-colors shrink-0 ${editingLic.hasBlackLabel ? 'bg-slate-400' : 'bg-slate-600'}`}>
                          <div className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition-transform ${editingLic.hasBlackLabel ? 'translate-x-4' : 'translate-x-0'}`}></div>
                        </button>
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Calendar size={12} className="mr-1"/> Fecha del Evento</label>
                      <input type="date" value={editingLic.fechaEvento || ''} onChange={e => setEditingLic({...editingLic, fechaEvento: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-xs transition-colors [color-scheme:dark]" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2 flex items-center transition-colors"><Clock size={12} className="mr-1"/> Hora de Inicio</label>
                      <input type="time" value={editingLic.horaEvento || ''} onChange={e => setEditingLic({...editingLic, horaEvento: e.target.value})} className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl outline-none focus:border-[#D4AF37] font-bold text-white text-xs transition-colors [color-scheme:dark]" />
                    </div>
                  </div>

                  {['oro', 'diamante', 'security_kit'].includes(editingLic.plan) && (
                    <>
                      <div className="flex items-center justify-between bg-indigo-500/10 p-4 rounded-xl border border-indigo-500/20 mb-2">
                        <div>
                          <p className="text-[10px] font-black text-indigo-400 uppercase tracking-widest flex items-center"><QrCode size={12} className="mr-1"/> Generar QRs Únicos</p>
                          <p className="text-[9px] text-indigo-300/70 mt-1">Apágalo si el cliente quiere invitación simple.</p>
                        </div>
                        <button type="button" onClick={() => setEditingLic({...editingLic, isQrEnabled: !editingLic.isQrEnabled})} className={`relative w-10 h-5 rounded-full transition-colors shrink-0 ${editingLic.isQrEnabled ? 'bg-indigo-500' : 'bg-slate-600'}`}>
                           <div className={`absolute top-1 left-1 w-3 h-3 bg-white rounded-full transition-transform ${editingLic.isQrEnabled ? 'translate-x-5' : 'translate-x-0'}`}></div>
                        </button>
                      </div>

                      <div className="flex items-center justify-between bg-emerald-500/10 p-4 rounded-xl border border-emerald-500/20">
                        <div>
                          <p className="text-[10px] font-black text-emerald-400 uppercase tracking-widest flex items-center"><Users size={12} className="mr-1"/> Contar Pases (RSVP)</p>
                          <p className="text-[9px] text-emerald-300/70 mt-1">Apágalo para una confirmación general sin números.</p>
                        </div>
                        <button type="button" onClick={() => setEditingLic({...editingLic, isPassCountEnabled: !editingLic.isPassCountEnabled})} className={`relative w-10 h-5 rounded-full transition-colors shrink-0 ${editingLic.isPassCountEnabled ? 'bg-emerald-500' : 'bg-slate-600'}`}>
                           <div className={`absolute top-1 left-1 w-3 h-3 bg-white rounded-full transition-transform ${editingLic.isPassCountEnabled ? 'translate-x-5' : 'translate-x-0'}`}></div>
                        </button>
                      </div>
                    </>
                  )}

                  {/* 🟢 CONTROL DE DEUDA Y KILL SWITCH EN EDICIÓN */}
                  {Number(editingLic.deudaPlataforma) > 0 && (
                    <div className="bg-amber-500/10 border border-amber-500/30 p-4 rounded-xl flex items-center justify-between">
                      <div>
                        <p className="text-[10px] font-black text-amber-400 uppercase tracking-widest">Saldo Pendiente: {formatMoney(editingLic.deudaPlataforma)}</p>
                        <p className="text-[9px] text-slate-400 mt-0.5">Si ya liquidó por fuera, marca como pagado para liberar su bóveda e invitación.</p>
                      </div>
                      <button type="button" onClick={() => setEditingLic({...editingLic, deudaPlataforma: 0, bloqueadoPorPago: false})} className="px-3 py-2 bg-emerald-500 text-[#1C1917] rounded-lg font-black text-[9px] uppercase tracking-widest shrink-0 hover:bg-emerald-400 transition-colors">
                        Liquidar $0
                      </button>
                    </div>
                  )}

                  <div className="bg-sky-500/10 text-sky-400 p-4 rounded-xl text-xs font-bold border border-sky-500/20 flex items-start transition-colors leading-relaxed">
                    <AlertCircle size={16} className="mr-2 flex-shrink-0 mt-0.5" />
                    Nota: Al pegar la URL de la invitación, el estatus pasa a ACTIVO y arranca el reloj de 24 hrs si el cliente tiene saldo pendiente.
                  </div>
                  <div className="flex space-x-3 mt-8">
                    <button type="button" onClick={() => {setIsEditModalOpen(false); setEditingLic(null);}} className="flex-1 py-4 bg-white/5 border border-white/10 text-slate-300 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-white/10 transition-colors">Cancelar</button>
                    <button type="submit" className="flex-1 py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-[10px] uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] transition-colors">
                      Guardar Cambios
                    </button>
                  </div>
               </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ==========================================
// --- COMPONENTE: CONFIGURACIÓN MAESTRA (WHITE-LABEL) ---
// ==========================================
const ConfiguracionMaestraView = ({ agencyConfig, addNotification }) => {
  const [formData, setFormData] = useState({
    name: agencyConfig?.name || 'EVENT MASTER',
    themeColor: agencyConfig?.themeColor || 'indigo',
    domain: agencyConfig?.domain || '',
    logoUrl: agencyConfig?.logoUrl || ''
  });
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const cloudName = "duy0mcqsh"; 
  const uploadPreset = "ml_default"; 

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploading(true);
    if (addNotification) addNotification('Subiendo Logo...', 'Espera unos segundos.', 'info');
    
    try {
      const uploadData = new FormData(); 
      uploadData.append("file", file); 
      uploadData.append("upload_preset", uploadPreset);
      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, { method: "POST", body: uploadData });
      const data = await res.json();
      if (data.secure_url) {
        const urlParts = data.secure_url.split('/upload/');
        const optimUrl = `${urlParts[0]}/upload/c_fit,h_100,w_300,f_png,q_auto/${urlParts[1]}`;
        setFormData({ ...formData, logoUrl: optimUrl });
        if (addNotification) addNotification('Logo Subido', 'No olvides hacer clic en Guardar.', 'success');
      }
    } catch (err) { 
      if (addNotification) addNotification('Error', 'Fallo al subir la imagen.', 'error');
    } finally {
      setIsUploading(false);
    }
  };

  const handleSaveConfig = async (e) => {
    e.preventDefault();
    try {
      await setDoc(doc(db, "eventos", ID_DEL_EVENTO, "configuracion", "marcaBlanca"), formData);
      if (addNotification) addNotification('Guardado', 'La identidad visual ha sido actualizada en toda la plataforma.', 'success');
    } catch (error) {
      if (addNotification) addNotification('Error', 'No se pudo guardar la configuración.', 'error');
    }
  };

  const colorOptions = [
    { id: 'indigo', hex: 'bg-indigo-600', label: 'Índigo (Por defecto)' },
    { id: 'rose', hex: 'bg-rose-600', label: 'Rosa Premium' },
    { id: 'emerald', hex: 'bg-emerald-600', label: 'Esmeralda' },
    { id: 'slate', hex: 'bg-slate-800', label: 'Carbón / Oscuro' },
    { id: 'amber', hex: 'bg-amber-500', label: 'Ámbar / Dorado' },
    { id: 'sky', hex: 'bg-sky-500', label: 'Cielo' }
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-6 pb-10">
      <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-3xl p-8 shadow-xl text-white flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-black flex items-center mb-2"><Settings2 className="mr-3 text-rose-500" size={36}/> Configuración Maestra</h2>
          <p className="text-slate-400 max-w-lg">Personaliza la plataforma con la identidad de tu Agencia (White-Label). Tus clientes verán tus colores y logotipos en todos sus paneles.</p>
        </div>
        <div className="hidden md:flex w-24 h-24 bg-white/10 rounded-full items-center justify-center border border-white/20">
           <Layers size={40} className="text-white/50" />
        </div>
      </div>

      <form onSubmit={handleSaveConfig} className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="p-8 space-y-8">
          
          {/* SECCIÓN 1: LOGOTIPO */}
          <div>
            <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center"><Image size={20} className="mr-2 text-indigo-500"/> 1. Logotipo Corporativo</h3>
            <div className="flex flex-col sm:flex-row items-center gap-6 bg-slate-50 p-6 rounded-2xl border border-slate-100">
              <div className="w-full sm:w-64 h-24 bg-slate-900 rounded-xl border border-slate-300 flex items-center justify-center overflow-hidden relative shadow-inner">
                <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
                {formData.logoUrl ? (
                  <img src={formData.logoUrl} alt="Logo Agencia" className="h-16 object-contain z-10 drop-shadow-md px-2" />
                ) : (
                  <span className="text-slate-500 font-bold z-10 uppercase tracking-widest text-xs">Tu Logo Aquí</span>
                )}
                {isUploading && <div className="absolute inset-0 bg-slate-900/80 z-20 flex items-center justify-center"><RefreshCw className="text-white animate-spin"/></div>}
              </div>
              <div className="flex-1 space-y-3 w-full">
                <p className="text-xs text-slate-500">Se recomienda un archivo PNG con fondo transparente (máx. 2MB). Este logo reemplazará el nombre "EVENT MASTER" en el menú principal.</p>
                <input type="file" accept="image/png, image/jpeg" ref={fileInputRef} onChange={handleLogoUpload} className="hidden" />
                <button type="button" onClick={() => fileInputRef.current.click()} className="px-5 py-2.5 bg-white border border-slate-300 text-slate-700 font-bold rounded-xl shadow-sm hover:bg-slate-100 transition-colors flex items-center">
                  <UploadCloud size={16} className="mr-2"/> Seleccionar Archivo
                </button>
              </div>
            </div>
          </div>

          {/* SECCIÓN 2: IDENTIDAD VISUAL */}
          <div>
            <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center"><Palette size={20} className="mr-2 text-rose-500"/> 2. Nombre y Color Principal</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Nombre de la Agencia / Planner</label>
                <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} className="w-full p-3.5 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-800 outline-none focus:ring-2 focus:ring-indigo-500 transition-all" placeholder="Ej. Elite Weddings" />
              </div>
              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">Color del Panel</label>
                <div className="flex gap-2">
                  {colorOptions.map(color => (
                    <button 
                      key={color.id} type="button" title={color.label}
                      onClick={() => setFormData({...formData, themeColor: color.id})} 
                      className={`w-12 h-12 rounded-xl border-2 transition-all flex items-center justify-center ${color.hex} ${formData.themeColor === color.id ? 'border-slate-900 scale-110 shadow-lg' : 'border-transparent opacity-80 hover:opacity-100 hover:scale-105'}`}
                    >
                      {formData.themeColor === color.id && <CheckCircle size={16} className="text-white drop-shadow-md" />}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* SECCIÓN 3: DOMINIO */}
          <div className="opacity-60 grayscale cursor-not-allowed">
             <h3 className="text-lg font-bold text-slate-800 mb-4 flex items-center"><Globe size={20} className="mr-2 text-sky-500"/> 3. Dominio Personalizado (Próximamente)</h3>
             <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200 relative">
                <div className="absolute top-4 right-4 bg-slate-800 text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-widest">Fase 6</div>
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">URL de la plataforma</label>
                <div className="flex items-center">
                  <span className="p-3.5 bg-slate-200 text-slate-500 font-medium rounded-l-xl border border-r-0 border-slate-300">https://</span>
                  <input type="text" disabled value={formData.domain} placeholder="bodas.tu-agencia.com" className="w-full p-3.5 bg-slate-100 border border-slate-300 rounded-r-xl font-mono text-sm" />
                </div>
                <p className="text-xs text-slate-400 mt-2 flex items-center"><AlertTriangle size={14} className="mr-1.5"/> Requiere configuración de registros CNAME y A en tu proveedor de dominio (GoDaddy, Hostinger, etc).</p>
             </div>
          </div>

        </div>

        <div className="p-6 bg-slate-50 border-t border-slate-200 flex justify-end">
          <button type="submit" className="px-8 py-3.5 bg-slate-900 text-white rounded-xl font-bold shadow-xl hover:bg-slate-800 hover:shadow-indigo-500/20 transition-all flex items-center text-lg active:scale-95">
            <CheckSquare size={20} className="mr-2"/> Guardar Configuración Maestra
          </button>
        </div>
      </form>
    </div>
  );
};

// Función auxiliar para el efecto Cristal (Glassmorphism)
const hexToRgb = (hex) => {
  if (!hex || hex.length !== 7) return {r:255,g:255,b:255};
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) } : {r:255,g:255,b:255};
};

// ==========================================
// --- COMPONENTE: VISOR PÚBLICO WIDGET (ALTA COSTURA - MULTIMODAL) ---
// ==========================================
const InvitacionPublicaView = ({ eventId, guestUid }) => {
  const [eventoInfo, setEventoInfo] = useState(null);
  const [guestInfo, setGuestInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showRSVP, setShowRSVP] = useState(false);
  const [rsvpStatus, setRsvpStatus] = useState('idle'); 
  const [formError, setFormError] = useState(''); 
  const [logoFailed, setLogoFailed] = useState(false);
  const [dataSent, setDataSent] = useState(false); 
  
  // 🟢 TOAST NOTIFICATION
  const [toast, setToast] = useState(null);
  const showToast = (text, type = 'info') => {
    setToast({ text, type });
    setTimeout(() => setToast(null), 3500);
  };

  // Estados para Modo Estricto y Simple
  const [tempSubGuests, setTempSubGuests] = useState([]);
  const [willAttendSimple, setWillAttendSimple] = useState(true);
  const [attendingCount, setAttendingCount] = useState(1);
  const [extraRequested, setExtraRequested] = useState(0);
  const [openPasses, setOpenPasses] = useState(1);
  const [openName, setOpenName] = useState('');

  // 🟢 EXTRACCIÓN MAESTRA DE DISEÑO Y DETECCIÓN AUTOMÁTICA DE SIMULADOR
  const searchString = window.location.search || (window.location.hash.includes('?') ? window.location.hash.split('?')[1] : '');
  const urlParams = new URLSearchParams(searchString);
  const isIframe = urlParams.get('iframe') === 'true' || window.location.href.includes('iframe=true');
  
  // Si el padre del iframe NO es la ventana superior (window.top), significa que estamos dentro del Simulador del Panel
  const isInsideSimulator = (() => {
    try { return window.self !== window.top && window.parent !== window.top; } 
    catch (e) { return true; }
  })();

  const isPreviewMode = urlParams.get('preview') === '1' || window.location.href.includes('preview=1') || document.referrer.includes('preview=1') || isInsideSimulator;
  
  const getHex = (param) => {
      const val = urlParams.get(param);
      if (!val) return null;
      if (val === 'transparent') return 'transparent';
      return val.startsWith('#') ? val : `#${val}`;
  };

  const t_bg = getHex('bg') || 'transparent';
  const t_card = getHex('card'); 
  const t_btn = getHex('btn') || '#d97706'; 
  const t_txt = getHex('txt') || '#1c1917'; 
  const t_font = urlParams.get('font') || '';

  const textRgb = hexToRgb(t_txt);
  const isDarkText = (textRgb.r * 0.299 + textRgb.g * 0.587 + textRgb.b * 0.114) < 186;

  // 🟢 INTEGRACIÓN NATIVA: Color sólido para la tarjeta
  const finalCardBg = (t_card && t_card !== 'transparent') ? t_card : (isDarkText ? '#ffffff' : '#111111');

  const themeContainer = { 
    backgroundColor: t_bg, 
    fontFamily: t_font ? `"${t_font}", sans-serif` : 'inherit', 
    minHeight: '100vh', 
    color: t_txt 
  };
  
  const themeSolidForm = {
    backgroundColor: finalCardBg,
    border: `1px solid rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.1)`,
    boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
    color: t_txt
  };

  const themeBtn = { backgroundColor: t_btn, color: '#ffffff', textTransform: 'uppercase', letterSpacing: '0.1em' };
  
  const themeInput = { 
    backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.04)`, 
    color: t_txt, 
    borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.15)`,
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
  };

  // 🟢 ESCUDO ANTI-MODO OSCURO
  useEffect(() => {
    if (isIframe) {
      document.documentElement.classList.remove('dark');
      document.documentElement.style.colorScheme = 'light';
    }
  }, [isIframe]);

  const qrEnabled = eventoInfo?.isQrEnabled !== false;
  const passCountEnabled = eventoInfo?.isPassCountEnabled !== false;

  useEffect(() => {
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = "viewport";
      document.head.appendChild(meta);
    }
    meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
  }, []);

  const comunicarDatosALaInvitacionHTML = useCallback((guestData) => {
    if (!isIframe || !window.parent || dataSent) return;

    const getCleanBaseUrl = () => window.location.hostname.includes('localhost') ? window.location.origin : 'https://baulia.com';
    const baseLink = `${getCleanBaseUrl()}/${eventId}`;

    const subGuestsWithQr = guestData.subGuests?.map(sg => ({
        ...sg,
        qrUrl: `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(baseLink + '?u=' + sg.id)}&margin=10`,
        eventNames: eventoInfo?.nombres || ''
    })) || [];

    window.parent.postMessage({ 
        action: 'RSVP_SUCCESS_DATA', 
        passesLimit: guestData.originalPasses || guestData.passes,
        confirmedCount: guestData.passes,
        subGuests: qrEnabled ? subGuestsWithQr : [], 
        status: guestData.status,
        theme: { btn: t_btn, txt: t_txt, txtRgb: textRgb }
    }, '*');

    window.parent.postMessage('rsvp_success', '*');
    
    setDataSent(true);
  }, [eventId, isIframe, eventoInfo, t_btn, t_txt, textRgb, dataSent, qrEnabled]);

  useEffect(() => {
    const getColOnce = async (colRef) => {
      try {
        const snap = await getDocs(colRef);
        return snap.docs.map(d => ({ id: d.id, ...d.data() }));
      } catch (error) {
        console.error("Error descargando datos:", error);
        return [];
      }
    };

    const fetchData = async () => {
      try {
        const docSnap = await getDoc(doc(db, "eventos", eventId));
        if (docSnap.exists()) setEventoInfo(docSnap.data());

        if (guestUid) {
          const [allGuests, allTables] = await Promise.all([
            getColOnce(collection(db, "eventos", eventId, "invitados")),
            getColOnce(collection(db, "eventos", eventId, "mesas"))
          ]);

          const tablesMap = {};
          allTables.forEach(t => { tablesMap[t.id] = t.name; });

          const targetDoc = allGuests.find(d => d.id === guestUid);
          if (targetDoc) {
            const rootId = targetDoc.parentId || targetDoc.id;
            const familyFragments = allGuests.filter(d => (d.parentId || d.id) === rootId);
            const rootDoc = familyFragments.find(d => d.id === rootId) || targetDoc;

            // Reunimos todos los QRs de la familia inyectando a cada uno su mesa asignada
            let mergedSubs = [];
            familyFragments.forEach(frag => {
              const rawTableName = frag.tableId ? (tablesMap[frag.tableId] || frag.tableId) : null;
              const cleanTableLabel = rawTableName ? String(rawTableName).replace(/^Mesa\s*:?\s*/i, '').trim() : null;
              const fragSubs = (frag.subGuests || []).map(sg => ({
                ...sg,
                tableId: cleanTableLabel,
                tableName: rawTableName
              }));
              mergedSubs = [...mergedSubs, ...fragSubs];
            });

            // Ordenamos para que el titular siempre aparezca primero
            mergedSubs.sort((a, b) => {
              if (a.name === rootDoc.name && b.name !== rootDoc.name) return -1;
              if (b.name === rootDoc.name && a.name !== rootDoc.name) return 1;
              return 0;
            });

            const totalActivePasses = familyFragments.reduce((sum, f) => sum + (f.passes || 0), 0);
            const gData = {
              ...rootDoc,
              id: rootId,
              passes: totalActivePasses,
              subGuests: mergedSubs
            };

            setGuestInfo(gData);
            setExtraRequested(gData.extraRequested || 0);
            
            const totalLimit = gData.originalPasses || gData.passes; 
            const currentSubs = gData.subGuests || [];
            
            const newTemp = Array(totalLimit).fill(null).map((_, i) => {
              if (currentSubs[i]) return { ...currentSubs[i], willAttend: true };
              const esMenor = gData.childrenPasses > 0 && i >= (totalLimit - gData.childrenPasses);
              return { name: i === 0 ? gData.name : '', isChild: esMenor, willAttend: false, id: `s_new_${Date.now()}_${i}` };
            });
            setTempSubGuests(newTemp);
            setAttendingCount(totalLimit);
            setWillAttendSimple(gData.status !== 'cancelado');
          }
        }
      } catch (error) {}
      setLoading(false);
    };
    setShowRSVP(true);
    fetchData();
  }, [eventId, guestUid]);

  const isConfirmadoOrSuccess = (guestInfo && (guestInfo.status === 'confirmado' || guestInfo.status === 'ingreso')) || rsvpStatus === 'success';

  useEffect(() => {
    if (!loading && guestInfo && eventoInfo && isConfirmadoOrSuccess) {
        comunicarDatosALaInvitacionHTML(guestInfo);
    }
  }, [loading, guestInfo, eventoInfo, isConfirmadoOrSuccess, comunicarDatosALaInvitacionHTML]);

  const handleSubGuestChange = (index, field, value) => {
    setFormError('');
    const newSubGuests = [...tempSubGuests];
    newSubGuests[index] = { ...newSubGuests[index], [field]: value };
    setTempSubGuests(newSubGuests);
  };

  const handleRSVPSubmit = async (e) => {
    e.preventDefault();
    setFormError('');

    if (isPreviewMode) {
      setRsvpStatus('submitting');
      setTimeout(() => {
         setRsvpStatus('success');
         showToast('Simulación Segura: Base de datos intacta.', 'success');
         if (guestInfo) {
           const attendingList = tempSubGuests.filter(sg => sg.willAttend);
           const safeAttending = (attendingList.length > 0 ? attendingList : tempSubGuests).map((sg, i) => ({
             ...sg,
             name: sg.name?.trim() || (i === 0 ? guestInfo.name : `Acompañante ${i + 1}`)
           }));

           const mockData = {
             ...guestInfo,
             status: 'confirmado',
             passes: qrEnabled ? safeAttending.length : attendingCount,
             subGuests: qrEnabled ? safeAttending : Array(attendingCount).fill({ id: 'sim_qr', name: guestInfo.name })
           };
           comunicarDatosALaInvitacionHTML(mockData);
         }
      }, 900);
      return; 
    }

    setRsvpStatus('submitting');
    
    try {
      let finalGuestData = null;

      if (guestUid && guestInfo) {
        if (qrEnabled) {
          const attendingGuests = tempSubGuests.filter(sg => sg.willAttend);
          const isCancelled = attendingGuests.length === 0;

          if (!isCancelled) {
            const emptyNames = attendingGuests.filter(sg => !sg.name.trim());
            if(emptyNames.length > 0) { 
               setFormError("Ingresa el nombre de todos los asistentes."); 
               setRsvpStatus('idle'); 
               return; 
            }
          }

          const subGuestsArray = attendingGuests.map((sg, i) => ({ 
            id: sg.id?.startsWith('s_new') ? `usr_${guestInfo.id}_${i}` : sg.id, 
            name: sg.name, isChild: sg.isChild, entered: false 
          }));

          finalGuestData = {
            ...guestInfo, passes: isCancelled ? 0 : attendingGuests.length, 
            status: isCancelled ? 'cancelado' : 'confirmado', extraRequested: extraRequested, 
            fechaConfirmacion: serverTimestamp(), subGuests: subGuestsArray
          };
        } else {
          const isCancelled = !willAttendSimple;
          const finalCount = isCancelled ? 0 : (passCountEnabled ? attendingCount : (guestInfo.originalPasses || 1));
          const subGuestsArray = isCancelled ? [] : Array(finalCount).fill(null).map((_, i) => ({
              id: `usr_${guestInfo.id}_${i}`, name: i === 0 ? guestInfo.name : `Acompañante de ${guestInfo.name}`,
              isChild: false, entered: false
          }));

          finalGuestData = {
            ...guestInfo, passes: finalCount, status: isCancelled ? 'cancelado' : 'confirmado',
            extraRequested: passCountEnabled ? extraRequested : 0, 
            fechaConfirmacion: serverTimestamp(), subGuests: subGuestsArray
          };
        }
        await setDoc(doc(db, "eventos", eventId, "invitados", guestUid), finalGuestData);
        setGuestInfo(finalGuestData);
      } else {
        const subGuestsArray = Array(parseInt(openPasses)).fill(null).map((_, i) => ({ 
          id: `usr_gen_${Date.now()}_${i}`, name: i === 0 ? openName : `Acompañante de ${openName}`, 
          isChild: false, entered: false 
        }));
        const newDocRef = await addDoc(collection(db, "eventos", eventId, "invitados"), {
          name: openName, passes: parseInt(openPasses), originalPasses: parseInt(openPasses),
          status: 'confirmado', fechaConfirmacion: serverTimestamp(), side: 'general', entered: 0, tableId: null,
          subGuests: subGuestsArray
        });
        const newGuestSnap = await getDoc(newDocRef);
        finalGuestData = { id: newDocRef.id, ...newGuestSnap.data() };
        setGuestInfo(finalGuestData);
      }
      
      setRsvpStatus('success');
      if (finalGuestData) comunicarDatosALaInvitacionHTML(finalGuestData);
    } catch (error) { 
      setFormError("Error al guardar. Revisa tu conexión."); setRsvpStatus('idle'); 
    }
  };

  // ==========================================
  // PANTALLA 1: ESTADO DE CARGA (INTEGRADO)
  // ==========================================
  if (loading) return (
    <div style={themeContainer} className="relative flex items-center justify-center p-3 sm:p-4 overflow-hidden min-h-screen">
      {isIframe && (<style>{`html, body, #root { background: transparent !important; overflow-x: hidden !important; touch-action: pan-y !important; }`}</style>)}
      {t_font && <style>{`@import url('https://fonts.googleapis.com/css2?family=${t_font.replace(/ /g, '+')}&display=swap');`}</style>}
      
      <div className="w-full max-w-sm mx-auto z-50 animate-in slide-in-from-bottom-8 duration-500">
        <div style={themeSolidForm} className={`w-full ${isPreviewMode ? 'rounded-b-2xl' : 'rounded-3xl'} p-8 flex flex-col items-center justify-center min-h-[300px] shadow-2xl`}>
          <svg className="animate-spin h-10 w-10 mb-5" style={{ color: t_btn }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
          <p className="text-[10px] font-bold uppercase tracking-widest opacity-60" style={{ color: t_txt }}>Conectando Bóveda...</p>
        </div>
      </div>
    </div>
  );

  // ==========================================
  // PANTALLA 2: ERROR 404
  // ==========================================
  if (!eventoInfo) return (
    <div style={themeContainer} className="relative flex items-center justify-center p-3 sm:p-4 overflow-hidden min-h-screen">
      {isIframe && (<style>{`html, body, #root { background: transparent !important; overflow-x: hidden !important; touch-action: pan-y !important; }`}</style>)}
      <div className="w-full max-w-sm mx-auto z-50">
        <div style={themeSolidForm} className="w-full rounded-3xl p-10 flex flex-col items-center justify-center shadow-2xl text-center">
          <div className="w-16 h-16 rounded-full bg-rose-500/10 flex items-center justify-center mb-4"><svg className="text-rose-500 w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg></div>
          <p className="text-sm font-bold uppercase tracking-widest text-rose-500">Error 404</p>
          <p className="text-xs opacity-70 mt-2" style={{ color: t_txt }}>El enlace es inválido.</p>
        </div>
      </div>
    </div>
  );

  // ==========================================
  // PANTALLA 3: CONFIRMACIÓN EXITOSA
  // ==========================================
  if (isConfirmadoOrSuccess) {
    return (
      <div style={themeContainer} className="relative flex items-center justify-center p-3 sm:p-4 overflow-hidden min-h-screen">
        {isIframe && (<style>{`html, body, #root { background: transparent !important; overflow-x: hidden !important; touch-action: pan-y !important; }`}</style>)}
        {t_font && <style>{`@import url('https://fonts.googleapis.com/css2?family=${t_font.replace(/ /g, '+')}&display=swap');`}</style>}
        
        <div className="w-full max-w-sm mx-auto z-50 animate-in zoom-in-95 duration-500">
          <div style={themeSolidForm} className={`w-full ${isPreviewMode ? 'rounded-b-2xl' : 'rounded-3xl'} p-10 flex flex-col items-center justify-center shadow-2xl text-center min-h-[300px]`}>
            <div style={{ borderColor: t_btn, color: t_btn, backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.03)` }} className="w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-inner border">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </div>
            <h2 className="text-lg font-bold uppercase tracking-widest mb-3" style={{ color: t_txt }}>¡Confirmado!</h2>
            <p className="text-xs opacity-70 leading-relaxed max-w-[250px]" style={{ color: t_txt }}>Tu asistencia ha sido registrada exitosamente en nuestra base de datos.</p>
          </div>
        </div>
      </div>
    );
  }

  // ==========================================
  // PANTALLA 4: EL FORMULARIO DE RSVP
  // ==========================================
  return (
    <div style={themeContainer} className="relative flex items-center justify-center p-3 sm:p-4 overflow-hidden min-h-screen">
      {isIframe && (<style>{`html, body, #root { background: transparent !important; overflow-x: hidden !important; touch-action: pan-y !important; }`}</style>)}
      {t_font && <style>{`@import url('https://fonts.googleapis.com/css2?family=${t_font.replace(/ /g, '+')}&display=swap');`}</style>}

      {toast && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[99999] animate-in slide-in-from-top-4 fade-in duration-300 w-max max-w-[90vw]">
          <div className={`px-4 py-2.5 rounded-full shadow-2xl flex items-center gap-2 text-[10px] sm:text-xs font-bold text-white border border-white/20 ${toast.type === 'error' ? 'bg-rose-600' : 'bg-emerald-600'}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> {toast.text}
          </div>
        </div>
      )}

      {showRSVP && (
        <div className="w-full max-w-sm mx-auto z-50 animate-in slide-in-from-bottom-8 duration-500">
          
          {isPreviewMode && (
            <div className="bg-rose-500 text-white text-[10px] font-black uppercase tracking-widest py-1.5 text-center shadow-lg rounded-t-xl animate-pulse flex justify-center items-center">
               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg> Vista Previa Protegida
            </div>
          )}

          {/* 🟢 LA TARJETA SÓLIDA NATIVA */}
          <div style={themeSolidForm} className={`w-full ${isPreviewMode ? 'rounded-b-2xl' : 'rounded-3xl'} p-6 sm:p-8 max-h-[90vh] overflow-y-auto overflow-x-hidden custom-scrollbar shadow-2xl`}>
            
            <div className="text-center mb-6 border-b pb-4" style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.15)` }}>
               {!logoFailed ? (
                 <img src={`/${eventId}/logodeevento.svg`} alt="Logotipo" className="h-16 mx-auto mb-3 object-contain drop-shadow-md" onError={() => setLogoFailed(true)} />
               ) : (
                 <h3 className="text-xl sm:text-2xl font-editorial font-bold leading-tight mb-2">{eventoInfo?.nombres || 'Confirmación'}</h3>
               )}
               {guestInfo && (
                  <p className="mt-1 text-sm font-medium opacity-80">
                     {guestInfo.name} {passCountEnabled && `(${guestInfo.originalPasses || guestInfo.passes} lugares)`}
                  </p>
               )}
            </div>
            
            <form onSubmit={handleRSVPSubmit} className="space-y-4">
              {guestInfo ? (
                <>
                  {qrEnabled ? (
                    <>
                      <div className="text-center mt-5 mb-3">
                        <h4 className="font-bold text-sm uppercase tracking-widest opacity-90">Asistentes</h4>
                      </div>
                      
                      <div className="space-y-3">
                        {tempSubGuests.map((sg, idx) => (
                          <div key={idx} style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, ${sg.willAttend ? '0.2' : '0.1'})`, backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.03)` }} className="p-4 rounded-2xl border transition-all">
                            <div className="flex justify-between items-center mb-1">
                              <label className="text-xs font-bold uppercase tracking-wider">Pase #{idx + 1}</label>
                              <label style={{ backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.05)` }} className="flex items-center space-x-2 cursor-pointer px-3 py-1.5 rounded-lg border border-white/5" >
                                <input type="checkbox" checked={sg.willAttend} onChange={(e) => handleSubGuestChange(idx, 'willAttend', e.target.checked)} className="w-4 h-4 accent-emerald-600" />
                                <span className="text-[10px] font-bold uppercase tracking-wider">{sg.willAttend ? 'SÍ VOY' : 'NO VOY'}</span>
                              </label>
                            </div>
                            
                            {sg.willAttend && (
                              <div className="space-y-2 mt-4 pt-3 border-t animate-in fade-in" style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.1)` }}>
                                <input 
                                  type="text" required placeholder={sg.isChild ? "Nombre del niño..." : (idx === 0 ? "Tu nombre..." : "Nombre del adulto...")} 
                                  value={sg.name || ''} onChange={(e) => handleSubGuestChange(idx, 'name', e.target.value)} 
                                  style={themeInput} className="w-full p-3 border rounded-xl text-sm font-medium outline-none" 
                                />
                                <label className="flex items-center space-x-2 cursor-pointer pt-2">
                                   <input type="checkbox" checked={sg.isChild || false} onChange={(e) => handleSubGuestChange(idx, 'isChild', e.target.checked)} className="w-4 h-4 accent-indigo-600" />
                                   <span className="text-[10px] font-bold uppercase tracking-wider opacity-70">Pase de Menor / Niño</span>
                                </label>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="space-y-4 text-center mt-6">
                       <p className="text-sm font-bold opacity-90 uppercase tracking-widest">¿Asistirás al evento?</p>
                       <div className="flex gap-3 justify-center">
                          <button type="button" onClick={() => setWillAttendSimple(true)} style={{ backgroundColor: willAttendSimple ? t_btn : 'transparent', color: willAttendSimple ? '#ffffff' : t_txt, borderColor: willAttendSimple ? 'transparent' : `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.2)` }} className="flex-1 py-3.5 rounded-2xl font-bold text-xs uppercase tracking-widest transition-all border shadow-sm">Sí, Asistiré</button>
                          <button type="button" onClick={() => setWillAttendSimple(false)} style={{ backgroundColor: !willAttendSimple ? '#ef4444' : 'transparent', color: !willAttendSimple ? '#ffffff' : t_txt, borderColor: !willAttendSimple ? 'transparent' : `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.2)` }} className="flex-1 py-3.5 rounded-2xl font-bold text-xs uppercase tracking-widest transition-all border opacity-90 shadow-sm">No Asistiré</button>
                       </div>
                       
                       {passCountEnabled && willAttendSimple && (
                          <div className="p-5 rounded-2xl border mt-5 text-left animate-in fade-in slide-in-from-top-2" style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.15)`, backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.03)` }}>
                             <label className="block text-[10px] font-bold uppercase tracking-widest mb-2.5 opacity-90">¿Cuántos asisten de tu grupo?</label>
                             <select value={attendingCount} onChange={e => setAttendingCount(Number(e.target.value))} style={themeInput} className="w-full p-3.5 border rounded-xl outline-none font-medium text-sm cursor-pointer appearance-none">
                                {Array.from({ length: guestInfo.originalPasses || guestInfo.passes }, (_, i) => i + 1).map(n => (
                                   <option key={n} value={n} className="text-slate-900">{n} {n === 1 ? 'persona' : 'personas'}</option>
                                ))}
                             </select>
                          </div>
                       )}
                    </div>
                  )}

                  {passCountEnabled && (
                    <div className="border-t pt-5 mt-6 flex items-center justify-between p-2" style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.15)` }}>
                      <div>
                        <p className="text-xs font-bold uppercase tracking-widest">¿Pases extra?</p>
                        <p className="text-[9px] opacity-60 leading-tight mt-0.5">Sujeto a disponibilidad.</p>
                      </div>
                      <div style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.2)`, backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.05)` }} className="flex items-center border rounded-xl p-1 shadow-inner">
                        <button type="button" onClick={() => setExtraRequested(Math.max(0, extraRequested - 1))} className="w-8 h-8 rounded-lg flex items-center justify-center text-lg font-bold hover:bg-black/5">-</button>
                        <span className="text-sm font-black w-8 text-center">{extraRequested}</span>
                        <button type="button" onClick={() => setExtraRequested(extraRequested + 1)} className="w-8 h-8 rounded-lg flex items-center justify-center text-lg font-bold hover:bg-black/5">+</button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div className="space-y-4 mt-4">
                  <div className="p-4 rounded-2xl border" style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.15)`, backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.03)` }}>
                    <label className="block text-[10px] font-bold uppercase tracking-widest mb-2 opacity-90">Para Ti</label>
                    <input type="text" required value={openName} onChange={e => setOpenName(e.target.value)} style={themeInput} className="w-full p-3.5 border rounded-xl outline-none font-medium text-sm" placeholder="Ej. Familia López" />
                  </div>
                  {passCountEnabled && (
                    <div className="p-4 rounded-2xl border" style={{ borderColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.15)`, backgroundColor: `rgba(${textRgb.r}, ${textRgb.g}, ${textRgb.b}, 0.03)` }}>
                      <label className="block text-[10px] font-bold uppercase tracking-widest mb-2 opacity-90">¿Cuántos asisten?</label>
                      <select value={openPasses} onChange={e => setOpenPasses(e.target.value)} style={themeInput} className="w-full p-3.5 border rounded-xl outline-none font-medium text-sm appearance-none cursor-pointer">
                        {[1,2,3,4,5,6,7,8].map(n => <option key={n} value={n} className="text-slate-900">{n} persona(s)</option>)}
                      </select>
                    </div>
                  )}
                </div>
              )}
              
              {formError && (
                 <div className="bg-rose-500/10 border border-rose-500/30 text-rose-600 p-4 rounded-2xl font-bold text-xs flex items-center shadow-sm animate-in shake mt-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 flex-shrink-0"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> {formError}
                 </div>
              )}

              <button type="submit" disabled={rsvpStatus === 'submitting'} style={{...themeBtn, opacity: (!guestInfo || (qrEnabled ? tempSubGuests.filter(s => s.willAttend).length > 0 : willAttendSimple)) ? 1 : 0.8 }} className="w-full py-4 rounded-2xl font-bold text-sm shadow-xl hover:scale-[1.02] transition-transform mt-8 border-b-4 border-black/10 flex justify-center items-center">
                {rsvpStatus === 'submitting' ? <><svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> Enviando...</> : (!guestInfo || (qrEnabled ? tempSubGuests.filter(s => s.willAttend).length > 0 : willAttendSimple) ? 'Confirmar Asistencia' : 'Declinar Invitación')}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// ==========================================
// --- COMPONENTE: PANTALLA DE ACCESO BAULIA ---
// ==========================================
const LoginScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [mensajeOk, setMensajeOk] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); setError(''); setMensajeOk('');
    try { await signInWithEmailAndPassword(auth, email.trim(), password); } 
    catch (err) { setError('Credenciales incorrectas o usuario no encontrado.'); setIsLoading(false); }
  };

  const handleResetPassword = async () => {
    if (!email) { setError('Escribe tu correo arriba y presiona "Recuperar" de nuevo.'); return; }
    try { await sendPasswordResetEmail(auth, email.trim()); setMensajeOk('Enlace de recuperación enviado al correo.'); setError(''); } 
    catch (err) { setError('Error al enviar. Verifica el correo.'); }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center p-4 font-sans relative overflow-hidden text-white">
      {/* Luces de fondo estilo Champagne */}
      <div className="absolute top-[-20%] left-[-10%] w-[500px] h-[500px] bg-[#D4AF37]/10 hidden md:block blur-[120px] rounded-full pointer-events-none"></div>
      <div className="absolute bottom-[-20%] right-[-10%] w-[600px] h-[600px] bg-white/5 hidden md:block blur-[150px] rounded-full pointer-events-none"></div>
      
      <div className="bg-[#1C1917]/95 backdrop-blur-xl p-10 rounded-3xl shadow-[0_30px_60px_rgba(0,0,0,0.9)] w-full max-w-md relative z-10 border border-[#D4AF37]/30">
        <div className="flex flex-col items-center mb-8">
           <div className="mb-2 drop-shadow-[0_0_15px_rgba(212,175,55,0.3)] hover:scale-105 transition-transform cursor-default">
              <BauliaLogo className="h-16 w-auto" forceWhite={true} />
           </div>
           <p className="text-[#D4AF37] text-[10px] font-black uppercase tracking-[0.25em] mt-3">Bóveda Premium</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Correo Electrónico</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none transition-colors font-bold text-white shadow-inner" placeholder="tu@correo.com" />
          </div>
          <div>
            <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Contraseña Segura</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required className="w-full p-4 bg-[#141210] border border-white/10 rounded-xl focus:border-[#D4AF37] outline-none transition-colors font-bold text-white shadow-inner" placeholder="••••••••" />
          </div>
          
          {error && <div className="bg-rose-500/10 text-rose-400 p-4 rounded-xl text-[10px] font-bold uppercase tracking-widest text-center border border-rose-500/20 animate-in shake">{error}</div>}
          {mensajeOk && <div className="bg-emerald-500/10 text-emerald-400 p-4 rounded-xl text-[10px] font-bold uppercase tracking-widest text-center border border-emerald-500/20">{mensajeOk}</div>}
          
          <button type="submit" disabled={isLoading} className="w-full py-4 bg-[#D4AF37] text-[#1C1917] rounded-xl font-black text-sm uppercase tracking-widest shadow-[0_10px_25px_rgba(212,175,55,0.25)] hover:bg-[#c5a028] hover:scale-[1.02] transition-all mt-6 disabled:opacity-50 disabled:hover:scale-100">
            {isLoading ? 'Autenticando...' : 'Acceder al Panel'}
          </button>
        </form>
        
        <div className="mt-8 text-center border-t border-white/10 pt-6">
          <button onClick={handleResetPassword} type="button" className="text-[10px] font-bold uppercase tracking-widest text-slate-500 hover:text-[#D4AF37] transition-colors">
            ¿Olvidaste tu contraseña? Recuperar aquí
          </button>
        </div>
      </div>
    </div>
  );
};

// ==========================================
// --- COMPONENTE: PANEL DE ADMINISTRACIÓN ---
// ==========================================
const AdminDashboard = ({ authData, cycleTheme, themeSetting, isDarkMode }) => {
  const { role: originalUserRole, plan: originalUserPlan, eventId: originalEventId, availableEvents } = authData;
  const switchEvent = (newEventId) => { localStorage.setItem('eventmaster_currentEventId', newEventId); window.location.reload(); };
  const [impersonating, setImpersonating] = useState(null);
  
  const eventId = impersonating ? impersonating.id : originalEventId;
  const userRole = impersonating ? impersonating.role : originalUserRole;
  const userPlan = impersonating ? impersonating.plan : originalUserPlan;

  const isSuperAdminMode = originalUserRole === 'superadmin' && !impersonating;
  const activeEventData = impersonating || authData?.availableEvents?.find(e => e.eventId === eventId) || {};
  const currentEventType = activeEventData.tipoEvento || 'general';
  const currentEventPlan = activeEventData.plan || 'diamante';
  const currentEventName = activeEventData.nombres || activeEventData.nombre || 'Evento Baulia';
  const hasSocialWall = activeEventData.hasSocialWall || false;
  const hasBlackLabel = activeEventData.hasBlackLabel || false;

  const isSingleAppMode = userPlan === 'social_wall';
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const [activeTab, setActiveTab] = useState(() => {
    if (userRole === 'superadmin') return 'licencias';
    if (userPlan === 'social_wall') return 'galeria';
    if (userPlan === 'security_kit') return 'invitados'; 
    return 'dashboard';
  });

  useEffect(() => {
    if (userPlan === 'social_wall' && activeTab !== 'galeria') {
      setActiveTab('galeria');
    } else if (userPlan === 'security_kit' && !['invitados', 'pulseras', 'escaner', 'monitor'].includes(activeTab)) {
      setActiveTab('invitados'); 
    } else if (!isSingleAppMode && userPlan !== 'security_kit') {
      if (activeTab === 'galeria' && !['diamante', 'social_wall'].includes(userPlan) && !hasSocialWall) setActiveTab('dashboard'); 
      if (activeTab === 'pulseras' && !['diamante'].includes(userPlan) && !hasBlackLabel) setActiveTab('dashboard'); 
      if (activeTab === 'escaner' && !['oro', 'diamante'].includes(userPlan) && !hasBlackLabel) setActiveTab('dashboard');
      if (activeTab === 'monitor' && !['diamante'].includes(userPlan) && !hasBlackLabel) setActiveTab('dashboard');
    }
  }, [userPlan, activeTab, isSingleAppMode, hasSocialWall, hasBlackLabel]);
  
  const [tareas, setTareas] = useState([]); 
  const [timing, setTiming] = useState([]); 
  const [guests, setGuests] = useState([]); 
  const [tables, setTables] = useState([]); 
  const [gastos, setGastos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [globalSearch, setGlobalSearch] = useState('');
  const [mapElements, setMapElements] = useState([]); 
  const [decoElements, setDecoElements] = useState([]);
  const [photos, setPhotos] = useState([]); 

  const [presupuestoTotal, setPresupuestoTotal] = useState(() => {
    const saved = localStorage.getItem('eventmaster_presupuesto');
    return saved ? Number(saved) : 150000;
  });

  const [notifications, setNotifications] = useState([]);
  const [bellAlerts, setBellAlerts] = useState([]); 
  const [agencyConfig, setAgencyConfig] = useState(null);

  const addNotification = React.useCallback((title, message, type = 'info', tab = null) => {
    const id = Date.now() + Math.random(); 
    const notifObj = { id, title, message, type, tab, date: new Date(), isRead: false };
    setNotifications(prev => [...prev, notifObj]);
    setTimeout(() => { setNotifications(prev => prev.filter(n => n.id !== id)); }, 6000);
    setBellAlerts(prev => [notifObj, ...prev].slice(0, 30));
  }, []);

  const markAsRead = React.useCallback((id) => setBellAlerts(prev => prev.map(a => a.id === id ? { ...a, isRead: true } : a)), []);

  useEffect(() => {
    const handleNotif = (e) => addNotification(e.detail.title, e.detail.message, e.detail.type);
    window.addEventListener('mostrarNotificacionBaulia', handleNotif);
    return () => window.removeEventListener('mostrarNotificacionBaulia', handleNotif);
  }, [addNotification]);
  
  const prevGuestsRef = useRef([]);
  const [estadoCuenta, setEstadoCuenta] = useState({ deuda: 0, fechaEntrega: null, bloqueado: false, urlInvitacion: '', status: '' });
  const [horasRestantesGracia, setHorasRestantesGracia] = useState(null);

  // 🟢 ESTADOS DE APP NATIVA (Scroll con amortiguador Instagram, Buscador separado y Menú Hub)
  const [showMobileHub, setShowMobileHub] = useState(false);
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const lastScrollY = useRef(0);
  const scrollUpAccum = useRef(0);
  const scrollDownAccum = useRef(0);

  // Elimina automáticamente el botón flotante de "Calificar Experiencia" que estorba
  useEffect(() => {
    const quitarBotonCalificar = () => {
      document.querySelectorAll('button').forEach(btn => {
        if (btn.textContent && btn.textContent.toLowerCase().includes('calificar experiencia')) {
          btn.style.display = 'none';
        }
      });
    };
    quitarBotonCalificar();
    const t = setTimeout(quitarBotonCalificar, 500);
    return () => clearTimeout(t);
  }, [activeTab]);

  const handleMainScroll = (e) => {
    const currentScrollY = e.target.scrollTop;
    const diff = currentScrollY - lastScrollY.current;

    // Si llega hasta arriba, siempre muestra la barra superior
    if (currentScrollY <= 25) {
      setIsHeaderVisible(true);
      scrollUpAccum.current = 0;
      scrollDownAccum.current = 0;
      lastScrollY.current = currentScrollY;
      return;
    }

    if (diff > 0) {
      // Bajando por la página
      scrollDownAccum.current += diff;
      scrollUpAccum.current = 0;
      if (scrollDownAccum.current > 25 && currentScrollY > 65) {
        setIsHeaderVisible(false);
      }
    } else if (diff < 0) {
      // Subiendo: requiere deslizar al menos 50px continuos hacia arriba (estilo Instagram)
      scrollUpAccum.current += Math.abs(diff);
      scrollDownAccum.current = 0;
      if (scrollUpAccum.current > 50) {
        setIsHeaderVisible(true);
      }
    }

    lastScrollY.current = currentScrollY;
  };

  const getInitialsMobile = (name) => {
    if(!name) return 'VIP';
    const words = name.split(' ').filter(w => w.length > 0 && w.toLowerCase() !== 'y' && w.toLowerCase() !== 'e');
    if(words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };

  // 🟢 ESTADOS PARA LA PASARELA DE LIQUIDACIÓN STRIPE DENTRO DE LA BÓVEDA
  const [showModalLiquidar, setShowModalLiquidar] = useState(false);
  const [clientSecretLiq, setClientSecretLiq] = useState(null);
  const [loadingLiq, setLoadingLiq] = useState(false);
  const [errorLiq, setErrorLiq] = useState(null);

  const abrirPasarelaLiquidacion = async () => {
    setShowModalLiquidar(true);
    setLoadingLiq(true);
    setErrorLiq(null);
    try {
      const respuesta = await fetch("https://us-central1-panel-de-control-intelig-db278.cloudfunctions.net/crearIntentoAsincrono", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          plan: currentEventPlan,
          precio: estadoCuenta.deuda,
          moneda: 'MXN',
          nombre: `LIQUIDACION_${eventId}`,
          email: activeEventData?.email || authData?.email || 'liquidacion@baulia.com',
          fecha: activeEventData?.fechaEvento || activeEventData?.fecha || '',
          telefono: activeEventData?.telefono || '+52 0000000000',
          pais: 'MX'
        })
      });
      const data = await respuesta.json();
      if (data.clientSecret) setClientSecretLiq(data.clientSecret);
      else setErrorLiq(data.error || "No se pudo iniciar la sesión con el banco.");
    } catch (e) {
      setErrorLiq("Error de conexión con la pasarela bancaria.");
    }
    setLoadingLiq(false);
  };

  const confirmarLiquidacionExitosa = async () => {
    try {
      await setDoc(doc(db, "usuarios", eventId), { deudaPlataforma: 0, bloqueadoPorPago: false }, { merge: true });
      await setDoc(doc(db, "eventos", eventId), { deudaPlataforma: 0, bloqueadoPorPago: false }, { merge: true });
      setEstadoCuenta(prev => ({ ...prev, deuda: 0, bloqueado: false }));
      setShowModalLiquidar(false);
      setClientSecretLiq(null);
      addNotification('¡Saldo Liquidado!', 'Tu bóveda e invitación digital han sido liberadas al 100%.', 'success');
    } catch (e) {
      console.error("Error al liberar bóveda:", e);
    }
  };

  useEffect(() => {
    if (userRole === 'superadmin' && !impersonating) return;
    if (typeof setGlobalEventId !== 'undefined') setGlobalEventId(eventId);

    // Escuchamos tanto usuarios como eventos para que los clientes de Stripe siempre tengan su deuda y reloj sincronizados
    const unsubUserDoc = onSnapshot(doc(db, "usuarios", eventId), (docSnap) => {
      if (docSnap.exists()) {
        const u = docSnap.data();
        setEstadoCuenta(prev => ({
          deuda: u.deudaPlataforma !== undefined ? Number(u.deudaPlataforma) : prev.deuda,
          fechaEntrega: u.fechaEntrega || prev.fechaEntrega,
          bloqueado: u.bloqueadoPorPago === true,
          urlInvitacion: u.urlInvitacion || prev.urlInvitacion || '',
          status: u.status || prev.status || ''
        }));
      }
    });

    const unsubConfigMain = onSnapshot(doc(db, "eventos", eventId), (docSnap) => {
      if (docSnap.exists()) {
        const d = docSnap.data();
        if (d.presupuestoTotal !== undefined) {
          const remoteBudget = Number(d.presupuestoTotal);
          setPresupuestoTotal(remoteBudget);
          localStorage.setItem('eventmaster_presupuesto', remoteBudget);
        }
        setEstadoCuenta(prev => ({
          deuda: d.deudaPlataforma !== undefined ? Number(d.deudaPlataforma) : prev.deuda,
          fechaEntrega: d.fechaEntrega || prev.fechaEntrega,
          bloqueado: d.bloqueadoPorPago === true,
          urlInvitacion: d.urlInvitacion || prev.urlInvitacion || '',
          status: d.status || prev.status || ''
        }));
      }
    });

    const unsubWhiteLabel = onSnapshot(doc(db, "eventos", eventId, "configuracion", "marcaBlanca"), (docSnap) => {
      if (docSnap.exists()) setAgencyConfig(docSnap.data());
    });

    const unsubGuests = onSnapshot(collection(db, "eventos", eventId, "invitados"), (snap) => {
      const newGuests = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      prevGuestsRef.current = newGuests;
      setGuests(newGuests);
    });

    const unsubGastos = onSnapshot(collection(db, "eventos", eventId, "gastos"), (snap) => setGastos(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubProv = onSnapshot(collection(db, "eventos", eventId, "proveedores"), (snap) => setProveedores(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubMesas = onSnapshot(collection(db, "eventos", eventId, "mesas"), (snap) => setTables(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubTareas = onSnapshot(collection(db, "eventos", eventId, "tareas"), (snap) => setTareas(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubTiming = onSnapshot(collection(db, "eventos", eventId, "timing"), (snap) => setTiming(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubMapa = onSnapshot(collection(db, "eventos", eventId, "mapa"), (snap) => setMapElements(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubDeco = onSnapshot(collection(db, "eventos", eventId, "decoracion"), (snap) => setDecoElements(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));
    const unsubFotos = onSnapshot(collection(db, "eventos", eventId, "fotos"), (snap) => setPhotos(snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))));

    return () => { unsubUserDoc(); unsubConfigMain(); unsubWhiteLabel(); unsubGuests(); unsubGastos(); unsubProv(); unsubMesas(); unsubTareas(); unsubTiming(); unsubMapa(); unsubDeco(); unsubFotos(); };
  }, [eventId, userRole, impersonating, addNotification]);

  // 🟢 CRONÓMETRO VIGILANTE DE 24 HORAS Y DISPARADOR DE KILL SWITCH
  useEffect(() => {
    if (isSuperAdminMode) return;
    
    const tieneLink = (estadoCuenta.urlInvitacion || '').trim() !== '';
    const estaActivo = estadoCuenta.status === 'activo';

    // BLINDAJE: Solo arranca si el cliente tiene deuda, fecha de entrega, status ACTIVO y un LINK real.
    if (estadoCuenta.deuda <= 0 || !estadoCuenta.fechaEntrega || !tieneLink || !estaActivo) {
      setHorasRestantesGracia(null);
      return;
    }

    const LIMITE_24H = 24 * 60 * 60 * 1000;
    const verificarPlazo = () => {
      const transcurrido = Date.now() - Number(estadoCuenta.fechaEntrega);
      const restante = LIMITE_24H - transcurrido;

      if (restante <= 0) {
        setHorasRestantesGracia(0);
        if (!estadoCuenta.bloqueado && eventId) {
          updateDoc(doc(db, "eventos", eventId), { bloqueadoPorPago: true }).catch(() => {});
          updateDoc(doc(db, "usuarios", eventId), { bloqueadoPorPago: true }).catch(() => {});
        }
      } else {
        const hrs = Math.floor(restante / (1000 * 60 * 60));
        const mins = Math.floor((restante % (1000 * 60 * 60)) / (1000 * 60));
        setHorasRestantesGracia(`${hrs}h ${mins}m`);
      }
    };

    verificarPlazo();
    const timer = setInterval(verificarPlazo, 30000);
    return () => clearInterval(timer);
  }, [estadoCuenta, eventId, isSuperAdminMode]);

  const renderContent = () => {
    if (userPlan === 'social_wall') {
      return typeof GaleriaView !== 'undefined' ? <GaleriaView photos={photos} addNotification={addNotification} eventoId={eventId} /> : null;
    }

    switch(activeTab) {
      case 'licencias': return isSuperAdminMode && typeof SuperAdminView !== 'undefined' ? <SuperAdminView onImpersonate={(cliente) => { setImpersonating(cliente); setActiveTab('dashboard'); }} authData={authData} /> : null;
      case 'precios': return isSuperAdminMode && typeof GestorPreciosView !== 'undefined' ? <GestorPreciosView /> : null;
      case 'dashboard': return ['basico', 'esencial', 'plata', 'oro', 'diamante'].includes(userPlan) && typeof DashboardView !== 'undefined' ? <DashboardView authData={authData} guests={guests} tables={tables} gastos={gastos} presupuestoTotal={presupuestoTotal} tareas={tareas} setActiveTab={setActiveTab} addNotification={addNotification} /> : null;      
      
      case 'invitados': 
        return ['basico', 'esencial', 'plata', 'oro', 'diamante', 'security_kit'].includes(userPlan) && typeof InvitadosView !== 'undefined' ? <InvitadosView tables={tables} guests={guests} setGuests={setGuests} addNotification={addNotification} tipoEvento={currentEventType} userPlan={currentEventPlan} eventName={currentEventName} urlInvitacion={activeEventData?.urlInvitacion} /> : null;      
      
      case 'pulseras': 
        return (['diamante', 'security_kit'].includes(userPlan) || hasBlackLabel) && typeof GestorPulserasView !== 'undefined' ? <GestorPulserasView addNotification={addNotification} eventId={eventId} /> : null;

      case 'escaner': return (['oro', 'diamante', 'security_kit'].includes(userPlan) || hasBlackLabel) && typeof EscanerView !== 'undefined' ? <EscanerView guests={guests} setGuests={setGuests} tables={tables} isSharedMode={false} addNotification={addNotification} /> : null; 
      case 'monitor': return (['security_kit', 'diamante', 'baulia_black_label'].includes(userPlan) || hasBlackLabel) && typeof MonitorRecepcionView !== 'undefined' ? <MonitorRecepcionView eventId={eventId} eventName={currentEventName} /> : null; 

      case 'mesas': return ['oro', 'diamante'].includes(userPlan) && typeof MesasView !== 'undefined' ? <MesasView tables={tables} setTables={setTables} guests={guests} setGuests={setGuests} addNotification={addNotification} /> : null; 
      case 'mapa': return userPlan === 'diamante' && typeof MapaView !== 'undefined' ? <MapaView tables={tables} setTables={setTables} guests={guests} setGuests={setGuests} globalSearch={globalSearch} elements={mapElements} setElements={setMapElements} /> : null;
      case 'decoracion': return userPlan === 'diamante' && typeof DecoracionView !== 'undefined' ? <DecoracionView elements={decoElements} setElements={setDecoElements} addNotification={addNotification} /> : null; 
      case 'tareas': return ['basico', 'esencial', 'plata', 'oro', 'diamante'].includes(userPlan) && typeof ChecklistView !== 'undefined' ? <ChecklistView tareas={tareas} addNotification={addNotification} /> : null;
      case 'timing': return ['plata', 'oro', 'diamante'].includes(userPlan) && typeof TimingView !== 'undefined' ? <TimingView timing={timing} setTiming={setTiming} addNotification={addNotification} /> : null;
      case 'presupuesto': return ['basico', 'esencial', 'plata', 'oro', 'diamante'].includes(userPlan) && typeof PresupuestoView !== 'undefined' ? <PresupuestoView eventId={eventId} authData={authData} gastos={gastos} setGastos={setGastos} proveedores={proveedores} setProveedores={setProveedores} presupuestoTotal={presupuestoTotal} setPresupuestoTotal={setPresupuestoTotal} addNotification={addNotification} /> : null;
      case 'proveedores': return ['basico', 'esencial', 'plata', 'oro', 'diamante'].includes(userPlan) && typeof ProveedoresView !== 'undefined' ? <ProveedoresView proveedores={proveedores} setProveedores={setProveedores} gastos={gastos} setGastos={setGastos} addNotification={addNotification} /> : null;
      
      case 'galeria': return (['diamante', 'social_wall'].includes(userPlan) || hasSocialWall) && typeof GaleriaView !== 'undefined' ? <GaleriaView photos={photos} addNotification={addNotification} eventoId={eventId} /> : null;
      
      case 'invitacion': return ['basico', 'esencial', 'plata', 'oro', 'diamante'].includes(userPlan) && typeof InvitacionView !== 'undefined' ? <InvitacionView guests={guests} urlInvitacion={activeEventData?.urlInvitacion} /> : null; 
      case 'configuracion': return userRole === 'planner' && typeof ConfiguracionMaestraView !== 'undefined' ? <ConfiguracionMaestraView agencyConfig={agencyConfig} addNotification={addNotification} /> : null;
      default: return <div className="p-8 text-center text-slate-500 font-bold">Módulo bloqueado.</div>;
    }
  };

  return (
    // 🟢 FÍSICA ESTRICTA DE APP: 100dvh, overscroll-none y fondo negro puro
    <div className="fixed inset-0 w-full flex h-[100dvh] bg-[#000000] overscroll-none font-sans overflow-hidden text-slate-200 selection:bg-white selection:text-black relative">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap'); 
        .font-editorial { font-family: 'Playfair Display', serif; }
        @media screen and (max-width: 768px) { input, select, textarea { font-size: 16px !important; } }
        
        /* MAGIA ANTI-REBOTE AZUL EN SAFARI/CHROME MÓVIL */
        body, html { background-color: #000000 !important; overscroll-behavior-y: none; }
        #root { background-color: #000000 !important; }
      `}</style>
      
      {impersonating && (
        <div className="absolute top-0 left-0 w-full bg-rose-600 text-white z-[9999] py-1.5 px-4 text-center text-xs font-black uppercase tracking-widest shadow-lg flex justify-center items-center">
          <AlertTriangle size={14} className="mr-2" /> Modo Soporte: {impersonating.nombres || impersonating.nombre}
          <button onClick={() => { setImpersonating(null); setActiveTab('licencias'); }} className="ml-6 bg-white text-rose-600 px-3 py-0.5 rounded hover:scale-105 transition-transform">Salir</button>
        </div>
      )}

      {typeof Sidebar !== 'undefined' && !isSuperAdminMode && !isSingleAppMode && (
        <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} activeTab={activeTab} setActiveTab={setActiveTab} userRole={userRole} userPlan={userPlan} agencyConfig={agencyConfig} isDarkMode={isDarkMode} hasSocialWall={hasSocialWall} hasBlackLabel={hasBlackLabel} />
      )}
      
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative z-10 bg-[#000000]">
        
        {/* HEADER FLOTANTE Y DINÁMICO */}
        <div className={`fixed xl:static top-0 left-0 right-0 z-50 transition-transform duration-300 ${isHeaderVisible ? 'translate-y-0' : '-translate-y-full xl:translate-y-0'} ${impersonating ? 'pt-7 xl:pt-0' : ''}`}>
          <Header setIsOpen={setSidebarOpen} setActiveTab={setActiveTab} data={{ guests, proveedores, gastos }} globalSearch={globalSearch} setGlobalSearch={setGlobalSearch} bellAlerts={bellAlerts} setBellAlerts={setBellAlerts} markAsRead={markAsRead} cycleTheme={cycleTheme} themeSetting={themeSetting} authData={authData} switchEvent={switchEvent} isSuperAdminMode={isSuperAdminMode} eventName={currentEventName} eventPlan={currentEventPlan} urlInvitacion={activeEventData?.urlInvitacion} />
        </div>
        
        {/* 🟢 MAIN SIN FRANJA NEGRA: Usamos pt-16 en lugar de mt-16 para que al ocultarse el Header el contenido suba hasta el tope */}
        <main onScroll={handleMainScroll} className={`flex-1 overflow-x-hidden overflow-y-auto px-0 pb-24 ${impersonating ? 'pt-24' : 'pt-16'} xl:pt-6 sm:px-5 lg:px-6 print:p-0 print:overflow-visible custom-scrollbar relative z-10 bg-[#000000]`}>
          
          {!isSuperAdminMode && estadoCuenta.deuda > 0 && !estadoCuenta.bloqueado && horasRestantesGracia && (
            <div className="bg-amber-500/15 border-b border-amber-500/30 px-4 py-2.5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs z-20">
              <div className="flex items-center text-amber-300 font-bold text-center sm:text-left">
                <Clock size={15} className="mr-2 text-[#D4AF37] shrink-0" />
                <span>Invitación entregada. Tienes <b className="text-white underline">{horasRestantesGracia}</b> para liquidar <b className="text-[#D4AF37]">${estadoCuenta.deuda} MXN</b>.</span>
              </div>
              <button type="button" onClick={abrirPasarelaLiquidacion} className="px-4 py-1.5 bg-white text-black rounded-lg font-black text-[10px] uppercase tracking-widest shrink-0 hover:bg-slate-200 transition-colors shadow-md">
                Liquidar Saldo (${estadoCuenta.deuda})
              </button>
            </div>
          )}

          {showModalLiquidar && (
            <div className="fixed inset-0 z-[9999] bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in">
              <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl max-w-md w-full p-6 sm:p-8 shadow-[0_25px_80px_rgba(0,0,0,0.95)] max-h-[90vh] overflow-y-auto custom-scrollbar text-white relative">
                <button type="button" onClick={() => { setShowModalLiquidar(false); setClientSecretLiq(null); }} className="absolute top-5 right-5 text-slate-400 hover:text-white transition-colors"><X size={20} /></button>
                <div className="mb-6">
                  <span className="text-[9px] font-black uppercase tracking-[0.25em] text-white block mb-1">Pasarela de Liquidación Automática</span>
                  <h3 className="text-2xl font-editorial font-black text-white">{currentEventName}</h3>
                </div>
                <div className="bg-[#111111] border border-white/5 rounded-2xl p-4 mb-6 flex justify-between items-center">
                  <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Saldo a Liquidar</span>
                  <span className="text-2xl font-editorial font-black text-white">${estadoCuenta.deuda} MXN</span>
                </div>
                {loadingLiq ? (
                  <div className="py-12 text-center text-white font-bold text-xs uppercase tracking-widest animate-pulse flex flex-col items-center gap-3"><RefreshCw size={24} className="animate-spin" />Conectando con Stripe...</div>
                ) : errorLiq ? (
                  <div className="text-center space-y-4 py-4"><p className="text-rose-400 text-xs font-bold">{errorLiq}</p><button type="button" onClick={abrirPasarelaLiquidacion} className="px-5 py-3 bg-white text-black rounded-xl font-black text-[10px] uppercase tracking-widest">Reintentar</button></div>
                ) : clientSecretLiq ? (
                  <Elements stripe={stripePromise} options={{ clientSecret: clientSecretLiq, appearance: { theme: 'night', variables: { colorPrimary: '#ffffff', colorBackground: '#111111', colorText: '#ffffff', colorDanger: '#f87171', fontFamily: '"Montserrat", sans-serif' } } }}>
                    <StripeCaja planSeleccionado={{ plan: currentEventPlan, precio: estadoCuenta.deuda, moneda: 'MXN' }} datosCliente={{ nombre: currentEventName, email: activeEventData?.email || authData?.email || '', telefono: activeEventData?.telefono || '', pais: 'MX' }} onSuccess={confirmarLiquidacionExitosa} onVolver={() => { setShowModalLiquidar(false); setClientSecretLiq(null); }} />
                  </Elements>
                ) : null}
              </div>
            </div>
          )}

          <div className="h-full max-w-7xl mx-auto print:max-w-none print:w-full">
            {!isSuperAdminMode && estadoCuenta.bloqueado && estadoCuenta.deuda > 0 ? (
              <div className="h-full min-h-[75vh] flex items-center justify-center p-4 animate-in fade-in">
                <div className="bg-[#0A0A0A] border border-white/10 rounded-3xl max-w-lg w-full p-8 sm:p-10 text-center shadow-2xl relative overflow-hidden">
                  <div className="w-20 h-20 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mx-auto mb-6 text-white"><Lock size={36} /></div>
                  <span className="text-[9px] font-black uppercase tracking-[0.3em] text-rose-400 block mb-2">Reserva Vencida</span>
                  <h2 className="text-2xl sm:text-3xl font-editorial font-black text-white mb-4">Bóveda en Pausa</h2>
                  <p className="text-xs sm:text-sm text-slate-400 leading-relaxed mb-6">Liquida el saldo pendiente de tu paquete para reactivar tu bóveda e invitación.</p>
                  <button type="button" onClick={abrirPasarelaLiquidacion} className="w-full py-4 bg-white text-black rounded-xl font-black text-xs uppercase tracking-widest hover:bg-slate-200 transition-all flex items-center justify-center">Liquidar ${estadoCuenta.deuda} en Línea</button>
                </div>
              </div>
            ) : (
              renderContent()
            )}
          </div>
        </main>

        {/* 📱 BOTTOM BAR MÓVIL (COMPACTA CON CASITA HOME Y BUSCADOR INDEPENDIENTE) */}
        {!isSuperAdminMode && !isSingleAppMode && (
          <nav className="xl:hidden fixed bottom-0 left-0 w-full bg-[#000000]/95 backdrop-blur-2xl border-t border-white/10 z-[100] flex justify-around items-center h-[52px] shadow-[0_-10px_40px_rgba(0,0,0,0.95)] px-2 print:hidden">
            {/* 1. CASITA (RESUMEN / DASHBOARD) */}
            <button onClick={() => { setActiveTab('dashboard'); setShowMobileHub(false); setShowMobileSearch(false); }} className={`flex flex-col items-center justify-center w-full h-full relative transition-colors ${activeTab === 'dashboard' && !showMobileHub && !showMobileSearch ? 'text-white' : 'text-white/45 hover:text-white/80'}`}>
              <svg width="23" height="23" viewBox="0 0 24 24" fill={activeTab === 'dashboard' && !showMobileHub && !showMobileSearch ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={activeTab === 'dashboard' && !showMobileHub && !showMobileSearch ? '2.2' : '1.8'} strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1V9.5z" />
              </svg>
            </button>

            {/* 2. INVITADOS */}
            <button onClick={() => { setActiveTab('invitados'); setShowMobileHub(false); setShowMobileSearch(false); }} className={`flex flex-col items-center justify-center w-full h-full relative transition-colors ${activeTab === 'invitados' && !showMobileHub && !showMobileSearch ? 'text-white' : 'text-white/45 hover:text-white/80'}`}>
              <Users size={23} strokeWidth={activeTab === 'invitados' && !showMobileHub && !showMobileSearch ? 2.4 : 1.7} />
            </button>

            {/* 3. LUPA (SOLO BUSCADOR) */}
            <button onClick={() => { setShowMobileSearch(!showMobileSearch); setShowMobileHub(false); }} className={`flex flex-col items-center justify-center w-full h-full relative transition-colors ${showMobileSearch ? 'text-white' : 'text-white/45 hover:text-white/80'}`}>
              <SearchIcon size={23} strokeWidth={showMobileSearch ? 2.5 : 1.7} />
            </button>

            {/* 4. MESAS */}
            <button onClick={() => { if(['oro', 'diamante'].includes(userPlan)) { setActiveTab('mesas'); setShowMobileHub(false); setShowMobileSearch(false); } else { addNotification('Función Premium', 'La gestión de mesas está disponible en planes Oro y Diamante.', 'warning'); } }} className={`flex flex-col items-center justify-center w-full h-full relative transition-colors ${activeTab === 'mesas' && !showMobileHub && !showMobileSearch ? 'text-white' : 'text-white/45 hover:text-white/80'}`}>
              <LayoutGrid size={22} strokeWidth={activeTab === 'mesas' && !showMobileHub && !showMobileSearch ? 2.4 : 1.7} />
            </button>

            {/* 5. MONOGRAMA (SOLO MENÚ HUB) */}
            <button onClick={() => { setShowMobileHub(!showMobileHub); setShowMobileSearch(false); }} className={`flex flex-col items-center justify-center w-full h-full transition-colors ${showMobileHub ? 'text-white' : 'text-white/60 hover:text-white'}`}>
              <div className={`w-7 h-7 rounded-full border flex items-center justify-center transition-all ${showMobileHub ? 'border-white bg-white text-black' : 'border-white/50 text-white'}`}>
                <span className="text-[9px] font-editorial font-black uppercase tracking-wider">{getInitialsMobile(currentEventName)}</span>
              </div>
            </button>
          </nav>
        )}

        {/* 🔍 MODAL EXCLUSIVO DE LUPA (SOLO BUSCADOR) */}
        {showMobileSearch && (
          <div className="xl:hidden fixed inset-0 z-[90] flex flex-col justify-end">
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setShowMobileSearch(false)}></div>
            <div className="bg-[#0A0A0A] w-full rounded-t-[2rem] border-t border-white/10 relative z-10 p-6 pb-20 max-h-[80vh] overflow-y-auto custom-scrollbar animate-in slide-in-from-bottom-full duration-300 shadow-[0_-20px_50px_rgba(0,0,0,0.95)]">
              <div className="w-12 h-1 bg-white/20 rounded-full mx-auto mb-5"></div>
              <div className="flex items-center justify-between mb-4 px-1">
                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Buscador Global</span>
                <button onClick={() => setShowMobileSearch(false)} className="text-slate-500 hover:text-white"><X size={16}/></button>
              </div>
              
              <div className="relative w-full mb-4">
                <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
                <input autoFocus type="text" placeholder="Escribe nombre de invitado, proveedor o gasto..." value={globalSearch} onChange={(e) => setGlobalSearch(e.target.value)} className="w-full pl-11 pr-9 py-3.5 bg-[#111111] border border-white/15 rounded-2xl text-sm text-white placeholder-slate-500 focus:outline-none focus:border-white transition-all"/>
                {globalSearch && (
                  <button onClick={() => setGlobalSearch('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"><X size={16}/></button>
                )}
              </div>

              {globalSearch.trim().length > 0 ? (
                <div className="bg-[#111111] border border-white/10 rounded-2xl overflow-hidden divide-y divide-white/5 max-h-64 overflow-y-auto">
                  {guests.filter(g => (g.name || '').toLowerCase().includes(globalSearch.toLowerCase())).slice(0, 6).map(g => (
                    <button key={`sr_g_${g.id}`} onClick={() => { setActiveTab('invitados'); setShowMobileSearch(false); }} className="w-full px-4 py-3.5 text-left flex items-center justify-between hover:bg-white/5">
                      <span className="text-xs font-bold text-white truncate">{g.name}</span>
                      <span className="text-[9px] uppercase tracking-widest text-slate-400">Invitado</span>
                    </button>
                  ))}
                  {proveedores.filter(p => (p.nombre || '').toLowerCase().includes(globalSearch.toLowerCase())).slice(0, 4).map(p => (
                    <button key={`sr_p_${p.id}`} onClick={() => { setActiveTab('proveedores'); setShowMobileSearch(false); }} className="w-full px-4 py-3.5 text-left flex items-center justify-between hover:bg-white/5">
                      <span className="text-xs font-bold text-white truncate">{p.nombre}</span>
                      <span className="text-[9px] uppercase tracking-widest text-amber-400">Proveedor</span>
                    </button>
                  ))}
                  {gastos.filter(g => (g.concepto || '').toLowerCase().includes(globalSearch.toLowerCase())).slice(0, 4).map(g => (
                    <button key={`sr_e_${g.id}`} onClick={() => { setActiveTab('presupuesto'); setShowMobileSearch(false); }} className="w-full px-4 py-3.5 text-left flex items-center justify-between hover:bg-white/5">
                      <span className="text-xs font-bold text-white truncate">{g.concepto}</span>
                      <span className="text-[9px] uppercase tracking-widest text-emerald-400">Finanzas</span>
                    </button>
                  ))}
                  {guests.filter(g => (g.name || '').toLowerCase().includes(globalSearch.toLowerCase())).length === 0 &&
                   proveedores.filter(p => (p.nombre || '').toLowerCase().includes(globalSearch.toLowerCase())).length === 0 &&
                   gastos.filter(g => (g.concepto || '').toLowerCase().includes(globalSearch.toLowerCase())).length === 0 && (
                    <div className="p-6 text-center text-xs text-slate-500">Sin coincidencias para "{globalSearch}"</div>
                  )}
                </div>
              ) : (
                <p className="text-center text-[11px] text-slate-500 py-6">Encuentra al instante cualquier invitado, proveedor o gasto de tu evento.</p>
              )}
            </div>
          </div>
        )}

        {/* 📱 HUB MÓVIL DESPLEGABLE (EXCLUSIVO DEL MONOGRAMA: SOLO MENÚ Y CUENTA) */}
        {showMobileHub && (
          <div className="xl:hidden fixed inset-0 z-[90] flex flex-col justify-end">
            <div className="absolute inset-0 bg-black/75 backdrop-blur-sm" onClick={() => setShowMobileHub(false)}></div>
            <div className="bg-[#0A0A0A] w-full rounded-t-[2rem] border-t border-white/10 relative z-10 p-6 pb-20 max-h-[85vh] overflow-y-auto custom-scrollbar animate-in slide-in-from-bottom-full duration-300 shadow-[0_-20px_50px_rgba(0,0,0,0.95)]">
              <div className="w-12 h-1 bg-white/20 rounded-full mx-auto mb-6"></div>

              <div className="space-y-7">
                <div>
                  <p className="text-[9px] text-slate-500 uppercase tracking-widest font-bold mb-3.5 px-1">Planeación & Logística</p>
                  <div className="grid grid-cols-4 gap-3">
                    <button onClick={() => {setActiveTab('tareas'); setShowMobileHub(false);}} className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 rounded-2xl bg-[#111111] border border-white/10 flex items-center justify-center text-white"><CheckSquare size={22} strokeWidth={1.6}/></div>
                      <span className="text-[9px] font-bold text-slate-300">Checklist</span>
                    </button>
                    <button onClick={() => {setActiveTab('presupuesto'); setShowMobileHub(false);}} className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 rounded-2xl bg-[#111111] border border-white/10 flex items-center justify-center text-white"><Wallet size={22} strokeWidth={1.6}/></div>
                      <span className="text-[9px] font-bold text-slate-300">Finanzas</span>
                    </button>
                    <button onClick={() => {setActiveTab('proveedores'); setShowMobileHub(false);}} className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 rounded-2xl bg-[#111111] border border-white/10 flex items-center justify-center text-white"><Store size={22} strokeWidth={1.6}/></div>
                      <span className="text-[9px] font-bold text-slate-300">Directorio</span>
                    </button>
                    <button onClick={() => { if(userPlan === 'diamante') { setActiveTab('mapa'); setShowMobileHub(false); } else { addNotification('Función Premium', 'El Croquis del Salón está disponible en el Plan Diamante.', 'warning'); } }} className="flex flex-col items-center gap-2 relative">
                      <div className={`w-14 h-14 rounded-2xl border flex items-center justify-center ${userPlan === 'diamante' ? 'bg-[#111111] border-white/10 text-white' : 'bg-transparent border-dashed border-white/15 text-slate-600'}`}><MapIcon size={22} strokeWidth={1.6}/></div>
                      <span className="text-[9px] font-bold text-slate-300">Croquis</span>
                      {userPlan !== 'diamante' && <div className="absolute top-[-4px] right-1 w-5 h-5 bg-[#000000] rounded-full flex items-center justify-center border border-white/10"><Lock size={10} className="text-white"/></div>}
                    </button>
                  </div>
                </div>

                <div>
                  <p className="text-[9px] text-slate-500 uppercase tracking-widest font-bold mb-3.5 px-1">Operación & Add-Ons</p>
                  <div className="grid grid-cols-4 gap-3">
                    <button onClick={() => {setActiveTab('timing'); setShowMobileHub(false);}} className="flex flex-col items-center gap-2">
                      <div className="w-14 h-14 rounded-2xl bg-[#111111] border border-white/10 flex items-center justify-center text-white"><Clock size={22} strokeWidth={1.6}/></div>
                      <span className="text-[9px] font-bold text-slate-300">Timing</span>
                    </button>
                    
                    <button onClick={() => { if(hasSocialWall || ['diamante', 'social_wall'].includes(userPlan)) { setActiveTab('galeria'); setShowMobileHub(false); } else { addNotification('Función Premium', 'Adquiere el Muro Social para activar esta función.', 'warning'); } }} className="flex flex-col items-center gap-2 relative">
                      <div className={`w-14 h-14 rounded-2xl border flex items-center justify-center transition-colors ${hasSocialWall || ['diamante', 'social_wall'].includes(userPlan) ? 'bg-[#111111] border-white/10 text-pink-400' : 'bg-transparent border-dashed border-white/15 text-slate-600'}`}>
                        <Camera size={22} strokeWidth={1.6}/>
                      </div>
                      <span className="text-[9px] font-bold text-slate-300">Social Wall</span>
                      {!(hasSocialWall || ['diamante', 'social_wall'].includes(userPlan)) && <div className="absolute top-[-4px] right-1 w-5 h-5 bg-[#000000] rounded-full flex items-center justify-center border border-white/10"><Lock size={10} className="text-white"/></div>}
                    </button>

                    <button onClick={() => { if(hasBlackLabel || ['oro', 'diamante', 'security_kit'].includes(userPlan)) { setActiveTab('escaner'); setShowMobileHub(false); } else { addNotification('Función Premium', 'Mejora tu plan para activar el Control de Puerta.', 'warning'); } }} className="flex flex-col items-center gap-2 relative">
                      <div className={`w-14 h-14 rounded-2xl border flex items-center justify-center transition-colors ${hasBlackLabel || ['oro', 'diamante', 'security_kit'].includes(userPlan) ? 'bg-[#111111] border-white/10 text-sky-400' : 'bg-transparent border-dashed border-white/15 text-slate-600'}`}>
                        <Scan size={22} strokeWidth={1.6}/>
                      </div>
                      <span className="text-[9px] font-bold text-slate-300">Escáner</span>
                      {!(hasBlackLabel || ['oro', 'diamante', 'security_kit'].includes(userPlan)) && <div className="absolute top-[-4px] right-1 w-5 h-5 bg-[#000000] rounded-full flex items-center justify-center border border-white/10"><Lock size={10} className="text-white"/></div>}
                    </button>
                    
                    <button onClick={() => { if(hasBlackLabel || ['diamante', 'security_kit'].includes(userPlan)) { setActiveTab('pulseras'); setShowMobileHub(false); } else { addNotification('Función Premium', 'Adquiere Black Label para diseñar pulseras VIP.', 'warning'); } }} className="flex flex-col items-center gap-2 relative">
                      <div className={`w-14 h-14 rounded-2xl border flex items-center justify-center transition-colors ${hasBlackLabel || ['diamante', 'security_kit'].includes(userPlan) ? 'bg-[#111111] border-white/10 text-[#D4AF37]' : 'bg-transparent border-dashed border-white/15 text-slate-600'}`}>
                        <Ticket size={22} strokeWidth={1.6}/>
                      </div>
                      <span className="text-[9px] font-bold text-slate-300">Black Label</span>
                      {!(hasBlackLabel || ['diamante', 'security_kit'].includes(userPlan)) && <div className="absolute top-[-4px] right-1 w-5 h-5 bg-[#000000] rounded-full flex items-center justify-center border border-white/10"><Lock size={10} className="text-white"/></div>}
                    </button>
                  </div>
                </div>

                <div>
                  <p className="text-[9px] text-slate-500 uppercase tracking-widest font-bold mb-3.5 px-1">Mi Cuenta</p>
                  <div className="bg-[#111111] border border-white/10 rounded-2xl overflow-hidden">
                    <button onClick={() => { setActiveTab('invitacion'); setShowMobileHub(false); }} className="w-full flex items-center p-4 border-b border-white/5 hover:bg-white/5 transition-colors">
                      <ExternalLink size={16} className="mr-3 text-slate-400"/> <span className="text-white text-xs font-bold">Ver Invitación Web</span>
                    </button>
                    <button onClick={() => window.open('https://wa.me/525512345678?text=Hola,%20necesito%20ayuda%20con%20mi%20panel%20Baulia', '_blank')} className="w-full flex items-center p-4 border-b border-white/5 hover:bg-white/5 transition-colors">
                      <MessageCircle size={16} className="mr-3 text-slate-400"/> <span className="text-white text-xs font-bold">Soporte Premium</span>
                    </button>
                    <button onClick={() => signOut(auth)} className="w-full flex items-center p-4 hover:bg-rose-500/10 transition-colors">
                      <LogOut size={16} className="mr-3 text-rose-500"/> <span className="text-rose-500 text-xs font-bold">Cerrar Sesión</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

// ==========================================
// --- COMPONENTE: VISTA INDEPENDIENTE PARA EL CADENERO (STAFF) ---
// ==========================================
const HostessStandaloneView = ({ eventId }) => {
  const [guests, setGuests] = useState([]);
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);

  // Sistema de notificaciones silencioso para no causar errores de consola
  const addNotification = (title, msg, type) => console.log(title, msg);

  useEffect(() => {
    setGlobalEventId(eventId);
    
    // El cadenero necesita conectarse a la base de datos de invitados y mesas de este evento
    const unsubGuests = onSnapshot(collection(db, "eventos", eventId, "invitados"), (snap) => {
      setGuests(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    
    const unsubMesas = onSnapshot(collection(db, "eventos", eventId, "mesas"), (snap) => {
      setTables(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    });

    return () => { unsubGuests(); unsubMesas(); };
  }, [eventId]);

  if (loading) {
    return (
      <div className="h-screen w-screen bg-[#050505] flex flex-col items-center justify-center text-[#D4AF37] font-black uppercase tracking-widest text-xs transition-colors">
        <RefreshCw size={40} className="animate-spin mb-4 opacity-80" /> Conectando a la Puerta...
      </div>
    );
  }

  return (
    <div className="h-screen w-screen bg-[#050505] p-2 sm:p-4 overflow-y-auto transition-colors duration-500">
       <EscanerView guests={guests} setGuests={setGuests} tables={tables} isSharedMode={true} addNotification={addNotification} />
    </div>
  );
};

// ==========================================
// --- COMPONENTE: COSECHADOR DE RESEÑAS VIP (CERO RIESGO) ---
// ==========================================
const ReviewHarvester = ({ authData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [status, setStatus] = useState('idle');

  // Solo se muestra a clientes o planners, NO al superadmin
  if (!authData || authData.role === 'superadmin') return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      // Guarda la reseña en una nueva bóveda llamada "resenas"
      await setDoc(doc(db, "resenas", authData.eventId), {
        eventId: authData.eventId,
        rating,
        comment,
        status: 'pendiente', // 🔴 Nace oculta. Solo tú podrás hacerla pública.
        createdAt: serverTimestamp(),
        authorName: 'Cliente Baulia', // Podrás editar su nombre real
        authorType: authData.role === 'planner' ? 'Agencia / Planner' : 'Anfitrión del Evento'
      });
      setStatus('success');
      setTimeout(() => setIsOpen(false), 4000);
    } catch (error) {
      console.error(error);
      setStatus('idle');
    }
  };

  return (
    <>
      {/* BOTÓN FLOTANTE EN LA ESQUINA */}
      <button onClick={() => setIsOpen(true)} className="fixed bottom-6 right-6 bg-slate-900 dark:bg-white text-amber-500 dark:text-slate-900 px-5 py-3.5 rounded-full shadow-2xl flex items-center gap-2 border border-slate-700 dark:border-slate-200 hover:scale-105 transition-transform z-50 group">
        <Star size={16} className="fill-amber-500 dark:fill-amber-500 group-hover:animate-spin"/>
        <span className="font-bold text-[10px] uppercase tracking-widest text-white dark:text-slate-900">Calificar Experiencia</span>
      </button>

      {/* MODAL DE BÓVEDA PARA CALIFICAR */}
      {isOpen && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/80 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-300">
          <div className="bg-[#0a0a0a] border border-white/10 rounded-[2.5rem] p-8 md:p-10 w-full max-w-md shadow-2xl relative transform animate-in zoom-in-95">
            <button onClick={() => setIsOpen(false)} className="absolute top-6 right-6 text-slate-500 hover:text-white transition-colors"><X size={20}/></button>
            
            {status === 'success' ? (
               <div className="text-center py-8">
                 <div className="w-16 h-16 bg-emerald-500/20 text-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(16,185,129,0.3)]"><CheckCircle size={32}/></div>
                 <h3 className="text-2xl font-editorial font-bold text-white mb-2">¡Gracias por tu opinión!</h3>
                 <p className="text-slate-400 font-light text-sm">Tus comentarios nos ayudan a mantener el estándar de oro en cada evento.</p>
               </div>
            ) : (
               <form onSubmit={handleSubmit}>
                 <div className="text-center mb-8">
                   <h3 className="text-2xl font-editorial font-bold text-white mb-2">Califica tu Bóveda</h3>
                   <p className="text-slate-400 font-light text-sm">¿Cómo fue tu experiencia gestionando tu evento con la tecnología de Baulia?</p>
                 </div>

                 <div className="flex justify-center gap-2 mb-8">
                   {[1,2,3,4,5].map(star => (
                     <button key={star} type="button" onClick={() => setRating(star)} className="focus:outline-none transform hover:scale-110 transition-transform">
                       <Star size={36} className={`${rating >= star ? 'fill-amber-500 text-amber-500' : 'text-slate-700'}`} />
                     </button>
                   ))}
                 </div>

                 <textarea 
                    required
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Escribe tu reseña aquí... (Ej. Nos ahorró horas de estrés y a los invitados les encantó)." 
                    className="w-full bg-white/5 border border-white/10 rounded-2xl p-5 text-white text-sm font-light focus:border-amber-500 outline-none min-h-[140px] mb-8 custom-scrollbar resize-none transition-colors"
                 ></textarea>

                 <button type="submit" disabled={status === 'loading'} className="w-full py-4 bg-amber-500 text-slate-900 rounded-full font-bold uppercase tracking-widest text-[10px] hover:bg-amber-400 transition-all shadow-lg disabled:opacity-50">
                   {status === 'loading' ? 'Enviando a Bóveda Segura...' : 'Enviar Reseña Privada'}
                 </button>
               </form>
            )}
          </div>
        </div>
      )}
    </>
  );
};

// ==========================================
// --- COMPONENTE: SHOWROOM SIMULADOR (VITRINA PERFECTA CON UPSELL Y SMART FOCUS) ---
// ==========================================
const ShowcaseSimulatorView = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isCheckout = urlParams.get('checkout') === '1';

  const [activeCategory, setActiveCategory] = useState('boda');
  const [checkoutStep, setCheckoutStep] = useState(isCheckout ? 1 : 0); 
  const [planSeleccionado, setPlanSeleccionado] = useState(null);

  // 🔴 ESTADOS Y REFS PARA EL "ENFOQUE INTELIGENTE" (SMART FOCUS)
  const macIframeRef = useRef(null);
  const iphoneIframeRef = useRef(null);
  const [activeDevice, setActiveDevice] = useState('iphone'); // Por defecto el iPhone tiene el control

  // Si cambia de demo (ej. de Boda a XV), regresamos el foco al iPhone
  useEffect(() => {
    setActiveDevice('iphone');
  }, [activeCategory]);

  // La magia: Envía la orden por radio al dispositivo que pierde el foco
  const switchFocus = (device) => {
    setActiveDevice(device);
    const inactiveRef = device === 'mac' ? iphoneIframeRef : macIframeRef;
    
    if (inactiveRef.current && inactiveRef.current.contentWindow) {
      // Usamos el "Walkie-Talkie" oficial para decirle al iframe inactivo que se silencie
      inactiveRef.current.contentWindow.postMessage('pause_baulia_audio', '*');
    }
  };

  useEffect(() => {
    const escucharMensajeDelIframe = (event) => {
      if (event.data === 'open_checkout') {
        setCheckoutStep(1); 
      }
    };
    window.addEventListener('message', escucharMensajeDelIframe);
    return () => window.removeEventListener('message', escucharMensajeDelIframe);
  }, []);

  const planes = [
    { id: 'basico', nombre: 'Básico', precio: '990', desc: 'Invitación, RSVP simple y GPS.', icon: <Smartphone size={24}/> },
    { id: 'plata', nombre: 'Plata', precio: '1,490', desc: 'Suma Mesa de Regalos e Itinerario.', icon: <Wallet size={24}/> },
    { id: 'oro', nombre: 'Oro', precio: '1,990', desc: 'Panel Maestro, Control QR y Mesas.', icon: <ShieldCheck size={24}/>, popular: true },
    { id: 'diamante', nombre: 'Diamante', precio: '2,990', desc: 'Bocetador 3D y Muro Social.', icon: <LayoutDashboard size={24}/> }
  ];

  const demos = {
    boda: { 
      id: 'boda', label: 'Bodas de Lujo', 
      url: '/demos/boda/index.html', 
      desc: 'Elegancia clásica, tipografías finas y paletas sobrias. El estándar de alta costura nupcial.',
      features: ['Mesa de Regalos', 'Cuenta Regresiva', 'Pases QR VIP', 'GPS Directo']
    },
    xv: { 
      id: 'xv', label: 'XV Años Glamour', 
      url: '/demos/xv/index.html', 
      desc: 'Luces neón, animaciones dinámicas y energía vibrante para la mejor noche.',
      features: ['Muro de Fotos', 'Dress Code Neón', 'Itinerario de Gala', 'Música Automática']
    },
    cumple_formal: { 
      id: 'cumple_formal', label: 'Cumpleaños Formal', 
      url: '/demos/cumple_formal/index.html', 
      desc: 'Diseños sofisticados para celebrar décadas (30s, 40s, 50s) con mucho estilo y elegancia.',
      features: ['Lluvia de Sobres', 'Confirmación Fácil', 'Galería de Recuerdos']
    },
    infantil: { 
      id: 'infantil', label: 'Fiestas Infantiles', 
      url: '/demos/infantil/index.html', 
      desc: 'Temáticas inmersivas al 100%. Llevamos a los niños al universo de sus personajes favoritos.',
      features: ['Diseños 100% Temáticos', 'Animaciones', 'Ubicación Salón']
    },
    bautizo: { 
      id: 'bautizo', label: 'Bautizos / Comunión', 
      url: '/demos/bautizo/index.html', 
      desc: 'Tonos pastel, acuarelas suaves y diseños angelicales para momentos familiares íntimos.',
      features: ['Padrinos', 'Locación Iglesia', 'Mesa de Regalos']
    },
    corporativo: { 
      id: 'corporativo', label: 'Empresarial / Galas', 
      url: '/demos/corporativo/index.html', 
      desc: 'Seriedad, branding corporativo y logística estricta para congresos y lanzamientos de marca.',
      features: ['Control de Gafetes', 'Programa por Horas', 'Patrocinadores']
    }
  };

  const currentDemo = demos[activeCategory];

  const handlePaymentSuccess = (datos, plan) => {
    setCheckoutStep(3);
  };

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col font-sans text-white overflow-x-hidden overflow-y-auto custom-scrollbar selection:bg-amber-500">
      
      {checkoutStep > 0 && (
        <div className="fixed inset-0 z-[999] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in transition-colors">
          <div className="bg-[#0a0a0a] rounded-[2rem] w-full max-w-2xl overflow-hidden shadow-[0_0_50px_rgba(245,158,11,0.1)] border border-white/10 relative flex flex-col max-h-[90vh]">
            
            {checkoutStep === 1 && (
              <div className="p-8 animate-in slide-in-from-right-8 duration-300">
                <div className="flex justify-between items-center mb-6">
                  <div>
                    <h3 className="font-editorial text-3xl font-bold text-white mb-1">Selecciona tu Plan</h3>
                    <p className="text-slate-400 text-xs">Añade tecnología de control a tu diseño perfecto.</p>
                  </div>
                  <button onClick={() => setCheckoutStep(0)} className="p-2 text-slate-500 hover:text-white transition-colors bg-white/5 rounded-full"><X size={20}/></button>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 overflow-y-auto max-h-[60vh] custom-scrollbar pr-2 pb-4">
                  {planes.map(plan => (
                    <button 
                      key={plan.id}
                      onClick={() => { setPlanSeleccionado(plan); setCheckoutStep(2); }}
                      className={`text-left p-5 rounded-2xl border transition-all duration-300 group relative overflow-hidden ${plan.popular ? 'border-amber-500/50 bg-amber-500/5 hover:bg-amber-500/10' : 'border-white/10 bg-[#111] hover:border-white/30 hover:bg-white/5'}`}
                    >
                      {plan.popular && <div className="absolute top-0 right-0 bg-amber-500 text-slate-900 text-[8px] font-black uppercase tracking-widest px-3 py-1 rounded-bl-lg">Ideal</div>}
                      <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-3 shadow-inner ${plan.popular ? 'bg-amber-500/20 text-amber-500' : 'bg-white/5 text-slate-400 group-hover:text-white'}`}>
                        {plan.icon}
                      </div>
                      <h4 className="font-bold text-lg text-white mb-1">{plan.nombre}</h4>
                      <p className="text-[10px] text-slate-400 mb-4 h-6 leading-relaxed">{plan.desc}</p>
                      <p className="font-black text-xl text-white">${plan.precio} <span className="text-[9px] text-slate-500 font-bold uppercase tracking-widest">MXN</span></p>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* PANTALLA 2: CHECKOUT */}
            {checkoutStep === 2 && planSeleccionado && (
              <div className="h-full flex flex-col bg-white dark:bg-[#0a0a0a] animate-in fade-in transition-colors">
                <div className="p-5 border-b border-slate-100 dark:border-white/5 flex items-center justify-between bg-slate-50 dark:bg-white/5 shrink-0 transition-colors">
                  <button onClick={() => setCheckoutStep(1)} className="p-2 text-slate-400 hover:text-slate-800 dark:hover:text-white transition-colors bg-white dark:bg-black/20 rounded-full shadow-sm">
                    <ArrowRight size={18} style={{ transform: 'rotate(180deg)' }}/>
                  </button>
                  <div className="text-center">
                    <p className="text-[10px] font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-0.5">Paso 2 de 2</p>
                    <h3 className="text-sm font-bold text-slate-800 dark:text-white">Pago Seguro</h3>
                  </div>
                  <div className="w-9"></div>
                </div>
                
                <div className="p-6 overflow-y-auto flex-1 custom-scrollbar">
                  <CheckoutForm 
                    planSeleccionado={planSeleccionado} 
                    onSuccess={handlePaymentSuccess} 
                    onCancel={() => setCheckoutModal('selector')} 
                  />
              </div>
              </div>
            )}

            {checkoutStep === 3 && (
              <div className="p-10 text-center animate-in zoom-in-95 duration-500">
                <div className="w-24 h-24 bg-emerald-500/20 border border-emerald-500/30 text-emerald-400 rounded-full flex items-center justify-center mx-auto mb-6 shadow-[0_0_30px_rgba(16,185,129,0.2)]">
                  <CheckCircle size={48} className="animate-pulse"/>
                </div>
                <h3 className="font-editorial font-black text-4xl text-white mb-3">¡Bienvenido a Baulia!</h3>
                <p className="text-slate-400 text-sm mb-10 leading-relaxed max-w-sm mx-auto">Tu bóveda privada se ha creado con éxito. Hemos enviado a tu correo las credenciales de acceso seguro.</p>
                <button onClick={() => window.location.href = 'https://panel.baulia.com'} className="w-full py-4 bg-amber-500 text-slate-900 font-black rounded-xl shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:bg-amber-400 transition-all uppercase tracking-widest text-[10px]">
                  Entrar a mi Panel de Control
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <header className="h-20 border-b border-white/5 flex items-center justify-between px-6 sm:px-10 shrink-0 bg-transparent z-20 relative">
        <div className="flex items-center gap-4">
          <button onClick={() => window.location.href = '/'} className="p-2 hover:bg-white/10 rounded-full transition-colors"><ArrowRight size={20} className="rotate-180"/></button>
          <h1 className="text-sm sm:text-xl font-bold tracking-widest uppercase">Galería <span className="text-amber-500 font-light">Baulia</span></h1>
        </div>
        <button onClick={() => setCheckoutStep(1)} className="hidden sm:block px-6 py-2.5 bg-amber-500 text-slate-900 font-bold rounded-full text-xs uppercase tracking-widest hover:bg-amber-400 transition-colors shadow-[0_0_20px_rgba(245,158,11,0.3)]">
          Crear la Mía
        </button>
      </header>

      <div className="flex flex-col lg:flex-row relative z-10 min-h-[calc(100vh-80px)]">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-indigo-900/20 via-[#050505] to-[#050505] z-0 pointer-events-none"></div>

        <div className="w-full lg:w-5/12 xl:w-1/3 p-6 sm:p-10 flex flex-col justify-center z-10 shrink-0">
          <h2 className="text-3xl sm:text-5xl font-editorial font-medium mb-4 text-white leading-tight">
            {currentDemo.label}
          </h2>
          <p className="text-slate-400 text-sm sm:text-base leading-relaxed mb-8">
            {currentDemo.desc}
          </p>

          <div className="space-y-4 mb-10">
            {currentDemo.features.map((feat, idx) => (
               <div key={idx} className="flex items-center bg-white/5 border border-white/10 px-4 py-3 rounded-xl">
                 <CheckCircle size={16} className="text-amber-500 mr-3 shrink-0"/>
                 <span className="font-bold text-sm tracking-wide">{feat}</span>
               </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-2">
            {Object.values(demos).map(demo => (
              <button 
                key={demo.id} 
                onClick={() => setActiveCategory(demo.id)}
                className={`px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest transition-all border ${activeCategory === demo.id ? 'bg-amber-500 text-slate-900 border-amber-500 shadow-[0_0_15px_rgba(245,158,11,0.3)]' : 'bg-transparent text-slate-400 border-white/20 hover:border-white/50'}`}
              >
                {demo.label.split(' ')[0]}
              </button>
            ))}
          </div>
        </div>

        <div className="flex-1 flex items-center justify-center p-6 lg:p-10 z-10 relative">
           
           <div className="relative w-full max-w-[850px] translate-x-[5%] xl:translate-x-[15%]">
               
               {/* --- MACBOOK DE FONDO CON CRISTAL INTELIGENTE --- */}
               <div className={`relative w-full bg-black rounded-t-3xl border-[8px] border-slate-800 shadow-[0_30px_60px_rgba(0,0,0,0.5)] flex flex-col transition-all duration-700 ${activeDevice === 'mac' ? 'scale-[1.02] z-30' : 'scale-100 z-10 opacity-70  hidden md:block  hidden md:block blur-[1px]'}`}>
                   <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-6 bg-black rounded-b-2xl z-30"></div>
                   <div className="w-full aspect-[16/10] bg-[#111] relative overflow-hidden rounded-t-xl border border-white/5 transition-colors">
                       <iframe 
                         ref={macIframeRef}
                         src={currentDemo.url} 
                         className="absolute top-0 left-0 border-0 origin-top-left" 
                         style={{ width: '250%', height: '250%', transform: 'scale(0.4)' }} 
                         title={`Mac Demo ${currentDemo.label}`}
                       ></iframe>
                       
                       {/* CRISTAL INTELIGENTE MAC */}
                       {activeDevice !== 'mac' && (
                         <div onClick={() => switchFocus('mac')} className="absolute inset-0 z-20 bg-black/10 backdrop- hidden md:block  hidden md:block blur-[2px] cursor-pointer flex items-center justify-center group transition-all duration-500">
                            <div className="bg-slate-900/90 text-white text-xs font-bold px-6 py-3 rounded-full opacity-0 group-hover:opacity-100 transition-opacity border border-white/20 shadow-2xl flex items-center transform scale-95 group-hover:scale-100">
                               <PlayCircle size={18} className="mr-2 text-amber-500"/> Haz clic para explorar en Mac
                            </div>
                         </div>
                       )}
                   </div>
                   <div className="relative w-[105%] -left-[2.5%] h-4 bg-slate-400 dark:bg-slate-700 rounded-b-3xl shadow-xl z-30 transition-colors">
                      <div className="w-40 h-1.5 bg-slate-300 dark:bg-slate-600 mx-auto rounded-b-md"></div>
                   </div>
               </div>

               {/* --- IPHONE AL FRENTE CON CRISTAL INTELIGENTE --- */}
               <div className={`absolute bottom-[-0%] left-[-5%] xl:left-[-15%] transition-all duration-700 ease-out origin-bottom ${activeDevice === 'iphone' ? 'z-40 scale-[1.05]' : 'z-20 scale-95 opacity-80  hidden md:block  hidden md:block blur-[1px]'}`}>
                   <div style={{ width: '220px', height: '458px' }} className="relative bg-black rounded-[2.5rem] border-[8px] border-slate-800 shadow-[0_30px_80px_rgba(0,0,0,0.8)] overflow-hidden flex-shrink-0 mx-auto">
                       
                       {/* Isla Dinámica */}
                       <div className="absolute top-1.5 left-1/2 -translate-x-1/2 w-[30%] h-[16px] bg-black rounded-full z-30 flex justify-end items-center pr-1.5">
                         <div className="w-1.5 h-1.5 rounded-full bg-slate-800/80 mr-1"></div>
                         <div className="w-1.5 h-1.5 rounded-full bg-indigo-900/50"></div>
                       </div>
                       
                       <div className="absolute inset-0 overflow-hidden rounded-[1.8rem] z-10 bg-[#111]">
                         <iframe 
                           ref={iphoneIframeRef}
                           src={currentDemo.url} 
                           className="border-0 absolute top-0 left-0" 
                           title={`iPhone Demo ${currentDemo.label}`}
                           style={{ 
                               width: '390px', 
                               height: '844px', 
                               transform: 'scale(0.523)', 
                               transformOrigin: 'top left' 
                           }}
                         ></iframe>

                         {/* CRISTAL INTELIGENTE IPHONE */}
                         {activeDevice !== 'iphone' && (
                           <div onClick={() => switchFocus('iphone')} className="absolute inset-0 z-20 bg-black/10 backdrop- hidden md:block  hidden md:block blur-[2px] cursor-pointer flex items-center justify-center group transition-all duration-500">
                              <div className="bg-slate-900/90 text-white text-[10px] font-bold px-4 py-3 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity border border-white/20 shadow-2xl text-center flex flex-col items-center transform scale-95 group-hover:scale-100">
                                 <Smartphone size={24} className="mb-1 text-amber-500"/>
                                 Tocar para usar<br/>en Móvil
                              </div>
                           </div>
                         )}
                       </div>
                   </div>
               </div>
           </div>

           <button onClick={() => window.open(currentDemo.url, '_blank')} className="absolute bottom-10 right-10 px-5 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 rounded-full font-bold text-[10px] uppercase tracking-widest flex items-center transition-colors shadow-2xl z-50">
             Pantalla completa <ExternalLink size={14} className="ml-2"/>
           </button>
        </div>
      </div>
      
      <div className="fixed bottom-6 w-full px-4 sm:hidden z-50">
        <button onClick={() => setCheckoutStep(1)} className="w-full py-4 bg-amber-500 text-slate-900 font-black rounded-full text-xs uppercase tracking-widest shadow-[0_0_20px_rgba(245,158,11,0.4)]">
          Comprar este Diseño <ArrowRight size={16} className="inline ml-1"/>
        </button>
      </div>

    </div>
  );
};

// ==========================================
// 3. EL ENRUTADOR PRINCIPAL (App) - CEREBRO MAESTRO
// ==========================================
export default function App() {
  const urlParams = new URLSearchParams(window.location.search);
  let modoApp = urlParams.get('modo');
  let eventIdParam = urlParams.get('e') || urlParams.get('evt') || urlParams.get('id');
  const guestUidParam = urlParams.get('u') || urlParams.get('usr') || urlParams.get('uid') || urlParams.get('invitado');

  // 🔴 MAGIA DE RUTAS: DETECTAR SI ES BAULIA.COM O PANEL.BAULIA.COM
  const hostname = window.location.hostname;
  const pathname = window.location.pathname.replace(/^\/+/g, '').replace(/\/+$/, '').replace('index.html', '');
  const isLocalIP = /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname);
  const isPanel = hostname.startsWith('panel.') || hostname.includes('localhost') || isLocalIP;

  // ==========================================
  // 1. REGLA DE ORO: TODOS LOS ESTADOS (HOOKS) PRIMERO
  // ==========================================
  const [themeSetting, setThemeSetting] = useState(() => localStorage.getItem('baulia_theme') || 'auto');
  const [systemIsDark, setSystemIsDark] = useState(false);
  const [authData, setAuthData] = useState({ isAuthenticated: false, email: null, role: null, plan: null, eventId: null });
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [accountSuspended, setAccountSuspended] = useState(false);

  // ==========================================
  // 2. TODOS LOS EFECTOS SECUNDARIOS
  // ==========================================
  
  // Escucha el sistema del usuario para el Modo Noche
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setSystemIsDark(mediaQuery.matches);
    const handleChange = (e) => setSystemIsDark(e.matches);
    
    try {
      mediaQuery.addEventListener('change', handleChange);
    } catch (e) {
      mediaQuery.addListener(handleChange);
    }
    
    return () => {
      try {
        mediaQuery.removeEventListener('change', handleChange);
      } catch (e) {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);

  const isDarkMode = themeSetting === 'dark' || (themeSetting === 'auto' && systemIsDark);

  useEffect(() => {
    const root = document.documentElement;
    if (isDarkMode) root.classList.add('dark');
    else root.classList.remove('dark');
  }, [isDarkMode]);

  // Autenticación Global de Firebase (Soporte Multi-Evento, Tiempo Real y Caducidad)
  useEffect(() => {
    if (!window.Html5QrcodeScanner && !document.getElementById('qr-script')) {
      const script = document.createElement('script');
      script.id = 'qr-script';
      script.src = "https://unpkg.com/html5-qrcode";
      script.async = true;
      document.body.appendChild(script);
    }

    let unsubData = null;

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      try {
        if (user && user.email) {
          const q = query(collection(db, "usuarios"), where("email", "==", user.email.toLowerCase()));
          
          unsubData = onSnapshot(q, (querySnapshot) => {
            if (!querySnapshot.empty) {
              const userEventsList = querySnapshot.docs.map(doc => doc.data());
              
              // Ordenamos en memoria
              userEventsList.sort((a, b) => (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0));
              
              // 🔴 FILTRO DE AUTO-CADUCIDAD (30 DÍAS) Y SUSPENDIDOS
              const activeEvents = [];
              const today = new Date();

              for (const e of userEventsList) {
                if (e.status === 'suspendido') continue;
                
                if (e.fechaEvento) {
                  const eventDate = new Date(e.fechaEvento);
                  const diffTime = today.getTime() - eventDate.getTime();
                  const diffDays = diffTime / (1000 * 3600 * 24);
                  
                  // Si ya pasaron más de 30 días, lo ocultamos del cliente
                  if (diffDays > 30) continue;
                }
                activeEvents.push(e);
              }
              
              if (activeEvents.length === 0) {
                 signOut(auth);
                 setAccountSuspended(true);
                 setAuthData({ isAuthenticated: false, email: null, role: null, plan: null, eventId: null, availableEvents: [] });
              } else {
                 const savedEventId = localStorage.getItem('eventmaster_currentEventId');
                 let selectedEvent = activeEvents.find(e => e.eventId === savedEventId) || activeEvents[0];
                 
                 setAuthData({ 
                   isAuthenticated: true, 
                   email: user.email, 
                   role: selectedEvent.role, 
                   plan: selectedEvent.plan, 
                   eventId: selectedEvent.eventId,
                   availableEvents: activeEvents 
                 });
                 localStorage.setItem('eventmaster_currentEventId', selectedEvent.eventId);
              }
            } else {
              signOut(auth);
              setAuthData({ isAuthenticated: false, email: null, role: null, plan: null, eventId: null, availableEvents: [] });
            }
          });
        } else {
          setAuthData({ isAuthenticated: false, email: null, role: null, plan: null, eventId: null, availableEvents: [] });
        }
      } catch (error) {
        setAuthData({ isAuthenticated: false, email: null, role: null, plan: null, eventId: null, availableEvents: [] });
      } finally {
        setIsCheckingAuth(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubData) unsubData(); // Limpiamos el radar al salir
    };
  }, []);

  const cycleTheme = () => {
    setThemeSetting(prev => {
      let next = 'auto';
      if (prev === 'auto') next = 'dark';
      else if (prev === 'dark') next = 'light';
      else if (prev === 'light') next = 'auto';

      if (next === 'auto') localStorage.removeItem('baulia_theme');
      else localStorage.setItem('baulia_theme', next);
      
      return next;
    });
  };

  // ==========================================
  // 3. ENRUTAMIENTO (AHORA SÍ, YA PODEMOS REDIRIGIR)
  // ==========================================

  // 🔴 MODO PORTAFOLIO: Interceptamos la palabra "showroom"
  if (pathname === 'showroom') {
    return <CatalogoMuestrasView />;
  }
  
  // Si entra a baulia.com/boda-ana-y-luis
  if (!isPanel && pathname && !eventIdParam) {
     eventIdParam = pathname;
     if (!modoApp) modoApp = 'invitacion';
  }

  // 🟢 1. LANDING PAGE PRINCIPAL
  if (!isPanel && !pathname && !eventIdParam && modoApp !== 'showcase') {
      return <LandingPageView isDarkMode={isDarkMode} themeSetting={themeSetting} cycleTheme={cycleTheme} />;
  }
  
  // 🟢 2. RUTAS DEMO (EL SHOWROOM INTERACTIVO)
  if (modoApp === 'showcase') {
    return <ShowcaseSimulatorView />;
  }

  // 🟢 3. RUTAS PÚBLICAS (INVITADOS)
  if (modoApp === 'camara') { 
    if (!eventIdParam) return <div className="p-10 text-center font-bold text-rose-500 mt-10 text-xl">Error: Enlace roto (Falta código de evento).</div>;
    return <GuestCameraView eventId={eventIdParam} />; 
  } 
  if (modoApp === 'proyector') { 
    if (!eventIdParam) return <div className="p-10 text-center font-bold text-rose-500 mt-10 text-xl">Error: Enlace roto (Falta código de evento).</div>;
    return <GuestProyectorView eventId={eventIdParam} />; 
  } 
  
  // 🔴 AQUÍ VOLÓ EL GUARDIAN PARA SIEMPRE
  if (modoApp === 'invitacion') { 
    if (!eventIdParam) return <div className="p-10 text-center font-bold text-rose-500 mt-10 text-xl">Error: Enlace de invitación roto.</div>;
    return <InvitacionPublicaView eventId={eventIdParam} guestUid={guestUidParam} />; 
  }

  if (modoApp === 'puerta') {
    if (!eventIdParam) return <div className="p-10 text-center font-bold text-rose-500 text-2xl mt-10">❌ Enlace de puerta inválido.</div>;
    return <HostessStandaloneView eventId={eventIdParam} />;
  }
  if (modoApp === 'monitor') { 
   if (!eventIdParam) return <div className="p-10 text-center font-bold text-rose-500 mt-10 text-xl">Error: Falta código de evento.</div>;
   return <MonitorRecepcionView eventId={eventIdParam} />; 
  }

  // 🟢 4. ZONA SEGURA (PANEL DE CLIENTES/ADMIN)
  if (isCheckingAuth) return (
    <div className="h-screen w-screen bg-[#050505] flex flex-col items-center justify-center text-white relative overflow-hidden">
       <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-amber-500/10  hidden md:block  hidden md:block blur-[100px] rounded-full pointer-events-none"></div>
       <BauliaLogo className="h-12 md:h-16 w-auto mb-8 opacity-90 relative z-10" forceWhite={true} />
       <div className="flex items-center gap-3 text-amber-500/80 uppercase tracking-[0.3em] text-[10px] font-black relative z-10">
         <RefreshCw size={14} className="animate-spin" /> Accediendo a Bóveda VIP...
       </div>
    </div>
  );

  if (accountSuspended) return (
      <div className="h-screen w-screen bg-[#050505] flex flex-col items-center justify-center p-6 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10"></div>
        <AlertTriangle size={64} className="text-rose-500 mb-4 animate-pulse relative z-10" />
        <h1 className="text-2xl font-black text-white mb-2 font-editorial relative z-10">Cuenta Suspendida</h1>
        <p className="text-slate-400 max-w-sm relative z-10">Contacta a tu administrador de plataforma para reactivar tu licencia.</p>
      </div>
  );

  if (!authData.isAuthenticated) { return <LoginScreen />; }
  
  return (
    <>
      <AdminDashboard authData={authData} cycleTheme={cycleTheme} themeSetting={themeSetting} isDarkMode={isDarkMode} />
      {typeof ReviewHarvester !== 'undefined' && <ReviewHarvester authData={authData} />}
    </>
  );
}